var e = ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"],
  n = ["mainAxis", "crossAxis", "limiter"];
function t(e, n) {
  if (null == e) return {};
  var t,
    o,
    r = function (e, n) {
      if (null == e) return {};
      var t = {};
      for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
        if (n.indexOf(o) >= 0) continue;
        t[o] = e[o];
      }
      return t;
    }(e, n);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++) t = i[o], n.indexOf(t) >= 0 || {}.propertyIsEnumerable.call(e, t) && (r[t] = e[t]);
  }
  return r;
}
function o(e, n) {
  var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!t) {
    if (Array.isArray(e) || (t = $(e)) || n && e && "number" == typeof e.length) {
      t && (e = t);
      var o = 0,
        r = function () {};
      return {
        s: r,
        n: function () {
          return o >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[o++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: r
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var i,
    a = !0,
    s = !1;
  return {
    s: function () {
      t = t.call(e);
    },
    n: function () {
      var e = t.next();
      return a = e.done, e;
    },
    e: function (e) {
      s = !0, i = e;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function r() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */r = function () {
    return n;
  };
  var e,
    n = {},
    t = Object.prototype,
    o = t.hasOwnProperty,
    i = Object.defineProperty || function (e, n, t) {
      e[n] = t.value;
    },
    a = "function" == typeof Symbol ? Symbol : {},
    s = a.iterator || "@@iterator",
    l = a.asyncIterator || "@@asyncIterator",
    c = a.toStringTag || "@@toStringTag";
  function u(e, n, t) {
    return Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[n];
  }
  try {
    u({}, "");
  } catch (e) {
    u = function (e, n, t) {
      return e[n] = t;
    };
  }
  function d(e, n, t, o) {
    var r = n && n.prototype instanceof j ? n : j,
      a = Object.create(r.prototype),
      s = new q(o || []);
    return i(a, "_invoke", {
      value: O(e, t, s)
    }), a;
  }
  function f(e, n, t) {
    try {
      return {
        type: "normal",
        arg: e.call(n, t)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  n.wrap = d;
  var v = "suspendedStart",
    p = "suspendedYield",
    m = "executing",
    g = "completed",
    h = {};
  function j() {}
  function b() {}
  function y() {}
  var x = {};
  u(x, s, function () {
    return this;
  });
  var w = Object.getPrototypeOf,
    $ = w && w(w(P([])));
  $ && $ !== t && o.call($, s) && (x = $);
  var k = y.prototype = j.prototype = Object.create(x);
  function C(e) {
    ["next", "throw", "return"].forEach(function (n) {
      u(e, n, function (e) {
        return this._invoke(n, e);
      });
    });
  }
  function M(e, n) {
    function t(r, i, a, s) {
      var l = f(e[r], e, i);
      if ("throw" !== l.type) {
        var c = l.arg,
          u = c.value;
        return u && "object" == S(u) && o.call(u, "__await") ? n.resolve(u.__await).then(function (e) {
          t("next", e, a, s);
        }, function (e) {
          t("throw", e, a, s);
        }) : n.resolve(u).then(function (e) {
          c.value = e, a(c);
        }, function (e) {
          return t("throw", e, a, s);
        });
      }
      s(l.arg);
    }
    var r;
    i(this, "_invoke", {
      value: function (e, o) {
        function i() {
          return new n(function (n, r) {
            t(e, o, n, r);
          });
        }
        return r = r ? r.then(i, i) : i();
      }
    });
  }
  function O(n, t, o) {
    var r = v;
    return function (i, a) {
      if (r === m) throw Error("Generator is already running");
      if (r === g) {
        if ("throw" === i) throw a;
        return {
          value: e,
          done: !0
        };
      }
      for (o.method = i, o.arg = a;;) {
        var s = o.delegate;
        if (s) {
          var l = z(s, o);
          if (l) {
            if (l === h) continue;
            return l;
          }
        }
        if ("next" === o.method) o.sent = o._sent = o.arg;else if ("throw" === o.method) {
          if (r === v) throw r = g, o.arg;
          o.dispatchException(o.arg);
        } else "return" === o.method && o.abrupt("return", o.arg);
        r = m;
        var c = f(n, t, o);
        if ("normal" === c.type) {
          if (r = o.done ? g : p, c.arg === h) continue;
          return {
            value: c.arg,
            done: o.done
          };
        }
        "throw" === c.type && (r = g, o.method = "throw", o.arg = c.arg);
      }
    };
  }
  function z(n, t) {
    var o = t.method,
      r = n.iterator[o];
    if (r === e) return t.delegate = null, "throw" === o && n.iterator.return && (t.method = "return", t.arg = e, z(n, t), "throw" === t.method) || "return" !== o && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + o + "' method")), h;
    var i = f(r, n.iterator, t.arg);
    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, h;
    var a = i.arg;
    return a ? a.done ? (t[n.resultName] = a.value, t.next = n.nextLoc, "return" !== t.method && (t.method = "next", t.arg = e), t.delegate = null, h) : a : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
  }
  function R(e) {
    var n = {
      tryLoc: e[0]
    };
    1 in e && (n.catchLoc = e[1]), 2 in e && (n.finallyLoc = e[2], n.afterLoc = e[3]), this.tryEntries.push(n);
  }
  function E(e) {
    var n = e.completion || {};
    n.type = "normal", delete n.arg, e.completion = n;
  }
  function q(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(R, this), this.reset(!0);
  }
  function P(n) {
    if (n || "" === n) {
      var t = n[s];
      if (t) return t.call(n);
      if ("function" == typeof n.next) return n;
      if (!isNaN(n.length)) {
        var r = -1,
          i = function t() {
            for (; ++r < n.length;) if (o.call(n, r)) return t.value = n[r], t.done = !1, t;
            return t.value = e, t.done = !0, t;
          };
        return i.next = i;
      }
    }
    throw new TypeError(S(n) + " is not iterable");
  }
  return b.prototype = y, i(k, "constructor", {
    value: y,
    configurable: !0
  }), i(y, "constructor", {
    value: b,
    configurable: !0
  }), b.displayName = u(y, c, "GeneratorFunction"), n.isGeneratorFunction = function (e) {
    var n = "function" == typeof e && e.constructor;
    return !!n && (n === b || "GeneratorFunction" === (n.displayName || n.name));
  }, n.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : (e.__proto__ = y, u(e, c, "GeneratorFunction")), e.prototype = Object.create(k), e;
  }, n.awrap = function (e) {
    return {
      __await: e
    };
  }, C(M.prototype), u(M.prototype, l, function () {
    return this;
  }), n.AsyncIterator = M, n.async = function (e, t, o, r, i) {
    void 0 === i && (i = Promise);
    var a = new M(d(e, t, o, r), i);
    return n.isGeneratorFunction(t) ? a : a.next().then(function (e) {
      return e.done ? e.value : a.next();
    });
  }, C(k), u(k, c, "Generator"), u(k, s, function () {
    return this;
  }), u(k, "toString", function () {
    return "[object Generator]";
  }), n.keys = function (e) {
    var n = Object(e),
      t = [];
    for (var o in n) t.push(o);
    return t.reverse(), function e() {
      for (; t.length;) {
        var o = t.pop();
        if (o in n) return e.value = o, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, n.values = P, q.prototype = {
    constructor: q,
    reset: function (n) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(E), !n) for (var t in this) "t" === t.charAt(0) && o.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = e);
    },
    stop: function () {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function (n) {
      if (this.done) throw n;
      var t = this;
      function r(o, r) {
        return s.type = "throw", s.arg = n, t.next = o, r && (t.method = "next", t.arg = e), !!r;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var a = this.tryEntries[i],
          s = a.completion;
        if ("root" === a.tryLoc) return r("end");
        if (a.tryLoc <= this.prev) {
          var l = o.call(a, "catchLoc"),
            c = o.call(a, "finallyLoc");
          if (l && c) {
            if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
            if (this.prev < a.finallyLoc) return r(a.finallyLoc);
          } else if (l) {
            if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
          } else {
            if (!c) throw Error("try statement without catch or finally");
            if (this.prev < a.finallyLoc) return r(a.finallyLoc);
          }
        }
      }
    },
    abrupt: function (e, n) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.tryLoc <= this.prev && o.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
          var i = r;
          break;
        }
      }
      i && ("break" === e || "continue" === e) && i.tryLoc <= n && n <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = e, a.arg = n, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
    },
    complete: function (e, n) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && n && (this.next = n), h;
    },
    finish: function (e) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var t = this.tryEntries[n];
        if (t.finallyLoc === e) return this.complete(t.completion, t.afterLoc), E(t), h;
      }
    },
    catch: function (e) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var t = this.tryEntries[n];
        if (t.tryLoc === e) {
          var o = t.completion;
          if ("throw" === o.type) {
            var r = o.arg;
            E(t);
          }
          return r;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (n, t, o) {
      return this.delegate = {
        iterator: P(n),
        resultName: t,
        nextLoc: o
      }, "next" === this.method && (this.arg = e), h;
    }
  }, n;
}
function i(e, n, t, o, r, i, a) {
  try {
    var s = e[i](a),
      l = s.value;
  } catch (e) {
    return void t(e);
  }
  s.done ? n(l) : Promise.resolve(l).then(o, r);
}
function a(e) {
  return function () {
    var n = this,
      t = arguments;
    return new Promise(function (o, r) {
      var a = e.apply(n, t);
      function s(e) {
        i(a, o, r, s, l, "next", e);
      }
      function l(e) {
        i(a, o, r, s, l, "throw", e);
      }
      s(void 0);
    });
  };
}
function s(e, n) {
  return c(e) || function (e, n) {
    var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != t) {
      var o,
        r,
        i,
        a,
        s = [],
        l = !0,
        c = !1;
      try {
        if (i = (t = t.call(e)).next, 0 === n) {
          if (Object(t) !== t) return;
          l = !1;
        } else for (; !(l = (o = i.call(t)).done) && (s.push(o.value), s.length !== n); l = !0);
      } catch (e) {
        c = !0, r = e;
      } finally {
        try {
          if (!l && null != t.return && (a = t.return(), Object(a) !== a)) return;
        } finally {
          if (c) throw r;
        }
      }
      return s;
    }
  }(e, n) || $(e, n) || l();
}
function l() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function c(e) {
  if (Array.isArray(e)) return e;
}
function u(e, n, t) {
  return n = f(n), function (e, n) {
    if (n && ("object" == S(n) || "function" == typeof n)) return n;
    if (void 0 !== n) throw new TypeError("Derived constructors may only return object or undefined");
    return function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e);
  }(e, d() ? Reflect.construct(n, t || [], f(e).constructor) : n.apply(e, t));
}
function d() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (d = function () {
    return !!e;
  })();
}
function f(e) {
  return f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, f(e);
}
function v(e, n) {
  if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), n && p(e, n);
}
function p(e, n) {
  return p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, n) {
    return e.__proto__ = n, e;
  }, p(e, n);
}
function m(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function g(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2 ? m(Object(t), !0).forEach(function (n) {
      y(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : m(Object(t)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function h(e, n) {
  if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function j(e, n) {
  for (var t = 0; t < n.length; t++) {
    var o = n[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, x(o.key), o);
  }
}
function b(e, n, t) {
  return n && j(e.prototype, n), t && j(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function y(e, n, t) {
  return (n = x(n)) in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function x(e) {
  var n = function (e, n) {
    if ("object" != S(e) || !e) return e;
    var t = e[Symbol.toPrimitive];
    if (void 0 !== t) {
      var o = t.call(e, n || "default");
      if ("object" != S(o)) return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === n ? String : Number)(e);
  }(e, "string");
  return "symbol" == S(n) ? n : n + "";
}
function w(e) {
  return function (e) {
    if (Array.isArray(e)) return C(e);
  }(e) || k(e) || $(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function $(e, n) {
  if (e) {
    if ("string" == typeof e) return C(e, n);
    var t = {}.toString.call(e).slice(8, -1);
    return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? C(e, n) : void 0;
  }
}
function k(e) {
  if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
}
function C(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var t = 0, o = Array(n); t < n; t++) o[t] = e[t];
  return o;
}
function S(e) {
  return S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, S(e);
}
import { parseJSONPointer as M, compileJSONPointer as O, getIn as z, immutableJSONPatch as R, isJSONPatchAdd as E, isJSONPatchRemove as q, isJSONPatchReplace as P, isJSONPatchCopy as I, isJSONPatchMove as T, parsePath as A, isJSONArray as N, isJSONObject as B, startsWithJSONPointer as F, existsIn as L, revertJSONPatch as U, setIn as D, appendToJSONPointer as J, compileJSONPointerProp as V } from "immutable-json-patch";
import H from "json-source-map";
import { jsonrepair as _ } from "jsonrepair";
import * as W from "lodash-es";
import { map as Q, minBy as Y, isEmpty as G, memoize as K, sortBy as Z, initial as X, last as ee, isEqual as ne, first as te, noop as oe, cloneDeepWith as re, times as ie, groupBy as ae, forEachRight as se, range as le, debounce as ce, partition as ue, mapValues as de, uniqueId as fe, cloneDeep as ve } from "lodash-es";
import { faCheckSquare as pe, faSquare as me, faClock as ge, faLightbulb as he } from "@fortawesome/free-regular-svg-icons";
import { faTimes as je, faDownLeftAndUpRightToCenter as be, faUpRightAndDownLeftFromCenter as ye, faCog as xe, faExclamationTriangle as we, faAngleRight as $e, faAngleDown as ke, faCheck as Ce, faArrowDown as Se, faWrench as Me, faCaretDown as Oe, faCaretRight as ze, faSearch as Re, faSortAmountDownAlt as Ee, faFilter as qe, faEllipsisV as Pe, faUndo as Ie, faRedo as Te, faCopy as Ae, faClose as Ne, faEdit as Be, faChevronDown as Fe, faChevronUp as Le, faCircleNotch as Ue, faPen as De, faCheckSquare as Je, faSquare as Ve, faCut as He, faPaste as _e, faClone as We, faCropAlt as Qe, faTrashCan as Ye, faArrowRightArrowLeft as Ge, faPlus as Ke, faCaretSquareUp as Ze, faCaretSquareDown as Xe, faCode as en, faEye as nn, faCaretUp as tn, faRotate as on, faCaretLeft as rn } from "@fortawesome/free-solid-svg-icons";
import an from "natural-compare-lite";
import sn from "memoize-one";
import { Compartment as ln, EditorState as cn, EditorSelection as un } from "@codemirror/state";
import { keymap as dn, lineNumbers as fn, highlightActiveLineGutter as vn, highlightSpecialChars as pn, drawSelection as mn, dropCursor as gn, rectangularSelection as hn, crosshairCursor as jn, highlightActiveLine as bn, EditorView as yn } from "@codemirror/view";
import { indentWithTab as xn, history as wn, defaultKeymap as $n, historyKeymap as kn, undo as Cn, redo as Sn, undoDepth as Mn, redoDepth as On } from "@codemirror/commands";
import { lintGutter as zn, lintKeymap as Rn, linter as En } from "@codemirror/lint";
import { json as qn } from "@codemirror/lang-json";
import { HighlightStyle as Pn, syntaxHighlighting as In, foldGutter as Tn, indentOnInput as An, defaultHighlightStyle as Nn, bracketMatching as Bn, foldKeymap as Fn, indentUnit as Ln } from "@codemirror/language";
import { highlightSelectionMatches as Un, searchKeymap as Dn, search as Jn, openSearchPanel as Vn, closeSearchPanel as Hn } from "@codemirror/search";
import { closeBrackets as _n, autocompletion as Wn, closeBracketsKeymap as Qn, completionKeymap as Yn } from "@codemirror/autocomplete";
import { tags as Gn } from "@lezer/highlight";
import { indentationMarkers as Kn } from "@replit/codemirror-indentation-markers";
import { wrappedLineIndent as Zn } from "codemirror-wrapped-line-indent";
import Xn from "ajv";
import et from "jmespath";
function nt() {}
var tt = function (e) {
  return e;
};
function ot(e, n) {
  for (var t in n) e[t] = n[t];
  return e;
}
function rt(e) {
  return e();
}
function it() {
  return Object.create(null);
}
function at(e) {
  e.forEach(rt);
}
function st(e) {
  return "function" == typeof e;
}
function lt(e, n) {
  return e != e ? n == n : e !== n || e && "object" === S(e) || "function" == typeof e;
}
function ct(e, n) {
  return e != e ? n == n : e !== n;
}
function ut(e, n, t, o) {
  if (e) {
    var r = dt(e, n, t, o);
    return e[0](r);
  }
}
function dt(e, n, t, o) {
  return e[1] && o ? ot(t.ctx.slice(), e[1](o(n))) : t.ctx;
}
function ft(e, n, t, o) {
  if (e[2] && o) {
    var r = e[2](o(t));
    if (void 0 === n.dirty) return r;
    if ("object" === S(r)) {
      for (var i = [], a = Math.max(n.dirty.length, r.length), s = 0; s < a; s += 1) i[s] = n.dirty[s] | r[s];
      return i;
    }
    return n.dirty | r;
  }
  return n.dirty;
}
function vt(e, n, t, o, r, i) {
  if (r) {
    var a = dt(n, t, o, i);
    e.p(a, r);
  }
}
function pt(e) {
  if (e.ctx.length > 32) {
    for (var n = [], t = e.ctx.length / 32, o = 0; o < t; o++) n[o] = -1;
    return n;
  }
  return -1;
}
function mt(e) {
  var n = {};
  for (var t in e) "$" !== t[0] && (n[t] = e[t]);
  return n;
}
function gt(e, n) {
  var t = {};
  for (var o in n = new Set(n), e) n.has(o) || "$" === o[0] || (t[o] = e[o]);
  return t;
}
function ht(e) {
  return null == e ? "" : e;
}
function jt(e) {
  return e && st(e.destroy) ? e.destroy : nt;
}
var bt = "undefined" != typeof window,
  yt = bt ? function () {
    return window.performance.now();
  } : function () {
    return Date.now();
  },
  xt = bt ? function (e) {
    return requestAnimationFrame(e);
  } : nt,
  wt = new Set();
function $t(e) {
  wt.forEach(function (n) {
    n.c(e) || (wt.delete(n), n.f());
  }), 0 !== wt.size && xt($t);
}
var kt = "undefined" != typeof window ? window : "undefined" != typeof globalThis ? globalThis : global;
function Ct(e, n) {
  e.appendChild(n);
}
function St(e, n, t) {
  var o = Mt(e);
  if (!o.getElementById(n)) {
    var r = Pt("style");
    r.id = n, r.textContent = t, zt(o, r);
  }
}
function Mt(e) {
  if (!e) return document;
  var n = e.getRootNode ? e.getRootNode() : e.ownerDocument;
  return n && n.host ? n : e.ownerDocument;
}
function Ot(e) {
  var n = Pt("style");
  return n.textContent = "/* empty */", zt(Mt(e), n), n.sheet;
}
function zt(e, n) {
  return Ct(e.head || e, n), n.sheet;
}
function Rt(e, n, t) {
  e.insertBefore(n, t || null);
}
function Et(e) {
  e.parentNode && e.parentNode.removeChild(e);
}
function qt(e, n) {
  for (var t = 0; t < e.length; t += 1) e[t] && e[t].d(n);
}
function Pt(e) {
  return document.createElement(e);
}
function It(e) {
  return document.createElementNS("http://www.w3.org/2000/svg", e);
}
function Tt(e) {
  return document.createTextNode(e);
}
function At() {
  return Tt(" ");
}
function Nt() {
  return Tt("");
}
function Bt(e, n, t, o) {
  return e.addEventListener(n, t, o), function () {
    return e.removeEventListener(n, t, o);
  };
}
function Ft(e) {
  return function (n) {
    return n.preventDefault(), e.call(this, n);
  };
}
function Lt(e) {
  return function (n) {
    return n.stopPropagation(), e.call(this, n);
  };
}
function Ut(e, n, t) {
  null == t ? e.removeAttribute(n) : e.getAttribute(n) !== t && e.setAttribute(n, t);
}
var Dt = ["width", "height"];
function Jt(e, n) {
  var t = Object.getOwnPropertyDescriptors(e.__proto__);
  for (var o in n) null == n[o] ? e.removeAttribute(o) : "style" === o ? e.style.cssText = n[o] : "__value" === o ? e.value = e[o] = n[o] : t[o] && t[o].set && -1 === Dt.indexOf(o) ? e[o] = n[o] : Ut(e, o, n[o]);
}
function Vt(e, n) {
  for (var t in n) Ut(e, t, n[t]);
}
function Ht(e, n) {
  n = "" + n, e.data !== n && (e.data = n);
}
function _t(e, n) {
  e.value = null == n ? "" : n;
}
function Wt(e, n, t, o) {
  null == t ? e.style.removeProperty(n) : e.style.setProperty(n, t, "");
}
function Qt(e, n, t) {
  for (var o = 0; o < e.options.length; o += 1) {
    var r = e.options[o];
    if (r.__value === n) return void (r.selected = !0);
  }
  t && void 0 === n || (e.selectedIndex = -1);
}
function Yt(e, n, t) {
  e.classList.toggle(n, !!t);
}
function Gt(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    o = t.bubbles,
    r = void 0 !== o && o,
    i = t.cancelable;
  return new CustomEvent(e, {
    detail: n,
    bubbles: r,
    cancelable: void 0 !== i && i
  });
}
function Kt(e, n) {
  return new e(n);
}
var Zt,
  Xt = new Map(),
  eo = 0;
function no(e, n, t, o, r, i, a) {
  for (var s = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 0, l = 16.666 / o, c = "{\n", u = 0; u <= 1; u += l) {
    var d = n + (t - n) * i(u);
    c += 100 * u + "%{".concat(a(d, 1 - d), "}\n");
  }
  var f = c + "100% {".concat(a(t, 1 - t), "}\n}"),
    v = "__svelte_".concat(function (e) {
      for (var n = 5381, t = e.length; t--;) n = (n << 5) - n ^ e.charCodeAt(t);
      return n >>> 0;
    }(f), "_").concat(s),
    p = Mt(e),
    m = Xt.get(p) || function (e, n) {
      var t = {
        stylesheet: Ot(n),
        rules: {}
      };
      return Xt.set(e, t), t;
    }(p, e),
    g = m.stylesheet,
    h = m.rules;
  h[v] || (h[v] = !0, g.insertRule("@keyframes ".concat(v, " ").concat(f), g.cssRules.length));
  var j = e.style.animation || "";
  return e.style.animation = "".concat(j ? "".concat(j, ", ") : "").concat(v, " ").concat(o, "ms linear ").concat(r, "ms 1 both"), eo += 1, v;
}
function to(e, n) {
  var t = (e.style.animation || "").split(", "),
    o = t.filter(n ? function (e) {
      return e.indexOf(n) < 0;
    } : function (e) {
      return -1 === e.indexOf("__svelte");
    }),
    r = t.length - o.length;
  r && (e.style.animation = o.join(", "), (eo -= r) || xt(function () {
    eo || (Xt.forEach(function (e) {
      var n = e.stylesheet.ownerNode;
      n && Et(n);
    }), Xt.clear());
  }));
}
function oo(e) {
  Zt = e;
}
function ro() {
  if (!Zt) throw new Error("Function called outside component initialization");
  return Zt;
}
function io(e) {
  ro().$$.on_mount.push(e);
}
function ao(e) {
  ro().$$.on_destroy.push(e);
}
function so() {
  var e = ro();
  return function (n, t) {
    var o = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).cancelable,
      r = void 0 !== o && o,
      i = e.$$.callbacks[n];
    if (i) {
      var a = Gt(n, t, {
        cancelable: r
      });
      return i.slice().forEach(function (n) {
        n.call(e, a);
      }), !a.defaultPrevented;
    }
    return !0;
  };
}
function lo(e, n) {
  return ro().$$.context.set(e, n), n;
}
function co(e) {
  return ro().$$.context.get(e);
}
function uo(e, n) {
  var t = this,
    o = e.$$.callbacks[n.type];
  o && o.slice().forEach(function (e) {
    return e.call(t, n);
  });
}
var fo = [],
  vo = [],
  po = [],
  mo = [],
  go = Promise.resolve(),
  ho = !1;
function jo() {
  ho || (ho = !0, go.then(Co));
}
function bo() {
  return jo(), go;
}
function yo(e) {
  po.push(e);
}
function xo(e) {
  mo.push(e);
}
var wo,
  $o = new Set(),
  ko = 0;
function Co() {
  if (0 === ko) {
    var e = Zt;
    do {
      try {
        for (; ko < fo.length;) {
          var n = fo[ko];
          ko++, oo(n), So(n.$$);
        }
      } catch (e) {
        throw fo.length = 0, ko = 0, e;
      }
      for (oo(null), fo.length = 0, ko = 0; vo.length;) vo.pop()();
      for (var t = 0; t < po.length; t += 1) {
        var o = po[t];
        $o.has(o) || ($o.add(o), o());
      }
      po.length = 0;
    } while (fo.length);
    for (; mo.length;) mo.pop()();
    ho = !1, $o.clear(), oo(e);
  }
}
function So(e) {
  if (null !== e.fragment) {
    e.update(), at(e.before_update);
    var n = e.dirty;
    e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, n), e.after_update.forEach(yo);
  }
}
function Mo(e, n, t) {
  e.dispatchEvent(Gt("".concat(n ? "intro" : "outro").concat(t)));
}
var Oo,
  zo = new Set();
function Ro() {
  Oo = {
    r: 0,
    c: [],
    p: Oo
  };
}
function Eo() {
  Oo.r || at(Oo.c), Oo = Oo.p;
}
function qo(e, n) {
  e && e.i && (zo.delete(e), e.i(n));
}
function Po(e, n, t, o) {
  if (e && e.o) {
    if (zo.has(e)) return;
    zo.add(e), Oo.c.push(function () {
      zo.delete(e), o && (t && e.d(1), o());
    }), e.o(n);
  } else o && o();
}
var Io = {
  duration: 0
};
function To(e, n, t, o) {
  var r,
    i = n(e, t, {
      direction: "both"
    }),
    a = o ? 0 : 1,
    s = null,
    l = null,
    c = null;
  function u() {
    c && to(e, c);
  }
  function d(e, n) {
    var t = e.b - a;
    return n *= Math.abs(t), {
      a: a,
      b: e.b,
      d: t,
      duration: n,
      start: e.start,
      end: e.start + n,
      group: e.group
    };
  }
  function f(n) {
    var t,
      o = i || Io,
      f = o.delay,
      v = void 0 === f ? 0 : f,
      p = o.duration,
      m = void 0 === p ? 300 : p,
      g = o.easing,
      h = void 0 === g ? tt : g,
      j = o.tick,
      b = void 0 === j ? nt : j,
      y = o.css,
      x = {
        start: yt() + v,
        b: n
      };
    n || (x.group = Oo, Oo.r += 1), "inert" in e && (n ? void 0 !== r && (e.inert = r) : (r = e.inert, e.inert = !0)), s || l ? l = x : (y && (u(), c = no(e, a, n, m, v, h, y)), n && b(0, 1), s = d(x, m), yo(function () {
      return Mo(e, n, "start");
    }), t = function (n) {
      if (l && n > l.start && (s = d(l, m), l = null, Mo(e, s.b, "start"), y && (u(), c = no(e, a, s.b, s.duration, 0, h, i.css))), s) if (n >= s.end) b(a = s.b, 1 - a), Mo(e, s.b, "end"), l || (s.b ? u() : --s.group.r || at(s.group.c)), s = null;else if (n >= s.start) {
        var t = n - s.start;
        a = s.a + s.d * h(t / s.duration), b(a, 1 - a);
      }
      return !(!s && !l);
    }, 0 === wt.size && xt($t), new Promise(function (e) {
      wt.add({
        c: t,
        f: e
      });
    }));
  }
  return {
    run: function (e) {
      st(i) ? (wo || (wo = Promise.resolve()).then(function () {
        wo = null;
      }), wo).then(function () {
        i = i({
          direction: e ? "in" : "out"
        }), f(e);
      }) : f(e);
    },
    end: function () {
      u(), s = l = null;
    }
  };
}
function Ao(e) {
  return void 0 !== (null == e ? void 0 : e.length) ? e : Array.from(e);
}
function No(e, n) {
  e.d(1), n.delete(e.key);
}
function Bo(e, n) {
  Po(e, 1, 1, function () {
    n.delete(e.key);
  });
}
function Fo(e, n, t, o, r, i, a, s, l, c, u, d) {
  for (var f = e.length, v = i.length, p = f, m = {}; p--;) m[e[p].key] = p;
  var g = [],
    h = new Map(),
    j = new Map(),
    b = [];
  p = v;
  for (var y = function () {
    var e = d(r, i, p),
      o = t(e),
      s = a.get(o);
    s ? b.push(function () {
      return s.p(e, n);
    }) : (s = c(o, e)).c(), h.set(o, g[p] = s), (o in m) && j.set(o, Math.abs(p - m[o]));
  }; p--;) y();
  var x = new Set(),
    w = new Set();
  function $(e) {
    qo(e, 1), e.m(s, u), a.set(e.key, e), u = e.first, v--;
  }
  for (; f && v;) {
    var k = g[v - 1],
      C = e[f - 1],
      S = k.key,
      M = C.key;
    k === C ? (u = k.first, f--, v--) : h.has(M) ? !a.has(S) || x.has(S) ? $(k) : w.has(M) ? f-- : j.get(S) > j.get(M) ? (w.add(S), $(k)) : (x.add(M), f--) : (l(C, a), f--);
  }
  for (; f--;) {
    var O = e[f];
    h.has(O.key) || l(O, a);
  }
  for (; v;) $(g[v - 1]);
  return at(b), g;
}
function Lo(e, n) {
  for (var t = {}, o = {}, r = {
      $$scope: 1
    }, i = e.length; i--;) {
    var a = e[i],
      s = n[i];
    if (s) {
      for (var l in a) l in s || (o[l] = 1);
      for (var c in s) r[c] || (t[c] = s[c], r[c] = 1);
      e[i] = s;
    } else for (var u in a) r[u] = 1;
  }
  for (var d in o) d in t || (t[d] = void 0);
  return t;
}
function Uo(e) {
  return "object" === S(e) && null !== e ? e : {};
}
function Do(e, n, t) {
  var o = e.$$.props[n];
  void 0 !== o && (e.$$.bound[o] = t, t(e.$$.ctx[o]));
}
function Jo(e) {
  e && e.c();
}
function Vo(e, n, t) {
  var o = e.$$,
    r = o.fragment,
    i = o.after_update;
  r && r.m(n, t), yo(function () {
    var n,
      t = e.$$.on_mount.map(rt).filter(st);
    e.$$.on_destroy ? (n = e.$$.on_destroy).push.apply(n, w(t)) : at(t);
    e.$$.on_mount = [];
  }), i.forEach(yo);
}
function Ho(e, n) {
  var t,
    o,
    r,
    i = e.$$;
  null !== i.fragment && (t = i.after_update, o = [], r = [], po.forEach(function (e) {
    return -1 === t.indexOf(e) ? o.push(e) : r.push(e);
  }), r.forEach(function (e) {
    return e();
  }), po = o, at(i.on_destroy), i.fragment && i.fragment.d(n), i.on_destroy = i.fragment = null, i.ctx = []);
}
function _o(e, n, t, o, r, i) {
  var a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null,
    s = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : [-1],
    l = Zt;
  oo(e);
  var c = e.$$ = {
    fragment: null,
    ctx: [],
    props: i,
    update: nt,
    not_equal: r,
    bound: it(),
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(n.context || (l ? l.$$.context : [])),
    callbacks: it(),
    dirty: s,
    skip_bound: !1,
    root: n.target || l.$$.root
  };
  a && a(c.root);
  var u = !1;
  if (c.ctx = t ? t(e, n.props || {}, function (n, t) {
    var o = !(arguments.length <= 2) && arguments.length - 2 ? arguments.length <= 2 ? void 0 : arguments[2] : t;
    return c.ctx && r(c.ctx[n], c.ctx[n] = o) && (!c.skip_bound && c.bound[n] && c.bound[n](o), u && function (e, n) {
      -1 === e.$$.dirty[0] && (fo.push(e), jo(), e.$$.dirty.fill(0)), e.$$.dirty[n / 31 | 0] |= 1 << n % 31;
    }(e, n)), t;
  }) : [], c.update(), u = !0, at(c.before_update), c.fragment = !!o && o(c.ctx), n.target) {
    if (n.hydrate) {
      var d = function (e) {
        return Array.from(e.childNodes);
      }(n.target);
      c.fragment && c.fragment.l(d), d.forEach(Et);
    } else c.fragment && c.fragment.c();
    n.intro && qo(e.$$.fragment), Vo(e, n.target, n.anchor), Co();
  }
  oo(l);
}
var Wo = function () {
  return b(function e() {
    h(this, e), y(this, "$$", void 0), y(this, "$$set", void 0);
  }, [{
    key: "$destroy",
    value: function () {
      Ho(this, 1), this.$destroy = nt;
    }
  }, {
    key: "$on",
    value: function (e, n) {
      if (!st(n)) return nt;
      var t = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
      return t.push(n), function () {
        var e = t.indexOf(n);
        -1 !== e && t.splice(e, 1);
      };
    }
  }, {
    key: "$set",
    value: function (e) {
      var n;
      this.$$set && (n = e, 0 !== Object.keys(n).length) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
    }
  }]);
}();
function Qo(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function (e) {
    var n = function (e) {
      try {
        if ("undefined" != typeof window && void 0 !== window.localStorage) return window.localStorage[e];
      } catch (e) {}
    }("debug");
    return null != n && n.endsWith("*") ? e.startsWith(n.slice(0, -1)) : e === n;
  }(e);
  if (!n) return Yo;
  var t = function (e) {
    for (var n = 0, t = 0; t < e.length; t++) n = (n << 5) - n + e.charCodeAt(t), n |= 0;
    return Go[Math.abs(n) % Go.length];
  }(e);
  return function () {
    for (var n, o = arguments.length, r = new Array(o), i = 0; i < o; i++) r[i] = arguments[i];
    (n = console).log.apply(n, ["%c".concat(e), "color:".concat(t)].concat(r));
  };
}
function Yo() {}
"undefined" != typeof window && (window.__svelte || (window.__svelte = {
  v: new Set()
})).v.add("4");
var Go = ["#0000CC", "#0099FF", "#009400", "#8dd200", "#CCCC00", "#CC9933", "#ae04e7", "#ff35d7", "#FF3333", "#FF6600", "#FF9933", "#FFCC33"];
function Ko(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    t = n.delay,
    o = void 0 === t ? 0 : t,
    r = n.duration,
    i = void 0 === r ? 400 : r,
    a = n.easing,
    s = void 0 === a ? tt : a,
    l = +getComputedStyle(e).opacity;
  return {
    delay: o,
    duration: i,
    easing: s,
    css: function (e) {
      return "opacity: ".concat(e * l);
    }
  };
}
var Zo = kt.window;
function Xo(e) {
  St(e, "svelte-n7cvum", ".svelte-n7cvum{box-sizing:border-box}.bg.svelte-n7cvum{position:fixed;z-index:1000;top:0;left:0;display:flex;flex-direction:column;justify-content:center;width:100vw;height:100vh;background:rgba(0, 0, 0, 0.66)}@supports (-webkit-touch-callout: none){}.wrap.svelte-n7cvum{position:relative;margin:2rem;max-height:100%}.window.svelte-n7cvum{position:relative;width:40rem;max-width:100%;max-height:100%;margin:2rem auto;color:black;border-radius:0.5rem;background:white}.content.svelte-n7cvum{position:relative;padding:1rem;max-height:calc(100vh - 4rem);overflow:auto}.close.svelte-n7cvum{display:block;box-sizing:border-box;position:absolute;z-index:1000;top:1rem;right:1rem;margin:0;padding:0;width:1.5rem;height:1.5rem;border:0;color:black;border-radius:1.5rem;background:white;box-shadow:0 0 0 1px black;transition:transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),\n      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);-webkit-appearance:none}.close.svelte-n7cvum:before,.close.svelte-n7cvum:after{content:'';display:block;box-sizing:border-box;position:absolute;top:50%;width:1rem;height:1px;background:black;transform-origin:center;transition:height 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),\n      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1)}.close.svelte-n7cvum:before{-webkit-transform:translate(0, -50%) rotate(45deg);-moz-transform:translate(0, -50%) rotate(45deg);transform:translate(0, -50%) rotate(45deg);left:0.25rem}.close.svelte-n7cvum:after{-webkit-transform:translate(0, -50%) rotate(-45deg);-moz-transform:translate(0, -50%) rotate(-45deg);transform:translate(0, -50%) rotate(-45deg);left:0.25rem}.close.svelte-n7cvum:hover{background:black}.close.svelte-n7cvum:hover:before,.close.svelte-n7cvum:hover:after{height:2px;background:white}.close.svelte-n7cvum:focus{border-color:#3399ff;box-shadow:0 0 0 2px #3399ff}.close.svelte-n7cvum:active{transform:scale(0.9)}.close.svelte-n7cvum:hover,.close.svelte-n7cvum:focus,.close.svelte-n7cvum:active{outline:none}");
}
function er(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f,
    v,
    p,
    m,
    g,
    h,
    j,
    b = e[1].closeButton && nr(e),
    y = e[2];
  return y && (a = Kt(y, {})), {
    c: function () {
      n = Pt("div"), t = Pt("div"), o = Pt("div"), b && b.c(), r = At(), i = Pt("div"), a && Jo(a.$$.fragment), Ut(i, "class", s = ht(e[1].classContent) + " svelte-n7cvum"), Ut(i, "style", e[9]), Yt(i, "content", !e[0]), Ut(o, "class", l = ht(e[1].classWindow) + " svelte-n7cvum"), Ut(o, "role", "dialog"), Ut(o, "aria-modal", "true"), Ut(o, "aria-label", c = e[1].ariaLabelledBy ? null : e[1].ariaLabel || null), Ut(o, "aria-labelledby", u = e[1].ariaLabelledBy || null), Ut(o, "style", e[8]), Yt(o, "window", !e[0]), Ut(t, "class", f = ht(e[1].classWindowWrap) + " svelte-n7cvum"), Ut(t, "style", e[7]), Yt(t, "wrap", !e[0]), Ut(n, "aria-hidden", "true"), Ut(n, "id", v = e[1].id), Ut(n, "class", p = ht(e[1].classBg) + " svelte-n7cvum"), Ut(n, "style", e[6]), Yt(n, "bg", !e[0]);
    },
    m: function (s, l) {
      Rt(s, n, l), Ct(n, t), Ct(t, o), b && b.m(o, null), Ct(o, r), Ct(o, i), a && Vo(a, i, null), e[50](o), e[51](t), e[52](n), g = !0, h || (j = [Bt(o, "introstart", function () {
        st(e[13]) && e[13].apply(this, arguments);
      }), Bt(o, "outrostart", function () {
        st(e[14]) && e[14].apply(this, arguments);
      }), Bt(o, "introend", function () {
        st(e[15]) && e[15].apply(this, arguments);
      }), Bt(o, "outroend", function () {
        st(e[16]) && e[16].apply(this, arguments);
      }), Bt(n, "mousedown", e[20]), Bt(n, "mouseup", e[21])], h = !0);
    },
    p: function (d, m) {
      if ((e = d)[1].closeButton ? b ? (b.p(e, m), 2 & m[0] && qo(b, 1)) : ((b = nr(e)).c(), qo(b, 1), b.m(o, r)) : b && (Ro(), Po(b, 1, 1, function () {
        b = null;
      }), Eo()), 4 & m[0] && y !== (y = e[2])) {
        if (a) {
          Ro();
          var h = a;
          Po(h.$$.fragment, 1, 0, function () {
            Ho(h, 1);
          }), Eo();
        }
        y ? (Jo((a = Kt(y, {})).$$.fragment), qo(a.$$.fragment, 1), Vo(a, i, null)) : a = null;
      }
      (!g || 2 & m[0] && s !== (s = ht(e[1].classContent) + " svelte-n7cvum")) && Ut(i, "class", s), (!g || 512 & m[0]) && Ut(i, "style", e[9]), (!g || 3 & m[0]) && Yt(i, "content", !e[0]), (!g || 2 & m[0] && l !== (l = ht(e[1].classWindow) + " svelte-n7cvum")) && Ut(o, "class", l), (!g || 2 & m[0] && c !== (c = e[1].ariaLabelledBy ? null : e[1].ariaLabel || null)) && Ut(o, "aria-label", c), (!g || 2 & m[0] && u !== (u = e[1].ariaLabelledBy || null)) && Ut(o, "aria-labelledby", u), (!g || 256 & m[0]) && Ut(o, "style", e[8]), (!g || 3 & m[0]) && Yt(o, "window", !e[0]), (!g || 2 & m[0] && f !== (f = ht(e[1].classWindowWrap) + " svelte-n7cvum")) && Ut(t, "class", f), (!g || 128 & m[0]) && Ut(t, "style", e[7]), (!g || 3 & m[0]) && Yt(t, "wrap", !e[0]), (!g || 2 & m[0] && v !== (v = e[1].id)) && Ut(n, "id", v), (!g || 2 & m[0] && p !== (p = ht(e[1].classBg) + " svelte-n7cvum")) && Ut(n, "class", p), (!g || 64 & m[0]) && Ut(n, "style", e[6]), (!g || 3 & m[0]) && Yt(n, "bg", !e[0]);
    },
    i: function (t) {
      g || (qo(b), a && qo(a.$$.fragment, t), t && yo(function () {
        g && (d || (d = To(o, e[12], e[1].transitionWindowProps, !0)), d.run(1));
      }), t && yo(function () {
        g && (m || (m = To(n, e[11], e[1].transitionBgProps, !0)), m.run(1));
      }), g = !0);
    },
    o: function (t) {
      Po(b), a && Po(a.$$.fragment, t), t && (d || (d = To(o, e[12], e[1].transitionWindowProps, !1)), d.run(0)), t && (m || (m = To(n, e[11], e[1].transitionBgProps, !1)), m.run(0)), g = !1;
    },
    d: function (t) {
      t && Et(n), b && b.d(), a && Ho(a), e[50](null), t && d && d.end(), e[51](null), e[52](null), t && m && m.end(), h = !1, at(j);
    }
  };
}
function nr(e) {
  var n,
    t,
    o,
    r,
    i,
    a = [or, tr],
    s = [];
  function l(e, t) {
    return 2 & t[0] && (n = null), null == n && (n = !!e[17](e[1].closeButton)), n ? 0 : 1;
  }
  return t = l(e, [-1, -1, -1]), o = s[t] = a[t](e), {
    c: function () {
      o.c(), r = Nt();
    },
    m: function (e, n) {
      s[t].m(e, n), Rt(e, r, n), i = !0;
    },
    p: function (e, n) {
      var i = t;
      (t = l(e, n)) === i ? s[t].p(e, n) : (Ro(), Po(s[i], 1, 1, function () {
        s[i] = null;
      }), Eo(), (o = s[t]) ? o.p(e, n) : (o = s[t] = a[t](e)).c(), qo(o, 1), o.m(r.parentNode, r));
    },
    i: function (e) {
      i || (qo(o), i = !0);
    },
    o: function (e) {
      Po(o), i = !1;
    },
    d: function (e) {
      e && Et(r), s[t].d(e);
    }
  };
}
function tr(e) {
  var n, t, o, r;
  return {
    c: function () {
      Ut(n = Pt("button"), "class", t = ht(e[1].classCloseButton) + " svelte-n7cvum"), Ut(n, "aria-label", "Close modal"), Ut(n, "style", e[10]), Ut(n, "type", "button"), Yt(n, "close", !e[0]);
    },
    m: function (t, i) {
      Rt(t, n, i), o || (r = Bt(n, "click", e[18]), o = !0);
    },
    p: function (e, o) {
      2 & o[0] && t !== (t = ht(e[1].classCloseButton) + " svelte-n7cvum") && Ut(n, "class", t), 1024 & o[0] && Ut(n, "style", e[10]), 3 & o[0] && Yt(n, "close", !e[0]);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n), o = !1, r();
    }
  };
}
function or(e) {
  var n,
    t,
    o,
    r = e[1].closeButton;
  function i(e, n) {
    return {
      props: {
        onClose: e[18]
      }
    };
  }
  return r && (n = Kt(r, i(e))), {
    c: function () {
      n && Jo(n.$$.fragment), t = Nt();
    },
    m: function (e, r) {
      n && Vo(n, e, r), Rt(e, t, r), o = !0;
    },
    p: function (e, o) {
      if (2 & o[0] && r !== (r = e[1].closeButton)) {
        if (n) {
          Ro();
          var a = n;
          Po(a.$$.fragment, 1, 0, function () {
            Ho(a, 1);
          }), Eo();
        }
        r ? (Jo((n = Kt(r, i(e))).$$.fragment), qo(n.$$.fragment, 1), Vo(n, t.parentNode, t)) : n = null;
      }
    },
    i: function (e) {
      o || (n && qo(n.$$.fragment, e), o = !0);
    },
    o: function (e) {
      n && Po(n.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(t), n && Ho(n, e);
    }
  };
}
function rr(e) {
  var n,
    t,
    o,
    r,
    i = e[2] && er(e),
    a = e[49].default,
    s = ut(a, e, e[48], null);
  return {
    c: function () {
      i && i.c(), n = At(), s && s.c();
    },
    m: function (a, l) {
      i && i.m(a, l), Rt(a, n, l), s && s.m(a, l), t = !0, o || (r = Bt(Zo, "keydown", e[19]), o = !0);
    },
    p: function (e, o) {
      e[2] ? i ? (i.p(e, o), 4 & o[0] && qo(i, 1)) : ((i = er(e)).c(), qo(i, 1), i.m(n.parentNode, n)) : i && (Ro(), Po(i, 1, 1, function () {
        i = null;
      }), Eo()), s && s.p && (!t || 131072 & o[1]) && vt(s, a, e, e[48], t ? ft(a, e[48], o, null) : pt(e[48]), null);
    },
    i: function (e) {
      t || (qo(i), qo(s, e), t = !0);
    },
    o: function (e) {
      Po(i), Po(s, e), t = !1;
    },
    d: function (e) {
      e && Et(n), i && i.d(e), s && s.d(e), o = !1, r();
    }
  };
}
function ir(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return function (t) {
    return new e(g(g({}, t), {}, {
      props: g(g({}, n), t.props)
    }));
  };
}
function ar(e, n, t) {
  var o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f,
    v,
    p,
    m,
    h,
    j,
    b = n.$$slots,
    y = void 0 === b ? {} : b,
    x = n.$$scope,
    w = so(),
    $ = lo,
    k = n.isTabbable,
    C = void 0 === k ? function (e) {
      return e.tabIndex >= 0 && !e.hidden && !e.disabled && "none" !== e.style.display && "hidden" !== e.type && Boolean(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    } : k,
    S = n.show,
    M = void 0 === S ? null : S,
    O = n.id,
    z = void 0 === O ? null : O,
    R = n.key,
    E = void 0 === R ? "simple-modal" : R,
    q = n.ariaLabel,
    P = void 0 === q ? null : q,
    I = n.ariaLabelledBy,
    T = void 0 === I ? null : I,
    A = n.closeButton,
    N = void 0 === A || A,
    B = n.closeOnEsc,
    F = void 0 === B || B,
    L = n.closeOnOuterClick,
    U = void 0 === L || L,
    D = n.styleBg,
    J = void 0 === D ? {} : D,
    V = n.styleWindowWrap,
    H = void 0 === V ? {} : V,
    _ = n.styleWindow,
    W = void 0 === _ ? {} : _,
    Q = n.styleContent,
    Y = void 0 === Q ? {} : Q,
    G = n.styleCloseButton,
    K = void 0 === G ? {} : G,
    Z = n.classBg,
    X = void 0 === Z ? null : Z,
    ee = n.classWindowWrap,
    ne = void 0 === ee ? null : ee,
    te = n.classWindow,
    oe = void 0 === te ? null : te,
    re = n.classContent,
    ie = void 0 === re ? null : re,
    ae = n.classCloseButton,
    se = void 0 === ae ? null : ae,
    le = n.unstyled,
    ce = void 0 !== le && le,
    ue = n.setContext,
    de = void 0 === ue ? $ : ue,
    fe = n.transitionBg,
    ve = void 0 === fe ? Ko : fe,
    pe = n.transitionBgProps,
    me = void 0 === pe ? {
      duration: 250
    } : pe,
    ge = n.transitionWindow,
    he = void 0 === ge ? ve : ge,
    je = n.transitionWindowProps,
    be = void 0 === je ? me : je,
    ye = n.disableFocusTrap,
    xe = void 0 !== ye && ye,
    we = {
      id: z,
      ariaLabel: P,
      ariaLabelledBy: T,
      closeButton: N,
      closeOnEsc: F,
      closeOnOuterClick: U,
      styleBg: J,
      styleWindowWrap: H,
      styleWindow: W,
      styleContent: Y,
      styleCloseButton: K,
      classBg: X,
      classWindowWrap: ne,
      classWindow: oe,
      classContent: ie,
      classCloseButton: se,
      transitionBg: ve,
      transitionBgProps: me,
      transitionWindow: he,
      transitionWindowProps: be,
      disableFocusTrap: xe,
      isTabbable: C,
      unstyled: ce
    },
    $e = g({}, we),
    ke = null,
    Ce = function (e) {
      return e ? Object.keys(e).reduce(function (n, t) {
        return "".concat(n, "; ").concat(function (e) {
          return e.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
        }(t), ": ").concat(e[t]);
      }, "") : "";
    },
    Se = function (e) {
      return !!(e && e.constructor && e.call && e.apply);
    },
    Me = function () {},
    Oe = Me,
    ze = Me,
    Re = Me,
    Ee = Me,
    qe = function (e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      t(2, ke = ir(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {})), t(1, $e = g(g({}, we), n)), t(6, s = Ce(Object.assign({}, {
        width: window.innerWidth,
        height: window.innerHeight
      }, $e.styleBg))), t(7, l = Ce($e.styleWindowWrap)), t(8, c = Ce($e.styleWindow)), t(9, u = Ce($e.styleContent)), t(10, d = Ce($e.styleCloseButton)), t(11, f = $e.transitionBg), t(12, v = $e.transitionWindow), Ie(), t(13, Oe = function (e) {
        o.onOpen && o.onOpen(e), w("open"), w("opening");
      }), t(14, ze = function (e) {
        o.onClose && o.onClose(e), w("close"), w("closing");
      }), t(15, Re = function (e) {
        o.onOpened && o.onOpened(e), w("opened");
      }), t(16, Ee = function (e) {
        o.onClosed && o.onClosed(e), w("closed");
      });
    },
    Pe = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      ke && (t(14, ze = e.onClose || ze), t(16, Ee = e.onClosed || Ee), t(2, ke = null), Te());
    },
    Ie = function () {
      a = window.scrollY, p = document.body.style.position, m = document.body.style.overflow, h = document.body.style.width, document.body.style.position = "fixed", document.body.style.top = "-".concat(a, "px"), document.body.style.overflow = "hidden", document.body.style.width = "100%";
    },
    Te = function () {
      document.body.style.position = p || "", document.body.style.top = "", document.body.style.overflow = m || "", document.body.style.width = h || "", window.scrollTo({
        top: a,
        left: 0,
        behavior: "instant"
      });
    };
  de(E, {
    open: qe,
    close: Pe
  });
  var Ae = !1;
  return ao(function () {
    Ae && Pe();
  }), io(function () {
    t(47, Ae = !0);
  }), e.$$set = function (e) {
    "isTabbable" in e && t(22, C = e.isTabbable), "show" in e && t(23, M = e.show), "id" in e && t(24, z = e.id), "key" in e && t(25, E = e.key), "ariaLabel" in e && t(26, P = e.ariaLabel), "ariaLabelledBy" in e && t(27, T = e.ariaLabelledBy), "closeButton" in e && t(28, N = e.closeButton), "closeOnEsc" in e && t(29, F = e.closeOnEsc), "closeOnOuterClick" in e && t(30, U = e.closeOnOuterClick), "styleBg" in e && t(31, J = e.styleBg), "styleWindowWrap" in e && t(32, H = e.styleWindowWrap), "styleWindow" in e && t(33, W = e.styleWindow), "styleContent" in e && t(34, Y = e.styleContent), "styleCloseButton" in e && t(35, K = e.styleCloseButton), "classBg" in e && t(36, X = e.classBg), "classWindowWrap" in e && t(37, ne = e.classWindowWrap), "classWindow" in e && t(38, oe = e.classWindow), "classContent" in e && t(39, ie = e.classContent), "classCloseButton" in e && t(40, se = e.classCloseButton), "unstyled" in e && t(0, ce = e.unstyled), "setContext" in e && t(41, de = e.setContext), "transitionBg" in e && t(42, ve = e.transitionBg), "transitionBgProps" in e && t(43, me = e.transitionBgProps), "transitionWindow" in e && t(44, he = e.transitionWindow), "transitionWindowProps" in e && t(45, be = e.transitionWindowProps), "disableFocusTrap" in e && t(46, xe = e.disableFocusTrap), "$$scope" in e && t(48, x = e.$$scope);
  }, e.$$.update = function () {
    8388608 & e.$$.dirty[0] | 65536 & e.$$.dirty[1] && Ae && (Se(M) ? qe(M) : Pe());
  }, [ce, $e, ke, o, r, i, s, l, c, u, d, f, v, Oe, ze, Re, Ee, Se, Pe, function (e) {
    if ($e.closeOnEsc && ke && "Escape" === e.key && (e.preventDefault(), Pe()), ke && "Tab" === e.key && !$e.disableFocusTrap) {
      var n = i.querySelectorAll("*"),
        t = Array.from(n).filter($e.isTabbable).sort(function (e, n) {
          return e.tabIndex - n.tabIndex;
        }),
        o = t.indexOf(document.activeElement);
      -1 === o && e.shiftKey && (o = 0), o += t.length + (e.shiftKey ? -1 : 1), t[o %= t.length].focus(), e.preventDefault();
    }
  }, function (e) {
    !$e.closeOnOuterClick || e.target !== o && e.target !== r || (j = e.target);
  }, function (e) {
    $e.closeOnOuterClick && e.target === j && (e.preventDefault(), Pe());
  }, C, M, z, E, P, T, N, F, U, J, H, W, Y, K, X, ne, oe, ie, se, de, ve, me, he, be, xe, Ae, x, y, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(5, i = e);
    });
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(4, r = e);
    });
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(3, o = e);
    });
  }];
}
var sr,
  lr,
  cr,
  ur,
  dr,
  fr,
  vr,
  pr = function (e) {
    function n(e) {
      var t;
      return h(this, n), _o(t = u(this, n), e, ar, rr, lt, {
        isTabbable: 22,
        show: 23,
        id: 24,
        key: 25,
        ariaLabel: 26,
        ariaLabelledBy: 27,
        closeButton: 28,
        closeOnEsc: 29,
        closeOnOuterClick: 30,
        styleBg: 31,
        styleWindowWrap: 32,
        styleWindow: 33,
        styleContent: 34,
        styleCloseButton: 35,
        classBg: 36,
        classWindowWrap: 37,
        classWindow: 38,
        classContent: 39,
        classCloseButton: 40,
        unstyled: 0,
        setContext: 41,
        transitionBg: 42,
        transitionBgProps: 43,
        transitionWindow: 44,
        transitionWindowProps: 45,
        disableFocusTrap: 46
      }, Xo, [-1, -1, -1]), t;
    }
    return v(n, Wo), b(n);
  }();
!function (e) {
  e.text = "text", e.tree = "tree", e.table = "table";
}(sr || (sr = {})), function (e) {
  e.after = "after", e.inside = "inside", e.key = "key", e.value = "value", e.multi = "multi", e.text = "text";
}(lr || (lr = {})), function (e) {
  e.after = "after", e.key = "key", e.value = "value", e.inside = "inside";
}(cr || (cr = {})), function (e) {
  e.info = "info", e.warning = "warning", e.error = "error";
}(ur || (ur = {})), function (e) {
  e.key = "key", e.value = "value";
}(dr || (dr = {})), function (e) {
  e.asc = "asc", e.desc = "desc";
}(fr || (fr = {})), function (e) {
  e.no = "no", e.self = "self", e.nextInside = "nextInside";
}(vr || (vr = {}));
var mr = 50,
  gr = 200,
  hr = 400,
  jr = 1200,
  br = 1e3,
  yr = 100,
  xr = 100,
  wr = 2e4,
  $r = [{
    start: 0,
    end: yr
  }],
  kr = 104857600,
  Cr = 1048576,
  Sr = 10485760,
  Mr = 10240,
  Or = {
    closeButton: !1,
    classBg: "jse-modal-bg",
    classWindow: "jse-modal-window",
    classWindowWrap: "jse-modal-window-wrap",
    classContent: "jse-modal-container"
  },
  zr = g(g({}, Or), {}, {
    classWindow: "jse-modal-window jse-modal-window-sort"
  }),
  Rr = g(g({}, Or), {}, {
    classWindow: "jse-modal-window jse-modal-window-transform"
  }),
  Er = g(g({}, Or), {}, {
    classWindow: "jse-modal-window jse-modal-window-jsoneditor"
  }),
  qr = "Insert or paste contents, enter [ insert a new array, enter { to insert a new object, or start typing to insert a new value",
  Pr = "Open context menu (Click here, right click on the selection, or use the context menu button or Ctrl+Q)",
  Ir = "hover-insert-inside",
  Tr = "hover-insert-after",
  Ar = "hover-collection",
  Nr = "valid",
  Br = "repairable",
  Fr = 336,
  Lr = 260,
  Ur = 100,
  Dr = y(y({}, fr.asc, "ascending"), fr.desc, "descending"),
  Jr = 0;
function Vr() {
  return ++Jr;
}
function Hr(e) {
  return parseInt(e, 10);
}
function _r(e) {
  return Wr.test(e);
}
var Wr = /^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$/;
function Qr(e) {
  return "object" === S(e) && null !== e && (void 0 === e.constructor || "Object" === e.constructor.name);
}
function Yr(e) {
  return "object" === S(e) && null !== e && (void 0 === e.constructor || "Object" === e.constructor.name || "Array" === e.constructor.name);
}
function Gr(e) {
  if ("number" == typeof e) return e > 9466848e5 && isFinite(e) && Math.floor(e) === e && !isNaN(new Date(e).valueOf());
  if ("bigint" == typeof e) return Gr(Number(e));
  try {
    var n = e ? e.valueOf() : e;
    if (n !== e) return Gr(n);
  } catch (e) {
    return !1;
  }
  return !1;
}
function Kr(e) {
  (Zr = Zr || window.document.createElement("div")).style.color = "", Zr.style.color = e;
  var n = Zr.style.color;
  return "" !== n ? n.replace(/\s+/g, "").toLowerCase() : null;
}
var Zr = null;
function Xr(e, n) {
  if ("number" == typeof e || "string" == typeof e || "boolean" == typeof e || void 0 === e) return S(e);
  if ("bigint" == typeof e) return "number";
  if (null === e) return "null";
  if (Array.isArray(e)) return "array";
  if (Qr(e)) return "object";
  var t = n.stringify(e);
  return t && _r(t) ? "number" : "true" === t || "false" === t ? "boolean" : "null" === t ? "null" : "unknown";
}
var ei = /^https?:\/\/\S+$/;
function ni(e) {
  return "string" == typeof e && ei.test(e);
}
function ti(e, n) {
  if ("" === e) return "";
  var t = e.trim();
  return "null" === t ? null : "true" === t || "false" !== t && (_r(t) ? n.parse(t) : e);
}
function oi(e) {
  return ri.test(e);
}
var ri = /^-?[0-9]+$/,
  ii = 1e4,
  ai = [];
function si(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
    t = {};
  if (!Array.isArray(e)) throw new TypeError("Array expected");
  function o(e, r) {
    (!Array.isArray(e) && !Qr(e) || n && r.length > 0) && (t[O(r)] = !0), Qr(e) && Object.keys(e).forEach(function (n) {
      o(e[n], r.concat(n));
    });
  }
  for (var r = Math.min(e.length, ii), i = 0; i < r; i++) {
    o(e[i], ai);
  }
  return Object.keys(t).sort().map(M);
}
function li(e, n, t) {
  if (!(n <= e)) for (var o = e; o < n; o++) t(o);
}
function ci(e, n) {
  return e.length > n ? e.slice(0, n) : e;
}
function ui(e) {
  return g({}, e);
}
function di(e) {
  return Object.values(e);
}
function fi(e, n, t, o) {
  var r = e.slice(0),
    i = r.splice(n, t);
  return r.splice.apply(r, [n + o, 0].concat(w(i))), r;
}
function vi(e, n) {
  try {
    return n.parse(e);
  } catch (t) {
    return n.parse(_(e));
  }
}
function pi(e, n) {
  try {
    return vi(e, n);
  } catch (e) {
    return;
  }
}
function mi(e, n) {
  e = e.replace(hi, "");
  try {
    return n(e);
  } catch (e) {}
  try {
    return n("[" + e + "]");
  } catch (e) {}
  try {
    return n("{" + e + "}");
  } catch (e) {}
  throw new Error("Failed to parse partial JSON");
}
function gi(e) {
  e = e.replace(hi, "");
  try {
    return _(e);
  } catch (e) {}
  try {
    var n = _("[" + e + "]");
    return n.substring(1, n.length - 1);
  } catch (e) {}
  try {
    var t = _("{" + e + "}");
    return t.substring(1, t.length - 1);
  } catch (e) {}
  throw new Error("Failed to repair partial JSON");
}
var hi = /,\s*$/;
function ji(e, n) {
  var t = Oi.exec(n);
  if (t) {
    var o = Hr(t[2]),
      r = function (e, n) {
        for (var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e.length, r = 0, i = t; i < o; i++) e.charAt(i) === n && r++;
        return r;
      }(e, "\n", 0, o),
      i = o - e.lastIndexOf("\n", o) - 1;
    return {
      position: o,
      line: r,
      column: i,
      message: n.replace(Oi, function () {
        return "line ".concat(r + 1, " column ").concat(i + 1);
      })
    };
  }
  var a = zi.exec(n),
    s = a ? Hr(a[1]) : null,
    l = null !== s ? s - 1 : null,
    c = Ri.exec(n),
    u = c ? Hr(c[1]) : null,
    d = null !== u ? u - 1 : null,
    f = null !== l && null !== d ? function (e, n, t) {
      var o = e.indexOf("\n"),
        r = 1;
      for (; r < n && -1 !== o;) o = e.indexOf("\n", o + 1), r++;
      return -1 !== o ? o + t + 1 : null;
    }(e, l, d) : null;
  return {
    position: f,
    line: l,
    column: d,
    message: n.replace(/^JSON.parse: /, "").replace(/ of the JSON data$/, "")
  };
}
function bi(e) {
  return Qr(e) ? void 0 !== e.json ? void 0 !== e.text ? 'Content must contain either a property "json" or a property "text" but not both' : null : void 0 === e.text ? 'Content must contain either a property "json" or a property "text"' : "string" != typeof e.text ? 'Content "text" property must be a string containing a JSON document. Did you mean to use the "json" property instead?' : null : "Content must be an object";
}
function yi(e) {
  return Qr(e) && (void 0 !== e.json || "string" == typeof e.text);
}
function xi(e) {
  return Qr(e) && "string" == typeof e.text;
}
function wi(e) {
  return Qr(e) && void 0 !== e.json;
}
function $i(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
    t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : JSON;
  return xi(e) ? e : {
    text: t.stringify(e.json, null, n)
  };
}
function ki(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : JSON;
  return wi(e) ? e : {
    json: n.parse(e.text)
  };
}
function Ci(e, n, t) {
  return $i(e, n, t).text;
}
function Si(e, n) {
  return Mi(e, n) > n;
}
function Mi(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1 / 0;
  if (xi(e)) return e.text.length;
  var t = e.json,
    o = 0;
  return function e(t) {
    if (Array.isArray(t)) {
      if ((o += t.length - 1 + 2) > n) return o;
      for (var r = 0; r < t.length; r++) {
        if (e(t[r]), o > n) return o;
      }
    } else if (Qr(t)) {
      var i = Object.keys(t);
      o += 2 + i.length + (i.length - 1);
      for (var a = 0; a < i.length; a++) {
        var s = i[a],
          l = t[s];
        o += s.length + 2, e(l);
      }
    } else o += "string" == typeof t ? t.length + 2 : String(t).length;
  }(t), o;
}
var Oi = /(position|char) (\d+)/,
  zi = /line (\d+)/,
  Ri = /column (\d+)/;
function Ei(e, n) {
  return e.parse === n.parse && e.stringify === n.stringify;
}
function qi(e) {
  var n = e.substring(0, 999).trim();
  return !n.includes("\n") && Pi.test(n);
}
var Pi = /[,:]\S/;
function Ii(e) {
  var n = e.escapeControlCharacters,
    t = e.escapeUnicodeCharacters;
  return n ? t ? Ti : Ai : t ? Ni : Bi;
}
var Ti = {
    escapeValue: function (e) {
      return Fi(Ji(String(e)));
    },
    unescapeValue: function (e) {
      return Vi(Li(e));
    }
  },
  Ai = {
    escapeValue: function (e) {
      return Ji(String(e));
    },
    unescapeValue: function (e) {
      return Vi(e);
    }
  },
  Ni = {
    escapeValue: function (e) {
      return Fi(String(e));
    },
    unescapeValue: function (e) {
      return Li(e);
    }
  },
  Bi = {
    escapeValue: function (e) {
      return String(e);
    },
    unescapeValue: function (e) {
      return e;
    }
  };
function Fi(e) {
  return e.replace(/[^\x20-\x7F]/g, function (e) {
    var n;
    return "\b" === e || "\f" === e || "\n" === e || "\r" === e || "\t" === e ? e : "\\u" + ("000" + (null === (n = e.codePointAt(0)) || void 0 === n ? void 0 : n.toString(16))).slice(-4);
  });
}
function Li(e) {
  return e.replace(/\\u[a-fA-F0-9]{4}/g, function (e) {
    try {
      var n = JSON.parse('"' + e + '"');
      return Ui[n] || n;
    } catch (n) {
      return e;
    }
  });
}
var Ui = {
    '"': '\\"',
    "\\": "\\\\",
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "\t": "\\t"
  },
  Di = {
    '\\"': '"',
    "\\\\": "\\",
    "\\/": "/",
    "\\b": "\b",
    "\\f": "\f",
    "\\n": "\n",
    "\\r": "\r",
    "\\t": "\t"
  };
function Ji(e) {
  return e.replace(/["\b\f\n\r\t\\]/g, function (e) {
    return Ui[e] || e;
  });
}
function Vi(e) {
  return e.replace(/\\["bfnrt\\]/g, function (e) {
    return Di[e] || e;
  });
}
function Hi(e) {
  return "string" != typeof e ? String(e) : e.endsWith("\n") ? e + "\n" : e;
}
function _i(e, n) {
  return Qi(e, function (e) {
    return e.nodeName.toUpperCase() === n.toUpperCase();
  });
}
function Wi(e, n, t) {
  return Qi(e, function (e) {
    return function (e, n, t) {
      return "function" == typeof e.getAttribute && e.getAttribute(n) === t;
    }(e, n, t);
  });
}
function Qi(e, n) {
  return !!Yi(e, n);
}
function Yi(e, n) {
  for (var t = e; t && !n(t);) t = t.parentNode;
  return t || void 0;
}
function Gi(e) {
  if (null != e.firstChild) {
    var n = document.createRange(),
      t = window.getSelection();
    n.setStart(e, 1), n.collapse(!0), null == t || t.removeAllRanges(), null == t || t.addRange(n);
  } else e.focus();
}
function Ki(e, n, t, o) {
  var r = Zi(e);
  if (r) {
    var i = r.document.activeElement ? r.document.activeElement : null;
    i && i.isContentEditable && (i.textContent = t ? n : i.textContent + n, Gi(i), o && o(i));
  }
}
function Zi(e) {
  return e && e.ownerDocument ? e.ownerDocument.defaultView : null;
}
function Xi(e) {
  var n = Zi(e),
    t = null == n ? void 0 : n.document.activeElement;
  return !!t && Qi(t, function (n) {
    return n === e;
  });
}
function ea(e, n) {
  return Yi(e, function (e) {
    return e.nodeName === n;
  });
}
function na(e) {
  return Wi(e, "data-type", "selectable-key") ? lr.key : Wi(e, "data-type", "selectable-value") ? lr.value : Wi(e, "data-type", "insert-selection-area-inside") ? lr.inside : Wi(e, "data-type", "insert-selection-area-after") ? lr.after : lr.multi;
}
function ta(e) {
  return encodeURIComponent(O(e));
}
function oa(e) {
  var n = Yi(e, function (e) {
      return !(null == e || !e.hasAttribute) && e.hasAttribute("data-path");
    }),
    t = null == n ? void 0 : n.getAttribute("data-path");
  return t ? M(decodeURIComponent(t)) : null;
}
function ra(e) {
  var n = e.allElements,
    t = e.currentElement,
    o = e.direction,
    r = e.hasPrio,
    i = void 0 === r ? function () {
      return !0;
    } : r,
    a = e.margin,
    s = void 0 === a ? 10 : a,
    l = Q(n.filter(function (e) {
      var n = e.getBoundingClientRect();
      return n.width > 0 && n.height > 0;
    }), u),
    c = u(t);
  function u(e) {
    var n = e.getBoundingClientRect();
    return {
      x: n.left + n.width / 2,
      y: n.top + n.height / 2,
      rect: n,
      element: e
    };
  }
  function d(e, n) {
    var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
      o = e.x - n.x,
      r = (e.y - n.y) * t;
    return Math.sqrt(o * o + r * r);
  }
  var f = function (e) {
    return d(e, c);
  };
  if ("Left" === o || "Right" === o) {
    var v = "Left" === o ? l.filter(function (e) {
        return n = c, e.rect.left + s < n.rect.left;
        var n;
      }) : l.filter(function (e) {
        return n = c, e.rect.right > n.rect.right + s;
        var n;
      }),
      p = v.filter(function (e) {
        return n = e, t = c, Math.abs(n.y - t.y) < s;
        var n, t;
      }),
      m = Y(p, f) || Y(v, function (e) {
        return d(e, c, 10);
      });
    return null == m ? void 0 : m.element;
  }
  if ("Up" === o || "Down" === o) {
    var g = "Up" === o ? l.filter(function (e) {
        return n = c, e.y + s < n.y;
        var n;
      }) : l.filter(function (e) {
        return n = c, e.y > n.y + s;
        var n;
      }),
      h = g.filter(function (e) {
        return i(e.element);
      }),
      j = Y(h, f) || Y(g, f);
    return null == j ? void 0 : j.element;
  }
}
function ia(e) {
  return !!e && "DIV" === e.nodeName && "function" == typeof e.refresh && "function" == typeof e.cancel;
}
function aa() {
  var e, n, t, o;
  return null !== (e = null !== (n = null === (t = navigator) || void 0 === t || null === (t = t.platform) || void 0 === t ? void 0 : t.toUpperCase().includes("MAC")) && void 0 !== n ? n : null === (o = navigator) || void 0 === o || null === (o = o.userAgentData) || void 0 === o || null === (o = o.platform) || void 0 === o ? void 0 : o.toUpperCase().includes("MAC")) && void 0 !== e && e;
}
function sa(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "+",
    t = [];
  la(e, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : aa) && t.push("Ctrl"), e.altKey && t.push("Alt"), e.shiftKey && t.push("Shift");
  var o = 1 === e.key.length ? e.key.toUpperCase() : e.key;
  return o in ca || t.push(o), t.join(n);
}
function la(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : aa;
  return e.ctrlKey || e.metaKey && n();
}
var ca = {
    Ctrl: !0,
    Command: !0,
    Control: !0,
    Alt: !0,
    Option: !0,
    Shift: !0
  },
  ua = kt.window;
function da(e) {
  St(e, "svelte-1r8q3m8", ".jse-absolute-popup.svelte-1r8q3m8.svelte-1r8q3m8{position:relative;left:0;top:0;width:0;height:0;z-index:1001}.jse-absolute-popup.svelte-1r8q3m8 .jse-hidden-input.svelte-1r8q3m8{position:fixed;left:0;top:0;width:0;height:0;padding:0;margin:0;border:none;outline:none;overflow:hidden}.jse-absolute-popup.svelte-1r8q3m8 .jse-absolute-popup-content.svelte-1r8q3m8{position:absolute}");
}
function fa(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s = [e[0].props],
    l = e[0].component;
  function c(e, n) {
    for (var t = {}, o = 0; o < s.length; o += 1) t = ot(t, s[o]);
    return void 0 !== n && 1 & n && (t = ot(t, Lo(s, [Uo(e[0].props)]))), {
      props: t
    };
  }
  return l && (r = Kt(l, c(e))), {
    c: function () {
      n = Pt("div"), t = Pt("input"), o = At(), r && Jo(r.$$.fragment), Ut(t, "type", "text"), t.readOnly = !0, Ut(t, "tabindex", "-1"), Ut(t, "class", "jse-hidden-input svelte-1r8q3m8"), Ut(n, "class", "jse-absolute-popup-content svelte-1r8q3m8"), Ut(n, "style", i = ma(e[1], e[0].options));
    },
    m: function (i, s) {
      Rt(i, n, s), Ct(n, t), e[7](t), Ct(n, o), r && Vo(r, n, null), a = !0;
    },
    p: function (e, t) {
      if (1 & t && l !== (l = e[0].component)) {
        if (r) {
          Ro();
          var o = r;
          Po(o.$$.fragment, 1, 0, function () {
            Ho(o, 1);
          }), Eo();
        }
        l ? (Jo((r = Kt(l, c(e, t))).$$.fragment), qo(r.$$.fragment, 1), Vo(r, n, null)) : r = null;
      } else if (l) {
        var u = 1 & t ? Lo(s, [Uo(e[0].props)]) : {};
        r.$set(u);
      }
      (!a || 3 & t && i !== (i = ma(e[1], e[0].options))) && Ut(n, "style", i);
    },
    i: function (e) {
      a || (r && qo(r.$$.fragment, e), a = !0);
    },
    o: function (e) {
      r && Po(r.$$.fragment, e), a = !1;
    },
    d: function (t) {
      t && Et(n), e[7](null), r && Ho(r);
    }
  };
}
function va(e) {
  var n,
    t,
    o,
    r,
    i = e[1] && fa(e);
  return {
    c: function () {
      n = Pt("div"), i && i.c(), Ut(n, "role", "none"), Ut(n, "class", "jse-absolute-popup svelte-1r8q3m8");
    },
    m: function (a, s) {
      Rt(a, n, s), i && i.m(n, null), e[8](n), t = !0, o || (r = [Bt(ua, "mousedown", e[3], !0), Bt(ua, "keydown", e[4], !0), Bt(ua, "wheel", e[5], !0), Bt(n, "mousedown", pa), Bt(n, "keydown", e[4])], o = !0);
    },
    p: function (e, t) {
      var o = s(t, 1)[0];
      e[1] ? i ? (i.p(e, o), 2 & o && qo(i, 1)) : ((i = fa(e)).c(), qo(i, 1), i.m(n, null)) : i && (Ro(), Po(i, 1, 1, function () {
        i = null;
      }), Eo());
    },
    i: function (e) {
      t || (qo(i), t = !0);
    },
    o: function (e) {
      Po(i), t = !1;
    },
    d: function (t) {
      t && Et(n), i && i.d(), e[8](null), o = !1, at(r);
    }
  };
}
function pa(e) {
  e.stopPropagation();
}
function ma(e, n) {
  var t = e.getBoundingClientRect(),
    o = function () {
      if (n.anchor) {
        var e = n.anchor,
          t = n.width,
          o = void 0 === t ? 0 : t,
          r = n.height,
          i = void 0 === r ? 0 : r,
          a = n.offsetTop,
          s = void 0 === a ? 0 : a,
          l = n.offsetLeft,
          c = void 0 === l ? 0 : l,
          u = n.position,
          d = e.getBoundingClientRect(),
          f = d.left,
          v = d.top,
          p = d.bottom,
          m = d.right,
          g = "top" === u || v + i > window.innerHeight && v > i,
          h = "left" === u || f + o > window.innerWidth && f > o;
        return {
          left: h ? m - c : f + c,
          top: g ? v - s : p + s,
          positionAbove: g,
          positionLeft: h
        };
      }
      if ("number" == typeof n.left && "number" == typeof n.top) {
        var j = n.left,
          b = n.top,
          y = n.width,
          x = void 0 === y ? 0 : y,
          w = n.height,
          $ = void 0 === w ? 0 : w;
        return {
          left: j,
          top: b,
          positionAbove: b + $ > window.innerHeight && b > $,
          positionLeft: j + x > window.innerWidth && j > x
        };
      }
      throw new Error('Invalid config: pass either "left" and "top", or pass "anchor"');
    }(),
    r = o.left,
    i = o.top,
    a = o.positionAbove,
    s = o.positionLeft;
  return (a ? "bottom: ".concat(t.top - i, "px;") : "top: ".concat(i - t.top, "px;")) + (s ? "right: ".concat(t.left - r, "px;") : "left: ".concat(r - t.left, "px;"));
}
function ga(e, n, t) {
  var o,
    r,
    i = n.popup,
    a = n.closeAbsolutePopup;
  function s(e) {
    i.options && i.options.closeOnOuterClick && !Qi(e.target, function (e) {
      return e === o;
    }) && a(i.id);
  }
  return io(function () {
    r && r.focus();
  }), e.$$set = function (e) {
    "popup" in e && t(0, i = e.popup), "closeAbsolutePopup" in e && t(6, a = e.closeAbsolutePopup);
  }, [i, o, r, function (e) {
    s(e);
  }, function (e) {
    "Escape" === sa(e) && a(i.id);
  }, function (e) {
    s(e);
  }, a, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(2, r = e);
    });
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(1, o = e);
    });
  }];
}
var ha = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, ga, va, lt, {
      popup: 0,
      closeAbsolutePopup: 6
    }, da), t;
  }
  return v(n, Wo), b(n);
}();
function ja(e, n, t) {
  var o = e.slice();
  return o[6] = n[t], o;
}
function ba(e) {
  var n, t;
  return n = new ha({
    props: {
      popup: e[6],
      closeAbsolutePopup: e[1]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.popup = e[6]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function ya(e) {
  for (var n, t, o = Ao(e[0]), r = [], i = 0; i < o.length; i += 1) r[i] = ba(ja(e, o, i));
  var a = function (e) {
      return Po(r[e], 1, 1, function () {
        r[e] = null;
      });
    },
    l = e[3].default,
    c = ut(l, e, e[2], null);
  return {
    c: function () {
      for (var e = 0; e < r.length; e += 1) r[e].c();
      n = At(), c && c.c();
    },
    m: function (e, o) {
      for (var i = 0; i < r.length; i += 1) r[i] && r[i].m(e, o);
      Rt(e, n, o), c && c.m(e, o), t = !0;
    },
    p: function (e, i) {
      var u = s(i, 1)[0];
      if (3 & u) {
        var d;
        for (o = Ao(e[0]), d = 0; d < o.length; d += 1) {
          var f = ja(e, o, d);
          r[d] ? (r[d].p(f, u), qo(r[d], 1)) : (r[d] = ba(f), r[d].c(), qo(r[d], 1), r[d].m(n.parentNode, n));
        }
        for (Ro(), d = o.length; d < r.length; d += 1) a(d);
        Eo();
      }
      c && c.p && (!t || 4 & u) && vt(c, l, e, e[2], t ? ft(l, e[2], u, null) : pt(e[2]), null);
    },
    i: function (e) {
      if (!t) {
        for (var n = 0; n < o.length; n += 1) qo(r[n]);
        qo(c, e), t = !0;
      }
    },
    o: function (e) {
      r = r.filter(Boolean);
      for (var n = 0; n < r.length; n += 1) Po(r[n]);
      Po(c, e), t = !1;
    },
    d: function (e) {
      e && Et(n), qt(r, e), c && c.d(e);
    }
  };
}
function xa(e, n, t) {
  var o = n.$$slots,
    r = void 0 === o ? {} : o,
    i = n.$$scope,
    a = Qo("jsoneditor:AbsolutePopup"),
    s = [];
  function l(e) {
    var n = s.findIndex(function (n) {
      return n.id === e;
    });
    if (-1 !== n) {
      var o = s[n];
      o.options.onClose && o.options.onClose(), t(0, s = s.filter(function (n) {
        return n.id !== e;
      }));
    }
  }
  return lo("absolute-popup", {
    openAbsolutePopup: function (e, n, o) {
      a("open...", n, o);
      var r = {
        id: Vr(),
        component: e,
        props: n || {},
        options: o || {}
      };
      return t(0, s = [].concat(w(s), [r])), r.id;
    },
    closeAbsolutePopup: l
  }), e.$$set = function (e) {
    "$$scope" in e && t(2, i = e.$$scope);
  }, e.$$.update = function () {
    1 & e.$$.dirty && a("popups", s);
  }, [s, l, i, r];
}
var wa = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, xa, ya, ct, {}), t;
  }
  return v(n, Wo), b(n);
}();
function $a(e) {
  return e.map(function (e, n) {
    return za.test(e) ? "[" + e + "]" : /[.[\]]/.test(e) || "" === e ? '["' + (e.replace(/"/g, '\\"') + '"]') : (n > 0 ? "." : "") + e;
  }).join("");
}
function ka(e) {
  for (var n = [], t = 0; t < e.length;) "." === e[t] && t++, "[" === e[t] ? (t++, '"' === e[t] ? (t++, n.push(o(function (e) {
    return '"' === e;
  }, !0)), r('"')) : n.push(o(function (e) {
    return "]" === e;
  })), r("]")) : n.push(o(function (e) {
    return "." === e || "[" === e;
  }));
  function o(n) {
    for (var o = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = ""; t < e.length && !n(e[t]);) o && "\\" === e[t] && '"' === e[t + 1] ? (r += '"', t += 2) : (r += e[t], t++);
    return r;
  }
  function r(n) {
    if (e[t] !== n) throw new SyntaxError("Invalid JSON path: ".concat(n, " expected at position ").concat(t));
    t++;
  }
  return n;
}
function Ca(e) {
  return {
    value: e,
    label: G(e) ? "(item root)" : $a(e)
  };
}
function Sa(e) {
  if (za.test(e)) return "[" + e + "]";
  if (Oa.test(e)) return "." + e;
  var n = JSON.stringify(e);
  return "['" + n.substring(1, n.length - 1).replace(/\\"/g, '"') + "']";
}
function Ma(e) {
  return e.map(function (e) {
    return za.test(e) ? "?.[".concat(e, "]") : Oa.test(e) ? "?.".concat(e) : "?.[".concat(JSON.stringify(e), "]");
  }).join("");
}
var Oa = /^[a-zA-Z$_][a-zA-Z$_\d]*$/,
  za = /^\d+$/;
function Ra(e, n) {
  for (var t = new Set(n), o = e.replace(/ \(copy( \d+)?\)$/, ""), r = e, i = 1; t.has(r);) {
    var a = "copy" + (i > 1 ? " " + i : "");
    r = "".concat(o, " (").concat(a, ")"), i++;
  }
  return r;
}
function Ea(e, n) {
  var t = n - 3;
  return e.length > n ? e.substring(0, t) + "..." : e;
}
function qa(e) {
  if ("" === e) return "";
  var n = e.toLowerCase();
  if ("null" === n) return null;
  if ("true" === n) return !0;
  if ("false" === n) return !1;
  if ("undefined" !== n) {
    var t = Number(e),
      o = parseFloat(e);
    return isNaN(t) || isNaN(o) ? e : t;
  }
}
var Pa = {
  id: "javascript",
  name: "JavaScript",
  description: "\n<p>\n  Enter a JavaScript function to filter, sort, or transform the data.\n</p>\n",
  createQuery: function (e, n) {
    var t = n.filter,
      o = n.sort,
      r = n.projection,
      i = ["  return data\n"];
    if (t && t.path && t.relation && t.value) {
      var a = "item => item".concat(Ma(t.path)),
        s = qa(t.value),
        l = "string" == typeof s ? "'".concat(t.value, "'") : oi(t.value) && !Number.isSafeInteger(s) ? "".concat(t.value, "n") : t.value;
      i.push("    .filter(".concat(a, " ").concat(t.relation, " ").concat(l, ")\n"));
    }
    o && o.path && o.direction && ("desc" === o.direction ? i.push("    .slice()\n    .sort((a, b) => {\n      // sort descending\n" + "      const valueA = a".concat(Ma(o.path), "\n") + "      const valueB = b".concat(Ma(o.path), "\n") + "      return valueA > valueB ? -1 : valueA < valueB ? 1 : 0\n    })\n") : i.push("    .slice()\n    .sort((a, b) => {\n      // sort ascending\n" + "      const valueA = a".concat(Ma(o.path), "\n") + "      const valueB = b".concat(Ma(o.path), "\n") + "      return valueA > valueB ? 1 : valueA < valueB ? -1 : 0\n    })\n"));
    if (r && r.paths) if (r.paths.length > 1) {
      var c = r.paths.map(function (e) {
        var n = e[e.length - 1] || "item",
          t = "item".concat(Ma(e));
        return "      ".concat(JSON.stringify(n), ": ").concat(t);
      });
      i.push("    .map(item => ({\n".concat(c.join(",\n"), "})\n    )\n"));
    } else {
      var u = "item".concat(Ma(r.paths[0]));
      i.push("    .map(item => ".concat(u, ")\n"));
    }
    return "function query (data) {\n".concat(i.join(""), "}");
  },
  executeQuery: function (e, n) {
    var t = new Function('"use strict";\n\n' + n + '\n\nif (typeof query !== "function") {\n  throw new Error("Cannot execute query: expecting a function named \'query\' but is undefined")\n}\n\nreturn query;\n')()(e);
    return void 0 !== t ? t : null;
  }
};
function Ia(e) {
  var n;
  return {
    c: function () {
      n = It("g");
    },
    m: function (t, o) {
      Rt(t, n, o), n.innerHTML = e[0];
    },
    p: function (e, t) {
      1 & s(t, 1)[0] && (n.innerHTML = e[0]);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Ta(e, n, t) {
  var o = 870711;
  var r = "",
    i = n.data;
  function a(e) {
    if (!e || !e.raw) return "";
    var n = e.raw,
      t = {};
    return n = n.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (e, n) {
      var r = "fa-".concat((o += 1).toString(16));
      return t[n] = r, ' id="'.concat(r, '"');
    }), n = n.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (e, n, o, r) {
      var i = n || r;
      return i && t[i] ? "#".concat(t[i]) : e;
    }), n;
  }
  return e.$$set = function (e) {
    "data" in e && t(1, i = e.data);
  }, e.$$.update = function () {
    2 & e.$$.dirty && t(0, r = a(i));
  }, [r, i];
}
var Aa = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Ta, Ia, lt, {
      data: 1
    }), t;
  }
  return v(n, Wo), b(n);
}();
function Na(e) {
  St(e, "svelte-1mc5hvj", ".fa-icon.svelte-1mc5hvj{display:inline-block;fill:currentColor}.fa-flip-horizontal.svelte-1mc5hvj{transform:scale(-1, 1)}.fa-flip-vertical.svelte-1mc5hvj{transform:scale(1, -1)}.fa-spin.svelte-1mc5hvj{animation:svelte-1mc5hvj-fa-spin 1s 0s infinite linear}.fa-inverse.svelte-1mc5hvj{color:#fff}.fa-pulse.svelte-1mc5hvj{animation:svelte-1mc5hvj-fa-spin 1s infinite steps(8)}@keyframes svelte-1mc5hvj-fa-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}");
}
function Ba(e) {
  for (var n, t, o, r, i = e[12].default, a = ut(i, e, e[11], null), l = [{
      version: "1.1"
    }, {
      class: t = "fa-icon " + e[0]
    }, {
      width: e[1]
    }, {
      height: e[2]
    }, {
      "aria-label": e[9]
    }, {
      role: o = e[9] ? "img" : "presentation"
    }, {
      viewBox: e[3]
    }, {
      style: e[8]
    }, e[10]], c = {}, u = 0; u < l.length; u += 1) c = ot(c, l[u]);
  return {
    c: function () {
      n = It("svg"), a && a.c(), Vt(n, c), Yt(n, "fa-spin", e[4]), Yt(n, "fa-pulse", e[6]), Yt(n, "fa-inverse", e[5]), Yt(n, "fa-flip-horizontal", "horizontal" === e[7]), Yt(n, "fa-flip-vertical", "vertical" === e[7]), Yt(n, "svelte-1mc5hvj", !0);
    },
    m: function (e, t) {
      Rt(e, n, t), a && a.m(n, null), r = !0;
    },
    p: function (e, u) {
      var d = s(u, 1)[0];
      a && a.p && (!r || 2048 & d) && vt(a, i, e, e[11], r ? ft(i, e[11], d, null) : pt(e[11]), null), Vt(n, c = Lo(l, [{
        version: "1.1"
      }, (!r || 1 & d && t !== (t = "fa-icon " + e[0])) && {
        class: t
      }, (!r || 2 & d) && {
        width: e[1]
      }, (!r || 4 & d) && {
        height: e[2]
      }, (!r || 512 & d) && {
        "aria-label": e[9]
      }, (!r || 512 & d && o !== (o = e[9] ? "img" : "presentation")) && {
        role: o
      }, (!r || 8 & d) && {
        viewBox: e[3]
      }, (!r || 256 & d) && {
        style: e[8]
      }, 1024 & d && e[10]])), Yt(n, "fa-spin", e[4]), Yt(n, "fa-pulse", e[6]), Yt(n, "fa-inverse", e[5]), Yt(n, "fa-flip-horizontal", "horizontal" === e[7]), Yt(n, "fa-flip-vertical", "vertical" === e[7]), Yt(n, "svelte-1mc5hvj", !0);
    },
    i: function (e) {
      r || (qo(a, e), r = !0);
    },
    o: function (e) {
      Po(a, e), r = !1;
    },
    d: function (e) {
      e && Et(n), a && a.d(e);
    }
  };
}
function Fa(e, n, t) {
  var o = ["class", "width", "height", "box", "spin", "inverse", "pulse", "flip", "style", "label"],
    r = gt(n, o),
    i = n,
    a = i.$$slots,
    s = void 0 === a ? {} : a,
    l = i.$$scope,
    c = n.class,
    u = void 0 === c ? "" : c,
    d = n.width,
    f = n.height,
    v = n.box,
    p = void 0 === v ? "0 0 0 0" : v,
    m = n.spin,
    g = void 0 !== m && m,
    h = n.inverse,
    j = void 0 !== h && h,
    b = n.pulse,
    y = void 0 !== b && b,
    x = n.flip,
    w = void 0 === x ? "none" : x,
    $ = n.style,
    k = void 0 === $ ? "" : $,
    C = n.label,
    S = void 0 === C ? "" : C;
  return e.$$set = function (e) {
    n = ot(ot({}, n), mt(e)), t(10, r = gt(n, o)), "class" in e && t(0, u = e.class), "width" in e && t(1, d = e.width), "height" in e && t(2, f = e.height), "box" in e && t(3, p = e.box), "spin" in e && t(4, g = e.spin), "inverse" in e && t(5, j = e.inverse), "pulse" in e && t(6, y = e.pulse), "flip" in e && t(7, w = e.flip), "style" in e && t(8, k = e.style), "label" in e && t(9, S = e.label), "$$scope" in e && t(11, l = e.$$scope);
  }, [u, d, f, p, g, j, y, w, k, S, r, l, s];
}
var La = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Fa, Ba, lt, {
      class: 0,
      width: 1,
      height: 2,
      box: 3,
      spin: 4,
      inverse: 5,
      pulse: 6,
      flip: 7,
      style: 8,
      label: 9
    }, Na), t;
  }
  return v(n, Wo), b(n);
}();
function Ua(e, n, t) {
  var o = e.slice();
  return o[24] = n[t], o;
}
function Da(e, n, t) {
  var o = e.slice();
  return o[27] = n[t], o;
}
function Ja(e) {
  for (var n, t = [e[27]], o = {}, r = 0; r < t.length; r += 1) o = ot(o, t[r]);
  return {
    c: function () {
      Vt(n = It("path"), o);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, r) {
      Vt(n, o = Lo(t, [64 & r && e[27]]));
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Va(e) {
  for (var n, t = [e[24]], o = {}, r = 0; r < t.length; r += 1) o = ot(o, t[r]);
  return {
    c: function () {
      Vt(n = It("polygon"), o);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, r) {
      Vt(n, o = Lo(t, [64 & r && e[24]]));
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Ha(e) {
  var n, t, o;
  function r(n) {
    e[16](n);
  }
  var i = {};
  return void 0 !== e[6] && (i.data = e[6]), n = new Aa({
    props: i
  }), vo.push(function () {
    return Do(n, "data", r);
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, t) {
      Vo(n, e, t), o = !0;
    },
    p: function (e, o) {
      var r = {};
      !t && 64 & o && (t = !0, r.data = e[6], xo(function () {
        return t = !1;
      })), n.$set(r);
    },
    i: function (e) {
      o || (qo(n.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), o = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function _a(e) {
  var n,
    t = e[15].default,
    o = ut(t, e, e[17], null),
    r = o || function (e) {
      for (var n, t, o, r, i, a, s, l = Ao((null === (n = e[6]) || void 0 === n ? void 0 : n.paths) || []), c = [], u = 0; u < l.length; u += 1) c[u] = Ja(Da(e, l, u));
      for (var d = Ao((null === (t = e[6]) || void 0 === t ? void 0 : t.polygons) || []), f = [], v = 0; v < d.length; v += 1) f[v] = Va(Ua(e, d, v));
      var p = (null === (o = e[6]) || void 0 === o ? void 0 : o.raw) && Ha(e);
      return {
        c: function () {
          for (var e = 0; e < c.length; e += 1) c[e].c();
          r = At();
          for (var n = 0; n < f.length; n += 1) f[n].c();
          i = At(), p && p.c(), a = Nt();
        },
        m: function (e, n) {
          for (var t = 0; t < c.length; t += 1) c[t] && c[t].m(e, n);
          Rt(e, r, n);
          for (var o = 0; o < f.length; o += 1) f[o] && f[o].m(e, n);
          Rt(e, i, n), p && p.m(e, n), Rt(e, a, n), s = !0;
        },
        p: function (e, n) {
          var t;
          if (64 & n) {
            var o, s;
            for (l = Ao((null === (o = e[6]) || void 0 === o ? void 0 : o.paths) || []), s = 0; s < l.length; s += 1) {
              var u = Da(e, l, s);
              c[s] ? c[s].p(u, n) : (c[s] = Ja(u), c[s].c(), c[s].m(r.parentNode, r));
            }
            for (; s < c.length; s += 1) c[s].d(1);
            c.length = l.length;
          }
          if (64 & n) {
            var v, m;
            for (d = Ao((null === (v = e[6]) || void 0 === v ? void 0 : v.polygons) || []), m = 0; m < d.length; m += 1) {
              var g = Ua(e, d, m);
              f[m] ? f[m].p(g, n) : (f[m] = Va(g), f[m].c(), f[m].m(i.parentNode, i));
            }
            for (; m < f.length; m += 1) f[m].d(1);
            f.length = d.length;
          }
          null !== (t = e[6]) && void 0 !== t && t.raw ? p ? (p.p(e, n), 64 & n && qo(p, 1)) : ((p = Ha(e)).c(), qo(p, 1), p.m(a.parentNode, a)) : p && (Ro(), Po(p, 1, 1, function () {
            p = null;
          }), Eo());
        },
        i: function (e) {
          s || (qo(p), s = !0);
        },
        o: function (e) {
          Po(p), s = !1;
        },
        d: function (e) {
          e && (Et(r), Et(i), Et(a)), qt(c, e), qt(f, e), p && p.d(e);
        }
      };
    }(e);
  return {
    c: function () {
      r && r.c();
    },
    m: function (e, t) {
      r && r.m(e, t), n = !0;
    },
    p: function (e, i) {
      o ? o.p && (!n || 131072 & i) && vt(o, t, e, e[17], n ? ft(t, e[17], i, null) : pt(e[17]), null) : r && r.p && (!n || 64 & i) && r.p(e, n ? i : -1);
    },
    i: function (e) {
      n || (qo(r, e), n = !0);
    },
    o: function (e) {
      Po(r, e), n = !1;
    },
    d: function (e) {
      r && r.d(e);
    }
  };
}
function Wa(e) {
  for (var n, t, o = [{
      label: e[5]
    }, {
      width: e[7]
    }, {
      height: e[8]
    }, {
      box: e[10]
    }, {
      style: e[9]
    }, {
      spin: e[1]
    }, {
      flip: e[4]
    }, {
      inverse: e[2]
    }, {
      pulse: e[3]
    }, {
      class: e[0]
    }, e[11]], r = {
      $$slots: {
        default: [_a]
      },
      $$scope: {
        ctx: e
      }
    }, i = 0; i < o.length; i += 1) r = ot(r, o[i]);
  return n = new La({
    props: r
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var r = s(t, 1)[0],
        i = 4031 & r ? Lo(o, [32 & r && {
          label: e[5]
        }, 128 & r && {
          width: e[7]
        }, 256 & r && {
          height: e[8]
        }, 1024 & r && {
          box: e[10]
        }, 512 & r && {
          style: e[9]
        }, 2 & r && {
          spin: e[1]
        }, 16 & r && {
          flip: e[4]
        }, 4 & r && {
          inverse: e[2]
        }, 8 & r && {
          pulse: e[3]
        }, 1 & r && {
          class: e[0]
        }, 2048 & r && Uo(e[11])]) : {};
      131136 & r && (i.$$scope = {
        dirty: r,
        ctx: e
      }), n.$set(i);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Qa(e, n, t) {
  var o,
    r,
    i,
    a = ["class", "data", "scale", "spin", "inverse", "pulse", "flip", "label", "style"],
    l = gt(n, a),
    c = n,
    u = c.$$slots,
    d = void 0 === u ? {} : u,
    f = c.$$scope,
    v = n.class,
    p = void 0 === v ? "" : v,
    m = n.data,
    g = n.scale,
    h = void 0 === g ? 1 : g,
    j = n.spin,
    b = void 0 !== j && j,
    y = n.inverse,
    x = void 0 !== y && y,
    w = n.pulse,
    $ = void 0 !== w && w,
    k = n.flip,
    C = void 0 === k ? void 0 : k,
    S = n.label,
    M = void 0 === S ? "" : S,
    O = n.style,
    z = void 0 === O ? "" : O,
    R = 10,
    E = 10;
  function q() {
    var e = 1;
    return void 0 !== h && (e = Number(h)), isNaN(e) || e <= 0 ? (console.warn('Invalid prop: prop "scale" should be a number over 0.'), 1) : 1 * e;
  }
  function P() {
    return o ? Math.max(o.width, o.height) / 16 : 1;
  }
  return e.$$set = function (e) {
    n = ot(ot({}, n), mt(e)), t(11, l = gt(n, a)), "class" in e && t(0, p = e.class), "data" in e && t(12, m = e.data), "scale" in e && t(13, h = e.scale), "spin" in e && t(1, b = e.spin), "inverse" in e && t(2, x = e.inverse), "pulse" in e && t(3, $ = e.pulse), "flip" in e && t(4, C = e.flip), "label" in e && t(5, M = e.label), "style" in e && t(14, z = e.style), "$$scope" in e && t(17, f = e.$$scope);
  }, e.$$.update = function () {
    28672 & e.$$.dirty && (t(6, o = function (e) {
      var n;
      if (e) {
        if (!("definition" in e)) {
          if ("iconName" in e && "icon" in e) {
            e.iconName;
            var t = s(e.icon, 5),
              o = t[0],
              r = t[1],
              i = t[4];
            n = {
              width: o,
              height: r,
              paths: (Array.isArray(i) ? i : [i]).map(function (e) {
                return {
                  d: e
                };
              })
            };
          } else n = e[Object.keys(e)[0]];
          return n;
        }
        console.error("`import faIconName from '@fortawesome/package-name/faIconName` not supported - Please use `import { faIconName } from '@fortawesome/package-name/faIconName'` instead");
      }
    }(m)), t(7, R = o ? o.width / P() * q() : 0), t(8, E = o ? o.height / P() * q() : 0), t(9, r = function () {
      var e = "";
      null !== z && (e += z);
      var n = q();
      return 1 === n ? 0 === e.length ? "" : e : ("" === e || e.endsWith(";") || (e += "; "), "".concat(e, "font-size: ").concat(n, "em"));
    }()), t(10, i = o ? "0 0 ".concat(o.width, " ").concat(o.height) : "0 0 ".concat(R, " ").concat(E)));
  }, [p, b, x, $, C, M, o, R, E, r, i, l, m, h, z, d, function (e) {
    t(6, o = e), t(12, m), t(14, z), t(13, h);
  }, f];
}
var Ya = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Qa, Wa, lt, {
      class: 0,
      data: 12,
      scale: 13,
      spin: 1,
      inverse: 2,
      pulse: 3,
      flip: 4,
      label: 5,
      style: 14
    }), t;
  }
  return v(n, Wo), b(n);
}();
function Ga(e) {
  St(e, "svelte-68vtq4", ".jse-boolean-toggle.svelte-68vtq4{padding:0;margin:1px 0 0;vertical-align:top;display:inline-flex;color:var(--jse-value-color-boolean, #ff8c00)}.jse-boolean-toggle.svelte-68vtq4:not(.jse-readonly){cursor:pointer}");
}
function Ka(e) {
  var n, t, o, r, i, a, l;
  return t = new Ya({
    props: {
      data: !0 === e[0] ? pe : me
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "role", "checkbox"), Ut(n, "tabindex", "-1"), Ut(n, "aria-checked", o = !0 === e[0]), Ut(n, "class", "jse-boolean-toggle svelte-68vtq4"), Ut(n, "title", r = e[1] ? "Boolean value ".concat(e[0]) : "Click to toggle this boolean value"), Yt(n, "jse-readonly", e[1]);
    },
    m: function (o, r) {
      Rt(o, n, r), Vo(t, n, null), i = !0, a || (l = Bt(n, "mousedown", e[2]), a = !0);
    },
    p: function (e, a) {
      var l = s(a, 1)[0],
        c = {};
      1 & l && (c.data = !0 === e[0] ? pe : me), t.$set(c), (!i || 1 & l && o !== (o = !0 === e[0])) && Ut(n, "aria-checked", o), (!i || 3 & l && r !== (r = e[1] ? "Boolean value ".concat(e[0]) : "Click to toggle this boolean value")) && Ut(n, "title", r), (!i || 2 & l) && Yt(n, "jse-readonly", e[1]);
    },
    i: function (e) {
      i || (qo(t.$$.fragment, e), i = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), i = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), a = !1, l();
    }
  };
}
function Za(e, n, t) {
  var o = n.path,
    r = n.value,
    i = n.readOnly,
    a = n.onPatch,
    s = n.focus;
  return e.$$set = function (e) {
    "path" in e && t(3, o = e.path), "value" in e && t(0, r = e.value), "readOnly" in e && t(1, i = e.readOnly), "onPatch" in e && t(4, a = e.onPatch), "focus" in e && t(5, s = e.focus);
  }, [r, i, function (e) {
    e.stopPropagation(), i || (a([{
      op: "replace",
      path: O(o),
      value: !r
    }]), s());
  }, o, a, s];
}
var Xa = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Za, Ka, ct, {
      path: 3,
      value: 0,
      readOnly: 1,
      onPatch: 4,
      focus: 5
    }, Ga), t;
  }
  return v(n, Wo), b(n);
}();
function es(e) {
  St(e, "svelte-1f4ayrt", ".jse-color-picker-popup.svelte-1f4ayrt .picker_wrapper.popup,.jse-color-picker-popup.svelte-1f4ayrt .picker_wrapper.popup .picker_arrow::before,.jse-color-picker-popup.svelte-1f4ayrt .picker_wrapper.popup .picker_arrow::after{background:var(--jse-color-picker-background, var(--jse-panel-background, #ebebeb));line-height:normal}.jse-color-picker-popup.svelte-1f4ayrt .picker_slider,.jse-color-picker-popup.svelte-1f4ayrt .picker_sl,.jse-color-picker-popup.svelte-1f4ayrt .picker_editor input,.jse-color-picker-popup.svelte-1f4ayrt .picker_sample,.jse-color-picker-popup.svelte-1f4ayrt .picker_done button{box-shadow:var(--jse-color-picker-border-box-shadow, #cbcbcb 0 0 0 1px)}.jse-color-picker-popup.svelte-1f4ayrt .picker_editor input{background:var(--jse-background-color, #fff);color:var(--jse-text-color, #4d4d4d)}.jse-color-picker-popup.svelte-1f4ayrt .picker_done button{background:var(--jse-button-background, #e0e0e0);color:var(--jse-button-color, var(--jse-text-color, #4d4d4d))}.jse-color-picker-popup.svelte-1f4ayrt .picker_done button:hover{background:var(--jse-button-background-highlight, #e7e7e7)}");
}
function ns(e) {
  var n;
  return {
    c: function () {
      Ut(n = Pt("div"), "class", "jse-color-picker-popup svelte-1f4ayrt");
    },
    m: function (t, o) {
      Rt(t, n, o), e[4](n);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (t) {
      t && Et(n), e[4](null);
    }
  };
}
function ts(e, n, t) {
  var o,
    i = n.color,
    s = n.onChange,
    l = n.showOnTop,
    c = function () {};
  return io(a(r().mark(function e() {
    var n, t, a;
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return e.next = 2, import("vanilla-picker");
        case 2:
          if (e.t1 = n = e.sent, e.t0 = null === e.t1, e.t0) {
            e.next = 6;
            break;
          }
          e.t0 = void 0 === n;
        case 6:
          if (!e.t0) {
            e.next = 10;
            break;
          }
          e.t2 = void 0, e.next = 11;
          break;
        case 10:
          e.t2 = n.default;
        case 11:
          t = e.t2, a = new t({
            parent: o,
            color: i,
            popup: l ? "top" : "bottom",
            onDone: function (e) {
              var n = 1 === e.rgba[3] ? e.hex.substring(0, 7) : e.hex;
              s(n);
            }
          }), a.show(), c = function () {
            a.destroy();
          };
        case 15:
        case "end":
          return e.stop();
      }
    }, e);
  }))), ao(function () {
    c();
  }), e.$$set = function (e) {
    "color" in e && t(1, i = e.color), "onChange" in e && t(2, s = e.onChange), "showOnTop" in e && t(3, l = e.showOnTop);
  }, [o, i, s, l, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(0, o = e);
    });
  }];
}
var os = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, ts, ns, lt, {
      color: 1,
      onChange: 2,
      showOnTop: 3
    }, es), t;
  }
  return v(n, Wo), b(n);
}();
function rs(e) {
  St(e, "svelte-1zzxwe", ".jse-color-picker-button.svelte-1zzxwe{font-size:var(--jse-font-size-mono, 14px);width:var(--jse-color-picker-button-size, 1em);height:var(--jse-color-picker-button-size, 1em);box-sizing:border-box;padding:0;margin:2px 0 0;display:inline-flex;vertical-align:top;border:1px solid var(--jse-text-color, #4d4d4d);border-radius:2px;background:inherit;outline:none}.jse-color-picker-button.svelte-1zzxwe:not(.jse-readonly){cursor:pointer}");
}
function is(e) {
  var n, t, o, r;
  return {
    c: function () {
      Ut(n = Pt("button"), "type", "button"), Ut(n, "class", "jse-color-picker-button svelte-1zzxwe"), Wt(n, "background", e[2]), Ut(n, "title", t = e[1] ? "Color ".concat(e[0]) : "Click to open a color picker"), Yt(n, "jse-readonly", e[1]);
    },
    m: function (t, i) {
      Rt(t, n, i), o || (r = Bt(n, "click", e[3]), o = !0);
    },
    p: function (e, o) {
      var r = s(o, 1)[0];
      4 & r && Wt(n, "background", e[2]), 3 & r && t !== (t = e[1] ? "Color ".concat(e[0]) : "Click to open a color picker") && Ut(n, "title", t), 2 & r && Yt(n, "jse-readonly", e[1]);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n), o = !1, r();
    }
  };
}
function as(e, n, t) {
  var o,
    r = co("absolute-popup").openAbsolutePopup,
    i = n.path,
    a = n.value,
    s = n.readOnly,
    l = n.onPatch,
    c = n.focus;
  function u(e) {
    l([{
      op: "replace",
      path: O(i),
      value: e
    }]), d();
  }
  function d() {
    c();
  }
  return e.$$set = function (e) {
    "path" in e && t(4, i = e.path), "value" in e && t(0, a = e.value), "readOnly" in e && t(1, s = e.readOnly), "onPatch" in e && t(5, l = e.onPatch), "focus" in e && t(6, c = e.focus);
  }, e.$$.update = function () {
    1 & e.$$.dirty && t(2, o = Kr(a));
  }, [a, s, o, function (e) {
    var n, t;
    if (!s) {
      var o = e.target,
        i = o.getBoundingClientRect().top,
        l = null !== (n = null === (t = Zi(o)) || void 0 === t ? void 0 : t.innerHeight) && void 0 !== n ? n : 0;
      r(os, {
        color: a,
        onChange: u,
        showOnTop: l - i < 300 && i > 300
      }, {
        anchor: o,
        closeOnOuterClick: !0,
        onClose: d,
        offsetTop: 18,
        offsetLeft: -8,
        height: 300
      });
    }
  }, i, l, c];
}
var ss = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, as, is, ct, {
      path: 4,
      value: 0,
      readOnly: 1,
      onPatch: 5,
      focus: 6
    }, rs), t;
  }
  return v(n, Wo), b(n);
}();
function ls(e) {
  for (var n = Z(e, function (e) {
      return e.start;
    }), t = [n[0]], o = 0; o < n.length; o++) {
    var r = t.length - 1,
      i = t[r],
      a = n[o];
    a.start <= i.end ? t[r] = {
      start: Math.min(i.start, a.start),
      end: Math.max(i.end, a.end)
    } : t.push(a);
  }
  return t;
}
function cs(e, n) {
  return e.some(function (e) {
    return n >= e.start && n < e.end;
  });
}
function us(e) {
  return ds(e) + yr;
}
function ds(e) {
  return Math.floor(e / yr) * yr;
}
function fs(e) {
  var n = {
    expandedMap: {},
    enforceStringMap: {},
    visibleSectionsMap: {},
    selection: null,
    sortedColumn: null
  };
  return null != e && e.select && void 0 !== e.json && (n = g(g({}, n), {}, {
    selection: e.select(e.json, n)
  })), null != e && e.expand && (n = gs(e.json, n, [], e.expand)), n;
}
function vs(e, n) {
  return e.visibleSectionsMap[n] || $r;
}
function ps(e, n, t) {
  n.forEach(function (n) {
    var o = n.start,
      r = n.end;
    li(o, Math.min(e.length, r), t);
  });
}
function ms(e, n, t) {
  for (var o = g({}, n.expandedMap), r = g({}, n.visibleSectionsMap), i = 0; i < t.length; i++) {
    var a = t.slice(0, i),
      s = O(a),
      l = z(e, a);
    if (Yr(l) && (o[s] = !0), Array.isArray(l) && i < t.length) {
      var c = r[s] || $r,
        u = Hr(t[i]);
      if (!cs(c, u)) {
        var d = ds(u),
          f = {
            start: d,
            end: us(d)
          };
        r[s] = ls(c.concat(f));
      }
    }
  }
  return g(g({}, n), {}, {
    expandedMap: o,
    visibleSectionsMap: r
  });
}
function gs(e, n, t, r) {
  var i = g({}, n.expandedMap);
  var a = t.slice(),
    s = void 0 !== e ? z(e, t) : e;
  return void 0 !== s && function e(t) {
    var s = a.length;
    if (Array.isArray(t)) {
      if (r(a)) {
        var l = O(a);
        if (i[l] = !0, t.length > 0) {
          var c = vs(n, l);
          ps(t, c, function (n) {
            a[s] = String(n), e(t[n]);
          }), a.pop();
        }
      }
    } else if (Qr(t) && r(a)) {
      i[O(a)] = !0;
      var u = Object.keys(t);
      if (u.length > 0) {
        var d,
          f = o(u);
        try {
          for (f.s(); !(d = f.n()).done;) {
            var v = d.value;
            a[s] = v, e(t[v]);
          }
        } catch (e) {
          f.e(e);
        } finally {
          f.f();
        }
        a.pop();
      }
    }
  }(s), g(g({}, n), {}, {
    expandedMap: i
  });
}
function hs(e, n) {
  var t = ws(e.expandedMap, n),
    o = ws(e.enforceStringMap, n),
    r = ws(e.visibleSectionsMap, n);
  return g(g({}, e), {}, {
    expandedMap: t,
    enforceStringMap: o,
    visibleSectionsMap: r
  });
}
function js(e, n, t) {
  if (t) {
    var o = g({}, e.enforceStringMap);
    return o[n] = t, g(g({}, e), {}, {
      enforceStringMap: o
    });
  }
  if ("boolean" == typeof e.enforceStringMap[n]) {
    var r = g({}, e.enforceStringMap);
    return delete r[n], g(g({}, e), {}, {
      enforceStringMap: r
    });
  }
  return e;
}
function bs(e, n, t) {
  var o = R(e, t),
    r = t.reduce(function (e, n) {
      return E(n) ? ys(o, e, n) : q(n) ? xs(o, e, n) : P(n) ? function (e, n, t) {
        var o = t.path,
          r = Ms(e, n.expandedMap),
          i = Ms(e, n.enforceStringMap),
          a = Ms(e, n.visibleSectionsMap);
        B(t.value) || N(t.value) || delete r[o];
        N(t.value) || delete a[o];
        (B(t.value) || N(t.value)) && delete i[o];
        return g(g({}, n), {}, {
          expandedMap: r,
          enforceStringMap: i,
          visibleSectionsMap: a
        });
      }(o, e, n) : I(n) || T(n) ? function (e, n, t) {
        if (T(t) && t.from === t.path) return n;
        var o = function (e) {
            return t.path + e.substring(t.from.length);
          },
          r = Cs($s(n.expandedMap, t.from), o),
          i = Cs($s(n.enforceStringMap, t.from), o),
          a = Cs($s(n.visibleSectionsMap, t.from), o),
          s = n;
        T(t) && (s = xs(e, s, {
          op: "remove",
          path: t.from
        }));
        s = ys(e, s, {
          op: "add",
          path: t.path,
          value: null
        });
        var l = ks(s.expandedMap, r),
          c = ks(s.enforceStringMap, i),
          u = ks(s.visibleSectionsMap, a);
        return g(g({}, n), {}, {
          expandedMap: l,
          enforceStringMap: c,
          visibleSectionsMap: u
        });
      }(o, e, n) : e;
    }, n);
  return {
    json: o,
    documentState: r
  };
}
function ys(e, n, t) {
  var o = A(e, t.path),
    r = X(o),
    i = O(r),
    a = z(e, r);
  if (N(a)) {
    var s = Hr(ee(o)),
      l = Ss(n.expandedMap, r, s, 1),
      c = Ss(n.enforceStringMap, r, s, 1),
      u = Ss(n.visibleSectionsMap, r, s, 1);
    return u = Os(u, i, function (e) {
      return zs(e, s, 1);
    }), g(g({}, n), {}, {
      expandedMap: l,
      enforceStringMap: c,
      visibleSectionsMap: u
    });
  }
  return n;
}
function xs(e, n, t) {
  var o = A(e, t.path),
    r = X(o),
    i = O(r),
    a = z(e, r),
    s = n.expandedMap,
    l = n.enforceStringMap,
    c = n.visibleSectionsMap;
  if (s = ws(s, o), l = ws(l, o), c = ws(c, o), N(a)) {
    var u = Hr(ee(o));
    s = Ss(s, r, u, -1), l = Ss(l, r, u, -1), c = Os(c = Ss(c, r, u, -1), i, function (e) {
      return zs(e, u, -1);
    });
  }
  return g(g({}, n), {}, {
    expandedMap: s,
    enforceStringMap: l,
    visibleSectionsMap: c
  });
}
function ws(e, n) {
  var t = {},
    o = O(n);
  return Object.keys(e).forEach(function (n) {
    F(n, o) || (t[n] = e[n]);
  }), t;
}
function $s(e, n) {
  var t = {};
  return Object.keys(e).forEach(function (o) {
    F(o, n) && (t[o] = e[o]);
  }), t;
}
function ks(e, n) {
  return g(g({}, e), n);
}
function Cs(e, n) {
  var t = {};
  return Object.keys(e).forEach(function (o) {
    var r = n(o);
    t[r] = e[o];
  }), t;
}
function Ss(e, n, t, o) {
  for (var r = n.length, i = O(n), a = [], s = 0, l = Object.keys(e); s < l.length; s++) {
    var c = l[s];
    if (F(c, i)) {
      var u = M(c),
        d = Hr(u[r]);
      d >= t && (u[r] = String(d + o), a.push({
        oldPointer: c,
        newPointer: O(u),
        value: e[c]
      }));
    }
  }
  if (0 === a.length) return e;
  var f = g({}, e);
  return a.forEach(function (e) {
    delete f[e.oldPointer];
  }), a.forEach(function (e) {
    f[e.newPointer] = e.value;
  }), f;
}
function Ms(e, n) {
  var t = {};
  return Object.keys(n).filter(function (n) {
    return L(e, A(e, n));
  }).forEach(function (e) {
    t[e] = n[e];
  }), t;
}
function Os(e, n, t) {
  var o = e[n];
  if (n in e) {
    var r = t(o);
    if (!ne(o, r)) {
      var i = g({}, e);
      return void 0 === r ? delete i[n] : i[n] = r, i;
    }
  }
  return e;
}
function zs(e, n, t) {
  return function (e) {
    var n = e.slice(0),
      t = 1;
    for (; t < n.length;) n[t - 1].end === n[t].start && (n[t - 1] = {
      start: n[t - 1].start,
      end: n[t].end
    }, n.splice(t)), t++;
    return n;
  }(e.map(function (e) {
    return {
      start: e.start > n ? e.start + t : e.start,
      end: e.end > n ? e.end + t : e.end
    };
  }));
}
function Rs(e, n, t, o) {
  var r = n ? n[t] : void 0;
  return "boolean" == typeof r ? r : function (e, n) {
    return "string" == typeof e && "string" != typeof ti(e, n);
  }(e, o);
}
function Es(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
    o = e.indexOf(n);
  return -1 !== o ? t ? e.slice(o) : e.slice(o + 1) : [];
}
function qs(e, n) {
  var t = [];
  return function e(o, r) {
    t.push(r);
    var i = O(r);
    if (o && !0 === n.expandedMap[i]) {
      if (N(o)) {
        var a = vs(n, i);
        ps(o, a, function (n) {
          e(o[n], r.concat(String(n)));
        });
      }
      B(o) && Object.keys(o).forEach(function (n) {
        e(o[n], r.concat(n));
      });
    }
  }(e, []), t;
}
function Ps(e, n) {
  var t = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
    o = [];
  return function e(r, i) {
    o.push({
      path: i,
      type: cr.value
    });
    var a = O(i);
    if (r && !0 === n.expandedMap[a]) {
      if (t && o.push({
        path: i,
        type: cr.inside
      }), N(r)) {
        var s = vs(n, a);
        ps(r, s, function (n) {
          var a = i.concat(String(n));
          e(r[n], a), t && o.push({
            path: a,
            type: cr.after
          });
        });
      }
      if (B(r)) Object.keys(r).forEach(function (n) {
        var a = i.concat(n);
        o.push({
          path: a,
          type: cr.key
        }), e(r[n], a), t && o.push({
          path: a,
          type: cr.after
        });
      });
    }
  }(e, []), o;
}
function Is(e, n, t) {
  var o = qs(e, n),
    r = o.map(O).indexOf(O(t));
  return -1 !== r && r < o.length - 1 ? o[r + 1] : null;
}
function Ts(e, n, t) {
  var o = z(e, t);
  return void 0 === o ? n : gs(e, n, t, !Si({
    json: o
  }, Mr) ? Ns : As);
}
function As(e) {
  return 0 === e.length || 1 === e.length && "0" === e[0];
}
function Ns() {
  return !0;
}
function Bs(e) {
  return e && e.type === lr.after || !1;
}
function Fs(e) {
  return e && e.type === lr.inside || !1;
}
function Ls(e) {
  return e && e.type === lr.key || !1;
}
function Us(e) {
  return e && e.type === lr.value || !1;
}
function Ds(e) {
  return e && e.type === lr.multi || !1;
}
function Js(e) {
  return Ds(e) && ne(e.focusPath, e.anchorPath);
}
function Vs(e) {
  return Ds(e) || Bs(e) || Fs(e) || Ls(e) || Us(e);
}
function Hs(e) {
  return e && e.type === lr.text || !1;
}
function _s(e, n) {
  var t = [];
  return function (e, n, t) {
    if (!n) return;
    var o = yl(n),
      r = bl(n);
    if (ne(o, r)) return t(o);
    if (void 0 === e) return;
    var i = el(o, r);
    if (o.length === i.length || r.length === i.length) return t(i);
    var a = cl(o, r),
      s = Qs(e, a),
      l = Ys(e, a),
      c = jl(e, a, s),
      u = jl(e, a, l);
    if (-1 === c || -1 === u) return;
    var d = z(e, i);
    if (B(d)) {
      for (var f = Object.keys(d), v = c; v <= u; v++) {
        var p = t(i.concat(f[v]));
        if (void 0 !== p) return p;
      }
      return;
    }
    if (N(d)) {
      for (var m = c; m <= u; m++) {
        var g = t(i.concat(String(m)));
        if (void 0 !== g) return g;
      }
      return;
    }
    throw new Error("Failed to create selection");
  }(e, n, function (e) {
    t.push(e);
  }), t;
}
function Ws(e) {
  return Fs(e) ? e.path : X(bl(e));
}
function Qs(e, n) {
  if (!Ds(n)) return n.path;
  var t = jl(e, n, n.anchorPath);
  return jl(e, n, n.focusPath) < t ? n.focusPath : n.anchorPath;
}
function Ys(e, n) {
  if (!Ds(n)) return n.path;
  var t = jl(e, n, n.anchorPath);
  return jl(e, n, n.focusPath) > t ? n.focusPath : n.anchorPath;
}
function Gs(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
    o = n.selection;
  if (!o) return null;
  var r = t ? bl(o) : Qs(e, o),
    i = function (e, n, t) {
      var o = qs(e, n),
        r = o.map(O),
        i = O(t),
        a = r.indexOf(i);
      return -1 !== a && a > 0 ? o[a - 1] : null;
    }(e, n, r);
  if (t) return Fs(o) || Bs(o) ? null !== i ? cl(r, r) : null : null !== i ? cl(yl(o), i) : null;
  if (Bs(o)) return al(r, !1);
  if (Fs(o)) return al(r, !1);
  if (Ls(o)) {
    if (null == i || 0 === i.length) return null;
    var a = X(i),
      s = z(e, a);
    return Array.isArray(s) || G(i) ? al(i, !1) : il(i, !1);
  }
  return Us(o), null !== i ? al(i, !1) : null;
}
function Ks(e, n, t) {
  var o = n.selection;
  if (!o) return {
    caret: null,
    previous: null,
    next: null
  };
  var r = Ps(e, n, t),
    i = r.findIndex(function (e) {
      return ne(e.path, bl(o)) && String(e.type) === String(o.type);
    });
  return {
    caret: -1 !== i ? r[i] : null,
    previous: -1 !== i && i > 0 ? r[i - 1] : null,
    next: -1 !== i && i < r.length - 1 ? r[i + 1] : null
  };
}
function Zs(e, n) {
  for (var t = qs(e, n), o = 0; o < t.length - 1 && t[o + 1].length > t[o].length;) o++;
  var r = t[o];
  return void 0 === r || 0 === r.length || Array.isArray(z(e, X(r))) ? al(r, !1) : il(r, !1);
}
function Xs(e, n) {
  if (1 === n.length) {
    var t = te(n);
    if ("replace" === t.op) return al(A(e, t.path), !1);
  }
  if (!G(n) && n.every(function (e) {
    return "move" === e.op;
  })) {
    var o = te(n),
      r = n.slice(1);
    if ((I(o) || T(o)) && o.from !== o.path && r.every(function (e) {
      return (I(e) || T(e)) && e.from === e.path;
    })) return il(A(e, o.path), !1);
  }
  var i = n.filter(function (e) {
    return "test" !== e.op && "remove" !== e.op && ("move" !== e.op || e.from !== e.path) && "string" == typeof e.path;
  }).map(function (n) {
    return A(e, n.path);
  });
  return G(i) ? null : {
    type: lr.multi,
    anchorPath: te(i),
    focusPath: ee(i)
  };
}
function el(e, n) {
  for (var t = 0; t < e.length && t < n.length && e[t] === n[t];) t++;
  return e.slice(0, t);
}
function nl(e) {
  return Ls(e) || Us(e) || Js(e);
}
function tl(e, n) {
  return nl(n) && Yr(z(e, bl(n))) ? bl(n) : X(bl(n));
}
function ol(e, n) {
  if (e.length < n.length) return !1;
  for (var t = 0; t < n.length; t++) if (e[t] !== n[t]) return !1;
  return !0;
}
function rl(e) {
  var n = e.selection;
  return (Ls(n) || Us(n)) && n.edit ? g(g({}, e), {}, {
    selection: g(g({}, n), {}, {
      edit: !1
    })
  }) : e;
}
function il(e, n) {
  return {
    type: lr.key,
    path: e,
    edit: n
  };
}
function al(e, n) {
  return {
    type: lr.value,
    path: e,
    edit: n
  };
}
function sl(e) {
  return {
    type: lr.inside,
    path: e
  };
}
function ll(e) {
  return {
    type: lr.after,
    path: e
  };
}
function cl(e, n) {
  var t = el(e, n),
    o = e.length > t.length && n.length > t.length;
  return {
    type: lr.multi,
    anchorPath: o ? t.concat(e[t.length]) : t,
    focusPath: o ? t.concat(n[t.length]) : t
  };
}
function ul(e, n, t, o) {
  if (Ls(n)) return String(ee(n.path));
  if (Us(n)) {
    var r,
      i = z(e, n.path);
    return "string" == typeof i ? i : null !== (r = o.stringify(i, null, t)) && void 0 !== r ? r : null;
  }
  if (Ds(n)) {
    var a;
    if (G(n.focusPath)) return null !== (a = o.stringify(e, null, t)) && void 0 !== a ? a : null;
    var s = Ws(n),
      l = z(e, s);
    if (Array.isArray(l)) {
      if (Js(n)) {
        var c,
          u = z(e, n.focusPath);
        return null !== (c = o.stringify(u, null, t)) && void 0 !== c ? c : null;
      }
      return _s(e, n).map(function (n) {
        var r = z(e, n);
        return "".concat(o.stringify(r, null, t), ",");
      }).join("\n");
    }
    return _s(e, n).map(function (n) {
      var r = ee(n),
        i = z(e, n);
      return "".concat(o.stringify(r), ": ").concat(o.stringify(i, null, t), ",");
    }).join("\n");
  }
  return null;
}
function dl(e) {
  return (Ls(e) || Us(e)) && !0 === e.edit;
}
function fl(e) {
  return Ls(e) || Us(e) || Ds(e);
}
function vl(e) {
  return Ls(e) || Us(e) || Js(e);
}
function pl(e) {
  switch (e.type) {
    case cr.key:
      return il(e.path, !1);
    case cr.value:
      return al(e.path, !1);
    case cr.after:
      return ll(e.path);
    case cr.inside:
      return sl(e.path);
  }
}
function ml(e, n, t) {
  switch (n) {
    case lr.key:
      return il(t, !1);
    case lr.value:
      return al(t, !1);
    case lr.after:
      return ll(t);
    case lr.inside:
      return sl(t);
    case lr.multi:
    case lr.text:
      return cl(t, t);
  }
}
function gl(e, n, t) {
  return n && (hl(e, n, t) || ol(Ds(n) ? X(n.focusPath) : n.path, t)) ? n : null;
}
function hl(e, n, t) {
  if (void 0 === e || !n) return !1;
  if (Ls(n) || Fs(n) || Bs(n)) return ne(n.path, t);
  if (Us(n)) return ol(t, n.path);
  if (Ds(n)) {
    var o = Qs(e, n),
      r = Ys(e, n),
      i = X(n.focusPath);
    if (!ol(t, i) || t.length <= i.length) return !1;
    var a = jl(e, n, o),
      s = jl(e, n, r),
      l = jl(e, n, t);
    return -1 !== l && l >= a && l <= s;
  }
  return !1;
}
function jl(e, n, t) {
  var o = X(n.focusPath);
  if (!ol(t, o) || t.length <= o.length) return -1;
  var r = t[o.length],
    i = z(e, o);
  if (B(i)) return Object.keys(i).indexOf(r);
  if (N(i)) {
    var a = Hr(r);
    if (a < i.length) return a;
  }
  return -1;
}
function bl(e) {
  return Ds(e) ? e.focusPath : e.path;
}
function yl(e) {
  return Ds(e) ? e.anchorPath : e.path;
}
function xl() {
  for (var e = [], n = arguments.length, t = new Array(n), o = 0; o < n; o++) t[o] = arguments[o];
  for (var r = 0, i = t; r < i.length; r++) {
    var a = i[r];
    if ("string" == typeof a && e.push(a), a && "object" === S(a)) for (var s in a) Object.hasOwnProperty.call(a, s) && a[s] && e.push(s);
  }
  return e.join(" ");
}
function wl(e, n) {
  return xl("jse-value", "jse-" + Xr(e, n), {
    "jse-url": ni(e),
    "jse-empty": "string" == typeof e && 0 === e.length
  });
}
function $l(e) {
  St(e, "svelte-zwlnit", ".jse-value.jse-string.svelte-zwlnit{color:var(--jse-value-color-string, #008000)}.jse-value.jse-object.svelte-zwlnit,.jse-value.jse-array.svelte-zwlnit{min-width:16px;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-value.jse-number.svelte-zwlnit{color:var(--jse-value-color-number, #ee422e)}.jse-value.jse-boolean.svelte-zwlnit{color:var(--jse-value-color-boolean, #ff8c00)}.jse-value.jse-null.svelte-zwlnit{color:var(--jse-value-color-null, #004ed0)}.jse-value.jse-invalid.svelte-zwlnit{color:var(--jse-text-color, #4d4d4d)}.jse-value.jse-url.svelte-zwlnit{color:var(--jse-value-color-url, #008000);text-decoration:underline}div.jse-editable-div.svelte-zwlnit{min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;cursor:text !important;word-break:normal;white-space:pre-wrap;overflow-wrap:anywhere}div.jse-editable-div.jse-short-text.svelte-zwlnit{overflow-wrap:normal}div.jse-editable-div[contenteditable=true].svelte-zwlnit{outline:var(--jse-edit-outline, 2px solid #656565);background:inherit !important;position:relative;border-radius:0;z-index:3}div.jse-editable-div.jse-empty.svelte-zwlnit:not(:focus){outline:1px dotted var(--jse-tag-background, rgba(0, 0, 0, 0.2));-moz-outline-radius:2px}div.jse-editable-div.jse-empty.svelte-zwlnit::after{pointer-events:none;color:var(--jse-tag-background, rgba(0, 0, 0, 0.2))}");
}
function kl(e) {
  var n, t, o, r;
  return {
    c: function () {
      Ut(n = Pt("div"), "role", "textbox"), Ut(n, "tabindex", "0"), Ut(n, "class", t = ht(xl("jse-editable-div", e[2], {
        "jse-short-text": e[0]
      })) + " svelte-zwlnit"), Ut(n, "contenteditable", "true"), Ut(n, "spellcheck", "false");
    },
    m: function (t, i) {
      Rt(t, n, i), e[13](n), o || (r = [Bt(n, "input", e[3]), Bt(n, "keydown", e[4]), Bt(n, "paste", e[5]), Bt(n, "blur", e[6])], o = !0);
    },
    p: function (e, o) {
      5 & s(o, 1)[0] && t !== (t = ht(xl("jse-editable-div", e[2], {
        "jse-short-text": e[0]
      })) + " svelte-zwlnit") && Ut(n, "class", t);
    },
    i: nt,
    o: nt,
    d: function (t) {
      t && Et(n), e[13](null), o = !1, at(r);
    }
  };
}
function Cl(e, n, t) {
  var o,
    r,
    i = Qo("jsoneditor:EditableDiv"),
    a = n.value,
    s = n.shortText,
    l = void 0 !== s && s,
    c = n.onChange,
    u = n.onCancel,
    d = n.onFind,
    f = n.onPaste,
    v = void 0 === f ? oe : f,
    p = n.onValueClass,
    m = void 0 === p ? function () {
      return "";
    } : p,
    g = !1;
  function h() {
    return o ? function (e) {
      return e.replace(/\n$/, "");
    }(o.innerText) : "";
  }
  function j(e) {
    o && t(1, o.innerText = Hi(e), o);
  }
  function b() {
    var e = h();
    "" === e && j(""), t(2, r = m(e));
  }
  function y() {
    g = !0, u();
  }
  return io(function () {
    i("onMount", {
      value: a
    }), j(a), o && (Gi(o), t(1, o.refresh = b, o), t(1, o.cancel = y, o));
  }), ao(function () {
    var e = h();
    i("onDestroy", {
      closed: g,
      value: a,
      newValue: e
    }), g || e === a || c(e, vr.no);
  }), e.$$set = function (e) {
    "value" in e && t(7, a = e.value), "shortText" in e && t(0, l = e.shortText), "onChange" in e && t(8, c = e.onChange), "onCancel" in e && t(9, u = e.onCancel), "onFind" in e && t(10, d = e.onFind), "onPaste" in e && t(11, v = e.onPaste), "onValueClass" in e && t(12, m = e.onValueClass);
  }, e.$$.update = function () {
    4224 & e.$$.dirty && t(2, r = m(a));
  }, [l, o, r, b, function (e) {
    e.stopPropagation();
    var n = sa(e);
    if ("Escape" === n && y(), "Enter" === n || "Tab" === n) {
      g = !0;
      var t = h();
      c(t, vr.nextInside);
    }
    "Ctrl+F" === n && (e.preventDefault(), d(!1)), "Ctrl+H" === n && (e.preventDefault(), d(!0));
  }, function (e) {
    if (e.stopPropagation(), v && e.clipboardData) {
      var n = e.clipboardData.getData("text/plain");
      v(n);
    }
  }, function () {
    var e = document.hasFocus(),
      n = h();
    i("handleBlur", {
      hasFocus: e,
      closed: g,
      value: a,
      newValue: n
    }), document.hasFocus() && !g && (g = !0, n !== a && c(n, vr.self));
  }, a, c, u, d, v, m, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(1, o = e);
    });
  }];
}
var Sl = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Cl, kl, ct, {
      value: 7,
      shortText: 0,
      onChange: 8,
      onCancel: 9,
      onFind: 10,
      onPaste: 11,
      onValueClass: 12
    }, $l), t;
  }
  return v(n, Wo), b(n);
}();
function Ml(e) {
  var n, t;
  return n = new Sl({
    props: {
      value: e[1].escapeValue(e[0]),
      onChange: e[3],
      onCancel: e[4],
      onPaste: e[5],
      onFind: e[2],
      onValueClass: e[6]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = s(t, 1)[0],
        r = {};
      3 & o && (r.value = e[1].escapeValue(e[0])), 4 & o && (r.onFind = e[2]), n.$set(r);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Ol(e, n, t) {
  var o = n.path,
    r = n.value,
    i = n.parser,
    a = n.normalization,
    s = n.enforceString,
    l = n.onPatch,
    c = n.onPasteJson,
    u = n.onSelect,
    d = n.onFind,
    f = n.focus,
    v = n.findNextInside;
  function p(e) {
    return s ? e : ti(e, i);
  }
  return e.$$set = function (e) {
    "path" in e && t(7, o = e.path), "value" in e && t(0, r = e.value), "parser" in e && t(8, i = e.parser), "normalization" in e && t(1, a = e.normalization), "enforceString" in e && t(9, s = e.enforceString), "onPatch" in e && t(10, l = e.onPatch), "onPasteJson" in e && t(11, c = e.onPasteJson), "onSelect" in e && t(12, u = e.onSelect), "onFind" in e && t(2, d = e.onFind), "focus" in e && t(13, f = e.focus), "findNextInside" in e && t(14, v = e.findNextInside);
  }, [r, a, d, function (e, n) {
    l([{
      op: "replace",
      path: O(o),
      value: p(a.unescapeValue(e))
    }], function (e, t) {
      if (!t.selection || ne(o, bl(t.selection))) {
        var r = n === vr.nextInside ? v(o) : al(o, !1);
        return {
          state: g(g({}, t), {}, {
            selection: r
          })
        };
      }
    }), f();
  }, function () {
    u(al(o, !1)), f();
  }, function (e) {
    try {
      var n = i.parse(e);
      Yr(n) && c({
        path: o,
        contents: n
      });
    } catch (e) {}
  }, function (e) {
    return wl(p(a.unescapeValue(e)), i);
  }, o, i, s, l, c, u, f, v];
}
var zl = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Ol, Ml, ct, {
      path: 7,
      value: 0,
      parser: 8,
      normalization: 1,
      enforceString: 9,
      onPatch: 10,
      onPasteJson: 11,
      onSelect: 12,
      onFind: 2,
      focus: 13,
      findNextInside: 14
    }), t;
  }
  return v(n, Wo), b(n);
}();
function Rl(e, n, t) {
  var o = X(n),
    r = z(e, o);
  if (N(r)) {
    var i = Hr(ee(n));
    return t.map(function (e, n) {
      return {
        op: "add",
        path: O(o.concat(String(i + n))),
        value: e.value
      };
    });
  }
  if (B(r)) {
    var a = ee(n),
      s = Object.keys(r),
      l = void 0 !== a ? Es(s, a, !0) : [];
    return [].concat(w(t.map(function (e) {
      var n = Ra(e.key, s);
      return {
        op: "add",
        path: O(o.concat(n)),
        value: e.value
      };
    })), w(l.map(function (e) {
      return Al(o, e);
    })));
  }
  throw new Error("Cannot create insert operations: parent must be an Object or Array");
}
function El(e, n, t) {
  var o = z(e, n);
  if (Array.isArray(o)) {
    var r = o.length;
    return t.map(function (e, t) {
      return {
        op: "add",
        path: O(n.concat(String(r + t))),
        value: e.value
      };
    });
  }
  return t.map(function (e) {
    var t = Ra(e.key, Object.keys(o));
    return {
      op: "add",
      path: O(n.concat(t)),
      value: e.value
    };
  });
}
function ql(e, n, t, o) {
  var r = Ra(o, n.filter(function (e) {
      return e !== t;
    })),
    i = Es(n, t, !1);
  return [{
    op: "move",
    from: O(e.concat(t)),
    path: O(e.concat(r))
  }].concat(w(i.map(function (n) {
    return Al(e, n);
  })));
}
function Pl(e, n) {
  var t = ee(n);
  if (G(t)) throw new Error("Cannot duplicate root object");
  var o = X(t),
    r = ee(t),
    i = z(e, o);
  if (N(i)) {
    var a = ee(n),
      s = a ? Hr(ee(a)) + 1 : 0;
    return w(n.map(function (e, n) {
      return {
        op: "copy",
        from: O(e),
        path: O(o.concat(String(n + s)))
      };
    }));
  }
  if (B(i)) {
    var l = Object.keys(i),
      c = void 0 !== r ? Es(l, r, !1) : [];
    return [].concat(w(n.map(function (e) {
      var n = Ra(ee(e), l);
      return {
        op: "copy",
        from: O(e),
        path: O(o.concat(n))
      };
    })), w(c.map(function (e) {
      return Al(o, e);
    })));
  }
  throw new Error("Cannot create duplicate operations: parent must be an Object or Array");
}
function Il(e, n, t, o) {
  if (Ls(n)) {
    var r = pi(t, o),
      i = X(n.path),
      a = z(e, i);
    return ql(i, Object.keys(a), ee(n.path), "string" == typeof r ? r : t);
  }
  if (Us(n) || Ds(n) && G(n.focusPath)) try {
    return [{
      op: "replace",
      path: O(bl(n)),
      value: mi(t, function (e) {
        return vi(e, o);
      })
    }];
  } catch (e) {
    return [{
      op: "replace",
      path: O(bl(n)),
      value: t
    }];
  }
  if (Ds(n)) {
    var s = Nl(t, o);
    return function (e, n, t) {
      var o = te(n),
        r = X(o),
        i = z(e, r);
      if (N(i)) {
        var a = te(n),
          s = a ? Hr(ee(a)) : 0;
        return [].concat(w(Tl(n)), w(t.map(function (e, n) {
          return {
            op: "add",
            path: O(r.concat(String(n + s))),
            value: e.value
          };
        })));
      }
      if (B(i)) {
        var l = ee(n),
          c = X(l),
          u = ee(l),
          d = Object.keys(i),
          f = void 0 !== u ? Es(d, u, !1) : [],
          v = new Set(n.map(function (e) {
            return ee(e);
          })),
          p = d.filter(function (e) {
            return !v.has(e);
          });
        return [].concat(w(Tl(n)), w(t.map(function (e) {
          var n = Ra(e.key, p);
          return {
            op: "add",
            path: O(c.concat(n)),
            value: e.value
          };
        })), w(f.map(function (e) {
          return Al(c, e);
        })));
      }
      throw new Error("Cannot create replace operations: parent must be an Object or Array");
    }(e, _s(e, n), s);
  }
  if (Bs(n)) {
    var l = Nl(t, o),
      c = n.path,
      u = X(c),
      d = z(e, u);
    if (N(d)) {
      var f = Hr(ee(c));
      return Rl(e, u.concat(String(f + 1)), l);
    }
    if (B(d)) {
      var v = String(ee(c)),
        p = Object.keys(d);
      if (G(p) || ee(p) === v) return El(e, u, l);
      var m = p.indexOf(v),
        g = p[m + 1];
      return Rl(e, u.concat(g), l);
    }
    throw new Error("Cannot create insert operations: parent must be an Object or Array");
  }
  if (Fs(n)) {
    var h = Nl(t, o),
      j = n.path,
      b = z(e, j);
    if (N(b)) return Rl(e, j.concat("0"), h);
    if (B(b)) {
      var y = Object.keys(b);
      if (G(y)) return El(e, j, h);
      var x = te(y);
      return Rl(e, j.concat(x), h);
    }
    throw new Error("Cannot create insert operations: parent must be an Object or Array");
  }
  throw new Error("Cannot insert: unsupported type of selection " + JSON.stringify(n));
}
function Tl(e) {
  return e.map(function (e) {
    return {
      op: "remove",
      path: O(e)
    };
  }).reverse();
}
function Al(e, n) {
  return {
    op: "move",
    from: O(e.concat(n)),
    path: O(e.concat(n))
  };
}
function Nl(e, n) {
  var t = /^\s*{/.test(e),
    o = /^\s*\[/.test(e),
    r = pi(e, n),
    i = void 0 !== r ? r : mi(e, function (e) {
      return vi(e, n);
    });
  return t && Qr(i) || o && Array.isArray(i) ? [{
    key: "New item",
    value: i
  }] : Array.isArray(i) ? i.map(function (e, n) {
    return {
      key: "New item " + n,
      value: e
    };
  }) : Qr(i) ? Object.keys(i).map(function (e) {
    return {
      key: e,
      value: i[e]
    };
  }) : [{
    key: "New item",
    value: i
  }];
}
function Bl(e, n) {
  if (Ls(n)) {
    var t = X(n.path),
      o = z(e, t),
      r = ql(t, Object.keys(o), ee(n.path), "");
    return {
      operations: r,
      newSelection: Xs(e, r)
    };
  }
  if (Us(n)) return {
    operations: [{
      op: "replace",
      path: O(n.path),
      value: ""
    }],
    newSelection: n
  };
  if (Ds(n)) {
    var i = _s(e, n),
      a = Tl(i),
      s = ee(i);
    if (G(s)) {
      return {
        operations: [{
          op: "replace",
          path: "",
          value: ""
        }],
        newSelection: al([], !1)
      };
    }
    var l = X(s),
      c = z(e, l);
    if (N(c)) {
      var u = te(i),
        d = Hr(ee(u));
      return {
        operations: a,
        newSelection: 0 === d ? sl(l) : ll(l.concat(String(d - 1)))
      };
    }
    if (B(c)) {
      var f = Object.keys(c),
        v = te(i),
        p = ee(v),
        m = f.indexOf(p),
        g = f[m - 1];
      return {
        operations: a,
        newSelection: 0 === m ? sl(l) : ll(l.concat(g))
      };
    }
    throw new Error("Cannot create remove operations: parent must be an Object or Array");
  }
  throw new Error("Cannot remove: unsupported type of selection " + JSON.stringify(n));
}
function Fl(e, n) {
  return U(e, n, {
    before: function (e, n, t) {
      if (q(n)) {
        var o = M(n.path);
        return {
          revertOperations: [].concat(w(t), w(Ll(e, o)))
        };
      }
      if (T(n)) {
        var r = M(n.from);
        return {
          revertOperations: [].concat(w(t), w(Ll(e, r)))
        };
      }
      return {
        document: e
      };
    }
  });
}
function Ll(e, n) {
  var t = X(n),
    o = ee(n),
    r = z(e, t);
  return B(r) ? Es(Object.keys(r), o, !1).map(function (e) {
    return Al(t, e);
  }) : [];
}
function Ul(e, n, t) {
  var o = null != t && t.activeItem ? Gl(t.activeItem) : void 0,
    r = n.findIndex(function (e) {
      return ne(o, Gl(e));
    }),
    i = -1 !== r ? r : void 0 !== (null == t ? void 0 : t.activeIndex) && (null == t ? void 0 : t.activeIndex) < n.length ? null == t ? void 0 : t.activeIndex : n.length > 0 ? 0 : -1,
    a = n.map(function (e, n) {
      return g(g({}, e), {}, {
        active: n === i
      });
    }),
    s = a[i];
  return {
    items: a,
    itemsMap: ae(a, function (e) {
      return O(e.path);
    }),
    activeItem: s,
    activeIndex: i
  };
}
function Dl(e) {
  var n = e.activeIndex < e.items.length - 1 ? e.activeIndex + 1 : e.items.length > 0 ? 0 : -1,
    t = e.items[n],
    o = e.items.map(function (e, t) {
      return g(g({}, e), {}, {
        active: t === n
      });
    });
  return g(g({}, e), {}, {
    items: o,
    itemsMap: ae(o, function (e) {
      return O(e.path);
    }),
    activeItem: t,
    activeIndex: n
  });
}
function Jl(e) {
  var n = e.activeIndex > 0 ? e.activeIndex - 1 : e.items.length - 1,
    t = e.items[n],
    o = e.items.map(function (e, t) {
      return g(g({}, e), {}, {
        active: t === n
      });
    });
  return g(g({}, e), {}, {
    items: o,
    itemsMap: ae(o, function (e) {
      return O(e.path);
    }),
    activeItem: t,
    activeIndex: n
  });
}
function Vl(e, n) {
  var t,
    o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    r = e.toLowerCase(),
    i = null !== (t = null == o ? void 0 : o.maxResults) && void 0 !== t ? t : 1 / 0,
    a = null == o ? void 0 : o.columns,
    s = [],
    l = [];
  function c(e) {
    s.length >= i || s.push(e);
  }
  function u(e, n) {
    if (N(n)) {
      var t = l.length;
      l.push("0");
      for (var o = 0; o < n.length; o++) if (l[t] = String(o), u(e, n[o]), s.length >= i) return;
      l.pop();
    } else if (B(n)) {
      var r = Object.keys(n),
        a = l.length;
      l.push("");
      for (var d = 0, f = r; d < f.length; d++) {
        var v = f[d];
        if (l[a] = v, Hl(v, e, l, dr.key, c), u(e, n[v]), s.length >= i) return;
      }
      l.pop();
    } else Hl(String(n), e, l, dr.value, c);
  }
  if ("" === e) return [];
  if (a) {
    if (!Array.isArray(n)) throw new Error("json must be an Array when option columns is defined");
    for (var d = 0; d < n.length; d++) {
      l[0] = String(d);
      for (var f = n[d], v = 0; v < a.length; v++) {
        var p = a[v];
        if (1 === p.length) l[1] = p[0];else for (var m = 0; m < p.length; m++) l[m + 1] = p[m];
        for (; l.length > p.length + 1;) l.pop();
        u(r, z(f, p));
      }
      if (s.length >= i) break;
    }
    return s;
  }
  return u(r, n), s;
}
function Hl(e, n, t, o, r) {
  var i = e.toLowerCase(),
    a = 0,
    s = -1,
    l = -1;
  do {
    -1 !== (l = i.indexOf(n, s)) && (s = l + n.length, r({
      path: t.slice(0),
      field: o,
      fieldIndex: a,
      start: l,
      end: s
    }), a++);
  } while (-1 !== l);
}
function _l(e, n, t, o) {
  return e.substring(0, t) + n + e.substring(o);
}
function Wl(e, n, t) {
  var o = e;
  return se(t, function (e) {
    o = _l(o, n, e.start, e.end);
  }), o;
}
function Ql(e, n, t, o, r) {
  var i = o.field,
    a = o.path,
    s = o.start,
    l = o.end;
  if (i === dr.key) {
    var c = X(a),
      u = z(e, c),
      d = ee(a),
      f = ql(c, Object.keys(u), d, _l(d, t, s, l));
    return {
      newSelection: Xs(e, f),
      operations: f
    };
  }
  if (i === dr.value) {
    var v = z(e, a);
    if (void 0 === v) throw new Error("Cannot replace: path not found ".concat(O(a)));
    var p = "string" == typeof v ? v : String(v),
      m = O(a),
      g = Rs(v, n.enforceStringMap, m, r),
      h = _l(p, t, s, l),
      j = [{
        op: "replace",
        path: O(a),
        value: g ? h : ti(h, r)
      }];
    return {
      newSelection: Xs(e, j),
      operations: j
    };
  }
  throw new Error("Cannot replace: unknown type of search result field ".concat(i));
}
function Yl(e, n, t, o, r) {
  for (var i = Vl(t, e, {
      maxResults: 1 / 0
    }), a = [], s = 0; s < i.length; s++) {
    var l = i[s - 1],
      c = i[s];
    0 !== s && c.field === l.field && ne(c.path, l.path) ? ee(a).items.push(c) : a.push({
      path: c.path,
      field: c.field,
      items: [c]
    });
  }
  a.sort(function (e, n) {
    return e.field !== n.field ? e.field === dr.key ? 1 : -1 : n.path.length - e.path.length;
  });
  var u = [],
    d = null;
  return a.forEach(function (t) {
    var i = t.field,
      a = t.path,
      s = t.items;
    if (i === dr.key) {
      var l = X(a),
        c = z(e, l),
        f = ee(a),
        v = ql(l, Object.keys(c), f, Wl(f, o, s));
      u = u.concat(v), d = Xs(e, v);
    } else {
      if (i !== dr.value) throw new Error("Cannot replace: unknown type of search result field ".concat(i));
      var p = z(e, a);
      if (void 0 === p) throw new Error("Cannot replace: path not found ".concat(O(a)));
      var m = "string" == typeof p ? p : String(p),
        g = O(a),
        h = Rs(p, n.enforceStringMap, g, r),
        j = Wl(m, o, s),
        b = [{
          op: "replace",
          path: O(a),
          value: h ? j : ti(j, r)
        }];
      u = u.concat(b), d = Xs(e, b);
    }
  }), {
    operations: u,
    newSelection: d
  };
}
function Gl(e) {
  return e.path.concat(e.field, String(e.fieldIndex));
}
function Kl(e, n) {
  var t,
    o = null == e || null === (t = e[n]) || void 0 === t ? void 0 : t.filter(function (e) {
      return e.field === dr.key;
    });
  if (o && 0 !== o.length) return o;
}
function Zl(e, n) {
  var t,
    o = null == e || null === (t = e[n]) || void 0 === t ? void 0 : t.filter(function (e) {
      return e.field === dr.value;
    });
  if (o && 0 !== o.length) return o;
}
function Xl(e) {
  St(e, "svelte-1n1l5ny", ".jse-highlight.svelte-1n1l5ny{background-color:var(--jse-search-match-color, #ffe665);outline:var(--jse-search-match-outline, 1px solid #ffd700)}.jse-highlight.jse-active.svelte-1n1l5ny{background-color:var(--jse-search-match-active-color, #ffd700);outline:var(--jse-search-match-active-outline, 1px solid #e1be00)}");
}
function ec(e, n, t) {
  var o = e.slice();
  return o[3] = n[t], o;
}
function nc(e) {
  var n,
    t,
    o = Hi(e[3].text) + "";
  return {
    c: function () {
      n = Pt("span"), t = Tt(o), Ut(n, "class", "jse-highlight svelte-1n1l5ny"), Yt(n, "jse-active", e[3].active);
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: function (e, r) {
      1 & r && o !== (o = Hi(e[3].text) + "") && Ht(t, o), 1 & r && Yt(n, "jse-active", e[3].active);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function tc(e) {
  var n,
    t = e[3].text + "";
  return {
    c: function () {
      n = Tt(t);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, o) {
      1 & o && t !== (t = e[3].text + "") && Ht(n, t);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function oc(e) {
  var n;
  function t(e, n) {
    return "normal" === e[3].type ? tc : nc;
  }
  var o = t(e),
    r = o(e);
  return {
    c: function () {
      r.c(), n = Nt();
    },
    m: function (e, t) {
      r.m(e, t), Rt(e, n, t);
    },
    p: function (e, i) {
      o === (o = t(e)) && r ? r.p(e, i) : (r.d(1), (r = o(e)) && (r.c(), r.m(n.parentNode, n)));
    },
    d: function (e) {
      e && Et(n), r.d(e);
    }
  };
}
function rc(e) {
  for (var n, t = Ao(e[0]), o = [], r = 0; r < t.length; r += 1) o[r] = oc(ec(e, t, r));
  return {
    c: function () {
      for (var e = 0; e < o.length; e += 1) o[e].c();
      n = Nt();
    },
    m: function (e, t) {
      for (var r = 0; r < o.length; r += 1) o[r] && o[r].m(e, t);
      Rt(e, n, t);
    },
    p: function (e, r) {
      var i = s(r, 1)[0];
      if (1 & i) {
        var a;
        for (t = Ao(e[0]), a = 0; a < t.length; a += 1) {
          var l = ec(e, t, a);
          o[a] ? o[a].p(l, i) : (o[a] = oc(l), o[a].c(), o[a].m(n.parentNode, n));
        }
        for (; a < o.length; a += 1) o[a].d(1);
        o.length = t.length;
      }
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n), qt(o, e);
    }
  };
}
function ic(e, n, t) {
  var r,
    i = n.text,
    a = n.searchResultItems;
  return e.$$set = function (e) {
    "text" in e && t(1, i = e.text), "searchResultItems" in e && t(2, a = e.searchResultItems);
  }, e.$$.update = function () {
    6 & e.$$.dirty && t(0, r = function (e, n) {
      var t,
        r = [],
        i = 0,
        a = o(n);
      try {
        for (a.s(); !(t = a.n()).done;) {
          var s = t.value,
            l = e.slice(i, s.start);
          "" !== l && r.push({
            type: "normal",
            text: l,
            active: !1
          });
          var c = e.slice(s.start, s.end);
          r.push({
            type: "highlight",
            text: c,
            active: s.active
          }), i = s.end;
        }
      } catch (e) {
        a.e(e);
      } finally {
        a.f();
      }
      var u = ee(n);
      return u && u.end < e.length && r.push({
        type: "normal",
        text: e.slice(u.end),
        active: !1
      }), r;
    }(String(i), a));
  }, [r, i, a];
}
var ac = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, ic, rc, lt, {
      text: 1,
      searchResultItems: 2
    }, Xl), t;
  }
  return v(n, Wo), b(n);
}();
function sc(e) {
  St(e, "svelte-1v88515", '.jse-value.jse-string.svelte-1v88515{color:var(--jse-value-color-string, #008000)}.jse-value.jse-object.svelte-1v88515,.jse-value.jse-array.svelte-1v88515{min-width:16px;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-value.jse-number.svelte-1v88515{color:var(--jse-value-color-number, #ee422e)}.jse-value.jse-boolean.svelte-1v88515{color:var(--jse-value-color-boolean, #ff8c00)}.jse-value.jse-null.svelte-1v88515{color:var(--jse-value-color-null, #004ed0)}.jse-value.jse-invalid.svelte-1v88515{color:var(--jse-text-color, #4d4d4d)}.jse-value.jse-url.svelte-1v88515{color:var(--jse-value-color-url, #008000);text-decoration:underline}.jse-value.svelte-1v88515{min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;cursor:var(--jse-contents-cursor, pointer);word-break:normal;overflow-wrap:anywhere;white-space:pre-wrap}.jse-value.svelte-1v88515:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-value.jse-empty.svelte-1v88515{min-width:4em;outline:1px dotted var(--jse-tag-background, rgba(0, 0, 0, 0.2));-moz-outline-radius:2px}.jse-value.jse-empty.svelte-1v88515::after{pointer-events:none;color:var(--jse-tag-background, rgba(0, 0, 0, 0.2));content:"value"}');
}
function lc(e) {
  var n,
    t = Hi(e[1].escapeValue(e[0])) + "";
  return {
    c: function () {
      n = Tt(t);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, o) {
      3 & o && t !== (t = Hi(e[1].escapeValue(e[0])) + "") && Ht(n, t);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function cc(e) {
  var n, t;
  return n = new ac({
    props: {
      text: e[1].escapeValue(e[0]),
      searchResultItems: e[3]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      3 & t && (o.text = e[1].escapeValue(e[0])), 8 & t && (o.searchResultItems = e[3]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function uc(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    l,
    c,
    u = [cc, lc],
    d = [];
  function f(e, n) {
    return e[3] ? 0 : 1;
  }
  return t = f(e), o = d[t] = u[t](e), {
    c: function () {
      n = Pt("div"), o.c(), Ut(n, "role", "button"), Ut(n, "tabindex", "-1"), Ut(n, "data-type", "selectable-value"), Ut(n, "class", r = ht(wl(e[0], e[2])) + " svelte-1v88515"), Ut(n, "title", i = e[4] ? "Ctrl+Click or Ctrl+Enter to open url in new window" : null);
    },
    m: function (o, r) {
      Rt(o, n, r), d[t].m(n, null), a = !0, l || (c = [Bt(n, "click", e[5]), Bt(n, "dblclick", e[6])], l = !0);
    },
    p: function (e, l) {
      var c = s(l, 1)[0],
        v = t;
      (t = f(e)) === v ? d[t].p(e, c) : (Ro(), Po(d[v], 1, 1, function () {
        d[v] = null;
      }), Eo(), (o = d[t]) ? o.p(e, c) : (o = d[t] = u[t](e)).c(), qo(o, 1), o.m(n, null)), (!a || 5 & c && r !== (r = ht(wl(e[0], e[2])) + " svelte-1v88515")) && Ut(n, "class", r), (!a || 16 & c && i !== (i = e[4] ? "Ctrl+Click or Ctrl+Enter to open url in new window" : null)) && Ut(n, "title", i);
    },
    i: function (e) {
      a || (qo(o), a = !0);
    },
    o: function (e) {
      Po(o), a = !1;
    },
    d: function (e) {
      e && Et(n), d[t].d(), l = !1, at(c);
    }
  };
}
function dc(e, n, t) {
  var o,
    r = n.path,
    i = n.value,
    a = n.readOnly,
    s = n.normalization,
    l = n.parser,
    c = n.onSelect,
    u = n.searchResultItems;
  return e.$$set = function (e) {
    "path" in e && t(7, r = e.path), "value" in e && t(0, i = e.value), "readOnly" in e && t(8, a = e.readOnly), "normalization" in e && t(1, s = e.normalization), "parser" in e && t(2, l = e.parser), "onSelect" in e && t(9, c = e.onSelect), "searchResultItems" in e && t(3, u = e.searchResultItems);
  }, e.$$.update = function () {
    1 & e.$$.dirty && t(4, o = ni(i));
  }, [i, s, l, u, o, function (e) {
    "string" == typeof i && o && la(e) && (e.preventDefault(), e.stopPropagation(), window.open(i, "_blank"));
  }, function (e) {
    a || (e.preventDefault(), c(al(r, !0)));
  }, r, a, c];
}
var fc = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, dc, uc, ct, {
      path: 7,
      value: 0,
      readOnly: 8,
      normalization: 1,
      parser: 2,
      onSelect: 9,
      searchResultItems: 3
    }, sc), t;
  }
  return v(n, Wo), b(n);
}();
function vc(e) {
  St(e, "svelte-1sftg37", '.jse-tooltip.svelte-1sftg37{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);border-radius:3px;background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));white-space:nowrap;box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}');
}
function pc(e) {
  var n, t;
  return {
    c: function () {
      n = Pt("div"), t = Tt(e[0]), Ut(n, "class", "jse-tooltip svelte-1sftg37");
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: function (e, n) {
      1 & s(n, 1)[0] && Ht(t, e[0]);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function mc(e, n, t) {
  var o = n.text;
  return e.$$set = function (e) {
    "text" in e && t(0, o = e.text);
  }, [o];
}
var gc = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, mc, pc, lt, {
      text: 0
    }, vc), t;
  }
  return v(n, Wo), b(n);
}();
function hc(e, n) {
  var t,
    o = n.text,
    r = n.openAbsolutePopup,
    i = n.closeAbsolutePopup;
  function a() {
    t = r(gc, {
      text: o
    }, {
      position: "top",
      width: 10 * o.length,
      offsetTop: 3,
      anchor: e,
      closeOnOuterClick: !0
    });
  }
  function s() {
    i(t);
  }
  return e.addEventListener("mouseenter", a), e.addEventListener("mouseleave", s), {
    destroy: function () {
      e.removeEventListener("mouseenter", a), e.removeEventListener("mouseleave", s);
    }
  };
}
function jc(e) {
  St(e, "svelte-1sqrs1u", ".jse-timestamp.svelte-1sqrs1u{padding:0;margin:0;vertical-align:middle;display:inline-flex;color:var(--jse-value-color-number, #ee422e)}");
}
function bc(e) {
  var n, t, o, r, i, a;
  return t = new Ya({
    props: {
      data: ge
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "class", "jse-timestamp svelte-1sqrs1u");
    },
    m: function (s, l) {
      Rt(s, n, l), Vo(t, n, null), r = !0, i || (a = jt(o = hc.call(null, n, g({
        text: e[0]
      }, e[1]))), i = !0);
    },
    p: function (e, n) {
      var t = s(n, 1)[0];
      o && st(o.update) && 1 & t && o.update.call(null, g({
        text: e[0]
      }, e[1]));
    },
    i: function (e) {
      r || (qo(t.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), i = !1, a();
    }
  };
}
function yc(e, n, t) {
  var o,
    r = co("absolute-popup"),
    i = n.value;
  return e.$$set = function (e) {
    "value" in e && t(2, i = e.value);
  }, e.$$.update = function () {
    4 & e.$$.dirty && t(0, o = "Time: ".concat(new Date(i).toString()));
  }, [o, r, i];
}
var xc = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, yc, bc, ct, {
      value: 2
    }, jc), t;
  }
  return v(n, Wo), b(n);
}();
function wc(e) {
  var n = e.path,
    t = e.value,
    o = e.readOnly,
    r = e.enforceString,
    i = e.searchResultItems,
    a = e.isEditing,
    s = e.parser,
    l = e.normalization,
    c = e.onPatch,
    u = e.onPasteJson,
    d = e.onSelect,
    f = e.onFind,
    v = e.findNextInside,
    p = e.focus,
    m = [];
  return !a && function (e) {
    return !0 === e || !1 === e;
  }(t) && m.push({
    component: Xa,
    props: {
      path: n,
      value: t,
      readOnly: o,
      onPatch: c,
      focus: p
    }
  }), !a && function (e) {
    return "string" == typeof e && e.length < 99 && !!Kr(e);
  }(t) && m.push({
    component: ss,
    props: {
      path: n,
      value: t,
      readOnly: o,
      onPatch: c,
      focus: p
    }
  }), a && m.push({
    component: zl,
    props: {
      path: n,
      value: t,
      enforceString: r,
      parser: s,
      normalization: l,
      onPatch: c,
      onPasteJson: u,
      onSelect: d,
      onFind: f,
      findNextInside: v,
      focus: p
    }
  }), a || m.push({
    component: fc,
    props: {
      path: n,
      value: t,
      readOnly: o,
      parser: s,
      normalization: l,
      searchResultItems: i,
      onSelect: d
    }
  }), !a && Gr(t) && m.push({
    component: xc,
    props: {
      value: t
    }
  }), m;
}
var $c = {},
  kc = {
    showWizard: !0,
    showOriginal: !0
  },
  Cc = Math.min,
  Sc = Math.max,
  Mc = Math.round,
  Oc = Math.floor,
  zc = function (e) {
    return {
      x: e,
      y: e
    };
  },
  Rc = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  },
  Ec = {
    start: "end",
    end: "start"
  };
function qc(e, n, t) {
  return Sc(e, Cc(n, t));
}
function Pc(e, n) {
  return "function" == typeof e ? e(n) : e;
}
function Ic(e) {
  return e.split("-")[0];
}
function Tc(e) {
  return e.split("-")[1];
}
function Ac(e) {
  return "x" === e ? "y" : "x";
}
function Nc(e) {
  return "y" === e ? "height" : "width";
}
function Bc(e) {
  return ["top", "bottom"].includes(Ic(e)) ? "y" : "x";
}
function Fc(e) {
  return Ac(Bc(e));
}
function Lc(e, n, t) {
  void 0 === t && (t = !1);
  var o = Tc(e),
    r = Fc(e),
    i = Nc(r),
    a = "x" === r ? o === (t ? "end" : "start") ? "right" : "left" : "start" === o ? "bottom" : "top";
  return n.reference[i] > n.floating[i] && (a = Vc(a)), [a, Vc(a)];
}
function Uc(e) {
  var n = Vc(e);
  return [Dc(e), n, Dc(n)];
}
function Dc(e) {
  return e.replace(/start|end/g, function (e) {
    return Ec[e];
  });
}
function Jc(e, n, t, o) {
  var r = Tc(e),
    i = function (e, n, t) {
      var o = ["left", "right"],
        r = ["right", "left"];
      switch (e) {
        case "top":
        case "bottom":
          return t ? n ? r : o : n ? o : r;
        case "left":
        case "right":
          return n ? ["top", "bottom"] : ["bottom", "top"];
        default:
          return [];
      }
    }(Ic(e), "start" === t, o);
  return r && (i = i.map(function (e) {
    return e + "-" + r;
  }), n && (i = i.concat(i.map(Dc)))), i;
}
function Vc(e) {
  return e.replace(/left|right|bottom|top/g, function (e) {
    return Rc[e];
  });
}
function Hc(e) {
  return "number" != typeof e ? function (e) {
    return g({
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, e);
  }(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function _c(e) {
  var n = e.x,
    t = e.y,
    o = e.width,
    r = e.height;
  return {
    width: o,
    height: r,
    top: t,
    left: n,
    right: n + o,
    bottom: t + r,
    x: n,
    y: t
  };
}
function Wc(e, n, t) {
  var o,
    r = e.reference,
    i = e.floating,
    a = Bc(n),
    s = Fc(n),
    l = Nc(s),
    c = Ic(n),
    u = "y" === a,
    d = r.x + r.width / 2 - i.width / 2,
    f = r.y + r.height / 2 - i.height / 2,
    v = r[l] / 2 - i[l] / 2;
  switch (c) {
    case "top":
      o = {
        x: d,
        y: r.y - i.height
      };
      break;
    case "bottom":
      o = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      o = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      o = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      o = {
        x: r.x,
        y: r.y
      };
  }
  switch (Tc(n)) {
    case "start":
      o[s] -= v * (t && u ? -1 : 1);
      break;
    case "end":
      o[s] += v * (t && u ? -1 : 1);
  }
  return o;
}
var Qc = function () {
  var e = a(r().mark(function e(n, t, o) {
    var i, a, s, l, c, u, d, f, v, p, m, h, j, b, x, w, $, k, C, M, O, z, R, E, q, P;
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return i = o.placement, a = void 0 === i ? "bottom" : i, s = o.strategy, l = void 0 === s ? "absolute" : s, c = o.middleware, u = void 0 === c ? [] : c, d = o.platform, f = u.filter(Boolean), e.next = 4, null == d.isRTL ? void 0 : d.isRTL(t);
        case 4:
          return v = e.sent, e.next = 7, d.getElementRects({
            reference: n,
            floating: t,
            strategy: l
          });
        case 7:
          p = e.sent, m = Wc(p, a, v), h = m.x, j = m.y, b = a, x = {}, w = 0, $ = 0;
        case 13:
          if (!($ < f.length)) {
            e.next = 45;
            break;
          }
          return k = f[$], C = k.name, M = k.fn, e.next = 17, M({
            x: h,
            y: j,
            initialPlacement: a,
            placement: b,
            strategy: l,
            middlewareData: x,
            rects: p,
            platform: d,
            elements: {
              reference: n,
              floating: t
            }
          });
        case 17:
          if (O = e.sent, z = O.x, R = O.y, E = O.data, q = O.reset, h = null != z ? z : h, j = null != R ? R : j, x = g(g({}, x), {}, y({}, C, g(g({}, x[C]), E))), !(q && w <= 50)) {
            e.next = 42;
            break;
          }
          if (w++, "object" !== S(q)) {
            e.next = 41;
            break;
          }
          if (q.placement && (b = q.placement), !q.rects) {
            e.next = 38;
            break;
          }
          if (!0 !== q.rects) {
            e.next = 36;
            break;
          }
          return e.next = 33, d.getElementRects({
            reference: n,
            floating: t,
            strategy: l
          });
        case 33:
          e.t0 = e.sent, e.next = 37;
          break;
        case 36:
          e.t0 = q.rects;
        case 37:
          p = e.t0;
        case 38:
          P = Wc(p, b, v), h = P.x, j = P.y;
        case 41:
          $ = -1;
        case 42:
          $++, e.next = 13;
          break;
        case 45:
          return e.abrupt("return", {
            x: h,
            y: j,
            placement: b,
            strategy: l,
            middlewareData: x
          });
        case 46:
        case "end":
          return e.stop();
      }
    }, e);
  }));
  return function (n, t, o) {
    return e.apply(this, arguments);
  };
}();
function Yc(e, n) {
  return Gc.apply(this, arguments);
}
function Gc() {
  return Gc = a(r().mark(function e(n, t) {
    var o, i, a, s, l, c, u, d, f, v, p, m, g, h, j, b, y, x, w, $, k, C, S, M, O;
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return void 0 === t && (t = {}), i = n.x, a = n.y, s = n.platform, l = n.rects, c = n.elements, u = n.strategy, d = Pc(t, n), f = d.boundary, v = void 0 === f ? "clippingAncestors" : f, p = d.rootBoundary, m = void 0 === p ? "viewport" : p, g = d.elementContext, h = void 0 === g ? "floating" : g, j = d.altBoundary, b = void 0 !== j && j, y = d.padding, x = Hc(void 0 === y ? 0 : y), w = "floating" === h ? "reference" : "floating", $ = c[b ? w : h], e.t0 = _c, e.t1 = s, e.next = 10, null == s.isElement ? void 0 : s.isElement($);
        case 10:
          if (e.t2 = o = e.sent, null == e.t2) {
            e.next = 15;
            break;
          }
          e.t3 = o, e.next = 16;
          break;
        case 15:
          e.t3 = !0;
        case 16:
          if (!e.t3) {
            e.next = 20;
            break;
          }
          e.t4 = $, e.next = 26;
          break;
        case 20:
          if (e.t5 = $.contextElement, e.t5) {
            e.next = 25;
            break;
          }
          return e.next = 24, null == s.getDocumentElement ? void 0 : s.getDocumentElement(c.floating);
        case 24:
          e.t5 = e.sent;
        case 25:
          e.t4 = e.t5;
        case 26:
          return e.t6 = e.t4, e.t7 = v, e.t8 = m, e.t9 = u, e.t10 = {
            element: e.t6,
            boundary: e.t7,
            rootBoundary: e.t8,
            strategy: e.t9
          }, e.next = 33, e.t1.getClippingRect.call(e.t1, e.t10);
        case 33:
          return e.t11 = e.sent, k = (0, e.t0)(e.t11), C = "floating" === h ? {
            x: i,
            y: a,
            width: l.floating.width,
            height: l.floating.height
          } : l.reference, e.next = 38, null == s.getOffsetParent ? void 0 : s.getOffsetParent(c.floating);
        case 38:
          return S = e.sent, e.next = 41, null == s.isElement ? void 0 : s.isElement(S);
        case 41:
          if (!e.sent) {
            e.next = 50;
            break;
          }
          return e.next = 44, null == s.getScale ? void 0 : s.getScale(S);
        case 44:
          if (e.t13 = e.sent, e.t13) {
            e.next = 47;
            break;
          }
          e.t13 = {
            x: 1,
            y: 1
          };
        case 47:
          e.t12 = e.t13, e.next = 51;
          break;
        case 50:
          e.t12 = {
            x: 1,
            y: 1
          };
        case 51:
          if (M = e.t12, e.t14 = _c, !s.convertOffsetParentRelativeRectToViewportRelativeRect) {
            e.next = 59;
            break;
          }
          return e.next = 56, s.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: c,
            rect: C,
            offsetParent: S,
            strategy: u
          });
        case 56:
          e.t15 = e.sent, e.next = 60;
          break;
        case 59:
          e.t15 = C;
        case 60:
          return e.t16 = e.t15, O = (0, e.t14)(e.t16), e.abrupt("return", {
            top: (k.top - O.top + x.top) / M.y,
            bottom: (O.bottom - k.bottom + x.bottom) / M.y,
            left: (k.left - O.left + x.left) / M.x,
            right: (O.right - k.right + x.right) / M.x
          });
        case 63:
        case "end":
          return e.stop();
      }
    }, e);
  })), Gc.apply(this, arguments);
}
function Kc(e, n) {
  return Zc.apply(this, arguments);
}
function Zc() {
  return Zc = a(r().mark(function e(n, t) {
    var o, i, a, s, l, c, u, d, f, v, p, m, h, j;
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return o = n.placement, i = n.platform, a = n.elements, e.next = 3, null == i.isRTL ? void 0 : i.isRTL(a.floating);
        case 3:
          return s = e.sent, l = Ic(o), c = Tc(o), u = "y" === Bc(o), d = ["left", "top"].includes(l) ? -1 : 1, f = s && u ? -1 : 1, v = Pc(t, n), p = "number" == typeof v ? {
            mainAxis: v,
            crossAxis: 0,
            alignmentAxis: null
          } : g({
            mainAxis: 0,
            crossAxis: 0,
            alignmentAxis: null
          }, v), m = p.mainAxis, h = p.crossAxis, j = p.alignmentAxis, c && "number" == typeof j && (h = "end" === c ? -1 * j : j), e.abrupt("return", u ? {
            x: h * f,
            y: m * d
          } : {
            x: m * d,
            y: h * f
          });
        case 13:
        case "end":
          return e.stop();
      }
    }, e);
  })), Zc.apply(this, arguments);
}
function Xc(e) {
  return tu(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function eu(e) {
  var n;
  return (null == e || null == (n = e.ownerDocument) ? void 0 : n.defaultView) || window;
}
function nu(e) {
  var n;
  return null == (n = (tu(e) ? e.ownerDocument : e.document) || window.document) ? void 0 : n.documentElement;
}
function tu(e) {
  return e instanceof Node || e instanceof eu(e).Node;
}
function ou(e) {
  return e instanceof Element || e instanceof eu(e).Element;
}
function ru(e) {
  return e instanceof HTMLElement || e instanceof eu(e).HTMLElement;
}
function iu(e) {
  return "undefined" != typeof ShadowRoot && (e instanceof ShadowRoot || e instanceof eu(e).ShadowRoot);
}
function au(e) {
  var n = du(e),
    t = n.overflow,
    o = n.overflowX,
    r = n.overflowY,
    i = n.display;
  return /auto|scroll|overlay|hidden|clip/.test(t + r + o) && !["inline", "contents"].includes(i);
}
function su(e) {
  return ["table", "td", "th"].includes(Xc(e));
}
function lu(e) {
  var n = cu(),
    t = du(e);
  return "none" !== t.transform || "none" !== t.perspective || !!t.containerType && "normal" !== t.containerType || !n && !!t.backdropFilter && "none" !== t.backdropFilter || !n && !!t.filter && "none" !== t.filter || ["transform", "perspective", "filter"].some(function (e) {
    return (t.willChange || "").includes(e);
  }) || ["paint", "layout", "strict", "content"].some(function (e) {
    return (t.contain || "").includes(e);
  });
}
function cu() {
  return !("undefined" == typeof CSS || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
}
function uu(e) {
  return ["html", "body", "#document"].includes(Xc(e));
}
function du(e) {
  return eu(e).getComputedStyle(e);
}
function fu(e) {
  return ou(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function vu(e) {
  if ("html" === Xc(e)) return e;
  var n = e.assignedSlot || e.parentNode || iu(e) && e.host || nu(e);
  return iu(n) ? n.host : n;
}
function pu(e) {
  var n = vu(e);
  return uu(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : ru(n) && au(n) ? n : pu(n);
}
function mu(e, n, t) {
  var o;
  void 0 === n && (n = []), void 0 === t && (t = !0);
  var r = pu(e),
    i = r === (null == (o = e.ownerDocument) ? void 0 : o.body),
    a = eu(r);
  return i ? n.concat(a, a.visualViewport || [], au(r) ? r : [], a.frameElement && t ? mu(a.frameElement) : []) : n.concat(r, mu(r, [], t));
}
function gu(e) {
  var n = du(e),
    t = parseFloat(n.width) || 0,
    o = parseFloat(n.height) || 0,
    r = ru(e),
    i = r ? e.offsetWidth : t,
    a = r ? e.offsetHeight : o,
    s = Mc(t) !== i || Mc(o) !== a;
  return s && (t = i, o = a), {
    width: t,
    height: o,
    $: s
  };
}
function hu(e) {
  return ou(e) ? e : e.contextElement;
}
function ju(e) {
  var n = hu(e);
  if (!ru(n)) return zc(1);
  var t = n.getBoundingClientRect(),
    o = gu(n),
    r = o.width,
    i = o.height,
    a = o.$,
    s = (a ? Mc(t.width) : t.width) / r,
    l = (a ? Mc(t.height) : t.height) / i;
  return s && Number.isFinite(s) || (s = 1), l && Number.isFinite(l) || (l = 1), {
    x: s,
    y: l
  };
}
var bu = zc(0);
function yu(e) {
  var n = eu(e);
  return cu() && n.visualViewport ? {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  } : bu;
}
function xu(e, n, t, o) {
  void 0 === n && (n = !1), void 0 === t && (t = !1);
  var r = e.getBoundingClientRect(),
    i = hu(e),
    a = zc(1);
  n && (o ? ou(o) && (a = ju(o)) : a = ju(e));
  var s = function (e, n, t) {
      return void 0 === n && (n = !1), !(!t || n && t !== eu(e)) && n;
    }(i, t, o) ? yu(i) : zc(0),
    l = (r.left + s.x) / a.x,
    c = (r.top + s.y) / a.y,
    u = r.width / a.x,
    d = r.height / a.y;
  if (i) for (var f = eu(i), v = o && ou(o) ? eu(o) : o, p = f, m = p.frameElement; m && o && v !== p;) {
    var g = ju(m),
      h = m.getBoundingClientRect(),
      j = du(m),
      b = h.left + (m.clientLeft + parseFloat(j.paddingLeft)) * g.x,
      y = h.top + (m.clientTop + parseFloat(j.paddingTop)) * g.y;
    l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += b, c += y, m = (p = eu(m)).frameElement;
  }
  return _c({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
var wu = [":popover-open", ":modal"];
function $u(e) {
  return wu.some(function (n) {
    try {
      return e.matches(n);
    } catch (e) {
      return !1;
    }
  });
}
function ku(e) {
  return xu(nu(e)).left + fu(e).scrollLeft;
}
function Cu(e, n, t) {
  var o;
  if ("viewport" === n) o = function (e, n) {
    var t = eu(e),
      o = nu(e),
      r = t.visualViewport,
      i = o.clientWidth,
      a = o.clientHeight,
      s = 0,
      l = 0;
    if (r) {
      i = r.width, a = r.height;
      var c = cu();
      (!c || c && "fixed" === n) && (s = r.offsetLeft, l = r.offsetTop);
    }
    return {
      width: i,
      height: a,
      x: s,
      y: l
    };
  }(e, t);else if ("document" === n) o = function (e) {
    var n = nu(e),
      t = fu(e),
      o = e.ownerDocument.body,
      r = Sc(n.scrollWidth, n.clientWidth, o.scrollWidth, o.clientWidth),
      i = Sc(n.scrollHeight, n.clientHeight, o.scrollHeight, o.clientHeight),
      a = -t.scrollLeft + ku(e),
      s = -t.scrollTop;
    return "rtl" === du(o).direction && (a += Sc(n.clientWidth, o.clientWidth) - r), {
      width: r,
      height: i,
      x: a,
      y: s
    };
  }(nu(e));else if (ou(n)) o = function (e, n) {
    var t = xu(e, !0, "fixed" === n),
      o = t.top + e.clientTop,
      r = t.left + e.clientLeft,
      i = ru(e) ? ju(e) : zc(1);
    return {
      width: e.clientWidth * i.x,
      height: e.clientHeight * i.y,
      x: r * i.x,
      y: o * i.y
    };
  }(n, t);else {
    var r = yu(e);
    o = g(g({}, n), {}, {
      x: n.x - r.x,
      y: n.y - r.y
    });
  }
  return _c(o);
}
function Su(e, n) {
  var t = vu(e);
  return !(t === n || !ou(t) || uu(t)) && ("fixed" === du(t).position || Su(t, n));
}
function Mu(e, n, t) {
  var o = ru(n),
    r = nu(n),
    i = "fixed" === t,
    a = xu(e, !0, i, n),
    s = {
      scrollLeft: 0,
      scrollTop: 0
    },
    l = zc(0);
  if (o || !o && !i) if (("body" !== Xc(n) || au(r)) && (s = fu(n)), o) {
    var c = xu(n, !0, i, n);
    l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  } else r && (l.x = ku(r));
  return {
    x: a.left + s.scrollLeft - l.x,
    y: a.top + s.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function Ou(e) {
  return "static" === du(e).position;
}
function zu(e, n) {
  return ru(e) && "fixed" !== du(e).position ? n ? n(e) : e.offsetParent : null;
}
function Ru(e, n) {
  var t = eu(e);
  if ($u(e)) return t;
  if (!ru(e)) {
    for (var o = vu(e); o && !uu(o);) {
      if (ou(o) && !Ou(o)) return o;
      o = vu(o);
    }
    return t;
  }
  for (var r = zu(e, n); r && su(r) && Ou(r);) r = zu(r, n);
  return r && uu(r) && Ou(r) && !lu(r) ? t : r || function (e) {
    for (var n = vu(e); ru(n) && !uu(n);) {
      if (lu(n)) return n;
      n = vu(n);
    }
    return null;
  }(e) || t;
}
var Eu = {
  convertOffsetParentRelativeRectToViewportRelativeRect: function (e) {
    var n = e.elements,
      t = e.rect,
      o = e.offsetParent,
      r = "fixed" === e.strategy,
      i = nu(o),
      a = !!n && $u(n.floating);
    if (o === i || a && r) return t;
    var s = {
        scrollLeft: 0,
        scrollTop: 0
      },
      l = zc(1),
      c = zc(0),
      u = ru(o);
    if ((u || !u && !r) && (("body" !== Xc(o) || au(i)) && (s = fu(o)), ru(o))) {
      var d = xu(o);
      l = ju(o), c.x = d.x + o.clientLeft, c.y = d.y + o.clientTop;
    }
    return {
      width: t.width * l.x,
      height: t.height * l.y,
      x: t.x * l.x - s.scrollLeft * l.x + c.x,
      y: t.y * l.y - s.scrollTop * l.y + c.y
    };
  },
  getDocumentElement: nu,
  getClippingRect: function (e) {
    var n = e.element,
      t = e.boundary,
      o = e.rootBoundary,
      r = e.strategy,
      i = "clippingAncestors" === t ? $u(n) ? [] : function (e, n) {
        var t = n.get(e);
        if (t) return t;
        for (var o = mu(e, [], !1).filter(function (e) {
            return ou(e) && "body" !== Xc(e);
          }), r = null, i = "fixed" === du(e).position, a = i ? vu(e) : e; ou(a) && !uu(a);) {
          var s = du(a),
            l = lu(a);
          l || "fixed" !== s.position || (r = null), (i ? !l && !r : !l && "static" === s.position && r && ["absolute", "fixed"].includes(r.position) || au(a) && !l && Su(e, a)) ? o = o.filter(function (e) {
            return e !== a;
          }) : r = s, a = vu(a);
        }
        return n.set(e, o), o;
      }(n, this._c) : [].concat(t),
      a = [].concat(w(i), [o]),
      s = a[0],
      l = a.reduce(function (e, t) {
        var o = Cu(n, t, r);
        return e.top = Sc(o.top, e.top), e.right = Cc(o.right, e.right), e.bottom = Cc(o.bottom, e.bottom), e.left = Sc(o.left, e.left), e;
      }, Cu(n, s, r));
    return {
      width: l.right - l.left,
      height: l.bottom - l.top,
      x: l.left,
      y: l.top
    };
  },
  getOffsetParent: Ru,
  getElementRects: function () {
    var e = a(r().mark(function e(n) {
      var t, o, i;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return t = this.getOffsetParent || Ru, o = this.getDimensions, e.next = 4, o(n.floating);
          case 4:
            return i = e.sent, e.t0 = Mu, e.t1 = n.reference, e.next = 9, t(n.floating);
          case 9:
            return e.t2 = e.sent, e.t3 = n.strategy, e.t4 = (0, e.t0)(e.t1, e.t2, e.t3), e.t5 = {
              x: 0,
              y: 0,
              width: i.width,
              height: i.height
            }, e.abrupt("return", {
              reference: e.t4,
              floating: e.t5
            });
          case 14:
          case "end":
            return e.stop();
        }
      }, e, this);
    }));
    return function (n) {
      return e.apply(this, arguments);
    };
  }(),
  getClientRects: function (e) {
    return Array.from(e.getClientRects());
  },
  getDimensions: function (e) {
    var n = gu(e);
    return {
      width: n.width,
      height: n.height
    };
  },
  getScale: ju,
  isElement: ou,
  isRTL: function (e) {
    return "rtl" === du(e).direction;
  }
};
function qu(e, n, t, o) {
  void 0 === o && (o = {});
  var r = o,
    i = r.ancestorScroll,
    a = void 0 === i || i,
    l = r.ancestorResize,
    c = void 0 === l || l,
    u = r.elementResize,
    d = void 0 === u ? "function" == typeof ResizeObserver : u,
    f = r.layoutShift,
    v = void 0 === f ? "function" == typeof IntersectionObserver : f,
    p = r.animationFrame,
    m = void 0 !== p && p,
    h = hu(e),
    j = a || c ? [].concat(w(h ? mu(h) : []), w(mu(n))) : [];
  j.forEach(function (e) {
    a && e.addEventListener("scroll", t, {
      passive: !0
    }), c && e.addEventListener("resize", t);
  });
  var b,
    y = h && v ? function (e, n) {
      var t,
        o = null,
        r = nu(e);
      function i() {
        var e;
        clearTimeout(t), null == (e = o) || e.disconnect(), o = null;
      }
      return function a(s, l) {
        void 0 === s && (s = !1), void 0 === l && (l = 1), i();
        var c = e.getBoundingClientRect(),
          u = c.left,
          d = c.top,
          f = c.width,
          v = c.height;
        if (s || n(), f && v) {
          var p = {
              rootMargin: -Oc(d) + "px " + -Oc(r.clientWidth - (u + f)) + "px " + -Oc(r.clientHeight - (d + v)) + "px " + -Oc(u) + "px",
              threshold: Sc(0, Cc(1, l)) || 1
            },
            m = !0;
          try {
            o = new IntersectionObserver(h, g(g({}, p), {}, {
              root: r.ownerDocument
            }));
          } catch (e) {
            o = new IntersectionObserver(h, p);
          }
          o.observe(e);
        }
        function h(e) {
          var n = e[0].intersectionRatio;
          if (n !== l) {
            if (!m) return a();
            n ? a(!1, n) : t = setTimeout(function () {
              a(!1, 1e-7);
            }, 1e3);
          }
          m = !1;
        }
      }(!0), i;
    }(h, t) : null,
    x = -1,
    $ = null;
  d && ($ = new ResizeObserver(function (e) {
    var o = s(e, 1)[0];
    o && o.target === h && $ && ($.unobserve(n), cancelAnimationFrame(x), x = requestAnimationFrame(function () {
      var e;
      null == (e = $) || e.observe(n);
    })), t();
  }), h && !m && $.observe(h), $.observe(n));
  var k = m ? xu(e) : null;
  return m && function n() {
    var o = xu(e);
    !k || o.x === k.x && o.y === k.y && o.width === k.width && o.height === k.height || t();
    k = o, b = requestAnimationFrame(n);
  }(), t(), function () {
    var e;
    j.forEach(function (e) {
      a && e.removeEventListener("scroll", t), c && e.removeEventListener("resize", t);
    }), null == y || y(), null == (e = $) || e.disconnect(), $ = null, m && cancelAnimationFrame(b);
  };
}
var Pu = function (e) {
    return void 0 === e && (e = 0), {
      name: "offset",
      options: e,
      fn: function (n) {
        return a(r().mark(function t() {
          var o, i, a, s, l, c, u;
          return r().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return a = n.x, s = n.y, l = n.placement, c = n.middlewareData, t.next = 3, Kc(n, e);
              case 3:
                if (u = t.sent, l !== (null == (o = c.offset) ? void 0 : o.placement) || null == (i = c.arrow) || !i.alignmentOffset) {
                  t.next = 6;
                  break;
                }
                return t.abrupt("return", {});
              case 6:
                return t.abrupt("return", {
                  x: a + u.x,
                  y: s + u.y,
                  data: g(g({}, u), {}, {
                    placement: l
                  })
                });
              case 7:
              case "end":
                return t.stop();
            }
          }, t);
        }))();
      }
    };
  },
  Iu = function (e) {
    return void 0 === e && (e = {}), {
      name: "shift",
      options: e,
      fn: function (o) {
        return a(r().mark(function i() {
          var a, s, l, c, u, d, f, v, p, m, h, j, b, x, w, $, k, C, S, M, O, z, R, E;
          return r().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return a = o.x, s = o.y, l = o.placement, c = Pc(e, o), u = c.mainAxis, d = void 0 === u || u, f = c.crossAxis, v = void 0 !== f && f, p = c.limiter, m = void 0 === p ? {
                  fn: function (e) {
                    return {
                      x: e.x,
                      y: e.y
                    };
                  }
                } : p, h = t(c, n), j = {
                  x: a,
                  y: s
                }, r.next = 5, Yc(o, h);
              case 5:
                return b = r.sent, x = Bc(Ic(l)), w = Ac(x), $ = j[w], k = j[x], d && (C = "y" === w ? "bottom" : "right", S = $ + b["y" === w ? "top" : "left"], M = $ - b[C], $ = qc(S, $, M)), v && (O = "y" === x ? "bottom" : "right", z = k + b["y" === x ? "top" : "left"], R = k - b[O], k = qc(z, k, R)), E = m.fn(g(g({}, o), {}, y(y({}, w, $), x, k))), r.abrupt("return", g(g({}, E), {}, {
                  data: {
                    x: E.x - a,
                    y: E.y - s
                  }
                }));
              case 14:
              case "end":
                return r.stop();
            }
          }, i);
        }))();
      }
    };
  },
  Tu = function (n) {
    return void 0 === n && (n = {}), {
      name: "flip",
      options: n,
      fn: function (o) {
        return a(r().mark(function i() {
          var a, s, l, c, u, d, f, v, p, m, g, h, j, b, y, x, $, k, C, S, M, O, z, R, E, q, P, I, T, A, N, B, F, L, U, D, J;
          return r().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                if (l = o.placement, c = o.middlewareData, u = o.rects, d = o.initialPlacement, f = o.platform, v = o.elements, p = Pc(n, o), m = p.mainAxis, g = void 0 === m || m, h = p.crossAxis, j = void 0 === h || h, b = p.fallbackPlacements, y = p.fallbackStrategy, x = void 0 === y ? "bestFit" : y, $ = p.fallbackAxisSideDirection, k = void 0 === $ ? "none" : $, C = p.flipAlignment, S = void 0 === C || C, M = t(p, e), null == (a = c.arrow) || !a.alignmentOffset) {
                  r.next = 4;
                  break;
                }
                return r.abrupt("return", {});
              case 4:
                return O = Ic(l), z = Ic(d) === d, r.next = 8, null == f.isRTL ? void 0 : f.isRTL(v.floating);
              case 8:
                return R = r.sent, E = b || (z || !S ? [Vc(d)] : Uc(d)), b || "none" === k || E.push.apply(E, w(Jc(d, S, k, R))), q = [d].concat(w(E)), r.next = 14, Yc(o, M);
              case 14:
                if (P = r.sent, I = [], T = (null == (s = c.flip) ? void 0 : s.overflows) || [], g && I.push(P[O]), j && (A = Lc(l, u, R), I.push(P[A[0]], P[A[1]])), T = [].concat(w(T), [{
                  placement: l,
                  overflows: I
                }]), I.every(function (e) {
                  return e <= 0;
                })) {
                  r.next = 37;
                  break;
                }
                if (F = ((null == (N = c.flip) ? void 0 : N.index) || 0) + 1, !(L = q[F])) {
                  r.next = 25;
                  break;
                }
                return r.abrupt("return", {
                  data: {
                    index: F,
                    overflows: T
                  },
                  reset: {
                    placement: L
                  }
                });
              case 25:
                if (U = null == (B = T.filter(function (e) {
                  return e.overflows[0] <= 0;
                }).sort(function (e, n) {
                  return e.overflows[1] - n.overflows[1];
                })[0]) ? void 0 : B.placement) {
                  r.next = 35;
                  break;
                }
                r.t0 = x, r.next = "bestFit" === r.t0 ? 30 : "initialPlacement" === r.t0 ? 33 : 35;
                break;
              case 30:
                return J = null == (D = T.map(function (e) {
                  return [e.placement, e.overflows.filter(function (e) {
                    return e > 0;
                  }).reduce(function (e, n) {
                    return e + n;
                  }, 0)];
                }).sort(function (e, n) {
                  return e[1] - n[1];
                })[0]) ? void 0 : D[0], J && (U = J), r.abrupt("break", 35);
              case 33:
                return U = d, r.abrupt("break", 35);
              case 35:
                if (l === U) {
                  r.next = 37;
                  break;
                }
                return r.abrupt("return", {
                  reset: {
                    placement: U
                  }
                });
              case 37:
                return r.abrupt("return", {});
              case 38:
              case "end":
                return r.stop();
            }
          }, i);
        }))();
      }
    };
  },
  Au = function (e, n, t) {
    var o = new Map(),
      r = g({
        platform: Eu
      }, t),
      i = g(g({}, r.platform), {}, {
        _c: o
      });
    return Qc(e, n, g(g({}, r), {}, {
      platform: i
    }));
  };
function Nu(e) {
  var n = e.loadOptions,
    t = e.filterText,
    o = e.items,
    r = e.multiple,
    i = e.value,
    a = e.itemId,
    s = e.groupBy,
    l = e.filterSelectedItems,
    c = e.itemFilter,
    u = e.convertStringItemsToObjects,
    d = e.filterGroupedItems,
    f = e.label;
  if (o && n) return o;
  if (!o) return [];
  o && o.length > 0 && "object" !== S(o[0]) && (o = u(o));
  var v = o.filter(function (e) {
    var n = c(e[f], t, e);
    return n && r && null != i && i.length && (n = !i.some(function (n) {
      return !!l && n[a] === e[a];
    })), n;
  });
  return s && (v = d(v)), v;
}
function Bu(e) {
  return Fu.apply(this, arguments);
}
function Fu() {
  return Fu = a(r().mark(function e(n) {
    var t, o, i, a, s;
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return t = n.dispatch, o = n.loadOptions, i = n.convertStringItemsToObjects, a = n.filterText, e.next = 3, o(a).catch(function (e) {
            console.warn("svelte-select loadOptions error :>> ", e), t("error", {
              type: "loadOptions",
              details: e
            });
          });
        case 3:
          if (!(s = e.sent) || s.cancelled) {
            e.next = 7;
            break;
          }
          return s ? (s && s.length > 0 && "object" !== S(s[0]) && (s = i(s)), t("loaded", {
            items: s
          })) : s = [], e.abrupt("return", {
            filteredItems: s,
            loading: !1,
            focused: !0,
            listOpen: !0
          });
        case 7:
        case "end":
          return e.stop();
      }
    }, e);
  })), Fu.apply(this, arguments);
}
function Lu(e) {
  St(e, "svelte-qbd276", "svg.svelte-qbd276{width:var(--chevron-icon-width, 20px);height:var(--chevron-icon-width, 20px);color:var(--chevron-icon-colour, currentColor)}");
}
function Uu(e) {
  var n, t;
  return {
    c: function () {
      n = It("svg"), Ut(t = It("path"), "fill", "currentColor"), Ut(t, "d", "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747\n          3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0\n          1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502\n          0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0\n          0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"), Ut(n, "width", "100%"), Ut(n, "height", "100%"), Ut(n, "viewBox", "0 0 20 20"), Ut(n, "focusable", "false"), Ut(n, "aria-hidden", "true"), Ut(n, "class", "svelte-qbd276");
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
var Du = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, null, Uu, lt, {}, Lu), t;
  }
  return v(n, Wo), b(n);
}();
function Ju(e) {
  St(e, "svelte-whdbu1", "svg.svelte-whdbu1{width:var(--clear-icon-width, 20px);height:var(--clear-icon-width, 20px);color:var(--clear-icon-color, currentColor)}");
}
function Vu(e) {
  var n, t;
  return {
    c: function () {
      n = It("svg"), Ut(t = It("path"), "fill", "currentColor"), Ut(t, "d", "M34.923,37.251L24,26.328L13.077,37.251L9.436,33.61l10.923-10.923L9.436,11.765l3.641-3.641L24,19.047L34.923,8.124\n    l3.641,3.641L27.641,22.688L38.564,33.61L34.923,37.251z"), Ut(n, "width", "100%"), Ut(n, "height", "100%"), Ut(n, "viewBox", "-2 -2 50 50"), Ut(n, "focusable", "false"), Ut(n, "aria-hidden", "true"), Ut(n, "role", "presentation"), Ut(n, "class", "svelte-whdbu1");
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
var Hu = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, null, Vu, lt, {}, Ju), t;
  }
  return v(n, Wo), b(n);
}();
function _u(e) {
  St(e, "svelte-1p3nqvd", ".loading.svelte-1p3nqvd{width:var(--spinner-width, 20px);height:var(--spinner-height, 20px);color:var(--spinner-color, var(--icons-color));animation:svelte-1p3nqvd-rotate 0.75s linear infinite;transform-origin:center center;transform:none}.circle_path.svelte-1p3nqvd{stroke-dasharray:90;stroke-linecap:round}@keyframes svelte-1p3nqvd-rotate{100%{transform:rotate(360deg)}}");
}
function Wu(e) {
  var n, t;
  return {
    c: function () {
      n = It("svg"), Ut(t = It("circle"), "class", "circle_path svelte-1p3nqvd"), Ut(t, "cx", "50"), Ut(t, "cy", "50"), Ut(t, "r", "20"), Ut(t, "fill", "none"), Ut(t, "stroke", "currentColor"), Ut(t, "stroke-width", "5"), Ut(t, "stroke-miterlimit", "10"), Ut(n, "class", "loading svelte-1p3nqvd"), Ut(n, "viewBox", "25 25 50 50");
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
var Qu = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, null, Wu, lt, {}, _u), t;
  }
  return v(n, Wo), b(n);
}();
function Yu(e) {
  St(e, "svelte-82qwg8", ".svelte-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{--borderRadius:var(--border-radius);--clearSelectColor:var(--clear-select-color);--clearSelectWidth:var(--clear-select-width);--disabledBackground:var(--disabled-background);--disabledBorderColor:var(--disabled-border-color);--disabledColor:var(--disabled-color);--disabledPlaceholderColor:var(--disabled-placeholder-color);--disabledPlaceholderOpacity:var(--disabled-placeholder-opacity);--errorBackground:var(--error-background);--errorBorder:var(--error-border);--groupItemPaddingLeft:var(--group-item-padding-left);--groupTitleColor:var(--group-title-color);--groupTitleFontSize:var(--group-title-font-size);--groupTitleFontWeight:var(--group-title-font-weight);--groupTitlePadding:var(--group-title-padding);--groupTitleTextTransform:var(--group-title-text-transform);--groupTitleBorderColor:var(--group-title-border-color);--groupTitleBorderWidth:var(--group-title-border-width);--groupTitleBorderStyle:var(--group-title-border-style);--indicatorColor:var(--chevron-color);--indicatorHeight:var(--chevron-height);--indicatorWidth:var(--chevron-width);--inputColor:var(--input-color);--inputLeft:var(--input-left);--inputLetterSpacing:var(--input-letter-spacing);--inputMargin:var(--input-margin);--inputPadding:var(--input-padding);--itemActiveBackground:var(--item-active-background);--itemColor:var(--item-color);--itemFirstBorderRadius:var(--item-first-border-radius);--itemHoverBG:var(--item-hover-bg);--itemHoverColor:var(--item-hover-color);--itemIsActiveBG:var(--item-is-active-bg);--itemIsActiveColor:var(--item-is-active-color);--itemIsNotSelectableColor:var(--item-is-not-selectable-color);--itemPadding:var(--item-padding);--listBackground:var(--list-background);--listBorder:var(--list-border);--listBorderRadius:var(--list-border-radius);--listEmptyColor:var(--list-empty-color);--listEmptyPadding:var(--list-empty-padding);--listEmptyTextAlign:var(--list-empty-text-align);--listMaxHeight:var(--list-max-height);--listPosition:var(--list-position);--listShadow:var(--list-shadow);--listZIndex:var(--list-z-index);--multiItemBG:var(--multi-item-bg);--multiItemBorderRadius:var(--multi-item-border-radius);--multiItemDisabledHoverBg:var(--multi-item-disabled-hover-bg);--multiItemDisabledHoverColor:var(--multi-item-disabled-hover-color);--multiItemHeight:var(--multi-item-height);--multiItemMargin:var(--multi-item-margin);--multiItemPadding:var(--multi-item-padding);--multiSelectInputMargin:var(--multi-select-input-margin);--multiSelectInputPadding:var(--multi-select-input-padding);--multiSelectPadding:var(--multi-select-padding);--placeholderColor:var(--placeholder-color);--placeholderOpacity:var(--placeholder-opacity);--selectedItemPadding:var(--selected-item-padding);--spinnerColor:var(--spinner-color);--spinnerHeight:var(--spinner-height);--spinnerWidth:var(--spinner-width);--internal-padding:0 0 0 16px;border:var(--border, 1px solid #d8dbdf);border-radius:var(--border-radius, 6px);min-height:var(--height, 42px);position:relative;display:flex;align-items:stretch;padding:var(--padding, var(--internal-padding));background:var(--background, #fff);margin:var(--margin, 0);width:var(--width, 100%);font-size:var(--font-size, 16px);max-height:var(--max-height)}.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{box-sizing:var(--box-sizing, border-box)}.svelte-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:hover{border:var(--border-hover, 1px solid #b2b8bf)}.value-container.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;flex:1 1 0%;flex-wrap:wrap;align-items:center;gap:5px 10px;padding:var(--value-container-padding, 5px 0);position:relative;overflow:var(--value-container-overflow, hidden);align-self:stretch}.prepend.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.indicators.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;flex-shrink:0;align-items:center}.indicators.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{position:var(--indicators-position);top:var(--indicators-top);right:var(--indicators-right);bottom:var(--indicators-bottom)}input.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{position:absolute;cursor:default;border:none;color:var(--input-color, var(--item-color));padding:var(--input-padding, 0);letter-spacing:var(--input-letter-spacing, inherit);margin:var(--input-margin, 0);min-width:10px;top:0;right:0;bottom:0;left:0;background:transparent;font-size:var(--font-size, 16px)}.svelte-82qwg8:not(.multi)>.value-container.svelte-82qwg8>input.svelte-82qwg8{width:100%;height:100%}input.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8::placeholder{color:var(--placeholder-color, #78848f);opacity:var(--placeholder-opacity, 1)}input.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:focus{outline:none}.svelte-select.focused.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{border:var(--border-focused, 1px solid #006fe8);border-radius:var(--border-radius-focused, var(--border-radius, 6px))}.disabled.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{background:var(--disabled-background, #ebedef);border-color:var(--disabled-border-color, #ebedef);color:var(--disabled-color, #c1c6cc)}.disabled.svelte-82qwg8 input.svelte-82qwg8.svelte-82qwg8::placeholder{color:var(--disabled-placeholder-color, #c1c6cc);opacity:var(--disabled-placeholder-opacity, 1)}.selected-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{position:relative;overflow:var(--selected-item-overflow, hidden);padding:var(--selected-item-padding, 0 20px 0 0);text-overflow:ellipsis;white-space:nowrap;color:var(--selected-item-color, inherit);font-size:var(--font-size, 16px)}.multi.svelte-82qwg8 .selected-item.svelte-82qwg8.svelte-82qwg8{position:absolute;line-height:var(--height, 42px);height:var(--height, 42px)}.selected-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:focus{outline:none}.hide-selected-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{opacity:0}.icon.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;align-items:center;justify-content:center}.clear-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{all:unset;display:flex;align-items:center;justify-content:center;width:var(--clear-select-width, 40px);height:var(--clear-select-height, 100%);color:var(--clear-select-color, var(--icons-color));margin:var(--clear-select-margin, 0);pointer-events:all;flex-shrink:0}.clear-select.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:focus{outline:var(--clear-select-focus-outline, 1px solid #006fe8)}.loading.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{width:var(--loading-width, 40px);height:var(--loading-height);color:var(--loading-color, var(--icons-color));margin:var(--loading--margin, 0);flex-shrink:0}.chevron.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{width:var(--chevron-width, 40px);height:var(--chevron-height, 40px);background:var(--chevron-background, transparent);pointer-events:var(--chevron-pointer-events, none);color:var(--chevron-color, var(--icons-color));border:var(--chevron-border, 0 0 0 1px solid #d8dbdf);flex-shrink:0}.multi.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{padding:var(--multi-select-padding, var(--internal-padding))}.multi.svelte-82qwg8 input.svelte-82qwg8.svelte-82qwg8{padding:var(--multi-select-input-padding, 0);position:relative;margin:var(--multi-select-input-margin, 5px 0);flex:1 1 40px}.svelte-select.error.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{border:var(--error-border, 1px solid #ff2d55);background:var(--error-background, #fff)}.a11y-text.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{z-index:9999;border:0px;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0px;white-space:nowrap}.multi-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{background:var(--multi-item-bg, #ebedef);margin:var(--multi-item-margin, 0);outline:var(--multi-item-outline, 1px solid #ddd);border-radius:var(--multi-item-border-radius, 4px);height:var(--multi-item-height, 25px);line-height:var(--multi-item-height, 25px);display:flex;cursor:default;padding:var(--multi-item-padding, 0 5px);overflow:hidden;gap:var(--multi-item-gap, 4px);outline-offset:-1px;max-width:var(--multi-max-width, none);color:var(--multi-item-color, var(--item-color))}.multi-item.disabled.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:hover{background:var(--multi-item-disabled-hover-bg, #ebedef);color:var(--multi-item-disabled-hover-color, #c1c6cc)}.multi-item-text.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.multi-item-clear.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{display:flex;align-items:center;justify-content:center;--clear-icon-color:var(--multi-item-clear-icon-color, #000)}.multi-item.active.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{outline:var(--multi-item-active-outline, 1px solid #006fe8)}.svelte-select-list.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{box-shadow:var(--list-shadow, 0 2px 3px 0 rgba(44, 62, 80, 0.24));border-radius:var(--list-border-radius, 4px);max-height:var(--list-max-height, 252px);overflow-y:auto;background:var(--list-background, #fff);position:var(--list-position, absolute);z-index:var(--list-z-index, 2);border:var(--list-border)}.prefloat.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{opacity:0;pointer-events:none}.list-group-title.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{color:var(--group-title-color, #8f8f8f);cursor:default;font-size:var(--group-title-font-size, 16px);font-weight:var(--group-title-font-weight, 600);height:var(--height, 42px);line-height:var(--height, 42px);padding:var(--group-title-padding, 0 20px);text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;text-transform:var(--group-title-text-transform, uppercase);border-width:var(--group-title-border-width, medium);border-style:var(--group-title-border-style, none);border-color:var(--group-title-border-color, color)}.empty.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{text-align:var(--list-empty-text-align, center);padding:var(--list-empty-padding, 20px 0);color:var(--list-empty-color, #78848f)}.item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{cursor:default;height:var(--item-height, var(--height, 42px));line-height:var(--item-line-height, var(--height, 42px));padding:var(--item-padding, 0 20px);color:var(--item-color, inherit);text-overflow:ellipsis;overflow:hidden;white-space:nowrap;transition:var(--item-transition, all 0.2s);align-items:center;width:100%}.item.group-item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{padding-left:var(--group-item-padding-left, 40px)}.item.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:active{background:var(--item-active-background, #b9daff)}.item.active.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{background:var(--item-is-active-bg, #007aff);color:var(--item-is-active-color, #fff)}.item.first.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{border-radius:var(--item-first-border-radius, 4px 4px 0 0)}.item.hover.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:not(.active){background:var(--item-hover-bg, #e7f2ff);color:var(--item-hover-color, inherit)}.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.item.hover.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.item.active.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8,.item.not-selectable.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8:active{color:var(--item-is-not-selectable-color, #999);background:transparent}.required.svelte-82qwg8.svelte-82qwg8.svelte-82qwg8{opacity:0;z-index:-1;position:absolute;top:0;left:0;bottom:0;right:0}");
}
var Gu = function (e) {
    return {
      value: 8 & e[0]
    };
  },
  Ku = function (e) {
    return {
      value: e[3]
    };
  },
  Zu = function (e) {
    return {
      value: 8 & e[0]
    };
  },
  Xu = function (e) {
    return {
      value: e[3]
    };
  },
  ed = function (e) {
    return {
      listOpen: 64 & e[0]
    };
  },
  nd = function (e) {
    return {
      listOpen: e[6]
    };
  },
  td = function (e) {
    return {};
  },
  od = function (e) {
    return {};
  },
  rd = function (e) {
    return {};
  },
  id = function (e) {
    return {};
  },
  ad = function (e) {
    return {
      selection: 8 & e[0]
    };
  },
  sd = function (e) {
    return {
      selection: e[3]
    };
  };
function ld(e, n, t) {
  var o = e.slice();
  return o[126] = n[t], o[128] = t, o;
}
var cd = function (e) {
    return {};
  },
  ud = function (e) {
    return {};
  },
  dd = function (e) {
    return {
      selection: 8 & e[0]
    };
  },
  fd = function (e) {
    return {
      selection: e[126],
      index: e[128]
    };
  },
  vd = function (e) {
    return {};
  },
  pd = function (e) {
    return {};
  },
  md = function (e) {
    return {};
  },
  gd = function (e) {
    return {};
  },
  hd = function (e) {
    return {};
  },
  jd = function (e) {
    return {};
  };
function bd(e, n, t) {
  var o = e.slice();
  return o[126] = n[t], o[128] = t, o;
}
var yd = function (e) {
    return {
      item: 16777216 & e[0]
    };
  },
  xd = function (e) {
    return {
      item: e[126],
      index: e[128]
    };
  },
  wd = function (e) {
    return {
      filteredItems: 16777216 & e[0]
    };
  },
  $d = function (e) {
    return {
      filteredItems: e[24]
    };
  },
  kd = function (e) {
    return {};
  },
  Cd = function (e) {
    return {};
  };
function Sd(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c = e[50]["list-prepend"] && Md(e),
    u = [Rd, zd, Od],
    d = [];
  function f(e, n) {
    return e[50].list ? 0 : e[24].length > 0 ? 1 : e[19] ? -1 : 2;
  }
  ~(o = f(e)) && (r = d[o] = u[o](e));
  var v = e[50]["list-append"] && qd(e);
  return {
    c: function () {
      n = Pt("div"), c && c.c(), t = At(), r && r.c(), i = At(), v && v.c(), Ut(n, "class", "svelte-select-list svelte-82qwg8"), Ut(n, "role", "none"), Yt(n, "prefloat", e[28]);
    },
    m: function (r, u) {
      Rt(r, n, u), c && c.m(n, null), Ct(n, t), ~o && d[o].m(n, null), Ct(n, i), v && v.m(n, null), e[91](n), a = !0, s || (l = [jt(e[49].call(null, n)), Bt(n, "scroll", e[41]), Bt(n, "pointerup", Lt(Ft(e[85]))), Bt(n, "mousedown", Lt(Ft(e[86])))], s = !0);
    },
    p: function (e, s) {
      e[50]["list-prepend"] ? c ? (c.p(e, s), 524288 & s[1] && qo(c, 1)) : ((c = Md(e)).c(), qo(c, 1), c.m(n, t)) : c && (Ro(), Po(c, 1, 1, function () {
        c = null;
      }), Eo());
      var l = o;
      (o = f(e)) === l ? ~o && d[o].p(e, s) : (r && (Ro(), Po(d[l], 1, 1, function () {
        d[l] = null;
      }), Eo()), ~o ? ((r = d[o]) ? r.p(e, s) : (r = d[o] = u[o](e)).c(), qo(r, 1), r.m(n, i)) : r = null), e[50]["list-append"] ? v ? (v.p(e, s), 524288 & s[1] && qo(v, 1)) : ((v = qd(e)).c(), qo(v, 1), v.m(n, null)) : v && (Ro(), Po(v, 1, 1, function () {
        v = null;
      }), Eo()), (!a || 268435456 & s[0]) && Yt(n, "prefloat", e[28]);
    },
    i: function (e) {
      a || (qo(c), qo(r), qo(v), a = !0);
    },
    o: function (e) {
      Po(c), Po(r), Po(v), a = !1;
    },
    d: function (t) {
      t && Et(n), c && c.d(), ~o && d[o].d(), v && v.d(), e[91](null), s = !1, at(l);
    }
  };
}
function Md(e) {
  var n,
    t = e[83]["list-prepend"],
    o = ut(t, e, e[82], Cd);
  return {
    c: function () {
      o && o.c();
    },
    m: function (e, t) {
      o && o.m(e, t), n = !0;
    },
    p: function (e, r) {
      o && o.p && (!n || 1048576 & r[2]) && vt(o, t, e, e[82], n ? ft(t, e[82], r, kd) : pt(e[82]), Cd);
    },
    i: function (e) {
      n || (qo(o, e), n = !0);
    },
    o: function (e) {
      Po(o, e), n = !1;
    },
    d: function (e) {
      o && o.d(e);
    }
  };
}
function Od(e) {
  var n,
    t,
    o = e[83].empty,
    r = ut(o, e, e[82], jd),
    i = r || {
      c: function () {
        (t = Pt("div")).textContent = "No options", Ut(t, "class", "empty svelte-82qwg8");
      },
      m: function (e, n) {
        Rt(e, t, n);
      },
      p: nt,
      d: function (e) {
        e && Et(t);
      }
    };
  return {
    c: function () {
      i && i.c();
    },
    m: function (e, t) {
      i && i.m(e, t), n = !0;
    },
    p: function (e, t) {
      r && r.p && (!n || 1048576 & t[2]) && vt(r, o, e, e[82], n ? ft(o, e[82], t, hd) : pt(e[82]), jd);
    },
    i: function (e) {
      n || (qo(i, e), n = !0);
    },
    o: function (e) {
      Po(i, e), n = !1;
    },
    d: function (e) {
      i && i.d(e);
    }
  };
}
function zd(e) {
  for (var n, t, o = Ao(e[24]), r = [], i = 0; i < o.length; i += 1) r[i] = Ed(bd(e, o, i));
  var a = function (e) {
    return Po(r[e], 1, 1, function () {
      r[e] = null;
    });
  };
  return {
    c: function () {
      for (var e = 0; e < r.length; e += 1) r[e].c();
      n = Nt();
    },
    m: function (e, o) {
      for (var i = 0; i < r.length; i += 1) r[i] && r[i].m(e, o);
      Rt(e, n, o), t = !0;
    },
    p: function (e, t) {
      if (1627402376 & t[0] | 28672 & t[1] | 1048576 & t[2]) {
        var i;
        for (o = Ao(e[24]), i = 0; i < o.length; i += 1) {
          var s = bd(e, o, i);
          r[i] ? (r[i].p(s, t), qo(r[i], 1)) : (r[i] = Ed(s), r[i].c(), qo(r[i], 1), r[i].m(n.parentNode, n));
        }
        for (Ro(), i = o.length; i < r.length; i += 1) a(i);
        Eo();
      }
    },
    i: function (e) {
      if (!t) {
        for (var n = 0; n < o.length; n += 1) qo(r[n]);
        t = !0;
      }
    },
    o: function (e) {
      r = r.filter(Boolean);
      for (var n = 0; n < r.length; n += 1) Po(r[n]);
      t = !1;
    },
    d: function (e) {
      e && Et(n), qt(r, e);
    }
  };
}
function Rd(e) {
  var n,
    t = e[83].list,
    o = ut(t, e, e[82], $d);
  return {
    c: function () {
      o && o.c();
    },
    m: function (e, t) {
      o && o.m(e, t), n = !0;
    },
    p: function (e, r) {
      o && o.p && (!n || 16777216 & r[0] | 1048576 & r[2]) && vt(o, t, e, e[82], n ? ft(t, e[82], r, wd) : pt(e[82]), $d);
    },
    i: function (e) {
      n || (qo(o, e), n = !0);
    },
    o: function (e) {
      Po(o, e), n = !1;
    },
    d: function (e) {
      o && o.d(e);
    }
  };
}
function Ed(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c = e[83].item,
    u = ut(c, e, e[82], xd),
    d = u || function (e) {
      var n,
        t,
        o = (null === (n = e[126]) || void 0 === n ? void 0 : n[e[12]]) + "";
      return {
        c: function () {
          t = Tt(o);
        },
        m: function (e, n) {
          Rt(e, t, n);
        },
        p: function (e, n) {
          var r;
          16781312 & n[0] && o !== (o = (null === (r = e[126]) || void 0 === r ? void 0 : r[e[12]]) + "") && Ht(t, o);
        },
        d: function (e) {
          e && Et(t);
        }
      };
    }(e);
  function f() {
    return e[88](e[128]);
  }
  function v() {
    return e[89](e[128]);
  }
  function p() {
    return e[90](e[126], e[128]);
  }
  return {
    c: function () {
      var o;
      n = Pt("div"), t = Pt("div"), d && d.c(), i = At(), Ut(t, "class", "item svelte-82qwg8"), Yt(t, "list-group-title", e[126].groupHeader), Yt(t, "active", e[45](e[126], e[3], e[13])), Yt(t, "first", 0 === e[128]), Yt(t, "hover", e[7] === e[128]), Yt(t, "group-item", e[126].groupItem), Yt(t, "not-selectable", !1 === (null === (o = e[126]) || void 0 === o ? void 0 : o.selectable)), Ut(n, "class", "list-item svelte-82qwg8"), Ut(n, "tabindex", "-1"), Ut(n, "role", "none");
    },
    m: function (c, u) {
      Rt(c, n, u), Ct(n, t), d && d.m(t, null), Ct(n, i), a = !0, s || (l = [jt(o = e[46].call(null, t, {
        scroll: e[45](e[126], e[3], e[13]),
        listDom: e[30]
      })), jt(r = e[47].call(null, t, {
        scroll: e[29] === e[128],
        listDom: e[30]
      })), Bt(n, "mouseover", f), Bt(n, "focus", v), Bt(n, "click", Lt(p)), Bt(n, "keydown", Lt(Ft(e[87])))], s = !0);
    },
    p: function (n, i) {
      var s;
      (e = n, u ? u.p && (!a || 16777216 & i[0] | 1048576 & i[2]) && vt(u, c, e, e[82], a ? ft(c, e[82], i, yd) : pt(e[82]), xd) : d && d.p && (!a || 16781312 & i[0]) && d.p(e, a ? i : [-1, -1, -1, -1, -1]), o && st(o.update) && 1090527240 & i[0] && o.update.call(null, {
        scroll: e[45](e[126], e[3], e[13]),
        listDom: e[30]
      }), r && st(r.update) && 1610612736 & i[0] && r.update.call(null, {
        scroll: e[29] === e[128],
        listDom: e[30]
      }), (!a || 16777216 & i[0]) && Yt(t, "list-group-title", e[126].groupHeader), (!a || 16785416 & i[0] | 16384 & i[1]) && Yt(t, "active", e[45](e[126], e[3], e[13])), (!a || 128 & i[0]) && Yt(t, "hover", e[7] === e[128]), (!a || 16777216 & i[0]) && Yt(t, "group-item", e[126].groupItem), !a || 16777216 & i[0]) && Yt(t, "not-selectable", !1 === (null === (s = e[126]) || void 0 === s ? void 0 : s.selectable));
    },
    i: function (e) {
      a || (qo(d, e), a = !0);
    },
    o: function (e) {
      Po(d, e), a = !1;
    },
    d: function (e) {
      e && Et(n), d && d.d(e), s = !1, at(l);
    }
  };
}
function qd(e) {
  var n,
    t = e[83]["list-append"],
    o = ut(t, e, e[82], gd);
  return {
    c: function () {
      o && o.c();
    },
    m: function (e, t) {
      o && o.m(e, t), n = !0;
    },
    p: function (e, r) {
      o && o.p && (!n || 1048576 & r[2]) && vt(o, t, e, e[82], n ? ft(t, e[82], r, md) : pt(e[82]), gd);
    },
    i: function (e) {
      n || (qo(o, e), n = !0);
    },
    o: function (e) {
      Po(o, e), n = !1;
    },
    d: function (e) {
      o && o.d(e);
    }
  };
}
function Pd(e) {
  var n, t, o, r, i;
  return {
    c: function () {
      n = Pt("span"), t = Tt(e[32]), o = At(), r = Pt("span"), i = Tt(e[31]), Ut(n, "id", "aria-selection"), Ut(n, "class", "svelte-82qwg8"), Ut(r, "id", "aria-context"), Ut(r, "class", "svelte-82qwg8");
    },
    m: function (e, a) {
      Rt(e, n, a), Ct(n, t), Rt(e, o, a), Rt(e, r, a), Ct(r, i);
    },
    p: function (e, n) {
      2 & n[1] && Ht(t, e[32]), 1 & n[1] && Ht(i, e[31]);
    },
    d: function (e) {
      e && (Et(n), Et(o), Et(r));
    }
  };
}
function Id(e) {
  var n,
    t,
    o,
    r,
    i = [Ad, Td],
    a = [];
  function s(e, n) {
    return e[9] ? 0 : 1;
  }
  return n = s(e), t = a[n] = i[n](e), {
    c: function () {
      t.c(), o = Nt();
    },
    m: function (e, t) {
      a[n].m(e, t), Rt(e, o, t), r = !0;
    },
    p: function (e, r) {
      var l = n;
      (n = s(e)) === l ? a[n].p(e, r) : (Ro(), Po(a[l], 1, 1, function () {
        a[l] = null;
      }), Eo(), (t = a[n]) ? t.p(e, r) : (t = a[n] = i[n](e)).c(), qo(t, 1), t.m(o.parentNode, o));
    },
    i: function (e) {
      r || (qo(t), r = !0);
    },
    o: function (e) {
      Po(t), r = !1;
    },
    d: function (e) {
      e && Et(o), a[n].d(e);
    }
  };
}
function Td(e) {
  var n,
    t,
    o = e[83].selection,
    r = ut(o, e, e[82], sd),
    i = r || function (e) {
      var n,
        t = e[3][e[12]] + "";
      return {
        c: function () {
          n = Tt(t);
        },
        m: function (e, t) {
          Rt(e, n, t);
        },
        p: function (e, o) {
          4104 & o[0] && t !== (t = e[3][e[12]] + "") && Ht(n, t);
        },
        d: function (e) {
          e && Et(n);
        }
      };
    }(e);
  return {
    c: function () {
      n = Pt("div"), i && i.c(), Ut(n, "class", "selected-item svelte-82qwg8"), Yt(n, "hide-selected-item", e[35]);
    },
    m: function (e, o) {
      Rt(e, n, o), i && i.m(n, null), t = !0;
    },
    p: function (e, a) {
      r ? r.p && (!t || 8 & a[0] | 1048576 & a[2]) && vt(r, o, e, e[82], t ? ft(o, e[82], a, ad) : pt(e[82]), sd) : i && i.p && (!t || 4104 & a[0]) && i.p(e, t ? a : [-1, -1, -1, -1, -1]), (!t || 16 & a[1]) && Yt(n, "hide-selected-item", e[35]);
    },
    i: function (e) {
      t || (qo(i, e), t = !0);
    },
    o: function (e) {
      Po(i, e), t = !1;
    },
    d: function (e) {
      e && Et(n), i && i.d(e);
    }
  };
}
function Ad(e) {
  for (var n, t, o = Ao(e[3]), r = [], i = 0; i < o.length; i += 1) r[i] = Bd(ld(e, o, i));
  var a = function (e) {
    return Po(r[e], 1, 1, function () {
      r[e] = null;
    });
  };
  return {
    c: function () {
      for (var e = 0; e < r.length; e += 1) r[e].c();
      n = Nt();
    },
    m: function (e, o) {
      for (var i = 0; i < r.length; i += 1) r[i] && r[i].m(e, o);
      Rt(e, n, o), t = !0;
    },
    p: function (e, t) {
      if (67116040 & t[0] | 32 & t[1] | 1048576 & t[2]) {
        var i;
        for (o = Ao(e[3]), i = 0; i < o.length; i += 1) {
          var s = ld(e, o, i);
          r[i] ? (r[i].p(s, t), qo(r[i], 1)) : (r[i] = Bd(s), r[i].c(), qo(r[i], 1), r[i].m(n.parentNode, n));
        }
        for (Ro(), i = o.length; i < r.length; i += 1) a(i);
        Eo();
      }
    },
    i: function (e) {
      if (!t) {
        for (var n = 0; n < o.length; n += 1) qo(r[n]);
        t = !0;
      }
    },
    o: function (e) {
      r = r.filter(Boolean);
      for (var n = 0; n < r.length; n += 1) Po(r[n]);
      t = !1;
    },
    d: function (e) {
      e && Et(n), qt(r, e);
    }
  };
}
function Nd(e) {
  var n,
    t,
    o,
    r,
    i = e[83]["multi-clear-icon"],
    a = ut(i, e, e[82], ud),
    s = a || function (e) {
      var n, t;
      return n = new Hu({}), {
        c: function () {
          Jo(n.$$.fragment);
        },
        m: function (e, o) {
          Vo(n, e, o), t = !0;
        },
        i: function (e) {
          t || (qo(n.$$.fragment, e), t = !0);
        },
        o: function (e) {
          Po(n.$$.fragment, e), t = !1;
        },
        d: function (e) {
          Ho(n, e);
        }
      };
    }();
  function l() {
    return e[92](e[128]);
  }
  return {
    c: function () {
      n = Pt("div"), s && s.c(), Ut(n, "class", "multi-item-clear svelte-82qwg8");
    },
    m: function (e, i) {
      Rt(e, n, i), s && s.m(n, null), t = !0, o || (r = Bt(n, "pointerup", Lt(Ft(l))), o = !0);
    },
    p: function (n, o) {
      e = n, a && a.p && (!t || 1048576 & o[2]) && vt(a, i, e, e[82], t ? ft(i, e[82], o, cd) : pt(e[82]), ud);
    },
    i: function (e) {
      t || (qo(s, e), t = !0);
    },
    o: function (e) {
      Po(s, e), t = !1;
    },
    d: function (e) {
      e && Et(n), s && s.d(e), o = !1, r();
    }
  };
}
function Bd(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l = e[83].selection,
    c = ut(l, e, e[82], fd),
    u = c || function (e) {
      var n,
        t = e[126][e[12]] + "";
      return {
        c: function () {
          n = Tt(t);
        },
        m: function (e, t) {
          Rt(e, n, t);
        },
        p: function (e, o) {
          4104 & o[0] && t !== (t = e[126][e[12]] + "") && Ht(n, t);
        },
        d: function (e) {
          e && Et(n);
        }
      };
    }(e),
    d = !e[11] && !e[10] && Hu && Nd(e);
  function f() {
    return e[93](e[128]);
  }
  return {
    c: function () {
      n = Pt("div"), t = Pt("span"), u && u.c(), o = At(), d && d.c(), r = At(), Ut(t, "class", "multi-item-text svelte-82qwg8"), Ut(n, "class", "multi-item svelte-82qwg8"), Ut(n, "role", "none"), Yt(n, "active", e[26] === e[128]), Yt(n, "disabled", e[11]);
    },
    m: function (l, c) {
      Rt(l, n, c), Ct(n, t), u && u.m(t, null), Ct(n, o), d && d.m(n, null), Ct(n, r), i = !0, a || (s = [Bt(n, "click", Ft(f)), Bt(n, "keydown", Lt(Ft(e[84])))], a = !0);
    },
    p: function (t, o) {
      e = t, c ? c.p && (!i || 8 & o[0] | 1048576 & o[2]) && vt(c, l, e, e[82], i ? ft(l, e[82], o, dd) : pt(e[82]), fd) : u && u.p && (!i || 4104 & o[0]) && u.p(e, i ? o : [-1, -1, -1, -1, -1]), e[11] || e[10] || !Hu ? d && (Ro(), Po(d, 1, 1, function () {
        d = null;
      }), Eo()) : d ? (d.p(e, o), 3072 & o[0] && qo(d, 1)) : ((d = Nd(e)).c(), qo(d, 1), d.m(n, r)), (!i || 67108864 & o[0]) && Yt(n, "active", e[26] === e[128]), (!i || 2048 & o[0]) && Yt(n, "disabled", e[11]);
    },
    i: function (e) {
      i || (qo(u, e), qo(d), i = !0);
    },
    o: function (e) {
      Po(u, e), Po(d), i = !1;
    },
    d: function (e) {
      e && Et(n), u && u.d(e), d && d.d(), a = !1, at(s);
    }
  };
}
function Fd(e) {
  var n,
    t,
    o = e[83]["loading-icon"],
    r = ut(o, e, e[82], id),
    i = r || function (e) {
      var n, t;
      return n = new Qu({}), {
        c: function () {
          Jo(n.$$.fragment);
        },
        m: function (e, o) {
          Vo(n, e, o), t = !0;
        },
        i: function (e) {
          t || (qo(n.$$.fragment, e), t = !0);
        },
        o: function (e) {
          Po(n.$$.fragment, e), t = !1;
        },
        d: function (e) {
          Ho(n, e);
        }
      };
    }();
  return {
    c: function () {
      n = Pt("div"), i && i.c(), Ut(n, "class", "icon loading svelte-82qwg8"), Ut(n, "aria-hidden", "true");
    },
    m: function (e, o) {
      Rt(e, n, o), i && i.m(n, null), t = !0;
    },
    p: function (e, n) {
      r && r.p && (!t || 1048576 & n[2]) && vt(r, o, e, e[82], t ? ft(o, e[82], n, rd) : pt(e[82]), id);
    },
    i: function (e) {
      t || (qo(i, e), t = !0);
    },
    o: function (e) {
      Po(i, e), t = !1;
    },
    d: function (e) {
      e && Et(n), i && i.d(e);
    }
  };
}
function Ld(e) {
  var n,
    t,
    o,
    r,
    i = e[83]["clear-icon"],
    a = ut(i, e, e[82], od),
    s = a || function (e) {
      var n, t;
      return n = new Hu({}), {
        c: function () {
          Jo(n.$$.fragment);
        },
        m: function (e, o) {
          Vo(n, e, o), t = !0;
        },
        i: function (e) {
          t || (qo(n.$$.fragment, e), t = !0);
        },
        o: function (e) {
          Po(n.$$.fragment, e), t = !1;
        },
        d: function (e) {
          Ho(n, e);
        }
      };
    }();
  return {
    c: function () {
      n = Pt("button"), s && s.c(), Ut(n, "type", "button"), Ut(n, "class", "icon clear-select svelte-82qwg8");
    },
    m: function (i, a) {
      Rt(i, n, a), s && s.m(n, null), t = !0, o || (r = Bt(n, "click", e[22]), o = !0);
    },
    p: function (e, n) {
      a && a.p && (!t || 1048576 & n[2]) && vt(a, i, e, e[82], t ? ft(i, e[82], n, td) : pt(e[82]), od);
    },
    i: function (e) {
      t || (qo(s, e), t = !0);
    },
    o: function (e) {
      Po(s, e), t = !1;
    },
    d: function (e) {
      e && Et(n), s && s.d(e), o = !1, r();
    }
  };
}
function Ud(e) {
  var n,
    t,
    o = e[83]["chevron-icon"],
    r = ut(o, e, e[82], nd),
    i = r || function (e) {
      var n, t;
      return n = new Du({}), {
        c: function () {
          Jo(n.$$.fragment);
        },
        m: function (e, o) {
          Vo(n, e, o), t = !0;
        },
        i: function (e) {
          t || (qo(n.$$.fragment, e), t = !0);
        },
        o: function (e) {
          Po(n.$$.fragment, e), t = !1;
        },
        d: function (e) {
          Ho(n, e);
        }
      };
    }();
  return {
    c: function () {
      n = Pt("div"), i && i.c(), Ut(n, "class", "icon chevron svelte-82qwg8"), Ut(n, "aria-hidden", "true");
    },
    m: function (e, o) {
      Rt(e, n, o), i && i.m(n, null), t = !0;
    },
    p: function (e, n) {
      r && r.p && (!t || 64 & n[0] | 1048576 & n[2]) && vt(r, o, e, e[82], t ? ft(o, e[82], n, ed) : pt(e[82]), nd);
    },
    i: function (e) {
      t || (qo(i, e), t = !0);
    },
    o: function (e) {
      Po(i, e), t = !1;
    },
    d: function (e) {
      e && Et(n), i && i.d(e);
    }
  };
}
function Dd(e) {
  var n,
    t,
    o = e[83].required,
    r = ut(o, e, e[82], Ku),
    i = r || {
      c: function () {
        Ut(t = Pt("select"), "class", "required svelte-82qwg8"), t.required = !0, Ut(t, "tabindex", "-1"), Ut(t, "aria-hidden", "true");
      },
      m: function (e, n) {
        Rt(e, t, n);
      },
      p: nt,
      d: function (e) {
        e && Et(t);
      }
    };
  return {
    c: function () {
      i && i.c();
    },
    m: function (e, t) {
      i && i.m(e, t), n = !0;
    },
    p: function (e, t) {
      r && r.p && (!n || 8 & t[0] | 1048576 & t[2]) && vt(r, o, e, e[82], n ? ft(o, e[82], t, Gu) : pt(e[82]), Ku);
    },
    i: function (e) {
      n || (qo(i, e), n = !0);
    },
    o: function (e) {
      Po(i, e), n = !1;
    },
    d: function (e) {
      i && i.d(e);
    }
  };
}
function Jd(e) {
  for (var n, t, o, r, i, a, s, l, c, u, d, f, v, p, m, g, h, j, b, y, x = e[6] && Sd(e), w = e[2] && Pd(e), $ = e[83].prepend, k = ut($, e, e[82], pd), C = e[25] && Id(e), S = [{
      readOnly: u = !e[17]
    }, e[27], {
      placeholder: e[33]
    }, {
      style: e[18]
    }, {
      disabled: e[11]
    }], M = {}, O = 0; O < S.length; O += 1) M = ot(M, S[O]);
  var z = e[5] && Fd(e),
    R = e[34] && Ld(e),
    E = e[20] && Ud(e),
    q = e[83]["input-hidden"],
    P = ut(q, e, e[82], Xu),
    I = P || function (e) {
      var n, t;
      return {
        c: function () {
          Ut(n = Pt("input"), "name", e[8]), Ut(n, "type", "hidden"), n.value = t = e[3] ? JSON.stringify(e[3]) : null, Ut(n, "class", "svelte-82qwg8");
        },
        m: function (e, t) {
          Rt(e, n, t);
        },
        p: function (e, o) {
          256 & o[0] && Ut(n, "name", e[8]), 8 & o[0] && t !== (t = e[3] ? JSON.stringify(e[3]) : null) && (n.value = t);
        },
        d: function (e) {
          e && Et(n);
        }
      };
    }(e),
    T = e[16] && (!e[3] || 0 === e[3].length) && Dd(e);
  return {
    c: function () {
      n = Pt("div"), x && x.c(), t = At(), o = Pt("span"), w && w.c(), r = At(), i = Pt("div"), k && k.c(), a = At(), s = Pt("div"), C && C.c(), l = At(), c = Pt("input"), d = At(), f = Pt("div"), z && z.c(), v = At(), R && R.c(), p = At(), E && E.c(), m = At(), I && I.c(), g = At(), T && T.c(), Ut(o, "aria-live", "polite"), Ut(o, "aria-atomic", "false"), Ut(o, "aria-relevant", "additions text"), Ut(o, "class", "a11y-text svelte-82qwg8"), Ut(i, "class", "prepend svelte-82qwg8"), Jt(c, M), Yt(c, "svelte-82qwg8", !0), Ut(s, "class", "value-container svelte-82qwg8"), Ut(f, "class", "indicators svelte-82qwg8"), Ut(n, "class", h = "svelte-select " + e[21] + " svelte-82qwg8"), Ut(n, "style", e[14]), Ut(n, "role", "none"), Yt(n, "multi", e[9]), Yt(n, "disabled", e[11]), Yt(n, "focused", e[2]), Yt(n, "list-open", e[6]), Yt(n, "show-chevron", e[20]), Yt(n, "error", e[15]);
    },
    m: function (u, h) {
      Rt(u, n, h), x && x.m(n, null), Ct(n, t), Ct(n, o), w && w.m(o, null), Ct(n, r), Ct(n, i), k && k.m(i, null), Ct(n, a), Ct(n, s), C && C.m(s, null), Ct(s, l), Ct(s, c), c.autofocus && c.focus(), e[94](c), _t(c, e[4]), Ct(n, d), Ct(n, f), z && z.m(f, null), Ct(f, v), R && R.m(f, null), Ct(f, p), E && E.m(f, null), Ct(n, m), I && I.m(n, null), Ct(n, g), T && T.m(n, null), e[96](n), j = !0, b || (y = [Bt(window, "click", e[42]), Bt(window, "keydown", e[37]), Bt(c, "keydown", e[37]), Bt(c, "blur", e[39]), Bt(c, "focus", e[38]), Bt(c, "input", e[95]), Bt(n, "pointerup", Ft(e[40])), jt(e[48].call(null, n))], b = !0);
    },
    p: function (e, r) {
      e[6] ? x ? (x.p(e, r), 64 & r[0] && qo(x, 1)) : ((x = Sd(e)).c(), qo(x, 1), x.m(n, t)) : x && (Ro(), Po(x, 1, 1, function () {
        x = null;
      }), Eo()), e[2] ? w ? w.p(e, r) : ((w = Pd(e)).c(), w.m(o, null)) : w && (w.d(1), w = null), k && k.p && (!j || 1048576 & r[2]) && vt(k, $, e, e[82], j ? ft($, e[82], r, vd) : pt(e[82]), pd), e[25] ? C ? (C.p(e, r), 33554432 & r[0] && qo(C, 1)) : ((C = Id(e)).c(), qo(C, 1), C.m(s, l)) : C && (Ro(), Po(C, 1, 1, function () {
        C = null;
      }), Eo()), Jt(c, M = Lo(S, [(!j || 131072 & r[0] && u !== (u = !e[17])) && {
        readOnly: u
      }, 134217728 & r[0] && e[27], (!j || 4 & r[1]) && {
        placeholder: e[33]
      }, (!j || 262144 & r[0]) && {
        style: e[18]
      }, (!j || 2048 & r[0]) && {
        disabled: e[11]
      }])), 16 & r[0] && c.value !== e[4] && _t(c, e[4]), Yt(c, "svelte-82qwg8", !0), e[5] ? z ? (z.p(e, r), 32 & r[0] && qo(z, 1)) : ((z = Fd(e)).c(), qo(z, 1), z.m(f, v)) : z && (Ro(), Po(z, 1, 1, function () {
        z = null;
      }), Eo()), e[34] ? R ? (R.p(e, r), 8 & r[1] && qo(R, 1)) : ((R = Ld(e)).c(), qo(R, 1), R.m(f, p)) : R && (Ro(), Po(R, 1, 1, function () {
        R = null;
      }), Eo()), e[20] ? E ? (E.p(e, r), 1048576 & r[0] && qo(E, 1)) : ((E = Ud(e)).c(), qo(E, 1), E.m(f, null)) : E && (Ro(), Po(E, 1, 1, function () {
        E = null;
      }), Eo()), P ? P.p && (!j || 8 & r[0] | 1048576 & r[2]) && vt(P, q, e, e[82], j ? ft(q, e[82], r, Zu) : pt(e[82]), Xu) : I && I.p && (!j || 264 & r[0]) && I.p(e, j ? r : [-1, -1, -1, -1, -1]), !e[16] || e[3] && 0 !== e[3].length ? T && (Ro(), Po(T, 1, 1, function () {
        T = null;
      }), Eo()) : T ? (T.p(e, r), 65544 & r[0] && qo(T, 1)) : ((T = Dd(e)).c(), qo(T, 1), T.m(n, null)), (!j || 2097152 & r[0] && h !== (h = "svelte-select " + e[21] + " svelte-82qwg8")) && Ut(n, "class", h), (!j || 16384 & r[0]) && Ut(n, "style", e[14]), (!j || 2097664 & r[0]) && Yt(n, "multi", e[9]), (!j || 2099200 & r[0]) && Yt(n, "disabled", e[11]), (!j || 2097156 & r[0]) && Yt(n, "focused", e[2]), (!j || 2097216 & r[0]) && Yt(n, "list-open", e[6]), (!j || 3145728 & r[0]) && Yt(n, "show-chevron", e[20]), (!j || 2129920 & r[0]) && Yt(n, "error", e[15]);
    },
    i: function (e) {
      j || (qo(x), qo(k, e), qo(C), qo(z), qo(R), qo(E), qo(I, e), qo(T), j = !0);
    },
    o: function (e) {
      Po(x), Po(k, e), Po(C), Po(z), Po(R), Po(E), Po(I, e), Po(T), j = !1;
    },
    d: function (t) {
      t && Et(n), x && x.d(), w && w.d(), k && k.d(t), C && C.d(), e[94](null), z && z.d(), R && R.d(), E && E.d(), I && I.d(t), T && T.d(), e[96](null), b = !1, at(y);
    }
  };
}
function Vd(e) {
  return e.map(function (e, n) {
    return {
      index: n,
      value: e,
      label: "".concat(e)
    };
  });
}
function Hd(e, n, t) {
  var o,
    i,
    l,
    c,
    u,
    d,
    f,
    v,
    p,
    m,
    h,
    j,
    b,
    x,
    $,
    k,
    C = n.$$slots,
    M = void 0 === C ? {} : C,
    O = n.$$scope,
    z = function (e) {
      var n = {};
      for (var t in e) n[t] = !0;
      return n;
    }(M),
    R = so(),
    E = n.justValue,
    q = void 0 === E ? null : E,
    P = n.filter,
    I = void 0 === P ? Nu : P,
    T = n.getItems,
    A = void 0 === T ? Bu : T,
    N = n.id,
    B = void 0 === N ? null : N,
    F = n.name,
    L = void 0 === F ? null : F,
    U = n.container,
    D = void 0 === U ? void 0 : U,
    J = n.input,
    V = void 0 === J ? void 0 : J,
    H = n.multiple,
    _ = void 0 !== H && H,
    W = n.multiFullItemClearable,
    Q = void 0 !== W && W,
    Y = n.disabled,
    G = void 0 !== Y && Y,
    K = n.focused,
    Z = void 0 !== K && K,
    X = n.value,
    ee = void 0 === X ? null : X,
    ne = n.filterText,
    te = void 0 === ne ? "" : ne,
    oe = n.placeholder,
    re = void 0 === oe ? "Please select" : oe,
    ie = n.placeholderAlwaysShow,
    ae = void 0 !== ie && ie,
    se = n.items,
    le = void 0 === se ? null : se,
    ce = n.label,
    ue = void 0 === ce ? "label" : ce,
    de = n.itemFilter,
    fe = void 0 === de ? function (e, n, t) {
      return "".concat(e).toLowerCase().includes(n.toLowerCase());
    } : de,
    ve = n.groupBy,
    pe = void 0 === ve ? void 0 : ve,
    me = n.groupFilter,
    ge = void 0 === me ? function (e) {
      return e;
    } : me,
    he = n.groupHeaderSelectable,
    je = void 0 !== he && he,
    be = n.itemId,
    ye = void 0 === be ? "value" : be,
    xe = n.loadOptions,
    we = void 0 === xe ? void 0 : xe,
    $e = n.containerStyles,
    ke = void 0 === $e ? "" : $e,
    Ce = n.hasError,
    Se = void 0 !== Ce && Ce,
    Me = n.filterSelectedItems,
    Oe = void 0 === Me || Me,
    ze = n.required,
    Re = void 0 !== ze && ze,
    Ee = n.closeListOnChange,
    qe = void 0 === Ee || Ee,
    Pe = n.clearFilterTextOnBlur,
    Ie = void 0 === Pe || Pe,
    Te = n.createGroupHeaderItem,
    Ae = void 0 === Te ? function (e, n) {
      return y({
        value: e
      }, ue, e);
    } : Te,
    Ne = n.searchable,
    Be = void 0 === Ne || Ne,
    Fe = n.inputStyles,
    Le = void 0 === Fe ? "" : Fe,
    Ue = n.clearable,
    De = void 0 === Ue || Ue,
    Je = n.loading,
    Ve = void 0 !== Je && Je,
    He = n.listOpen,
    _e = void 0 !== He && He,
    We = n.debounce,
    Qe = void 0 === We ? function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
      clearTimeout(m), m = setTimeout(e, n);
    } : We,
    Ye = n.debounceWait,
    Ge = void 0 === Ye ? 300 : Ye,
    Ke = n.hideEmptyState,
    Ze = void 0 !== Ke && Ke,
    Xe = n.inputAttributes,
    en = void 0 === Xe ? {} : Xe,
    nn = n.listAutoWidth,
    tn = void 0 === nn || nn,
    on = n.showChevron,
    rn = void 0 !== on && on,
    an = n.listOffset,
    sn = void 0 === an ? 5 : an,
    ln = n.hoverItemIndex,
    cn = void 0 === ln ? 0 : ln,
    un = n.floatingConfig,
    dn = void 0 === un ? {} : un,
    fn = n.class,
    vn = void 0 === fn ? "" : fn;
  function pn(e) {
    var n = [],
      t = {};
    e.forEach(function (e) {
      var o = pe(e);
      n.includes(o) || (n.push(o), t[o] = [], o && t[o].push(Object.assign(Ae(o, e), {
        id: o,
        groupHeader: !0,
        selectable: je
      }))), t[o].push(Object.assign({
        groupItem: !!o
      }, e));
    });
    var o = [];
    return ge(n).forEach(function (e) {
      t[e] && o.push.apply(o, w(t[e]));
    }), o;
  }
  function mn() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
      n = arguments.length > 1 ? arguments[1] : void 0;
    t(7, cn = e < 0 ? 0 : e), !n && pe && f[cn] && !f[cn].selectable && Nn(1);
  }
  function gn() {
    var e = !0;
    if (ee) {
      var n = [],
        o = [];
      ee.forEach(function (t) {
        n.includes(t[ye]) ? e = !1 : (n.push(t[ye]), o.push(t));
      }), e || t(3, ee = o);
    }
    return e;
  }
  function hn(e) {
    var n = e ? e[ye] : ee[ye];
    return le.find(function (e) {
      return e[ye] === n;
    });
  }
  function jn(e) {
    return bn.apply(this, arguments);
  }
  function bn() {
    return (bn = a(r().mark(function e(n) {
      var o;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            o = ee[n], 1 === ee.length ? t(3, ee = void 0) : t(3, ee = ee.filter(function (e) {
              return e !== o;
            })), R("clear", o);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function yn(e) {
    var n, o;
    Z && V === (null === (n = document) || void 0 === n ? void 0 : n.activeElement) || (e && R("focus", e), null === (o = V) || void 0 === o || o.focus(), t(2, Z = !0));
  }
  function xn(e) {
    return wn.apply(this, arguments);
  }
  function wn() {
    return (wn = a(r().mark(function e(n) {
      var o;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (!Pn) {
              e.next = 2;
              break;
            }
            return e.abrupt("return");
          case 2:
            (_e || Z) && (R("blur", n), $n(), t(2, Z = !1), t(26, h = void 0), null === (o = V) || void 0 === o || o.blur());
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function $n() {
    Ie && t(4, te = ""), t(6, _e = !1);
  }
  k = a(r().mark(function e() {
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          t(78, j = ee), t(79, b = te), t(80, x = _);
        case 3:
        case "end":
          return e.stop();
      }
    }, e);
  })), ro().$$.before_update.push(k), io(function () {
    _e && t(2, Z = !0), Z && V && V.focus();
  });
  var kn = n.ariaValues,
    Cn = void 0 === kn ? function (e) {
      return "Option ".concat(e, ", selected.");
    } : kn,
    Sn = n.ariaListOpen,
    Mn = void 0 === Sn ? function (e, n) {
      return "You are currently focused on option ".concat(e, ". There are ").concat(n, " results available.");
    } : Sn,
    On = n.ariaFocused,
    zn = void 0 === On ? function () {
      return "Select is focused, type to refine list, press down to open the menu.";
    } : On;
  var Rn,
    En = null;
  function qn() {
    clearTimeout(Rn), Rn = setTimeout(function () {
      Pn = !1;
    }, 100);
  }
  ao(function () {
    var e;
    null === (e = En) || void 0 === e || e.remove();
  });
  var Pn = !1;
  function In(e) {
    e && !1 !== e.selectable && function (e) {
      if (e) {
        t(4, te = "");
        var n = Object.assign({}, e);
        if (n.groupHeader && !n.selectable) return;
        t(3, ee = _ ? ee ? ee.concat([n]) : [n] : t(3, ee = n)), setTimeout(function () {
          qe && $n(), t(26, h = void 0), R("change", ee), R("select", e);
        });
      }
    }(e);
  }
  function Tn(e) {
    Pn || t(7, cn = e);
  }
  function An(e) {
    var n = e.item,
      o = e.i;
    if (!1 !== (null == n ? void 0 : n.selectable)) return ee && !_ && ee[ye] === n[ye] ? $n() : void (function (e) {
      return e.groupHeader && e.selectable || e.selectable || !e.hasOwnProperty("selectable");
    }(n) && (t(7, cn = o), In(n)));
  }
  function Nn(e) {
    if (0 === f.filter(function (e) {
      return !Object.hasOwn(e, "selectable") || !0 === e.selectable;
    }).length) return t(7, cn = 0);
    e > 0 && cn === f.length - 1 ? t(7, cn = 0) : t(7, e < 0 && 0 === cn ? cn = f.length - 1 : cn += e);
    var n = f[cn];
    n && !1 === n.selectable && (1 !== e && -1 !== e || Nn(e));
  }
  var Bn = Ln,
    Fn = Ln;
  function Ln(e) {
    return {
      update: function (n) {
        n.scroll && (qn(), e.scrollIntoView({
          behavior: "auto",
          block: "nearest"
        }));
      }
    };
  }
  var Un,
    Dn,
    Jn,
    Vn,
    Hn,
    _n,
    Wn,
    Qn,
    Yn = {
      strategy: "absolute",
      placement: "bottom-start",
      middleware: [Pu(sn), Tu(), Iu()],
      autoUpdate: !1
    },
    Gn = (Vn = {
      autoUpdate: !0
    }, Hn = Un = Yn, _n = function (e) {
      return g(g(g({}, Vn), Un || {}), e || {});
    }, Qn = function (e) {
      ao(e.subscribe(function (e) {
        void 0 === Dn ? (Dn = e, Wn()) : (Object.assign(Dn, e), Wn());
      }));
    }, [function (e) {
      if ("subscribe" in e) return Qn(e), {};
      Dn = e, Wn();
    }, function (e, n) {
      var t;
      Jn = e, Hn = _n(n), setTimeout(function () {
        return Wn(n);
      }, 0), Wn(n);
      var o = function () {
          t && (t(), t = void 0);
        },
        r = function () {
          var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Hn || {}).autoUpdate;
          o(), !1 !== e && bo().then(function () {
            return qu(Dn, Jn, function () {
              return Wn(Hn);
            }, !0 === e ? {} : e);
          });
        };
      return t = r(), {
        update: function (e) {
          Wn(e), t = r(e);
        },
        destroy: function () {
          o();
        }
      };
    }, Wn = function (e) {
      Dn && Jn && (Hn = _n(e), Au(Dn, Jn, Hn).then(function (e) {
        var n;
        Object.assign(Jn.style, {
          position: e.strategy,
          left: "".concat(e.x, "px"),
          top: "".concat(e.y, "px")
        }), (null === (n = Hn) || void 0 === n ? void 0 : n.onComputed) && Hn.onComputed(e);
      }));
    }]),
    Kn = s(Gn, 3),
    Zn = Kn[0],
    Xn = Kn[1],
    et = Kn[2],
    nt = !0;
  return e.$$set = function (e) {
    "justValue" in e && t(52, q = e.justValue), "filter" in e && t(53, I = e.filter), "getItems" in e && t(54, A = e.getItems), "id" in e && t(55, B = e.id), "name" in e && t(8, L = e.name), "container" in e && t(0, D = e.container), "input" in e && t(1, V = e.input), "multiple" in e && t(9, _ = e.multiple), "multiFullItemClearable" in e && t(10, Q = e.multiFullItemClearable), "disabled" in e && t(11, G = e.disabled), "focused" in e && t(2, Z = e.focused), "value" in e && t(3, ee = e.value), "filterText" in e && t(4, te = e.filterText), "placeholder" in e && t(56, re = e.placeholder), "placeholderAlwaysShow" in e && t(57, ae = e.placeholderAlwaysShow), "items" in e && t(51, le = e.items), "label" in e && t(12, ue = e.label), "itemFilter" in e && t(58, fe = e.itemFilter), "groupBy" in e && t(59, pe = e.groupBy), "groupFilter" in e && t(60, ge = e.groupFilter), "groupHeaderSelectable" in e && t(61, je = e.groupHeaderSelectable), "itemId" in e && t(13, ye = e.itemId), "loadOptions" in e && t(62, we = e.loadOptions), "containerStyles" in e && t(14, ke = e.containerStyles), "hasError" in e && t(15, Se = e.hasError), "filterSelectedItems" in e && t(63, Oe = e.filterSelectedItems), "required" in e && t(16, Re = e.required), "closeListOnChange" in e && t(64, qe = e.closeListOnChange), "clearFilterTextOnBlur" in e && t(65, Ie = e.clearFilterTextOnBlur), "createGroupHeaderItem" in e && t(66, Ae = e.createGroupHeaderItem), "searchable" in e && t(17, Be = e.searchable), "inputStyles" in e && t(18, Le = e.inputStyles), "clearable" in e && t(68, De = e.clearable), "loading" in e && t(5, Ve = e.loading), "listOpen" in e && t(6, _e = e.listOpen), "debounce" in e && t(69, Qe = e.debounce), "debounceWait" in e && t(70, Ge = e.debounceWait), "hideEmptyState" in e && t(19, Ze = e.hideEmptyState), "inputAttributes" in e && t(71, en = e.inputAttributes), "listAutoWidth" in e && t(72, tn = e.listAutoWidth), "showChevron" in e && t(20, rn = e.showChevron), "listOffset" in e && t(73, sn = e.listOffset), "hoverItemIndex" in e && t(7, cn = e.hoverItemIndex), "floatingConfig" in e && t(74, dn = e.floatingConfig), "class" in e && t(21, vn = e.class), "ariaValues" in e && t(75, Cn = e.ariaValues), "ariaListOpen" in e && t(76, Mn = e.ariaListOpen), "ariaFocused" in e && t(77, zn = e.ariaFocused), "$$scope" in e && t(82, O = e.$$scope);
  }, e.$$.update = function () {
    var n, s, m, g;
    (8 & e.$$.dirty[0] | 1048576 & e.$$.dirty[1] && ee && function () {
      if ("string" == typeof ee) {
        var e = (le || []).find(function (e) {
          return e[ye] === ee;
        });
        t(3, ee = e || y(y({}, ye, ee), "label", ee));
      } else _ && Array.isArray(ee) && ee.length > 0 && t(3, ee = ee.map(function (e) {
        return "string" == typeof e ? {
          value: e,
          label: e
        } : e;
      }));
    }(), 131072 & e.$$.dirty[0] | 512 & e.$$.dirty[2] && (!en && Be || (t(27, $ = Object.assign({
      autocapitalize: "none",
      autocomplete: "off",
      autocorrect: "off",
      spellcheck: !1,
      tabindex: 0,
      type: "text",
      "aria-autocomplete": "list"
    }, en)), B && t(27, $.id = B, $), Be || t(27, $.readonly = !0, $))), 512 & e.$$.dirty[0] && _ && ee && (Array.isArray(ee) ? t(3, ee = w(ee)) : t(3, ee = [ee])), 512 & e.$$.dirty[0] | 262144 & e.$$.dirty[2] && x && !_ && ee && t(3, ee = null), 520 & e.$$.dirty[0] && _ && ee && ee.length > 1 && gn(), 8 & e.$$.dirty[0] && ee && (_ ? JSON.stringify(ee) !== JSON.stringify(j) && gn() && R("input", ee) : j && JSON.stringify(ee[ye]) === JSON.stringify(j[ye]) || R("input", ee)), 520 & e.$$.dirty[0] | 65536 & e.$$.dirty[2] && !ee && _ && j && R("input", ee), 6 & e.$$.dirty[0] && !Z && V && $n(), 16 & e.$$.dirty[0] | 131072 & e.$$.dirty[2] && te !== b && (we || 0 !== te.length) && (we ? Qe(a(r().mark(function e() {
      var n;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return t(5, Ve = !0), e.next = 3, A({
              dispatch: R,
              loadOptions: we,
              convertStringItemsToObjects: Vd,
              filterText: te
            });
          case 3:
            (n = e.sent) ? (t(5, Ve = n.loading), t(6, _e = _e ? n.listOpen : te.length > 0), t(2, Z = _e && n.focused), t(51, le = pe ? pn(n.filteredItems) : n.filteredItems)) : (t(5, Ve = !1), t(2, Z = !0), t(6, _e = !0));
          case 5:
          case "end":
            return e.stop();
        }
      }, e);
    })), Ge) : (t(6, _e = !0), _ && t(26, h = void 0))), 12824 & e.$$.dirty[0] | 407896064 & e.$$.dirty[1] | 3 & e.$$.dirty[2] && t(24, f = I({
      loadOptions: we,
      filterText: te,
      items: le,
      multiple: _,
      value: ee,
      itemId: ye,
      groupBy: pe,
      label: ue,
      filterSelectedItems: Oe,
      itemFilter: fe,
      convertStringItemsToObjects: Vd,
      filterGroupedItems: pn
    })), 16777800 & e.$$.dirty[0] && !_ && _e && ee && f && mn(f.findIndex(function (e) {
      return e[ye] === ee[ye];
    }), !0), 576 & e.$$.dirty[0] && _e && _ && t(7, cn = 0), 16 & e.$$.dirty[0] && te && t(7, cn = 0), 128 & e.$$.dirty[0] && R("hoverItem", cn), 520 & e.$$.dirty[0] && t(25, o = _ ? ee && ee.length > 0 : ee), 33554448 & e.$$.dirty[0] && t(35, i = o && te.length > 0), 33556512 & e.$$.dirty[0] | 64 & e.$$.dirty[2] && t(34, l = o && De && !G && !Ve), 520 & e.$$.dirty[0] | 100663296 & e.$$.dirty[1]) && t(33, c = ae && _ || _ && 0 === (null === (n = ee) || void 0 === n ? void 0 : n.length) ? re : ee ? "" : re);
    (520 & e.$$.dirty[0] && t(32, u = ee ? (s = void 0, s = _ && ee.length > 0 ? ee.map(function (e) {
      return e[ue];
    }).join(", ") : ee[ue], Cn(s)) : ""), 16777412 & e.$$.dirty[0] && t(31, d = function () {
      if (!f || 0 === f.length) return "";
      var e = f[cn];
      if (_e && e) {
        var n = f ? f.length : 0;
        return Mn(e[ue], n);
      }
      return zn();
    }()), 1048576 & e.$$.dirty[1] && function (e) {
      e && 0 !== e.length && !e.some(function (e) {
        return "object" !== S(e);
      }) && ee && (_ ? !ee.some(function (e) {
        return !e || !e[ye];
      }) : ee[ye]) && (Array.isArray(ee) ? t(3, ee = ee.map(function (e) {
        return hn(e) || e;
      })) : t(3, ee = hn() || ee));
    }(le), 8712 & e.$$.dirty[0] && t(52, q = _ ? ee ? ee.map(function (e) {
      return e[ye];
    }) : null : ee ? ee[ye] : ee), 520 & e.$$.dirty[0] | 65536 & e.$$.dirty[2] && (_ || !j || ee || R("input", ee)), 16777800 & e.$$.dirty[0] && _e && f && !_ && !ee && mn(), 16777216 & e.$$.dirty[0] && function (e) {
      _e && R("filter", e);
    }(f), 1 & e.$$.dirty[0] | 4096 & e.$$.dirty[2]) && D && void 0 === (null === (m = dn) || void 0 === m ? void 0 : m.autoUpdate) && t(81, Yn.autoUpdate = !0, Yn);
    1 & e.$$.dirty[0] | 528384 & e.$$.dirty[2] && D && dn && et(Object.assign(Yn, dn)), 8388608 & e.$$.dirty[0] && t(30, v = !!En), 8388672 & e.$$.dirty[0] && function (e, n) {
      if (!e || !n) return t(28, nt = !0);
      setTimeout(function () {
        t(28, nt = !1);
      }, 0);
    }(En, _e), 8388673 & e.$$.dirty[0] && _e && D && En && (g = D.getBoundingClientRect().width, t(23, En.style.width = tn ? g + "px" : "auto", En)), 128 & e.$$.dirty[0] && t(29, p = cn), 70 & e.$$.dirty[0] && V && _e && !Z && yn();
  }, [D, V, Z, ee, te, Ve, _e, cn, L, _, Q, G, ue, ye, ke, Se, Re, Be, Le, Ze, rn, vn, function () {
    R("clear", ee), t(3, ee = void 0), $n(), yn();
  }, En, f, o, h, $, nt, p, v, d, u, c, l, i, jn, function (e) {
    if (Z) switch (e.stopPropagation(), e.key) {
      case "Escape":
        e.preventDefault(), $n();
        break;
      case "Enter":
        if (e.preventDefault(), _e) {
          if (0 === f.length) break;
          var n = f[cn];
          if (ee && !_ && ee[ye] === n[ye]) {
            $n();
            break;
          }
          In(f[cn]);
        }
        break;
      case "ArrowDown":
        e.preventDefault(), _e ? Nn(1) : (t(6, _e = !0), t(26, h = void 0));
        break;
      case "ArrowUp":
        e.preventDefault(), _e ? Nn(-1) : (t(6, _e = !0), t(26, h = void 0));
        break;
      case "Tab":
        if (_e && Z) {
          if (0 === f.length || ee && ee[ye] === f[cn][ye]) return $n();
          e.preventDefault(), In(f[cn]), $n();
        }
        break;
      case "Backspace":
        if (!_ || te.length > 0) return;
        if (_ && ee && ee.length > 0) {
          if (jn(void 0 !== h ? h : ee.length - 1), 0 === h || void 0 === h) break;
          t(26, h = ee.length > h ? h - 1 : void 0);
        }
        break;
      case "ArrowLeft":
        if (!ee || !_ || te.length > 0) return;
        void 0 === h ? t(26, h = ee.length - 1) : ee.length > h && 0 !== h && t(26, h -= 1);
        break;
      case "ArrowRight":
        if (!ee || !_ || te.length > 0 || void 0 === h) return;
        h === ee.length - 1 ? t(26, h = void 0) : h < ee.length - 1 && t(26, h += 1);
    }
  }, yn, xn, function () {
    if (!G) return te.length > 0 ? t(6, _e = !0) : void t(6, _e = !_e);
  }, qn, function (e) {
    var n;
    _e || Z || !D || D.contains(e.target) || null !== (n = En) && void 0 !== n && n.contains(e.target) || xn();
  }, Tn, An, function (e, n, t) {
    if (!_) return n && n[t] === e[t];
  }, Bn, Fn, Zn, Xn, z, le, q, I, A, B, re, ae, fe, pe, ge, je, we, Oe, qe, Ie, Ae, function () {
    return f;
  }, De, Qe, Ge, en, tn, sn, dn, Cn, Mn, zn, j, b, x, Yn, O, M, function (n) {
    uo.call(this, e, n);
  }, function (n) {
    uo.call(this, e, n);
  }, function (n) {
    uo.call(this, e, n);
  }, function (n) {
    uo.call(this, e, n);
  }, function (e) {
    return Tn(e);
  }, function (e) {
    return Tn(e);
  }, function (e, n) {
    return An({
      item: e,
      i: n
    });
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(23, En = e);
    });
  }, function (e) {
    return jn(e);
  }, function (e) {
    return Q ? jn(e) : {};
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(1, V = e);
    });
  }, function () {
    te = this.value, t(4, te);
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(0, D = e);
    });
  }];
}
var _d = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Hd, Jd, lt, {
      justValue: 52,
      filter: 53,
      getItems: 54,
      id: 55,
      name: 8,
      container: 0,
      input: 1,
      multiple: 9,
      multiFullItemClearable: 10,
      disabled: 11,
      focused: 2,
      value: 3,
      filterText: 4,
      placeholder: 56,
      placeholderAlwaysShow: 57,
      items: 51,
      label: 12,
      itemFilter: 58,
      groupBy: 59,
      groupFilter: 60,
      groupHeaderSelectable: 61,
      itemId: 13,
      loadOptions: 62,
      containerStyles: 14,
      hasError: 15,
      filterSelectedItems: 63,
      required: 16,
      closeListOnChange: 64,
      clearFilterTextOnBlur: 65,
      createGroupHeaderItem: 66,
      getFilteredItems: 67,
      searchable: 17,
      inputStyles: 18,
      clearable: 68,
      loading: 5,
      listOpen: 6,
      debounce: 69,
      debounceWait: 70,
      hideEmptyState: 19,
      inputAttributes: 71,
      listAutoWidth: 72,
      showChevron: 20,
      listOffset: 73,
      hoverItemIndex: 7,
      floatingConfig: 74,
      class: 21,
      handleClear: 22,
      ariaValues: 75,
      ariaListOpen: 76,
      ariaFocused: 77
    }, Yu, [-1, -1, -1, -1, -1]), t;
  }
  return v(n, Wo), b(n, [{
    key: "getFilteredItems",
    get: function () {
      return this.$$.ctx[67];
    }
  }, {
    key: "handleClear",
    get: function () {
      return this.$$.ctx[22];
    }
  }]);
}();
function Wd(e) {
  St(e, "svelte-ijtq0l", "table.jse-transform-wizard.svelte-ijtq0l.svelte-ijtq0l{border-collapse:collapse;border-spacing:0;width:100%}table.jse-transform-wizard.svelte-ijtq0l input.svelte-ijtq0l{font-family:inherit;font-size:inherit}table.jse-transform-wizard.svelte-ijtq0l tr th.svelte-ijtq0l{font-weight:normal;text-align:left;width:60px}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l{width:100%;display:flex;flex-direction:row;margin-bottom:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select .multi-item{align-items:center}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select .value-container{gap:0 !important}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-filter-path{flex:4;margin-right:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-filter-relation{flex:1.5;margin-right:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-sort-path{flex:3;margin-right:calc(0.5 * var(--jse-padding, 10px))}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-sort-direction{flex:1}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select.jse-projection-paths{flex:1}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal.svelte-ijtq0l .svelte-select input{box-sizing:border-box}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal .jse-filter-value.svelte-ijtq0l{flex:4;padding:4px 8px;border:var(--jse-input-border, 1px solid #d8dbdf);border-radius:var(--jse-input-radius, 3px);outline:none;background:var(--jse-input-background, var(--jse-background-color, #fff));color:inherit}table.jse-transform-wizard.svelte-ijtq0l tr td .jse-horizontal .jse-filter-value.svelte-ijtq0l:focus{border:var(--jse-input-border-focus, 1px solid var(--jse-input-border-focus, var(--jse-theme-color, #3883fa)))}");
}
function Qd(e) {
  var n, t, o, r, i, a, l, c, u, d, f, v, p, m, g, h, j, b, y, x, w, $, k, C, S, M, O, z, R, E, q, P, I, T, A;
  function N(n) {
    e[16](n);
  }
  var B = {
    class: "jse-filter-path",
    showChevron: !0,
    items: e[7]
  };
  function F(n) {
    e[17](n);
  }
  void 0 !== e[0] && (B.value = e[0]), l = new _d({
    props: B
  }), vo.push(function () {
    return Do(l, "value", N);
  });
  var L = {
    class: "jse-filter-relation",
    showChevron: !0,
    items: e[8]
  };
  function U(n) {
    e[19](n);
  }
  void 0 !== e[1] && (L.value = e[1]), d = new _d({
    props: L
  }), vo.push(function () {
    return Do(d, "value", F);
  });
  var D = {
    class: "jse-sort-path",
    showChevron: !0,
    items: e[7]
  };
  function J(n) {
    e[20](n);
  }
  void 0 !== e[3] && (D.value = e[3]), x = new _d({
    props: D
  }), vo.push(function () {
    return Do(x, "value", U);
  });
  var V = {
    class: "jse-sort-direction",
    showChevron: !0,
    items: e[9]
  };
  function H(n) {
    e[21](n);
  }
  void 0 !== e[4] && (V.value = e[4]), k = new _d({
    props: V
  }), vo.push(function () {
    return Do(k, "value", J);
  });
  var _ = {
    class: "jse-projection-paths",
    multiple: !0,
    showChevron: !0,
    items: e[6]
  };
  return void 0 !== e[5] && (_.value = e[5]), q = new _d({
    props: _
  }), vo.push(function () {
    return Do(q, "value", H);
  }), {
    c: function () {
      n = Pt("table"), t = Pt("tr"), (o = Pt("th")).textContent = "Filter", r = At(), i = Pt("td"), a = Pt("div"), Jo(l.$$.fragment), u = At(), Jo(d.$$.fragment), v = At(), p = Pt("input"), m = At(), g = Pt("tr"), (h = Pt("th")).textContent = "Sort", j = At(), b = Pt("td"), y = Pt("div"), Jo(x.$$.fragment), $ = At(), Jo(k.$$.fragment), S = At(), M = Pt("tr"), (O = Pt("th")).textContent = "Pick", z = At(), R = Pt("td"), E = Pt("div"), Jo(q.$$.fragment), Ut(o, "class", "svelte-ijtq0l"), Ut(p, "class", "jse-filter-value svelte-ijtq0l"), Ut(a, "class", "jse-horizontal svelte-ijtq0l"), Ut(h, "class", "svelte-ijtq0l"), Ut(y, "class", "jse-horizontal svelte-ijtq0l"), Ut(O, "class", "svelte-ijtq0l"), Ut(E, "class", "jse-horizontal svelte-ijtq0l"), Ut(n, "class", "jse-transform-wizard svelte-ijtq0l");
    },
    m: function (s, c) {
      Rt(s, n, c), Ct(n, t), Ct(t, o), Ct(t, r), Ct(t, i), Ct(i, a), Vo(l, a, null), Ct(a, u), Vo(d, a, null), Ct(a, v), Ct(a, p), _t(p, e[2]), Ct(n, m), Ct(n, g), Ct(g, h), Ct(g, j), Ct(g, b), Ct(b, y), Vo(x, y, null), Ct(y, $), Vo(k, y, null), Ct(n, S), Ct(n, M), Ct(M, O), Ct(M, z), Ct(M, R), Ct(R, E), Vo(q, E, null), I = !0, T || (A = Bt(p, "input", e[18]), T = !0);
    },
    p: function (e, n) {
      var t = s(n, 1)[0],
        o = {};
      128 & t && (o.items = e[7]), !c && 1 & t && (c = !0, o.value = e[0], xo(function () {
        return c = !1;
      })), l.$set(o);
      var r = {};
      !f && 2 & t && (f = !0, r.value = e[1], xo(function () {
        return f = !1;
      })), d.$set(r), 4 & t && p.value !== e[2] && _t(p, e[2]);
      var i = {};
      128 & t && (i.items = e[7]), !w && 8 & t && (w = !0, i.value = e[3], xo(function () {
        return w = !1;
      })), x.$set(i);
      var a = {};
      !C && 16 & t && (C = !0, a.value = e[4], xo(function () {
        return C = !1;
      })), k.$set(a);
      var u = {};
      64 & t && (u.items = e[6]), !P && 32 & t && (P = !0, u.value = e[5], xo(function () {
        return P = !1;
      })), q.$set(u);
    },
    i: function (e) {
      I || (qo(l.$$.fragment, e), qo(d.$$.fragment, e), qo(x.$$.fragment, e), qo(k.$$.fragment, e), qo(q.$$.fragment, e), I = !0);
    },
    o: function (e) {
      Po(l.$$.fragment, e), Po(d.$$.fragment, e), Po(x.$$.fragment, e), Po(k.$$.fragment, e), Po(q.$$.fragment, e), I = !1;
    },
    d: function (e) {
      e && Et(n), Ho(l), Ho(d), Ho(x), Ho(k), Ho(q), T = !1, A();
    }
  };
}
function Yd(e, n, t) {
  var o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f,
    v,
    p = Qo("jsoneditor:TransformWizard"),
    m = n.json,
    g = n.queryOptions,
    h = void 0 === g ? {} : g,
    j = n.onChange,
    b = ["==", "!=", "<", "<=", ">", ">="].map(function (e) {
      return {
        value: e,
        label: e
      };
    }),
    y = [{
      value: "asc",
      label: "ascending"
    }, {
      value: "desc",
      label: "descending"
    }],
    x = null !== (o = h) && void 0 !== o && null !== (o = o.filter) && void 0 !== o && o.path ? Ca(h.filter.path) : null,
    w = null !== (r = h) && void 0 !== r && null !== (r = r.filter) && void 0 !== r && r.relation ? b.find(function (e) {
      var n;
      return e.value === (null === (n = h.filter) || void 0 === n ? void 0 : n.relation);
    }) : null,
    $ = (null === (i = h) || void 0 === i || null === (i = i.filter) || void 0 === i ? void 0 : i.value) || "",
    k = null !== (a = h) && void 0 !== a && null !== (a = a.sort) && void 0 !== a && a.path ? Ca(h.sort.path) : null,
    C = null !== (s = h) && void 0 !== s && null !== (s = s.sort) && void 0 !== s && s.direction ? y.find(function (e) {
      var n;
      return e.value === (null === (n = h.sort) || void 0 === n ? void 0 : n.direction);
    }) : null;
  return e.$$set = function (e) {
    "json" in e && t(11, m = e.json), "queryOptions" in e && t(10, h = e.queryOptions), "onChange" in e && t(12, j = e.onChange);
  }, e.$$.update = function () {
    var n, o, r, i, a, s, g, b, y, S, M, O, z;
    (2048 & e.$$.dirty && t(15, l = Array.isArray(m)), 34816 & e.$$.dirty && t(14, c = l ? si(m) : []), 34816 & e.$$.dirty && t(13, u = l ? si(m, !0) : []), 16384 & e.$$.dirty && t(7, d = c.map(Ca)), 8192 & e.$$.dirty && t(6, f = u ? u.map(Ca) : []), 1088 & e.$$.dirty) && t(5, v = null !== (n = h) && void 0 !== n && null !== (n = n.projection) && void 0 !== n && n.paths && f ? h.projection.paths.map(function (e) {
      return f.find(function (n) {
        return ne(n.value, e);
      });
    }).filter(function (e) {
      return !!e;
    }) : null);
    1 & e.$$.dirty && (r = null === (o = x) || void 0 === o ? void 0 : o.value, ne(null === (i = h) || void 0 === i || null === (i = i.filter) || void 0 === i ? void 0 : i.path, r) || (p("changeFilterPath", r), t(10, h = D(h, ["filter", "path"], r, !0)), j(h)));
    2 & e.$$.dirty && (s = null === (a = w) || void 0 === a ? void 0 : a.value, ne(null === (g = h) || void 0 === g || null === (g = g.filter) || void 0 === g ? void 0 : g.relation, s) || (p("changeFilterRelation", s), t(10, h = D(h, ["filter", "relation"], s, !0)), j(h)));
    (4 & e.$$.dirty && (b = $, ne(null === (y = h) || void 0 === y || null === (y = y.filter) || void 0 === y ? void 0 : y.value, b) || (p("changeFilterValue", b), t(10, h = D(h, ["filter", "value"], b, !0)), j(h))), 8 & e.$$.dirty) && function (e) {
      var n;
      ne(null === (n = h) || void 0 === n || null === (n = n.sort) || void 0 === n ? void 0 : n.path, e) || (p("changeSortPath", e), t(10, h = D(h, ["sort", "path"], e, !0)), j(h));
    }(null === (S = k) || void 0 === S ? void 0 : S.value);
    16 & e.$$.dirty && (O = null === (M = C) || void 0 === M ? void 0 : M.value, ne(null === (z = h) || void 0 === z || null === (z = z.sort) || void 0 === z ? void 0 : z.direction, O) || (p("changeSortDirection", O), t(10, h = D(h, ["sort", "direction"], O, !0)), j(h)));
    32 & e.$$.dirty && function (e) {
      var n;
      ne(null === (n = h) || void 0 === n || null === (n = n.projection) || void 0 === n ? void 0 : n.paths, e) || (p("changeProjectionPaths", e), t(10, h = D(h, ["projection", "paths"], e, !0)), j(h));
    }(v ? v.map(function (e) {
      return e.value;
    }) : void 0);
  }, [x, w, $, k, C, v, f, d, b, y, h, m, j, u, c, l, function (e) {
    t(0, x = e);
  }, function (e) {
    t(1, w = e);
  }, function () {
    $ = this.value, t(2, $);
  }, function (e) {
    t(3, k = e);
  }, function (e) {
    t(4, C = e);
  }, function (e) {
    t(5, v = e), t(10, h), t(6, f), t(13, u), t(15, l), t(11, m);
  }];
}
var Gd = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Yd, Qd, ct, {
      json: 11,
      queryOptions: 10,
      onChange: 12
    }, Wd), t;
  }
  return v(n, Wo), b(n);
}();
function Kd(e) {
  St(e, "svelte-1wg043c", '.jse-select-query-language.svelte-1wg043c.svelte-1wg043c{position:relative;width:32px}.jse-select-query-language.svelte-1wg043c .jse-select-query-language-container.svelte-1wg043c{position:absolute;top:0;right:0;display:flex;flex-direction:column;box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}.jse-select-query-language.svelte-1wg043c .jse-select-query-language-container .jse-query-language.svelte-1wg043c{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;text-align:left;padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));white-space:nowrap;color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));background:var(--jse-context-menu-background, #656565)}.jse-select-query-language.svelte-1wg043c .jse-select-query-language-container .jse-query-language.svelte-1wg043c:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}');
}
function Zd(e, n, t) {
  var o = e.slice();
  return o[5] = n[t], o;
}
function Xd(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: me
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function ef(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: pe
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function nf(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d = e[5].name + "",
    f = [ef, Xd],
    v = [];
  function p(e, n) {
    return e[5].id === e[0] ? 0 : 1;
  }
  function m() {
    return e[4](e[5]);
  }
  return t = p(e), o = v[t] = f[t](e), {
    c: function () {
      n = Pt("button"), o.c(), r = At(), i = Tt(d), a = At(), Ut(n, "type", "button"), Ut(n, "class", "jse-query-language svelte-1wg043c"), Ut(n, "title", s = "Select ".concat(e[5].name, " as query language")), Yt(n, "selected", e[5].id === e[0]);
    },
    m: function (e, o) {
      Rt(e, n, o), v[t].m(n, null), Ct(n, r), Ct(n, i), Ct(n, a), l = !0, c || (u = Bt(n, "click", m), c = !0);
    },
    p: function (a, c) {
      var u = t;
      (t = p(e = a)) !== u && (Ro(), Po(v[u], 1, 1, function () {
        v[u] = null;
      }), Eo(), (o = v[t]) || (o = v[t] = f[t](e)).c(), qo(o, 1), o.m(n, r)), (!l || 2 & c) && d !== (d = e[5].name + "") && Ht(i, d), (!l || 2 & c && s !== (s = "Select ".concat(e[5].name, " as query language"))) && Ut(n, "title", s), (!l || 3 & c) && Yt(n, "selected", e[5].id === e[0]);
    },
    i: function (e) {
      l || (qo(o), l = !0);
    },
    o: function (e) {
      Po(o), l = !1;
    },
    d: function (e) {
      e && Et(n), v[t].d(), c = !1, u();
    }
  };
}
function tf(e) {
  for (var n, t, o, r = Ao(e[1]), i = [], a = 0; a < r.length; a += 1) i[a] = nf(Zd(e, r, a));
  var l = function (e) {
    return Po(i[e], 1, 1, function () {
      i[e] = null;
    });
  };
  return {
    c: function () {
      n = Pt("div"), t = Pt("div");
      for (var e = 0; e < i.length; e += 1) i[e].c();
      Ut(t, "class", "jse-select-query-language-container svelte-1wg043c"), Ut(n, "class", "jse-select-query-language svelte-1wg043c");
    },
    m: function (e, r) {
      Rt(e, n, r), Ct(n, t);
      for (var a = 0; a < i.length; a += 1) i[a] && i[a].m(t, null);
      o = !0;
    },
    p: function (e, n) {
      var o = s(n, 1)[0];
      if (7 & o) {
        var a;
        for (r = Ao(e[1]), a = 0; a < r.length; a += 1) {
          var c = Zd(e, r, a);
          i[a] ? (i[a].p(c, o), qo(i[a], 1)) : (i[a] = nf(c), i[a].c(), qo(i[a], 1), i[a].m(t, null));
        }
        for (Ro(), a = r.length; a < i.length; a += 1) l(a);
        Eo();
      }
    },
    i: function (e) {
      if (!o) {
        for (var n = 0; n < r.length; n += 1) qo(i[n]);
        o = !0;
      }
    },
    o: function (e) {
      i = i.filter(Boolean);
      for (var n = 0; n < i.length; n += 1) Po(i[n]);
      o = !1;
    },
    d: function (e) {
      e && Et(n), qt(i, e);
    }
  };
}
function of(e, n, t) {
  var o = n.queryLanguages,
    r = n.queryLanguageId,
    i = n.onChangeQueryLanguage;
  function a(e) {
    t(0, r = e), i(e);
  }
  return e.$$set = function (e) {
    "queryLanguages" in e && t(1, o = e.queryLanguages), "queryLanguageId" in e && t(0, r = e.queryLanguageId), "onChangeQueryLanguage" in e && t(3, i = e.onChangeQueryLanguage);
  }, [r, o, a, i, function (e) {
    return a(e.id);
  }];
}
var rf = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, of, tf, lt, {
      queryLanguages: 1,
      queryLanguageId: 0,
      onChangeQueryLanguage: 3
    }, Kd), t;
  }
  return v(n, Wo), b(n);
}();
function af(e) {
  St(e, "svelte-1n68mbh", ".jse-header.svelte-1n68mbh.svelte-1n68mbh{display:flex;background:var(--jse-theme-color, #3883fa);color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff))}.jse-header.svelte-1n68mbh .jse-title.svelte-1n68mbh{flex:1;padding:5px;vertical-align:middle}.jse-header.svelte-1n68mbh button.svelte-1n68mbh{border:none;background:transparent;min-width:32px;color:inherit;cursor:pointer}.jse-header.svelte-1n68mbh button.svelte-1n68mbh:hover{background:rgba(255, 255, 255, 0.1)}");
}
var sf = function (e) {
    return {};
  },
  lf = function (e) {
    return {};
  };
function cf(e) {
  var n, t, o, r, i;
  return t = new Ya({
    props: {
      data: e[0] ? be : ye
    }
  }), {
    c: function () {
      n = Pt("button"), Jo(t.$$.fragment), Ut(n, "type", "button"), Ut(n, "class", "jse-fullscreen svelte-1n68mbh"), Ut(n, "title", "Toggle full screen");
    },
    m: function (a, s) {
      Rt(a, n, s), Vo(t, n, null), o = !0, r || (i = Bt(n, "click", e[7]), r = !0);
    },
    p: function (e, n) {
      var o = {};
      1 & n && (o.data = e[0] ? be : ye), t.$set(o);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), r = !1, i();
    }
  };
}
function uf(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    l,
    c,
    u,
    d,
    f,
    v = e[6].actions,
    p = ut(v, e, e[5], lf),
    m = e[2] && cf(e);
  return c = new Ya({
    props: {
      data: je
    }
  }), {
    c: function () {
      n = Pt("div"), t = Pt("div"), o = Tt(e[1]), r = At(), p && p.c(), i = At(), m && m.c(), a = At(), l = Pt("button"), Jo(c.$$.fragment), Ut(t, "class", "jse-title svelte-1n68mbh"), Ut(l, "type", "button"), Ut(l, "class", "jse-close svelte-1n68mbh"), Ut(n, "class", "jse-header svelte-1n68mbh");
    },
    m: function (s, v) {
      Rt(s, n, v), Ct(n, t), Ct(t, o), Ct(n, r), p && p.m(n, null), Ct(n, i), m && m.m(n, null), Ct(n, a), Ct(n, l), Vo(c, l, null), u = !0, d || (f = Bt(l, "click", e[8]), d = !0);
    },
    p: function (e, t) {
      var r = s(t, 1)[0];
      (!u || 2 & r) && Ht(o, e[1]), p && p.p && (!u || 32 & r) && vt(p, v, e, e[5], u ? ft(v, e[5], r, sf) : pt(e[5]), lf), e[2] ? m ? (m.p(e, r), 4 & r && qo(m, 1)) : ((m = cf(e)).c(), qo(m, 1), m.m(n, a)) : m && (Ro(), Po(m, 1, 1, function () {
        m = null;
      }), Eo());
    },
    i: function (e) {
      u || (qo(p, e), qo(m), qo(c.$$.fragment, e), u = !0);
    },
    o: function (e) {
      Po(p, e), Po(m), Po(c.$$.fragment, e), u = !1;
    },
    d: function (e) {
      e && Et(n), p && p.d(e), m && m.d(), Ho(c), d = !1, f();
    }
  };
}
function df(e, n, t) {
  var o = n.$$slots,
    r = void 0 === o ? {} : o,
    i = n.$$scope,
    a = n.title,
    s = void 0 === a ? "Modal" : a,
    l = n.fullScreenButton,
    c = void 0 !== l && l,
    u = n.fullscreen,
    d = void 0 !== u && u,
    f = n.onClose,
    v = void 0 === f ? void 0 : f,
    p = co("simple-modal").close;
  return e.$$set = function (e) {
    "title" in e && t(1, s = e.title), "fullScreenButton" in e && t(2, c = e.fullScreenButton), "fullscreen" in e && t(0, d = e.fullscreen), "onClose" in e && t(3, v = e.onClose), "$$scope" in e && t(5, i = e.$$scope);
  }, [d, s, c, v, p, i, r, function () {
    return t(0, d = !d);
  }, function () {
    v ? v() : p();
  }];
}
var ff = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, df, uf, ct, {
      title: 1,
      fullScreenButton: 2,
      fullscreen: 0,
      onClose: 3
    }, af), t;
  }
  return v(n, Wo), b(n);
}();
function vf(e) {
  St(e, "svelte-zdpca7", ".jse-config.svelte-zdpca7{border:none;background:transparent;min-width:32px;color:inherit;cursor:pointer}.jse-config.svelte-zdpca7:hover{background:rgba(255, 255, 255, 0.1)}.jse-config.hide.svelte-zdpca7{display:none}");
}
function pf(e) {
  var n, t, o, r, i;
  return t = new Ya({
    props: {
      data: xe
    }
  }), {
    c: function () {
      n = Pt("button"), Jo(t.$$.fragment), Ut(n, "slot", "actions"), Ut(n, "type", "button"), Ut(n, "class", "jse-config svelte-zdpca7"), Ut(n, "title", "Select a query language"), Yt(n, "hide", e[1].length <= 1);
    },
    m: function (a, s) {
      Rt(a, n, s), Vo(t, n, null), e[7](n), o = !0, r || (i = Bt(n, "click", e[4]), r = !0);
    },
    p: function (e, t) {
      (!o || 2 & t) && Yt(n, "hide", e[1].length <= 1);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (o) {
      o && Et(n), Ho(t), e[7](null), r = !1, i();
    }
  };
}
function mf(e) {
  var n, t, o;
  function r(n) {
    e[8](n);
  }
  var i = {
    title: "Transform",
    fullScreenButton: !0,
    onClose: e[3],
    $$slots: {
      actions: [pf]
    },
    $$scope: {
      ctx: e
    }
  };
  return void 0 !== e[0] && (i.fullscreen = e[0]), n = new ff({
    props: i
  }), vo.push(function () {
    return Do(n, "fullscreen", r);
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, t) {
      Vo(n, e, t), o = !0;
    },
    p: function (e, o) {
      var r = s(o, 1)[0],
        i = {};
      4102 & r && (i.$$scope = {
        dirty: r,
        ctx: e
      }), !t && 1 & r && (t = !0, i.fullscreen = e[0], xo(function () {
        return t = !1;
      })), n.$set(i);
    },
    i: function (e) {
      o || (qo(n.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), o = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function gf(e, n, t) {
  var o,
    r,
    i = n.queryLanguages,
    a = n.queryLanguageId,
    s = n.onChangeQueryLanguage,
    l = n.fullscreen,
    c = co("simple-modal").close,
    u = co("absolute-popup"),
    d = u.openAbsolutePopup,
    f = u.closeAbsolutePopup;
  return e.$$set = function (e) {
    "queryLanguages" in e && t(1, i = e.queryLanguages), "queryLanguageId" in e && t(5, a = e.queryLanguageId), "onChangeQueryLanguage" in e && t(6, s = e.onChangeQueryLanguage), "fullscreen" in e && t(0, l = e.fullscreen);
  }, [l, i, o, c, function () {
    var e = {
      queryLanguages: i,
      queryLanguageId: a,
      onChangeQueryLanguage: function (e) {
        f(r), s(e);
      }
    };
    r = d(rf, e, {
      offsetTop: -2,
      offsetLeft: 0,
      anchor: o,
      closeOnOuterClick: !0
    });
  }, a, s, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(2, o = e);
    });
  }, function (e) {
    t(0, l = e);
  }];
}
var hf = function (e) {
    function n(e) {
      var t;
      return h(this, n), _o(t = u(this, n), e, gf, mf, ct, {
        queryLanguages: 1,
        queryLanguageId: 5,
        onChangeQueryLanguage: 6,
        fullscreen: 0
      }, vf), t;
    }
    return v(n, Wo), b(n);
  }(),
  jf = Qo("jsoneditor:AutoScrollHandler");
var bf = function (e, n, t, o) {
    return (e /= o / 2) < 1 ? t / 2 * e * e + n : -t / 2 * (--e * (e - 2) - 1) + n;
  },
  yf = function () {
    var e, n, t, o, r, i, a, s, l, c, u, d, f;
    function v(n) {
      return n.getBoundingClientRect().top - (e.getBoundingClientRect ? e.getBoundingClientRect().top : 0) + t;
    }
    function p(n) {
      e.scrollTo ? e.scrollTo(e.scrollLeft, n) : e.scrollTop = n;
    }
    function m(e) {
      c || (c = e), p(i(u = e - c, t, s, l)), f = !0, u < l ? requestAnimationFrame(m) : function () {
        if (p(t + s), n && a) {
          n.setAttribute("tabindex", "-1"), n.focus();
        }
        "function" == typeof d && d();
        c = 0, f = !1;
      }();
    }
    return function (u) {
      var p = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      switch (l = 1e3, r = p.offset || 0, d = p.callback, i = p.easing || bf, a = p.a11y || !1, S(p.container)) {
        case "object":
          e = p.container;
          break;
        case "string":
          e = document.querySelector(p.container);
          break;
        default:
          e = window.document.documentElement;
      }
      switch (t = e.scrollTop, S(u)) {
        case "number":
          n = void 0, a = !1, o = t + u;
          break;
        case "object":
          o = v(n = u);
          break;
        case "string":
          n = document.querySelector(u), o = v(n);
      }
      switch (s = o - t + r, S(p.duration)) {
        case "number":
          l = p.duration;
          break;
        case "function":
          l = p.duration(s);
      }
      f ? c = 0 : requestAnimationFrame(m);
    };
  },
  xf = 1e3,
  wf = Qo("jsoneditor:History");
function $f() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    n = e.maxItems || xf,
    t = [],
    o = 0;
  function r() {
    return o < t.length;
  }
  function i() {
    return o > 0;
  }
  function a() {
    return {
      canUndo: r(),
      canRedo: i(),
      length: t.length
    };
  }
  function s() {
    e.onChange && e.onChange(a());
  }
  return {
    add: function (e) {
      wf("add", e), t = [e].concat(t.slice(o)).slice(0, n), o = 0, s();
    },
    clear: function () {
      wf("clear"), t = [], o = 0, s();
    },
    getState: a,
    undo: function () {
      if (r()) {
        var e = t[o];
        return o += 1, wf("undo", e), s(), e;
      }
    },
    redo: function () {
      if (i()) return wf("redo", t[o -= 1]), s(), t[o];
    }
  };
}
function kf(e, n) {
  var t = Date.now(),
    o = e();
  return n(Date.now() - t), o;
}
var Cf = Qo("validation");
function Sf(e, n, t, o) {
  if (Cf("validateJSON"), !n) return [];
  if (t !== o) {
    var r = t.stringify(e);
    return n(void 0 !== r ? o.parse(r) : void 0);
  }
  return n(e);
}
function Mf(e, n, t, o) {
  if (Cf("validateText"), e.length > kr) return {
    validationErrors: [{
      path: [],
      message: "Validation turned off: the document is too large",
      severity: ur.info
    }]
  };
  if (0 === e.length) return null;
  try {
    var r = kf(function () {
      return t.parse(e);
    }, function (e) {
      return Cf("validate: parsed json in ".concat(e, " ms"));
    });
    if (!n) return null;
    var i = t === o ? r : kf(function () {
        return o.parse(e);
      }, function (e) {
        return Cf("validate: parsed json with the validationParser in ".concat(e, " ms"));
      }),
      a = kf(function () {
        return n(i);
      }, function (e) {
        return Cf("validate: validated json in ".concat(e, " ms"));
      });
    return G(a) ? null : {
      validationErrors: a
    };
  } catch (n) {
    var s = kf(function () {
      return function (e, n) {
        if (e.length > Cr) return !1;
        try {
          return n.parse(_(e)), !0;
        } catch (e) {
          return !1;
        }
      }(e, t);
    }, function (e) {
      return Cf("validate: checked whether repairable in ".concat(e, " ms"));
    });
    return {
      parseError: ji(e, n.message || n.toString()),
      isRepairable: s
    };
  }
}
var Of = Qo("jsoneditor:FocusTracker");
function zf(e) {
  var n,
    t = e.onMount,
    o = e.onDestroy,
    r = e.getWindow,
    i = e.hasFocus,
    a = e.onFocus,
    s = e.onBlur,
    l = !1;
  function c() {
    var e = i();
    e && (clearTimeout(n), l || (Of("focus"), a(), l = e));
  }
  function u() {
    l && (clearTimeout(n), n = setTimeout(function () {
      i() || (Of("blur"), l = !1, s());
    }));
  }
  t(function () {
    Of("mount FocusTracker");
    var e = r();
    e && (e.addEventListener("focusin", c, !0), e.addEventListener("focusout", u, !0));
  }), o(function () {
    Of("destroy FocusTracker");
    var e = r();
    e && (e.removeEventListener("focusin", c, !0), e.removeEventListener("focusout", u, !0));
  });
}
function Rf(e) {
  St(e, "svelte-p1zf9f", '.jse-message.svelte-p1zf9f.svelte-p1zf9f{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);padding:var(--jse-padding, 10px);display:flex;gap:var(--jse-padding, 10px);flex-wrap:wrap;align-items:stretch}.jse-message.jse-success.svelte-p1zf9f.svelte-p1zf9f{background:var(--message-success-background, #9ac45d);color:var(--jse-message-success-color, #fff)}.jse-message.svelte-p1zf9f .jse-text.svelte-p1zf9f{display:flex;flex:1;min-width:60%;align-items:center}.jse-message.svelte-p1zf9f .jse-text.jse-clickable.svelte-p1zf9f{cursor:pointer}.jse-message.svelte-p1zf9f .jse-text.jse-clickable.svelte-p1zf9f:hover{background-color:rgba(255, 255, 255, 0.1)}.jse-message.jse-error.svelte-p1zf9f.svelte-p1zf9f{background:var(--jse-message-error-background, var(--jse-error-color, #ee5341));color:var(--jse-message-error-color, #fff)}.jse-message.jse-warning.svelte-p1zf9f.svelte-p1zf9f{background:var(--jse-message-warning-background, #ffde5c);color:var(--jse-message-warning-color, #4d4d4d)}.jse-message.jse-info.svelte-p1zf9f.svelte-p1zf9f{background:var(--jse-message-info-background, #4f91ff);color:var(--jse-message-info-color, #fff)}.jse-message.svelte-p1zf9f .jse-actions.svelte-p1zf9f{display:flex;gap:var(--jse-padding, 10px)}.jse-message.svelte-p1zf9f .jse-actions button.jse-action.svelte-p1zf9f{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-message-action-background, rgba(255, 255, 255, 0.2));color:inherit;padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px)}.jse-message.svelte-p1zf9f .jse-actions button.jse-action.svelte-p1zf9f:hover{background:var(--jse-message-action-background-highlight, rgba(255, 255, 255, 0.3))}');
}
function Ef(e, n, t) {
  var o = e.slice();
  return o[9] = n[t], o;
}
function qf(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: e[1]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      2 & t && (o.data = e[1]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Pf(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: e[9].icon
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      8 & t && (o.data = e[9].icon), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function If(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u = e[9].text + "",
    d = e[9].icon && Pf(e);
  function f() {
    return e[7](e[9]);
  }
  function v() {
    return e[8](e[9]);
  }
  return {
    c: function () {
      n = Pt("button"), d && d.c(), t = At(), o = Tt(u), r = At(), Ut(n, "type", "button"), Ut(n, "class", "jse-button jse-action jse-primary svelte-p1zf9f"), Ut(n, "title", i = e[9].title), n.disabled = a = e[9].disabled;
    },
    m: function (e, i) {
      Rt(e, n, i), d && d.m(n, null), Ct(n, t), Ct(n, o), Ct(n, r), s = !0, l || (c = [Bt(n, "click", f), Bt(n, "mousedown", v)], l = !0);
    },
    p: function (r, l) {
      (e = r)[9].icon ? d ? (d.p(e, l), 8 & l && qo(d, 1)) : ((d = Pf(e)).c(), qo(d, 1), d.m(n, t)) : d && (Ro(), Po(d, 1, 1, function () {
        d = null;
      }), Eo()), (!s || 8 & l) && u !== (u = e[9].text + "") && Ht(o, u), (!s || 8 & l && i !== (i = e[9].title)) && Ut(n, "title", i), (!s || 8 & l && a !== (a = e[9].disabled)) && (n.disabled = a);
    },
    i: function (e) {
      s || (qo(d), s = !0);
    },
    o: function (e) {
      Po(d), s = !1;
    },
    d: function (e) {
      e && Et(n), d && d.d(), l = !1, at(c);
    }
  };
}
function Tf(e) {
  for (var n, t, o, r, i, a, l, c, u, d, f, v = e[1] && qf(e), p = Ao(e[3]), m = [], g = 0; g < p.length; g += 1) m[g] = If(Ef(e, p, g));
  var h = function (e) {
    return Po(m[e], 1, 1, function () {
      m[e] = null;
    });
  };
  return {
    c: function () {
      n = Pt("div"), t = Pt("div"), o = Pt("div"), v && v.c(), r = At(), i = Tt(e[2]), a = At(), l = Pt("div");
      for (var s = 0; s < m.length; s += 1) m[s].c();
      Ut(o, "class", "jse-text-centered"), Ut(t, "role", "button"), Ut(t, "tabindex", "-1"), Ut(t, "class", "jse-text svelte-p1zf9f"), Yt(t, "jse-clickable", !!e[4]), Ut(l, "class", "jse-actions svelte-p1zf9f"), Ut(n, "class", c = "jse-message jse-" + e[0] + " svelte-p1zf9f");
    },
    m: function (s, c) {
      Rt(s, n, c), Ct(n, t), Ct(t, o), v && v.m(o, null), Ct(o, r), Ct(o, i), Ct(n, a), Ct(n, l);
      for (var p = 0; p < m.length; p += 1) m[p] && m[p].m(l, null);
      u = !0, d || (f = Bt(t, "click", e[5]), d = !0);
    },
    p: function (e, a) {
      var d = s(a, 1)[0];
      if (e[1] ? v ? (v.p(e, d), 2 & d && qo(v, 1)) : ((v = qf(e)).c(), qo(v, 1), v.m(o, r)) : v && (Ro(), Po(v, 1, 1, function () {
        v = null;
      }), Eo()), (!u || 4 & d) && Ht(i, e[2]), (!u || 16 & d) && Yt(t, "jse-clickable", !!e[4]), 8 & d) {
        var f;
        for (p = Ao(e[3]), f = 0; f < p.length; f += 1) {
          var g = Ef(e, p, f);
          m[f] ? (m[f].p(g, d), qo(m[f], 1)) : (m[f] = If(g), m[f].c(), qo(m[f], 1), m[f].m(l, null));
        }
        for (Ro(), f = p.length; f < m.length; f += 1) h(f);
        Eo();
      }
      (!u || 1 & d && c !== (c = "jse-message jse-" + e[0] + " svelte-p1zf9f")) && Ut(n, "class", c);
    },
    i: function (e) {
      if (!u) {
        qo(v);
        for (var n = 0; n < p.length; n += 1) qo(m[n]);
        u = !0;
      }
    },
    o: function (e) {
      Po(v), m = m.filter(Boolean);
      for (var n = 0; n < m.length; n += 1) Po(m[n]);
      u = !1;
    },
    d: function (e) {
      e && Et(n), v && v.d(), qt(m, e), d = !1, f();
    }
  };
}
function Af(e, n, t) {
  var o = n.type,
    r = void 0 === o ? "success" : o,
    i = n.icon,
    a = void 0 === i ? void 0 : i,
    s = n.message,
    l = void 0 === s ? void 0 : s,
    c = n.actions,
    u = void 0 === c ? [] : c,
    d = n.onClick,
    f = void 0 === d ? void 0 : d,
    v = n.onClose,
    p = void 0 === v ? void 0 : v;
  p && ao(p);
  return e.$$set = function (e) {
    "type" in e && t(0, r = e.type), "icon" in e && t(1, a = e.icon), "message" in e && t(2, l = e.message), "actions" in e && t(3, u = e.actions), "onClick" in e && t(4, f = e.onClick), "onClose" in e && t(6, p = e.onClose);
  }, [r, a, l, u, f, function () {
    f && f();
  }, p, function (e) {
    e.onClick && e.onClick();
  }, function (e) {
    e.onMouseDown && e.onMouseDown();
  }];
}
var Nf = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Af, Tf, ct, {
      type: 0,
      icon: 1,
      message: 2,
      actions: 3,
      onClick: 4,
      onClose: 6
    }, Rf), t;
  }
  return v(n, Wo), b(n);
}();
function Bf(e) {
  St(e, "svelte-1gq3gfv", '.jse-validation-errors-overview.svelte-1gq3gfv.svelte-1gq3gfv{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);overflow:auto;max-height:25%}.jse-validation-errors-overview.svelte-1gq3gfv table.svelte-1gq3gfv{border-collapse:collapse;width:100%}.jse-validation-errors-overview.svelte-1gq3gfv table tr.svelte-1gq3gfv{cursor:pointer}.jse-validation-errors-overview.svelte-1gq3gfv table tr.jse-validation-error.svelte-1gq3gfv{background:var(--jse-message-error-background, var(--jse-error-color, #ee5341));color:var(--jse-message-error-color, #fff)}.jse-validation-errors-overview.svelte-1gq3gfv table tr.jse-validation-warning.svelte-1gq3gfv{background:var(--jse-message-warning-background, #ffde5c);color:var(--jse-message-warning-color, #4d4d4d)}.jse-validation-errors-overview.svelte-1gq3gfv table tr.jse-validation-warning.svelte-1gq3gfv:hover{filter:brightness(105%)}.jse-validation-errors-overview.svelte-1gq3gfv table tr.jse-validation-info.svelte-1gq3gfv{background:var(--jse-message-info-background, #4f91ff);color:var(--jse-message-info-color, #fff)}.jse-validation-errors-overview.svelte-1gq3gfv table tr.svelte-1gq3gfv:hover{filter:brightness(110%)}.jse-validation-errors-overview.svelte-1gq3gfv table tr td.svelte-1gq3gfv{padding:4px var(--jse-padding, 10px);vertical-align:middle}.jse-validation-errors-overview.svelte-1gq3gfv table tr td.jse-validation-error-icon.svelte-1gq3gfv{width:36px;box-sizing:border-box}.jse-validation-errors-overview.svelte-1gq3gfv table tr td.jse-validation-error-action.svelte-1gq3gfv{width:36px;box-sizing:border-box;padding:0}.jse-validation-errors-overview.svelte-1gq3gfv table tr td.jse-validation-error-action button.jse-validation-errors-collapse.svelte-1gq3gfv{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;width:36px;height:26px;cursor:pointer}.jse-validation-errors-overview.svelte-1gq3gfv table tr td.jse-validation-error-action button.jse-validation-errors-collapse.svelte-1gq3gfv:hover{background-color:rgba(255, 255, 255, 0.2)}.jse-validation-errors-overview.svelte-1gq3gfv table tr td div.jse-validation-errors-expand.svelte-1gq3gfv{display:inline-block;position:relative;top:3px}');
}
function Ff(e, n, t) {
  var o = e.slice();
  return o[8] = n[t], o[10] = t, o;
}
function Lf(e) {
  var n,
    t,
    o,
    r,
    i = [Df, Uf],
    a = [];
  function s(e, n) {
    return e[2] || 1 === e[3] ? 0 : 1;
  }
  return t = s(e), o = a[t] = i[t](e), {
    c: function () {
      n = Pt("div"), o.c(), Ut(n, "class", "jse-validation-errors-overview svelte-1gq3gfv");
    },
    m: function (e, o) {
      Rt(e, n, o), a[t].m(n, null), r = !0;
    },
    p: function (e, r) {
      var l = t;
      (t = s(e)) === l ? a[t].p(e, r) : (Ro(), Po(a[l], 1, 1, function () {
        a[l] = null;
      }), Eo(), (o = a[t]) ? o.p(e, r) : (o = a[t] = i[t](e)).c(), qo(o, 1), o.m(n, null));
    },
    i: function (e) {
      r || (qo(o), r = !0);
    },
    o: function (e) {
      Po(o), r = !1;
    },
    d: function (e) {
      e && Et(n), a[t].d();
    }
  };
}
function Uf(e) {
  var n, t, o, r, i, a, s, l, c, u, d, f, v, p, m;
  return i = new Ya({
    props: {
      data: we
    }
  }), d = new Ya({
    props: {
      data: $e
    }
  }), {
    c: function () {
      n = Pt("table"), t = Pt("tbody"), o = Pt("tr"), r = Pt("td"), Jo(i.$$.fragment), a = At(), s = Pt("td"), l = Tt(e[3]), c = Tt(" validation errors\n              "), u = Pt("div"), Jo(d.$$.fragment), Ut(r, "class", "jse-validation-error-icon svelte-1gq3gfv"), Ut(u, "class", "jse-validation-errors-expand svelte-1gq3gfv"), Ut(s, "class", "jse-validation-error-count svelte-1gq3gfv"), Ut(o, "class", f = "jse-validation-" + e[6](e[0]) + " svelte-1gq3gfv"), Ut(n, "class", "jse-validation-errors-overview-collapsed svelte-1gq3gfv");
    },
    m: function (f, g) {
      Rt(f, n, g), Ct(n, t), Ct(t, o), Ct(o, r), Vo(i, r, null), Ct(o, a), Ct(o, s), Ct(s, l), Ct(s, c), Ct(s, u), Vo(d, u, null), v = !0, p || (m = Bt(o, "click", e[5]), p = !0);
    },
    p: function (e, n) {
      (!v || 8 & n) && Ht(l, e[3]), (!v || 1 & n && f !== (f = "jse-validation-" + e[6](e[0]) + " svelte-1gq3gfv")) && Ut(o, "class", f);
    },
    i: function (e) {
      v || (qo(i.$$.fragment, e), qo(d.$$.fragment, e), v = !0);
    },
    o: function (e) {
      Po(i.$$.fragment, e), Po(d.$$.fragment, e), v = !1;
    },
    d: function (e) {
      e && Et(n), Ho(i), Ho(d), p = !1, m();
    }
  };
}
function Df(e) {
  for (var n, t, o, r, i = Ao(ci(e[0], xr)), a = [], s = 0; s < i.length; s += 1) a[s] = Vf(Ff(e, i, s));
  var l = function (e) {
      return Po(a[e], 1, 1, function () {
        a[e] = null;
      });
    },
    c = e[3] > xr && Hf(e);
  return {
    c: function () {
      n = Pt("table"), t = Pt("tbody");
      for (var e = 0; e < a.length; e += 1) a[e].c();
      o = At(), c && c.c(), Ut(n, "class", "jse-validation-errors-overview-expanded svelte-1gq3gfv");
    },
    m: function (e, i) {
      Rt(e, n, i), Ct(n, t);
      for (var s = 0; s < a.length; s += 1) a[s] && a[s].m(t, null);
      Ct(t, o), c && c.m(t, null), r = !0;
    },
    p: function (e, n) {
      if (19 & n) {
        var r;
        for (i = Ao(ci(e[0], xr)), r = 0; r < i.length; r += 1) {
          var s = Ff(e, i, r);
          a[r] ? (a[r].p(s, n), qo(a[r], 1)) : (a[r] = Vf(s), a[r].c(), qo(a[r], 1), a[r].m(t, o));
        }
        for (Ro(), r = i.length; r < a.length; r += 1) l(r);
        Eo();
      }
      e[3] > xr ? c ? c.p(e, n) : ((c = Hf(e)).c(), c.m(t, null)) : c && (c.d(1), c = null);
    },
    i: function (e) {
      if (!r) {
        for (var n = 0; n < i.length; n += 1) qo(a[n]);
        r = !0;
      }
    },
    o: function (e) {
      a = a.filter(Boolean);
      for (var n = 0; n < a.length; n += 1) Po(a[n]);
      r = !1;
    },
    d: function (e) {
      e && Et(n), qt(a, e), c && c.d();
    }
  };
}
function Jf(e) {
  var n, t, o, r, i;
  return t = new Ya({
    props: {
      data: ke
    }
  }), {
    c: function () {
      n = Pt("button"), Jo(t.$$.fragment), Ut(n, "type", "button"), Ut(n, "class", "jse-validation-errors-collapse svelte-1gq3gfv"), Ut(n, "title", "Collapse validation errors");
    },
    m: function (a, s) {
      Rt(a, n, s), Vo(t, n, null), o = !0, r || (i = Bt(n, "click", Lt(e[4])), r = !0);
    },
    p: nt,
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), r = !1, i();
    }
  };
}
function Vf(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f,
    v,
    p,
    m,
    g = $a(e[8].path) + "",
    h = e[8].message + "";
  o = new Ya({
    props: {
      data: we
    }
  });
  var j = 0 === e[10] && e[0].length > 1 && Jf(e);
  function b() {
    return e[7](e[8]);
  }
  return {
    c: function () {
      n = Pt("tr"), t = Pt("td"), Jo(o.$$.fragment), r = At(), i = Pt("td"), a = Tt(g), s = At(), l = Pt("td"), c = Tt(h), u = At(), d = Pt("td"), j && j.c(), Ut(t, "class", "jse-validation-error-icon svelte-1gq3gfv"), Ut(i, "class", "jse-validation-error-path svelte-1gq3gfv"), Ut(l, "class", "jse-validation-error-message svelte-1gq3gfv"), Ut(d, "class", "jse-validation-error-action svelte-1gq3gfv"), Ut(n, "class", f = "jse-validation-" + e[8].severity + " svelte-1gq3gfv");
    },
    m: function (e, f) {
      Rt(e, n, f), Ct(n, t), Vo(o, t, null), Ct(n, r), Ct(n, i), Ct(i, a), Ct(n, s), Ct(n, l), Ct(l, c), Ct(n, u), Ct(n, d), j && j.m(d, null), v = !0, p || (m = Bt(n, "click", b), p = !0);
    },
    p: function (t, o) {
      e = t, (!v || 1 & o) && g !== (g = $a(e[8].path) + "") && Ht(a, g), (!v || 1 & o) && h !== (h = e[8].message + "") && Ht(c, h), 0 === e[10] && e[0].length > 1 ? j ? (j.p(e, o), 1 & o && qo(j, 1)) : ((j = Jf(e)).c(), qo(j, 1), j.m(d, null)) : j && (Ro(), Po(j, 1, 1, function () {
        j = null;
      }), Eo()), (!v || 1 & o && f !== (f = "jse-validation-" + e[8].severity + " svelte-1gq3gfv")) && Ut(n, "class", f);
    },
    i: function (e) {
      v || (qo(o.$$.fragment, e), qo(j), v = !0);
    },
    o: function (e) {
      Po(o.$$.fragment, e), Po(j), v = !1;
    },
    d: function (e) {
      e && Et(n), Ho(o), j && j.d(), p = !1, m();
    }
  };
}
function Hf(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f = e[3] - xr + "";
  return {
    c: function () {
      n = Pt("tr"), t = Pt("td"), o = At(), r = Pt("td"), i = At(), a = Pt("td"), s = Tt("(and "), l = Tt(f), c = Tt(" more errors)"), u = At(), d = Pt("td"), Ut(t, "class", "svelte-1gq3gfv"), Ut(r, "class", "svelte-1gq3gfv"), Ut(a, "class", "svelte-1gq3gfv"), Ut(d, "class", "svelte-1gq3gfv"), Ut(n, "class", "jse-validation-error svelte-1gq3gfv");
    },
    m: function (e, f) {
      Rt(e, n, f), Ct(n, t), Ct(n, o), Ct(n, r), Ct(n, i), Ct(n, a), Ct(a, s), Ct(a, l), Ct(a, c), Ct(n, u), Ct(n, d);
    },
    p: function (e, n) {
      8 & n && f !== (f = e[3] - xr + "") && Ht(l, f);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function _f(e) {
  var n,
    t,
    o = !G(e[0]),
    r = o && Lf(e);
  return {
    c: function () {
      r && r.c(), n = Nt();
    },
    m: function (e, o) {
      r && r.m(e, o), Rt(e, n, o), t = !0;
    },
    p: function (e, t) {
      var i = s(t, 1)[0];
      1 & i && (o = !G(e[0])), o ? r ? (r.p(e, i), 1 & i && qo(r, 1)) : ((r = Lf(e)).c(), qo(r, 1), r.m(n.parentNode, n)) : r && (Ro(), Po(r, 1, 1, function () {
        r = null;
      }), Eo());
    },
    i: function (e) {
      t || (qo(r), t = !0);
    },
    o: function (e) {
      Po(r), t = !1;
    },
    d: function (e) {
      e && Et(n), r && r.d(e);
    }
  };
}
function Wf(e, n, t) {
  var o,
    r = n.validationErrors,
    i = n.selectError,
    a = !0;
  return e.$$set = function (e) {
    "validationErrors" in e && t(0, r = e.validationErrors), "selectError" in e && t(1, i = e.selectError);
  }, e.$$.update = function () {
    1 & e.$$.dirty && t(3, o = r.length);
  }, [r, i, a, o, function () {
    t(2, a = !1);
  }, function () {
    t(2, a = !0);
  }, function (e) {
    return [ur.error, ur.warning, ur.info].find(function (n) {
      return e.some(function (e) {
        return e.severity === n;
      });
    });
  }, function (e) {
    setTimeout(function () {
      return i(e);
    });
  }];
}
var Qf = function (e) {
    function n(e) {
      var t;
      return h(this, n), _o(t = u(this, n), e, Wf, _f, ct, {
        validationErrors: 0,
        selectError: 1
      }, Bf), t;
    }
    return v(n, Wo), b(n);
  }(),
  Yf = [];
function Gf(e) {
  if ("Escape" === e.key) {
    var n = ee(Yf);
    n && n();
  }
}
function Kf(e, n) {
  return G(Yf) && window.addEventListener("keydown", Gf), Yf.push(n), {
    destroy: function () {
      Yf = Yf.filter(function (e) {
        return e !== n;
      }), G(Yf) && window.removeEventListener("keydown", Gf);
    }
  };
}
function Zf(e) {
  St(e, "svelte-1nm0t3v", '.jse-modal.svelte-1nm0t3v.svelte-1nm0t3v{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-1nm0t3v .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-1nm0t3v .jse-modal-contents.svelte-1nm0t3v{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-1nm0t3v .jse-modal-contents .jse-actions.svelte-1nm0t3v{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-1nm0t3v .jse-modal-contents .jse-actions button.jse-primary.svelte-1nm0t3v{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-1nm0t3v .jse-modal-contents .jse-actions button.jse-primary.svelte-1nm0t3v:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-1nm0t3v .jse-modal-contents .jse-actions button.jse-primary.svelte-1nm0t3v:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0;overflow:auto}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;max-height:500px;display:flex}.bg.jse-modal-bg .jse-modal-window:has(div.fullscreen){margin:var(--jse-padding, 10px);padding:0;width:calc(100vw - 2 * var(--jse-padding, 10px));height:calc(100vh - 2 * var(--jse-padding, 10px));max-width:none;max-height:none}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0;max-height:none}.jse-modal.jse-copy-paste.svelte-1nm0t3v .jse-shortcuts.svelte-1nm0t3v{display:flex;flex-wrap:wrap;justify-content:space-around;margin:calc(2 * var(--jse-padding, 10px)) 0}.jse-modal.jse-copy-paste.svelte-1nm0t3v .jse-shortcuts .jse-shortcut .jse-key.svelte-1nm0t3v{font-size:200%;color:var(--jse-theme-color, #3883fa)}');
}
function Xf(e) {
  var n, t, o, r, i, a, s, l, c, u, d, f, v, p, m, g, h, j, b, y, x, w, $, k;
  return t = new ff({
    props: {
      title: "Copying and pasting"
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), o = At(), r = Pt("div"), (i = Pt("div")).textContent = "These actions are unavailable via the menu. Please use:", a = At(), s = Pt("div"), l = Pt("div"), (c = Pt("div")).textContent = "".concat(e[1], "+C"), u = Tt("\n        for copy"), d = At(), f = Pt("div"), (v = Pt("div")).textContent = "".concat(e[1], "+X"), p = Tt("\n        for cut"), m = At(), g = Pt("div"), (h = Pt("div")).textContent = "".concat(e[1], "+V"), j = Tt("\n        for paste"), b = At(), y = Pt("div"), (x = Pt("button")).textContent = "Close", Ut(c, "class", "jse-key svelte-1nm0t3v"), Ut(l, "class", "jse-shortcut"), Ut(v, "class", "jse-key svelte-1nm0t3v"), Ut(f, "class", "jse-shortcut"), Ut(h, "class", "jse-key svelte-1nm0t3v"), Ut(g, "class", "jse-shortcut"), Ut(s, "class", "jse-shortcuts svelte-1nm0t3v"), Ut(x, "type", "button"), Ut(x, "class", "jse-primary svelte-1nm0t3v"), Ut(y, "class", "jse-actions svelte-1nm0t3v"), Ut(r, "class", "jse-modal-contents svelte-1nm0t3v"), Ut(n, "class", "jse-modal jse-copy-paste svelte-1nm0t3v");
    },
    m: function (C, S) {
      Rt(C, n, S), Vo(t, n, null), Ct(n, o), Ct(n, r), Ct(r, i), Ct(r, a), Ct(r, s), Ct(s, l), Ct(l, c), Ct(l, u), Ct(s, d), Ct(s, f), Ct(f, v), Ct(f, p), Ct(s, m), Ct(s, g), Ct(g, h), Ct(g, j), Ct(r, b), Ct(r, y), Ct(y, x), w = !0, $ || (k = [Bt(x, "click", e[2]), jt(Kf.call(null, n, e[3]))], $ = !0);
    },
    p: nt,
    i: function (e) {
      w || (qo(t.$$.fragment, e), w = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), w = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), $ = !1, at(k);
    }
  };
}
function ev(e) {
  var n = co("simple-modal").close,
    t = aa() ? "⌘" : "Ctrl";
  return [n, t, function () {
    return n();
  }, function () {
    return n();
  }];
}
var nv = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, ev, Xf, ct, {}, Zf), t;
  }
  return v(n, Wo), b(n);
}();
function tv(e) {
  return !!e && ("space" === e.type || !0 === e.space);
}
function ov(e) {
  return !!e && ("separator" === e.type || !0 === e.separator);
}
function rv(e) {
  return !!e && "label" === e.type && "string" == typeof e.text;
}
function iv(e) {
  return !!e && "function" == typeof e.onClick;
}
function av(e) {
  return !!e && "dropdown-button" === e.type && iv(e.main) && Array.isArray(e.items);
}
function sv(e) {
  return !!e && "row" === e.type && Array.isArray(e.items);
}
function lv(e) {
  return !!e && "column" === e.type && Array.isArray(e.items);
}
function cv(e) {
  return Qr(e) && Qr(e.parseError);
}
function uv(e) {
  return Qr(e) && Array.isArray(e.validationErrors);
}
function dv(e) {
  return Qr(e) && Array.isArray(e.path) && "string" == typeof e.message && "severity" in e;
}
function fv(e) {
  return Qr(e) && dv(e) && "boolean" == typeof e.isChildError;
}
function vv(e) {
  return Qr(e) && "component" in e && Qr(e.props);
}
function pv(e) {
  return Qr(e) && "function" == typeof e.action && Qr(e.props);
}
function mv(e) {
  St(e, "svelte-7deygj", '.jse-menu.svelte-7deygj.svelte-7deygj{background:var(--jse-theme-color, #3883fa);font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-main-menu, 14px);color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));display:flex;flex-wrap:wrap;align-items:stretch;position:relative}.jse-menu.svelte-7deygj .jse-button.svelte-7deygj{font-family:inherit;font-size:inherit;line-height:1.5em;border:none;background:transparent;color:inherit;cursor:pointer;width:var(--jse-menu-button-size, 32px);height:var(--jse-menu-button-size, 32px);padding:calc(0.5 * var(--jse-padding, 10px));margin:0;border-radius:0;display:inline-flex;align-items:center;text-align:center;justify-content:center}.jse-menu.svelte-7deygj .jse-button.svelte-7deygj:hover,.jse-menu.svelte-7deygj .jse-button.svelte-7deygj:focus{background:var(--jse-theme-color-highlight, #5f9dff)}.jse-menu.svelte-7deygj .jse-button.svelte-7deygj:disabled{color:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));opacity:0.5;background:transparent}.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj{width:auto;height:calc(var(--jse-menu-button-size, 32px) - var(--jse-padding, 10px));margin:calc(0.5 * var(--jse-padding, 10px)) 0;padding:0 calc(0.5 * var(--jse-padding, 10px)) 1px;border:1px solid var(--jse-menu-color, var(--jse-text-color-inverse, #fff))}.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj:not(.jse-last){border-right:none}.jse-menu.svelte-7deygj .jse-button.jse-group-button.jse-first.svelte-7deygj{margin-left:calc(0.5 * var(--jse-padding, 10px))}.jse-menu.svelte-7deygj .jse-button.jse-group-button.jse-last.svelte-7deygj{margin-right:calc(0.5 * var(--jse-padding, 10px))}.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj:hover,.jse-menu.svelte-7deygj .jse-button.jse-group-button.svelte-7deygj:focus{background:var(--jse-theme-color-highlight, #5f9dff)}.jse-menu.svelte-7deygj .jse-button.jse-group-button.jse-selected.svelte-7deygj{background:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));color:var(--jse-theme-color, #3883fa)}.jse-menu.svelte-7deygj .jse-space.svelte-7deygj{flex:1}.jse-menu.svelte-7deygj .jse-separator.svelte-7deygj{background:var(--jse-menu-color, var(--jse-text-color-inverse, #fff));opacity:0.3;width:1px;margin:3px}');
}
var gv = function (e) {
    return {};
  },
  hv = function (e) {
    return {};
  };
function jv(e, n, t) {
  var o = e.slice();
  return o[3] = n[t], o;
}
var bv = function (e) {
    return {};
  },
  yv = function (e) {
    return {};
  };
function xv(e) {
  var n,
    t = zv(e[3]) + "";
  return {
    c: function () {
      n = Tt(t);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, o) {
      1 & o && t !== (t = zv(e[3]) + "") && Ht(n, t);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function wv(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c = e[3].icon && Cv(e),
    u = e[3].text && Sv(e);
  return {
    c: function () {
      n = Pt("button"), c && c.c(), t = At(), u && u.c(), Ut(n, "type", "button"), Ut(n, "class", o = "jse-button " + e[3].className + " svelte-7deygj"), Ut(n, "title", r = e[3].title), n.disabled = i = e[3].disabled || !1;
    },
    m: function (o, r) {
      Rt(o, n, r), c && c.m(n, null), Ct(n, t), u && u.m(n, null), a = !0, s || (l = Bt(n, "click", function () {
        st(e[3].onClick) && e[3].onClick.apply(this, arguments);
      }), s = !0);
    },
    p: function (s, l) {
      (e = s)[3].icon ? c ? (c.p(e, l), 1 & l && qo(c, 1)) : ((c = Cv(e)).c(), qo(c, 1), c.m(n, t)) : c && (Ro(), Po(c, 1, 1, function () {
        c = null;
      }), Eo()), e[3].text ? u ? u.p(e, l) : ((u = Sv(e)).c(), u.m(n, null)) : u && (u.d(1), u = null), (!a || 1 & l && o !== (o = "jse-button " + e[3].className + " svelte-7deygj")) && Ut(n, "class", o), (!a || 1 & l && r !== (r = e[3].title)) && Ut(n, "title", r), (!a || 1 & l && i !== (i = e[3].disabled || !1)) && (n.disabled = i);
    },
    i: function (e) {
      a || (qo(c), a = !0);
    },
    o: function (e) {
      Po(c), a = !1;
    },
    d: function (e) {
      e && Et(n), c && c.d(), u && u.d(), s = !1, l();
    }
  };
}
function $v(e) {
  var n;
  return {
    c: function () {
      Ut(n = Pt("div"), "class", "jse-space svelte-7deygj");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function kv(e) {
  var n;
  return {
    c: function () {
      Ut(n = Pt("div"), "class", "jse-separator svelte-7deygj");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Cv(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: e[3].icon
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.data = e[3].icon), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Sv(e) {
  var n,
    t = e[3].text + "";
  return {
    c: function () {
      n = Tt(t);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, o) {
      1 & o && t !== (t = e[3].text + "") && Ht(n, t);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Mv(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l = [kv, $v, wv, xv],
    c = [];
  function u(e, r) {
    return 1 & r && (n = null), 1 & r && (t = null), 1 & r && (o = null), null == n && (n = !!ov(e[3])), n ? 0 : (null == t && (t = !!tv(e[3])), t ? 1 : (null == o && (o = !!iv(e[3])), o ? 2 : 3));
  }
  return r = u(e, -1), i = c[r] = l[r](e), {
    c: function () {
      i.c(), a = Nt();
    },
    m: function (e, n) {
      c[r].m(e, n), Rt(e, a, n), s = !0;
    },
    p: function (e, n) {
      var t = r;
      (r = u(e, n)) === t ? c[r].p(e, n) : (Ro(), Po(c[t], 1, 1, function () {
        c[t] = null;
      }), Eo(), (i = c[r]) ? i.p(e, n) : (i = c[r] = l[r](e)).c(), qo(i, 1), i.m(a.parentNode, a));
    },
    i: function (e) {
      s || (qo(i), s = !0);
    },
    o: function (e) {
      Po(i), s = !1;
    },
    d: function (e) {
      e && Et(a), c[r].d(e);
    }
  };
}
function Ov(e) {
  for (var n, t, o, r, i = e[2].left, a = ut(i, e, e[1], yv), l = Ao(e[0]), c = [], u = 0; u < l.length; u += 1) c[u] = Mv(jv(e, l, u));
  var d = function (e) {
      return Po(c[e], 1, 1, function () {
        c[e] = null;
      });
    },
    f = e[2].right,
    v = ut(f, e, e[1], hv);
  return {
    c: function () {
      n = Pt("div"), a && a.c(), t = At();
      for (var e = 0; e < c.length; e += 1) c[e].c();
      o = At(), v && v.c(), Ut(n, "class", "jse-menu svelte-7deygj");
    },
    m: function (e, i) {
      Rt(e, n, i), a && a.m(n, null), Ct(n, t);
      for (var s = 0; s < c.length; s += 1) c[s] && c[s].m(n, null);
      Ct(n, o), v && v.m(n, null), r = !0;
    },
    p: function (e, t) {
      var u = s(t, 1)[0];
      if (a && a.p && (!r || 2 & u) && vt(a, i, e, e[1], r ? ft(i, e[1], u, bv) : pt(e[1]), yv), 1 & u) {
        var p;
        for (l = Ao(e[0]), p = 0; p < l.length; p += 1) {
          var m = jv(e, l, p);
          c[p] ? (c[p].p(m, u), qo(c[p], 1)) : (c[p] = Mv(m), c[p].c(), qo(c[p], 1), c[p].m(n, o));
        }
        for (Ro(), p = l.length; p < c.length; p += 1) d(p);
        Eo();
      }
      v && v.p && (!r || 2 & u) && vt(v, f, e, e[1], r ? ft(f, e[1], u, gv) : pt(e[1]), hv);
    },
    i: function (e) {
      if (!r) {
        qo(a, e);
        for (var n = 0; n < l.length; n += 1) qo(c[n]);
        qo(v, e), r = !0;
      }
    },
    o: function (e) {
      Po(a, e), c = c.filter(Boolean);
      for (var n = 0; n < c.length; n += 1) Po(c[n]);
      Po(v, e), r = !1;
    },
    d: function (e) {
      e && Et(n), a && a.d(e), qt(c, e), v && v.d(e);
    }
  };
}
function zv(e) {
  return console.error("Unknown type of menu item", e), "???";
}
function Rv(e, n, t) {
  var o = n.$$slots,
    r = void 0 === o ? {} : o,
    i = n.$$scope,
    a = n.items,
    s = void 0 === a ? [] : a;
  return e.$$set = function (e) {
    "items" in e && t(0, s = e.items), "$$scope" in e && t(1, i = e.$$scope);
  }, [s, i, r];
}
var Ev = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Rv, Ov, ct, {
      items: 0
    }, mv), t;
  }
  return v(n, Wo), b(n);
}();
function qv(e) {
  St(e, "svelte-1d84pok", '.jse-json-repair-component.svelte-1d84pok.svelte-1d84pok{flex:1;display:flex;flex-direction:column;background:var(--jse-background-color, #fff);color:var(--jse-text-color, #4d4d4d)}.jse-json-repair-component.svelte-1d84pok .jse-menu .jse-info.svelte-1d84pok{padding:calc(0.5 * var(--jse-padding, 10px));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);vertical-align:center}.jse-json-repair-component.svelte-1d84pok .jse-json-text.svelte-1d84pok{flex:1;border:none;padding:2px;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);background:var(--jse-input-background, var(--jse-background-color, #fff));color:var(--jse-text-color, #4d4d4d);resize:none;outline:none}');
}
function Pv(e) {
  var n;
  return {
    c: function () {
      (n = Pt("div")).textContent = "Repair invalid JSON, then click apply", Ut(n, "slot", "left"), Ut(n, "class", "jse-info svelte-1d84pok");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Iv(e) {
  var n, t;
  return n = new Nf({
    props: {
      type: "success",
      message: "JSON is valid now and can be parsed.",
      actions: e[5]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      32 & t && (o.actions = e[5]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Tv(e) {
  var n, t;
  return n = new Nf({
    props: {
      type: "error",
      icon: we,
      message: "Cannot parse JSON: ".concat(e[2].message),
      actions: e[6]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      4 & t && (o.message = "Cannot parse JSON: ".concat(e[2].message)), 64 & t && (o.actions = e[6]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Av(e) {
  var n, t, o, r, i, a, l, c, u, d;
  t = new Ev({
    props: {
      items: e[4],
      $$slots: {
        left: [Pv]
      },
      $$scope: {
        ctx: e
      }
    }
  });
  var f = [Tv, Iv],
    v = [];
  function p(e, n) {
    return e[2] ? 0 : 1;
  }
  return r = p(e), i = v[r] = f[r](e), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), o = At(), i.c(), a = At(), (l = Pt("textarea")).readOnly = e[1], Ut(l, "class", "jse-json-text svelte-1d84pok"), Ut(l, "autocomplete", "off"), Ut(l, "autocapitalize", "off"), Ut(l, "spellcheck", "false"), l.value = e[0], Ut(n, "class", "jse-json-repair-component svelte-1d84pok");
    },
    m: function (i, s) {
      Rt(i, n, s), Vo(t, n, null), Ct(n, o), v[r].m(n, null), Ct(n, a), Ct(n, l), e[16](l), c = !0, u || (d = Bt(l, "input", e[7]), u = !0);
    },
    p: function (e, o) {
      var u = s(o, 1)[0],
        d = {};
      16 & u && (d.items = e[4]), 8388608 & u && (d.$$scope = {
        dirty: u,
        ctx: e
      }), t.$set(d);
      var m = r;
      (r = p(e)) === m ? v[r].p(e, u) : (Ro(), Po(v[m], 1, 1, function () {
        v[m] = null;
      }), Eo(), (i = v[r]) ? i.p(e, u) : (i = v[r] = f[r](e)).c(), qo(i, 1), i.m(n, a)), (!c || 2 & u) && (l.readOnly = e[1]), (!c || 1 & u) && (l.value = e[0]);
    },
    i: function (e) {
      c || (qo(t.$$.fragment, e), qo(i), c = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), Po(i), c = !1;
    },
    d: function (o) {
      o && Et(n), Ho(t), v[r].d(), e[16](null), u = !1, d();
    }
  };
}
function Nv(e, n, t) {
  var o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d = n.text,
    f = void 0 === d ? "" : d,
    v = n.readOnly,
    p = void 0 !== v && v,
    m = n.onParse,
    g = n.onRepair,
    h = n.onChange,
    j = void 0 === h ? null : h,
    b = n.onApply,
    y = n.onCancel,
    x = Qo("jsoneditor:JSONRepair");
  function w() {
    b(f);
  }
  return e.$$set = function (e) {
    "text" in e && t(0, f = e.text), "readOnly" in e && t(1, p = e.readOnly), "onParse" in e && t(8, m = e.onParse), "onRepair" in e && t(9, g = e.onRepair), "onChange" in e && t(10, j = e.onChange), "onApply" in e && t(11, b = e.onApply), "onCancel" in e && t(12, y = e.onCancel);
  }, e.$$.update = function () {
    1 & e.$$.dirty && t(2, o = function (e) {
      try {
        return m(e), null;
      } catch (n) {
        return ji(e, n.message);
      }
    }(f)), 1 & e.$$.dirty && t(15, r = function (e) {
      try {
        return g(e), !0;
      } catch (e) {
        return !1;
      }
    }(f)), 4 & e.$$.dirty && x("error", o), 4096 & e.$$.dirty && t(4, u = [{
      type: "space"
    }, {
      type: "button",
      icon: je,
      title: "Cancel repair",
      className: "jse-cancel",
      onClick: y
    }]), 57344 & e.$$.dirty && t(6, s = r ? [i, a] : [i]), 2 & e.$$.dirty && t(5, l = [{
      icon: Ce,
      text: "Apply",
      title: "Apply fixed JSON",
      disabled: p,
      onClick: w
    }]);
  }, t(13, i = {
    icon: Se,
    text: "Show me",
    title: "Scroll to the error location",
    onClick: function () {
      if (c && o) {
        var e = null != o.position ? o.position : 0;
        c.setSelectionRange(e, e), c.focus();
      }
    }
  }), t(14, a = {
    icon: Me,
    text: "Auto repair",
    title: "Automatically repair JSON",
    onClick: function () {
      try {
        t(0, f = g(f)), j && j(f);
      } catch (e) {}
    }
  }), [f, p, o, c, u, l, s, function (e) {
    x("handleChange");
    var n = e.target.value;
    f !== n && (t(0, f = n), j && j(f));
  }, m, g, j, b, y, i, a, r, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(3, c = e);
    });
  }];
}
var Bv = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Nv, Av, ct, {
      text: 0,
      readOnly: 1,
      onParse: 8,
      onRepair: 9,
      onChange: 10,
      onApply: 11,
      onCancel: 12
    }, qv), t;
  }
  return v(n, Wo), b(n);
}();
function Fv(e) {
  St(e, "svelte-rn18r0", '.jse-modal.jse-repair.svelte-rn18r0{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}');
}
function Lv(e) {
  var n, t, o, r, i, a;
  function l(n) {
    e[7](n);
  }
  var c = {
    onParse: e[1],
    onRepair: e[2],
    onApply: e[4],
    onCancel: e[5]
  };
  return void 0 !== e[0] && (c.text = e[0]), t = new Bv({
    props: c
  }), vo.push(function () {
    return Do(t, "text", l);
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "class", "jse-modal jse-repair svelte-rn18r0");
    },
    m: function (o, s) {
      Rt(o, n, s), Vo(t, n, null), r = !0, i || (a = jt(Kf.call(null, n, e[3])), i = !0);
    },
    p: function (e, n) {
      var r = s(n, 1)[0],
        i = {};
      2 & r && (i.onParse = e[1]), 4 & r && (i.onRepair = e[2]), !o && 1 & r && (o = !0, i.text = e[0], xo(function () {
        return o = !1;
      })), t.$set(i);
    },
    i: function (e) {
      r || (qo(t.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), i = !1, a();
    }
  };
}
function Uv(e, n, t) {
  var o = n.text,
    r = n.onParse,
    i = n.onRepair,
    a = n.onApply,
    s = co("simple-modal").close;
  return e.$$set = function (e) {
    "text" in e && t(0, o = e.text), "onParse" in e && t(1, r = e.onParse), "onRepair" in e && t(2, i = e.onRepair), "onApply" in e && t(6, a = e.onApply);
  }, [o, r, i, s, function (e) {
    s(), a(e);
  }, function () {
    s();
  }, a, function (e) {
    t(0, o = e);
  }];
}
var Dv = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Uv, Lv, ct, {
      text: 0,
      onParse: 1,
      onRepair: 2,
      onApply: 6
    }, Fv), t;
  }
  return v(n, Wo), b(n);
}();
function Jv(e) {
  St(e, "svelte-lajpxi", 'div.jse-collapsed-items.svelte-lajpxi.svelte-lajpxi{margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);color:var(--jse-collapsed-items-link-color, rgba(0, 0, 0, 0.38));padding:calc(0.5 * var(--jse-padding, 10px));border:8px solid transparent;border-width:8px 0;background-color:var(--jse-contents-background-color, transparent);background-image:linear-gradient(var(--jse-collapsed-items-background-color, #f5f5f5), var(--jse-collapsed-items-background-color, #f5f5f5)), linear-gradient(to bottom right, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%), linear-gradient(to bottom left, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%), linear-gradient(to top right, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%), linear-gradient(to top left, transparent 50.5%, var(--jse-collapsed-items-background-color, #f5f5f5) 50.5%);background-repeat:repeat, repeat-x, repeat-x, repeat-x, repeat-x;background-position:0 0, 8px 0, 8px 0, 8px 100%, 8px 100%;background-size:auto auto, 16px 16px, 16px 16px, 16px 16px, 16px 16px;background-clip:padding-box, border-box, border-box, border-box, border-box;background-origin:padding-box, border-box, border-box, border-box, border-box;display:flex}div.jse-collapsed-items.svelte-lajpxi div.jse-text.svelte-lajpxi,div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi{margin:0 calc(0.5 * var(--jse-padding, 10px))}div.jse-collapsed-items.svelte-lajpxi div.jse-text.svelte-lajpxi{display:inline}div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi{font-family:inherit;font-size:inherit;color:var(--jse-collapsed-items-link-color, rgba(0, 0, 0, 0.38));background:none;border:none;padding:0;text-decoration:underline;cursor:pointer}div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi:hover,div.jse-collapsed-items.svelte-lajpxi button.jse-expand-items.svelte-lajpxi:focus{color:var(--jse-collapsed-items-link-color-highlight, #ee5341)}');
}
function Vv(e, n, t) {
  var o = e.slice();
  return o[13] = n[t], o;
}
function Hv(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c = e[13].start + "",
    u = e[13].end + "";
  function d() {
    return e[12](e[13]);
  }
  return {
    c: function () {
      n = Pt("button"), t = Tt("show "), o = Tt(c), r = Tt("-"), i = Tt(u), a = At(), Ut(n, "type", "button"), Ut(n, "class", "jse-expand-items svelte-lajpxi");
    },
    m: function (e, c) {
      Rt(e, n, c), Ct(n, t), Ct(n, o), Ct(n, r), Ct(n, i), Ct(n, a), s || (l = Bt(n, "click", d), s = !0);
    },
    p: function (n, t) {
      e = n, 16 & t && c !== (c = e[13].start + "") && Ht(o, c), 16 & t && u !== (u = e[13].end + "") && Ht(i, u);
    },
    d: function (e) {
      e && Et(n), s = !1, l();
    }
  };
}
function _v(e) {
  for (var n, t, o, r, i, a, l, c, u, d, f = Ao(e[4]), v = [], p = 0; p < f.length; p += 1) v[p] = Hv(Vv(e, f, p));
  return {
    c: function () {
      n = Pt("div"), t = Pt("div"), o = Pt("div"), r = Tt("Items "), i = Tt(e[3]), a = Tt("-"), l = Tt(e[2]), c = At();
      for (var s = 0; s < v.length; s += 1) v[s].c();
      Ut(o, "class", "jse-text svelte-lajpxi"), Ut(n, "role", "none"), Ut(n, "class", "jse-collapsed-items svelte-lajpxi"), Yt(n, "jse-selected", e[5]), Wt(n, "--level", e[0].length + 2);
    },
    m: function (e, s) {
      Rt(e, n, s), Ct(n, t), Ct(t, o), Ct(o, r), Ct(o, i), Ct(o, a), Ct(o, l), Ct(t, c);
      for (var f = 0; f < v.length; f += 1) v[f] && v[f].m(t, null);
      u || (d = Bt(n, "mousemove", Wv), u = !0);
    },
    p: function (e, o) {
      var r = s(o, 1)[0];
      if (8 & r && Ht(i, e[3]), 4 & r && Ht(l, e[2]), 19 & r) {
        var a;
        for (f = Ao(e[4]), a = 0; a < f.length; a += 1) {
          var c = Vv(e, f, a);
          v[a] ? v[a].p(c, r) : (v[a] = Hv(c), v[a].c(), v[a].m(t, null));
        }
        for (; a < v.length; a += 1) v[a].d(1);
        v.length = f.length;
      }
      32 & r && Yt(n, "jse-selected", e[5]), 1 & r && Wt(n, "--level", e[0].length + 2);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n), qt(v, e), u = !1, d();
    }
  };
}
function Wv(e) {
  e.stopPropagation();
}
function Qv(e, n, t) {
  var o,
    r,
    i,
    a,
    s,
    l = n.visibleSections,
    c = n.sectionIndex,
    u = n.total,
    d = n.path,
    f = n.selection,
    v = n.onExpandSection,
    p = n.context;
  return e.$$set = function (e) {
    "visibleSections" in e && t(6, l = e.visibleSections), "sectionIndex" in e && t(7, c = e.sectionIndex), "total" in e && t(8, u = e.total), "path" in e && t(0, d = e.path), "selection" in e && t(9, f = e.selection), "onExpandSection" in e && t(1, v = e.onExpandSection), "context" in e && t(10, p = e.context);
  }, e.$$.update = function () {
    192 & e.$$.dirty && t(11, o = l[c]), 2048 & e.$$.dirty && t(3, r = o.end), 448 & e.$$.dirty && t(2, i = l[c + 1] ? l[c + 1].start : u), 1545 & e.$$.dirty && t(5, a = hl(p.getJson(), f, d.concat(String(r)))), 12 & e.$$.dirty && t(4, s = function (e, n) {
      var t = {
          start: e,
          end: Math.min(us(e), n)
        },
        o = Math.max(ds((e + n) / 2), e),
        r = {
          start: o,
          end: Math.min(us(o), n)
        },
        i = ds(n),
        a = i === n ? i - yr : i,
        s = {
          start: Math.max(a, e),
          end: n
        },
        l = [t],
        c = r.start >= t.end && r.end <= s.start;
      return c && l.push(r), s.start >= (c ? r.end : t.end) && l.push(s), l;
    }(r, i));
  }, [d, v, i, r, s, a, l, c, u, f, p, o, function (e) {
    return v(d, e);
  }];
}
var Yv = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Qv, _v, ct, {
      visibleSections: 6,
      sectionIndex: 7,
      total: 8,
      path: 0,
      selection: 9,
      onExpandSection: 1,
      context: 10
    }, Jv), t;
  }
  return v(n, Wo), b(n);
}();
function Gv(e) {
  St(e, "svelte-6k6355", ".jse-context-menu-pointer.svelte-6k6355{position:absolute;top:calc(-0.5 * var(--jse-context-menu-pointer-size, calc(1em + 4px)));right:calc(-0.5 * var(--jse-context-menu-pointer-size, calc(1em + 4px)));width:var(--jse-context-menu-pointer-size, calc(1em + 4px));height:var(--jse-context-menu-pointer-size, calc(1em + 4px));padding:0;margin:0;cursor:pointer;background:transparent;border-radius:2px;background:var(--jse-context-menu-pointer-background, var(--jse-context-menu-background, #656565));color:var(--jse-context-menu-pointer-color, var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff)));border:none;box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}.jse-context-menu-pointer.svelte-6k6355:hover{background:var(--jse-context-menu-pointer-background-highlight, var(--jse-context-menu-background-highlight, #7a7a7a))}");
}
function Kv(e) {
  var n, t, o, r, i;
  return t = new Ya({
    props: {
      data: Oe
    }
  }), {
    c: function () {
      n = Pt("button"), Jo(t.$$.fragment), Ut(n, "type", "button"), Ut(n, "class", "jse-context-menu-pointer svelte-6k6355"), Ut(n, "title", Pr), Yt(n, "jse-selected", e[0]);
    },
    m: function (a, s) {
      Rt(a, n, s), Vo(t, n, null), o = !0, r || (i = Bt(n, "click", e[1]), r = !0);
    },
    p: function (e, t) {
      var r = s(t, 1)[0];
      (!o || 1 & r) && Yt(n, "jse-selected", e[0]);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), r = !1, i();
    }
  };
}
function Zv(e, n, t) {
  var o = n.selected,
    r = n.onContextMenu;
  return e.$$set = function (e) {
    "selected" in e && t(0, o = e.selected), "onContextMenu" in e && t(2, r = e.onContextMenu);
  }, [o, function (e) {
    for (var n = e.target; n && "BUTTON" !== n.nodeName;) n = n.parentNode;
    n && r({
      anchor: n,
      left: 0,
      top: 0,
      width: Lr,
      height: Fr,
      offsetTop: 2,
      offsetLeft: 0,
      showTip: !0
    });
  }, r];
}
var Xv = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Zv, Kv, ct, {
      selected: 0,
      onContextMenu: 2
    }, Gv), t;
  }
  return v(n, Wo), b(n);
}();
function ep(e) {
  St(e, "svelte-10xe8tv", '.jse-key.svelte-10xe8tv{display:inline-block;min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;color:var(--jse-key-color, #1a1a1a);cursor:var(--jse-contents-cursor, pointer);word-break:normal;overflow-wrap:normal;white-space:pre-wrap}.jse-key.svelte-10xe8tv:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-key.svelte-10xe8tv:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-key.jse-empty.svelte-10xe8tv{min-width:3em;outline:1px dotted var(--jse-tag-background, rgba(0, 0, 0, 0.2));-moz-outline-radius:2px}.jse-key.jse-empty.svelte-10xe8tv::after{pointer-events:none;color:var(--jse-tag-background, rgba(0, 0, 0, 0.2));content:"key"}');
}
function np(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l = [rp, op],
    c = [];
  function u(e, n) {
    return e[1] ? 0 : 1;
  }
  return t = u(e), o = c[t] = l[t](e), {
    c: function () {
      n = Pt("div"), o.c(), Ut(n, "role", "none"), Ut(n, "data-type", "selectable-key"), Ut(n, "class", r = ht(e[6](e[0])) + " svelte-10xe8tv");
    },
    m: function (o, r) {
      Rt(o, n, r), c[t].m(n, null), i = !0, a || (s = Bt(n, "dblclick", e[5]), a = !0);
    },
    p: function (e, a) {
      var s = t;
      (t = u(e)) === s ? c[t].p(e, a) : (Ro(), Po(c[s], 1, 1, function () {
        c[s] = null;
      }), Eo(), (o = c[t]) ? o.p(e, a) : (o = c[t] = l[t](e)).c(), qo(o, 1), o.m(n, null)), (!i || 1 & a && r !== (r = ht(e[6](e[0])) + " svelte-10xe8tv")) && Ut(n, "class", r);
    },
    i: function (e) {
      i || (qo(o), i = !0);
    },
    o: function (e) {
      Po(o), i = !1;
    },
    d: function (e) {
      e && Et(n), c[t].d(), a = !1, s();
    }
  };
}
function tp(e) {
  var n, t;
  return n = new Sl({
    props: {
      value: e[2].normalization.escapeValue(e[0]),
      shortText: !0,
      onChange: e[7],
      onCancel: e[8],
      onFind: e[2].onFind
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      5 & t && (o.value = e[2].normalization.escapeValue(e[0])), 4 & t && (o.onFind = e[2].onFind), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function op(e) {
  var n,
    t = Hi(e[2].normalization.escapeValue(e[0])) + "";
  return {
    c: function () {
      n = Tt(t);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, o) {
      5 & o && t !== (t = Hi(e[2].normalization.escapeValue(e[0])) + "") && Ht(n, t);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function rp(e) {
  var n, t;
  return n = new ac({
    props: {
      text: e[2].normalization.escapeValue(e[0]),
      searchResultItems: e[1]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      5 & t && (o.text = e[2].normalization.escapeValue(e[0])), 2 & t && (o.searchResultItems = e[1]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function ip(e) {
  var n, t;
  return n = new Xv({
    props: {
      selected: !0,
      onContextMenu: e[2].onContextMenu
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      4 & t && (o.onContextMenu = e[2].onContextMenu), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function ap(e) {
  var n,
    t,
    o,
    r,
    i,
    a = [tp, np],
    l = [];
  function c(e, n) {
    return !e[2].readOnly && e[4] ? 0 : 1;
  }
  n = c(e), t = l[n] = a[n](e);
  var u = !e[2].readOnly && e[3] && !e[4] && ip(e);
  return {
    c: function () {
      t.c(), o = At(), u && u.c(), r = Nt();
    },
    m: function (e, t) {
      l[n].m(e, t), Rt(e, o, t), u && u.m(e, t), Rt(e, r, t), i = !0;
    },
    p: function (e, i) {
      var d = s(i, 1)[0],
        f = n;
      (n = c(e)) === f ? l[n].p(e, d) : (Ro(), Po(l[f], 1, 1, function () {
        l[f] = null;
      }), Eo(), (t = l[n]) ? t.p(e, d) : (t = l[n] = a[n](e)).c(), qo(t, 1), t.m(o.parentNode, o)), e[2].readOnly || !e[3] || e[4] ? u && (Ro(), Po(u, 1, 1, function () {
        u = null;
      }), Eo()) : u ? (u.p(e, d), 28 & d && qo(u, 1)) : ((u = ip(e)).c(), qo(u, 1), u.m(r.parentNode, r));
    },
    i: function (e) {
      i || (qo(t), qo(u), i = !0);
    },
    o: function (e) {
      Po(t), Po(u), i = !1;
    },
    d: function (e) {
      e && (Et(o), Et(r)), l[n].d(e), u && u.d(e);
    }
  };
}
function sp(e, n, t) {
  var o,
    r,
    i = n.path,
    a = n.key,
    s = n.selection,
    l = n.searchResultItems,
    c = n.onUpdateKey,
    u = n.context;
  return e.$$set = function (e) {
    "path" in e && t(9, i = e.path), "key" in e && t(0, a = e.key), "selection" in e && t(10, s = e.selection), "searchResultItems" in e && t(1, l = e.searchResultItems), "onUpdateKey" in e && t(11, c = e.onUpdateKey), "context" in e && t(2, u = e.context);
  }, e.$$.update = function () {
    1536 & e.$$.dirty && t(3, o = !!s && Ls(s) && ne(s.path, i)), 1032 & e.$$.dirty && t(4, r = o && dl(s));
  }, [a, l, u, o, r, function (e) {
    r || u.readOnly || (e.preventDefault(), u.onSelect(il(i, !0)));
  }, function (e) {
    return xl("jse-key", {
      "jse-empty": "" === e
    });
  }, function (e, n) {
    var t = c(a, u.normalization.unescapeValue(e)),
      o = X(i).concat(t);
    u.onSelect(n === vr.nextInside ? al(o, !1) : il(o, !1)), n !== vr.self && u.focus();
  }, function () {
    u.onSelect(il(i, !1)), u.focus();
  }, i, s, c];
}
var lp = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, sp, ap, ct, {
      path: 9,
      key: 0,
      selection: 10,
      searchResultItems: 1,
      onUpdateKey: 11,
      context: 2
    }, ep), t;
  }
  return v(n, Wo), b(n);
}();
function cp(e, n, t) {
  var o = e.slice();
  return o[8] = n[t], o;
}
function up(e) {
  var n,
    t,
    o = e[8].component,
    r = fp(e);
  return {
    c: function () {
      r.c(), n = Nt();
    },
    m: function (e, o) {
      r.m(e, o), Rt(e, n, o), t = !0;
    },
    p: function (e, t) {
      1 & t && ct(o, o = e[8].component) ? (Ro(), Po(r, 1, 1, nt), Eo(), (r = fp(e)).c(), qo(r, 1), r.m(n.parentNode, n)) : r.p(e, t);
    },
    i: function (e) {
      t || (qo(r), t = !0);
    },
    o: function (e) {
      Po(r), t = !1;
    },
    d: function (e) {
      e && Et(n), r.d(e);
    }
  };
}
function dp(e) {
  var n,
    t = e[8].action,
    o = vp(e);
  return {
    c: function () {
      o.c(), n = Nt();
    },
    m: function (e, t) {
      o.m(e, t), Rt(e, n, t);
    },
    p: function (e, r) {
      1 & r && ct(t, t = e[8].action) ? (o.d(1), (o = vp(e)).c(), o.m(n.parentNode, n)) : o.p(e, r);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n), o.d(e);
    }
  };
}
function fp(e) {
  var n,
    t,
    o,
    r = [e[8].props],
    i = e[8].component;
  function a(e, n) {
    for (var t = {}, o = 0; o < r.length; o += 1) t = ot(t, r[o]);
    return void 0 !== n && 1 & n && (t = ot(t, Lo(r, [Uo(e[8].props)]))), {
      props: t
    };
  }
  return i && (n = Kt(i, a(e))), {
    c: function () {
      n && Jo(n.$$.fragment), t = Nt();
    },
    m: function (e, r) {
      n && Vo(n, e, r), Rt(e, t, r), o = !0;
    },
    p: function (e, o) {
      if (1 & o && i !== (i = e[8].component)) {
        if (n) {
          Ro();
          var s = n;
          Po(s.$$.fragment, 1, 0, function () {
            Ho(s, 1);
          }), Eo();
        }
        i ? (Jo((n = Kt(i, a(e, o))).$$.fragment), qo(n.$$.fragment, 1), Vo(n, t.parentNode, t)) : n = null;
      } else if (i) {
        var l = 1 & o ? Lo(r, [Uo(e[8].props)]) : {};
        n.$set(l);
      }
    },
    i: function (e) {
      o || (n && qo(n.$$.fragment, e), o = !0);
    },
    o: function (e) {
      n && Po(n.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(t), n && Ho(n, e);
    }
  };
}
function vp(e) {
  var n, t, o, r;
  return {
    c: function () {
      Ut(n = Pt("div"), "role", "button"), Ut(n, "tabindex", "-1"), Ut(n, "class", "jse-value"), Ut(n, "data-type", "selectable-value");
    },
    m: function (i, a) {
      Rt(i, n, a), o || (r = jt(t = e[11].call(null, n, e[8].props)), o = !0);
    },
    p: function (n, o) {
      e = n, t && st(t.update) && 1 & o && t.update.call(null, e[8].props);
    },
    d: function (e) {
      e && Et(n), o = !1, r();
    }
  };
}
function pp(e) {
  var n,
    t,
    o,
    r,
    i,
    a = [dp, up],
    s = [];
  function l(e, t) {
    return 1 & t && (n = null), null == n && (n = !!pv(e[8])), n ? 0 : 1;
  }
  function c(e, n) {
    return 0 === n ? function (e) {
      var n = e.slice(),
        t = n[8].action;
      return n[11] = t, n;
    }(e) : e;
  }
  return t = l(e, -1), o = s[t] = a[t](c(e, t)), {
    c: function () {
      o.c(), r = Nt();
    },
    m: function (e, n) {
      s[t].m(e, n), Rt(e, r, n), i = !0;
    },
    p: function (e, n) {
      var i = t;
      (t = l(e, n)) === i ? s[t].p(c(e, t), n) : (Ro(), Po(s[i], 1, 1, function () {
        s[i] = null;
      }), Eo(), (o = s[t]) ? o.p(c(e, t), n) : (o = s[t] = a[t](c(e, t))).c(), qo(o, 1), o.m(r.parentNode, r));
    },
    i: function (e) {
      i || (qo(o), i = !0);
    },
    o: function (e) {
      Po(o), i = !1;
    },
    d: function (e) {
      e && Et(r), s[t].d(e);
    }
  };
}
function mp(e) {
  for (var n, t, o = Ao(e[0]), r = [], i = 0; i < o.length; i += 1) r[i] = pp(cp(e, o, i));
  var a = function (e) {
    return Po(r[e], 1, 1, function () {
      r[e] = null;
    });
  };
  return {
    c: function () {
      for (var e = 0; e < r.length; e += 1) r[e].c();
      n = Nt();
    },
    m: function (e, o) {
      for (var i = 0; i < r.length; i += 1) r[i] && r[i].m(e, o);
      Rt(e, n, o), t = !0;
    },
    p: function (e, t) {
      var i = s(t, 1)[0];
      if (1 & i) {
        var l;
        for (o = Ao(e[0]), l = 0; l < o.length; l += 1) {
          var c = cp(e, o, l);
          r[l] ? (r[l].p(c, i), qo(r[l], 1)) : (r[l] = pp(c), r[l].c(), qo(r[l], 1), r[l].m(n.parentNode, n));
        }
        for (Ro(), l = o.length; l < r.length; l += 1) a(l);
        Eo();
      }
    },
    i: function (e) {
      if (!t) {
        for (var n = 0; n < o.length; n += 1) qo(r[n]);
        t = !0;
      }
    },
    o: function (e) {
      r = r.filter(Boolean);
      for (var n = 0; n < r.length; n += 1) Po(r[n]);
      t = !1;
    },
    d: function (e) {
      e && Et(n), qt(r, e);
    }
  };
}
function gp(e, n, t) {
  var o,
    r,
    i = n.path,
    a = n.value,
    s = n.context,
    l = n.enforceString,
    c = n.selection,
    u = n.searchResultItems;
  return e.$$set = function (e) {
    "path" in e && t(1, i = e.path), "value" in e && t(2, a = e.value), "context" in e && t(3, s = e.context), "enforceString" in e && t(4, l = e.enforceString), "selection" in e && t(5, c = e.selection), "searchResultItems" in e && t(6, u = e.searchResultItems);
  }, e.$$.update = function () {
    32 & e.$$.dirty && t(7, o = Us(c) && dl(c)), 254 & e.$$.dirty && t(0, r = s.onRenderValue({
      path: i,
      value: a,
      readOnly: s.readOnly,
      enforceString: l,
      isEditing: o,
      parser: s.parser,
      normalization: s.normalization,
      selection: c,
      searchResultItems: u,
      onPatch: s.onPatch,
      onPasteJson: s.onPasteJson,
      onSelect: s.onSelect,
      onFind: s.onFind,
      findNextInside: s.findNextInside,
      focus: s.focus
    }));
  }, [r, i, a, s, l, c, u, o];
}
var hp = function (e) {
    function n(e) {
      var t;
      return h(this, n), _o(t = u(this, n), e, gp, mp, ct, {
        path: 1,
        value: 2,
        context: 3,
        enforceString: 4,
        selection: 5,
        searchResultItems: 6
      }), t;
    }
    return v(n, Wo), b(n);
  }(),
  jp = {
    selecting: !1,
    selectionAnchor: null,
    selectionAnchorType: null,
    selectionFocus: null,
    dragging: !1
  };
function bp(e) {
  var n = e.json,
    t = e.documentState,
    o = e.deltaY,
    r = e.items;
  if (!t.selection) return {
    operations: void 0,
    updatedSelection: null,
    offset: 0
  };
  var i = t.selection,
    a = o < 0 ? function (e) {
      var n = e.json,
        t = e.items,
        o = e.selection,
        r = e.deltaY,
        i = Qs(n, o),
        a = t.findIndex(function (e) {
          return ne(e.path, i);
        }),
        s = function () {
          var e;
          return null === (e = t[l - 1]) || void 0 === e ? void 0 : e.height;
        },
        l = a,
        c = 0;
      for (; void 0 !== s() && Math.abs(r) > c + s() / 2;) c += s(), l -= 1;
      var u = t[l].path,
        d = l - a;
      return l !== a && void 0 !== t[l] ? {
        beforePath: u,
        offset: d
      } : void 0;
    }({
      json: n,
      selection: i,
      deltaY: o,
      items: r
    }) : function (e) {
      var n,
        t = e.json,
        o = e.items,
        r = e.selection,
        i = e.deltaY,
        a = Ys(t, r),
        s = o.findIndex(function (e) {
          return ne(e.path, a);
        }),
        l = 0,
        c = s,
        u = function () {
          var e;
          return null === (e = o[c + 1]) || void 0 === e ? void 0 : e.height;
        };
      for (; void 0 !== u() && Math.abs(i) > l + u() / 2;) l += u(), c += 1;
      var d = X(a),
        f = z(t, d),
        v = Array.isArray(f),
        p = null === (n = o[v ? c : c + 1]) || void 0 === n ? void 0 : n.path,
        m = c - s;
      return p ? {
        beforePath: p,
        offset: m
      } : {
        append: !0,
        offset: m
      };
    }({
      json: n,
      selection: i,
      deltaY: o,
      items: r
    });
  if (!a || 0 === a.offset) return {
    operations: void 0,
    updatedSelection: null,
    offset: 0
  };
  var s = function (e, n, t) {
      if (!n) return [];
      var o = "beforePath" in t ? t.beforePath : void 0,
        r = "append" in t ? t.append : void 0,
        i = X(bl(n)),
        a = z(e, i);
      if (!(r || o && ol(o, i) && o.length > i.length)) return [];
      var s = Qs(e, n),
        l = Ys(e, n),
        c = ee(s),
        u = ee(l),
        d = o ? o[i.length] : void 0;
      if (!B(a)) {
        if (N(a)) {
          var f = Hr(c),
            v = Hr(u),
            p = void 0 !== d ? Hr(d) : a.length;
          return ie(v - f + 1, p < f ? function (e) {
            return {
              op: "move",
              from: O(i.concat(String(f + e))),
              path: O(i.concat(String(p + e)))
            };
          } : function () {
            return {
              op: "move",
              from: O(i.concat(String(f))),
              path: O(i.concat(String(p)))
            };
          });
        }
        throw new Error("Cannot create move operations: parent must be an Object or Array");
      }
      var m = Object.keys(a),
        g = m.indexOf(c),
        h = m.indexOf(u),
        j = r ? m.length : void 0 !== d ? m.indexOf(d) : -1;
      return -1 !== g && -1 !== h && -1 !== j ? j > g ? [].concat(w(m.slice(g, h + 1)), w(m.slice(j, m.length))).map(function (e) {
        return Al(i, e);
      }) : [].concat(w(m.slice(j, g)), w(m.slice(h + 1, m.length))).map(function (e) {
        return Al(i, e);
      }) : [];
    }(n, i, a),
    l = X(Qs(n, i)),
    c = z(n, l);
  if (Array.isArray(c)) {
    var u = function (e) {
      var n,
        t,
        o = e.items,
        r = e.json,
        i = e.selection,
        a = e.offset,
        s = Qs(r, i),
        l = Ys(r, i),
        c = o.findIndex(function (e) {
          return ne(e.path, s);
        }),
        u = o.findIndex(function (e) {
          return ne(e.path, l);
        }),
        d = null === (n = o[c + a]) || void 0 === n ? void 0 : n.path,
        f = null === (t = o[u + a]) || void 0 === t ? void 0 : t.path;
      return cl(d, f);
    }({
      items: r,
      json: n,
      selection: i,
      offset: a.offset
    });
    return {
      operations: s,
      updatedSelection: u,
      offset: a.offset
    };
  }
  return {
    operations: s,
    updatedSelection: null,
    offset: a.offset
  };
}
function yp(e, n) {
  return function (e, n) {
    if (e) {
      for (var t = {}, o = 0, r = Object.keys(e); o < r.length; o++) {
        var i = r[o];
        n(i, e[i]) && (t[i] = e[i]);
      }
      return Object.keys(t).length > 0 ? t : void 0;
    }
  }(e, function (e) {
    return F(e, n);
  });
}
function xp(e) {
  St(e, "svelte-1yy7qpj", 'button.jse-validation-error.svelte-1yy7qpj{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;padding:0;margin:0;vertical-align:top;display:inline-flex;color:var(--jse-error-color, #ee5341)}button.jse-validation-info.svelte-1yy7qpj{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;padding:0;margin:0;vertical-align:top;display:inline-flex;color:var(--jse-info-color, #4f91ff)}button.jse-validation-warning.svelte-1yy7qpj{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;padding:0;margin:0;vertical-align:top;display:inline-flex;color:var(--jse-warning-color, #fdc539)}');
}
function wp(e) {
  var n, t, o, r, i, a, l;
  return t = new Ya({
    props: {
      data: we
    }
  }), {
    c: function () {
      n = Pt("button"), Jo(t.$$.fragment), Ut(n, "type", "button"), Ut(n, "class", o = "jse-validation-" + e[0].severity + " svelte-1yy7qpj");
    },
    m: function (o, s) {
      Rt(o, n, s), Vo(t, n, null), i = !0, a || (l = [Bt(n, "click", function () {
        st(e[1]) && e[1].apply(this, arguments);
      }), jt(r = hc.call(null, n, g({
        text: e[2]
      }, e[3])))], a = !0);
    },
    p: function (t, a) {
      var l = s(a, 1)[0];
      e = t, (!i || 1 & l && o !== (o = "jse-validation-" + e[0].severity + " svelte-1yy7qpj")) && Ut(n, "class", o), r && st(r.update) && 4 & l && r.update.call(null, g({
        text: e[2]
      }, e[3]));
    },
    i: function (e) {
      i || (qo(t.$$.fragment, e), i = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), i = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), a = !1, at(l);
    }
  };
}
function $p(e, n, t) {
  var o,
    r = co("absolute-popup"),
    i = n.validationError,
    a = n.onExpand;
  return e.$$set = function (e) {
    "validationError" in e && t(0, i = e.validationError), "onExpand" in e && t(1, a = e.onExpand);
  }, e.$$.update = function () {
    1 & e.$$.dirty && t(2, o = fv(i) && i.isChildError ? "Contains invalid data" : i.message);
  }, [i, a, o, r];
}
var kp = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, $p, wp, lt, {
      validationError: 0,
      onExpand: 1
    }, xp), t;
  }
  return v(n, Wo), b(n);
}();
function Cp(e) {
  St(e, "svelte-6mjnsm", '.jse-json-node.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{position:relative;color:var(--jse-text-color, #4d4d4d)}.jse-json-node.jse-root.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{min-height:100%;padding-bottom:2px;box-sizing:border-box}.jse-json-node.jse-root.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm .jse-context-menu-pointer,.jse-json-node.jse-root.svelte-6mjnsm>.jse-contents-outer.svelte-6mjnsm>.jse-contents.svelte-6mjnsm .jse-context-menu-pointer{top:0;right:calc(-2px - var(--jse-context-menu-pointer-size, calc(1em + 4px)))}.jse-json-node.jse-root.svelte-6mjnsm>.jse-contents-outer.svelte-6mjnsm>.jse-contents.svelte-6mjnsm.svelte-6mjnsm{padding-left:0}.jse-json-node.svelte-6mjnsm .jse-props.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.svelte-6mjnsm .jse-items.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{position:relative}.jse-json-node.svelte-6mjnsm .jse-header-outer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.svelte-6mjnsm .jse-footer-outer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:flex;margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)))}.jse-json-node.svelte-6mjnsm .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{position:relative}.jse-json-node.svelte-6mjnsm .jse-header .jse-meta.svelte-6mjnsm>.jse-meta-inner.svelte-6mjnsm.svelte-6mjnsm{display:flex;justify-content:center}.jse-json-node.svelte-6mjnsm .jse-contents-outer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:flex;margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)))}.jse-json-node.svelte-6mjnsm .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.svelte-6mjnsm .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:flex;flex-direction:row;align-items:flex-start}.jse-json-node.svelte-6mjnsm .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{padding-left:var(--jse-indent-size, calc(1em + 4px))}.jse-json-node.svelte-6mjnsm .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:inline-flex;padding-left:calc(var(--jse-indent-size, calc(1em + 4px)) + 5px)}.jse-json-node.svelte-6mjnsm .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.svelte-6mjnsm .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.svelte-6mjnsm .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{background:var(--jse-contents-background-color, transparent)}.jse-json-node.svelte-6mjnsm .jse-insert-selection-area.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{visibility:hidden;padding:0 calc(0.5 * var(--jse-padding, 10px));flex:1}.jse-json-node.svelte-6mjnsm .jse-insert-selection-area.jse-inside.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:inline-flex;align-items:center}.jse-json-node.svelte-6mjnsm .jse-insert-selection-area.jse-after.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:flex;align-items:flex-end}.jse-json-node.svelte-6mjnsm .jse-context-menu-pointer-anchor.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{position:relative}.jse-json-node.svelte-6mjnsm .jse-insert-area.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{display:flex;position:relative;z-index:1;margin-left:calc(var(--level) * var(--jse-indent-size, calc(1em + 4px)));max-width:250px;min-width:100px;height:0;margin-right:calc(0.5 * var(--jse-padding, 10px));outline:1px solid}.jse-json-node.svelte-6mjnsm .jse-insert-area.svelte-6mjnsm .jse-context-menu-pointer{right:-1px;background:var(--jse-context-menu-pointer-hover-background, #b2b2b2)}.jse-json-node.svelte-6mjnsm .jse-insert-area.jse-hovered.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{outline-color:var(--jse-context-menu-pointer-hover-background, #b2b2b2)}.jse-json-node.svelte-6mjnsm:hover>.jse-contents-outer .jse-insert-selection-area.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm:not(.jse-selected),.jse-json-node.svelte-6mjnsm .jse-header-outer.svelte-6mjnsm:hover>.jse-insert-selection-area.svelte-6mjnsm.svelte-6mjnsm:not(.jse-selected),.jse-json-node.svelte-6mjnsm .jse-footer-outer:hover .jse-insert-selection-area.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm:not(.jse-selected){visibility:visible}.jse-json-node.jse-hovered.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-meta.svelte-6mjnsm,.jse-json-node.jse-hovered.svelte-6mjnsm .jse-props .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-hovered.svelte-6mjnsm .jse-items .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-hovered.svelte-6mjnsm .jse-props .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-hovered.svelte-6mjnsm .jse-items .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-hovered.svelte-6mjnsm .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-json-node.jse-selected.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-meta.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-props .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-items .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-props .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-items .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected.svelte-6mjnsm .jse-value{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.jse-selected.svelte-6mjnsm .jse-expand.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{background:var(--jse-selection-background-color, #d3d3d3)}.jse-json-node.jse-selected-key.svelte-6mjnsm>.jse-contents-outer.svelte-6mjnsm>.jse-contents.svelte-6mjnsm>.jse-identifier>.jse-key,.jse-json-node.jse-selected-key.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-identifier>.jse-key{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-contents-outer.svelte-6mjnsm>.jse-contents.svelte-6mjnsm>.jse-value{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.svelte-6mjnsm .jse-collapsed-items.jse-selected,.jse-json-node.jse-selected.svelte-6mjnsm .jse-collapsed-items,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-collapsed-items{background-color:var(--jse-selection-background-color, #d3d3d3);--jse-collapsed-items-background-color:var(--jse-collapsed-items-selected-background-color, #c2c2c2)}.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-meta.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-meta.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-footer-outer.svelte-6mjnsm>.jse-footer.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-expand.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-contents.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-header.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-footer.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-expand.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{background:var(--jse-selection-background-color, #d3d3d3)}.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-meta.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-meta.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-meta.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-header-outer.svelte-6mjnsm>.jse-header.svelte-6mjnsm>.jse-meta.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-footer-outer.svelte-6mjnsm>.jse-footer.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm>.jse-footer-outer.svelte-6mjnsm>.jse-footer.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-contents.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-contents.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-header.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-header.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-footer.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-footer.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-expand.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-props .jse-expand.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-contents.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-contents.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-header.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-header.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-footer.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-footer.svelte-6mjnsm .jse-value,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-expand.svelte-6mjnsm .jse-key,.jse-json-node.jse-selected-value.svelte-6mjnsm .jse-items .jse-expand.svelte-6mjnsm .jse-value{background:var(--jse-selection-background-color, #d3d3d3);cursor:var(--jse-contents-selected-cursor, grab)}.jse-json-node.jse-readonly.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{--jse-contents-selected-cursor:pointer}.jse-json-node.svelte-6mjnsm .jse-insert-area.jse-selected.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{outline-color:var(--jse-context-menu-pointer-background, var(--jse-context-menu-background, #656565))}.jse-json-node.svelte-6mjnsm .jse-insert-area.jse-selected.svelte-6mjnsm .jse-context-menu-pointer{background:var(--jse-context-menu-pointer-background, var(--jse-context-menu-background, #656565))}.jse-json-node.svelte-6mjnsm .jse-insert-area.jse-selected.svelte-6mjnsm .jse-context-menu-pointer:hover{background:var(--jse-context-menu-pointer-background-highlight, var(--jse-context-menu-background-highlight, #7a7a7a))}.jse-main:not(.jse-focus) .jse-json-node.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{--jse-selection-background-color:var(--jse-selection-background-inactive-color, #e8e8e8);--jse-context-menu-pointer-background:var(--jse-context-menu-pointer-hover-background, #b2b2b2)}.jse-expand.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{width:var(--jse-indent-size, calc(1em + 4px));padding:0;margin:0;border:none;cursor:pointer;background:transparent;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38));font-size:var(--jse-font-size-mono, 14px);height:var(--jse-line-height, calc(1em + 4px))}.jse-expand.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm:hover{opacity:0.8}.jse-meta.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-separator.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-index.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,.jse-bracket.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{vertical-align:top;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-index.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{padding:0 calc(0.5 * var(--jse-padding, 10px))}.jse-bracket.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{padding:0 2px}.jse-bracket.jse-expanded.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{padding-right:var(--jse-padding, 10px)}.jse-tag.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{border:none;font-size:80%;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);color:var(--jse-tag-color, var(--jse-text-color-inverse, #fff));background:var(--jse-tag-background, rgba(0, 0, 0, 0.2));border-radius:2px;cursor:pointer;display:inline-block;padding:0 4px;line-height:normal;margin:1px 0}.jse-tag.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm:hover{opacity:0.8}.jse-tag.jse-expanded.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{opacity:0.7;cursor:inherit}.jse-identifier.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm{vertical-align:top;position:relative}');
}
var Sp = function (e) {
    return {};
  },
  Mp = function (e) {
    return {};
  };
function Op(e, n, t) {
  var o = e.slice();
  return o[52] = n[t], o;
}
var zp = function (e) {
    return {};
  },
  Rp = function (e) {
    return {};
  };
function Ep(e, n, t) {
  var o = e.slice();
  return o[46] = n[t], o[48] = t, o;
}
function qp(e, n, t) {
  var o = e.slice();
  return o[49] = n[t], o;
}
var Pp = function (e) {
    return {};
  },
  Ip = function (e) {
    return {};
  };
function Tp(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u = !e[8].readOnly && e[16] && e[7] && (Us(e[7]) || Ds(e[7])) && !dl(e[7]) && ne(bl(e[7]), e[1]),
    d = e[33].identifier,
    f = ut(d, e, e[34], Mp),
    v = !e[17] && Bp();
  i = new hp({
    props: {
      path: e[1],
      value: e[0],
      enforceString: e[13] || !1,
      selection: e[16] ? e[7] : null,
      searchResultItems: Zl(e[6], e[9]),
      context: e[8]
    }
  });
  var p = u && Fp(e),
    m = e[15] && Lp(e),
    g = !e[17] && Up(e);
  return {
    c: function () {
      n = Pt("div"), t = Pt("div"), f && f.c(), o = At(), v && v.c(), r = At(), Jo(i.$$.fragment), a = At(), p && p.c(), s = At(), m && m.c(), l = At(), g && g.c(), Ut(t, "class", "jse-contents svelte-6mjnsm"), Ut(n, "class", "jse-contents-outer svelte-6mjnsm");
    },
    m: function (e, u) {
      Rt(e, n, u), Ct(n, t), f && f.m(t, null), Ct(t, o), v && v.m(t, null), Ct(t, r), Vo(i, t, null), Ct(t, a), p && p.m(t, null), Ct(n, s), m && m.m(n, null), Ct(n, l), g && g.m(n, null), c = !0;
    },
    p: function (e, o) {
      f && f.p && (!c || 8 & o[1]) && vt(f, d, e, e[34], c ? ft(d, e[34], o, Sp) : pt(e[34]), Mp), e[17] ? v && (v.d(1), v = null) : v || ((v = Bp()).c(), v.m(t, r));
      var a = {};
      2 & o[0] && (a.path = e[1]), 1 & o[0] && (a.value = e[0]), 8192 & o[0] && (a.enforceString = e[13] || !1), 65664 & o[0] && (a.selection = e[16] ? e[7] : null), 576 & o[0] && (a.searchResultItems = Zl(e[6], e[9])), 256 & o[0] && (a.context = e[8]), i.$set(a), 65922 & o[0] && (u = !e[8].readOnly && e[16] && e[7] && (Us(e[7]) || Ds(e[7])) && !dl(e[7]) && ne(bl(e[7]), e[1])), u ? p ? (p.p(e, o), 65922 & o[0] && qo(p, 1)) : ((p = Fp(e)).c(), qo(p, 1), p.m(t, null)) : p && (Ro(), Po(p, 1, 1, function () {
        p = null;
      }), Eo()), e[15] ? m ? (m.p(e, o), 32768 & o[0] && qo(m, 1)) : ((m = Lp(e)).c(), qo(m, 1), m.m(n, l)) : m && (Ro(), Po(m, 1, 1, function () {
        m = null;
      }), Eo()), e[17] ? g && (g.d(1), g = null) : g ? g.p(e, o) : ((g = Up(e)).c(), g.m(n, null));
    },
    i: function (e) {
      c || (qo(f, e), qo(i.$$.fragment, e), qo(p), qo(m), c = !0);
    },
    o: function (e) {
      Po(f, e), Po(i.$$.fragment, e), Po(p), Po(m), c = !1;
    },
    d: function (e) {
      e && Et(n), f && f.d(e), v && v.d(), Ho(i), p && p.d(), m && m.d(), g && g.d();
    }
  };
}
function Ap(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f,
    v,
    p,
    m,
    g,
    h,
    j,
    b = !e[8].readOnly && e[16] && e[7] && (Us(e[7]) || Ds(e[7])) && !dl(e[7]) && ne(bl(e[7]), e[1]),
    y = [Jp, Dp],
    x = [];
  function w(e, n) {
    return e[12] ? 0 : 1;
  }
  r = w(e), i = x[r] = y[r](e);
  var $ = e[33].identifier,
    k = ut($, e, e[34], Rp),
    C = !e[17] && Vp();
  function S(e, n) {
    return e[12] ? _p : Hp;
  }
  var M = S(e),
    O = M(e),
    z = b && Wp(e),
    R = e[15] && (!e[12] || !e[15].isChildError) && Qp(e);
  function E(e, n) {
    return e[12] ? Gp : e[17] ? void 0 : Yp;
  }
  var q = E(e),
    P = q && q(e),
    I = e[12] && Kp(e);
  return {
    c: function () {
      n = Pt("div"), t = Pt("div"), o = Pt("button"), i.c(), a = At(), k && k.c(), s = At(), C && C.c(), l = At(), c = Pt("div"), u = Pt("div"), O.c(), d = At(), z && z.c(), f = At(), R && R.c(), v = At(), P && P.c(), p = At(), I && I.c(), m = Nt(), Ut(o, "type", "button"), Ut(o, "class", "jse-expand svelte-6mjnsm"), Ut(o, "title", "Expand or collapse this object (Ctrl+Click to expand/collapse recursively)"), Ut(u, "class", "jse-meta-inner svelte-6mjnsm"), Ut(c, "class", "jse-meta svelte-6mjnsm"), Ut(c, "data-type", "selectable-value"), Ut(t, "class", "jse-header svelte-6mjnsm"), Ut(n, "class", "jse-header-outer svelte-6mjnsm");
    },
    m: function (i, b) {
      Rt(i, n, b), Ct(n, t), Ct(t, o), x[r].m(o, null), Ct(t, a), k && k.m(t, null), Ct(t, s), C && C.m(t, null), Ct(t, l), Ct(t, c), Ct(c, u), O.m(u, null), Ct(t, d), z && z.m(t, null), Ct(n, f), R && R.m(n, null), Ct(n, v), P && P.m(n, null), Rt(i, p, b), I && I.m(i, b), Rt(i, m, b), g = !0, h || (j = Bt(o, "click", e[20]), h = !0);
    },
    p: function (e, a) {
      var s = r;
      (r = w(e)) !== s && (Ro(), Po(x[s], 1, 1, function () {
        x[s] = null;
      }), Eo(), (i = x[r]) || (i = x[r] = y[r](e)).c(), qo(i, 1), i.m(o, null)), k && k.p && (!g || 8 & a[1]) && vt(k, $, e, e[34], g ? ft($, e[34], a, zp) : pt(e[34]), Rp), e[17] ? C && (C.d(1), C = null) : C || ((C = Vp()).c(), C.m(t, l)), M === (M = S(e)) && O ? O.p(e, a) : (O.d(1), (O = M(e)) && (O.c(), O.m(u, null))), 65922 & a[0] && (b = !e[8].readOnly && e[16] && e[7] && (Us(e[7]) || Ds(e[7])) && !dl(e[7]) && ne(bl(e[7]), e[1])), b ? z ? (z.p(e, a), 65922 & a[0] && qo(z, 1)) : ((z = Wp(e)).c(), qo(z, 1), z.m(t, null)) : z && (Ro(), Po(z, 1, 1, function () {
        z = null;
      }), Eo()), !e[15] || e[12] && e[15].isChildError ? R && (Ro(), Po(R, 1, 1, function () {
        R = null;
      }), Eo()) : R ? (R.p(e, a), 36864 & a[0] && qo(R, 1)) : ((R = Qp(e)).c(), qo(R, 1), R.m(n, v)), q === (q = E(e)) && P ? P.p(e, a) : (P && P.d(1), (P = q && q(e)) && (P.c(), P.m(n, null))), e[12] ? I ? (I.p(e, a), 4096 & a[0] && qo(I, 1)) : ((I = Kp(e)).c(), qo(I, 1), I.m(m.parentNode, m)) : I && (Ro(), Po(I, 1, 1, function () {
        I = null;
      }), Eo());
    },
    i: function (e) {
      g || (qo(i), qo(k, e), qo(z), qo(R), qo(I), g = !0);
    },
    o: function (e) {
      Po(i), Po(k, e), Po(z), Po(R), Po(I), g = !1;
    },
    d: function (e) {
      e && (Et(n), Et(p), Et(m)), x[r].d(), k && k.d(e), C && C.d(), O.d(), z && z.d(), R && R.d(), P && P.d(), I && I.d(e), h = !1, j();
    }
  };
}
function Np(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f,
    v,
    p,
    m,
    g,
    h,
    j,
    b = !e[8].readOnly && e[16] && e[7] && (Us(e[7]) || Ds(e[7])) && !dl(e[7]) && ne(bl(e[7]), e[1]),
    y = [om, tm],
    x = [];
  function w(e, n) {
    return e[12] ? 0 : 1;
  }
  r = w(e), i = x[r] = y[r](e);
  var $ = e[33].identifier,
    k = ut($, e, e[34], Ip),
    C = !e[17] && rm();
  function S(e, n) {
    return e[12] ? am : im;
  }
  var M = S(e),
    O = M(e),
    z = b && sm(e),
    R = e[15] && (!e[12] || !e[15].isChildError) && lm(e);
  function E(e, n) {
    return e[12] ? um : cm;
  }
  var q = E(e),
    P = q(e),
    I = e[12] && dm(e);
  return {
    c: function () {
      n = Pt("div"), t = Pt("div"), o = Pt("button"), i.c(), a = At(), k && k.c(), s = At(), C && C.c(), l = At(), c = Pt("div"), u = Pt("div"), O.c(), d = At(), z && z.c(), f = At(), R && R.c(), v = At(), P.c(), p = At(), I && I.c(), m = Nt(), Ut(o, "type", "button"), Ut(o, "class", "jse-expand svelte-6mjnsm"), Ut(o, "title", "Expand or collapse this array (Ctrl+Click to expand/collapse recursively)"), Ut(u, "class", "jse-meta-inner svelte-6mjnsm"), Ut(u, "data-type", "selectable-value"), Ut(c, "class", "jse-meta svelte-6mjnsm"), Ut(t, "class", "jse-header svelte-6mjnsm"), Ut(n, "class", "jse-header-outer svelte-6mjnsm");
    },
    m: function (i, b) {
      Rt(i, n, b), Ct(n, t), Ct(t, o), x[r].m(o, null), Ct(t, a), k && k.m(t, null), Ct(t, s), C && C.m(t, null), Ct(t, l), Ct(t, c), Ct(c, u), O.m(u, null), Ct(t, d), z && z.m(t, null), Ct(n, f), R && R.m(n, null), Ct(n, v), P.m(n, null), Rt(i, p, b), I && I.m(i, b), Rt(i, m, b), g = !0, h || (j = Bt(o, "click", e[20]), h = !0);
    },
    p: function (e, a) {
      var s = r;
      (r = w(e)) !== s && (Ro(), Po(x[s], 1, 1, function () {
        x[s] = null;
      }), Eo(), (i = x[r]) || (i = x[r] = y[r](e)).c(), qo(i, 1), i.m(o, null)), k && k.p && (!g || 8 & a[1]) && vt(k, $, e, e[34], g ? ft($, e[34], a, Pp) : pt(e[34]), Ip), e[17] ? C && (C.d(1), C = null) : C || ((C = rm()).c(), C.m(t, l)), M === (M = S(e)) && O ? O.p(e, a) : (O.d(1), (O = M(e)) && (O.c(), O.m(u, null))), 65922 & a[0] && (b = !e[8].readOnly && e[16] && e[7] && (Us(e[7]) || Ds(e[7])) && !dl(e[7]) && ne(bl(e[7]), e[1])), b ? z ? (z.p(e, a), 65922 & a[0] && qo(z, 1)) : ((z = sm(e)).c(), qo(z, 1), z.m(t, null)) : z && (Ro(), Po(z, 1, 1, function () {
        z = null;
      }), Eo()), !e[15] || e[12] && e[15].isChildError ? R && (Ro(), Po(R, 1, 1, function () {
        R = null;
      }), Eo()) : R ? (R.p(e, a), 36864 & a[0] && qo(R, 1)) : ((R = lm(e)).c(), qo(R, 1), R.m(n, v)), q === (q = E(e)) && P ? P.p(e, a) : (P.d(1), (P = q(e)) && (P.c(), P.m(n, null))), e[12] ? I ? (I.p(e, a), 4096 & a[0] && qo(I, 1)) : ((I = dm(e)).c(), qo(I, 1), I.m(m.parentNode, m)) : I && (Ro(), Po(I, 1, 1, function () {
        I = null;
      }), Eo());
    },
    i: function (e) {
      g || (qo(i), qo(k, e), qo(z), qo(R), qo(I), g = !0);
    },
    o: function (e) {
      Po(i), Po(k, e), Po(z), Po(R), Po(I), g = !1;
    },
    d: function (e) {
      e && (Et(n), Et(p), Et(m)), x[r].d(), k && k.d(e), C && C.d(), O.d(), z && z.d(), R && R.d(), P.d(), I && I.d(e), h = !1, j();
    }
  };
}
function Bp(e) {
  var n;
  return {
    c: function () {
      (n = Pt("div")).textContent = ":", Ut(n, "class", "jse-separator svelte-6mjnsm");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Fp(e) {
  var n, t, o;
  return t = new Xv({
    props: {
      selected: !0,
      onContextMenu: e[8].onContextMenu
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "class", "jse-context-menu-pointer-anchor svelte-6mjnsm");
    },
    m: function (e, r) {
      Rt(e, n, r), Vo(t, n, null), o = !0;
    },
    p: function (e, n) {
      var o = {};
      256 & n[0] && (o.onContextMenu = e[8].onContextMenu), t.$set(o);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function Lp(e) {
  var n, t;
  return n = new kp({
    props: {
      validationError: e[15],
      onExpand: e[21]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      32768 & t[0] && (o.validationError = e[15]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Up(e) {
  var n, t, o;
  return {
    c: function () {
      Ut(n = Pt("div"), "role", "none"), Ut(n, "class", "jse-insert-selection-area jse-after svelte-6mjnsm"), Ut(n, "data-type", "insert-selection-area-after");
    },
    m: function (r, i) {
      Rt(r, n, i), t || (o = Bt(n, "click", e[29]), t = !0);
    },
    p: nt,
    d: function (e) {
      e && Et(n), t = !1, o();
    }
  };
}
function Dp(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: ze
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Jp(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: Oe
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Vp(e) {
  var n;
  return {
    c: function () {
      (n = Pt("div")).textContent = ":", Ut(n, "class", "jse-separator svelte-6mjnsm");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Hp(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d = Object.keys(e[0]).length + "",
    f = 1 === Object.keys(e[0]).length ? "prop" : "props";
  return {
    c: function () {
      (n = Pt("div")).textContent = "{", t = At(), o = Pt("button"), r = Tt(d), i = At(), a = Tt(f), s = At(), (l = Pt("div")).textContent = "}", Ut(n, "class", "jse-bracket svelte-6mjnsm"), Ut(o, "type", "button"), Ut(o, "class", "jse-tag svelte-6mjnsm"), Ut(l, "class", "jse-bracket svelte-6mjnsm");
    },
    m: function (d, f) {
      Rt(d, n, f), Rt(d, t, f), Rt(d, o, f), Ct(o, r), Ct(o, i), Ct(o, a), Rt(d, s, f), Rt(d, l, f), c || (u = Bt(o, "click", e[21]), c = !0);
    },
    p: function (e, n) {
      1 & n[0] && d !== (d = Object.keys(e[0]).length + "") && Ht(r, d), 1 & n[0] && f !== (f = 1 === Object.keys(e[0]).length ? "prop" : "props") && Ht(a, f);
    },
    d: function (e) {
      e && (Et(n), Et(t), Et(o), Et(s), Et(l)), c = !1, u();
    }
  };
}
function _p(e) {
  var n;
  return {
    c: function () {
      (n = Pt("div")).textContent = "{", Ut(n, "class", "jse-bracket jse-expanded svelte-6mjnsm");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Wp(e) {
  var n, t, o;
  return t = new Xv({
    props: {
      selected: !0,
      onContextMenu: e[8].onContextMenu
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "class", "jse-context-menu-pointer-anchor svelte-6mjnsm");
    },
    m: function (e, r) {
      Rt(e, n, r), Vo(t, n, null), o = !0;
    },
    p: function (e, n) {
      var o = {};
      256 & n[0] && (o.onContextMenu = e[8].onContextMenu), t.$set(o);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function Qp(e) {
  var n, t;
  return n = new kp({
    props: {
      validationError: e[15],
      onExpand: e[21]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      32768 & t[0] && (o.validationError = e[15]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Yp(e) {
  var n, t, o;
  return {
    c: function () {
      Ut(n = Pt("div"), "role", "none"), Ut(n, "class", "jse-insert-selection-area jse-after svelte-6mjnsm"), Ut(n, "data-type", "insert-selection-area-after");
    },
    m: function (r, i) {
      Rt(r, n, i), t || (o = Bt(n, "click", e[29]), t = !0);
    },
    p: nt,
    d: function (e) {
      e && Et(n), t = !1, o();
    }
  };
}
function Gp(e) {
  var n, t, o;
  return {
    c: function () {
      Ut(n = Pt("div"), "role", "none"), Ut(n, "class", "jse-insert-selection-area jse-inside svelte-6mjnsm"), Ut(n, "data-type", "insert-selection-area-inside");
    },
    m: function (r, i) {
      Rt(r, n, i), t || (o = Bt(n, "click", e[28]), t = !0);
    },
    p: nt,
    d: function (e) {
      e && Et(n), t = !1, o();
    }
  };
}
function Kp(e) {
  for (var n, t, o, r, i, a, s, l = !e[8].readOnly && (e[10] === Ir || e[16] && Fs(e[7])), c = l && Zp(e), u = Ao(e[18](e[1], e[0], e[2], e[3], e[4], e[5], e[6], e[7], e[11])), d = [], f = 0; f < u.length; f += 1) d[f] = em(Op(e, u, f));
  var v = function (e) {
      return Po(d[e], 1, 1, function () {
        d[e] = null;
      });
    },
    p = !e[17] && nm(e);
  return {
    c: function () {
      n = Pt("div"), c && c.c(), t = At();
      for (var e = 0; e < d.length; e += 1) d[e].c();
      o = At(), r = Pt("div"), (i = Pt("div")).innerHTML = '<div class="jse-bracket svelte-6mjnsm">}</div>', a = At(), p && p.c(), Ut(n, "class", "jse-props svelte-6mjnsm"), Ut(i, "data-type", "selectable-value"), Ut(i, "class", "jse-footer svelte-6mjnsm"), Ut(r, "class", "jse-footer-outer svelte-6mjnsm");
    },
    m: function (e, l) {
      Rt(e, n, l), c && c.m(n, null), Ct(n, t);
      for (var u = 0; u < d.length; u += 1) d[u] && d[u].m(n, null);
      Rt(e, o, l), Rt(e, r, l), Ct(r, i), Ct(r, a), p && p.m(r, null), s = !0;
    },
    p: function (e, o) {
      if (66944 & o[0] && (l = !e[8].readOnly && (e[10] === Ir || e[16] && Fs(e[7]))), l ? c ? (c.p(e, o), 66944 & o[0] && qo(c, 1)) : ((c = Zp(e)).c(), qo(c, 1), c.m(n, t)) : c && (Ro(), Po(c, 1, 1, function () {
        c = null;
      }), Eo()), 38013439 & o[0]) {
        var i;
        for (u = Ao(e[18](e[1], e[0], e[2], e[3], e[4], e[5], e[6], e[7], e[11])), i = 0; i < u.length; i += 1) {
          var a = Op(e, u, i);
          d[i] ? (d[i].p(a, o), qo(d[i], 1)) : (d[i] = em(a), d[i].c(), qo(d[i], 1), d[i].m(n, null));
        }
        for (Ro(), i = u.length; i < d.length; i += 1) v(i);
        Eo();
      }
      e[17] ? p && (p.d(1), p = null) : p ? p.p(e, o) : ((p = nm(e)).c(), p.m(r, null));
    },
    i: function (e) {
      if (!s) {
        qo(c);
        for (var n = 0; n < u.length; n += 1) qo(d[n]);
        s = !0;
      }
    },
    o: function (e) {
      Po(c), d = d.filter(Boolean);
      for (var n = 0; n < d.length; n += 1) Po(d[n]);
      s = !1;
    },
    d: function (e) {
      e && (Et(n), Et(o), Et(r)), c && c.d(), qt(d, e), p && p.d();
    }
  };
}
function Zp(e) {
  var n, t, o;
  return t = new Xv({
    props: {
      selected: e[16] && Fs(e[7]),
      onContextMenu: e[30]
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "class", "jse-insert-area jse-inside svelte-6mjnsm"), Ut(n, "data-type", "insert-selection-area-inside"), Ut(n, "title", qr), Yt(n, "jse-hovered", e[10] === Ir), Yt(n, "jse-selected", e[16] && Fs(e[7])), Wt(n, "--level", e[1].length + 1);
    },
    m: function (e, r) {
      Rt(e, n, r), Vo(t, n, null), o = !0;
    },
    p: function (e, r) {
      var i = {};
      65664 & r[0] && (i.selected = e[16] && Fs(e[7])), t.$set(i), (!o || 1024 & r[0]) && Yt(n, "jse-hovered", e[10] === Ir), (!o || 65664 & r[0]) && Yt(n, "jse-selected", e[16] && Fs(e[7])), 2 & r[0] && Wt(n, "--level", e[1].length + 1);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function Xp(e) {
  var n, t, o, r;
  return t = new lp({
    props: {
      path: e[52].path,
      key: e[52].key,
      selection: e[52].selection,
      searchResultItems: e[52].keySearchResultItemsMap,
      context: e[8],
      onUpdateKey: e[22]
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), o = At(), Ut(n, "slot", "identifier"), Ut(n, "class", "jse-identifier svelte-6mjnsm");
    },
    m: function (e, i) {
      Rt(e, n, i), Vo(t, n, null), Ct(n, o), r = !0;
    },
    p: function (e, n) {
      var o = {};
      2303 & n[0] && (o.path = e[52].path), 2303 & n[0] && (o.key = e[52].key), 2303 & n[0] && (o.selection = e[52].selection), 2303 & n[0] && (o.searchResultItems = e[52].keySearchResultItemsMap), 256 & n[0] && (o.context = e[8]), t.$set(o);
    },
    i: function (e) {
      r || (qo(t.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function em(e) {
  var n, t;
  return n = new xm({
    props: {
      value: e[52].value,
      path: e[52].path,
      expandedMap: e[52].expandedMap,
      enforceStringMap: e[52].enforceStringMap,
      visibleSectionsMap: e[52].visibleSectionsMap,
      validationErrorsMap: e[52].validationErrorsMap,
      searchResultItemsMap: e[52].valueSearchResultItemsMap,
      selection: e[52].selection,
      context: e[8],
      onDragSelectionStart: e[25],
      $$slots: {
        identifier: [Xp]
      },
      $$scope: {
        ctx: e
      }
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      2303 & t[0] && (o.value = e[52].value), 2303 & t[0] && (o.path = e[52].path), 2303 & t[0] && (o.expandedMap = e[52].expandedMap), 2303 & t[0] && (o.enforceStringMap = e[52].enforceStringMap), 2303 & t[0] && (o.visibleSectionsMap = e[52].visibleSectionsMap), 2303 & t[0] && (o.validationErrorsMap = e[52].validationErrorsMap), 2303 & t[0] && (o.searchResultItemsMap = e[52].valueSearchResultItemsMap), 2303 & t[0] && (o.selection = e[52].selection), 256 & t[0] && (o.context = e[8]), 2559 & t[0] | 8 & t[1] && (o.$$scope = {
        dirty: t,
        ctx: e
      }), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function nm(e) {
  var n, t, o;
  return {
    c: function () {
      Ut(n = Pt("div"), "role", "none"), Ut(n, "class", "jse-insert-selection-area jse-after svelte-6mjnsm"), Ut(n, "data-type", "insert-selection-area-after");
    },
    m: function (r, i) {
      Rt(r, n, i), t || (o = Bt(n, "click", e[29]), t = !0);
    },
    p: nt,
    d: function (e) {
      e && Et(n), t = !1, o();
    }
  };
}
function tm(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: ze
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function om(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: Oe
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function rm(e) {
  var n;
  return {
    c: function () {
      (n = Pt("div")).textContent = ":", Ut(n, "class", "jse-separator svelte-6mjnsm");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function im(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d = e[0].length + "",
    f = 1 === e[0].length ? "item" : "items";
  return {
    c: function () {
      (n = Pt("div")).textContent = "[", t = At(), o = Pt("button"), r = Tt(d), i = At(), a = Tt(f), s = At(), (l = Pt("div")).textContent = "]", Ut(n, "class", "jse-bracket svelte-6mjnsm"), Ut(o, "type", "button"), Ut(o, "class", "jse-tag svelte-6mjnsm"), Ut(l, "class", "jse-bracket svelte-6mjnsm");
    },
    m: function (d, f) {
      Rt(d, n, f), Rt(d, t, f), Rt(d, o, f), Ct(o, r), Ct(o, i), Ct(o, a), Rt(d, s, f), Rt(d, l, f), c || (u = Bt(o, "click", e[21]), c = !0);
    },
    p: function (e, n) {
      1 & n[0] && d !== (d = e[0].length + "") && Ht(r, d), 1 & n[0] && f !== (f = 1 === e[0].length ? "item" : "items") && Ht(a, f);
    },
    d: function (e) {
      e && (Et(n), Et(t), Et(o), Et(s), Et(l)), c = !1, u();
    }
  };
}
function am(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l = e[0].length + "",
    c = 1 === e[0].length ? "item" : "items";
  return {
    c: function () {
      (n = Pt("div")).textContent = "[", t = At(), o = Pt("span"), r = Tt(l), i = At(), a = Tt(c), s = Tt("\n               "), Ut(n, "class", "jse-bracket svelte-6mjnsm"), Ut(o, "class", "jse-tag jse-expanded svelte-6mjnsm");
    },
    m: function (e, l) {
      Rt(e, n, l), Rt(e, t, l), Rt(e, o, l), Ct(o, r), Ct(o, i), Ct(o, a), Rt(e, s, l);
    },
    p: function (e, n) {
      1 & n[0] && l !== (l = e[0].length + "") && Ht(r, l), 1 & n[0] && c !== (c = 1 === e[0].length ? "item" : "items") && Ht(a, c);
    },
    d: function (e) {
      e && (Et(n), Et(t), Et(o), Et(s));
    }
  };
}
function sm(e) {
  var n, t, o;
  return t = new Xv({
    props: {
      selected: !0,
      onContextMenu: e[8].onContextMenu
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "class", "jse-context-menu-pointer-anchor svelte-6mjnsm");
    },
    m: function (e, r) {
      Rt(e, n, r), Vo(t, n, null), o = !0;
    },
    p: function (e, n) {
      var o = {};
      256 & n[0] && (o.onContextMenu = e[8].onContextMenu), t.$set(o);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function lm(e) {
  var n, t;
  return n = new kp({
    props: {
      validationError: e[15],
      onExpand: e[21]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      32768 & t[0] && (o.validationError = e[15]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function cm(e) {
  var n, t, o;
  return {
    c: function () {
      Ut(n = Pt("div"), "role", "none"), Ut(n, "class", "jse-insert-selection-area jse-after svelte-6mjnsm"), Ut(n, "data-type", "insert-selection-area-after");
    },
    m: function (r, i) {
      Rt(r, n, i), t || (o = Bt(n, "click", e[29]), t = !0);
    },
    p: nt,
    d: function (e) {
      e && Et(n), t = !1, o();
    }
  };
}
function um(e) {
  var n, t, o;
  return {
    c: function () {
      Ut(n = Pt("div"), "role", "none"), Ut(n, "class", "jse-insert-selection-area jse-inside svelte-6mjnsm"), Ut(n, "data-type", "insert-selection-area-inside");
    },
    m: function (r, i) {
      Rt(r, n, i), t || (o = Bt(n, "click", e[28]), t = !0);
    },
    p: nt,
    d: function (e) {
      e && Et(n), t = !1, o();
    }
  };
}
function dm(e) {
  for (var n, t, o, r, i, a, s, l = !e[8].readOnly && (e[10] === Ir || e[16] && Fs(e[7])), c = [], u = new Map(), d = l && fm(e), f = Ao(e[14] || $r), v = function (e) {
      return e[48];
    }, p = 0; p < f.length; p += 1) {
    var m = Ep(e, f, p),
      g = v(m);
    u.set(g, c[p] = gm(g, m));
  }
  var h = !e[17] && hm(e);
  return {
    c: function () {
      n = Pt("div"), d && d.c(), t = At();
      for (var e = 0; e < c.length; e += 1) c[e].c();
      o = At(), r = Pt("div"), (i = Pt("div")).innerHTML = '<span class="jse-bracket svelte-6mjnsm">]</span>', a = At(), h && h.c(), Ut(n, "class", "jse-items svelte-6mjnsm"), Ut(i, "data-type", "selectable-value"), Ut(i, "class", "jse-footer svelte-6mjnsm"), Ut(r, "class", "jse-footer-outer svelte-6mjnsm");
    },
    m: function (e, l) {
      Rt(e, n, l), d && d.m(n, null), Ct(n, t);
      for (var u = 0; u < c.length; u += 1) c[u] && c[u].m(n, null);
      Rt(e, o, l), Rt(e, r, l), Ct(r, i), Ct(r, a), h && h.m(r, null), s = !0;
    },
    p: function (e, o) {
      66944 & o[0] && (l = !e[8].readOnly && (e[10] === Ir || e[16] && Fs(e[7]))), l ? d ? (d.p(e, o), 66944 & o[0] && qo(d, 1)) : ((d = fm(e)).c(), qo(d, 1), d.m(n, t)) : d && (Ro(), Po(d, 1, 1, function () {
        d = null;
      }), Eo()), 34097663 & o[0] && (f = Ao(e[14] || $r), Ro(), c = Fo(c, o, v, 0, e, f, u, n, Bo, gm, null, Ep), Eo()), e[17] ? h && (h.d(1), h = null) : h ? h.p(e, o) : ((h = hm(e)).c(), h.m(r, null));
    },
    i: function (e) {
      if (!s) {
        qo(d);
        for (var n = 0; n < f.length; n += 1) qo(c[n]);
        s = !0;
      }
    },
    o: function (e) {
      Po(d);
      for (var n = 0; n < c.length; n += 1) Po(c[n]);
      s = !1;
    },
    d: function (e) {
      e && (Et(n), Et(o), Et(r)), d && d.d();
      for (var t = 0; t < c.length; t += 1) c[t].d();
      h && h.d();
    }
  };
}
function fm(e) {
  var n, t, o;
  return t = new Xv({
    props: {
      selected: e[16] && Fs(e[7]),
      onContextMenu: e[30]
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "class", "jse-insert-area jse-inside svelte-6mjnsm"), Ut(n, "data-type", "insert-selection-area-inside"), Ut(n, "title", qr), Yt(n, "jse-hovered", e[10] === Ir), Yt(n, "jse-selected", e[16] && Fs(e[7])), Wt(n, "--level", e[1].length + 1);
    },
    m: function (e, r) {
      Rt(e, n, r), Vo(t, n, null), o = !0;
    },
    p: function (e, r) {
      var i = {};
      65664 & r[0] && (i.selected = e[16] && Fs(e[7])), t.$set(i), (!o || 1024 & r[0]) && Yt(n, "jse-hovered", e[10] === Ir), (!o || 65664 & r[0]) && Yt(n, "jse-selected", e[16] && Fs(e[7])), 2 & r[0] && Wt(n, "--level", e[1].length + 1);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function vm(e) {
  var n,
    t,
    o,
    r = e[49].index + "";
  return {
    c: function () {
      n = Pt("div"), t = Pt("div"), o = Tt(r), Ut(t, "class", "jse-index svelte-6mjnsm"), Ut(n, "slot", "identifier"), Ut(n, "class", "jse-identifier svelte-6mjnsm");
    },
    m: function (e, r) {
      Rt(e, n, r), Ct(n, t), Ct(t, o);
    },
    p: function (e, n) {
      18687 & n[0] && r !== (r = e[49].index + "") && Ht(o, r);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function pm(e, n) {
  var t, o, r;
  return o = new xm({
    props: {
      value: n[49].value,
      path: n[49].path,
      expandedMap: n[49].expandedMap,
      enforceStringMap: n[49].enforceStringMap,
      visibleSectionsMap: n[49].visibleSectionsMap,
      validationErrorsMap: n[49].validationErrorsMap,
      searchResultItemsMap: n[49].searchResultItemsMap,
      selection: n[49].selection,
      context: n[8],
      onDragSelectionStart: n[25],
      $$slots: {
        identifier: [vm]
      },
      $$scope: {
        ctx: n
      }
    }
  }), {
    key: e,
    first: null,
    c: function () {
      t = Nt(), Jo(o.$$.fragment), this.first = t;
    },
    m: function (e, n) {
      Rt(e, t, n), Vo(o, e, n), r = !0;
    },
    p: function (e, t) {
      n = e;
      var r = {};
      18687 & t[0] && (r.value = n[49].value), 18687 & t[0] && (r.path = n[49].path), 18687 & t[0] && (r.expandedMap = n[49].expandedMap), 18687 & t[0] && (r.enforceStringMap = n[49].enforceStringMap), 18687 & t[0] && (r.visibleSectionsMap = n[49].visibleSectionsMap), 18687 & t[0] && (r.validationErrorsMap = n[49].validationErrorsMap), 18687 & t[0] && (r.searchResultItemsMap = n[49].searchResultItemsMap), 18687 & t[0] && (r.selection = n[49].selection), 256 & t[0] && (r.context = n[8]), 18687 & t[0] | 8 & t[1] && (r.$$scope = {
        dirty: t,
        ctx: n
      }), o.$set(r);
    },
    i: function (e) {
      r || (qo(o.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(o.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(t), Ho(o, e);
    }
  };
}
function mm(e) {
  var n, t;
  return n = new Yv({
    props: {
      visibleSections: e[14] || $r,
      sectionIndex: e[48],
      total: e[0].length,
      path: e[1],
      onExpandSection: e[8].onExpandSection,
      selection: e[7],
      context: e[8]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      16384 & t[0] && (o.visibleSections = e[14] || $r), 16384 & t[0] && (o.sectionIndex = e[48]), 1 & t[0] && (o.total = e[0].length), 2 & t[0] && (o.path = e[1]), 256 & t[0] && (o.onExpandSection = e[8].onExpandSection), 128 & t[0] && (o.selection = e[7]), 256 & t[0] && (o.context = e[8]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function gm(e, n) {
  for (var t, o, r, i, a = [], s = new Map(), l = Ao(n[19](n[1], n[0], n[46], n[2], n[3], n[4], n[5], n[6], n[7], n[11])), c = function (e) {
      return e[49].index;
    }, u = 0; u < l.length; u += 1) {
    var d = qp(n, l, u),
      f = c(d);
    s.set(f, a[u] = pm(f, d));
  }
  var v = n[46].end < n[0].length && mm(n);
  return {
    key: e,
    first: null,
    c: function () {
      t = Nt();
      for (var e = 0; e < a.length; e += 1) a[e].c();
      o = At(), v && v.c(), r = Nt(), this.first = t;
    },
    m: function (e, n) {
      Rt(e, t, n);
      for (var s = 0; s < a.length; s += 1) a[s] && a[s].m(e, n);
      Rt(e, o, n), v && v.m(e, n), Rt(e, r, n), i = !0;
    },
    p: function (e, t) {
      n = e, 34097663 & t[0] && (l = Ao(n[19](n[1], n[0], n[46], n[2], n[3], n[4], n[5], n[6], n[7], n[11])), Ro(), a = Fo(a, t, c, 0, n, l, s, o.parentNode, Bo, pm, o, qp), Eo()), n[46].end < n[0].length ? v ? (v.p(n, t), 16385 & t[0] && qo(v, 1)) : ((v = mm(n)).c(), qo(v, 1), v.m(r.parentNode, r)) : v && (Ro(), Po(v, 1, 1, function () {
        v = null;
      }), Eo());
    },
    i: function (e) {
      if (!i) {
        for (var n = 0; n < l.length; n += 1) qo(a[n]);
        qo(v), i = !0;
      }
    },
    o: function (e) {
      for (var n = 0; n < a.length; n += 1) Po(a[n]);
      Po(v), i = !1;
    },
    d: function (e) {
      e && (Et(t), Et(o), Et(r));
      for (var n = 0; n < a.length; n += 1) a[n].d(e);
      v && v.d(e);
    }
  };
}
function hm(e) {
  var n, t, o;
  return {
    c: function () {
      Ut(n = Pt("div"), "role", "none"), Ut(n, "class", "jse-insert-selection-area jse-after svelte-6mjnsm"), Ut(n, "data-type", "insert-selection-area-after");
    },
    m: function (r, i) {
      Rt(r, n, i), t || (o = Bt(n, "click", e[29]), t = !0);
    },
    p: nt,
    d: function (e) {
      e && Et(n), t = !1, o();
    }
  };
}
function jm(e) {
  var n, t, o;
  return t = new Xv({
    props: {
      selected: e[16] && Bs(e[7]),
      onContextMenu: e[31]
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "class", "jse-insert-area jse-after svelte-6mjnsm"), Ut(n, "data-type", "insert-selection-area-after"), Ut(n, "title", qr), Yt(n, "jse-hovered", e[10] === Tr), Yt(n, "jse-selected", e[16] && Bs(e[7]));
    },
    m: function (e, r) {
      Rt(e, n, r), Vo(t, n, null), o = !0;
    },
    p: function (e, r) {
      var i = {};
      65664 & r[0] && (i.selected = e[16] && Bs(e[7])), t.$set(i), (!o || 1024 & r[0]) && Yt(n, "jse-hovered", e[10] === Tr), (!o || 65664 & r[0]) && Yt(n, "jse-selected", e[16] && Bs(e[7]));
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function bm(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f = !e[8].readOnly && (e[10] === Tr || e[16] && Bs(e[7])),
    v = [Np, Ap, Tp],
    p = [];
  function m(e, n) {
    return 1 & n[0] && (t = null), 1 & n[0] && (o = null), null == t && (t = !!Array.isArray(e[0])), t ? 0 : (null == o && (o = !!Qr(e[0])), o ? 1 : 2);
  }
  r = m(e, [-1, -1]), i = p[r] = v[r](e);
  var g = f && jm(e);
  return {
    c: function () {
      n = Pt("div"), i.c(), a = At(), g && g.c(), Ut(n, "role", "treeitem"), Ut(n, "tabindex", "-1"), Ut(n, "class", s = ht(xl("jse-json-node", {
        "jse-expanded": e[12]
      }, e[8].onClassName(e[1], e[0]))) + " svelte-6mjnsm"), Ut(n, "data-path", l = ta(e[1])), Ut(n, "aria-selected", e[16]), Yt(n, "jse-root", e[17]), Yt(n, "jse-selected", e[16] && Ds(e[7])), Yt(n, "jse-selected-key", e[16] && Ls(e[7])), Yt(n, "jse-selected-value", e[16] && Us(e[7])), Yt(n, "jse-readonly", e[8].readOnly), Yt(n, "jse-hovered", e[10] === Ar), Wt(n, "--level", e[1].length);
    },
    m: function (t, o) {
      Rt(t, n, o), p[r].m(n, null), Ct(n, a), g && g.m(n, null), c = !0, u || (d = [Bt(n, "mousedown", e[23]), Bt(n, "mousemove", e[24]), Bt(n, "mouseover", e[26]), Bt(n, "mouseout", e[27]), Bt(n, "focus", void 0), Bt(n, "blur", void 0)], u = !0);
    },
    p: function (e, t) {
      var o = r;
      (r = m(e, t)) === o ? p[r].p(e, t) : (Ro(), Po(p[o], 1, 1, function () {
        p[o] = null;
      }), Eo(), (i = p[r]) ? i.p(e, t) : (i = p[r] = v[r](e)).c(), qo(i, 1), i.m(n, a)), 66944 & t[0] && (f = !e[8].readOnly && (e[10] === Tr || e[16] && Bs(e[7]))), f ? g ? (g.p(e, t), 66944 & t[0] && qo(g, 1)) : ((g = jm(e)).c(), qo(g, 1), g.m(n, null)) : g && (Ro(), Po(g, 1, 1, function () {
        g = null;
      }), Eo()), (!c || 4355 & t[0] && s !== (s = ht(xl("jse-json-node", {
        "jse-expanded": e[12]
      }, e[8].onClassName(e[1], e[0]))) + " svelte-6mjnsm")) && Ut(n, "class", s), (!c || 2 & t[0] && l !== (l = ta(e[1]))) && Ut(n, "data-path", l), (!c || 65536 & t[0]) && Ut(n, "aria-selected", e[16]), (!c || 135427 & t[0]) && Yt(n, "jse-root", e[17]), (!c || 70019 & t[0]) && Yt(n, "jse-selected", e[16] && Ds(e[7])), (!c || 70019 & t[0]) && Yt(n, "jse-selected-key", e[16] && Ls(e[7])), (!c || 70019 & t[0]) && Yt(n, "jse-selected-value", e[16] && Us(e[7])), (!c || 4355 & t[0]) && Yt(n, "jse-readonly", e[8].readOnly), (!c || 5379 & t[0]) && Yt(n, "jse-hovered", e[10] === Ar), 2 & t[0] && Wt(n, "--level", e[1].length);
    },
    i: function (e) {
      c || (qo(i), qo(g), c = !0);
    },
    o: function (e) {
      Po(i), Po(g), c = !1;
    },
    d: function (e) {
      e && Et(n), p[r].d(), g && g.d(), u = !1, at(d);
    }
  };
}
function ym(e, n, t) {
  var o,
    r,
    i,
    a,
    s,
    l,
    c,
    u = n.$$slots,
    d = void 0 === u ? {} : u,
    f = n.$$scope,
    v = n.value,
    p = n.path,
    m = n.expandedMap,
    h = n.enforceStringMap,
    j = n.visibleSectionsMap,
    b = n.validationErrorsMap,
    y = n.searchResultItemsMap,
    x = n.selection,
    w = n.context,
    $ = n.onDragSelectionStart,
    k = Qo("jsoneditor:JSONNode"),
    C = void 0,
    S = void 0,
    z = void 0,
    R = K(function (e) {
      return e;
    }, $a);
  function E(e) {
    w.onDrag(e);
  }
  function q(e) {
    jp.selecting && (jp.selecting = !1, e.stopPropagation()), w.onDragEnd(), document.removeEventListener("mousemove", E, !0), document.removeEventListener("mouseup", q);
  }
  function P() {
    var e;
    return (null === (e = w.findElement([])) || void 0 === e || null === (e = e.getBoundingClientRect()) || void 0 === e ? void 0 : e.top) || 0;
  }
  function I(e, n) {
    var t = P() - e.initialContentTop;
    return n.clientY - e.initialClientY - t;
  }
  function T(e) {
    if (z) {
      var n = w.getJson();
      if (void 0 === n) return;
      var o = w.getDocumentState(),
        r = I(z, e),
        i = bp({
          json: n,
          documentState: o,
          deltaY: r,
          items: z.items
        }).offset;
      i !== z.offset && (k("drag selection", i, r), t(11, z = g(g({}, z), {}, {
        offset: i,
        didMoveItems: !0
      })));
    }
  }
  function A(e) {
    if (z) {
      var n = w.getJson();
      if (void 0 === n) return;
      var o = bp({
          json: n,
          documentState: w.getDocumentState(),
          deltaY: I(z, e),
          items: z.items
        }),
        r = o.operations,
        i = o.updatedSelection;
      if (r) w.onPatch(r, function (e, n) {
        return {
          state: g(g({}, n), {}, {
            selection: i || x
          })
        };
      });else if (e.target === z.initialTarget && !z.didMoveItems) {
        var a = na(e.target),
          s = oa(e.target);
        s && w.onSelect(ml(0, a, s));
      }
      t(11, z = void 0), jp.dragging = !1, document.removeEventListener("mousemove", T, !0), document.removeEventListener("mouseup", A);
    }
  }
  return e.$$set = function (e) {
    "value" in e && t(0, v = e.value), "path" in e && t(1, p = e.path), "expandedMap" in e && t(2, m = e.expandedMap), "enforceStringMap" in e && t(3, h = e.enforceStringMap), "visibleSectionsMap" in e && t(4, j = e.visibleSectionsMap), "validationErrorsMap" in e && t(5, b = e.validationErrorsMap), "searchResultItemsMap" in e && t(6, y = e.searchResultItemsMap), "selection" in e && t(7, x = e.selection), "context" in e && t(8, w = e.context), "onDragSelectionStart" in e && t(32, $ = e.onDragSelectionStart), "$$scope" in e && t(34, f = e.$$scope);
  }, e.$$.update = function () {
    2 & e.$$.dirty[0] && t(9, r = O(p)), 516 & e.$$.dirty[0] && t(12, i = !!m && !0 === m[r]), 777 & e.$$.dirty[0] && t(13, a = Rs(v, h, r, w.parser)), 528 & e.$$.dirty[0] && t(14, s = j ? j[r] : void 0), 544 & e.$$.dirty[0] && t(15, l = b ? b[r] : void 0), 386 & e.$$.dirty[0] && t(16, c = hl(w.getJson(), x, p)), 2 & e.$$.dirty[0] && t(17, o = 0 === p.length);
  }, [v, p, m, h, j, b, y, x, w, r, C, z, i, a, s, l, c, o, function (e, n, t, o, i, a, s, l, c) {
    var u = Object.keys(n).map(function (c) {
      var u = R(e.concat(c)),
        d = J(r, c);
      return {
        key: c,
        value: n[c],
        path: u,
        expandedMap: yp(t, d),
        enforceStringMap: yp(o, d),
        visibleSectionsMap: yp(i, d),
        validationErrorsMap: yp(a, d),
        keySearchResultItemsMap: Kl(s, d),
        valueSearchResultItemsMap: yp(s, d),
        selection: gl(w.getJson(), l, u)
      };
    });
    return c && 0 !== c.offset && (u = fi(u, c.selectionStartIndex, c.selectionItemsCount, c.offset)), u;
  }, function (e, n, t, o, i, a, s, l, c, u) {
    for (var d = t.start, f = Math.min(t.end, n.length), v = [], p = d; p < f; p++) {
      var m = R(e.concat(String(p))),
        g = J(r, p);
      v.push({
        index: p,
        value: n[p],
        path: m,
        expandedMap: yp(o, g),
        enforceStringMap: yp(i, g),
        visibleSectionsMap: yp(a, g),
        validationErrorsMap: yp(s, g),
        searchResultItemsMap: yp(l, g),
        selection: gl(w.getJson(), c, m)
      });
    }
    if (u && 0 !== u.offset) {
      var h = v.map(function (e) {
        return e.index;
      });
      v = fi(v, u.selectionStartIndex, u.selectionItemsCount, u.offset);
      for (var j = 0; j < v.length; j++) v[j].index = h[j];
    }
    return v;
  }, function (e) {
    e.stopPropagation();
    var n = la(e);
    w.onExpand(p, !i, n);
  }, function (e) {
    e.stopPropagation(), w.onExpand(p, !0);
  }, function (e, n) {
    var t = ql(p, Object.keys(v), e, n);
    return w.onPatch(t), ee(M(t[0].path));
  }, function (e) {
    if ((1 === e.buttons || 2 === e.buttons) && !(function (e) {
      return "DIV" === e.nodeName && "true" === e.contentEditable;
    }(e.target) || 1 === e.buttons && _i(e.target, "BUTTON"))) {
      e.stopPropagation(), e.preventDefault(), w.focus(), document.addEventListener("mousemove", E, !0), document.addEventListener("mouseup", q);
      var n = na(e.target),
        t = w.getJson(),
        r = w.getDocumentState();
      if (!x || n === lr.after || n === lr.inside || x.type !== n && x.type !== lr.multi || !hl(t, x, p)) {
        if (jp.selecting = !0, jp.selectionAnchor = p, jp.selectionAnchorType = n, jp.selectionFocus = p, e.shiftKey) {
          var i = w.getDocumentState().selection;
          i && w.onSelect(cl(yl(i), p));
        } else if (n === lr.multi) {
          if (o && e.target.hasAttribute("data-path")) {
            var a = ee(Ps(v, r));
            w.onSelect(pl(a));
          } else w.onSelect(cl(p, p));
        } else void 0 !== t && w.onSelect(ml(0, n, p));
      } else 0 === e.button && $(e);
    }
  }, function (e) {
    if (jp.selecting) {
      e.preventDefault(), e.stopPropagation(), null == jp.selectionFocus && window.getSelection && window.getSelection().empty();
      var n = na(e.target);
      ne(p, jp.selectionFocus) && n === jp.selectionAnchorType || (jp.selectionFocus = p, jp.selectionAnchorType = n, w.onSelect(cl(jp.selectionAnchor || jp.selectionFocus, jp.selectionFocus)));
    }
  }, function (e) {
    if (!w.readOnly && x) {
      var n = X(bl(x));
      if (ne(p, n)) {
        var o = function (e, n) {
          var t = [];
          function o(e) {
            var n = p.concat(e),
              o = w.findElement(n);
            null != o && t.push({
              path: n,
              height: o.clientHeight
            });
          }
          if (Array.isArray(v)) {
            var r = w.getJson();
            if (void 0 === r) return null;
            var i = Qs(r, e),
              a = Ys(r, e),
              s = parseInt(ee(i), 10),
              l = parseInt(ee(a), 10),
              c = n.find(function (e) {
                return s >= e.start && l <= e.end;
              });
            if (!c) return null;
            var u = c.start,
              d = c.end;
            li(u, Math.min(v.length, d), function (e) {
              return o(String(e));
            });
          } else Object.keys(v).forEach(o);
          return t;
        }(x, s || $r);
        if (k("dragSelectionStart", {
          selection: x,
          items: o
        }), o) {
          var r = w.getJson();
          if (void 0 !== r) {
            var i = Qs(r, x),
              a = o.findIndex(function (e) {
                return ne(e.path, i);
              }),
              l = bp({
                json: r,
                documentState: w.getDocumentState(),
                deltaY: 0,
                items: o
              }).offset;
            t(11, z = {
              initialTarget: e.target,
              initialClientY: e.clientY,
              initialContentTop: P(),
              selectionStartIndex: a,
              selectionItemsCount: _s(r, x).length,
              items: o,
              offset: l,
              didMoveItems: !1
            }), jp.dragging = !0, document.addEventListener("mousemove", T, !0), document.addEventListener("mouseup", A);
          }
        } else k("Cannot drag the current selection (probably spread over multiple sections)");
      } else $(e);
    }
  }, function (e) {
    jp.selecting || jp.dragging || (e.stopPropagation(), Wi(e.target, "data-type", "selectable-value") ? t(10, C = Ar) : Wi(e.target, "data-type", "insert-selection-area-inside") ? t(10, C = Ir) : Wi(e.target, "data-type", "insert-selection-area-after") && t(10, C = Tr), clearTimeout(S));
  }, function (e) {
    e.stopPropagation(), S = window.setTimeout(function () {
      return t(10, C = void 0);
    });
  }, function (e) {
    e.shiftKey || (e.stopPropagation(), e.preventDefault(), w.onSelect(sl(p)));
  }, function (e) {
    e.shiftKey || (e.stopPropagation(), e.preventDefault(), w.onSelect(ll(p)));
  }, function (e) {
    w.onSelect(sl(p)), w.onContextMenu(e);
  }, function (e) {
    w.onSelect(ll(p)), w.onContextMenu(e);
  }, $, d, f];
}
var xm = function (e) {
    function n(e) {
      var t;
      return h(this, n), _o(t = u(this, n), e, ym, bm, ct, {
        value: 0,
        path: 1,
        expandedMap: 2,
        enforceStringMap: 3,
        visibleSectionsMap: 4,
        validationErrorsMap: 5,
        searchResultItemsMap: 6,
        selection: 7,
        context: 8,
        onDragSelectionStart: 32
      }, Cp, [-1, -1]), t;
    }
    return v(n, Wo), b(n);
  }(),
  wm = {
    prefix: "fas",
    iconName: "jsoneditor-expand",
    icon: [512, 512, [], "", "M 0,448 V 512 h 512 v -64 z M 0,0 V 64 H 512 V 0 Z M 256,96 128,224 h 256 z M 256,416 384,288 H 128 Z"]
  },
  $m = {
    prefix: "fas",
    iconName: "jsoneditor-collapse",
    icon: [512, 512, [], "", "m 0,224 v 64 h 512 v -64 z M 256,192 384,64 H 128 Z M 256,320 128,448 h 256 z"]
  },
  km = {
    prefix: "fas",
    iconName: "jsoneditor-format",
    icon: [512, 512, [], "", "M 0,32 v 64 h 416 v -64 z M 160,160 v 64 h 352 v -64 z M 160,288 v 64 h 288 v -64 z M 0,416 v 64 h 320 v -64 z"]
  },
  Cm = {
    prefix: "fas",
    iconName: "jsoneditor-compact",
    icon: [512, 512, [], "", "M 0,32 v 64 h 512 v -64 z M 0,160 v 64 h 512 v -64 z M 0,288 v 64 h 352 v -64 z"]
  };
function Sm(e) {
  var n, t;
  return n = new Ev({
    props: {
      items: e[0]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & s(t, 1)[0] && (o.items = e[0]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Mm(e, n, t) {
  var o,
    r,
    i,
    a,
    s,
    l,
    c,
    u = n.json,
    d = n.selection,
    f = n.readOnly,
    v = n.showSearch,
    p = void 0 !== v && v,
    m = n.historyState,
    g = n.onExpandAll,
    h = n.onCollapseAll,
    j = n.onUndo,
    b = n.onRedo,
    y = n.onSort,
    x = n.onTransform,
    w = n.onContextMenu,
    $ = n.onCopy,
    k = n.onRenderMenu;
  function C() {
    t(1, p = !p);
  }
  return e.$$set = function (e) {
    "json" in e && t(2, u = e.json), "selection" in e && t(3, d = e.selection), "readOnly" in e && t(4, f = e.readOnly), "showSearch" in e && t(1, p = e.showSearch), "historyState" in e && t(5, m = e.historyState), "onExpandAll" in e && t(6, g = e.onExpandAll), "onCollapseAll" in e && t(7, h = e.onCollapseAll), "onUndo" in e && t(8, j = e.onUndo), "onRedo" in e && t(9, b = e.onRedo), "onSort" in e && t(10, y = e.onSort), "onTransform" in e && t(11, x = e.onTransform), "onContextMenu" in e && t(12, w = e.onContextMenu), "onCopy" in e && t(13, $ = e.onCopy), "onRenderMenu" in e && t(14, k = e.onRenderMenu);
  }, e.$$.update = function () {
    4 & e.$$.dirty && t(20, o = void 0 !== u), 1048584 & e.$$.dirty && t(19, r = o && (Ds(d) || Ls(d) || Us(d))), 68 & e.$$.dirty && t(15, a = {
      type: "button",
      icon: wm,
      title: "Expand all",
      className: "jse-expand-all",
      onClick: g,
      disabled: !Yr(u)
    }), 132 & e.$$.dirty && t(16, s = {
      type: "button",
      icon: $m,
      title: "Collapse all",
      className: "jse-collapse-all",
      onClick: h,
      disabled: !Yr(u)
    }), 4 & e.$$.dirty && t(17, l = {
      type: "button",
      icon: Re,
      title: "Search (Ctrl+F)",
      className: "jse-search",
      onClick: C,
      disabled: void 0 === u
    }), 769844 & e.$$.dirty && t(18, c = f ? [a, s, {
      type: "separator"
    }, {
      type: "button",
      icon: Ae,
      title: "Copy (Ctrl+C)",
      className: "jse-copy",
      onClick: $,
      disabled: !r
    }, {
      type: "separator"
    }, l, {
      type: "space"
    }] : [a, s, {
      type: "separator"
    }, {
      type: "button",
      icon: Ee,
      title: "Sort",
      className: "jse-sort",
      onClick: y,
      disabled: f || void 0 === u
    }, {
      type: "button",
      icon: qe,
      title: "Transform contents (filter, sort, project)",
      className: "jse-transform",
      onClick: x,
      disabled: f || void 0 === u
    }, l, {
      type: "button",
      icon: Pe,
      title: Pr,
      className: "jse-contextmenu",
      onClick: w
    }, {
      type: "separator"
    }, {
      type: "button",
      icon: Ie,
      title: "Undo (Ctrl+Z)",
      className: "jse-undo",
      onClick: j,
      disabled: !m.canUndo
    }, {
      type: "button",
      icon: Te,
      title: "Redo (Ctrl+Shift+Z)",
      className: "jse-redo",
      onClick: b,
      disabled: !m.canRedo
    }, {
      type: "space"
    }]), 278528 & e.$$.dirty && t(0, i = k(c));
  }, [i, p, u, d, f, m, g, h, j, b, y, x, w, $, k, a, s, l, c, r, o];
}
var Om = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Mm, Sm, ct, {
      json: 2,
      selection: 3,
      readOnly: 4,
      showSearch: 1,
      historyState: 5,
      onExpandAll: 6,
      onCollapseAll: 7,
      onUndo: 8,
      onRedo: 9,
      onSort: 10,
      onTransform: 11,
      onContextMenu: 12,
      onCopy: 13,
      onRenderMenu: 14
    }), t;
  }
  return v(n, Wo), b(n);
}();
function zm(e) {
  St(e, "svelte-s2toti", '.jse-welcome.svelte-s2toti.svelte-s2toti{flex:1;overflow:auto;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);display:flex;flex-direction:column;align-items:center;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-welcome.svelte-s2toti.svelte-s2toti:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-welcome.svelte-s2toti .jse-space.jse-before.svelte-s2toti{flex:1}.jse-welcome.svelte-s2toti .jse-space.jse-after.svelte-s2toti{flex:2}.jse-welcome.svelte-s2toti .jse-contents.svelte-s2toti{display:flex;flex-direction:column;max-width:300px;margin:2em var(--jse-padding, 10px);gap:var(--jse-padding, 10px)}.jse-welcome.svelte-s2toti .jse-contents .jse-welcome-info.svelte-s2toti{color:var(--jse-panel-color-readonly, #b2b2b2)}.jse-welcome.svelte-s2toti .jse-contents button.svelte-s2toti{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-welcome.svelte-s2toti .jse-contents button.svelte-s2toti:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-welcome.svelte-s2toti .jse-contents button.svelte-s2toti:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}');
}
function Rm(e) {
  var n, t, o, r, i, a, s;
  return {
    c: function () {
      (n = Pt("div")).innerHTML = "You can paste clipboard data using <b>Ctrl+V</b>, or use the following options:", t = At(), (o = Pt("button")).textContent = "Create object", r = At(), (i = Pt("button")).textContent = "Create array", Ut(n, "class", "jse-welcome-info svelte-s2toti"), Ut(o, "title", "Create an empty JSON object (press '{')"), Ut(o, "class", "svelte-s2toti"), Ut(i, "title", "Create an empty JSON array (press '[')"), Ut(i, "class", "svelte-s2toti");
    },
    m: function (l, c) {
      Rt(l, n, c), Rt(l, t, c), Rt(l, o, c), Rt(l, r, c), Rt(l, i, c), a || (s = [Bt(o, "click", Lt(e[4])), Bt(i, "click", Lt(e[5]))], a = !0);
    },
    p: nt,
    d: function (e) {
      e && (Et(n), Et(t), Et(o), Et(r), Et(i)), a = !1, at(s);
    }
  };
}
function Em(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    l,
    c,
    u,
    d,
    f = !e[0] && Rm(e);
  return {
    c: function () {
      n = Pt("div"), t = Pt("div"), o = At(), r = Pt("div"), (i = Pt("div")).textContent = "Empty document", a = At(), f && f.c(), l = At(), c = Pt("div"), Ut(t, "class", "jse-space jse-before svelte-s2toti"), Ut(i, "class", "jse-welcome-title"), Ut(r, "class", "jse-contents svelte-s2toti"), Ut(c, "class", "jse-space jse-after svelte-s2toti"), Ut(n, "class", "jse-welcome svelte-s2toti"), Ut(n, "role", "none");
    },
    m: function (s, v) {
      Rt(s, n, v), Ct(n, t), Ct(n, o), Ct(n, r), Ct(r, i), Ct(r, a), f && f.m(r, null), Ct(n, l), Ct(n, c), u || (d = Bt(n, "click", e[6]), u = !0);
    },
    p: function (e, n) {
      var t = s(n, 1)[0];
      e[0] ? f && (f.d(1), f = null) : f ? f.p(e, t) : ((f = Rm(e)).c(), f.m(r, null));
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n), f && f.d(), u = !1, d();
    }
  };
}
function qm(e, n, t) {
  var o = n.readOnly,
    r = n.onCreateArray,
    i = n.onCreateObject,
    a = n.onClick;
  return e.$$set = function (e) {
    "readOnly" in e && t(0, o = e.readOnly), "onCreateArray" in e && t(1, r = e.onCreateArray), "onCreateObject" in e && t(2, i = e.onCreateObject), "onClick" in e && t(3, a = e.onClick);
  }, [o, r, i, a, function () {
    return i();
  }, function () {
    return r();
  }, function () {
    return a();
  }];
}
var Pm = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, qm, Em, ct, {
      readOnly: 0,
      onCreateArray: 1,
      onCreateObject: 2,
      onClick: 3
    }, zm), t;
  }
  return v(n, Wo), b(n);
}();
function Im(e, n) {
  var t = "string" == typeof e ? e.toLowerCase() : e,
    o = "string" == typeof n ? n.toLowerCase() : n;
  return an(t, o);
}
function Tm(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
    t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
    o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
  if (N(z(e, n))) {
    if (void 0 === t) throw new Error("Cannot sort: no property selected by which to sort the array");
    return function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
        t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
        o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
        r = function (e, n) {
          return function (t, o) {
            var r = z(t, e),
              i = z(o, e);
            return void 0 === r ? n : void 0 === i ? -n : "string" != typeof r && "string" != typeof i ? r > i ? n : r < i ? -n : 0 : n * Im(r, i);
          };
        }(t, o),
        i = z(e, n);
      return [{
        op: "replace",
        path: O(n),
        value: i.slice(0).sort(r)
      }];
    }(e, n, t, o);
  }
  if (Qr(e)) return function (e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
      t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
      o = z(e, n),
      r = Object.keys(o).slice();
    r.sort(function (e, n) {
      return t * Im(e, n);
    });
    for (var i = [], a = 0; a < r.length; a++) {
      var s = r[a],
        l = O(n.concat(s));
      i.push({
        op: "move",
        from: l,
        path: l
      });
    }
    return i;
  }(e, n, o);
  throw new Error("Cannot sort: no array or object");
}
function Am(e) {
  St(e, "svelte-12glmu0", '.jse-navigation-bar-dropdown.svelte-12glmu0.svelte-12glmu0{position:absolute;top:100%;left:0;z-index:3;background:var(--jse-navigation-bar-background, var(--jse-background-color, #fff));color:var(--jse-navigation-bar-dropdown-color, #656565);box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24));display:flex;flex-direction:column;max-height:300px;overflow:auto;min-width:80px}.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.svelte-12glmu0{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);border:none;background:transparent;color:inherit;cursor:pointer;outline:none;text-align:left;white-space:nowrap;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding, 10px)) 36px}.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.svelte-12glmu0:focus,.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.svelte-12glmu0:hover{background:var(--jse-navigation-bar-background-highlight, #e5e5e5)}.jse-navigation-bar-dropdown.svelte-12glmu0 button.jse-navigation-bar-dropdown-item.jse-selected.svelte-12glmu0{background:var(--jse-navigation-bar-dropdown-color, #656565);color:var(--jse-navigation-bar-background, var(--jse-background-color, #fff))}');
}
function Nm(e, n, t) {
  var o = e.slice();
  return o[4] = n[t], o;
}
function Bm(e, n) {
  var t,
    o,
    r,
    i,
    a,
    s = Ea(n[4].toString(), Dm) + "";
  function l() {
    return n[3](n[4]);
  }
  return {
    key: e,
    first: null,
    c: function () {
      t = Pt("button"), o = Tt(s), Ut(t, "type", "button"), Ut(t, "class", "jse-navigation-bar-dropdown-item svelte-12glmu0"), Ut(t, "title", r = n[4].toString()), Yt(t, "jse-selected", n[4] === n[1]), this.first = t;
    },
    m: function (e, n) {
      Rt(e, t, n), Ct(t, o), i || (a = Bt(t, "click", Lt(l)), i = !0);
    },
    p: function (e, i) {
      n = e, 1 & i && s !== (s = Ea(n[4].toString(), Dm) + "") && Ht(o, s), 1 & i && r !== (r = n[4].toString()) && Ut(t, "title", r), 3 & i && Yt(t, "jse-selected", n[4] === n[1]);
    },
    d: function (e) {
      e && Et(t), i = !1, a();
    }
  };
}
function Fm(e) {
  var n, t;
  return {
    c: function () {
      n = Pt("button"), t = Tt("..."), Ut(n, "type", "button"), Ut(n, "class", "jse-navigation-bar-dropdown-item svelte-12glmu0"), Ut(n, "title", "Limited to " + Um + " items");
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Lm(e) {
  for (var n, t, o = [], r = new Map(), i = Ao(ci(e[0], Um)), a = function (e) {
      return e[4];
    }, l = 0; l < i.length; l += 1) {
    var c = Nm(e, i, l),
      u = a(c);
    r.set(u, o[l] = Bm(u, c));
  }
  var d = e[0].length > Um && Fm();
  return {
    c: function () {
      n = Pt("div");
      for (var e = 0; e < o.length; e += 1) o[e].c();
      t = At(), d && d.c(), Ut(n, "class", "jse-navigation-bar-dropdown svelte-12glmu0");
    },
    m: function (e, r) {
      Rt(e, n, r);
      for (var i = 0; i < o.length; i += 1) o[i] && o[i].m(n, null);
      Ct(n, t), d && d.m(n, null);
    },
    p: function (e, l) {
      var c = s(l, 1)[0];
      7 & c && (i = Ao(ci(e[0], Um)), o = Fo(o, c, a, 0, e, i, r, n, No, Bm, t, Nm)), e[0].length > Um ? d ? d.p(e, c) : ((d = Fm()).c(), d.m(n, null)) : d && (d.d(1), d = null);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
      for (var t = 0; t < o.length; t += 1) o[t].d();
      d && d.d();
    }
  };
}
var Um = 100,
  Dm = 30;
function Jm(e, n, t) {
  var o = n.items,
    r = n.selectedItem,
    i = n.onSelect;
  return e.$$set = function (e) {
    "items" in e && t(0, o = e.items), "selectedItem" in e && t(1, r = e.selectedItem), "onSelect" in e && t(2, i = e.onSelect);
  }, [o, r, i, function (e) {
    return i(e);
  }];
}
var Vm = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Jm, Lm, ct, {
      items: 0,
      selectedItem: 1,
      onSelect: 2
    }, Am), t;
  }
  return v(n, Wo), b(n);
}();
function Hm(e) {
  St(e, "svelte-x08607", ".jse-navigation-bar-item.svelte-x08607.svelte-x08607{position:relative;display:flex}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.svelte-x08607{font-family:inherit;font-size:inherit;padding:calc(0.5 * var(--jse-padding, 10px)) 2px;border:none;background:transparent;color:inherit;cursor:pointer;outline:none;min-width:2em;white-space:nowrap}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.svelte-x08607:focus,.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.svelte-x08607:hover{background:var(--jse-panel-button-background-highlight, #e0e0e0);color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d))}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.jse-navigation-bar-arrow.svelte-x08607{padding:2px var(--jse-padding, 10px) 0}.jse-navigation-bar-item.svelte-x08607 button.jse-navigation-bar-button.jse-navigation-bar-arrow.jse-open.svelte-x08607{background:var(--jse-navigation-bar-background, var(--jse-background-color, #fff));color:var(--jse-navigation-bar-dropdown-color, #656565)}.jse-navigation-bar-item.svelte-x08607.svelte-x08607:last-child{padding-right:var(--jse-padding, 10px)}");
}
function _m(e) {
  var n, t, o, r;
  return {
    c: function () {
      n = Pt("button"), t = Tt(e[2]), Ut(n, "type", "button"), Ut(n, "class", "jse-navigation-bar-button svelte-x08607");
    },
    m: function (i, a) {
      Rt(i, n, a), Ct(n, t), o || (r = Bt(n, "click", e[9]), o = !0);
    },
    p: function (e, n) {
      4 & n && Ht(t, e[2]);
    },
    d: function (e) {
      e && Et(n), o = !1, r();
    }
  };
}
function Wm(e) {
  var n, t, o, r, i, a, l;
  o = new Ya({
    props: {
      data: $e
    }
  });
  var c = void 0 !== e[2] && _m(e);
  return {
    c: function () {
      n = Pt("div"), t = Pt("button"), Jo(o.$$.fragment), r = At(), c && c.c(), Ut(t, "type", "button"), Ut(t, "class", "jse-navigation-bar-button jse-navigation-bar-arrow svelte-x08607"), Yt(t, "jse-open", e[1]), Ut(n, "class", "jse-navigation-bar-item svelte-x08607");
    },
    m: function (s, u) {
      Rt(s, n, u), Ct(n, t), Vo(o, t, null), Ct(n, r), c && c.m(n, null), e[10](n), i = !0, a || (l = Bt(t, "click", e[4]), a = !0);
    },
    p: function (e, o) {
      var r = s(o, 1)[0];
      (!i || 2 & r) && Yt(t, "jse-open", e[1]), void 0 !== e[2] ? c ? c.p(e, r) : ((c = _m(e)).c(), c.m(n, null)) : c && (c.d(1), c = null);
    },
    i: function (e) {
      i || (qo(o.$$.fragment, e), i = !0);
    },
    o: function (e) {
      Po(o.$$.fragment, e), i = !1;
    },
    d: function (t) {
      t && Et(n), Ho(o), c && c.d(), e[10](null), a = !1, l();
    }
  };
}
function Qm(e, n, t) {
  var o,
    r,
    i,
    a,
    s = co("absolute-popup"),
    l = s.openAbsolutePopup,
    c = s.closeAbsolutePopup,
    u = n.path,
    d = n.index,
    f = n.onSelect,
    v = n.getItems,
    p = !1;
  function m(e) {
    c(a), f(o.concat(e));
  }
  return e.$$set = function (e) {
    "path" in e && t(5, u = e.path), "index" in e && t(6, d = e.index), "onSelect" in e && t(7, f = e.onSelect), "getItems" in e && t(8, v = e.getItems);
  }, e.$$.update = function () {
    96 & e.$$.dirty && (o = u.slice(0, d)), 96 & e.$$.dirty && t(2, r = u[d]);
  }, [i, p, r, m, function () {
    if (i) {
      t(1, p = !0);
      var e = {
        items: v(o),
        selectedItem: r,
        onSelect: m
      };
      a = l(Vm, e, {
        anchor: i,
        closeOnOuterClick: !0,
        onClose: function () {
          t(1, p = !1);
        }
      });
    }
  }, u, d, f, v, function () {
    return m(r);
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(0, i = e);
    });
  }];
}
var Ym = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Qm, Wm, ct, {
      path: 5,
      index: 6,
      onSelect: 7,
      getItems: 8
    }, Hm), t;
  }
  return v(n, Wo), b(n);
}();
function Gm(e) {
  var n, t;
  if (navigator.clipboard) return navigator.clipboard.writeText(e);
  if (null !== (n = (t = document).queryCommandSupported) && void 0 !== n && n.call(t, "copy")) {
    var o = document.createElement("textarea");
    o.value = e, o.style.position = "fixed", o.style.opacity = "0", document.body.appendChild(o), o.select();
    try {
      document.execCommand("copy");
    } catch (e) {
      console.error(e);
    } finally {
      document.body.removeChild(o);
    }
  } else console.error("Copy failed.");
}
function Km(e) {
  St(e, "svelte-1844qyt", ".jse-navigation-bar-path-editor.svelte-1844qyt.svelte-1844qyt{flex:1;display:flex;border:var(--jse-edit-outline, 2px solid #656565);background:var(--jse-background-color, #fff)}.jse-navigation-bar-path-editor.svelte-1844qyt input.jse-navigation-bar-text.svelte-1844qyt{flex:1;font-family:inherit;font-size:inherit;padding:0 5px 1px;background:var(--jse-background-color, #fff);color:var(--jse-text-color, #4d4d4d);border:none;outline:none}.jse-navigation-bar-path-editor.svelte-1844qyt button.svelte-1844qyt{border:none;background:var(--jse-background-color, #fff);cursor:pointer;font-family:inherit;font-size:80%;color:inherit}.jse-navigation-bar-path-editor.svelte-1844qyt button.jse-navigation-bar-copy.copied.svelte-1844qyt{color:var(--message-success-background, #9ac45d)}.jse-navigation-bar-path-editor.svelte-1844qyt button.jse-navigation-bar-validation-error.svelte-1844qyt{color:var(--jse-error-color, #ee5341)}.jse-navigation-bar-path-editor.error.svelte-1844qyt.svelte-1844qyt{border-color:var(--jse-error-color, #ee5341)}.jse-navigation-bar-path-editor.error.svelte-1844qyt input.jse-navigation-bar-text.svelte-1844qyt{color:var(--jse-error-color, #ee5341)}.jse-navigation-bar-path-editor.svelte-1844qyt .jse-copied-text.svelte-1844qyt{background:var(--message-success-background, #9ac45d);color:var(--jse-message-success-color, #fff);position:relative;margin:2px;padding:0 5px;border-radius:3px}");
}
function Zm(e) {
  var n, t, o, r, i, a;
  return t = new Ya({
    props: {
      data: we
    }
  }), {
    c: function () {
      n = Pt("button"), Jo(t.$$.fragment), Ut(n, "type", "button"), Ut(n, "class", "jse-navigation-bar-validation-error svelte-1844qyt");
    },
    m: function (s, l) {
      Rt(s, n, l), Vo(t, n, null), r = !0, i || (a = jt(o = hc.call(null, n, g({
        text: String(e[3] || "")
      }, e[4]))), i = !0);
    },
    p: function (e, n) {
      o && st(o.update) && 8 & n && o.update.call(null, g({
        text: String(e[3] || "")
      }, e[4]));
    },
    i: function (e) {
      r || (qo(t.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), i = !1, a();
    }
  };
}
function Xm(e) {
  var n;
  return {
    c: function () {
      (n = Pt("div")).textContent = "Copied!", Ut(n, "class", "jse-copied-text svelte-1844qyt");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function eg(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    l,
    c,
    u,
    d,
    f = e[3] && Zm(e),
    v = e[2] && Xm();
  return l = new Ya({
    props: {
      data: Ae
    }
  }), {
    c: function () {
      n = Pt("div"), t = Pt("input"), o = At(), f && f.c(), r = At(), v && v.c(), i = At(), a = Pt("button"), Jo(l.$$.fragment), Ut(t, "type", "text"), Ut(t, "class", "jse-navigation-bar-text svelte-1844qyt"), t.value = e[0], Ut(a, "type", "button"), Ut(a, "class", "jse-navigation-bar-copy svelte-1844qyt"), Ut(a, "title", "Copy selected path to the clipboard"), Yt(a, "copied", e[2]), Ut(n, "class", "jse-navigation-bar-path-editor svelte-1844qyt"), Yt(n, "error", e[3]);
    },
    m: function (s, p) {
      Rt(s, n, p), Ct(n, t), e[15](t), Ct(n, o), f && f.m(n, null), Ct(n, r), v && v.m(n, null), Ct(n, i), Ct(n, a), Vo(l, a, null), c = !0, u || (d = [Bt(t, "keydown", Lt(e[6])), Bt(t, "input", e[5]), Bt(a, "click", e[7])], u = !0);
    },
    p: function (e, o) {
      var l = s(o, 1)[0];
      (!c || 1 & l && t.value !== e[0]) && (t.value = e[0]), e[3] ? f ? (f.p(e, l), 8 & l && qo(f, 1)) : ((f = Zm(e)).c(), qo(f, 1), f.m(n, r)) : f && (Ro(), Po(f, 1, 1, function () {
        f = null;
      }), Eo()), e[2] ? v || ((v = Xm()).c(), v.m(n, i)) : v && (v.d(1), v = null), (!c || 4 & l) && Yt(a, "copied", e[2]), (!c || 8 & l) && Yt(n, "error", e[3]);
    },
    i: function (e) {
      c || (qo(f), qo(l.$$.fragment, e), c = !0);
    },
    o: function (e) {
      Po(f), Po(l.$$.fragment, e), c = !1;
    },
    d: function (t) {
      t && Et(n), e[15](null), f && f.d(), v && v.d(), Ho(l), u = !1, at(d);
    }
  };
}
function ng(e, n, t) {
  var o,
    r,
    i,
    a = co("absolute-popup"),
    s = n.path,
    l = n.pathParser,
    c = n.onChange,
    u = n.onClose,
    d = n.onError,
    f = n.pathExists,
    v = !1,
    p = void 0,
    m = !1;
  function g() {
    r.focus();
  }
  function h(e) {
    try {
      var n = l.parse(e);
      return function (e) {
        if (!f(e)) throw new Error("Path does not exist in current document");
      }(n), {
        path: n,
        error: void 0
      };
    } catch (e) {
      return {
        path: void 0,
        error: e
      };
    }
  }
  return io(function () {
    g();
  }), ao(function () {
    clearTimeout(p);
  }), e.$$set = function (e) {
    "path" in e && t(8, s = e.path), "pathParser" in e && t(9, l = e.pathParser), "onChange" in e && t(10, c = e.onChange), "onClose" in e && t(11, u = e.onClose), "onError" in e && t(12, d = e.onError), "pathExists" in e && t(13, f = e.pathExists);
  }, e.$$.update = function () {
    768 & e.$$.dirty && t(0, i = l.stringify(s)), 16385 & e.$$.dirty && t(3, o = v ? h(i).error : void 0);
  }, [i, r, m, o, a, function (e) {
    t(0, i = e.currentTarget.value);
  }, function (e) {
    var n = sa(e);
    if ("Escape" === n && u(), "Enter" === n) {
      t(14, v = !0);
      var o = h(i);
      void 0 !== o.path ? c(o.path) : d(o.error);
    }
  }, function () {
    Gm(i), t(2, m = !0), p = window.setTimeout(function () {
      return t(2, m = !1);
    }, 1e3), g();
  }, s, l, c, u, d, f, v, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(1, r = e);
    });
  }];
}
var tg = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, ng, eg, lt, {
      path: 8,
      pathParser: 9,
      onChange: 10,
      onClose: 11,
      onError: 12,
      pathExists: 13
    }, Km), t;
  }
  return v(n, Wo), b(n);
}();
function og(e) {
  St(e, "svelte-1aycet9", '.jse-navigation-bar.svelte-1aycet9.svelte-1aycet9{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-button-color, inherit);padding:0;margin:0;display:flex;overflow:auto;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.svelte-1aycet9{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);color:var(--jse-panel-color-readonly, #b2b2b2);background:transparent;border:none;display:flex;cursor:pointer;outline:none;align-items:center}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.flex.svelte-1aycet9{flex:1}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.svelte-1aycet9:focus,.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.svelte-1aycet9:hover,.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit.editing.svelte-1aycet9{background:var(--jse-panel-button-background-highlight, #e0e0e0);color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d));transition:color 0.2s ease-in, background 0.2s ease-in}.jse-navigation-bar.svelte-1aycet9 .jse-navigation-bar-edit .jse-navigation-bar-space.svelte-1aycet9{flex:1;text-align:left}');
}
function rg(e, n, t) {
  var o = e.slice();
  return o[18] = n[t], o[20] = t, o;
}
function ig(e) {
  var n, t;
  return n = new tg({
    props: {
      path: e[3],
      onClose: e[11],
      onChange: e[12],
      onError: e[1],
      pathExists: e[8],
      pathParser: e[2]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      8 & t && (o.path = e[3]), 2 & t && (o.onError = e[1]), 4 & t && (o.pathParser = e[2]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function ag(e) {
  for (var n, t, o, r = [], i = new Map(), a = Ao(e[3]), s = function (e) {
      return e[20];
    }, l = 0; l < a.length; l += 1) {
    var c = rg(e, a, l),
      u = s(c);
    i.set(u, r[l] = sg(u, c));
  }
  var d = e[6] && lg(e);
  return {
    c: function () {
      for (var e = 0; e < r.length; e += 1) r[e].c();
      n = At(), d && d.c(), t = Nt();
    },
    m: function (e, i) {
      for (var a = 0; a < r.length; a += 1) r[a] && r[a].m(e, i);
      Rt(e, n, i), d && d.m(e, i), Rt(e, t, i), o = !0;
    },
    p: function (e, o) {
      648 & o && (a = Ao(e[3]), Ro(), r = Fo(r, o, s, 0, e, a, i, n.parentNode, Bo, sg, n, rg), Eo()), e[6] ? d ? (d.p(e, o), 64 & o && qo(d, 1)) : ((d = lg(e)).c(), qo(d, 1), d.m(t.parentNode, t)) : d && (Ro(), Po(d, 1, 1, function () {
        d = null;
      }), Eo());
    },
    i: function (e) {
      if (!o) {
        for (var n = 0; n < a.length; n += 1) qo(r[n]);
        qo(d), o = !0;
      }
    },
    o: function (e) {
      for (var n = 0; n < r.length; n += 1) Po(r[n]);
      Po(d), o = !1;
    },
    d: function (e) {
      e && (Et(n), Et(t));
      for (var o = 0; o < r.length; o += 1) r[o].d(e);
      d && d.d(e);
    }
  };
}
function sg(e, n) {
  var t, o, r;
  return o = new Ym({
    props: {
      getItems: n[7],
      path: n[3],
      index: n[20],
      onSelect: n[9]
    }
  }), {
    key: e,
    first: null,
    c: function () {
      t = Nt(), Jo(o.$$.fragment), this.first = t;
    },
    m: function (e, n) {
      Rt(e, t, n), Vo(o, e, n), r = !0;
    },
    p: function (e, t) {
      n = e;
      var r = {};
      8 & t && (r.path = n[3]), 8 & t && (r.index = n[20]), o.$set(r);
    },
    i: function (e) {
      r || (qo(o.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(o.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(t), Ho(o, e);
    }
  };
}
function lg(e) {
  var n, t;
  return n = new Ym({
    props: {
      getItems: e[7],
      path: e[3],
      index: e[3].length,
      onSelect: e[9]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      8 & t && (o.path = e[3]), 8 & t && (o.index = e[3].length), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function cg(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    l,
    c,
    u,
    d,
    f,
    v,
    p,
    m = Yr(e[0]) || e[5] ? " " : "Navigation bar",
    g = [ag, ig],
    h = [];
  function j(e, n) {
    return e[5] ? 1 : 0;
  }
  return t = j(e), o = h[t] = g[t](e), u = new Ya({
    props: {
      data: e[5] ? Ne : Be
    }
  }), {
    c: function () {
      n = Pt("div"), o.c(), r = At(), i = Pt("button"), a = Pt("span"), l = Tt(m), c = At(), Jo(u.$$.fragment), Ut(a, "class", "jse-navigation-bar-space svelte-1aycet9"), Ut(i, "type", "button"), Ut(i, "class", "jse-navigation-bar-edit svelte-1aycet9"), Ut(i, "title", d = e[5] ? "Cancel editing the selected path" : "Edit the selected path"), Yt(i, "flex", !e[5]), Yt(i, "editing", e[5]), Ut(n, "class", "jse-navigation-bar svelte-1aycet9");
    },
    m: function (o, s) {
      Rt(o, n, s), h[t].m(n, null), Ct(n, r), Ct(n, i), Ct(i, a), Ct(a, l), Ct(i, c), Vo(u, i, null), e[15](n), f = !0, v || (p = Bt(i, "click", e[10]), v = !0);
    },
    p: function (e, a) {
      var c = s(a, 1)[0],
        v = t;
      (t = j(e)) === v ? h[t].p(e, c) : (Ro(), Po(h[v], 1, 1, function () {
        h[v] = null;
      }), Eo(), (o = h[t]) ? o.p(e, c) : (o = h[t] = g[t](e)).c(), qo(o, 1), o.m(n, r)), (!f || 33 & c) && m !== (m = Yr(e[0]) || e[5] ? " " : "Navigation bar") && Ht(l, m);
      var p = {};
      32 & c && (p.data = e[5] ? Ne : Be), u.$set(p), (!f || 32 & c && d !== (d = e[5] ? "Cancel editing the selected path" : "Edit the selected path")) && Ut(i, "title", d), (!f || 32 & c) && Yt(i, "flex", !e[5]), (!f || 32 & c) && Yt(i, "editing", e[5]);
    },
    i: function (e) {
      f || (qo(o), qo(u.$$.fragment, e), f = !0);
    },
    o: function (e) {
      Po(o), Po(u.$$.fragment, e), f = !1;
    },
    d: function (o) {
      o && Et(n), h[t].d(), Ho(u), e[15](null), v = !1, p();
    }
  };
}
function ug(e, n, t) {
  var o,
    r,
    i,
    a = Qo("jsoneditor:NavigationBar"),
    s = n.json,
    l = n.selection,
    c = n.onSelect,
    u = n.onError,
    d = n.pathParser,
    f = !1;
  function v(e) {
    a("select path", JSON.stringify(e)), c(cl(e, e));
  }
  function p() {
    t(5, f = !1);
  }
  return e.$$set = function (e) {
    "json" in e && t(0, s = e.json), "selection" in e && t(13, l = e.selection), "onSelect" in e && t(14, c = e.onSelect), "onError" in e && t(1, u = e.onError), "pathParser" in e && t(2, d = e.pathParser);
  }, e.$$.update = function () {
    8192 & e.$$.dirty && t(3, o = l ? bl(l) : []), 9 & e.$$.dirty && t(6, r = Yr(z(s, o))), 8 & e.$$.dirty && setTimeout(function () {
      if (i && i.scrollTo) {
        var e = i.scrollWidth - i.clientWidth;
        e > 0 && (a("scrollTo ", e), i.scrollTo({
          left: e,
          behavior: "smooth"
        }));
      }
    });
  }, [s, u, d, o, i, f, r, function (e) {
    a("get items for path", e);
    var n = z(s, e);
    if (Array.isArray(n)) return le(0, n.length).map(String);
    if (Qr(n)) {
      var t = Object.keys(n).slice(0);
      return t.sort(Im), t;
    }
    return [];
  }, function (e) {
    return L(s, e);
  }, v, function () {
    t(5, f = !f);
  }, p, function (e) {
    p(), v(e);
  }, l, c, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(4, i = e);
    });
  }];
}
var dg = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, ug, cg, ct, {
      json: 0,
      selection: 13,
      onSelect: 14,
      onError: 1,
      pathParser: 2
    }, og), t;
  }
  return v(n, Wo), b(n);
}();
function fg(e) {
  St(e, "svelte-wnmp4a", '.jse-search-box.svelte-wnmp4a.svelte-wnmp4a{border:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7));border-radius:3px;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color-readonly, #b2b2b2);box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24));display:inline-block;width:400px;max-width:100%;overflow:auto}.jse-search-box.svelte-wnmp4a .jse-search-form.svelte-wnmp4a{display:flex;align-items:stretch}.jse-search-box.svelte-wnmp4a .jse-search-form button.svelte-wnmp4a,.jse-search-box.svelte-wnmp4a .jse-search-form input.svelte-wnmp4a{font-family:inherit;font-size:inherit}.jse-search-box.svelte-wnmp4a .jse-search-form button.svelte-wnmp4a{display:block;text-align:center;border:none;padding:0 5px;margin:0;cursor:pointer;color:var(--jse-panel-button-color, inherit);background:var(--jse-panel-button-background, transparent)}.jse-search-box.svelte-wnmp4a .jse-search-form button.svelte-wnmp4a:hover{color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d));background:var(--jse-panel-button-background-highlight, #e0e0e0)}.jse-search-box.svelte-wnmp4a .jse-search-form input.svelte-wnmp4a{color:var(--jse-panel-color, var(--jse-text-color, #4d4d4d));border:var(--jse-input-border, 1px solid #d8dbdf);border-radius:3px;background:var(--jse-input-background, var(--jse-background-color, #fff));height:28px;padding:0 5px;margin:0;flex:1;width:0;min-width:50px;outline:none}.jse-search-box.svelte-wnmp4a .jse-search-form .jse-replace-toggle.svelte-wnmp4a{padding:var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px));min-width:20px;background:var(--jse-panel-button-background-highlight, #e0e0e0)}.jse-search-box.svelte-wnmp4a .jse-search-form .jse-search-contents.svelte-wnmp4a{flex:1;display:flex;flex-direction:column;padding:calc(0.5 * var(--jse-padding, 10px));gap:calc(0.5 * var(--jse-padding, 10px))}.jse-search-box.svelte-wnmp4a .jse-search-form .jse-search-contents .jse-search-section.svelte-wnmp4a{flex:1;display:flex;align-items:center;position:relative}.jse-search-box.svelte-wnmp4a .jse-search-form .jse-search-contents .jse-search-section .jse-search-icon.svelte-wnmp4a{color:inherit;cursor:inherit;background:inherit;width:32px;text-align:center}.jse-search-box.svelte-wnmp4a .jse-search-form .jse-search-contents .jse-search-section label.jse-search-input-label.svelte-wnmp4a{flex:1;display:flex}.jse-search-box.svelte-wnmp4a .jse-search-form .jse-search-contents .jse-search-section .jse-search-count.svelte-wnmp4a{color:inherit;font-size:80%;visibility:hidden;padding:0 5px;min-width:36px;text-align:center}.jse-search-box.svelte-wnmp4a .jse-search-form .jse-search-contents .jse-search-section .jse-search-count.jse-visible.svelte-wnmp4a{visibility:visible}.jse-search-box.svelte-wnmp4a .jse-search-form .jse-search-contents .jse-replace-section.svelte-wnmp4a{padding-left:32px;flex:1;display:flex}.jse-search-box.svelte-wnmp4a .jse-search-form .jse-search-contents .jse-replace-section button.svelte-wnmp4a{width:auto}');
}
function vg(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f,
    v,
    p,
    m,
    g,
    h,
    j,
    b,
    y,
    x,
    w,
    $,
    k,
    C,
    S,
    M,
    O,
    z = (-1 !== e[7] && e[7] < e[4] ? "".concat(e[7] + 1, "/") : "") + "",
    R = !e[2] && pg(e),
    E = [gg, mg],
    q = [];
  function P(e, n) {
    return e[6] ? 0 : 1;
  }
  s = P(e), l = q[s] = E[s](e), j = new Ya({
    props: {
      data: Fe
    }
  }), x = new Ya({
    props: {
      data: Le
    }
  }), k = new Ya({
    props: {
      data: je
    }
  });
  var I = e[0] && !e[2] && hg(e);
  return {
    c: function () {
      n = Pt("div"), t = Pt("form"), R && R.c(), o = At(), r = Pt("div"), i = Pt("div"), a = Pt("div"), l.c(), c = At(), u = Pt("label"), d = Pt("input"), f = At(), v = Pt("div"), p = Tt(z), m = Tt(e[8]), g = At(), h = Pt("button"), Jo(j.$$.fragment), b = At(), y = Pt("button"), Jo(x.$$.fragment), w = At(), $ = Pt("button"), Jo(k.$$.fragment), C = At(), I && I.c(), Ut(a, "class", "jse-search-icon svelte-wnmp4a"), Ut(d, "class", "jse-search-input svelte-wnmp4a"), Ut(d, "title", "Enter text to search"), Ut(d, "type", "text"), Ut(d, "placeholder", "Find"), Ut(u, "class", "jse-search-input-label svelte-wnmp4a"), Ut(u, "about", "jse-search input"), Ut(v, "class", "jse-search-count svelte-wnmp4a"), Yt(v, "jse-visible", "" !== e[3]), Ut(h, "type", "button"), Ut(h, "class", "jse-search-next svelte-wnmp4a"), Ut(h, "title", "Go to next search result (Enter)"), Ut(y, "type", "button"), Ut(y, "class", "jse-search-previous svelte-wnmp4a"), Ut(y, "title", "Go to previous search result (Shift+Enter)"), Ut($, "type", "button"), Ut($, "class", "jse-search-clear svelte-wnmp4a"), Ut($, "title", "Close search box (Esc)"), Ut(i, "class", "jse-search-section svelte-wnmp4a"), Ut(r, "class", "jse-search-contents svelte-wnmp4a"), Ut(t, "class", "jse-search-form svelte-wnmp4a"), Ut(n, "class", "jse-search-box svelte-wnmp4a");
    },
    m: function (l, z) {
      Rt(l, n, z), Ct(n, t), R && R.m(t, null), Ct(t, o), Ct(t, r), Ct(r, i), Ct(i, a), q[s].m(a, null), Ct(i, c), Ct(i, u), Ct(u, d), _t(d, e[3]), Ct(i, f), Ct(i, v), Ct(v, p), Ct(v, m), Ct(i, g), Ct(i, h), Vo(j, h, null), Ct(i, b), Ct(i, y), Vo(x, y, null), Ct(i, w), Ct(i, $), Vo(k, $, null), Ct(r, C), I && I.m(r, null), S = !0, M || (O = [Bt(d, "input", e[27]), jt(bg.call(null, d)), Bt(d, "paste", e[12]), Bt(h, "click", e[15]), Bt(y, "click", e[16]), Bt($, "click", e[17]), Bt(t, "keydown", e[10])], M = !0);
    },
    p: function (e, n) {
      e[2] ? R && (Ro(), Po(R, 1, 1, function () {
        R = null;
      }), Eo()) : R ? (R.p(e, n), 4 & n[0] && qo(R, 1)) : ((R = pg(e)).c(), qo(R, 1), R.m(t, o));
      var i = s;
      (s = P(e)) !== i && (Ro(), Po(q[i], 1, 1, function () {
        q[i] = null;
      }), Eo(), (l = q[s]) || (l = q[s] = E[s](e)).c(), qo(l, 1), l.m(a, null)), 8 & n[0] && d.value !== e[3] && _t(d, e[3]), (!S || 144 & n[0]) && z !== (z = (-1 !== e[7] && e[7] < e[4] ? "".concat(e[7] + 1, "/") : "") + "") && Ht(p, z), (!S || 256 & n[0]) && Ht(m, e[8]), (!S || 8 & n[0]) && Yt(v, "jse-visible", "" !== e[3]), e[0] && !e[2] ? I ? I.p(e, n) : ((I = hg(e)).c(), I.m(r, null)) : I && (I.d(1), I = null);
    },
    i: function (e) {
      S || (qo(R), qo(l), qo(j.$$.fragment, e), qo(x.$$.fragment, e), qo(k.$$.fragment, e), S = !0);
    },
    o: function (e) {
      Po(R), Po(l), Po(j.$$.fragment, e), Po(x.$$.fragment, e), Po(k.$$.fragment, e), S = !1;
    },
    d: function (e) {
      e && Et(n), R && R.d(), q[s].d(), Ho(j), Ho(x), Ho(k), I && I.d(), M = !1, at(O);
    }
  };
}
function pg(e) {
  var n, t, o, r, i;
  return t = new Ya({
    props: {
      data: e[0] ? Oe : ze
    }
  }), {
    c: function () {
      n = Pt("button"), Jo(t.$$.fragment), Ut(n, "type", "button"), Ut(n, "class", "jse-replace-toggle svelte-wnmp4a"), Ut(n, "title", "Toggle visibility of replace options (Ctrl+H)");
    },
    m: function (a, s) {
      Rt(a, n, s), Vo(t, n, null), o = !0, r || (i = Bt(n, "click", e[9]), r = !0);
    },
    p: function (e, n) {
      var o = {};
      1 & n[0] && (o.data = e[0] ? Oe : ze), t.$set(o);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), r = !1, i();
    }
  };
}
function mg(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: Re
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function gg(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: Ue,
      spin: !0
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function hg(e) {
  var n, t, o, r, i, a, s, l;
  return {
    c: function () {
      n = Pt("div"), t = Pt("input"), o = At(), (r = Pt("button")).textContent = "Replace", i = At(), (a = Pt("button")).textContent = "All", Ut(t, "class", "jse-replace-input svelte-wnmp4a"), Ut(t, "title", "Enter replacement text"), Ut(t, "type", "text"), Ut(t, "placeholder", "Replace"), Ut(r, "type", "button"), Ut(r, "title", "Replace current occurrence (Ctrl+Enter)"), Ut(r, "class", "svelte-wnmp4a"), Ut(a, "type", "button"), Ut(a, "title", "Replace all occurrences"), Ut(a, "class", "svelte-wnmp4a"), Ut(n, "class", "jse-replace-section svelte-wnmp4a");
    },
    m: function (c, u) {
      Rt(c, n, u), Ct(n, t), _t(t, e[5]), Ct(n, o), Ct(n, r), Ct(n, i), Ct(n, a), s || (l = [Bt(t, "input", e[28]), Bt(t, "keydown", e[11]), Bt(r, "click", e[13]), Bt(a, "click", e[14])], s = !0);
    },
    p: function (e, n) {
      32 & n[0] && t.value !== e[5] && _t(t, e[5]);
    },
    d: function (e) {
      e && Et(n), s = !1, at(l);
    }
  };
}
function jg(e) {
  var n,
    t,
    o = e[1] && vg(e);
  return {
    c: function () {
      o && o.c(), n = Nt();
    },
    m: function (e, r) {
      o && o.m(e, r), Rt(e, n, r), t = !0;
    },
    p: function (e, t) {
      e[1] ? o ? (o.p(e, t), 2 & t[0] && qo(o, 1)) : ((o = vg(e)).c(), qo(o, 1), o.m(n.parentNode, n)) : o && (Ro(), Po(o, 1, 1, function () {
        o = null;
      }), Eo());
    },
    i: function (e) {
      t || (qo(o), t = !0);
    },
    o: function (e) {
      Po(o), t = !1;
    },
    d: function (e) {
      e && Et(n), o && o.d(e);
    }
  };
}
function bg(e) {
  e.select();
}
function yg(e, n, t) {
  var o,
    i,
    s,
    l,
    c = Qo("jsoneditor:SearchBox"),
    u = n.json,
    d = n.documentState,
    f = n.parser,
    v = n.showSearch,
    p = n.showReplace,
    m = n.readOnly,
    h = n.columns,
    j = n.onSearch,
    b = n.onFocus,
    y = n.onPatch,
    x = n.onClose,
    w = "",
    $ = "",
    k = "",
    C = !1,
    S = ce(function (e) {
      return L.apply(this, arguments);
    }, 300),
    M = ce(function (e) {
      return U.apply(this, arguments);
    }, 300);
  function O() {
    t(0, p = !p && !m);
  }
  function z() {
    return (z = a(r().mark(function e() {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, bo();
          case 2:
            setTimeout(function () {
              return S.flush();
            });
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function R() {
    return E.apply(this, arguments);
  }
  function E() {
    return (E = a(r().mark(function e() {
      var n, o, a, s, v;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (!m) {
              e.next = 2;
              break;
            }
            return e.abrupt("return");
          case 2:
            if (o = null === (n = l) || void 0 === n ? void 0 : n.activeItem, c("handleReplace", {
              replaceText: k,
              activeItem: o
            }), l && o && void 0 !== u) {
              e.next = 6;
              break;
            }
            return e.abrupt("return");
          case 6:
            return t(26, l = g(g({}, Dl(l)), {}, {
              activeIndex: i
            })), a = Ql(u, d, k, o, f), s = a.operations, v = a.newSelection, y(s, function (e, n) {
              return {
                state: g(g({}, n), {}, {
                  selection: v
                })
              };
            }), e.next = 11, bo();
          case 11:
            return e.next = 13, M.flush();
          case 13:
            return e.next = 15, N();
          case 15:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function q() {
    return (q = a(r().mark(function e() {
      var n, t, o;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (!m) {
              e.next = 2;
              break;
            }
            return e.abrupt("return");
          case 2:
            return c("handleReplaceAll", {
              text: w,
              replaceText: k
            }), n = Yl(u, d, w, k, f), t = n.operations, o = n.newSelection, y(t, function (e, n) {
              return {
                state: g(g({}, n), {}, {
                  selection: o
                })
              };
            }), e.next = 7, N();
          case 7:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function P() {
    return I.apply(this, arguments);
  }
  function I() {
    return (I = a(r().mark(function e() {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return t(26, l = l ? Dl(l) : void 0), e.next = 3, N();
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function T() {
    return A.apply(this, arguments);
  }
  function A() {
    return (A = a(r().mark(function e() {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return t(26, l = l ? Jl(l) : void 0), e.next = 3, N();
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function N() {
    return B.apply(this, arguments);
  }
  function B() {
    return (B = a(r().mark(function e() {
      var n, t;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (c("handleFocus", l), !(t = null === (n = l) || void 0 === n ? void 0 : n.activeItem) || void 0 === u) {
              e.next = 5;
              break;
            }
            return e.next = 5, b(t.path);
          case 5:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function F() {
    return F = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, D(n, w, u);
          case 2:
          case "end":
            return e.stop();
        }
      }, e);
    })), F.apply(this, arguments);
  }
  function L() {
    return L = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, D(v, n, u);
          case 2:
            return e.next = 4, N();
          case 4:
          case "end":
            return e.stop();
        }
      }, e);
    })), L.apply(this, arguments);
  }
  function U() {
    return U = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, D(v, w, n);
          case 2:
          case "end":
            return e.stop();
        }
      }, e);
    })), U.apply(this, arguments);
  }
  function D(e, n, t) {
    return J.apply(this, arguments);
  }
  function J() {
    return J = a(r().mark(function e(n, o, i) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (n) {
              e.next = 3;
              break;
            }
            return l && t(26, l = void 0), e.abrupt("return");
          case 3:
            if (c("applySearch", {
              showSearch: n,
              text: o
            }), "" !== o) {
              e.next = 8;
              break;
            }
            return c("clearing search result"), void 0 !== l && t(26, l = void 0), e.abrupt("return");
          case 8:
            return t(6, C = !0), e.abrupt("return", new Promise(function (e) {
              setTimeout(function () {
                var n = Vl(o, i, {
                  maxResults: br,
                  columns: h
                });
                t(26, l = Ul(0, n, l)), t(6, C = !1), e();
              });
            }));
          case 10:
          case "end":
            return e.stop();
        }
      }, e);
    })), J.apply(this, arguments);
  }
  function V() {
    c("handleClose"), S.cancel(), M.cancel(), D(!1, w, u), x();
  }
  return e.$$set = function (e) {
    "json" in e && t(18, u = e.json), "documentState" in e && t(19, d = e.documentState), "parser" in e && t(20, f = e.parser), "showSearch" in e && t(1, v = e.showSearch), "showReplace" in e && t(0, p = e.showReplace), "readOnly" in e && t(2, m = e.readOnly), "columns" in e && t(21, h = e.columns), "onSearch" in e && t(22, j = e.onSearch), "onFocus" in e && t(23, b = e.onFocus), "onPatch" in e && t(24, y = e.onPatch), "onClose" in e && t(25, x = e.onClose);
  }, e.$$.update = function () {
    var n, r;
    67108864 & e.$$.dirty[0] && t(4, o = (null === (n = l) || void 0 === n || null === (n = n.items) || void 0 === n ? void 0 : n.length) || 0);
    67108864 & e.$$.dirty[0] && t(7, i = (null === (r = l) || void 0 === r ? void 0 : r.activeIndex) || 0);
    16 & e.$$.dirty[0] && t(8, s = o >= br ? "".concat(999, "+") : String(o)), 71303168 & e.$$.dirty[0] && j(l), 2 & e.$$.dirty[0] && function (e) {
      F.apply(this, arguments);
    }(v), 8 & e.$$.dirty[0] && S(w), 262144 & e.$$.dirty[0] && M(u);
  }, [p, v, m, w, o, k, C, i, s, O, function (e) {
    e.stopPropagation();
    var n = sa(e);
    "Enter" === n && (e.preventDefault(), w !== $ ? (S.flush(), $ = w) : P()), "Shift+Enter" === n && (e.preventDefault(), T()), "Ctrl+Enter" === n && (e.preventDefault(), p ? R() : P()), "Ctrl+H" === n && (e.preventDefault(), O()), "Escape" === n && (e.preventDefault(), V());
  }, function (e) {
    "Enter" === sa(e) && (e.preventDefault(), e.stopPropagation(), R());
  }, function () {
    return z.apply(this, arguments);
  }, R, function () {
    return q.apply(this, arguments);
  }, P, T, V, u, d, f, h, j, b, y, x, l, function () {
    w = this.value, t(3, w);
  }, function () {
    k = this.value, t(5, k);
  }];
}
var xg = function (e) {
    function n(e) {
      var t;
      return h(this, n), _o(t = u(this, n), e, yg, jg, ct, {
        json: 18,
        documentState: 19,
        parser: 20,
        showSearch: 1,
        showReplace: 0,
        readOnly: 2,
        columns: 21,
        onSearch: 22,
        onFocus: 23,
        onPatch: 24,
        onClose: 25
      }, fg, [-1, -1]), t;
    }
    return v(n, Wo), b(n);
  }(),
  wg = Symbol("path");
function $g(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1 / 0,
    o = {};
  Array.isArray(e) && function (e, n, t) {
    if (e.length < n) e.forEach(t);else for (var o = n > 1 ? (e.length - 1) / (n - 1) : e.length, r = 0; r < n; r++) {
      var i = Math.floor(r * o);
      t(e[i], i, e);
    }
  }(e, t, function (e) {
    Qr(e) ? kg(e, o, n) : o[wg] = !0;
  });
  var r = [];
  return wg in o && r.push([]), Cg(o, [], r, n), r;
}
function kg(e, n, t) {
  for (var o in e) {
    var r = e[o],
      i = n[o] || (n[o] = {});
    Qr(r) && t ? kg(r, i, t) : void 0 === i[wg] && (i[wg] = !0);
  }
}
function Cg(e, n, t, o) {
  for (var r in e) {
    var i = n.concat(r),
      a = e[r];
    a && !0 === a[wg] && t.push(i), B(a) && o && Cg(a, i, t, o);
  }
}
function Sg(e, n, t, o, r, i) {
  for (var a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 80, s = N(t) ? t.length : 0, l = function (e, n) {
      var t = Object.values(e);
      if (G(t)) return n;
      var o = function (e, n) {
        return e + n;
      };
      return t.reduce(o) / t.length;
    }(o, r), c = e - a, u = n + 2 * a, d = function (e) {
      return o[e] || r;
    }, f = 0, v = i; v < c && f < s;) v += d(f), f++;
  f > 0 && (v -= d(--f));
  for (var p = f, m = 0; m < u && p < s;) m += d(p), p++;
  for (var g = 0, h = p; h < s; h++) g += d(h);
  return {
    startIndex: f,
    endIndex: p,
    startHeight: v,
    endHeight: g,
    averageItemHeight: l,
    visibleHeight: m,
    visibleItems: N(t) ? t.slice(f, p) : []
  };
}
function Mg(e, n, t, o) {
  for (var r = Og(e, n).rowIndex, i = 0, a = 0; a < r; a++) i += t[a] || o;
  return i;
}
function Og(e, n) {
  var t,
    o = c(t = e) || k(t) || $(t) || l(),
    r = o[0],
    i = o.slice(1),
    a = parseInt(r, 10);
  return {
    rowIndex: isNaN(a) ? -1 : a,
    columnIndex: n.findIndex(function (e) {
      return ol(i, e);
    })
  };
}
function zg(e, n) {
  var t = e.rowIndex,
    o = e.columnIndex;
  return [String(t)].concat(w(n[o]));
}
function Rg(e, n) {
  var t = s(ue(e, function (e) {
      return _r(e.path[0]);
    }), 2),
    o = t[0],
    r = t[1],
    i = ae(o, qg),
    a = de(i, function (e) {
      var t = {
        row: [],
        columns: {}
      };
      return e.forEach(function (e) {
        var o = function (e, n) {
          var t = Og(e.path, n);
          if (-1 !== t.columnIndex) return t.columnIndex;
          return -1;
        }(e, n);
        -1 !== o ? (void 0 === t.columns[o] && (t.columns[o] = []), t.columns[o].push(e)) : t.row.push(e);
      }), t;
    });
  return {
    root: r,
    rows: a
  };
}
function Eg(e, n) {
  if (n && 0 !== n.length) return 1 === n.length ? n[0] : {
    path: e,
    message: "Multiple validation issues: " + n.map(function (e) {
      return $a(e.path) + " " + e.message;
    }).join(", "),
    severity: ur.warning
  };
}
function qg(e) {
  return parseInt(e.path[0], 10);
}
function Pg(e, n, t) {
  return n.some(function (n) {
    return function (e, n, t) {
      if (!e) return !1;
      if ("replace" === n.op) {
        var o = Og(M(n.path), t),
          r = o.rowIndex,
          i = o.columnIndex,
          a = t.findIndex(function (n) {
            return ne(n, e.path);
          });
        if (-1 !== r && -1 !== i && i !== a) return !1;
      }
      return !0;
    }(e.sortedColumn, n, t);
  }) ? g(g({}, e), {}, {
    sortedColumn: null
  }) : e;
}
var Ig = Qo("jsoneditor:actions");
function Tg(e) {
  return Ag.apply(this, arguments);
}
function Ag() {
  return Ag = a(r().mark(function e(n) {
    var t, o, i, a, s, l, c, u, d, f;
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          if (t = n.json, o = n.documentState, i = n.indentation, a = n.readOnly, s = n.parser, l = n.onPatch, !a && void 0 !== t && o.selection && fl(o.selection)) {
            e.next = 3;
            break;
          }
          return e.abrupt("return");
        case 3:
          if (null != (c = ul(t, o.selection, i, s))) {
            e.next = 6;
            break;
          }
          return e.abrupt("return");
        case 6:
          return Ig("cut", {
            selection: o.selection,
            clipboard: c,
            indentation: i
          }), e.next = 9, Gm(c);
        case 9:
          u = Bl(t, o.selection), d = u.operations, f = u.newSelection, l(d, function (e, n) {
            return {
              state: g(g({}, n), {}, {
                selection: f
              })
            };
          });
        case 11:
        case "end":
          return e.stop();
      }
    }, e);
  })), Ag.apply(this, arguments);
}
function Ng(e) {
  return Bg.apply(this, arguments);
}
function Bg() {
  return Bg = a(r().mark(function e(n) {
    var t, o, i, a, s;
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          if (t = n.json, o = n.documentState, i = n.indentation, a = n.parser, null != (s = ul(t, o.selection, i, a))) {
            e.next = 4;
            break;
          }
          return e.abrupt("return");
        case 4:
          return Ig("copy", {
            clipboard: s,
            indentation: i
          }), e.next = 7, Gm(s);
        case 7:
        case "end":
          return e.stop();
      }
    }, e);
  })), Bg.apply(this, arguments);
}
function Fg(e) {
  var n = e.clipboardText,
    t = e.json,
    o = e.selection,
    r = e.readOnly,
    i = e.parser,
    a = e.onPatch,
    s = e.onChangeText,
    l = e.openRepairModal;
  if (!r) try {
    c(n);
  } catch (e) {
    l(n, function (e) {
      Ig("repaired pasted text: ", e), c(e);
    });
  }
  function c(e) {
    if (void 0 !== t) {
      var r = o || al([], !1),
        l = Il(t, r, e, i);
      Ig("paste", {
        pastedText: e,
        operations: l,
        selectionNonNull: r
      }), a(l, function (e, n) {
        var o = n;
        return l.filter(function (e) {
          return (E(e) || P(e)) && Yr(e.value);
        }).forEach(function (n) {
          var r = A(t, n.path);
          o = Ts(e, o, r);
        }), {
          state: o
        };
      });
    } else Ig("paste text", {
      pastedText: e
    }), s(n, function (e, n) {
      if (e) {
        return {
          state: Ts(e, n, [])
        };
      }
    });
  }
}
function Lg(e) {
  var n = e.json,
    t = e.text,
    o = e.documentState,
    r = e.keepSelection,
    i = e.readOnly,
    a = e.onChange,
    s = e.onPatch;
  if (!i && o.selection) {
    var l = void 0 !== n && (Ls(o.selection) || Us(o.selection)) ? cl(o.selection.path, o.selection.path) : o.selection;
    if (G(bl(o.selection))) Ig("remove root", {
      selection: o.selection
    }), a && a({
      text: "",
      json: void 0
    }, void 0 !== n ? {
      text: void 0,
      json: n
    } : {
      text: t || "",
      json: n
    }, {
      contentErrors: null,
      patchResult: null
    });else if (void 0 !== n) {
      var c = Bl(n, l),
        u = c.operations,
        d = c.newSelection;
      Ig("remove", {
        operations: u,
        selection: o.selection,
        newSelection: d
      }), s(u, function (e, n) {
        return {
          state: g(g({}, n), {}, {
            selection: r ? o.selection : d
          })
        };
      });
    }
  }
}
function Ug(e) {
  var n = e.json,
    t = e.documentState,
    o = e.columns,
    r = e.readOnly,
    i = e.onPatch;
  if (!r && void 0 !== n && t.selection && fl(t.selection)) {
    var a = Og(bl(t.selection), o),
      s = a.rowIndex,
      l = a.columnIndex;
    Ig("duplicate row", {
      rowIndex: s
    });
    var c = [String(s)];
    i(Pl(n, [c]), function (e, t) {
      var r = al(zg({
        rowIndex: s < n.length ? s + 1 : s,
        columnIndex: l
      }, o), !1);
      return {
        state: g(g({}, t), {}, {
          selection: r
        })
      };
    });
  }
}
function Dg(e) {
  var n = e.json,
    t = e.documentState,
    o = e.columns,
    r = e.readOnly,
    i = e.onPatch;
  if (!r && void 0 !== n && t.selection && fl(t.selection)) {
    var a = Og(bl(t.selection), o).rowIndex;
    Ig("insert before row", {
      rowIndex: a
    }), i(Rl(n, [String(a)], [{
      key: "",
      value: B(n[0]) ? {} : ""
    }]));
  }
}
function Jg(e) {
  var n = e.json,
    t = e.documentState,
    o = e.columns,
    r = e.readOnly,
    i = e.onPatch;
  if (!r && void 0 !== n && t.selection && fl(t.selection)) {
    var a = Og(bl(t.selection), o),
      s = a.rowIndex,
      l = a.columnIndex;
    Ig("insert after row", {
      rowIndex: s
    });
    var c = s + 1,
      u = [String(c)],
      d = [{
        key: "",
        value: B(n[0]) ? {} : ""
      }];
    i(c < n.length ? Rl(n, u, d) : El(n, [], d), function (e, n) {
      var t = al(zg({
        rowIndex: c,
        columnIndex: l
      }, o), !1);
      return {
        state: g(g({}, n), {}, {
          selection: t
        })
      };
    });
  }
}
function Vg(e) {
  var n = e.json,
    t = e.documentState,
    o = e.columns,
    r = e.readOnly,
    i = e.onPatch;
  if (!r && void 0 !== n && t.selection && fl(t.selection)) {
    var a = Og(bl(t.selection), o),
      s = a.rowIndex,
      l = a.columnIndex;
    Ig("remove row", {
      rowIndex: s
    }), i(Tl([[String(s)]]), function (e, n) {
      var t = s < e.length ? s : s > 0 ? s - 1 : void 0,
        r = void 0 !== t ? al(zg({
          rowIndex: t,
          columnIndex: l
        }, o), !1) : null;
      return Ig("remove row new selection", {
        rowIndex: s,
        newRowIndex: t,
        newSelection: r
      }), {
        state: g(g({}, n), {}, {
          selection: r
        })
      };
    });
  }
}
function Hg(e) {
  var n = e.insertType,
    t = e.selectInside,
    o = e.refJsonEditor,
    r = e.json,
    i = e.selection,
    a = e.readOnly,
    s = e.parser,
    l = e.onPatch,
    c = e.onReplaceJson;
  if (!a) {
    var u = function (e, n, t) {
      if ("object" === t) return {};
      if ("array" === t) return [];
      if ("structure" === t && void 0 !== e) {
        var o = n ? Ws(n) : [],
          r = z(e, o);
        if (Array.isArray(r) && !G(r)) {
          var i = te(r);
          return Yr(i) ? re(i, function (e) {
            return Array.isArray(e) ? [] : Qr(e) ? void 0 : "";
          }) : "";
        }
      }
      return "";
    }(r, i, n);
    if (void 0 !== r) {
      var d = s.stringify(u),
        f = Il(r, i, d, s);
      Ig("onInsert", {
        insertType: n,
        operations: f,
        newValue: u,
        data: d
      });
      var v = ee(f.filter(function (e) {
        return "add" === e.op || "replace" === e.op;
      }));
      l(f, function (e, n) {
        if (v) {
          var o = A(e, v.path);
          if (Yr(u)) return {
            state: g(g({}, gs(e, n, o, Ns)), {}, {
              selection: t ? sl(o) : n.selection
            })
          };
          if ("" === u) {
            var r = G(o) ? null : z(e, X(o));
            return {
              state: ms(e, g(g({}, n), {}, {
                selection: Qr(r) ? il(o, !0) : al(o, !0)
              }), o)
            };
          }
        } else ;
      }), Ig("after patch"), v && "" === u && Gg(function () {
        return Ki(o, "", !0, Kg);
      });
    } else {
      Ig("onInsert", {
        insertType: n,
        newValue: u
      });
      var p = [];
      c(u, function (e, n) {
        return {
          state: g(g({}, Ts(e, n, p)), {}, {
            selection: Yr(u) ? sl(p) : al(p, !0)
          })
        };
      });
    }
  }
}
function _g(e) {
  return Wg.apply(this, arguments);
}
function Wg() {
  return Wg = a(r().mark(function e(n) {
    var t, o, i, a, s, l, c, u, d, f, v, p;
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          if (t = n.char, o = n.selectInside, i = n.refJsonEditor, a = n.json, s = n.selection, l = n.readOnly, c = n.parser, u = n.onPatch, d = n.onReplaceJson, f = n.onSelect, !l) {
            e.next = 3;
            break;
          }
          return e.abrupt("return");
        case 3:
          if (!Ls(s)) {
            e.next = 8;
            break;
          }
          return v = !s.edit, f(g(g({}, s), {}, {
            edit: !0
          })), Gg(function () {
            return Ki(i, t, v, Kg);
          }), e.abrupt("return");
        case 8:
          if ("{" !== t) {
            e.next = 12;
            break;
          }
          Hg({
            insertType: "object",
            selectInside: o,
            refJsonEditor: i,
            json: a,
            selection: s,
            readOnly: l,
            parser: c,
            onPatch: u,
            onReplaceJson: d
          }), e.next = 23;
          break;
        case 12:
          if ("[" !== t) {
            e.next = 16;
            break;
          }
          Hg({
            insertType: "array",
            selectInside: o,
            refJsonEditor: i,
            json: a,
            selection: s,
            readOnly: l,
            parser: c,
            onPatch: u,
            onReplaceJson: d
          }), e.next = 23;
          break;
        case 16:
          if (!Us(s) || void 0 === a) {
            e.next = 20;
            break;
          }
          Yr(z(a, s.path)) || (p = !s.edit, f(g(g({}, s), {}, {
            edit: !0
          })), Gg(function () {
            return Ki(i, t, p, Kg);
          })), e.next = 23;
          break;
        case 20:
          return Ig("onInsertValueWithCharacter", {
            char: t
          }), e.next = 23, Qg({
            char: t,
            refJsonEditor: i,
            json: a,
            selection: s,
            readOnly: l,
            parser: c,
            onPatch: u,
            onReplaceJson: d
          });
        case 23:
        case "end":
          return e.stop();
      }
    }, e);
  })), Wg.apply(this, arguments);
}
function Qg(e) {
  return Yg.apply(this, arguments);
}
function Yg() {
  return Yg = a(r().mark(function e(n) {
    var t, o, i, a, s, l, c, u, d;
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          if (t = n.char, o = n.refJsonEditor, i = n.json, a = n.selection, s = n.readOnly, l = n.parser, c = n.onPatch, u = n.onReplaceJson, !s) {
            e.next = 3;
            break;
          }
          return e.abrupt("return");
        case 3:
          Hg({
            insertType: "value",
            selectInside: !1,
            refJsonEditor: o,
            json: i,
            selection: a,
            readOnly: s,
            parser: l,
            onPatch: c,
            onReplaceJson: u
          }), d = !dl(a), Gg(function () {
            return Ki(o, t, d, Kg);
          });
        case 6:
        case "end":
          return e.stop();
      }
    }, e);
  })), Yg.apply(this, arguments);
}
function Gg(e) {
  setTimeout(function () {
    return setTimeout(e);
  });
}
function Kg(e) {
  null == e || e.refresh();
}
function Zg(e) {
  St(e, "svelte-l2z0i3", '.jse-json-preview.svelte-l2z0i3{flex:1;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-panel-color-readonly, #b2b2b2);overflow:auto;white-space:pre-wrap;padding:2px;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7);border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}');
}
function Xg(e) {
  var n, t;
  return {
    c: function () {
      n = Pt("div"), t = Tt(e[0]), Ut(n, "class", "jse-json-preview svelte-l2z0i3");
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: function (e, n) {
      1 & s(n, 1)[0] && Ht(t, e[0]);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function eh(e, n, t) {
  var o,
    r,
    i = n.text,
    a = n.json,
    s = n.indentation,
    l = n.parser;
  return e.$$set = function (e) {
    "text" in e && t(1, i = e.text), "json" in e && t(2, a = e.json), "indentation" in e && t(3, s = e.indentation), "parser" in e && t(4, l = e.parser);
  }, e.$$.update = function () {
    6 & e.$$.dirty && t(5, o = void 0 !== a ? {
      json: a
    } : {
      text: i || ""
    }), 56 & e.$$.dirty && t(0, r = Ea(Ci(o, s, l), wr));
  }, [r, i, a, s, l, o];
}
var nh = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, eh, Xg, lt, {
      text: 1,
      json: 2,
      indentation: 3,
      parser: 4
    }, Zg), t;
  }
  return v(n, Wo), b(n);
}();
function th(e) {
  St(e, "svelte-szeu2l", 'button.jse-context-menu-button.svelte-szeu2l{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;flex:1;white-space:nowrap;padding:var(--jse-padding, 10px);color:inherit}button.jse-context-menu-button.svelte-szeu2l:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}button.jse-context-menu-button.svelte-szeu2l:focus{background:var(--jse-context-menu-background-highlight, #7a7a7a);z-index:1}button.jse-context-menu-button.svelte-szeu2l:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}button.jse-context-menu-button.left.svelte-szeu2l{text-align:left}button.jse-context-menu-button.svelte-szeu2l svg{width:16px}');
}
function oh(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: e[0].icon
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.data = e[0].icon), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function rh(e) {
  var n,
    t = e[0].text + "";
  return {
    c: function () {
      n = Tt(t);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, o) {
      1 & o && t !== (t = e[0].text + "") && Ht(n, t);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function ih(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    l,
    c,
    u = e[0].icon && oh(e),
    d = e[0].text && rh(e);
  return {
    c: function () {
      n = Pt("button"), u && u.c(), t = At(), d && d.c(), Ut(n, "type", "button"), Ut(n, "class", o = ht(xl("jse-context-menu-button", e[1], e[0].className)) + " svelte-szeu2l"), Ut(n, "title", r = e[0].title), n.disabled = i = e[0].disabled || !1;
    },
    m: function (o, r) {
      Rt(o, n, r), u && u.m(n, null), Ct(n, t), d && d.m(n, null), a = !0, l || (c = Bt(n, "click", e[3]), l = !0);
    },
    p: function (e, l) {
      var c = s(l, 1)[0];
      e[0].icon ? u ? (u.p(e, c), 1 & c && qo(u, 1)) : ((u = oh(e)).c(), qo(u, 1), u.m(n, t)) : u && (Ro(), Po(u, 1, 1, function () {
        u = null;
      }), Eo()), e[0].text ? d ? d.p(e, c) : ((d = rh(e)).c(), d.m(n, null)) : d && (d.d(1), d = null), (!a || 3 & c && o !== (o = ht(xl("jse-context-menu-button", e[1], e[0].className)) + " svelte-szeu2l")) && Ut(n, "class", o), (!a || 1 & c && r !== (r = e[0].title)) && Ut(n, "title", r), (!a || 1 & c && i !== (i = e[0].disabled || !1)) && (n.disabled = i);
    },
    i: function (e) {
      a || (qo(u), a = !0);
    },
    o: function (e) {
      Po(u), a = !1;
    },
    d: function (e) {
      e && Et(n), u && u.d(), d && d.d(), l = !1, c();
    }
  };
}
function ah(e, n, t) {
  var o = n.item,
    r = n.className,
    i = void 0 === r ? void 0 : r,
    a = n.onRequestClose;
  return e.$$set = function (e) {
    "item" in e && t(0, o = e.item), "className" in e && t(1, i = e.className), "onRequestClose" in e && t(2, a = e.onRequestClose);
  }, [o, i, a, function (e) {
    a(), o.onClick(e);
  }];
}
var sh = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, ah, ih, lt, {
      item: 0,
      className: 1,
      onRequestClose: 2
    }, th), t;
  }
  return v(n, Wo), b(n);
}();
function lh(e) {
  St(e, "svelte-9i012w", '.jse-dropdown-button.svelte-9i012w.svelte-9i012w{flex:1;line-height:normal;border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;position:relative;padding:0;display:flex}.jse-dropdown-button.svelte-9i012w ul.svelte-9i012w{margin:0;padding:0}.jse-dropdown-button.svelte-9i012w ul li.svelte-9i012w{margin:0;padding:0;list-style-type:none}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;width:2em;background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));border-radius:0}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.jse-visible.svelte-9i012w{background:var(--jse-context-menu-background, #656565)}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w:focus{z-index:1}.jse-dropdown-button.svelte-9i012w button.jse-open-dropdown.svelte-9i012w:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items.svelte-9i012w{display:none;position:absolute;top:100%;left:0;z-index:1;background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff));box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24))}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items.jse-visible.svelte-9i012w{display:block}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items button.svelte-9i012w{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;width:100%;text-align:left;padding:var(--jse-padding, 10px);margin:0}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items button.svelte-9i012w:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}.jse-dropdown-button.svelte-9i012w .jse-dropdown-items button.svelte-9i012w:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}');
}
function ch(e, n, t) {
  var o = e.slice();
  return o[11] = n[t], o;
}
var uh = function (e) {
    return {};
  },
  dh = function (e) {
    return {};
  };
function fh(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: e[11].icon
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.data = e[11].icon), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function vh(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f = e[11].text + "",
    v = e[11].icon && fh(e);
  function p() {
    for (var n, t = arguments.length, o = new Array(t), r = 0; r < t; r++) o[r] = arguments[r];
    return (n = e)[9].apply(n, [e[11]].concat(o));
  }
  return {
    c: function () {
      n = Pt("li"), t = Pt("button"), v && v.c(), o = At(), r = Tt(f), l = At(), Ut(t, "type", "button"), Ut(t, "title", i = e[11].title), t.disabled = a = e[11].disabled, Ut(t, "class", s = ht(e[11].className) + " svelte-9i012w"), Ut(n, "class", "svelte-9i012w");
    },
    m: function (e, i) {
      Rt(e, n, i), Ct(n, t), v && v.m(t, null), Ct(t, o), Ct(t, r), Ct(n, l), c = !0, u || (d = Bt(t, "click", p), u = !0);
    },
    p: function (n, l) {
      (e = n)[11].icon ? v ? (v.p(e, l), 1 & l && qo(v, 1)) : ((v = fh(e)).c(), qo(v, 1), v.m(t, o)) : v && (Ro(), Po(v, 1, 1, function () {
        v = null;
      }), Eo()), (!c || 1 & l) && f !== (f = e[11].text + "") && Ht(r, f), (!c || 1 & l && i !== (i = e[11].title)) && Ut(t, "title", i), (!c || 1 & l && a !== (a = e[11].disabled)) && (t.disabled = a), (!c || 1 & l && s !== (s = ht(e[11].className) + " svelte-9i012w")) && Ut(t, "class", s);
    },
    i: function (e) {
      c || (qo(v), c = !0);
    },
    o: function (e) {
      Po(v), c = !1;
    },
    d: function (e) {
      e && Et(n), v && v.d(), u = !1, d();
    }
  };
}
function ph(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    l,
    c,
    u,
    d,
    f = e[8].defaultItem,
    v = ut(f, e, e[7], dh);
  r = new Ya({
    props: {
      data: Oe
    }
  });
  for (var p = Ao(e[0]), m = [], g = 0; g < p.length; g += 1) m[g] = vh(ch(e, p, g));
  var h = function (e) {
    return Po(m[e], 1, 1, function () {
      m[e] = null;
    });
  };
  return {
    c: function () {
      n = Pt("div"), v && v.c(), t = At(), o = Pt("button"), Jo(r.$$.fragment), i = At(), a = Pt("div"), l = Pt("ul");
      for (var s = 0; s < m.length; s += 1) m[s].c();
      Ut(o, "type", "button"), Ut(o, "class", "jse-open-dropdown svelte-9i012w"), Ut(o, "data-type", "jse-open-dropdown"), o.disabled = e[4], Yt(o, "jse-visible", e[3]), Ut(l, "class", "svelte-9i012w"), Ut(a, "class", "jse-dropdown-items svelte-9i012w"), Wt(a, "width", e[2]), Yt(a, "jse-visible", e[3]), Ut(n, "role", "button"), Ut(n, "tabindex", "0"), Ut(n, "class", "jse-dropdown-button svelte-9i012w"), Ut(n, "title", e[1]);
    },
    m: function (s, f) {
      Rt(s, n, f), v && v.m(n, null), Ct(n, t), Ct(n, o), Vo(r, o, null), Ct(n, i), Ct(n, a), Ct(a, l);
      for (var p = 0; p < m.length; p += 1) m[p] && m[p].m(l, null);
      c = !0, u || (d = [Bt(o, "click", e[5]), Bt(n, "click", e[6])], u = !0);
    },
    p: function (e, t) {
      var r = s(t, 1)[0];
      if (v && v.p && (!c || 128 & r) && vt(v, f, e, e[7], c ? ft(f, e[7], r, uh) : pt(e[7]), dh), (!c || 16 & r) && (o.disabled = e[4]), (!c || 8 & r) && Yt(o, "jse-visible", e[3]), 1 & r) {
        var i;
        for (p = Ao(e[0]), i = 0; i < p.length; i += 1) {
          var u = ch(e, p, i);
          m[i] ? (m[i].p(u, r), qo(m[i], 1)) : (m[i] = vh(u), m[i].c(), qo(m[i], 1), m[i].m(l, null));
        }
        for (Ro(), i = p.length; i < m.length; i += 1) h(i);
        Eo();
      }
      (!c || 4 & r) && Wt(a, "width", e[2]), (!c || 8 & r) && Yt(a, "jse-visible", e[3]), (!c || 2 & r) && Ut(n, "title", e[1]);
    },
    i: function (e) {
      if (!c) {
        qo(v, e), qo(r.$$.fragment, e);
        for (var n = 0; n < p.length; n += 1) qo(m[n]);
        c = !0;
      }
    },
    o: function (e) {
      Po(v, e), Po(r.$$.fragment, e), m = m.filter(Boolean);
      for (var n = 0; n < m.length; n += 1) Po(m[n]);
      c = !1;
    },
    d: function (e) {
      e && Et(n), v && v.d(e), Ho(r), qt(m, e), u = !1, at(d);
    }
  };
}
function mh(e, n, t) {
  var o,
    r = n.$$slots,
    i = void 0 === r ? {} : r,
    a = n.$$scope,
    s = n.items,
    l = void 0 === s ? [] : s,
    c = n.title,
    u = void 0 === c ? void 0 : c,
    d = n.width,
    f = void 0 === d ? "120px" : d,
    v = !1;
  function p() {
    t(3, v = !1);
  }
  function m(e) {
    "Escape" === sa(e) && (e.preventDefault(), t(3, v = !1));
  }
  io(function () {
    document.addEventListener("click", p), document.addEventListener("keydown", m);
  }), ao(function () {
    document.removeEventListener("click", p), document.removeEventListener("keydown", m);
  });
  return e.$$set = function (e) {
    "items" in e && t(0, l = e.items), "title" in e && t(1, u = e.title), "width" in e && t(2, f = e.width), "$$scope" in e && t(7, a = e.$$scope);
  }, e.$$.update = function () {
    1 & e.$$.dirty && t(4, o = l.every(function (e) {
      return !0 === e.disabled;
    }));
  }, [l, u, f, v, o, function () {
    var e = v;
    setTimeout(function () {
      return t(3, v = !e);
    });
  }, p, a, i, function (e, n) {
    return e.onClick(n);
  }];
}
var gh = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, mh, ph, ct, {
      items: 0,
      title: 1,
      width: 2
    }, lh), t;
  }
  return v(n, Wo), b(n);
}();
function hh(e) {
  St(e, "svelte-szeu2l", 'button.jse-context-menu-button.svelte-szeu2l{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;flex:1;white-space:nowrap;padding:var(--jse-padding, 10px);color:inherit}button.jse-context-menu-button.svelte-szeu2l:hover{background:var(--jse-context-menu-background-highlight, #7a7a7a)}button.jse-context-menu-button.svelte-szeu2l:focus{background:var(--jse-context-menu-background-highlight, #7a7a7a);z-index:1}button.jse-context-menu-button.svelte-szeu2l:disabled{color:var(--jse-context-menu-color-disabled, #9d9d9d);background:unset}button.jse-context-menu-button.left.svelte-szeu2l{text-align:left}button.jse-context-menu-button.svelte-szeu2l svg{width:16px}');
}
function jh(e) {
  var n, t;
  return n = new Ya({
    props: {
      data: e[0].main.icon
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.data = e[0].main.icon), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function bh(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u = e[0].main.text + "",
    d = e[0].main.icon && jh(e);
  return {
    c: function () {
      n = Pt("button"), d && d.c(), t = At(), o = Tt(u), Ut(n, "class", r = ht(xl("jse-context-menu-button", e[1], e[0].main.className)) + " svelte-szeu2l"), Ut(n, "type", "button"), Ut(n, "slot", "defaultItem"), Ut(n, "title", i = e[0].main.title), n.disabled = a = e[0].main.disabled || !1;
    },
    m: function (r, i) {
      Rt(r, n, i), d && d.m(n, null), Ct(n, t), Ct(n, o), s = !0, l || (c = Bt(n, "click", e[4]), l = !0);
    },
    p: function (e, l) {
      e[0].main.icon ? d ? (d.p(e, l), 1 & l && qo(d, 1)) : ((d = jh(e)).c(), qo(d, 1), d.m(n, t)) : d && (Ro(), Po(d, 1, 1, function () {
        d = null;
      }), Eo()), (!s || 1 & l) && u !== (u = e[0].main.text + "") && Ht(o, u), (!s || 3 & l && r !== (r = ht(xl("jse-context-menu-button", e[1], e[0].main.className)) + " svelte-szeu2l")) && Ut(n, "class", r), (!s || 1 & l && i !== (i = e[0].main.title)) && Ut(n, "title", i), (!s || 1 & l && a !== (a = e[0].main.disabled || !1)) && (n.disabled = a);
    },
    i: function (e) {
      s || (qo(d), s = !0);
    },
    o: function (e) {
      Po(d), s = !1;
    },
    d: function (e) {
      e && Et(n), d && d.d(), l = !1, c();
    }
  };
}
function yh(e) {
  var n, t;
  return n = new gh({
    props: {
      width: e[0].width,
      items: e[3],
      $$slots: {
        defaultItem: [bh]
      },
      $$scope: {
        ctx: e
      }
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = s(t, 1)[0],
        r = {};
      1 & o && (r.width = e[0].width), 8 & o && (r.items = e[3]), 39 & o && (r.$$scope = {
        dirty: o,
        ctx: e
      }), n.$set(r);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function xh(e, n, t) {
  var o,
    r = n.item,
    i = n.className,
    a = void 0 === i ? void 0 : i,
    s = n.onRequestClose;
  return e.$$set = function (e) {
    "item" in e && t(0, r = e.item), "className" in e && t(1, a = e.className), "onRequestClose" in e && t(2, s = e.onRequestClose);
  }, e.$$.update = function () {
    5 & e.$$.dirty && t(3, o = r.items.map(function (e) {
      return g(g({}, e), {}, {
        onClick: function (n) {
          s(), e.onClick(n);
        }
      });
    }));
  }, [r, a, s, o, function (e) {
    s(), r.main.onClick(e);
  }];
}
var wh = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, xh, yh, lt, {
      item: 0,
      className: 1,
      onRequestClose: 2
    }, hh), t;
  }
  return v(n, Wo), b(n);
}();
function $h(e) {
  St(e, "svelte-fnyc8j", '.jse-contextmenu.svelte-fnyc8j.svelte-fnyc8j{box-shadow:var(--jse-controls-box-shadow, 0 2px 6px 0 rgba(0, 0, 0, 0.24));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);background:var(--jse-context-menu-background, #656565);color:var(--jse-context-menu-color, var(--jse-text-color-inverse, #fff))}.jse-contextmenu.svelte-fnyc8j .jse-row.svelte-fnyc8j{display:flex;flex-direction:row;align-items:flex-start;justify-content:stretch}.jse-contextmenu.svelte-fnyc8j .jse-row div.jse-label.svelte-fnyc8j{flex:1;white-space:nowrap;padding:var(--jse-padding, 10px);color:var(--jse-context-menu-color-disabled, #9d9d9d);line-height:normal}.jse-contextmenu.svelte-fnyc8j .jse-row div.jse-tip.svelte-fnyc8j{flex:1;background:var(--jse-context-menu-tip-background, rgba(255, 255, 255, 0.2));color:var(--context-menu-tip-color, inherit);margin:calc(0.5 * var(--jse-padding, 10px));padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);font-size:80%;line-height:1.3em;display:flex;flex-direction:row;align-items:flex-start;gap:var(--jse-padding, 10px);border-radius:3px}.jse-contextmenu.svelte-fnyc8j .jse-row div.jse-tip div.jse-tip-icon.svelte-fnyc8j{padding-top:calc(0.5 * var(--jse-padding, 10px))}.jse-contextmenu.svelte-fnyc8j .jse-column.svelte-fnyc8j{flex:1;display:flex;flex-direction:column;align-items:stretch}.jse-contextmenu.svelte-fnyc8j .jse-column.svelte-fnyc8j:not(:last-child){border-right:1px solid var(--jse-context-menu-separator-color, #7a7a7a)}.jse-contextmenu.svelte-fnyc8j .jse-separator.svelte-fnyc8j{width:100%;height:1px;background:var(--jse-context-menu-separator-color, #7a7a7a)}');
}
function kh(e, n, t) {
  var o = e.slice();
  return o[7] = n[t], o;
}
function Ch(e, n, t) {
  var o = e.slice();
  return o[10] = n[t], o;
}
function Sh(e, n, t) {
  var o = e.slice();
  return o[13] = n[t], o;
}
function Mh(e) {
  var n,
    t = Wh(e[7]) + "";
  return {
    c: function () {
      n = Tt(t);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, o) {
      1 & o && t !== (t = Wh(e[7]) + "") && Ht(n, t);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Oh(e) {
  var n;
  return {
    c: function () {
      Ut(n = Pt("div"), "class", "jse-separator svelte-fnyc8j");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function zh(e) {
  for (var n, t, o = Ao(e[7].items), r = [], i = 0; i < o.length; i += 1) r[i] = Jh(Ch(e, o, i));
  var a = function (e) {
    return Po(r[e], 1, 1, function () {
      r[e] = null;
    });
  };
  return {
    c: function () {
      n = Pt("div");
      for (var e = 0; e < r.length; e += 1) r[e].c();
      Ut(n, "class", "jse-row svelte-fnyc8j");
    },
    m: function (e, o) {
      Rt(e, n, o);
      for (var i = 0; i < r.length; i += 1) r[i] && r[i].m(n, null);
      t = !0;
    },
    p: function (e, t) {
      if (3 & t) {
        var i;
        for (o = Ao(e[7].items), i = 0; i < o.length; i += 1) {
          var s = Ch(e, o, i);
          r[i] ? (r[i].p(s, t), qo(r[i], 1)) : (r[i] = Jh(s), r[i].c(), qo(r[i], 1), r[i].m(n, null));
        }
        for (Ro(), i = o.length; i < r.length; i += 1) a(i);
        Eo();
      }
    },
    i: function (e) {
      if (!t) {
        for (var n = 0; n < o.length; n += 1) qo(r[n]);
        t = !0;
      }
    },
    o: function (e) {
      r = r.filter(Boolean);
      for (var n = 0; n < r.length; n += 1) Po(r[n]);
      t = !1;
    },
    d: function (e) {
      e && Et(n), qt(r, e);
    }
  };
}
function Rh(e) {
  var n, t;
  return n = new wh({
    props: {
      item: e[7],
      onRequestClose: e[1]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.item = e[7]), 2 & t && (o.onRequestClose = e[1]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Eh(e) {
  var n, t;
  return n = new sh({
    props: {
      item: e[7],
      onRequestClose: e[1]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.item = e[7]), 2 & t && (o.onRequestClose = e[1]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function qh(e) {
  var n,
    t = Wh(e[10]) + "";
  return {
    c: function () {
      n = Tt(t);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, o) {
      1 & o && t !== (t = Wh(e[10]) + "") && Ht(n, t);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Ph(e) {
  var n;
  return {
    c: function () {
      Ut(n = Pt("div"), "class", "jse-separator svelte-fnyc8j");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Ih(e) {
  for (var n, t, o = Ao(e[10].items), r = [], i = 0; i < o.length; i += 1) r[i] = Dh(Sh(e, o, i));
  var a = function (e) {
    return Po(r[e], 1, 1, function () {
      r[e] = null;
    });
  };
  return {
    c: function () {
      n = Pt("div");
      for (var e = 0; e < r.length; e += 1) r[e].c();
      Ut(n, "class", "jse-column svelte-fnyc8j");
    },
    m: function (e, o) {
      Rt(e, n, o);
      for (var i = 0; i < r.length; i += 1) r[i] && r[i].m(n, null);
      t = !0;
    },
    p: function (e, t) {
      if (3 & t) {
        var i;
        for (o = Ao(e[10].items), i = 0; i < o.length; i += 1) {
          var s = Sh(e, o, i);
          r[i] ? (r[i].p(s, t), qo(r[i], 1)) : (r[i] = Dh(s), r[i].c(), qo(r[i], 1), r[i].m(n, null));
        }
        for (Ro(), i = o.length; i < r.length; i += 1) a(i);
        Eo();
      }
    },
    i: function (e) {
      if (!t) {
        for (var n = 0; n < o.length; n += 1) qo(r[n]);
        t = !0;
      }
    },
    o: function (e) {
      r = r.filter(Boolean);
      for (var n = 0; n < r.length; n += 1) Po(r[n]);
      t = !1;
    },
    d: function (e) {
      e && Et(n), qt(r, e);
    }
  };
}
function Th(e) {
  var n, t;
  return n = new wh({
    props: {
      item: e[10],
      onRequestClose: e[1]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.item = e[10]), 2 & t && (o.onRequestClose = e[1]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Ah(e) {
  var n, t;
  return n = new sh({
    props: {
      item: e[10],
      onRequestClose: e[1]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.item = e[10]), 2 & t && (o.onRequestClose = e[1]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Nh(e) {
  var n,
    t = Wh(e[13]) + "";
  return {
    c: function () {
      n = Tt(t);
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: function (e, o) {
      1 & o && t !== (t = Wh(e[13]) + "") && Ht(n, t);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Bh(e) {
  var n,
    t,
    o = e[13].text + "";
  return {
    c: function () {
      n = Pt("div"), t = Tt(o), Ut(n, "class", "jse-label svelte-fnyc8j");
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: function (e, n) {
      1 & n && o !== (o = e[13].text + "") && Ht(t, o);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Fh(e) {
  var n;
  return {
    c: function () {
      Ut(n = Pt("div"), "class", "jse-separator svelte-fnyc8j");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Lh(e) {
  var n, t;
  return n = new wh({
    props: {
      className: "left",
      item: e[13],
      onRequestClose: e[1]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.item = e[13]), 2 & t && (o.onRequestClose = e[1]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Uh(e) {
  var n, t;
  return n = new sh({
    props: {
      className: "left",
      item: e[13],
      onRequestClose: e[1]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t && (o.item = e[13]), 2 & t && (o.onRequestClose = e[1]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Dh(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c = [Uh, Lh, Fh, Bh, Nh],
    u = [];
  function d(e, i) {
    return 1 & i && (n = null), 1 & i && (t = null), 1 & i && (o = null), 1 & i && (r = null), null == n && (n = !!iv(e[13])), n ? 0 : (null == t && (t = !!av(e[13])), t ? 1 : (null == o && (o = !!ov(e[13])), o ? 2 : (null == r && (r = !!rv(e[13])), r ? 3 : 4)));
  }
  return i = d(e, -1), a = u[i] = c[i](e), {
    c: function () {
      a.c(), s = Nt();
    },
    m: function (e, n) {
      u[i].m(e, n), Rt(e, s, n), l = !0;
    },
    p: function (e, n) {
      var t = i;
      (i = d(e, n)) === t ? u[i].p(e, n) : (Ro(), Po(u[t], 1, 1, function () {
        u[t] = null;
      }), Eo(), (a = u[i]) ? a.p(e, n) : (a = u[i] = c[i](e)).c(), qo(a, 1), a.m(s.parentNode, s));
    },
    i: function (e) {
      l || (qo(a), l = !0);
    },
    o: function (e) {
      Po(a), l = !1;
    },
    d: function (e) {
      e && Et(s), u[i].d(e);
    }
  };
}
function Jh(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c = [Ah, Th, Ih, Ph, qh],
    u = [];
  function d(e, i) {
    return 1 & i && (n = null), 1 & i && (t = null), 1 & i && (o = null), 1 & i && (r = null), null == n && (n = !!iv(e[10])), n ? 0 : (null == t && (t = !!av(e[10])), t ? 1 : (null == o && (o = !!lv(e[10])), o ? 2 : (null == r && (r = !!ov(e[10])), r ? 3 : 4)));
  }
  return i = d(e, -1), a = u[i] = c[i](e), {
    c: function () {
      a.c(), s = Nt();
    },
    m: function (e, n) {
      u[i].m(e, n), Rt(e, s, n), l = !0;
    },
    p: function (e, n) {
      var t = i;
      (i = d(e, n)) === t ? u[i].p(e, n) : (Ro(), Po(u[t], 1, 1, function () {
        u[t] = null;
      }), Eo(), (a = u[i]) ? a.p(e, n) : (a = u[i] = c[i](e)).c(), qo(a, 1), a.m(s.parentNode, s));
    },
    i: function (e) {
      l || (qo(a), l = !0);
    },
    o: function (e) {
      Po(a), l = !1;
    },
    d: function (e) {
      e && Et(s), u[i].d(e);
    }
  };
}
function Vh(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c = [Eh, Rh, zh, Oh, Mh],
    u = [];
  function d(e, i) {
    return 1 & i && (n = null), 1 & i && (t = null), 1 & i && (o = null), 1 & i && (r = null), null == n && (n = !!iv(e[7])), n ? 0 : (null == t && (t = !!av(e[7])), t ? 1 : (null == o && (o = !!sv(e[7])), o ? 2 : (null == r && (r = !!ov(e[7])), r ? 3 : 4)));
  }
  return i = d(e, -1), a = u[i] = c[i](e), {
    c: function () {
      a.c(), s = Nt();
    },
    m: function (e, n) {
      u[i].m(e, n), Rt(e, s, n), l = !0;
    },
    p: function (e, n) {
      var t = i;
      (i = d(e, n)) === t ? u[i].p(e, n) : (Ro(), Po(u[t], 1, 1, function () {
        u[t] = null;
      }), Eo(), (a = u[i]) ? a.p(e, n) : (a = u[i] = c[i](e)).c(), qo(a, 1), a.m(s.parentNode, s));
    },
    i: function (e) {
      l || (qo(a), l = !0);
    },
    o: function (e) {
      Po(a), l = !1;
    },
    d: function (e) {
      e && Et(s), u[i].d(e);
    }
  };
}
function Hh(e) {
  var n, t, o, r, i, a, s, l;
  return r = new Ya({
    props: {
      data: he
    }
  }), {
    c: function () {
      n = Pt("div"), t = Pt("div"), o = Pt("div"), Jo(r.$$.fragment), i = At(), a = Pt("div"), s = Tt(e[2]), Ut(o, "class", "jse-tip-icon svelte-fnyc8j"), Ut(a, "class", "jse-tip-text"), Ut(t, "class", "jse-tip svelte-fnyc8j"), Ut(n, "class", "jse-row svelte-fnyc8j");
    },
    m: function (e, c) {
      Rt(e, n, c), Ct(n, t), Ct(t, o), Vo(r, o, null), Ct(t, i), Ct(t, a), Ct(a, s), l = !0;
    },
    p: function (e, n) {
      (!l || 4 & n) && Ht(s, e[2]);
    },
    i: function (e) {
      l || (qo(r.$$.fragment, e), l = !0);
    },
    o: function (e) {
      Po(r.$$.fragment, e), l = !1;
    },
    d: function (e) {
      e && Et(n), Ho(r);
    }
  };
}
function _h(e) {
  for (var n, t, o, r, i, a = Ao(e[0]), l = [], c = 0; c < a.length; c += 1) l[c] = Vh(kh(e, a, c));
  var u = function (e) {
      return Po(l[e], 1, 1, function () {
        l[e] = null;
      });
    },
    d = e[2] && Hh(e);
  return {
    c: function () {
      n = Pt("div");
      for (var e = 0; e < l.length; e += 1) l[e].c();
      t = At(), d && d.c(), Ut(n, "role", "menu"), Ut(n, "tabindex", "-1"), Ut(n, "class", "jse-contextmenu svelte-fnyc8j");
    },
    m: function (a, s) {
      Rt(a, n, s);
      for (var c = 0; c < l.length; c += 1) l[c] && l[c].m(n, null);
      Ct(n, t), d && d.m(n, null), e[5](n), o = !0, r || (i = Bt(n, "keydown", e[4]), r = !0);
    },
    p: function (e, o) {
      var r = s(o, 1)[0];
      if (3 & r) {
        var i;
        for (a = Ao(e[0]), i = 0; i < a.length; i += 1) {
          var c = kh(e, a, i);
          l[i] ? (l[i].p(c, r), qo(l[i], 1)) : (l[i] = Vh(c), l[i].c(), qo(l[i], 1), l[i].m(n, t));
        }
        for (Ro(), i = a.length; i < l.length; i += 1) u(i);
        Eo();
      }
      e[2] ? d ? (d.p(e, r), 4 & r && qo(d, 1)) : ((d = Hh(e)).c(), qo(d, 1), d.m(n, null)) : d && (Ro(), Po(d, 1, 1, function () {
        d = null;
      }), Eo());
    },
    i: function (e) {
      if (!o) {
        for (var n = 0; n < a.length; n += 1) qo(l[n]);
        qo(d), o = !0;
      }
    },
    o: function (e) {
      l = l.filter(Boolean);
      for (var n = 0; n < l.length; n += 1) Po(l[n]);
      Po(d), o = !1;
    },
    d: function (t) {
      t && Et(n), qt(l, t), d && d.d(), e[5](null), r = !1, i();
    }
  };
}
function Wh(e) {
  return console.error("Unknown type of context menu item", e), "???";
}
function Qh(e, n, t) {
  var o,
    r = n.items,
    i = n.onRequestClose,
    a = n.tip;
  io(function () {
    var e = Array.from(o.querySelectorAll("button")).find(function (e) {
      return !e.disabled;
    });
    e && e.focus();
  });
  var s = {
    ArrowUp: "Up",
    ArrowDown: "Down",
    ArrowLeft: "Left",
    ArrowRight: "Right"
  };
  return e.$$set = function (e) {
    "items" in e && t(0, r = e.items), "onRequestClose" in e && t(1, i = e.onRequestClose), "tip" in e && t(2, a = e.tip);
  }, [r, i, a, o, function (e) {
    var n = sa(e),
      t = s[n];
    if (t && e.target) {
      e.preventDefault();
      var r = ra({
        allElements: Array.from(o.querySelectorAll("button:not([disabled])")),
        currentElement: e.target,
        direction: t,
        hasPrio: function (e) {
          return "jse-open-dropdown" !== e.getAttribute("data-type");
        }
      });
      r && r.focus();
    }
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(3, o = e);
    });
  }];
}
var Yh = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Qh, _h, ct, {
      items: 0,
      onRequestClose: 1,
      tip: 2
    }, $h), t;
  }
  return v(n, Wo), b(n);
}();
var Gh = kt.window;
function Kh(e) {
  St(e, "svelte-1ig7ktu", '.jse-tree-mode.svelte-1ig7ktu.svelte-1ig7ktu{flex:1;display:flex;flex-direction:column;position:relative;background:var(--jse-background-color, #fff);min-width:0;min-height:0;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-text-color, #4d4d4d);line-height:var(--jse-line-height, calc(1em + 4px))}.jse-tree-mode.svelte-1ig7ktu .jse-hidden-input-label .jse-hidden-input.svelte-1ig7ktu{position:fixed;top:-10px;left:-10px;width:1px;height:1px;padding:0;border:0;outline:none}.jse-tree-mode.no-main-menu.svelte-1ig7ktu.svelte-1ig7ktu{border-top:var(--jse-main-border, 1px solid #d7d7d7)}.jse-tree-mode.svelte-1ig7ktu .jse-search-box-container.svelte-1ig7ktu{position:relative;height:0;top:var(--jse-padding, 10px);margin-right:calc(var(--jse-padding, 10px) + 20px);margin-left:var(--jse-padding, 10px);text-align:right;z-index:3}.jse-tree-mode.svelte-1ig7ktu .jse-contents.svelte-1ig7ktu{flex:1;overflow:auto;position:relative;padding:2px;display:flex;flex-direction:column;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-tree-mode.svelte-1ig7ktu .jse-contents.svelte-1ig7ktu:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-tree-mode.svelte-1ig7ktu .jse-contents .jse-loading-space.svelte-1ig7ktu{flex:1}.jse-tree-mode.svelte-1ig7ktu .jse-contents .jse-loading.svelte-1ig7ktu{flex:2;text-align:center;color:var(--jse-panel-color-readonly, #b2b2b2);box-sizing:border-box;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}');
}
function Zh(e) {
  var n, t, o;
  function r(n) {
    e[75](n);
  }
  var i = {
    json: e[11],
    selection: e[12].selection,
    readOnly: e[0],
    historyState: e[22],
    onExpandAll: e[38],
    onCollapseAll: e[39],
    onUndo: e[33],
    onRedo: e[34],
    onSort: e[35],
    onTransform: e[36],
    onContextMenu: e[43],
    onCopy: e[30],
    onRenderMenu: e[7]
  };
  return void 0 !== e[13] && (i.showSearch = e[13]), n = new Om({
    props: i
  }), vo.push(function () {
    return Do(n, "showSearch", r);
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, t) {
      Vo(n, e, t), o = !0;
    },
    p: function (e, o) {
      var r = {};
      2048 & o[0] && (r.json = e[11]), 4096 & o[0] && (r.selection = e[12].selection), 1 & o[0] && (r.readOnly = e[0]), 4194304 & o[0] && (r.historyState = e[22]), 128 & o[0] && (r.onRenderMenu = e[7]), !t && 8192 & o[0] && (t = !0, r.showSearch = e[13], xo(function () {
        return t = !1;
      })), n.$set(r);
    },
    i: function (e) {
      o || (qo(n.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), o = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Xh(e) {
  var n, t;
  return n = new dg({
    props: {
      json: e[11],
      selection: e[12].selection,
      onSelect: e[47],
      onError: e[6],
      pathParser: e[4]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      2048 & t[0] && (o.json = e[11]), 4096 & t[0] && (o.selection = e[12].selection), 64 & t[0] && (o.onError = e[6]), 16 & t[0] && (o.pathParser = e[4]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function ej(e) {
  var n;
  return {
    c: function () {
      (n = Pt("div")).innerHTML = '<div class="jse-loading-space svelte-1ig7ktu"></div> <div class="jse-loading svelte-1ig7ktu">loading...</div>', Ut(n, "class", "jse-contents svelte-1ig7ktu");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function nj(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u = [oj, tj],
    d = [];
  function f(e, n) {
    return void 0 === e[11] ? 0 : 1;
  }
  return r = f(e), i = d[r] = u[r](e), {
    c: function () {
      n = Pt("label"), t = Pt("input"), o = At(), i.c(), a = Nt(), Ut(t, "type", "text"), t.readOnly = !0, Ut(t, "tabindex", "-1"), Ut(t, "class", "jse-hidden-input svelte-1ig7ktu"), Ut(n, "class", "jse-hidden-input-label");
    },
    m: function (i, u) {
      Rt(i, n, u), Ct(n, t), e[76](t), Rt(i, o, u), d[r].m(i, u), Rt(i, a, u), s = !0, l || (c = Bt(t, "paste", e[31]), l = !0);
    },
    p: function (e, n) {
      var t = r;
      (r = f(e)) === t ? d[r].p(e, n) : (Ro(), Po(d[t], 1, 1, function () {
        d[t] = null;
      }), Eo(), (i = d[r]) ? i.p(e, n) : (i = d[r] = u[r](e)).c(), qo(i, 1), i.m(a.parentNode, a));
    },
    i: function (e) {
      s || (qo(i), s = !0);
    },
    o: function (e) {
      Po(i), s = !1;
    },
    d: function (t) {
      t && (Et(n), Et(o), Et(a)), e[76](null), d[r].d(t), l = !1, c();
    }
  };
}
function tj(e) {
  var n, t, o, r, i, a, s, l, c, u, d;
  o = new xg({
    props: {
      json: e[11],
      documentState: e[12],
      parser: e[3],
      showSearch: e[13],
      showReplace: e[21],
      readOnly: e[0],
      columns: void 0,
      onSearch: e[26],
      onFocus: e[27],
      onPatch: e[37],
      onClose: e[28]
    }
  }), a = new xm({
    props: {
      value: e[11],
      path: [],
      expandedMap: e[12].expandedMap,
      enforceStringMap: e[12].enforceStringMap,
      visibleSectionsMap: e[12].visibleSectionsMap,
      validationErrorsMap: e[24],
      searchResultItemsMap: null === (n = e[20]) || void 0 === n ? void 0 : n.itemsMap,
      selection: e[12].selection,
      context: e[15],
      onDragSelectionStart: oe
    }
  });
  var f = e[19] && rj(e),
    v = e[23] && ij(e);
  return u = new Qf({
    props: {
      validationErrors: e[14],
      selectError: e[29]
    }
  }), {
    c: function () {
      t = Pt("div"), Jo(o.$$.fragment), r = At(), i = Pt("div"), Jo(a.$$.fragment), s = At(), f && f.c(), l = At(), v && v.c(), c = At(), Jo(u.$$.fragment), Ut(t, "class", "jse-search-box-container svelte-1ig7ktu"), Ut(i, "class", "jse-contents svelte-1ig7ktu"), Ut(i, "data-jsoneditor-scrollable-contents", !0);
    },
    m: function (n, p) {
      Rt(n, t, p), Vo(o, t, null), Rt(n, r, p), Rt(n, i, p), Vo(a, i, null), e[80](i), Rt(n, s, p), f && f.m(n, p), Rt(n, l, p), v && v.m(n, p), Rt(n, c, p), Vo(u, n, p), d = !0;
    },
    p: function (e, n) {
      var t,
        r = {};
      2048 & n[0] && (r.json = e[11]), 4096 & n[0] && (r.documentState = e[12]), 8 & n[0] && (r.parser = e[3]), 8192 & n[0] && (r.showSearch = e[13]), 2097152 & n[0] && (r.showReplace = e[21]), 1 & n[0] && (r.readOnly = e[0]), o.$set(r);
      var i = {};
      2048 & n[0] && (i.value = e[11]), 4096 & n[0] && (i.expandedMap = e[12].expandedMap), 4096 & n[0] && (i.enforceStringMap = e[12].enforceStringMap), 4096 & n[0] && (i.visibleSectionsMap = e[12].visibleSectionsMap), 16777216 & n[0] && (i.validationErrorsMap = e[24]), 1048576 & n[0] && (i.searchResultItemsMap = null === (t = e[20]) || void 0 === t ? void 0 : t.itemsMap), 4096 & n[0] && (i.selection = e[12].selection), 32768 & n[0] && (i.context = e[15]), a.$set(i), e[19] ? f ? (f.p(e, n), 524288 & n[0] && qo(f, 1)) : ((f = rj(e)).c(), qo(f, 1), f.m(l.parentNode, l)) : f && (Ro(), Po(f, 1, 1, function () {
        f = null;
      }), Eo()), e[23] ? v ? (v.p(e, n), 8388608 & n[0] && qo(v, 1)) : ((v = ij(e)).c(), qo(v, 1), v.m(c.parentNode, c)) : v && (Ro(), Po(v, 1, 1, function () {
        v = null;
      }), Eo());
      var s = {};
      16384 & n[0] && (s.validationErrors = e[14]), u.$set(s);
    },
    i: function (e) {
      d || (qo(o.$$.fragment, e), qo(a.$$.fragment, e), qo(f), qo(v), qo(u.$$.fragment, e), d = !0);
    },
    o: function (e) {
      Po(o.$$.fragment, e), Po(a.$$.fragment, e), Po(f), Po(v), Po(u.$$.fragment, e), d = !1;
    },
    d: function (n) {
      n && (Et(t), Et(r), Et(i), Et(s), Et(l), Et(c)), Ho(o), Ho(a), e[80](null), f && f.d(n), v && v.d(n), Ho(u, n);
    }
  };
}
function oj(e) {
  var n,
    t,
    o,
    r,
    i = [sj, aj],
    a = [];
  function s(e, n) {
    return "" === e[18] || void 0 === e[18] ? 0 : 1;
  }
  return n = s(e), t = a[n] = i[n](e), {
    c: function () {
      t.c(), o = Nt();
    },
    m: function (e, t) {
      a[n].m(e, t), Rt(e, o, t), r = !0;
    },
    p: function (e, r) {
      var l = n;
      (n = s(e)) === l ? a[n].p(e, r) : (Ro(), Po(a[l], 1, 1, function () {
        a[l] = null;
      }), Eo(), (t = a[n]) ? t.p(e, r) : (t = a[n] = i[n](e)).c(), qo(t, 1), t.m(o.parentNode, o));
    },
    i: function (e) {
      r || (qo(t), r = !0);
    },
    o: function (e) {
      Po(t), r = !1;
    },
    d: function (e) {
      e && Et(o), a[n].d(e);
    }
  };
}
function rj(e) {
  var n, t;
  return n = new Nf({
    props: {
      type: "info",
      message: "You pasted a JSON ".concat(Array.isArray(e[19].contents) ? "array" : "object", " as text"),
      actions: [{
        icon: Me,
        text: "Paste as JSON instead",
        title: "Replace the value with the pasted JSON",
        onMouseDown: e[44]
      }, {
        text: "Leave as is",
        title: "Keep the JSON embedded in the value",
        onClick: e[45]
      }]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      524288 & t[0] && (o.message = "You pasted a JSON ".concat(Array.isArray(e[19].contents) ? "array" : "object", " as text")), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function ij(e) {
  var n, t;
  return n = new Nf({
    props: {
      type: "success",
      message: "The loaded JSON document was invalid but is successfully repaired.",
      actions: e[0] ? [] : [{
        icon: Ce,
        text: "Ok",
        title: "Accept the repaired document",
        onClick: e[8]
      }, {
        icon: en,
        text: "Repair manually instead",
        title: "Leave the document unchanged and repair it manually instead",
        onClick: e[46]
      }],
      onClose: e[9]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t[0] && (o.actions = e[0] ? [] : [{
        icon: Ce,
        text: "Ok",
        title: "Accept the repaired document",
        onClick: e[8]
      }, {
        icon: en,
        text: "Repair manually instead",
        title: "Leave the document unchanged and repair it manually instead",
        onClick: e[46]
      }]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function aj(e) {
  var n, t, o, r;
  return n = new Nf({
    props: {
      type: "error",
      message: "The loaded JSON document is invalid and could not be repaired automatically.",
      actions: e[0] ? [] : [{
        icon: en,
        text: "Repair manually",
        title: 'Open the document in "code" mode and repair it manually',
        onClick: e[46]
      }]
    }
  }), o = new nh({
    props: {
      text: e[18],
      json: e[11],
      indentation: e[5],
      parser: e[3]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment), t = At(), Jo(o.$$.fragment);
    },
    m: function (e, i) {
      Vo(n, e, i), Rt(e, t, i), Vo(o, e, i), r = !0;
    },
    p: function (e, t) {
      var r = {};
      1 & t[0] && (r.actions = e[0] ? [] : [{
        icon: en,
        text: "Repair manually",
        title: 'Open the document in "code" mode and repair it manually',
        onClick: e[46]
      }]), n.$set(r);
      var i = {};
      262144 & t[0] && (i.text = e[18]), 2048 & t[0] && (i.json = e[11]), 32 & t[0] && (i.indentation = e[5]), 8 & t[0] && (i.parser = e[3]), o.$set(i);
    },
    i: function (e) {
      r || (qo(n.$$.fragment, e), qo(o.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), Po(o.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(t), Ho(n, e), Ho(o, e);
    }
  };
}
function sj(e) {
  var n, t;
  return n = new Pm({
    props: {
      readOnly: e[0],
      onCreateObject: e[77],
      onCreateArray: e[78],
      onClick: e[79]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t[0] && (o.readOnly = e[0]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function lj(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c = e[1] && Zh(e),
    u = e[2] && Xh(e),
    d = [nj, ej],
    f = [];
  return r = function (e, n) {
    return e[25] ? 1 : 0;
  }(e), i = f[r] = d[r](e), {
    c: function () {
      n = Pt("div"), c && c.c(), t = At(), u && u.c(), o = At(), i.c(), Ut(n, "role", "tree"), Ut(n, "tabindex", "-1"), Ut(n, "class", "jse-tree-mode svelte-1ig7ktu"), Yt(n, "no-main-menu", !e[1]);
    },
    m: function (i, d) {
      Rt(i, n, d), c && c.m(n, null), Ct(n, t), u && u.m(n, null), Ct(n, o), f[r].m(n, null), e[81](n), a = !0, s || (l = [Bt(Gh, "mousedown", e[48]), Bt(n, "keydown", e[40]), Bt(n, "mousedown", e[41]), Bt(n, "contextmenu", e[42])], s = !0);
    },
    p: function (e, r) {
      e[1] ? c ? (c.p(e, r), 2 & r[0] && qo(c, 1)) : ((c = Zh(e)).c(), qo(c, 1), c.m(n, t)) : c && (Ro(), Po(c, 1, 1, function () {
        c = null;
      }), Eo()), e[2] ? u ? (u.p(e, r), 4 & r[0] && qo(u, 1)) : ((u = Xh(e)).c(), qo(u, 1), u.m(n, o)) : u && (Ro(), Po(u, 1, 1, function () {
        u = null;
      }), Eo()), i.p(e, r), (!a || 2 & r[0]) && Yt(n, "no-main-menu", !e[1]);
    },
    i: function (e) {
      a || (qo(c), qo(u), qo(i), a = !0);
    },
    o: function (e) {
      Po(c), Po(u), Po(i), a = !1;
    },
    d: function (t) {
      t && Et(n), c && c.d(), u && u.d(), f[r].d(), e[81](null), s = !1, at(l);
    }
  };
}
function cj(e, n, t) {
  var o,
    i = Qo("jsoneditor:TreeMode"),
    s = "undefined" == typeof window;
  i("isSSR:", s);
  var l,
    c,
    u,
    d,
    f,
    v = co("simple-modal").open,
    p = fe(),
    m = fe(),
    h = co("absolute-popup"),
    j = h.openAbsolutePopup,
    b = h.closeAbsolutePopup,
    x = !1,
    w = yf(),
    $ = n.readOnly,
    k = n.externalContent,
    C = n.externalSelection,
    S = n.mainMenuBar,
    M = n.navigationBar,
    E = n.escapeControlCharacters,
    q = n.escapeUnicodeCharacters,
    P = n.parser,
    I = n.parseMemoizeOne,
    T = n.validator,
    A = n.validationParser,
    F = n.pathParser,
    U = n.indentation,
    D = n.onError,
    J = n.onChange,
    V = n.onChangeMode,
    H = n.onSelect,
    W = n.onRenderValue,
    Q = n.onRenderMenu,
    Y = n.onRenderContextMenu,
    K = n.onClassName,
    Z = n.onFocus,
    te = n.onBlur,
    oe = n.onSortModal,
    re = n.onTransformModal,
    ie = n.onJSONEditorModal,
    ae = !1;
  zf({
    onMount: io,
    onDestroy: ao,
    getWindow: function () {
      return Zi(u);
    },
    hasFocus: function () {
      return ae && document.hasFocus() || Xi(u);
    },
    onFocus: function () {
      x = !0, Z && Z();
    },
    onBlur: function () {
      x = !1, te && te();
    }
  });
  var se = void 0;
  function le(e) {
    i("updateSelection", e);
    var n = "function" == typeof e ? e(pe.selection) || null : e;
    ne(n, pe.selection) || (t(12, pe = g(g({}, pe), {}, {
      selection: n
    })), H(n));
  }
  var ce,
    ue,
    de,
    ve = !1,
    pe = fs(),
    me = !1,
    ge = !1;
  function he() {
    return (he = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return t(12, pe = g(g({}, ms(d, pe, n)), {}, {
              selection: null
            })), e.next = 3, wn(n);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  var je = $f({
      onChange: function (e) {
        t(22, be = e);
      }
    }),
    be = je.getState();
  var ye,
    xe,
    we = !1,
    $e = [],
    ke = sn(Sf);
  function Ce(e, n, o, r) {
    kf(function () {
      var a;
      try {
        a = ke(e, n, o, r);
      } catch (e) {
        a = [{
          path: [],
          message: "Failed to validate: " + e.message,
          severity: ur.warning
        }];
      }
      ne(a, $e) || (i("validationErrors changed:", a), t(14, $e = a));
    }, function (e) {
      return i("validationErrors updated in ".concat(e, " ms"));
    });
  }
  function Se() {
    return i("validate"), se ? {
      parseError: se,
      isRepairable: !1
    } : (Ce(d, T, P, A), G($e) ? null : {
      validationErrors: $e
    });
  }
  function Me() {
    return d;
  }
  function Oe() {
    return pe;
  }
  function ze(e) {
    wi(e) ? function (e) {
      if (void 0 === e) return;
      var n = !ne(d, e);
      if (i("update external json", {
        isChanged: n,
        currentlyText: void 0 === d
      }), !n) return;
      var o = pe,
        r = d,
        a = f,
        s = we;
      t(11, d = e), Re(d), t(18, f = void 0), t(23, we = !1), se = void 0, Pe(d), Ie({
        previousJson: r,
        previousState: o,
        previousText: a,
        previousTextIsRepaired: s
      });
    }(e.json) : xi(e) && function (e) {
      if (void 0 === e || wi(k)) return;
      var n = e !== f;
      if (i("update external text", {
        isChanged: n
      }), !n) return;
      var o = d,
        r = pe,
        a = f,
        s = we;
      try {
        t(11, d = I(e)), Re(d), t(18, f = e), t(23, we = !1), se = void 0;
      } catch (n) {
        try {
          t(11, d = I(_(e))), Re(d), t(18, f = e), t(23, we = !0), se = void 0, Pe(d);
        } catch (e) {
          t(11, d = void 0), t(18, f = k.text), t(23, we = !1), se = void 0 !== f && "" !== f ? ji(f, n.message || String(n)) : void 0;
        }
      }
      Pe(d), Ie({
        previousJson: o,
        previousState: r,
        previousText: a,
        previousTextIsRepaired: s
      });
    }(e.text);
  }
  function Re(e) {
    ve || (ve = !0, t(12, pe = gs(e, pe, [], function (e) {
      return Si({
        json: e
      }, Mr) ? As : Ns;
    }(e))));
  }
  function Pe(e) {
    pe.selection && (L(e, yl(pe.selection)) && L(e, bl(pe.selection)) || (i("clearing selection: path does not exist anymore", pe.selection), t(12, pe = g(g({}, pe), {}, {
      selection: Zs(e, pe)
    }))));
  }
  function Ie(e) {
    var n = e.previousJson,
      t = e.previousState,
      o = e.previousText,
      r = e.previousTextIsRepaired;
    void 0 === n && void 0 === o || (void 0 !== d ? void 0 !== n ? je.add({
      undo: {
        patch: [{
          op: "replace",
          path: "",
          value: n
        }],
        state: rl(t),
        json: void 0,
        text: o,
        textIsRepaired: r
      },
      redo: {
        patch: [{
          op: "replace",
          path: "",
          value: d
        }],
        state: rl(pe),
        json: void 0,
        text: f,
        textIsRepaired: we
      }
    }) : je.add({
      undo: {
        patch: void 0,
        json: void 0,
        text: o,
        state: rl(t),
        textIsRepaired: r
      },
      redo: {
        patch: void 0,
        json: d,
        state: rl(pe),
        text: f,
        textIsRepaired: we
      }
    }) : void 0 !== n && je.add({
      undo: {
        patch: void 0,
        json: n,
        state: rl(t),
        text: o,
        textIsRepaired: r
      },
      redo: {
        patch: void 0,
        json: void 0,
        text: f,
        textIsRepaired: we,
        state: rl(pe)
      }
    }));
  }
  function Te(e, n) {
    if (i("patch", e, n), void 0 === d) throw new Error("Cannot apply patch: no JSON");
    var o = d,
      r = pe,
      a = f,
      s = we,
      l = Fl(d, e),
      c = bs(d, pe, e),
      u = Xs(d, e),
      v = function (e, n) {
        return n || !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? g(g({}, e), {}, {
          selection: n
        }) : e;
      }(c.documentState, u, !1);
    i("patch updatedSelection", u);
    var p = "function" == typeof n ? n(c.json, v) : void 0;
    t(11, d = p && void 0 !== p.json ? p.json : c.json);
    var m = p && void 0 !== p.state ? p.state : v;
    return t(12, pe = m), t(18, f = void 0), t(23, we = !1), t(19, ue = void 0), se = void 0, Pe(d), je.add({
      undo: {
        patch: l,
        json: void 0,
        text: a,
        state: rl(r),
        textIsRepaired: s
      },
      redo: {
        patch: e,
        json: void 0,
        state: rl(m),
        text: f,
        textIsRepaired: we
      }
    }), {
      json: d,
      previousJson: o,
      undo: l,
      redo: e
    };
  }
  function Ne() {
    !$ && pe.selection && le(il(bl(pe.selection), !0));
  }
  function Be() {
    if (!$ && pe.selection) {
      var e = bl(pe.selection),
        n = z(d, e);
      Yr(n) ? function (e, n) {
        i("openJSONEditorModal", {
          path: e,
          value: n
        }), ae = !0, ie({
          content: {
            json: n
          },
          path: e,
          onPatch: xe.onPatch,
          onClose: function () {
            ae = !1, Nn();
          }
        });
      }(e, n) : le(al(e, !0));
    }
  }
  function Fe() {
    if (!$ && Us(pe.selection)) {
      var e = bl(pe.selection),
        n = O(e),
        t = z(d, e),
        o = !Rs(t, pe.enforceStringMap, n, P),
        r = o ? String(t) : ti(String(t), P);
      i("handleToggleEnforceString", {
        enforceString: o,
        value: t,
        updatedValue: r
      }), Mn([{
        op: "replace",
        path: n,
        value: r
      }], function (e, t) {
        return {
          state: js(t, n, o)
        };
      });
    }
  }
  function Le() {
    return Ue.apply(this, arguments);
  }
  function Ue() {
    return Ue = a(r().mark(function e() {
      var n,
        t = arguments;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return n = !(t.length > 0 && void 0 !== t[0]) || t[0], e.next = 3, Tg({
              json: d,
              documentState: pe,
              indentation: n ? U : void 0,
              readOnly: $,
              parser: P,
              onPatch: Mn
            });
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    })), Ue.apply(this, arguments);
  }
  function en() {
    return nn.apply(this, arguments);
  }
  function nn() {
    return nn = a(r().mark(function e() {
      var n,
        t = arguments;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (n = !(t.length > 0 && void 0 !== t[0]) || t[0], void 0 !== d) {
              e.next = 3;
              break;
            }
            return e.abrupt("return");
          case 3:
            return e.next = 5, Ng({
              json: d,
              documentState: pe,
              indentation: n ? U : void 0,
              parser: P
            });
          case 5:
          case "end":
            return e.stop();
        }
      }, e);
    })), nn.apply(this, arguments);
  }
  function tn() {
    v(nv, {}, g(g({}, Or), {}, {
      styleWindow: {
        width: "450px"
      }
    }), {
      onClose: function () {
        return Nn();
      }
    });
  }
  function on(e, n) {
    v(Dv, {
      text: e,
      onParse: function (e) {
        return mi(e, function (e) {
          return vi(e, P);
        });
      },
      onRepair: gi,
      onApply: n
    }, g(g({}, Or), {}, {
      styleWindow: {
        width: "600px",
        height: "500px"
      },
      styleContent: {
        padding: 0,
        height: "100%"
      }
    }), {
      onClose: function () {
        return Nn();
      }
    });
  }
  function rn() {
    Lg({
      json: d,
      text: f,
      documentState: pe,
      keepSelection: !1,
      readOnly: $,
      onChange: J,
      onPatch: Mn
    });
  }
  function an() {
    !$ && void 0 !== d && pe.selection && fl && !G(bl(pe.selection)) && (i("duplicate", {
      selection: pe.selection
    }), Mn(Pl(d, _s(d, pe.selection))));
  }
  function ln() {
    if (!$ && pe.selection && (Ds(pe.selection) || Us(pe.selection)) && !G(bl(pe.selection))) {
      i("extract", {
        selection: pe.selection
      });
      var e = function (e, n) {
        if (Us(n)) return [{
          op: "move",
          from: O(n.path),
          path: ""
        }];
        if (!Ds(n)) throw new Error("Cannot create extract operations: parent must be an Object or Array");
        var t = X(n.focusPath),
          o = z(e, t);
        if (N(o)) return [{
          op: "replace",
          path: "",
          value: _s(e, n).map(function (e) {
            var n = Hr(ee(e));
            return o[n];
          })
        }];
        if (B(o)) {
          var r = {};
          return _s(e, n).forEach(function (e) {
            var n = String(ee(e));
            r[n] = o[n];
          }), [{
            op: "replace",
            path: "",
            value: r
          }];
        }
        throw new Error("Cannot extract: unsupported type of selection " + JSON.stringify(n));
      }(d, pe.selection);
      Mn(e, function (e, n) {
        if (Yr(e)) {
          return {
            state: Ts(e, n, [])
          };
        }
      });
    }
  }
  function cn(e) {
    Hg({
      insertType: e,
      selectInside: !0,
      refJsonEditor: u,
      json: d,
      selection: pe.selection,
      readOnly: $,
      parser: P,
      onPatch: Mn,
      onReplaceJson: On
    });
  }
  function un(e) {
    Ls(pe.selection) && le(al(pe.selection.path, !1)), pe.selection || le(Zs(d, pe)), cn(e);
  }
  function dn(e) {
    if (!$ && pe.selection) if (vl(pe.selection)) try {
      var n = yl(pe.selection),
        t = z(d, n),
        o = function (e, n, t) {
          if ("array" === n) {
            if (Array.isArray(e)) return e;
            if (Qr(e)) return di(e);
            if ("string" == typeof e) try {
              var o = t.parse(e);
              if (Array.isArray(o)) return o;
              if (Qr(o)) return di(o);
            } catch (n) {
              return [e];
            }
            return [e];
          }
          if ("object" === n) {
            if (Array.isArray(e)) return ui(e);
            if (Qr(e)) return e;
            if ("string" == typeof e) try {
              var r = t.parse(e);
              if (Qr(r)) return r;
              if (Array.isArray(r)) return ui(r);
            } catch (n) {
              return {
                value: e
              };
            }
            return {
              value: e
            };
          }
          if ("value" === n) return Yr(e) ? t.stringify(e) : e;
          throw new Error("Cannot convert ".concat(Xr(e, t), " to ").concat(n));
        }(t, e, P);
      if (o === t) return;
      var r = [{
        op: "replace",
        path: O(n),
        value: o
      }];
      i("handleConvert", {
        selection: pe.selection,
        path: n,
        type: e,
        operations: r
      }), Mn(r, function (e, n) {
        return {
          state: pe.selection ? Ts(e, n, bl(pe.selection)) : pe
        };
      });
    } catch (e) {
      D(e);
    } else D(new Error("Cannot convert current selection to ".concat(e)));
  }
  function fn() {
    if (pe.selection) {
      var e = Gs(d, pe, !1),
        n = X(bl(pe.selection));
      e && !G(bl(e)) && ne(n, X(bl(e))) ? le(ll(bl(e))) : le(sl(n)), i("insert before", {
        selection: pe.selection,
        selectionBefore: e,
        parentPath: n
      }), bo().then(function () {
        return Tn();
      });
    }
  }
  function vn() {
    if (pe.selection) {
      var e = Ys(d, pe.selection);
      i("insert after", e), le(ll(e)), bo().then(function () {
        return Tn();
      });
    }
  }
  function pn(e) {
    return mn.apply(this, arguments);
  }
  function mn() {
    return (mn = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, _g({
              char: n,
              selectInside: !0,
              refJsonEditor: u,
              json: d,
              selection: pe.selection,
              readOnly: $,
              parser: P,
              onPatch: Mn,
              onReplaceJson: On,
              onSelect: le
            });
          case 2:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function gn() {
    if (!$ && je.getState().canUndo) {
      var e = je.undo();
      if (e) {
        var n = {
          json: d,
          text: f
        };
        t(11, d = e.undo.patch ? R(d, e.undo.patch) : e.undo.json), t(12, pe = e.undo.state), t(18, f = e.undo.text), t(23, we = e.undo.textIsRepaired), se = void 0, i("undo", {
          item: e,
          json: d,
          documentState: pe
        }), Sn(n, e.undo.patch && e.redo.patch ? {
          json: d,
          previousJson: n.json,
          redo: e.undo.patch,
          undo: e.redo.patch
        } : null), Nn(), pe.selection && wn(bl(pe.selection), !1);
      }
    }
  }
  function hn() {
    if (!$ && je.getState().canRedo) {
      var e = je.redo();
      if (e) {
        var n = {
          json: d,
          text: f
        };
        t(11, d = e.redo.patch ? R(d, e.redo.patch) : e.redo.json), t(12, pe = e.redo.state), t(18, f = e.redo.text), t(23, we = e.redo.textIsRepaired), se = void 0, i("redo", {
          item: e,
          json: d,
          documentState: pe
        }), Sn(n, e.undo.patch && e.redo.patch ? {
          json: d,
          previousJson: n.json,
          redo: e.redo.patch,
          undo: e.undo.patch
        } : null), Nn(), pe.selection && wn(bl(pe.selection), !1);
      }
    }
  }
  function jn(e) {
    var n;
    $ || void 0 === d || (ae = !0, oe({
      id: p,
      json: d,
      rootPath: e,
      onSort: (n = a(r().mark(function n(t) {
        var o;
        return r().wrap(function (n) {
          for (;;) switch (n.prev = n.next) {
            case 0:
              o = t.operations, i("onSort", e, o), Mn(o, function (n, t) {
                return {
                  state: g(g({}, Ts(n, t, e)), {}, {
                    selection: al(e, !1)
                  })
                };
              });
            case 3:
            case "end":
              return n.stop();
          }
        }, n);
      })), function (e) {
        return n.apply(this, arguments);
      }),
      onClose: function () {
        ae = !1, Nn();
      }
    }));
  }
  function bn() {
    pe.selection && jn(tl(d, pe.selection));
  }
  function yn(e) {
    if (void 0 !== d) {
      var n = e.id,
        t = e.onTransform,
        o = e.onClose,
        r = e.rootPath || [];
      ae = !0, re({
        id: n || m,
        json: d,
        rootPath: r,
        onTransform: function (e) {
          t ? t({
            operations: e,
            json: d,
            transformedJson: R(d, e)
          }) : (i("onTransform", r, e), Mn(e, function (e, n) {
            return {
              state: g(g({}, Ts(e, n, r)), {}, {
                selection: al(r, !1)
              })
            };
          }));
        },
        onClose: function () {
          ae = !1, Nn(), o && o();
        }
      });
    }
  }
  function xn() {
    pe.selection && yn({
      rootPath: tl(d, pe.selection)
    });
  }
  function wn(e) {
    return $n.apply(this, arguments);
  }
  function $n() {
    return $n = a(r().mark(function e(n) {
      var o,
        a,
        s,
        c,
        u,
        f = arguments;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return o = !(f.length > 1 && void 0 !== f[1]) || f[1], t(12, pe = ms(d, pe, n)), e.next = 4, bo();
          case 4:
            if (a = kn(n), i("scrollTo", {
              path: n,
              elem: a,
              refContents: l
            }), a && l) {
              e.next = 8;
              break;
            }
            return e.abrupt("return", Promise.resolve());
          case 8:
            if (s = l.getBoundingClientRect(), c = a.getBoundingClientRect(), o) {
              e.next = 13;
              break;
            }
            if (!(c.bottom > s.top && c.top < s.bottom)) {
              e.next = 13;
              break;
            }
            return e.abrupt("return", Promise.resolve());
          case 13:
            return u = -s.height / 4, e.abrupt("return", new Promise(function (e) {
              w(a, {
                container: l,
                offset: u,
                duration: 300,
                callback: function () {
                  return e();
                }
              });
            }));
          case 15:
          case "end":
            return e.stop();
        }
      }, e);
    })), $n.apply(this, arguments);
  }
  function kn(e) {
    return l ? l.querySelector('div[data-path="'.concat(ta(e), '"]')) : null;
  }
  function Cn(e) {
    var n = kn(e);
    if (n && l) {
      var t = l.getBoundingClientRect(),
        o = n.getBoundingClientRect(),
        r = Yr(z(d, e)) ? 20 : o.height;
      o.top < t.top + 20 ? w(n, {
        container: l,
        offset: -20,
        duration: 0
      }) : o.top + r > t.bottom - 20 && w(n, {
        container: l,
        offset: -(t.height - r - 20),
        duration: 0
      });
    }
  }
  function Sn(e, n) {
    var t;
    if (void 0 !== e.json || void 0 !== (null == e ? void 0 : e.text)) if (void 0 !== f) null === (t = J) || void 0 === t || t({
      text: f,
      json: void 0
    }, e, {
      contentErrors: Se(),
      patchResult: n
    });else if (void 0 !== d) {
      var o;
      null === (o = J) || void 0 === o || o({
        text: void 0,
        json: d
      }, e, {
        contentErrors: Se(),
        patchResult: n
      });
    }
  }
  function Mn(e, n) {
    i("handlePatch", e, n);
    var t = {
        json: d,
        text: f
      },
      o = Te(e, n);
    return Sn(t, o), o;
  }
  function On(e, n) {
    var o = pe,
      r = d,
      i = f,
      a = {
        json: d,
        text: f
      },
      s = we,
      l = gs(d, pe, [], As),
      c = "function" == typeof n ? n(e, l) : void 0;
    t(11, d = c && void 0 !== c.json ? c.json : e), t(12, pe = c && void 0 !== c.state ? c.state : l), t(18, f = void 0), t(23, we = !1), se = void 0, Pe(d), Ie({
      previousJson: r,
      previousState: o,
      previousText: i,
      previousTextIsRepaired: s
    });
    Sn(a, null);
  }
  function zn(e, n) {
    i("handleChangeText");
    var o = pe,
      r = d,
      a = f,
      s = {
        json: d,
        text: f
      },
      l = we;
    try {
      t(11, d = I(e)), t(12, pe = gs(d, pe, [], As)), t(18, f = void 0), t(23, we = !1), se = void 0;
    } catch (n) {
      try {
        t(11, d = I(_(e))), t(12, pe = gs(d, pe, [], As)), t(18, f = e), t(23, we = !0), se = void 0;
      } catch (o) {
        t(11, d = void 0), t(12, pe = fs({
          json: d,
          expand: As
        })), t(18, f = e), t(23, we = !1), se = "" !== f ? ji(f, n.message || String(n)) : void 0;
      }
    }
    if ("function" == typeof n) {
      var c = n(d, pe);
      t(11, d = c && c.json ? c.json : d), t(12, pe = c && c.state ? c.state : pe);
    }
    Pe(d), Ie({
      previousJson: r,
      previousState: o,
      previousText: a,
      previousTextIsRepaired: l
    });
    Sn(s, null);
  }
  function Rn(e, n) {
    var o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
    i("expand", {
      path: e,
      expanded: n,
      recursive: o
    }), t(12, pe = n ? o ? gs(d, pe, e, Ns) : function (e, n) {
      return g(g({}, e), {}, {
        expandedMap: g(g({}, e.expandedMap), {}, y({}, O(n), !0))
      });
    }(pe, e) : hs(pe, e)), pe.selection && !n && function (e, n) {
      return ol(bl(e), n) && (bl(e).length > n.length || Fs(e));
    }(pe.selection, e) && le(null), Nn();
  }
  function En(e) {
    i("openFind", {
      findAndReplace: e
    }), t(13, me = !1), t(21, ge = !1), bo().then(function () {
      t(13, me = !0), t(21, ge = e);
    });
  }
  function qn(e, n) {
    i("handleExpandSection", e, n);
    var o = O(e);
    t(12, pe = function (e, n, t, o) {
      return g(g({}, n), {}, {
        visibleSectionsMap: g(g({}, n.visibleSectionsMap), {}, y({}, t, ls(vs(n, t).concat(o))))
      });
    }(0, pe, o, n));
  }
  function Pn(e) {
    i("pasted json as text", e), t(19, ue = e);
  }
  function In(e) {
    var n = e.anchor,
      t = e.left,
      o = e.top,
      r = e.width,
      i = e.height,
      a = e.offsetTop,
      s = e.offsetLeft,
      l = e.showTip,
      c = function (e) {
        var n = e.json,
          t = e.documentState,
          o = e.readOnly,
          r = e.parser,
          i = e.onEditKey,
          a = e.onEditValue,
          s = e.onToggleEnforceString,
          l = e.onCut,
          c = e.onCopy,
          u = e.onPaste,
          d = e.onRemove,
          f = e.onDuplicate,
          v = e.onExtract,
          p = e.onInsertBefore,
          m = e.onInsert,
          g = e.onConvert,
          h = e.onInsertAfter,
          j = e.onSort,
          b = e.onTransform,
          y = t.selection,
          x = void 0 !== n,
          w = !!y,
          $ = !!y && G(bl(y)),
          k = y ? z(n, bl(y)) : void 0,
          C = Array.isArray(k) ? "Edit array" : Qr(k) ? "Edit object" : "Edit value",
          S = x && (Ds(y) || Ls(y) || Us(y)),
          M = !o && x && null != y && nl(y) && !$ && !Array.isArray(z(n, X(bl(y)))),
          R = !o && x && null != y && nl(y),
          E = R && !Yr(k),
          q = !o && S,
          P = S,
          I = !o && w,
          T = !o && x && S && !$,
          A = !o && x && null != y && (Ds(y) || Us(y)) && !$,
          N = S,
          B = N ? "Convert to:" : "Insert:",
          F = !o && !N && w,
          L = !o && (N ? vl(y) && !Qr(k) : w),
          U = !o && (N ? vl(y) && !Array.isArray(k) : w),
          D = !o && (N ? vl(y) && Yr(k) : w),
          J = !(null == y || !k) && Rs(k, t.enforceStringMap, O(bl(y)), r);
        function V(e) {
          S ? "structure" !== e && g(e) : m(e);
        }
        return [{
          type: "row",
          items: [{
            type: "button",
            onClick: function () {
              return i();
            },
            icon: De,
            text: "Edit key",
            title: "Edit the key (Double-click on the key)",
            disabled: !M
          }, {
            type: "dropdown-button",
            main: {
              type: "button",
              onClick: function () {
                return a();
              },
              icon: De,
              text: C,
              title: "Edit the value (Double-click on the value)",
              disabled: !R
            },
            width: "11em",
            items: [{
              type: "button",
              icon: De,
              text: C,
              title: "Edit the value (Double-click on the value)",
              onClick: function () {
                return a();
              },
              disabled: !R
            }, {
              type: "button",
              icon: J ? Je : Ve,
              text: "Enforce string",
              title: "Enforce keeping the value as string when it contains a numeric value",
              onClick: function () {
                return s();
              },
              disabled: !E
            }]
          }]
        }, {
          type: "separator"
        }, {
          type: "row",
          items: [{
            type: "dropdown-button",
            main: {
              type: "button",
              onClick: function () {
                return l(!0);
              },
              icon: He,
              text: "Cut",
              title: "Cut selected contents, formatted with indentation (Ctrl+X)",
              disabled: !q
            },
            width: "10em",
            items: [{
              type: "button",
              icon: He,
              text: "Cut formatted",
              title: "Cut selected contents, formatted with indentation (Ctrl+X)",
              onClick: function () {
                return l(!0);
              },
              disabled: !q
            }, {
              type: "button",
              icon: He,
              text: "Cut compacted",
              title: "Cut selected contents, without indentation (Ctrl+Shift+X)",
              onClick: function () {
                return l(!1);
              },
              disabled: !q
            }]
          }, {
            type: "dropdown-button",
            main: {
              type: "button",
              onClick: function () {
                return c(!0);
              },
              icon: Ae,
              text: "Copy",
              title: "Copy selected contents, formatted with indentation (Ctrl+C)",
              disabled: !P
            },
            width: "12em",
            items: [{
              type: "button",
              icon: Ae,
              text: "Copy formatted",
              title: "Copy selected contents, formatted with indentation (Ctrl+C)",
              onClick: function () {
                return c(!0);
              },
              disabled: !P
            }, {
              type: "button",
              icon: Ae,
              text: "Copy compacted",
              title: "Copy selected contents, without indentation (Ctrl+Shift+C)",
              onClick: function () {
                return c(!1);
              },
              disabled: !P
            }]
          }, {
            type: "button",
            onClick: function () {
              return u();
            },
            icon: _e,
            text: "Paste",
            title: "Paste clipboard contents (Ctrl+V)",
            disabled: !I
          }]
        }, {
          type: "separator"
        }, {
          type: "row",
          items: [{
            type: "column",
            items: [{
              type: "button",
              onClick: function () {
                return f();
              },
              icon: We,
              text: "Duplicate",
              title: "Duplicate selected contents (Ctrl+D)",
              disabled: !T
            }, {
              type: "button",
              onClick: function () {
                return v();
              },
              icon: Qe,
              text: "Extract",
              title: "Extract selected contents",
              disabled: !A
            }, {
              type: "button",
              onClick: function () {
                return j();
              },
              icon: Ee,
              text: "Sort",
              title: "Sort array or object contents",
              disabled: o || !S
            }, {
              type: "button",
              onClick: function () {
                return b();
              },
              icon: qe,
              text: "Transform",
              title: "Transform array or object contents (filter, sort, project)",
              disabled: o || !S
            }, {
              type: "button",
              onClick: function () {
                return d();
              },
              icon: Ye,
              text: "Remove",
              title: "Remove selected contents (Delete)",
              disabled: o || !S
            }]
          }, {
            type: "column",
            items: [{
              type: "label",
              text: B
            }, {
              type: "button",
              onClick: function () {
                return V("structure");
              },
              icon: N ? Ge : Ke,
              text: "Structure",
              title: B + " structure",
              disabled: !F
            }, {
              type: "button",
              onClick: function () {
                return V("object");
              },
              icon: N ? Ge : Ke,
              text: "Object",
              title: B + " structure",
              disabled: !L
            }, {
              type: "button",
              onClick: function () {
                return V("array");
              },
              icon: N ? Ge : Ke,
              text: "Array",
              title: B + " array",
              disabled: !U
            }, {
              type: "button",
              onClick: function () {
                return V("value");
              },
              icon: N ? Ge : Ke,
              text: "Value",
              title: B + " value",
              disabled: !D
            }]
          }]
        }, {
          type: "separator"
        }, {
          type: "row",
          items: [{
            type: "button",
            onClick: function () {
              return p();
            },
            icon: Ze,
            text: "Insert before",
            title: "Select area before current entry to insert or paste contents",
            disabled: o || !S || $
          }, {
            type: "button",
            onClick: function () {
              return h();
            },
            icon: Xe,
            text: "Insert after",
            title: "Select area after current entry to insert or paste contents",
            disabled: o || !S || $
          }]
        }];
      }({
        json: d,
        documentState: pe,
        readOnly: $,
        parser: P,
        onEditKey: Ne,
        onEditValue: Be,
        onToggleEnforceString: Fe,
        onCut: Le,
        onCopy: en,
        onPaste: tn,
        onRemove: rn,
        onDuplicate: an,
        onExtract: ln,
        onInsertBefore: fn,
        onInsert: un,
        onInsertAfter: vn,
        onConvert: dn,
        onSort: bn,
        onTransform: xn
      }),
      u = Y(c);
    if (!1 !== u) {
      var f = {
        left: t,
        top: o,
        offsetTop: a,
        offsetLeft: s,
        width: r,
        height: i,
        anchor: n,
        closeOnOuterClick: !0,
        onClose: function () {
          ae = !1, Nn();
        }
      };
      ae = !0;
      var v = j(Yh, {
        tip: l ? "Tip: you can open this context menu via right-click or with Ctrl+Q" : void 0,
        items: u,
        onRequestClose: function () {
          return b(v);
        }
      }, f);
    }
  }
  function Tn(e) {
    if (!dl(pe.selection)) {
      if (e && (e.stopPropagation(), e.preventDefault()), e && "contextmenu" === e.type && e.target !== c) In({
        left: e.clientX,
        top: e.clientY,
        width: Lr,
        height: Fr,
        showTip: !1
      });else {
        var n,
          t = null === (n = l) || void 0 === n ? void 0 : n.querySelector(".jse-context-menu-pointer.jse-selected");
        if (t) In({
          anchor: t,
          offsetTop: 2,
          width: Lr,
          height: Fr,
          showTip: !1
        });else {
          var o,
            r = null === (o = l) || void 0 === o ? void 0 : o.getBoundingClientRect();
          r && In({
            top: r.top + 2,
            left: r.left + 2,
            width: Lr,
            height: Fr,
            showTip: !1
          });
        }
      }
      return !1;
    }
  }
  function An() {
    return (An = a(r().mark(function e() {
      var n, o, a, s, c;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (i("apply pasted json", ue), ue) {
              e.next = 3;
              break;
            }
            return e.abrupt("return");
          case 3:
            a = (o = ue).path, s = o.contents, t(19, ue = void 0), ia(c = (null === (n = l) || void 0 === n ? void 0 : n.querySelector(".jse-editable-div")) || null) && c.cancel(), Mn([{
              op: "replace",
              path: O(a),
              value: s
            }], function (e, n) {
              return {
                state: Ts(e, n, a)
              };
            }), setTimeout(Nn);
          case 10:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function Nn() {
    i("focus"), c && (c.focus(), c.select());
  }
  function Bn(e) {
    return function (e, n, t) {
      var o = X(t),
        r = [ee(t)],
        i = z(e, o),
        a = i ? Is(i, n, r) : void 0;
      return a ? al(o.concat(a), !1) : ll(t);
    }(d, pe, e);
  }
  function Fn(e) {
    o && o.onDrag(e);
  }
  function Ln() {
    o && o.onDragEnd();
  }
  return e.$$set = function (e) {
    "readOnly" in e && t(0, $ = e.readOnly), "externalContent" in e && t(49, k = e.externalContent), "externalSelection" in e && t(50, C = e.externalSelection), "mainMenuBar" in e && t(1, S = e.mainMenuBar), "navigationBar" in e && t(2, M = e.navigationBar), "escapeControlCharacters" in e && t(51, E = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && t(52, q = e.escapeUnicodeCharacters), "parser" in e && t(3, P = e.parser), "parseMemoizeOne" in e && t(53, I = e.parseMemoizeOne), "validator" in e && t(54, T = e.validator), "validationParser" in e && t(55, A = e.validationParser), "pathParser" in e && t(4, F = e.pathParser), "indentation" in e && t(5, U = e.indentation), "onError" in e && t(6, D = e.onError), "onChange" in e && t(56, J = e.onChange), "onChangeMode" in e && t(57, V = e.onChangeMode), "onSelect" in e && t(58, H = e.onSelect), "onRenderValue" in e && t(59, W = e.onRenderValue), "onRenderMenu" in e && t(7, Q = e.onRenderMenu), "onRenderContextMenu" in e && t(60, Y = e.onRenderContextMenu), "onClassName" in e && t(61, K = e.onClassName), "onFocus" in e && t(62, Z = e.onFocus), "onBlur" in e && t(63, te = e.onBlur), "onSortModal" in e && t(64, oe = e.onSortModal), "onTransformModal" in e && t(65, re = e.onTransformModal), "onJSONEditorModal" in e && t(66, ie = e.onJSONEditorModal);
  }, e.$$.update = function () {
    3145728 & e.$$.dirty[1] && t(74, ce = Ii({
      escapeControlCharacters: E,
      escapeUnicodeCharacters: q
    })), 4096 & e.$$.dirty[0] && i("selection", pe.selection), 8192 & e.$$.dirty[0] && function (e) {
      if (l) if (e) {
        var n,
          o = null !== (n = parseInt(getComputedStyle(l).padding)) && void 0 !== n ? n : 0;
        t(10, l.style.overflowAnchor = "none", l), t(10, l.style.paddingTop = o + Ur + "px", l), t(10, l.scrollTop += Ur, l), t(10, l.style.overflowAnchor = "", l);
      } else t(10, l.style.overflowAnchor = "none", l), t(10, l.style.paddingTop = "", l), t(10, l.scrollTop -= Ur, l), t(10, l.style.overflowAnchor = "", l);
    }(me), 262144 & e.$$.dirty[1] && ze(k), 524288 & e.$$.dirty[1] && function (e) {
      ne(pe.selection, e) || (i("applyExternalSelection", e), (Vs(e) || null === e) && le(e));
    }(C), 2056 & e.$$.dirty[0] | 25165824 & e.$$.dirty[1] && Ce(d, T, P, A), 16384 & e.$$.dirty[0] && t(24, ye = function (e) {
      var n = {};
      return e.forEach(function (e) {
        n[O(e.path)] = e;
      }), e.forEach(function (e) {
        for (var t = e.path; t.length > 0;) {
          t = X(t);
          var o = O(t);
          o in n || (n[o] = {
            isChildError: !0,
            path: t,
            message: "Contains invalid data",
            severity: ur.warning
          });
        }
      }), n;
    }($e)), 1024 & e.$$.dirty[0] && (o = l ? function (e) {
      var n, t;
      function o(e) {
        return e < 20 ? gr : e < 50 ? hr : jr;
      }
      function r() {
        if (e) {
          var t = (n || 0) * (mr / 1e3);
          e.scrollTop += t;
        }
      }
      function i(e) {
        t && e === n || (a(), jf("startAutoScroll", e), n = e, t = setInterval(r, mr));
      }
      function a() {
        t && (jf("stopAutoScroll"), clearInterval(t), t = void 0, n = void 0);
      }
      return jf("createAutoScrollHandler", e), {
        onDrag: function (n) {
          if (e) {
            var t = n.clientY,
              r = e.getBoundingClientRect(),
              s = r.top,
              l = r.bottom;
            t < s ? i(-o(s - t)) : t > l ? i(o(t - l)) : a();
          }
        },
        onDragEnd: function () {
          a();
        }
      };
    }(l) : void 0), 9 & e.$$.dirty[0] | 1342177280 & e.$$.dirty[1] | 4096 & e.$$.dirty[2] && t(15, xe = {
      readOnly: $,
      parser: P,
      normalization: ce,
      getJson: Me,
      getDocumentState: Oe,
      findElement: kn,
      findNextInside: Bn,
      focus: Nn,
      onPatch: Mn,
      onInsert: cn,
      onExpand: Rn,
      onSelect: le,
      onFind: En,
      onExpandSection: qn,
      onPasteJson: Pn,
      onRenderValue: W,
      onContextMenu: In,
      onClassName: K || function () {},
      onDrag: Fn,
      onDragEnd: Ln
    }), 32768 & e.$$.dirty[0] && i("context changed", xe);
  }, [$, S, M, P, F, U, D, Q, function () {
    return we && void 0 !== d && On(d), void 0 !== d ? {
      json: d
    } : {
      text: f || ""
    };
  }, Nn, l, d, pe, me, $e, xe, c, u, f, ue, de, ge, be, we, ye, s, function (e) {
    t(20, de = e);
  }, function (e) {
    return he.apply(this, arguments);
  }, function () {
    t(13, me = !1), t(21, ge = !1), Nn();
  }, function (e) {
    i("select validation error", e), le(al(e.path, !1)), wn(e.path);
  }, en, function (e) {
    var n;
    e.preventDefault();
    var t = null === (n = e.clipboardData) || void 0 === n ? void 0 : n.getData("text/plain");
    void 0 !== t && Fg({
      clipboardText: t,
      json: d,
      selection: pe.selection,
      readOnly: $,
      parser: P,
      onPatch: Mn,
      onChangeText: zn,
      openRepairModal: on
    });
  }, pn, gn, hn, function () {
    jn([]);
  }, function () {
    yn({
      rootPath: []
    });
  }, Mn, function () {
    Rn([], !0, !0);
  }, function () {
    Rn([], !1, !0);
  }, function (e) {
    var n = sa(e),
      t = e.shiftKey;
    if (i("keydown", {
      combo: n,
      key: e.key
    }), "Ctrl+X" === n && (e.preventDefault(), Le(!0)), "Ctrl+Shift+X" === n && (e.preventDefault(), Le(!1)), "Ctrl+C" === n && (e.preventDefault(), en(!0)), "Ctrl+Shift+C" === n && (e.preventDefault(), en(!1)), "Ctrl+D" === n && (e.preventDefault(), an()), "Delete" !== n && "Backspace" !== n || (e.preventDefault(), rn()), "Insert" === n && (e.preventDefault(), cn("structure")), "Ctrl+A" === n && (e.preventDefault(), le(al([], !1))), "Ctrl+Q" === n && Tn(e), "ArrowUp" === n || "Shift+ArrowUp" === n) {
      e.preventDefault();
      var o = pe.selection ? Gs(d, pe, t) || pe.selection : Zs(d, pe);
      le(o), Cn(bl(o));
    }
    if ("ArrowDown" === n || "Shift+ArrowDown" === n) {
      e.preventDefault();
      var r = pe.selection ? function (e, n) {
        var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          o = n.selection;
        if (!o) return null;
        var r = t ? bl(o) : Ys(e, o),
          i = Yr(z(e, r)) ? hs(n, r) : n,
          a = Is(e, n, r),
          s = Is(e, i, r);
        if (t) return Fs(o) ? null !== a ? cl(a, a) : null : Bs(o) ? null !== s ? cl(s, s) : null : null !== s ? cl(yl(o), s) : null;
        if (Bs(o)) return null !== s ? al(s, !1) : null;
        if (Fs(o)) return null !== a ? al(a, !1) : null;
        if (Us(o)) return null !== a ? al(a, !1) : null;
        if (Ls(o)) {
          if (null === a || 0 === a.length) return null;
          var l = X(a),
            c = z(e, l);
          return Array.isArray(c) ? al(a, !1) : il(a, !1);
        }
        return Ds(o) ? null !== s ? al(s, !1) : null !== a ? al(a, !1) : null : null;
      }(d, pe, t) || pe.selection : Zs(d, pe);
      le(r), Cn(bl(r));
    }
    if ("ArrowLeft" === n || "Shift+ArrowLeft" === n) {
      e.preventDefault();
      var a = pe.selection ? function (e, n) {
        var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          o = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
          r = n.selection;
        if (!r) return null;
        var i = Ks(e, n, o),
          a = i.caret,
          s = i.previous;
        if (t) return Ds(r) ? null : cl(r.path, r.path);
        if (a && s) return pl(s);
        var l = X(bl(r)),
          c = z(e, l);
        return Us(r) && Array.isArray(c) ? cl(r.path, r.path) : Ds(r) && !Array.isArray(c) ? il(r.focusPath, !1) : null;
      }(d, pe, t, !$) || pe.selection : Zs(d, pe);
      le(a), Cn(bl(a));
    }
    if ("ArrowRight" === n || "Shift+ArrowRight" === n) {
      e.preventDefault();
      var s = pe.selection && void 0 !== d ? function (e, n) {
        var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          o = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
          r = n.selection;
        if (!r) return null;
        var i = Ks(e, n, o),
          a = i.caret,
          s = i.next;
        return t ? Ds(r) ? null : cl(r.path, r.path) : a && s ? pl(s) : Ds(r) ? al(r.focusPath, !1) : null;
      }(d, pe, t, !$) || pe.selection : Zs(d, pe);
      le(s), Cn(bl(s));
    }
    if ("Enter" === n && pe.selection) {
      if (Js(pe.selection)) {
        var l = pe.selection.focusPath,
          c = z(d, X(l));
        Array.isArray(c) && le(al(l, !1));
      }
      if (Ls(pe.selection) && (e.preventDefault(), le(g(g({}, pe.selection), {}, {
        edit: !0
      }))), Us(pe.selection)) e.preventDefault(), Yr(z(d, pe.selection.path)) ? Rn(pe.selection.path, !0) : le(g(g({}, pe.selection), {}, {
        edit: !0
      }));
    }
    if (1 === n.replace(/^Shift\+/, "").length && pe.selection) return e.preventDefault(), void pn(e.key);
    if ("Enter" === n && (Bs(pe.selection) || Fs(pe.selection))) return e.preventDefault(), void pn("");
    if ("Ctrl+Enter" === n && Us(pe.selection)) {
      var u = z(d, pe.selection.path);
      ni(u) && window.open(String(u), "_blank");
    }
    "Escape" === n && pe.selection && (e.preventDefault(), le(null)), "Ctrl+F" === n && (e.preventDefault(), En(!1)), "Ctrl+H" === n && (e.preventDefault(), En(!0)), "Ctrl+Z" === n && (e.preventDefault(), gn()), "Ctrl+Shift+Z" === n && (e.preventDefault(), hn());
  }, function (e) {
    i("handleMouseDown", e);
    var n = e.target;
    _i(n, "BUTTON") || n.isContentEditable || (Nn(), pe.selection || void 0 !== d || "" !== f && void 0 !== f || (i("createDefaultSelection"), t(12, pe = g(g({}, pe), {}, {
      selection: al([], !1)
    }))));
  }, Tn, function (e) {
    In({
      anchor: ea(e.target, "BUTTON"),
      offsetTop: 0,
      width: Lr,
      height: Fr,
      showTip: !0
    });
  }, function () {
    return An.apply(this, arguments);
  }, function () {
    i("clear pasted json"), t(19, ue = void 0), Nn();
  }, function () {
    V(sr.text);
  }, function (e) {
    le(e), Nn(), wn(bl(e));
  }, function (e) {
    var n = !Qi(e.target, function (e) {
      return e === u;
    });
    n && dl(pe.selection) && (i("click outside the editor, stop edit mode"), le(function (e) {
      return Ls(e) || Us(e) ? g(g({}, e), {}, {
        edit: !1
      }) : e;
    }), x && c && (c.focus(), c.blur()), i("blur (outside editor)"), c && c.blur());
  }, k, C, E, q, I, T, A, J, V, H, W, Y, K, Z, te, oe, re, ie, function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ns;
    i("expand");
    var n = g(g({}, pe), {}, {
      expandedMap: {},
      visibleSectionsMap: {}
    });
    t(12, pe = gs(d, n, [], e));
  }, Se, Me, Te, yn, wn, kn, ce, function (e) {
    t(13, me = e);
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(16, c = e);
    });
  }, function () {
    Nn(), pn("{");
  }, function () {
    Nn(), pn("[");
  }, function () {
    Nn();
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(10, l = e);
    });
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(17, u = e);
    });
  }];
}
var uj = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, cj, lj, ct, {
      readOnly: 0,
      externalContent: 49,
      externalSelection: 50,
      mainMenuBar: 1,
      navigationBar: 2,
      escapeControlCharacters: 51,
      escapeUnicodeCharacters: 52,
      parser: 3,
      parseMemoizeOne: 53,
      validator: 54,
      validationParser: 55,
      pathParser: 4,
      indentation: 5,
      onError: 6,
      onChange: 56,
      onChangeMode: 57,
      onSelect: 58,
      onRenderValue: 59,
      onRenderMenu: 7,
      onRenderContextMenu: 60,
      onClassName: 61,
      onFocus: 62,
      onBlur: 63,
      onSortModal: 64,
      onTransformModal: 65,
      onJSONEditorModal: 66,
      expand: 67,
      validate: 68,
      getJson: 69,
      patch: 70,
      acceptAutoRepair: 8,
      openTransformModal: 71,
      scrollTo: 72,
      findElement: 73,
      focus: 9
    }, Kh, [-1, -1, -1, -1, -1]), t;
  }
  return v(n, Wo), b(n, [{
    key: "expand",
    get: function () {
      return this.$$.ctx[67];
    }
  }, {
    key: "validate",
    get: function () {
      return this.$$.ctx[68];
    }
  }, {
    key: "getJson",
    get: function () {
      return this.$$.ctx[69];
    }
  }, {
    key: "patch",
    get: function () {
      return this.$$.ctx[70];
    }
  }, {
    key: "acceptAutoRepair",
    get: function () {
      return this.$$.ctx[8];
    }
  }, {
    key: "openTransformModal",
    get: function () {
      return this.$$.ctx[71];
    }
  }, {
    key: "scrollTo",
    get: function () {
      return this.$$.ctx[72];
    }
  }, {
    key: "findElement",
    get: function () {
      return this.$$.ctx[73];
    }
  }, {
    key: "focus",
    get: function () {
      return this.$$.ctx[9];
    }
  }]);
}();
function dj(e) {
  return "object" !== S(n = e) || null === n ? e : new Proxy(e, {
    get: function (e, n, t) {
      return dj(Reflect.get(e, n, t));
    },
    set: function () {
      return !1;
    },
    deleteProperty: function () {
      return !1;
    }
  });
  var n;
}
function fj(e) {
  St(e, "svelte-1mpf6w7", '.jse-modal.svelte-1mpf6w7.svelte-1mpf6w7{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-1mpf6w7 .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-1mpf6w7 .jse-modal-contents.svelte-1mpf6w7{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-1mpf6w7 .jse-modal-contents .jse-actions.svelte-1mpf6w7{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-1mpf6w7 .jse-modal-contents .jse-actions button.jse-primary.svelte-1mpf6w7{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-1mpf6w7 .jse-modal-contents .jse-actions button.jse-primary.svelte-1mpf6w7:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-1mpf6w7 .jse-modal-contents .jse-actions button.jse-primary.svelte-1mpf6w7:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0;overflow:auto}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;max-height:500px;display:flex}.bg.jse-modal-bg .jse-modal-window:has(div.fullscreen){margin:var(--jse-padding, 10px);padding:0;width:calc(100vw - 2 * var(--jse-padding, 10px));height:calc(100vh - 2 * var(--jse-padding, 10px));max-width:none;max-height:none}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0;max-height:none}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents.svelte-1mpf6w7{color:inherit;min-height:0;padding:0}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents.svelte-1mpf6w7{flex:1;display:flex;gap:calc(2 * var(--jse-padding, 10px));min-height:0;box-sizing:border-box;padding:0 calc(2 * var(--jse-padding, 10px)) var(--jse-padding, 10px)}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-query-contents.svelte-1mpf6w7{flex:1;display:flex;flex-direction:column}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-1mpf6w7 p{margin:var(--jse-padding, 10px) 0}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-1mpf6w7 p:first-child{margin-top:0}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-1mpf6w7 p:last-child{margin-bottom:0}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-query-contents .jse-description.svelte-1mpf6w7 code{background:var(--jse-modal-code-background, rgba(0, 0, 0, 0.05));font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px)}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-query-contents textarea.jse-query.svelte-1mpf6w7{flex:1;outline:none;resize:vertical}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-data-contents.svelte-1mpf6w7{flex:1;display:flex;flex-direction:column;gap:calc(2 * var(--jse-padding, 10px))}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-data-contents .jse-original-data.svelte-1mpf6w7{flex:1;display:flex;flex-direction:column;min-height:0;box-sizing:border-box}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-data-contents .jse-original-data.jse-hide.svelte-1mpf6w7{flex:none}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-data-contents .jse-preview-data.svelte-1mpf6w7{flex:1;display:flex;flex-direction:column;min-height:0;box-sizing:border-box}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-data-contents.jse-hide-original-data.svelte-1mpf6w7{flex-direction:column;gap:0;margin-bottom:0}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-actions.svelte-1mpf6w7{padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px)) calc(2 * var(--jse-padding, 10px))}@media screen and (max-width: 1200px){.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents.svelte-1mpf6w7{flex-direction:column;overflow:auto}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-query-contents textarea.jse-query.svelte-1mpf6w7{min-height:150px;flex:none}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-modal-contents .jse-main-contents .jse-data-contents.svelte-1mpf6w7 .jse-tree-mode{height:300px;flex:none}}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-label.svelte-1mpf6w7{font-weight:bold;display:block;box-sizing:border-box}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-label .jse-label-inner.svelte-1mpf6w7{margin-top:calc(2 * var(--jse-padding, 10px));margin-bottom:calc(0.5 * var(--jse-padding, 10px));box-sizing:border-box}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-label .jse-label-inner button.svelte-1mpf6w7{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;font-weight:bold;padding:0}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-tree-mode{flex:1;background:var(--jse-input-background-readonly, transparent);box-shadow:none;box-sizing:border-box;--jse-main-border:var(--jse-input-border, 1px solid #d8dbdf)}.jse-modal.jse-transform.svelte-1mpf6w7 input.svelte-1mpf6w7,.jse-modal.jse-transform.svelte-1mpf6w7 textarea.svelte-1mpf6w7{border:var(--jse-input-border, 1px solid #d8dbdf);outline:none;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding, 10px));font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:inherit;background:var(--jse-input-background, var(--jse-background-color, #fff))}.jse-modal.jse-transform.svelte-1mpf6w7 input.svelte-1mpf6w7:focus,.jse-modal.jse-transform.svelte-1mpf6w7 textarea.svelte-1mpf6w7:focus{border:var(--jse-input-border-focus, 1px solid var(--jse-input-border-focus, var(--jse-theme-color, #3883fa)))}.jse-modal.jse-transform.svelte-1mpf6w7 input.svelte-1mpf6w7:read-only,.jse-modal.jse-transform.svelte-1mpf6w7 textarea.svelte-1mpf6w7:read-only{background:var(--jse-input-background-readonly, transparent)}.jse-modal.jse-transform.svelte-1mpf6w7 .jse-preview.jse-error.svelte-1mpf6w7{flex:1;background:var(--jse-input-background-readonly, transparent);border:var(--jse-input-border, 1px solid #d8dbdf);color:var(--jse-error-color, #ee5341);padding:calc(0.5 * var(--jse-padding, 10px))}.jse-modal.jse-transform.svelte-1mpf6w7 a{color:var(--jse-a-color, #156fc5)}.jse-modal.jse-transform.svelte-1mpf6w7 a:hover{color:var(--jse-a-color-highlight, #0f508d)}');
}
function vj(e) {
  var n,
    t,
    o,
    r,
    i,
    a = [mj, pj],
    s = [];
  function l(e, t) {
    return 16384 & t[0] && (n = null), null == n && (n = !!Array.isArray(e[14])), n ? 0 : 1;
  }
  return t = l(e, [-1, -1]), o = s[t] = a[t](e), {
    c: function () {
      o.c(), r = Nt();
    },
    m: function (e, n) {
      s[t].m(e, n), Rt(e, r, n), i = !0;
    },
    p: function (e, n) {
      var i = t;
      (t = l(e, n)) === i ? s[t].p(e, n) : (Ro(), Po(s[i], 1, 1, function () {
        s[i] = null;
      }), Eo(), (o = s[t]) ? o.p(e, n) : (o = s[t] = a[t](e)).c(), qo(o, 1), o.m(r.parentNode, r));
    },
    i: function (e) {
      i || (qo(o), i = !0);
    },
    o: function (e) {
      Po(o), i = !1;
    },
    d: function (e) {
      e && Et(r), s[t].d(e);
    }
  };
}
function pj(e) {
  var n;
  return {
    c: function () {
      n = Tt("(Only available for arrays, not for objects)");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function mj(e) {
  var n, t;
  return n = new Gd({
    props: {
      queryOptions: e[15],
      json: e[14],
      onChange: e[24]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      32768 & t[0] && (o.queryOptions = e[15]), 16384 & t[0] && (o.json = e[14]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function gj(e) {
  var n, t;
  return n = new uj({
    props: {
      externalContent: e[17],
      externalSelection: null,
      readOnly: !0,
      mainMenuBar: !1,
      navigationBar: !1,
      indentation: e[2],
      escapeControlCharacters: e[3],
      escapeUnicodeCharacters: e[4],
      parser: e[5],
      parseMemoizeOne: e[6],
      onRenderValue: e[10],
      onRenderMenu: e[11],
      onRenderContextMenu: e[12],
      onError: console.error,
      onChange: oe,
      onChangeMode: oe,
      onSelect: oe,
      onFocus: oe,
      onBlur: oe,
      onSortModal: oe,
      onTransformModal: oe,
      onJSONEditorModal: oe,
      onClassName: e[13],
      validator: null,
      validationParser: e[7],
      pathParser: e[8]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      131072 & t[0] && (o.externalContent = e[17]), 4 & t[0] && (o.indentation = e[2]), 8 & t[0] && (o.escapeControlCharacters = e[3]), 16 & t[0] && (o.escapeUnicodeCharacters = e[4]), 32 & t[0] && (o.parser = e[5]), 64 & t[0] && (o.parseMemoizeOne = e[6]), 1024 & t[0] && (o.onRenderValue = e[10]), 2048 & t[0] && (o.onRenderMenu = e[11]), 4096 & t[0] && (o.onRenderContextMenu = e[12]), 8192 & t[0] && (o.onClassName = e[13]), 128 & t[0] && (o.validationParser = e[7]), 256 & t[0] && (o.pathParser = e[8]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function hj(e) {
  var n, t;
  return {
    c: function () {
      n = Pt("div"), t = Tt(e[21]), Ut(n, "class", "jse-preview jse-error svelte-1mpf6w7");
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: function (e, n) {
      2097152 & n[0] && Ht(t, e[21]);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function jj(e) {
  var n, t;
  return n = new uj({
    props: {
      externalContent: e[22],
      externalSelection: null,
      readOnly: !0,
      mainMenuBar: !1,
      navigationBar: !1,
      indentation: e[2],
      escapeControlCharacters: e[3],
      escapeUnicodeCharacters: e[4],
      parser: e[5],
      parseMemoizeOne: e[6],
      onRenderValue: e[10],
      onRenderMenu: e[11],
      onRenderContextMenu: e[12],
      onError: console.error,
      onChange: oe,
      onChangeMode: oe,
      onSelect: oe,
      onFocus: oe,
      onBlur: oe,
      onSortModal: oe,
      onTransformModal: oe,
      onJSONEditorModal: oe,
      onClassName: e[13],
      validator: null,
      validationParser: e[7],
      pathParser: e[8]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      4194304 & t[0] && (o.externalContent = e[22]), 4 & t[0] && (o.indentation = e[2]), 8 & t[0] && (o.escapeControlCharacters = e[3]), 16 & t[0] && (o.escapeUnicodeCharacters = e[4]), 32 & t[0] && (o.parser = e[5]), 64 & t[0] && (o.parseMemoizeOne = e[6]), 1024 & t[0] && (o.onRenderValue = e[10]), 2048 & t[0] && (o.onRenderMenu = e[11]), 4096 & t[0] && (o.onRenderContextMenu = e[12]), 8192 & t[0] && (o.onClassName = e[13]), 128 & t[0] && (o.validationParser = e[7]), 256 & t[0] && (o.pathParser = e[8]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function bj(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f,
    v,
    p,
    m,
    g,
    h,
    j,
    b,
    y,
    x,
    w,
    $,
    k,
    C,
    S,
    M,
    O,
    z,
    R,
    E,
    q,
    P,
    I,
    T,
    A,
    N,
    B,
    F,
    L,
    U,
    D,
    J,
    V,
    H,
    _,
    W,
    Q,
    Y = e[23](e[0]).description + "";
  function K(n) {
    e[37](n);
  }
  var Z = {
    queryLanguages: e[9],
    queryLanguageId: e[0],
    onChangeQueryLanguage: e[29]
  };
  void 0 !== e[18] && (Z.fullscreen = e[18]), n = new hf({
    props: Z
  }), vo.push(function () {
    return Do(n, "fullscreen", K);
  }), b = new Ya({
    props: {
      data: e[19] ? Oe : ze
    }
  });
  var X = e[19] && vj(e);
  q = new Ya({
    props: {
      data: e[20] ? Oe : ze
    }
  });
  var ee = e[20] && gj(e),
    ne = [jj, hj],
    te = [];
  function oe(e, n) {
    return e[21] ? 1 : 0;
  }
  return F = oe(e), L = te[F] = ne[F](e), {
    c: function () {
      Jo(n.$$.fragment), o = At(), r = Pt("div"), i = Pt("div"), a = Pt("div"), (s = Pt("div")).innerHTML = '<div class="jse-label-inner svelte-1mpf6w7">Language</div>', l = At(), c = Pt("div"), u = At(), (d = Pt("div")).innerHTML = '<div class="jse-label-inner svelte-1mpf6w7">Path</div>', f = At(), v = Pt("input"), m = At(), g = Pt("div"), h = Pt("div"), j = Pt("button"), Jo(b.$$.fragment), y = Tt("\n                Wizard"), x = At(), X && X.c(), w = At(), ($ = Pt("div")).innerHTML = '<div class="jse-label-inner svelte-1mpf6w7">Query</div>', k = At(), C = Pt("textarea"), S = At(), M = Pt("div"), O = Pt("div"), z = Pt("div"), R = Pt("div"), E = Pt("button"), Jo(q.$$.fragment), P = Tt("\n                  Original"), I = At(), ee && ee.c(), T = At(), A = Pt("div"), (N = Pt("div")).innerHTML = '<div class="jse-label-inner svelte-1mpf6w7">Preview</div>', B = At(), L.c(), U = At(), D = Pt("div"), J = Pt("button"), V = Tt("Transform"), Ut(s, "class", "jse-label svelte-1mpf6w7"), Ut(c, "class", "jse-description svelte-1mpf6w7"), Ut(d, "class", "jse-label svelte-1mpf6w7"), Ut(v, "class", "jse-path svelte-1mpf6w7"), Ut(v, "type", "text"), v.readOnly = !0, Ut(v, "title", "Selected path"), v.value = p = G(e[1]) ? "(document root)" : $a(e[1]), Ut(j, "type", "button"), Ut(j, "class", "svelte-1mpf6w7"), Ut(h, "class", "jse-label-inner svelte-1mpf6w7"), Ut(g, "class", "jse-label svelte-1mpf6w7"), Ut($, "class", "jse-label svelte-1mpf6w7"), Ut(C, "class", "jse-query svelte-1mpf6w7"), Ut(C, "spellcheck", "false"), C.value = e[16], Ut(a, "class", "jse-query-contents svelte-1mpf6w7"), Ut(E, "type", "button"), Ut(E, "class", "svelte-1mpf6w7"), Ut(R, "class", "jse-label-inner svelte-1mpf6w7"), Ut(z, "class", "jse-label svelte-1mpf6w7"), Ut(O, "class", "jse-original-data svelte-1mpf6w7"), Yt(O, "jse-hide", !e[20]), Ut(N, "class", "jse-label svelte-1mpf6w7"), Ut(A, "class", "jse-preview-data svelte-1mpf6w7"), Ut(M, "class", "jse-data-contents svelte-1mpf6w7"), Yt(M, "jse-hide-original-data", !e[20]), Ut(i, "class", "jse-main-contents svelte-1mpf6w7"), Ut(J, "type", "button"), Ut(J, "class", "jse-primary svelte-1mpf6w7"), J.disabled = H = !!e[21], Ut(D, "class", "jse-actions svelte-1mpf6w7"), Ut(r, "class", "jse-modal-contents svelte-1mpf6w7");
    },
    m: function (t, p) {
      Vo(n, t, p), Rt(t, o, p), Rt(t, r, p), Ct(r, i), Ct(i, a), Ct(a, s), Ct(a, l), Ct(a, c), c.innerHTML = Y, Ct(a, u), Ct(a, d), Ct(a, f), Ct(a, v), Ct(a, m), Ct(a, g), Ct(g, h), Ct(h, j), Vo(b, j, null), Ct(j, y), Ct(a, x), X && X.m(a, null), Ct(a, w), Ct(a, $), Ct(a, k), Ct(a, C), Ct(i, S), Ct(i, M), Ct(M, O), Ct(O, z), Ct(z, R), Ct(R, E), Vo(q, E, null), Ct(E, P), Ct(O, I), ee && ee.m(O, null), Ct(M, T), Ct(M, A), Ct(A, N), Ct(A, B), te[F].m(A, null), Ct(r, U), Ct(r, D), Ct(D, J), Ct(J, V), _ = !0, W || (Q = [Bt(j, "click", e[27]), Bt(C, "input", e[25]), Bt(E, "click", e[28]), Bt(J, "click", e[26]), jt(xj.call(null, J))], W = !0);
    },
    p: function (e, o) {
      var r = {};
      512 & o[0] && (r.queryLanguages = e[9]), 1 & o[0] && (r.queryLanguageId = e[0]), !t && 262144 & o[0] && (t = !0, r.fullscreen = e[18], xo(function () {
        return t = !1;
      })), n.$set(r), (!_ || 1 & o[0]) && Y !== (Y = e[23](e[0]).description + "") && (c.innerHTML = Y), (!_ || 2 & o[0] && p !== (p = G(e[1]) ? "(document root)" : $a(e[1])) && v.value !== p) && (v.value = p);
      var i = {};
      524288 & o[0] && (i.data = e[19] ? Oe : ze), b.$set(i), e[19] ? X ? (X.p(e, o), 524288 & o[0] && qo(X, 1)) : ((X = vj(e)).c(), qo(X, 1), X.m(a, w)) : X && (Ro(), Po(X, 1, 1, function () {
        X = null;
      }), Eo()), (!_ || 65536 & o[0]) && (C.value = e[16]);
      var s = {};
      1048576 & o[0] && (s.data = e[20] ? Oe : ze), q.$set(s), e[20] ? ee ? (ee.p(e, o), 1048576 & o[0] && qo(ee, 1)) : ((ee = gj(e)).c(), qo(ee, 1), ee.m(O, null)) : ee && (Ro(), Po(ee, 1, 1, function () {
        ee = null;
      }), Eo()), (!_ || 1048576 & o[0]) && Yt(O, "jse-hide", !e[20]);
      var l = F;
      (F = oe(e)) === l ? te[F].p(e, o) : (Ro(), Po(te[l], 1, 1, function () {
        te[l] = null;
      }), Eo(), (L = te[F]) ? L.p(e, o) : (L = te[F] = ne[F](e)).c(), qo(L, 1), L.m(A, null)), (!_ || 1048576 & o[0]) && Yt(M, "jse-hide-original-data", !e[20]), (!_ || 2097152 & o[0] && H !== (H = !!e[21])) && (J.disabled = H);
    },
    i: function (e) {
      _ || (qo(n.$$.fragment, e), qo(b.$$.fragment, e), qo(X), qo(q.$$.fragment, e), qo(ee), qo(L), _ = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), Po(b.$$.fragment, e), Po(X), Po(q.$$.fragment, e), Po(ee), Po(L), _ = !1;
    },
    d: function (e) {
      e && (Et(o), Et(r)), Ho(n, e), Ho(b), X && X.d(), Ho(q), ee && ee.d(), te[F].d(), W = !1, at(Q);
    }
  };
}
function yj(e) {
  var n, t, o, r, i;
  return t = new wa({
    props: {
      $$slots: {
        default: [bj]
      },
      $$scope: {
        ctx: e
      }
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "class", "jse-modal jse-transform svelte-1mpf6w7"), Yt(n, "fullscreen", e[18]);
    },
    m: function (a, s) {
      Rt(a, n, s), Vo(t, n, null), o = !0, r || (i = jt(Kf.call(null, n, e[30])), r = !0);
    },
    p: function (e, r) {
      var i = {};
      8388607 & r[0] | 16384 & r[1] && (i.$$scope = {
        dirty: r,
        ctx: e
      }), t.$set(i), (!o || 262144 & r[0]) && Yt(n, "fullscreen", e[18]);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), r = !1, i();
    }
  };
}
function xj(e) {
  e.focus();
}
function wj(e, n, t) {
  var o,
    r,
    i = Qo("jsoneditor:TransformModal"),
    a = n.id,
    s = void 0 === a ? "transform-modal-" + Vr() : a,
    l = n.json,
    c = n.rootPath,
    u = void 0 === c ? [] : c,
    d = n.indentation,
    f = n.escapeControlCharacters,
    v = n.escapeUnicodeCharacters,
    p = n.parser,
    m = n.parseMemoizeOne,
    g = n.validationParser,
    h = n.pathParser,
    j = n.queryLanguages,
    b = n.queryLanguageId,
    y = n.onChangeQueryLanguage,
    x = n.onRenderValue,
    w = n.onRenderMenu,
    $ = n.onRenderContextMenu,
    k = n.onClassName,
    C = n.onTransform,
    S = co("simple-modal").close,
    M = !1,
    R = "".concat(s, ":").concat(O(u)),
    E = $c[R] || {},
    q = !1 !== kc.showWizard,
    P = !1 !== kc.showOriginal,
    I = E.queryOptions || {},
    T = b === E.queryLanguageId && E.query ? E.query : F(b).createQuery(o, E.queryOptions || {}),
    A = E.isManual || !1,
    N = void 0,
    B = {
      text: ""
    };
  function F(e) {
    return j.find(function (n) {
      return n.id === e;
    }) || j[0];
  }
  var L = ce(function (e, n) {
    if (void 0 === e) return t(22, B = {
      text: ""
    }), void t(21, N = "Error: No JSON");
    try {
      i("previewTransform", {
        query: n
      });
      var o = F(b).executeQuery(e, n, p);
      t(22, B = {
        json: o
      }), t(21, N = void 0);
    } catch (e) {
      t(22, B = {
        text: ""
      }), t(21, N = String(e));
    }
  }, 300);
  return e.$$set = function (e) {
    "id" in e && t(31, s = e.id), "json" in e && t(32, l = e.json), "rootPath" in e && t(1, u = e.rootPath), "indentation" in e && t(2, d = e.indentation), "escapeControlCharacters" in e && t(3, f = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && t(4, v = e.escapeUnicodeCharacters), "parser" in e && t(5, p = e.parser), "parseMemoizeOne" in e && t(6, m = e.parseMemoizeOne), "validationParser" in e && t(7, g = e.validationParser), "pathParser" in e && t(8, h = e.pathParser), "queryLanguages" in e && t(9, j = e.queryLanguages), "queryLanguageId" in e && t(0, b = e.queryLanguageId), "onChangeQueryLanguage" in e && t(33, y = e.onChangeQueryLanguage), "onRenderValue" in e && t(10, x = e.onRenderValue), "onRenderMenu" in e && t(11, w = e.onRenderMenu), "onRenderContextMenu" in e && t(12, $ = e.onRenderContextMenu), "onClassName" in e && t(13, k = e.onClassName), "onTransform" in e && t(34, C = e.onTransform);
  }, e.$$.update = function () {
    2 & e.$$.dirty[0] | 2 & e.$$.dirty[1] && t(14, o = dj(z(l, u))), 16384 & e.$$.dirty[0] && t(17, r = o ? {
      json: o
    } : {
      text: ""
    }), 81920 & e.$$.dirty[0] && L(o, T), 98305 & e.$$.dirty[0] | 48 & e.$$.dirty[1] && (t(35, $c[R] = {
      queryOptions: I,
      query: T,
      queryLanguageId: b,
      isManual: A
    }, $c), i("store state in memory", R, $c[R]));
  }, [b, u, d, f, v, p, m, g, h, j, x, w, $, k, o, I, T, r, M, q, P, N, B, F, function (e) {
    t(15, I = e), t(16, T = F(b).createQuery(o, e)), t(36, A = !1), i("updateQueryByWizard", {
      queryOptions: I,
      query: T,
      isManual: A
    });
  }, function (e) {
    t(16, T = e.target.value), t(36, A = !0), i("handleChangeQuery", {
      query: T,
      isManual: A
    });
  }, function () {
    if (void 0 === o) return t(22, B = {
      text: ""
    }), void t(21, N = "Error: No JSON");
    try {
      i("handleTransform", {
        query: T
      });
      var e = F(b).executeQuery(o, T, p);
      C([{
        op: "replace",
        path: O(u),
        value: e
      }]), S();
    } catch (e) {
      console.error(e), t(22, B = {
        text: ""
      }), t(21, N = String(e));
    }
  }, function () {
    t(19, q = !q), kc.showWizard = q;
  }, function () {
    t(20, P = !P), kc.showOriginal = P;
  }, function (e) {
    i("handleChangeQueryLanguage", e), t(0, b = e), y(e);
    var n = F(b);
    t(16, T = n.createQuery(o, I)), t(36, A = !1);
  }, function () {
    M ? t(18, M = !M) : S();
  }, s, l, y, C, $c, A, function (e) {
    t(18, M = e);
  }];
}
var $j = function (e) {
    function n(e) {
      var t;
      return h(this, n), _o(t = u(this, n), e, wj, yj, ct, {
        id: 31,
        json: 32,
        rootPath: 1,
        indentation: 2,
        escapeControlCharacters: 3,
        escapeUnicodeCharacters: 4,
        parser: 5,
        parseMemoizeOne: 6,
        validationParser: 7,
        pathParser: 8,
        queryLanguages: 9,
        queryLanguageId: 0,
        onChangeQueryLanguage: 33,
        onRenderValue: 10,
        onRenderMenu: 11,
        onRenderContextMenu: 12,
        onClassName: 13,
        onTransform: 34
      }, fj, [-1, -1]), t;
    }
    return v(n, Wo), b(n);
  }(),
  kj = {};
function Cj(e) {
  St(e, "svelte-jdii8g", '.jse-modal.svelte-jdii8g.svelte-jdii8g{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-jdii8g .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-jdii8g .jse-modal-contents.svelte-jdii8g{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-jdii8g .jse-modal-contents .jse-actions.svelte-jdii8g{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-jdii8g .jse-modal-contents .jse-actions button.jse-primary.svelte-jdii8g{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-jdii8g .jse-modal-contents .jse-actions button.jse-primary.svelte-jdii8g:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-jdii8g .jse-modal-contents .jse-actions button.jse-primary.svelte-jdii8g:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0;overflow:auto}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;max-height:500px;display:flex}.bg.jse-modal-bg .jse-modal-window:has(div.fullscreen){margin:var(--jse-padding, 10px);padding:0;width:calc(100vw - 2 * var(--jse-padding, 10px));height:calc(100vh - 2 * var(--jse-padding, 10px));max-width:none;max-height:none}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0;max-height:none}.jse-modal.jse-sort.svelte-jdii8g table.svelte-jdii8g{width:100%;border-collapse:collapse;border-spacing:0}.jse-modal.jse-sort.svelte-jdii8g table th.svelte-jdii8g,.jse-modal.jse-sort.svelte-jdii8g table td.svelte-jdii8g{text-align:left;vertical-align:middle;font-weight:normal;padding-bottom:var(--jse-padding, 10px)}.jse-modal.jse-sort.svelte-jdii8g table th input.jse-path.svelte-jdii8g,.jse-modal.jse-sort.svelte-jdii8g table td input.jse-path.svelte-jdii8g{width:100%;box-sizing:border-box;padding:6px 16px;border:var(--jse-input-border, 1px solid #d8dbdf);border-radius:var(--jse-input-radius, 3px);font-family:inherit;font-size:inherit;background:inherit;color:inherit;outline:none}.jse-modal.jse-sort.svelte-jdii8g table th input.jse-path.svelte-jdii8g:read-only,.jse-modal.jse-sort.svelte-jdii8g table td input.jse-path.svelte-jdii8g:read-only{background:var(--jse-input-background-readonly, transparent)}.jse-modal.jse-sort.svelte-jdii8g table th.svelte-jdii8g .svelte-select input,.jse-modal.jse-sort.svelte-jdii8g table td.svelte-jdii8g .svelte-select input{box-sizing:border-box}.jse-modal.jse-sort.svelte-jdii8g .jse-space.svelte-jdii8g{height:200px}.jse-modal.jse-sort.svelte-jdii8g .jse-space .jse-error.svelte-jdii8g{color:var(--jse-error-color, #ee5341)}');
}
function Sj(e) {
  var n, t, o, r, i, a, s;
  function l(n) {
    e[14](n);
  }
  var c = {
    showChevron: !0,
    items: e[5]
  };
  return void 0 !== e[1] && (c.value = e[1]), i = new _d({
    props: c
  }), vo.push(function () {
    return Do(i, "value", l);
  }), {
    c: function () {
      n = Pt("tr"), (t = Pt("th")).textContent = "Property", o = At(), r = Pt("td"), Jo(i.$$.fragment), Ut(t, "class", "svelte-jdii8g"), Ut(r, "class", "svelte-jdii8g");
    },
    m: function (e, a) {
      Rt(e, n, a), Ct(n, t), Ct(n, o), Ct(n, r), Vo(i, r, null), s = !0;
    },
    p: function (e, n) {
      var t = {};
      32 & n && (t.items = e[5]), !a && 2 & n && (a = !0, t.value = e[1], xo(function () {
        return a = !1;
      })), i.$set(t);
    },
    i: function (e) {
      s || (qo(i.$$.fragment, e), s = !0);
    },
    o: function (e) {
      Po(i.$$.fragment, e), s = !1;
    },
    d: function (e) {
      e && Et(n), Ho(i);
    }
  };
}
function Mj(e) {
  var n, t;
  return {
    c: function () {
      n = Pt("div"), t = Tt(e[4]), Ut(n, "class", "jse-error svelte-jdii8g");
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: function (e, n) {
      16 & n && Ht(t, e[4]);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Oj(e) {
  var n, t, o, r, i, a, l, c, u, d, f, v, p, m, g, h, j, b, y, x, w, $, k, C, S, M, O, z, R, E, q, P, I;
  o = new ff({
    props: {
      title: e[3] ? "Sort array items" : "Sort object keys"
    }
  });
  var T = e[3] && (e[5] && (null === (n = e[5]) || void 0 === n ? void 0 : n.length) > 1 || void 0 === e[1]) && Sj(e);
  function A(n) {
    e[15](n);
  }
  var N = {
    showChevron: !0,
    clearable: !1,
    items: e[7]
  };
  void 0 !== e[2] && (N.value = e[2]), $ = new _d({
    props: N
  }), vo.push(function () {
    return Do($, "value", A);
  });
  var B = e[4] && Mj(e);
  return {
    c: function () {
      var n;
      t = Pt("div"), Jo(o.$$.fragment), r = At(), i = Pt("div"), a = Pt("table"), (l = Pt("colgroup")).innerHTML = '<col width="25%"/> <col width="75%"/>', c = At(), u = Pt("tbody"), d = Pt("tr"), (f = Pt("th")).textContent = "Path", v = At(), p = Pt("td"), m = Pt("input"), h = At(), T && T.c(), j = At(), b = Pt("tr"), (y = Pt("th")).textContent = "Direction", x = At(), w = Pt("td"), Jo($.$$.fragment), C = At(), S = Pt("div"), B && B.c(), M = At(), O = Pt("div"), z = Pt("button"), R = Tt("Sort"), Ut(f, "class", "svelte-jdii8g"), Ut(m, "class", "jse-path svelte-jdii8g"), Ut(m, "type", "text"), m.readOnly = !0, Ut(m, "title", "Selected path"), m.value = g = G(e[0]) ? "(document root)" : $a(e[0]), Ut(p, "class", "svelte-jdii8g"), Ut(y, "class", "svelte-jdii8g"), Ut(w, "class", "svelte-jdii8g"), Ut(a, "class", "svelte-jdii8g"), Ut(S, "class", "jse-space svelte-jdii8g"), Ut(z, "type", "button"), Ut(z, "class", "jse-primary svelte-jdii8g"), z.disabled = E = !!(e[3] && e[5] && (null === (n = e[5]) || void 0 === n ? void 0 : n.length) > 1) && !e[1], Ut(O, "class", "jse-actions svelte-jdii8g"), Ut(i, "class", "jse-modal-contents svelte-jdii8g"), Ut(t, "class", "jse-modal jse-sort svelte-jdii8g");
    },
    m: function (n, s) {
      Rt(n, t, s), Vo(o, t, null), Ct(t, r), Ct(t, i), Ct(i, a), Ct(a, l), Ct(a, c), Ct(a, u), Ct(u, d), Ct(d, f), Ct(d, v), Ct(d, p), Ct(p, m), Ct(u, h), T && T.m(u, null), Ct(u, j), Ct(u, b), Ct(b, y), Ct(b, x), Ct(b, w), Vo($, w, null), Ct(i, C), Ct(i, S), B && B.m(S, null), Ct(i, M), Ct(i, O), Ct(O, z), Ct(z, R), q = !0, P || (I = [Bt(z, "click", e[8]), jt(zj.call(null, z)), jt(Kf.call(null, t, e[6]))], P = !0);
    },
    p: function (e, n) {
      var t,
        r,
        i = s(n, 1)[0],
        a = {};
      8 & i && (a.title = e[3] ? "Sort array items" : "Sort object keys"), o.$set(a), (!q || 1 & i && g !== (g = G(e[0]) ? "(document root)" : $a(e[0])) && m.value !== g) && (m.value = g), e[3] && (e[5] && (null === (t = e[5]) || void 0 === t ? void 0 : t.length) > 1 || void 0 === e[1]) ? T ? (T.p(e, i), 42 & i && qo(T, 1)) : ((T = Sj(e)).c(), qo(T, 1), T.m(u, j)) : T && (Ro(), Po(T, 1, 1, function () {
        T = null;
      }), Eo());
      var l = {};
      !k && 4 & i && (k = !0, l.value = e[2], xo(function () {
        return k = !1;
      })), $.$set(l), e[4] ? B ? B.p(e, i) : ((B = Mj(e)).c(), B.m(S, null)) : B && (B.d(1), B = null), (!q || 42 & i && E !== (E = !!(e[3] && e[5] && (null === (r = e[5]) || void 0 === r ? void 0 : r.length) > 1) && !e[1])) && (z.disabled = E);
    },
    i: function (e) {
      q || (qo(o.$$.fragment, e), qo(T), qo($.$$.fragment, e), q = !0);
    },
    o: function (e) {
      Po(o.$$.fragment, e), Po(T), Po($.$$.fragment, e), q = !1;
    },
    d: function (e) {
      e && Et(t), Ho(o), T && T.d(), Ho($), B && B.d(), P = !1, at(I);
    }
  };
}
function zj(e) {
  e.focus();
}
function Rj(e, n, t) {
  var o,
    r,
    i,
    a,
    s,
    l = Qo("jsoneditor:SortModal"),
    c = n.id,
    u = n.json,
    d = n.rootPath,
    f = n.onSort,
    v = co("simple-modal").close,
    p = "".concat(c, ":").concat(O(d)),
    m = z(u, d),
    g = {
      value: 1,
      label: "ascending"
    },
    h = [g, {
      value: -1,
      label: "descending"
    }],
    j = null === (o = kj[p]) || void 0 === o ? void 0 : o.selectedProperty,
    b = (null === (r = kj[p]) || void 0 === r ? void 0 : r.selectedDirection) || g,
    y = void 0;
  return e.$$set = function (e) {
    "id" in e && t(9, c = e.id), "json" in e && t(10, u = e.json), "rootPath" in e && t(0, d = e.rootPath), "onSort" in e && t(11, f = e.onSort);
  }, e.$$.update = function () {
    8 & e.$$.dirty && t(13, a = i && void 0 !== m ? si(m) : void 0), 8192 & e.$$.dirty && t(5, s = a ? a.map(Ca) : void 0), 4102 & e.$$.dirty && (t(12, kj[p] = {
      selectedProperty: j,
      selectedDirection: b
    }, kj), l("store state in memory", p, kj[p]));
  }, t(3, i = Array.isArray(m)), [d, j, b, i, y, s, v, h, function () {
    try {
      var e, n, o;
      t(4, y = void 0);
      var r = (null === (e = j) || void 0 === e ? void 0 : e.value) || (null === (n = s) || void 0 === n || null === (n = n[0]) || void 0 === n ? void 0 : n.value) || [],
        i = null === (o = b) || void 0 === o ? void 0 : o.value,
        a = Tm(u, d, r, i);
      f({
        operations: a,
        rootPath: d,
        itemPath: r,
        direction: i
      }), v();
    } catch (e) {
      t(4, y = String(e));
    }
  }, c, u, f, kj, a, function (e) {
    t(1, j = e);
  }, function (e) {
    t(2, b = e);
  }];
}
var Ej = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Rj, Oj, ct, {
      id: 9,
      json: 10,
      rootPath: 0,
      onSort: 11
    }, Cj), t;
  }
  return v(n, Wo), b(n);
}();
function qj() {}
function Pj(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e3;
  if (e < .9 * n) return e.toFixed() + " B";
  var t = e / n;
  if (t < .9 * n) return t.toFixed(1) + " KB";
  var o = t / n;
  if (o < .9 * n) return o.toFixed(1) + " MB";
  var r = o / n;
  return r < .9 * n ? r.toFixed(1) + " GB" : (r / n).toFixed(1) + " TB";
}
function Ij(e) {
  var n, t;
  return n = new Ev({
    props: {
      items: e[0]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & s(t, 1)[0] && (o.items = e[0]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Tj(e, n, t) {
  var o,
    r,
    i = n.readOnly,
    a = void 0 !== i && i,
    s = n.onFormat,
    l = n.onCompact,
    c = n.onSort,
    u = n.onTransform,
    d = n.onToggleSearch,
    f = n.onUndo,
    v = n.onRedo,
    p = n.canUndo,
    m = n.canRedo,
    g = n.canFormat,
    h = n.canCompact,
    j = n.canSort,
    b = n.canTransform,
    y = n.onRenderMenu,
    x = {
      type: "button",
      icon: Re,
      title: "Search (Ctrl+F)",
      className: "jse-search",
      onClick: d
    };
  return e.$$set = function (e) {
    "readOnly" in e && t(1, a = e.readOnly), "onFormat" in e && t(2, s = e.onFormat), "onCompact" in e && t(3, l = e.onCompact), "onSort" in e && t(4, c = e.onSort), "onTransform" in e && t(5, u = e.onTransform), "onToggleSearch" in e && t(6, d = e.onToggleSearch), "onUndo" in e && t(7, f = e.onUndo), "onRedo" in e && t(8, v = e.onRedo), "canUndo" in e && t(9, p = e.canUndo), "canRedo" in e && t(10, m = e.canRedo), "canFormat" in e && t(11, g = e.canFormat), "canCompact" in e && t(12, h = e.canCompact), "canSort" in e && t(13, j = e.canSort), "canTransform" in e && t(14, b = e.canTransform), "onRenderMenu" in e && t(15, y = e.onRenderMenu);
  }, e.$$.update = function () {
    32702 & e.$$.dirty && t(16, r = a ? [x, {
      type: "space"
    }] : [{
      type: "button",
      icon: km,
      title: "Format JSON: add proper indentation and new lines (Ctrl+I)",
      className: "jse-format",
      onClick: s,
      disabled: a || !g
    }, {
      type: "button",
      icon: Cm,
      title: "Compact JSON: remove all white spacing and new lines (Ctrl+Shift+I)",
      className: "jse-compact",
      onClick: l,
      disabled: a || !h
    }, {
      type: "separator"
    }, {
      type: "button",
      icon: Ee,
      title: "Sort",
      className: "jse-sort",
      onClick: c,
      disabled: a || !j
    }, {
      type: "button",
      icon: qe,
      title: "Transform contents (filter, sort, project)",
      className: "jse-transform",
      onClick: u,
      disabled: a || !b
    }, x, {
      type: "separator"
    }, {
      type: "button",
      icon: Ie,
      title: "Undo (Ctrl+Z)",
      className: "jse-undo",
      onClick: f,
      disabled: !p
    }, {
      type: "button",
      icon: Te,
      title: "Redo (Ctrl+Shift+Z)",
      className: "jse-redo",
      onClick: v,
      disabled: !m
    }, {
      type: "space"
    }]), 98304 & e.$$.dirty && t(0, o = y(r) || r);
  }, [o, a, s, l, c, u, d, f, v, p, m, g, h, j, b, y, r];
}
var Aj = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Tj, Ij, ct, {
      readOnly: 1,
      onFormat: 2,
      onCompact: 3,
      onSort: 4,
      onTransform: 5,
      onToggleSearch: 6,
      onUndo: 7,
      onRedo: 8,
      canUndo: 9,
      canRedo: 10,
      canFormat: 11,
      canCompact: 12,
      canSort: 13,
      canTransform: 14,
      onRenderMenu: 15
    }), t;
  }
  return v(n, Wo), b(n);
}();
function Nj(e) {
  St(e, "svelte-hhcn0f", '.jse-status-bar.svelte-hhcn0f.svelte-hhcn0f{background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color-readonly, #b2b2b2);font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);margin:0;border-top:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7));border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7);display:flex;gap:var(--jse-padding, 10px)}.jse-status-bar.svelte-hhcn0f.svelte-hhcn0f:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-status-bar.svelte-hhcn0f .jse-status-bar-info.svelte-hhcn0f{padding:2px}');
}
function Bj(e) {
  var n, t, o;
  return {
    c: function () {
      n = Pt("div"), t = Tt("Line: "), o = Tt(e[0]), Ut(n, "class", "jse-status-bar-info svelte-hhcn0f");
    },
    m: function (e, r) {
      Rt(e, n, r), Ct(n, t), Ct(n, o);
    },
    p: function (e, n) {
      1 & n && Ht(o, e[0]);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Fj(e) {
  var n, t, o;
  return {
    c: function () {
      n = Pt("div"), t = Tt("Column: "), o = Tt(e[1]), Ut(n, "class", "jse-status-bar-info svelte-hhcn0f");
    },
    m: function (e, r) {
      Rt(e, n, r), Ct(n, t), Ct(n, o);
    },
    p: function (e, n) {
      2 & n && Ht(o, e[1]);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Lj(e) {
  var n, t, o, r;
  return {
    c: function () {
      n = Pt("div"), t = Tt("Selection: "), o = Tt(e[2]), r = Tt(" characters"), Ut(n, "class", "jse-status-bar-info svelte-hhcn0f");
    },
    m: function (e, i) {
      Rt(e, n, i), Ct(n, t), Ct(n, o), Ct(n, r);
    },
    p: function (e, n) {
      4 & n && Ht(o, e[2]);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Uj(e) {
  var n,
    t,
    o,
    r = void 0 !== e[0] && Bj(e),
    i = void 0 !== e[1] && Fj(e),
    a = void 0 !== e[2] && e[2] > 0 && Lj(e);
  return {
    c: function () {
      n = Pt("div"), r && r.c(), t = At(), i && i.c(), o = At(), a && a.c(), Ut(n, "class", "jse-status-bar svelte-hhcn0f");
    },
    m: function (e, s) {
      Rt(e, n, s), r && r.m(n, null), Ct(n, t), i && i.m(n, null), Ct(n, o), a && a.m(n, null);
    },
    p: function (e, l) {
      var c = s(l, 1)[0];
      void 0 !== e[0] ? r ? r.p(e, c) : ((r = Bj(e)).c(), r.m(n, t)) : r && (r.d(1), r = null), void 0 !== e[1] ? i ? i.p(e, c) : ((i = Fj(e)).c(), i.m(n, o)) : i && (i.d(1), i = null), void 0 !== e[2] && e[2] > 0 ? a ? a.p(e, c) : ((a = Lj(e)).c(), a.m(n, null)) : a && (a.d(1), a = null);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n), r && r.d(), i && i.d(), a && a.d();
    }
  };
}
function Dj(e, n, t) {
  var o,
    r,
    i,
    a,
    s,
    l = n.editorState;
  return e.$$set = function (e) {
    "editorState" in e && t(3, l = e.editorState);
  }, e.$$.update = function () {
    var n, c, u;
    8 & e.$$.dirty && t(4, o = null === (n = l) || void 0 === n || null === (n = n.selection) || void 0 === n || null === (n = n.main) || void 0 === n ? void 0 : n.head);
    24 & e.$$.dirty && t(5, r = void 0 !== o ? null === (c = l) || void 0 === c || null === (c = c.doc) || void 0 === c ? void 0 : c.lineAt(o) : void 0);
    (32 & e.$$.dirty && t(0, i = void 0 !== r ? r.number : void 0), 48 & e.$$.dirty && t(1, a = void 0 !== r && void 0 !== o ? o - r.from + 1 : void 0), 8 & e.$$.dirty) && t(2, s = null === (u = l) || void 0 === u || null === (u = u.selection) || void 0 === u || null === (u = u.ranges) || void 0 === u ? void 0 : u.reduce(function (e, n) {
      return e + n.to - n.from;
    }, 0));
  }, [i, a, s, l, o, r];
}
var Jj = function (e) {
    function n(e) {
      var t;
      return h(this, n), _o(t = u(this, n), e, Dj, Uj, lt, {
        editorState: 3
      }, Nj), t;
    }
    return v(n, Wo), b(n);
  }(),
  Vj = Pn.define([{
    tag: Gn.propertyName,
    color: "var(--internal-key-color)"
  }, {
    tag: Gn.number,
    color: "var(--internal-value-color-number)"
  }, {
    tag: Gn.bool,
    color: "var(--internal-value-color-boolean)"
  }, {
    tag: Gn.string,
    color: "var(--internal-value-color-string)"
  }, {
    tag: Gn.keyword,
    color: "var(--internal-value-color-null)"
  }]),
  Hj = In(Vj),
  _j = Vj.style;
function Wj(e) {
  St(e, "svelte-a0poeb", '.jse-text-mode.svelte-a0poeb.svelte-a0poeb{--internal-key-color:var(--jse-key-color, #1a1a1a);--internal-value-color-number:var(--jse-value-color-number, #ee422e);--internal-value-color-boolean:var(--jse-value-color-boolean, #ff8c00);--internal-value-color-string:var(--jse-value-color-string, #008000);--internal-value-color-null:var(--jse-value-color-null, #004ed0);flex:1;box-sizing:border-box;display:flex;flex-direction:column;background:var(--jse-background-color, #fff)}.jse-text-mode.no-main-menu.svelte-a0poeb.svelte-a0poeb{border-top:var(--jse-main-border, 1px solid #d7d7d7)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb{flex:1;display:flex;position:relative;flex-direction:column;overflow:hidden;min-width:0;min-height:0;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-text-mode.svelte-a0poeb .jse-contents.jse-hidden.svelte-a0poeb{visibility:hidden;position:absolute;top:0;left:0}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor{flex:1;overflow:hidden}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-scroller{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);line-height:var(--jse-line-height, calc(1em + 4px));color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-gutters{background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color-readonly, #b2b2b2);border-right:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-activeLine,.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-activeLineGutter{background:var(--jse-active-line-background-color, rgba(0, 0, 0, 0.06))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-selectionBackground{background:var(--jse-selection-background-color, #d3d3d3)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-searchMatch{background-color:var(--jse-search-match-color, #ffe665);outline:var(--jse-search-match-outline, 1px solid #ffd700)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-searchMatch.cm-searchMatch-selected{background-color:var(--jse-search-match-active-color, #ffd700);outline:var(--jse-search-match-active-outline, 1px solid #e1be00)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-selectionMatch{background-color:var(--jse-search-match-background-color, rgba(153, 255, 119, 0.5019607843))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-foldPlaceholder{background:var(--jse-tag-background, rgba(0, 0, 0, 0.2));color:var(--jse-tag-color, var(--jse-text-color-inverse, #fff));border:none;padding:0 var(--jse-padding, 10px)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-tooltip{font-size:var(--jse-font-size, 16px);font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);color:var(--jse-tooltip-color, var(--jse-text-color, #4d4d4d));background:var(--jse-tooltip-background, var(--jse-modal-background, #f5f5f5));border:var(--jse-tooltip-border, var(--jse-main-border, 1px solid #d7d7d7))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-diagnosticAction{background:var(--jse-tooltip-action-button-color, var(--jse-text-color-inverse, #fff));background:var(--jse-tooltip-action-button-background, #4d4d4d)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-panels{border-bottom:var(--jse-panel-border, var(--jse-main-border, 1px solid #d7d7d7))}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search{background:var(--jse-panel-background, #ebebeb);color:var(--jse-panel-color, var(--jse-text-color, #4d4d4d));font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search input{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-text-mode-search, 80%);color:var(--jse-input-color, var(--jse-text-color, #4d4d4d));border:var(--jse-input-border, 1px solid #d8dbdf);background:var(--jse-input-background, var(--jse-background-color, #fff));margin-right:2px}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search button{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-text-mode-search, 80%);color:var(--jse-panel-button-color, inherit);background:var(--jse-panel-button-background, transparent);border:none;cursor:pointer;text-transform:capitalize;padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px);margin:0}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search button:hover{color:var(--panel-button-color-highlight, var(--jse-text-color, #4d4d4d));background:var(--jse-panel-button-background-highlight, #e0e0e0)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search label{font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size-text-mode-search, 80%);padding-left:var(--jse-padding, 10px)}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search label input{margin-right:2px}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-search button[name="close"]{width:32px;height:32px;font-size:24px;line-height:24px;padding:0;right:0;top:-4px}.jse-text-mode.svelte-a0poeb .jse-contents.svelte-a0poeb .cm-editor .cm-cursor-primary{border-color:var(--jse-text-color, #4d4d4d)}.jse-text-mode.svelte-a0poeb .jse-contents .jse-loading-space.svelte-a0poeb{flex:1}.jse-text-mode.svelte-a0poeb .jse-contents .jse-loading.svelte-a0poeb{flex:2;text-align:center;color:var(--jse-panel-color-readonly, #b2b2b2);box-sizing:border-box;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}.jse-text-mode.svelte-a0poeb .jse-contents.jse-preview.svelte-a0poeb{flex:1;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-panel-color-readonly, #b2b2b2);overflow:auto;white-space:pre-wrap;word-break:break-word;padding:2px}');
}
function Qj(e) {
  var n = e.slice(),
    t = 0 === n[11].length;
  return n[100] = t, n;
}
function Yj(e) {
  var n, t;
  return n = new Aj({
    props: {
      readOnly: e[1],
      onFormat: e[17],
      onCompact: e[18],
      onSort: e[19],
      onTransform: e[20],
      onToggleSearch: e[21],
      onUndo: e[22],
      onRedo: e[23],
      canFormat: !e[100],
      canCompact: !e[100],
      canSort: !e[100],
      canTransform: !e[100],
      canUndo: e[12],
      canRedo: e[13],
      onRenderMenu: e[4]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      2 & t[0] && (o.readOnly = e[1]), 2048 & t[0] && (o.canFormat = !e[100]), 2048 & t[0] && (o.canCompact = !e[100]), 2048 & t[0] && (o.canSort = !e[100]), 2048 & t[0] && (o.canTransform = !e[100]), 4096 & t[0] && (o.canUndo = e[12]), 8192 & t[0] && (o.canRedo = e[13]), 16 & t[0] && (o.onRenderMenu = e[4]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Gj(e) {
  var n;
  return {
    c: function () {
      (n = Pt("div")).innerHTML = '<div class="jse-loading-space svelte-a0poeb"></div> <div class="jse-loading svelte-a0poeb">loading...</div>', Ut(n, "class", "jse-contents svelte-a0poeb");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Kj(e) {
  var n,
    t,
    o,
    r,
    i,
    a = e[99] && Zj(e),
    s = !e[99] && Xj(e);
  return {
    c: function () {
      n = Pt("div"), t = At(), a && a.c(), o = At(), s && s.c(), r = Nt(), Ut(n, "class", "jse-contents svelte-a0poeb"), Yt(n, "jse-hidden", e[99]);
    },
    m: function (l, c) {
      Rt(l, n, c), e[53](n), Rt(l, t, c), a && a.m(l, c), Rt(l, o, c), s && s.m(l, c), Rt(l, r, c), i = !0;
    },
    p: function (e, t) {
      (!i || 268438016 & t[0]) && Yt(n, "jse-hidden", e[99]), e[99] ? a ? (a.p(e, t), 2560 & t[0] && qo(a, 1)) : ((a = Zj(e)).c(), qo(a, 1), a.m(o.parentNode, o)) : a && (Ro(), Po(a, 1, 1, function () {
        a = null;
      }), Eo()), e[99] ? s && (Ro(), Po(s, 1, 1, function () {
        s = null;
      }), Eo()) : s ? (s.p(e, t), 2560 & t[0] && qo(s, 1)) : ((s = Xj(e)).c(), qo(s, 1), s.m(r.parentNode, r));
    },
    i: function (e) {
      i || (qo(a), qo(s), i = !0);
    },
    o: function (e) {
      Po(a), Po(s), i = !1;
    },
    d: function (i) {
      i && (Et(n), Et(t), Et(o), Et(r)), e[53](null), a && a.d(i), s && s.d(i);
    }
  };
}
function Zj(e) {
  var n,
    t,
    o,
    r,
    i,
    a = Ea(e[11] || "", wr) + "";
  return n = new Nf({
    props: {
      icon: we,
      type: "error",
      message: "The JSON document is larger than ".concat(Pj(Sr, 1024), ", ") + "and may crash your browser when loading it in text mode. Actual size: ".concat(Pj(e[11].length, 1024), "."),
      actions: [{
        text: "Open anyway",
        title: "Open the document in text mode. This may freeze or crash your browser.",
        onClick: e[24]
      }, {
        text: "Open in tree mode",
        title: "Open the document in tree mode. Tree mode can handle large documents.",
        onClick: e[25]
      }, {
        text: "Cancel",
        title: "Cancel opening this large document.",
        onClick: e[26]
      }],
      onClose: e[5]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment), t = At(), o = Pt("div"), r = Tt(a), Ut(o, "class", "jse-contents jse-preview svelte-a0poeb");
    },
    m: function (e, a) {
      Vo(n, e, a), Rt(e, t, a), Rt(e, o, a), Ct(o, r), i = !0;
    },
    p: function (e, t) {
      var o = {};
      2048 & t[0] && (o.message = "The JSON document is larger than ".concat(Pj(Sr, 1024), ", ") + "and may crash your browser when loading it in text mode. Actual size: ".concat(Pj(e[11].length, 1024), ".")), n.$set(o), (!i || 2048 & t[0]) && a !== (a = Ea(e[11] || "", wr) + "") && Ht(r, a);
    },
    i: function (e) {
      i || (qo(n.$$.fragment, e), i = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), i = !1;
    },
    d: function (e) {
      e && (Et(t), Et(o)), Ho(n, e);
    }
  };
}
function Xj(e) {
  var n,
    t,
    o,
    r,
    i,
    a = !e[14] && e[0] && qi(e[11]),
    s = e[3] && eb(e),
    l = e[14] && nb(e),
    c = a && tb(e);
  return r = new Qf({
    props: {
      validationErrors: e[10],
      selectError: e[27]
    }
  }), {
    c: function () {
      s && s.c(), n = At(), l && l.c(), t = At(), c && c.c(), o = At(), Jo(r.$$.fragment);
    },
    m: function (e, a) {
      s && s.m(e, a), Rt(e, n, a), l && l.m(e, a), Rt(e, t, a), c && c.m(e, a), Rt(e, o, a), Vo(r, e, a), i = !0;
    },
    p: function (e, i) {
      e[3] ? s ? (s.p(e, i), 8 & i[0] && qo(s, 1)) : ((s = eb(e)).c(), qo(s, 1), s.m(n.parentNode, n)) : s && (Ro(), Po(s, 1, 1, function () {
        s = null;
      }), Eo()), e[14] ? l ? (l.p(e, i), 16384 & i[0] && qo(l, 1)) : ((l = nb(e)).c(), qo(l, 1), l.m(t.parentNode, t)) : l && (Ro(), Po(l, 1, 1, function () {
        l = null;
      }), Eo()), 18433 & i[0] && (a = !e[14] && e[0] && qi(e[11])), a ? c ? (c.p(e, i), 18433 & i[0] && qo(c, 1)) : ((c = tb(e)).c(), qo(c, 1), c.m(o.parentNode, o)) : c && (Ro(), Po(c, 1, 1, function () {
        c = null;
      }), Eo());
      var u = {};
      1024 & i[0] && (u.validationErrors = e[10]), r.$set(u);
    },
    i: function (e) {
      i || (qo(s), qo(l), qo(c), qo(r.$$.fragment, e), i = !0);
    },
    o: function (e) {
      Po(s), Po(l), Po(c), Po(r.$$.fragment, e), i = !1;
    },
    d: function (e) {
      e && (Et(n), Et(t), Et(o)), s && s.d(e), l && l.d(e), c && c.d(e), Ho(r, e);
    }
  };
}
function eb(e) {
  var n, t;
  return n = new Jj({
    props: {
      editorState: e[8]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      256 & t[0] && (o.editorState = e[8]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function nb(e) {
  var n, t;
  return n = new Nf({
    props: {
      type: "error",
      icon: we,
      message: e[14].message,
      actions: e[15],
      onClick: e[29],
      onClose: e[5]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      16384 & t[0] && (o.message = e[14].message), 32768 & t[0] && (o.actions = e[15]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function tb(e) {
  var n, t;
  return n = new Nf({
    props: {
      type: "success",
      message: "Do you want to format the JSON?",
      actions: [{
        icon: km,
        text: "Format",
        title: "Format JSON: add proper indentation and new lines (Ctrl+I)",
        onClick: e[17]
      }, {
        icon: je,
        text: "No thanks",
        title: "Close this message",
        onClick: e[54]
      }],
      onClose: e[5]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t[0] && (o.actions = [{
        icon: km,
        text: "Format",
        title: "Format JSON: add proper indentation and new lines (Ctrl+I)",
        onClick: e[17]
      }, {
        icon: je,
        text: "No thanks",
        title: "Close this message",
        onClick: e[54]
      }]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function ob(e) {
  var n,
    t,
    o,
    r,
    i,
    a = e[2] && Yj(Qj(e)),
    s = [Kj, Gj],
    l = [];
  function c(e, n) {
    return 0 === n ? function (e) {
      var n = e.slice(),
        t = n[28](n[11], n[9]);
      return n[99] = t, n;
    }(e) : e;
  }
  return o = function (e, n) {
    return e[16] ? 1 : 0;
  }(e), r = l[o] = s[o](c(e, o)), {
    c: function () {
      n = Pt("div"), a && a.c(), t = At(), r.c(), Ut(n, "class", "jse-text-mode svelte-a0poeb"), Yt(n, "no-main-menu", !e[2]);
    },
    m: function (r, s) {
      Rt(r, n, s), a && a.m(n, null), Ct(n, t), l[o].m(n, null), e[55](n), i = !0;
    },
    p: function (e, s) {
      e[2] ? a ? (a.p(Qj(e), s), 4 & s[0] && qo(a, 1)) : ((a = Yj(Qj(e))).c(), qo(a, 1), a.m(n, t)) : a && (Ro(), Po(a, 1, 1, function () {
        a = null;
      }), Eo()), r.p(c(e, o), s), (!i || 4 & s[0]) && Yt(n, "no-main-menu", !e[2]);
    },
    i: function (e) {
      i || (qo(a), qo(r), i = !0);
    },
    o: function (e) {
      Po(a), Po(r), i = !1;
    },
    d: function (t) {
      t && Et(n), a && a.d(), l[o].d(), e[55](null);
    }
  };
}
function rb(e) {
  return {
    from: e.from || 0,
    to: e.to || 0,
    message: e.message || "",
    actions: e.actions,
    severity: e.severity
  };
}
function ib(e, n, t) {
  var o,
    i,
    s,
    l,
    c,
    u,
    d = n.readOnly,
    f = n.mainMenuBar,
    v = n.statusBar,
    p = n.askToFormat,
    m = n.externalContent,
    h = n.externalSelection,
    j = n.indentation,
    b = n.tabSize,
    y = n.escapeUnicodeCharacters,
    x = n.parser,
    $ = n.validator,
    k = n.validationParser,
    C = n.onChange,
    S = n.onChangeMode,
    M = n.onSelect,
    z = n.onError,
    E = n.onFocus,
    q = n.onBlur,
    P = n.onRenderMenu,
    I = n.onSortModal,
    T = n.onTransformModal,
    A = Qo("jsoneditor:TextMode"),
    N = {
      key: "Mod-i",
      run: ae,
      shift: se,
      preventDefault: !0
    },
    B = "undefined" == typeof window;
  A("isSSR:", B);
  var F = !1,
    L = [],
    D = new ln(),
    J = new ln(),
    V = new ln(),
    W = new ln(),
    Q = new ln(),
    Y = m,
    G = Ci(Y, j, x),
    K = y;
  io(a(r().mark(function e() {
    return r().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          if (!B) {
            e.next = 2;
            break;
          }
          return e.abrupt("return");
        case 2:
          try {
            c = me({
              target: s,
              initialText: Pe(G, F) ? "" : o.escapeValue(G),
              readOnly: d,
              indentation: j
            });
          } catch (e) {
            console.error(e);
          }
        case 3:
        case "end":
          return e.stop();
      }
    }, e);
  }))), ao(function () {
    c && (A("Destroy CodeMirror editor"), c.destroy());
  });
  var Z = !1,
    X = !1,
    ee = fe(),
    te = fe();
  function oe() {
    c && (A("focus"), c.focus());
  }
  var re = !1;
  function ie(e, n) {
    A("handlePatch", e, n);
    var t = x.parse(G),
      o = R(t, e),
      r = U(t, e);
    return ye({
      text: x.stringify(o, null, j)
    }, n, !1), {
      json: o,
      previousJson: t,
      undo: r,
      redo: e
    };
  }
  function ae() {
    if (A("format"), d) return !1;
    try {
      var e = x.parse(G);
      return ye({
        text: x.stringify(e, null, j)
      }, !0, !1), !0;
    } catch (e) {
      z(e);
    }
    return !1;
  }
  function se() {
    if (A("compact"), d) return !1;
    try {
      var e = x.parse(G);
      return ye({
        text: x.stringify(e)
      }, !0, !1), !0;
    } catch (e) {
      z(e);
    }
    return !1;
  }
  function le() {
    if (A("repair"), !d) try {
      ye({
        text: _(G)
      }, !0, !1), t(52, Ie = Nr), t(14, Te = null);
    } catch (e) {
      z(e);
    }
  }
  function ue(e) {
    var n = e.id,
      t = e.rootPath,
      o = e.onTransform,
      r = e.onClose;
    try {
      var i = x.parse(G);
      re = !0, T({
        id: n || te,
        json: i,
        rootPath: t || [],
        onTransform: function (e) {
          o ? o({
            operations: e,
            json: i,
            transformedJson: R(i, e)
          }) : (A("onTransform", e), ie(e, !0));
        },
        onClose: function () {
          re = !1, oe(), r && r();
        }
      });
    } catch (e) {
      z(e);
    }
  }
  function de(e, n) {
    A("setSelection", {
      anchor: e,
      head: n
    }), c && c.dispatch(c.state.update({
      selection: {
        anchor: e,
        head: n
      },
      scrollIntoView: !0
    }));
  }
  function ve(e, n) {
    if (1 === n.state.selection.ranges.length) {
      var t = n.state.selection.ranges[0],
        o = G.slice(t.from, t.to);
      if ("{" === o || "[" === o) {
        var r = H.parse(G),
          i = Object.keys(r.pointers).find(function (e) {
            var n;
            return (null === (n = r.pointers[e].value) || void 0 === n ? void 0 : n.pos) === t.from;
          }),
          a = r.pointers[i];
        if (i && a && a.value && a.valueEnd) A("pointer found, selecting inner contents of path:", i, a), de(a.value.pos + 1, a.valueEnd.pos - 1);
      }
    }
  }
  function pe() {
    return En(Ae, {
      delay: 300
    });
  }
  function me(e) {
    var n = e.target,
      o = e.initialText,
      r = e.readOnly,
      i = e.indentation;
    A("Create CodeMirror editor", {
      readOnly: r,
      indentation: i
    });
    var a = cn.create({
      doc: o,
      selection: he(h, o) ? xe(h) : void 0,
      extensions: [dn.of([xn, N]), D.of(pe()), zn(), fn(), vn(), pn(), wn(), Tn(), mn(), gn(), cn.allowMultipleSelections.of(!0), An(), In(Nn, {
        fallback: !0
      }), Bn(), _n(), Wn(), hn(), jn(), bn(), Un(), dn.of([].concat(w(Qn), w($n), w(Dn), w(kn), w(Fn), w(Yn), w(Rn))), Hj, Kn({
        hideFirstIndent: !0
      }), yn.domEventHandlers({
        dblclick: ve
      }), yn.updateListener.of(function (e) {
        t(8, u = e.state), e.docChanged ? ze() : e.selectionSet && qe();
      }), qn(), Jn({
        top: !0
      }), yn.lineWrapping, J.of(cn.readOnly.of(r)), W.of(cn.tabSize.of(b)), V.of(Se(i)), Q.of(yn.theme({}, {
        dark: ge()
      }))]
    });
    return c = new yn({
      state: a,
      parent: n
    });
  }
  function ge() {
    return !!s && getComputedStyle(s).getPropertyValue("--jse-theme").includes("dark");
  }
  function he(e, n) {
    return !!Hs(e) && e.ranges.every(function (e) {
      return e.anchor < n.length && e.head < n.length;
    });
  }
  function je(e) {
    var n = e.path,
      t = e.message,
      r = e.severity,
      i = function (e, n) {
        try {
          var t = H.parse(e),
            o = O(n),
            r = t.pointers[o];
          if (r) return {
            path: n,
            line: r.key ? r.key.line : r.value ? r.value.line : 0,
            column: r.key ? r.key.column : r.value ? r.value.column : 0,
            from: r.key ? r.key.pos : r.value ? r.value.pos : 0,
            to: r.keyEnd ? r.keyEnd.pos : r.valueEnd ? r.valueEnd.pos : 0
          };
        } catch (e) {
          console.error(e);
        }
        return {
          path: n,
          line: 0,
          column: 0,
          from: 0,
          to: 0
        };
      }(o.escapeValue(G), n);
    return {
      path: n,
      line: i.line,
      column: i.column,
      from: i.from,
      to: i.to,
      message: t,
      severity: r,
      actions: []
    };
  }
  function be(e, n) {
    var t = e.line,
      o = e.column,
      r = e.position,
      i = e.message;
    return {
      path: [],
      line: t,
      column: o,
      from: r,
      to: r,
      severity: ur.error,
      message: i,
      actions: n && !d ? [{
        name: "Auto repair",
        apply: function () {
          return le();
        }
      }] : null
    };
  }
  function ye(e, n, r) {
    var i = Ci(e, j, x),
      a = !ne(e, Y),
      s = Y;
    A("setCodeMirrorContent", {
      isChanged: a,
      emitChange: n,
      forceUpdate: r
    }), c && (a || r) && (Y = e, t(11, G = i), Pe(G, F) || c.dispatch({
      changes: {
        from: 0,
        to: c.state.doc.length,
        insert: o.escapeValue(G)
      }
    }), Oe(), a && n && Ee(Y, s));
  }
  function xe(e) {
    return Hs(e) ? un.fromJSON(e) : void 0;
  }
  function we() {
    return (we = a(r().mark(function e() {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return A("refresh"), e.next = 3, ke();
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function $e() {
    if (c) {
      var e = c ? o.unescapeValue(c.state.doc.toString()) : "",
        n = e !== G;
      if (A("onChangeCodeMirrorValue", {
        isChanged: n
      }), n) {
        var r = Y;
        t(11, G = e), Y = {
          text: G
        }, Oe(), Ee(Y, r), bo().then(qe);
      }
    }
  }
  function ke() {
    return Ce.apply(this, arguments);
  }
  function Ce() {
    return (Ce = a(r().mark(function e() {
      var n;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, bo();
          case 2:
            c && (n = ge(), A("updateTheme", {
              dark: n
            }), c.dispatch({
              effects: [Q.reconfigure(yn.theme({}, {
                dark: n
              }))]
            }));
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function Se(e) {
    var n = Ln.of("number" == typeof e ? " ".repeat(e) : e);
    return "\t" === e ? [n] : [n, Zn];
  }
  function Oe() {
    t(12, Z = Mn(c.state) > 0), t(13, X = On(c.state) > 0), A({
      canUndo: Z,
      canRedo: X
    });
  }
  ao(function () {
    Re();
  }), zf({
    onMount: io,
    onDestroy: ao,
    getWindow: function () {
      return Zi(l);
    },
    hasFocus: function () {
      return re && document.hasFocus() || Xi(l);
    },
    onFocus: E,
    onBlur: function () {
      Re(), q();
    }
  });
  var ze = ce($e, 300);
  function Re() {
    ze.flush();
  }
  function Ee(e, n) {
    C && C(e, n, {
      contentErrors: Ne(),
      patchResult: null
    });
  }
  function qe() {
    M(g({
      type: lr.text
    }, u.selection.toJSON()));
  }
  function Pe(e, n) {
    return !!e && e.length > Sr && !n;
  }
  var Ie = Nr,
    Te = null;
  function Ae() {
    if (Pe(G, F)) return [];
    var e = Ne();
    return cv(e) ? [rb(be(e.parseError, e.isRepairable))] : uv(e) ? e.validationErrors.map(je).map(rb) : [];
  }
  function Ne() {
    A("validate:start"), Re();
    var e = Be(o.escapeValue(G), $, x, k);
    return cv(e) ? (t(52, Ie = e.isRepairable ? Br : "invalid"), t(14, Te = e.parseError), t(10, L = [])) : (t(52, Ie = Nr), t(14, Te = null), t(10, L = (null == e ? void 0 : e.validationErrors) || [])), A("validate:end"), e;
  }
  var Be = sn(Mf);
  function Fe() {
    Te && function (e) {
      A("select parse error", e);
      var n = be(e, !1);
      de(null != n.from ? n.from : 0, null != n.to ? n.to : 0), oe();
    }(Te);
  }
  var Le = {
    icon: nn,
    text: "Show me",
    title: "Move to the parse error location",
    onClick: Fe
  };
  return e.$$set = function (e) {
    "readOnly" in e && t(1, d = e.readOnly), "mainMenuBar" in e && t(2, f = e.mainMenuBar), "statusBar" in e && t(3, v = e.statusBar), "askToFormat" in e && t(0, p = e.askToFormat), "externalContent" in e && t(30, m = e.externalContent), "externalSelection" in e && t(31, h = e.externalSelection), "indentation" in e && t(32, j = e.indentation), "tabSize" in e && t(33, b = e.tabSize), "escapeUnicodeCharacters" in e && t(34, y = e.escapeUnicodeCharacters), "parser" in e && t(35, x = e.parser), "validator" in e && t(36, $ = e.validator), "validationParser" in e && t(37, k = e.validationParser), "onChange" in e && t(38, C = e.onChange), "onChangeMode" in e && t(39, S = e.onChangeMode), "onSelect" in e && t(40, M = e.onSelect), "onError" in e && t(41, z = e.onError), "onFocus" in e && t(42, E = e.onFocus), "onBlur" in e && t(43, q = e.onBlur), "onRenderMenu" in e && t(4, P = e.onRenderMenu), "onSortModal" in e && t(44, I = e.onSortModal), "onTransformModal" in e && t(45, T = e.onTransformModal);
  }, e.$$.update = function () {
    8 & e.$$.dirty[1] && (o = Ii({
      escapeControlCharacters: !1,
      escapeUnicodeCharacters: y
    })), 1073741824 & e.$$.dirty[0] && ye(m, !1, !1), 1 & e.$$.dirty[1] && function (e) {
      if (Hs(e)) {
        var n = xe(e);
        !c || !n || u && u.selection.eq(n) || (A("applyExternalSelection", n), c.dispatch({
          selection: n
        }));
      }
    }(h), 32 & e.$$.dirty[1] && function (e) {
      A("updateLinter", e), c && c.dispatch({
        effects: D.reconfigure(pe())
      });
    }($), 2 & e.$$.dirty[1] && function (e) {
      c && (A("updateIndentation", e), c.dispatch({
        effects: V.reconfigure(Se(e))
      }));
    }(j), 4 & e.$$.dirty[1] && function (e) {
      c && (A("updateTabSize", e), c.dispatch({
        effects: W.reconfigure(cn.tabSize.of(e))
      }));
    }(b), 2 & e.$$.dirty[0] && function (e) {
      c && (A("updateReadOnly", e), c.dispatch({
        effects: [J.reconfigure(cn.readOnly.of(e))]
      }));
    }(d), 1048584 & e.$$.dirty[1] && K !== y && (t(51, K = y), A("forceUpdateText", {
      escapeUnicodeCharacters: y
    }), c && c.dispatch({
      changes: {
        from: 0,
        to: c.state.doc.length,
        insert: o.escapeValue(G)
      }
    })), 2 & e.$$.dirty[0] | 2097152 & e.$$.dirty[1] && t(15, i = Ie !== Br || d ? [Le] : [{
      icon: Me,
      text: "Auto repair",
      title: "Automatically repair JSON",
      onClick: le
    }, Le]);
  }, [p, d, f, v, P, oe, s, l, u, F, L, G, Z, X, Te, i, B, ae, se, function () {
    var e;
    if (!d) try {
      var n = x.parse(G);
      re = !0, I({
        id: ee,
        json: n,
        rootPath: [],
        onSort: (e = a(r().mark(function e(n) {
          var t;
          return r().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                t = n.operations, A("onSort", t), ie(t, !0);
              case 3:
              case "end":
                return e.stop();
            }
          }, e);
        })), function (n) {
          return e.apply(this, arguments);
        }),
        onClose: function () {
          re = !1, oe();
        }
      });
    } catch (e) {
      z(e);
    }
  }, function () {
    d || ue({
      rootPath: []
    });
  }, function () {
    c && (s && s.querySelector(".cm-search") ? Hn(c) : Vn(c));
  }, function () {
    d || c && (Cn(c), oe());
  }, function () {
    d || c && (Sn(c), oe());
  }, function () {
    t(9, F = !0), ye(m, !0, !0);
  }, function () {
    S(sr.tree);
  }, function () {
    $e();
  }, function (e) {
    A("select validation error", e);
    var n = je(e),
      t = n.from,
      o = n.to;
    null !== t && null !== o && (de(t, o), oe());
  }, Pe, Fe, m, h, j, b, y, x, $, k, C, S, M, z, E, q, I, T, function (e) {
    return ie(e, !1);
  }, ie, ue, function () {
    return we.apply(this, arguments);
  }, Ne, K, Ie, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(6, s = e);
    });
  }, function () {
    return t(0, p = !1);
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(7, l = e);
    });
  }];
}
Vj.style = function (e) {
  return _j(e || []);
};
var ab = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, ib, ob, ct, {
      readOnly: 1,
      mainMenuBar: 2,
      statusBar: 3,
      askToFormat: 0,
      externalContent: 30,
      externalSelection: 31,
      indentation: 32,
      tabSize: 33,
      escapeUnicodeCharacters: 34,
      parser: 35,
      validator: 36,
      validationParser: 37,
      onChange: 38,
      onChangeMode: 39,
      onSelect: 40,
      onError: 41,
      onFocus: 42,
      onBlur: 43,
      onRenderMenu: 4,
      onSortModal: 44,
      onTransformModal: 45,
      focus: 5,
      patch: 46,
      handlePatch: 47,
      openTransformModal: 48,
      refresh: 49,
      validate: 50
    }, Wj, [-1, -1, -1, -1]), t;
  }
  return v(n, Wo), b(n, [{
    key: "focus",
    get: function () {
      return this.$$.ctx[5];
    }
  }, {
    key: "patch",
    get: function () {
      return this.$$.ctx[46];
    }
  }, {
    key: "handlePatch",
    get: function () {
      return this.$$.ctx[47];
    }
  }, {
    key: "openTransformModal",
    get: function () {
      return this.$$.ctx[48];
    }
  }, {
    key: "refresh",
    get: function () {
      return this.$$.ctx[49];
    }
  }, {
    key: "validate",
    get: function () {
      return this.$$.ctx[50];
    }
  }]);
}();
function sb(e) {
  var n, t;
  return n = new Ev({
    props: {
      items: e[0]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & s(t, 1)[0] && (o.items = e[0]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function lb(e, n, t) {
  var o,
    r,
    i = n.containsValidArray,
    a = n.readOnly,
    s = n.showSearch,
    l = void 0 !== s && s,
    c = n.historyState,
    u = n.onSort,
    d = n.onTransform,
    f = n.onContextMenu,
    v = n.onUndo,
    p = n.onRedo,
    m = n.onRenderMenu;
  function g() {
    t(1, l = !l);
  }
  return e.$$set = function (e) {
    "containsValidArray" in e && t(2, i = e.containsValidArray), "readOnly" in e && t(3, a = e.readOnly), "showSearch" in e && t(1, l = e.showSearch), "historyState" in e && t(4, c = e.historyState), "onSort" in e && t(5, u = e.onSort), "onTransform" in e && t(6, d = e.onTransform), "onContextMenu" in e && t(7, f = e.onContextMenu), "onUndo" in e && t(8, v = e.onUndo), "onRedo" in e && t(9, p = e.onRedo), "onRenderMenu" in e && t(10, m = e.onRenderMenu);
  }, e.$$.update = function () {
    1020 & e.$$.dirty && t(11, o = a ? [{
      type: "space"
    }] : [{
      type: "button",
      icon: Ee,
      title: "Sort",
      className: "jse-sort",
      onClick: u,
      disabled: a || !i
    }, {
      type: "button",
      icon: qe,
      title: "Transform contents (filter, sort, project)",
      className: "jse-transform",
      onClick: d,
      disabled: a || !i
    }, {
      type: "button",
      icon: Re,
      title: "Search (Ctrl+F)",
      className: "jse-search",
      onClick: g,
      disabled: !i
    }, {
      type: "button",
      icon: Pe,
      title: Pr,
      className: "jse-contextmenu",
      onClick: f
    }, {
      type: "separator"
    }, {
      type: "button",
      icon: Ie,
      title: "Undo (Ctrl+Z)",
      className: "jse-undo",
      onClick: v,
      disabled: !c.canUndo
    }, {
      type: "button",
      icon: Te,
      title: "Redo (Ctrl+Shift+Z)",
      className: "jse-redo",
      onClick: p,
      disabled: !c.canRedo
    }, {
      type: "space"
    }]), 3072 & e.$$.dirty && t(0, r = m(o));
  }, [r, l, i, a, c, u, d, f, v, p, m, o];
}
var cb = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, lb, sb, ct, {
      containsValidArray: 2,
      readOnly: 3,
      showSearch: 1,
      historyState: 4,
      onSort: 5,
      onTransform: 6,
      onContextMenu: 7,
      onUndo: 8,
      onRedo: 9,
      onRenderMenu: 10
    }), t;
  }
  return v(n, Wo), b(n);
}();
function ub(e, n, t) {
  var o = e.slice();
  return o[9] = n[t], o;
}
function db(e) {
  var n,
    t,
    o = e[9].component,
    r = vb(e);
  return {
    c: function () {
      r.c(), n = Nt();
    },
    m: function (e, o) {
      r.m(e, o), Rt(e, n, o), t = !0;
    },
    p: function (e, t) {
      1 & t && ct(o, o = e[9].component) ? (Ro(), Po(r, 1, 1, nt), Eo(), (r = vb(e)).c(), qo(r, 1), r.m(n.parentNode, n)) : r.p(e, t);
    },
    i: function (e) {
      t || (qo(r), t = !0);
    },
    o: function (e) {
      Po(r), t = !1;
    },
    d: function (e) {
      e && Et(n), r.d(e);
    }
  };
}
function fb(e) {
  var n,
    t = e[9].action,
    o = pb(e);
  return {
    c: function () {
      o.c(), n = Nt();
    },
    m: function (e, t) {
      o.m(e, t), Rt(e, n, t);
    },
    p: function (e, r) {
      1 & r && ct(t, t = e[9].action) ? (o.d(1), (o = pb(e)).c(), o.m(n.parentNode, n)) : o.p(e, r);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n), o.d(e);
    }
  };
}
function vb(e) {
  var n,
    t,
    o,
    r = [e[9].props],
    i = e[9].component;
  function a(e, n) {
    for (var t = {}, o = 0; o < r.length; o += 1) t = ot(t, r[o]);
    return void 0 !== n && 1 & n && (t = ot(t, Lo(r, [Uo(e[9].props)]))), {
      props: t
    };
  }
  return i && (n = Kt(i, a(e))), {
    c: function () {
      n && Jo(n.$$.fragment), t = Nt();
    },
    m: function (e, r) {
      n && Vo(n, e, r), Rt(e, t, r), o = !0;
    },
    p: function (e, o) {
      if (1 & o && i !== (i = e[9].component)) {
        if (n) {
          Ro();
          var s = n;
          Po(s.$$.fragment, 1, 0, function () {
            Ho(s, 1);
          }), Eo();
        }
        i ? (Jo((n = Kt(i, a(e, o))).$$.fragment), qo(n.$$.fragment, 1), Vo(n, t.parentNode, t)) : n = null;
      } else if (i) {
        var l = 1 & o ? Lo(r, [Uo(e[9].props)]) : {};
        n.$set(l);
      }
    },
    i: function (e) {
      o || (n && qo(n.$$.fragment, e), o = !0);
    },
    o: function (e) {
      n && Po(n.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(t), n && Ho(n, e);
    }
  };
}
function pb(e) {
  var n, t, o, r;
  return {
    c: function () {
      Ut(n = Pt("div"), "role", "button"), Ut(n, "tabindex", "-1"), Ut(n, "class", "jse-value"), Ut(n, "data-type", "selectable-value");
    },
    m: function (i, a) {
      Rt(i, n, a), o || (r = jt(t = e[12].call(null, n, e[9].props)), o = !0);
    },
    p: function (n, o) {
      e = n, t && st(t.update) && 1 & o && t.update.call(null, e[9].props);
    },
    d: function (e) {
      e && Et(n), o = !1, r();
    }
  };
}
function mb(e) {
  var n,
    t,
    o,
    r,
    i,
    a = [fb, db],
    s = [];
  function l(e, t) {
    return 1 & t && (n = null), null == n && (n = !!pv(e[9])), n ? 0 : 1;
  }
  function c(e, n) {
    return 0 === n ? function (e) {
      var n = e.slice(),
        t = n[9].action;
      return n[12] = t, n;
    }(e) : e;
  }
  return t = l(e, -1), o = s[t] = a[t](c(e, t)), {
    c: function () {
      o.c(), r = Nt();
    },
    m: function (e, n) {
      s[t].m(e, n), Rt(e, r, n), i = !0;
    },
    p: function (e, n) {
      var i = t;
      (t = l(e, n)) === i ? s[t].p(c(e, t), n) : (Ro(), Po(s[i], 1, 1, function () {
        s[i] = null;
      }), Eo(), (o = s[t]) ? o.p(c(e, t), n) : (o = s[t] = a[t](c(e, t))).c(), qo(o, 1), o.m(r.parentNode, r));
    },
    i: function (e) {
      i || (qo(o), i = !0);
    },
    o: function (e) {
      Po(o), i = !1;
    },
    d: function (e) {
      e && Et(r), s[t].d(e);
    }
  };
}
function gb(e) {
  for (var n, t, o = Ao(e[0]), r = [], i = 0; i < o.length; i += 1) r[i] = mb(ub(e, o, i));
  var a = function (e) {
    return Po(r[e], 1, 1, function () {
      r[e] = null;
    });
  };
  return {
    c: function () {
      for (var e = 0; e < r.length; e += 1) r[e].c();
      n = Nt();
    },
    m: function (e, o) {
      for (var i = 0; i < r.length; i += 1) r[i] && r[i].m(e, o);
      Rt(e, n, o), t = !0;
    },
    p: function (e, t) {
      var i = s(t, 1)[0];
      if (1 & i) {
        var l;
        for (o = Ao(e[0]), l = 0; l < o.length; l += 1) {
          var c = ub(e, o, l);
          r[l] ? (r[l].p(c, i), qo(r[l], 1)) : (r[l] = mb(c), r[l].c(), qo(r[l], 1), r[l].m(n.parentNode, n));
        }
        for (Ro(), l = o.length; l < r.length; l += 1) a(l);
        Eo();
      }
    },
    i: function (e) {
      if (!t) {
        for (var n = 0; n < o.length; n += 1) qo(r[n]);
        t = !0;
      }
    },
    o: function (e) {
      r = r.filter(Boolean);
      for (var n = 0; n < r.length; n += 1) Po(r[n]);
      t = !1;
    },
    d: function (e) {
      e && Et(n), qt(r, e);
    }
  };
}
function hb(e, n, t) {
  var o,
    r,
    i = n.path,
    a = n.value,
    s = n.context,
    l = n.enforceString,
    c = n.selection,
    u = n.searchResultItems;
  function d(e, n) {
    return s.onPatch(function (e, n) {
      return e.flatMap(function (e) {
        if (P(e)) {
          var t = M(e.path);
          if (t.length > 0) {
            for (var o = [e], r = X(t); r.length > 0 && !L(n, r);) o.unshift({
              op: "add",
              path: O(r),
              value: {}
            }), r = X(r);
            return o;
          }
        }
        return e;
      });
    }(e, s.getJson()), n);
  }
  return e.$$set = function (e) {
    "path" in e && t(1, i = e.path), "value" in e && t(2, a = e.value), "context" in e && t(3, s = e.context), "enforceString" in e && t(4, l = e.enforceString), "selection" in e && t(5, c = e.selection), "searchResultItems" in e && t(6, u = e.searchResultItems);
  }, e.$$.update = function () {
    40 & e.$$.dirty && t(7, o = !s.readOnly && Us(c) && dl(c)), 254 & e.$$.dirty && t(0, r = s.onRenderValue({
      path: i,
      value: a,
      readOnly: s.readOnly,
      enforceString: l,
      isEditing: o,
      parser: s.parser,
      normalization: s.normalization,
      selection: c,
      searchResultItems: u,
      onPatch: d,
      onPasteJson: s.onPasteJson,
      onSelect: s.onSelect,
      onFind: s.onFind,
      findNextInside: s.findNextInside,
      focus: s.focus
    }));
  }, [r, i, a, s, l, c, u, o];
}
var jb = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, hb, gb, ct, {
      path: 1,
      value: 2,
      context: 3,
      enforceString: 4,
      selection: 5,
      searchResultItems: 6
    }), t;
  }
  return v(n, Wo), b(n);
}();
function bb(e) {
  St(e, "svelte-1dhomzn", '.jse-inline-value.svelte-1dhomzn{font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);line-height:var(--jse-line-height, calc(1em + 4px));border:none;padding:0 calc(0.5 * var(--jse-padding, 10px));background:transparent;color:inherit;cursor:pointer}.jse-inline-value.svelte-1dhomzn:hover{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06))}.jse-inline-value.jse-selected.svelte-1dhomzn{background:var(--jse-selection-background-color, #d3d3d3)}.jse-inline-value.jse-highlight.svelte-1dhomzn{background-color:var(--jse-search-match-color, #ffe665);outline:var(--jse-search-match-outline, 1px solid #ffd700)}.jse-inline-value.jse-highlight.jse-active.svelte-1dhomzn{background-color:var(--jse-search-match-active-color, #ffd700);outline:var(--jse-search-match-active-outline, 1px solid #e1be00)}');
}
function yb(e) {
  var n,
    t,
    o,
    r,
    i,
    a = Ea(null !== (n = e[2].stringify(e[1])) && void 0 !== n ? n : "", 50) + "";
  return {
    c: function () {
      t = Pt("button"), o = Tt(a), Ut(t, "type", "button"), Ut(t, "class", "jse-inline-value svelte-1dhomzn"), Yt(t, "jse-selected", e[3]), Yt(t, "jse-highlight", e[4]), Yt(t, "jse-active", e[5]);
    },
    m: function (n, a) {
      Rt(n, t, a), Ct(t, o), r || (i = Bt(t, "dblclick", e[7]), r = !0);
    },
    p: function (e, n) {
      var r,
        i = s(n, 1)[0];
      6 & i && a !== (a = Ea(null !== (r = e[2].stringify(e[1])) && void 0 !== r ? r : "", 50) + "") && Ht(o, a), 8 & i && Yt(t, "jse-selected", e[3]), 16 & i && Yt(t, "jse-highlight", e[4]), 32 & i && Yt(t, "jse-active", e[5]);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(t), r = !1, i();
    }
  };
}
function xb(e, n, t) {
  var o = n.path,
    r = n.value,
    i = n.parser,
    a = n.isSelected,
    s = n.containsSearchResult,
    l = n.containsActiveSearchResult,
    c = n.onEdit;
  return e.$$set = function (e) {
    "path" in e && t(0, o = e.path), "value" in e && t(1, r = e.value), "parser" in e && t(2, i = e.parser), "isSelected" in e && t(3, a = e.isSelected), "containsSearchResult" in e && t(4, s = e.containsSearchResult), "containsActiveSearchResult" in e && t(5, l = e.containsActiveSearchResult), "onEdit" in e && t(6, c = e.onEdit);
  }, [o, r, i, a, s, l, c, function () {
    return c(o);
  }];
}
var wb = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, xb, yb, ct, {
      path: 0,
      value: 1,
      parser: 2,
      isSelected: 3,
      containsSearchResult: 4,
      containsActiveSearchResult: 5,
      onEdit: 6
    }, bb), t;
  }
  return v(n, Wo), b(n);
}();
function $b(e) {
  St(e, "svelte-2v0aqj", ".jse-column-header.svelte-2v0aqj.svelte-2v0aqj{background:none;border:none;font-family:inherit;font-size:inherit;color:inherit;display:flex;gap:var(--jse-padding, 10px);padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px)) calc(0.5 * var(--jse-padding, 10px));width:100%}.jse-column-header.svelte-2v0aqj.svelte-2v0aqj:hover{background:var(--jse-table-header-background-highlight, #e8e8e8)}.jse-column-header.svelte-2v0aqj.svelte-2v0aqj:not(.jse-column-header.jse-readonly){cursor:pointer}.jse-column-header.svelte-2v0aqj span.jse-column-sort-icon.svelte-2v0aqj{height:1em}");
}
function kb(e) {
  var n, t, o, r;
  return t = new Ya({
    props: {
      data: e[1] === fr.asc ? Oe : tn
    }
  }), {
    c: function () {
      n = Pt("span"), Jo(t.$$.fragment), Ut(n, "class", "jse-column-sort-icon svelte-2v0aqj"), Ut(n, "title", o = "Currently sorted in ".concat(e[2], " order"));
    },
    m: function (e, o) {
      Rt(e, n, o), Vo(t, n, null), r = !0;
    },
    p: function (e, i) {
      var a = {};
      2 & i && (a.data = e[1] === fr.asc ? Oe : tn), t.$set(a), (!r || 4 & i && o !== (o = "Currently sorted in ".concat(e[2], " order"))) && Ut(n, "title", o);
    },
    i: function (e) {
      r || (qo(t.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function Cb(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    l,
    c,
    u = Ea(e[3], 50) + "",
    d = void 0 !== e[1] && kb(e);
  return {
    c: function () {
      n = Pt("button"), t = Pt("span"), o = Tt(u), r = At(), d && d.c(), Ut(t, "class", "jse-column-name"), Ut(n, "type", "button"), Ut(n, "class", "jse-column-header svelte-2v0aqj"), Ut(n, "title", i = e[0] ? e[3] : e[3] + " (Click to sort the data by this column)"), Yt(n, "jse-readonly", e[0]);
    },
    m: function (i, s) {
      Rt(i, n, s), Ct(n, t), Ct(t, o), Ct(n, r), d && d.m(n, null), a = !0, l || (c = Bt(n, "click", e[4]), l = !0);
    },
    p: function (e, t) {
      var r = s(t, 1)[0];
      (!a || 8 & r) && u !== (u = Ea(e[3], 50) + "") && Ht(o, u), void 0 !== e[1] ? d ? (d.p(e, r), 2 & r && qo(d, 1)) : ((d = kb(e)).c(), qo(d, 1), d.m(n, null)) : d && (Ro(), Po(d, 1, 1, function () {
        d = null;
      }), Eo()), (!a || 9 & r && i !== (i = e[0] ? e[3] : e[3] + " (Click to sort the data by this column)")) && Ut(n, "title", i), (!a || 1 & r) && Yt(n, "jse-readonly", e[0]);
    },
    i: function (e) {
      a || (qo(d), a = !0);
    },
    o: function (e) {
      Po(d), a = !1;
    },
    d: function (e) {
      e && Et(n), d && d.d(), l = !1, c();
    }
  };
}
function Sb(e, n, t) {
  var o,
    r,
    i,
    a = n.path,
    s = n.sortedColumn,
    l = n.readOnly,
    c = n.onSort;
  return e.$$set = function (e) {
    "path" in e && t(5, a = e.path), "sortedColumn" in e && t(6, s = e.sortedColumn), "readOnly" in e && t(0, l = e.readOnly), "onSort" in e && t(7, c = e.onSort);
  }, e.$$.update = function () {
    var n;
    (32 & e.$$.dirty && t(3, o = G(a) ? "values" : $a(a)), 96 & e.$$.dirty) && t(1, r = s && ne(a, null === (n = s) || void 0 === n ? void 0 : n.path) ? s.sortDirection : void 0);
    2 & e.$$.dirty && t(2, i = r ? Dr[r] : void 0);
  }, [l, r, i, o, function () {
    l || c({
      path: a,
      sortDirection: r === fr.asc ? fr.desc : fr.asc
    });
  }, a, s, c];
}
var Mb,
  Ob,
  zb = function (e) {
    function n(e) {
      var t;
      return h(this, n), _o(t = u(this, n), e, Sb, Cb, ct, {
        path: 5,
        sortedColumn: 6,
        readOnly: 0,
        onSort: 7
      }, $b), t;
    }
    return v(n, Wo), b(n);
  }();
function Rb(e, n) {
  return Mb || (Ob = new WeakMap(), Mb = new ResizeObserver(function (e) {
    var n,
      t = o(e);
    try {
      for (t.s(); !(n = t.n()).done;) {
        var r = n.value,
          i = Ob.get(r.target);
        i && i(r.target);
      }
    } catch (e) {
      t.e(e);
    } finally {
      t.f();
    }
  })), Ob.set(e, n), Mb.observe(e), {
    destroy: function () {
      Ob.delete(e), Mb.unobserve(e);
    }
  };
}
function Eb(e) {
  St(e, "svelte-fxr3ye", '.jse-table-mode-welcome.svelte-fxr3ye.svelte-fxr3ye{flex:1;display:flex;flex-direction:column;overflow:auto;align-items:center;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode-welcome.svelte-fxr3ye.svelte-fxr3ye:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode-welcome.svelte-fxr3ye .jse-space.jse-before.svelte-fxr3ye{flex:1}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays.svelte-fxr3ye{display:flex;flex-direction:column;gap:var(--jse-padding, 10px);max-width:300px;margin:2em var(--jse-padding, 10px);font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays .jse-nested-arrays-info.svelte-fxr3ye{color:var(--jse-panel-color-readonly, #b2b2b2)}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action.svelte-fxr3ye{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px;text-align:left}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action.svelte-fxr3ye:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action.svelte-fxr3ye:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.jse-table-mode-welcome.svelte-fxr3ye .jse-nested-arrays button.jse-nested-array-action .jse-nested-array-count.svelte-fxr3ye{opacity:0.5;white-space:nowrap}.jse-table-mode-welcome.svelte-fxr3ye .jse-space.jse-after.svelte-fxr3ye{flex:2}');
}
function qb(e, n, t) {
  var o = e.slice();
  o[16] = n[t];
  var r = o[9](o[16]);
  return o[17] = r, o;
}
function Pb(e) {
  var n, t;
  return {
    c: function () {
      n = Tt(e[7]), t = Tt(" cannot be opened in table mode.");
    },
    m: function (e, o) {
      Rt(e, n, o), Rt(e, t, o);
    },
    p: function (e, t) {
      128 & t && Ht(n, e[7]);
    },
    d: function (e) {
      e && (Et(n), Et(t));
    }
  };
}
function Ib(e) {
  var n;
  return {
    c: function () {
      n = Tt("An object cannot be opened in table mode. You can open a nested array instead, or open the\n        document in tree mode.");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Tb(e) {
  var n;
  return {
    c: function () {
      n = Tt("You can open the document in tree mode instead.");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Ab(e) {
  var n, t, o;
  return {
    c: function () {
      n = Tt("You can open the document in tree mode instead, or paste a JSON Array using "), (t = Pt("b")).textContent = "Ctrl+V", o = Tt(".");
    },
    m: function (e, r) {
      Rt(e, n, r), Rt(e, t, r), Rt(e, o, r);
    },
    d: function (e) {
      e && (Et(n), Et(t), Et(o));
    }
  };
}
function Nb(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f,
    v,
    p = $a(e[16]) + "",
    m = e[17] + "",
    g = 1 !== e[17] ? "items" : "item";
  function h() {
    return e[13](e[16]);
  }
  return {
    c: function () {
      n = Pt("button"), t = Tt(e[8]), o = Tt(' "'), r = Tt(p), i = Tt('"\n        '), a = Pt("span"), s = Tt("("), l = Tt(m), c = At(), u = Tt(g), d = Tt(")"), Ut(a, "class", "jse-nested-array-count svelte-fxr3ye"), Ut(n, "type", "button"), Ut(n, "class", "jse-nested-array-action svelte-fxr3ye");
    },
    m: function (e, p) {
      Rt(e, n, p), Ct(n, t), Ct(n, o), Ct(n, r), Ct(n, i), Ct(n, a), Ct(a, s), Ct(a, l), Ct(a, c), Ct(a, u), Ct(a, d), f || (v = Bt(n, "click", h), f = !0);
    },
    p: function (n, o) {
      e = n, 256 & o && Ht(t, e[8]), 16 & o && p !== (p = $a(e[16]) + "") && Ht(r, p), 16 & o && m !== (m = e[17] + "") && Ht(l, m), 16 & o && g !== (g = 1 !== e[17] ? "items" : "item") && Ht(u, g);
    },
    d: function (e) {
      e && Et(n), f = !1, v();
    }
  };
}
function Bb(e) {
  var n, t, o, r, i, a, l, c, u, d, f, v, p, m, g, h, j, b;
  function y(e, n) {
    return e[6] ? Ib : Pb;
  }
  var x = y(e),
    w = x(e);
  function $(e, n) {
    return e[5] && !e[0] ? Ab : Tb;
  }
  for (var k = $(e), C = k(e), S = Ao(e[4]), M = [], O = 0; O < S.length; O += 1) M[O] = Nb(qb(e, S, O));
  return {
    c: function () {
      n = Pt("div"), t = Pt("div"), o = At(), r = Pt("div"), i = Pt("div"), a = Tt(e[7]), l = At(), c = Pt("div"), w.c(), u = At(), C.c(), d = At();
      for (var s = 0; s < M.length; s += 1) M[s].c();
      f = At(), v = Pt("button"), p = Tt(e[8]), m = Tt(" in tree mode"), g = At(), h = Pt("div"), Ut(t, "class", "jse-space jse-before svelte-fxr3ye"), Ut(i, "class", "jse-nested-arrays-title"), Ut(c, "class", "jse-nested-arrays-info svelte-fxr3ye"), Ut(v, "type", "button"), Ut(v, "class", "jse-nested-array-action svelte-fxr3ye"), Ut(r, "class", "jse-nested-arrays svelte-fxr3ye"), Ut(h, "class", "jse-space jse-after svelte-fxr3ye"), Ut(n, "class", "jse-table-mode-welcome svelte-fxr3ye"), Ut(n, "role", "none");
    },
    m: function (s, y) {
      Rt(s, n, y), Ct(n, t), Ct(n, o), Ct(n, r), Ct(r, i), Ct(i, a), Ct(r, l), Ct(r, c), w.m(c, null), Ct(c, u), C.m(c, null), Ct(r, d);
      for (var x = 0; x < M.length; x += 1) M[x] && M[x].m(r, null);
      Ct(r, f), Ct(r, v), Ct(v, p), Ct(v, m), Ct(n, g), Ct(n, h), j || (b = [Bt(v, "click", e[14]), Bt(n, "click", e[15])], j = !0);
    },
    p: function (e, n) {
      var t = s(n, 1)[0];
      if (128 & t && Ht(a, e[7]), x === (x = y(e)) && w ? w.p(e, t) : (w.d(1), (w = x(e)) && (w.c(), w.m(c, u))), k !== (k = $(e)) && (C.d(1), (C = k(e)) && (C.c(), C.m(c, null))), 786 & t) {
        var o;
        for (S = Ao(e[4]), o = 0; o < S.length; o += 1) {
          var i = qb(e, S, o);
          M[o] ? M[o].p(i, t) : (M[o] = Nb(i), M[o].c(), M[o].m(r, f));
        }
        for (; o < M.length; o += 1) M[o].d(1);
        M.length = S.length;
      }
      256 & t && Ht(p, e[8]);
    },
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n), w.d(), C.d(), qt(M, e), j = !1, at(b);
    }
  };
}
function Fb(e, n, t) {
  var o,
    r,
    i,
    a,
    s,
    l = n.text,
    c = n.json,
    u = n.readOnly,
    d = n.parser,
    f = n.openJSONEditorModal,
    v = n.onChangeMode,
    p = n.onClick;
  return e.$$set = function (e) {
    "text" in e && t(10, l = e.text), "json" in e && t(11, c = e.json), "readOnly" in e && t(0, u = e.readOnly), "parser" in e && t(12, d = e.parser), "openJSONEditorModal" in e && t(1, f = e.openJSONEditorModal), "onChangeMode" in e && t(2, v = e.onChangeMode), "onClick" in e && t(3, p = e.onClick);
  }, e.$$.update = function () {
    1 & e.$$.dirty && t(8, o = u ? "View" : "Edit"), 2048 & e.$$.dirty && t(4, s = c ? function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
        t = [];
      return function e(o, r) {
        B(o) && r.length < n && Object.keys(o).forEach(function (n) {
          e(o[n], r.concat(n));
        }), N(o) && t.push(r);
      }(e, []), t;
    }(c).slice(0, 99).filter(function (e) {
      return e.length > 0;
    }) : []), 16 & e.$$.dirty && t(6, r = !G(s)), 3072 & e.$$.dirty && t(5, i = void 0 === c && ("" === l || void 0 === l)), 6240 & e.$$.dirty && t(7, a = r ? "Object with nested arrays" : i ? "An empty document" : B(c) ? "An object" : N(c) ? "An empty array" : "A ".concat(Xr(c, d)));
  }, [u, f, v, p, s, i, r, a, o, function (e) {
    return z(c, e).length;
  }, l, c, d, function (e) {
    return f(e);
  }, function () {
    return v(sr.tree);
  }, function () {
    return p();
  }];
}
var Lb = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Fb, Bb, ct, {
      text: 10,
      json: 11,
      readOnly: 0,
      parser: 12,
      openJSONEditorModal: 1,
      onChangeMode: 2,
      onClick: 3
    }, Eb), t;
  }
  return v(n, Wo), b(n);
}();
function Ub(e) {
  St(e, "svelte-1nml1r3", ".jse-column-header.svelte-1nml1r3{background:none;border:none;font-family:inherit;font-size:inherit;color:inherit;display:flex;gap:var(--jse-padding, 10px);padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px)) calc(0.5 * var(--jse-padding, 10px));width:100%}.jse-column-header.svelte-1nml1r3:hover{background:var(--jse-table-header-background-highlight, #e8e8e8)}.jse-column-header.svelte-1nml1r3:not(.jse-column-header.jse-readonly){cursor:pointer}");
}
function Db(e) {
  var n, t, o, r, i, a;
  return t = new Ya({
    props: {
      data: on
    }
  }), {
    c: function () {
      n = Pt("button"), Jo(t.$$.fragment), Ut(n, "type", "button"), Ut(n, "class", "jse-column-header svelte-1nml1r3"), Ut(n, "title", o = "The Columns are created by sampling ".concat(e[1], " items out of ").concat(e[0], ". ") + "If you're missing a column, click here to sample all of the items instead of a subset. This is slower.");
    },
    m: function (o, s) {
      Rt(o, n, s), Vo(t, n, null), r = !0, i || (a = Bt(n, "click", e[3]), i = !0);
    },
    p: function (e, t) {
      var i = s(t, 1)[0];
      (!r || 3 & i && o !== (o = "The Columns are created by sampling ".concat(e[1], " items out of ").concat(e[0], ". ") + "If you're missing a column, click here to sample all of the items instead of a subset. This is slower.")) && Ut(n, "title", o);
    },
    i: function (e) {
      r || (qo(t.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), i = !1, a();
    }
  };
}
function Jb(e, n, t) {
  var o = n.count,
    r = n.maxSampleCount,
    i = n.onRefresh;
  return e.$$set = function (e) {
    "count" in e && t(0, o = e.count), "maxSampleCount" in e && t(1, r = e.maxSampleCount), "onRefresh" in e && t(2, i = e.onRefresh);
  }, [o, r, i, function () {
    return i();
  }];
}
var Vb = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Jb, Db, ct, {
      count: 0,
      maxSampleCount: 1,
      onRefresh: 2
    }, Ub), t;
  }
  return v(n, Wo), b(n);
}();
function Hb(e) {
  St(e, "svelte-12ygzbc", '.jse-table-mode.svelte-12ygzbc.svelte-12ygzbc{flex:1;display:flex;flex-direction:column;position:relative;background:var(--jse-background-color, #fff);min-width:0;min-height:0;font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:var(--jse-text-color, #4d4d4d);line-height:var(--jse-line-height, calc(1em + 4px))}.jse-table-mode.no-main-menu.svelte-12ygzbc.svelte-12ygzbc{border-top:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode.svelte-12ygzbc .jse-search-box-container.svelte-12ygzbc{position:relative;height:0;top:calc(var(--jse-line-height, calc(1em + 4px)) + 2 * var(--jse-padding, 10px));margin-right:calc(var(--jse-padding, 10px) + 20px);margin-left:var(--jse-padding, 10px);text-align:right;z-index:3}.jse-table-mode.svelte-12ygzbc .jse-hidden-input-label.svelte-12ygzbc{position:fixed;right:0;top:0;width:0;height:0}.jse-table-mode.svelte-12ygzbc .jse-hidden-input-label .jse-hidden-input.svelte-12ygzbc{width:0;height:0;padding:0;border:0;outline:none}.jse-table-mode.svelte-12ygzbc .jse-contents.svelte-12ygzbc{flex:1;align-items:flex-start;flex-direction:column;display:flex;overflow:auto;overflow-anchor:none;scrollbar-gutter:stable;border-left:var(--jse-main-border, 1px solid #d7d7d7);border-right:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode.svelte-12ygzbc .jse-contents.svelte-12ygzbc:last-child{border-bottom:var(--jse-main-border, 1px solid #d7d7d7)}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main.svelte-12ygzbc{border-collapse:collapse;border-spacing:0}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-invisible-start-section td.svelte-12ygzbc,.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-invisible-end-section td.svelte-12ygzbc{margin:0;padding:0}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-invisible-end-section td.svelte-12ygzbc{padding-bottom:var(--jse-padding, 10px)}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-row.svelte-12ygzbc:hover{background-color:var(--jse-table-row-odd-background, rgba(0, 0, 0, 0.05))}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.svelte-12ygzbc{padding:0 var(--jse-padding, 10px) 0 0;vertical-align:top;white-space:nowrap;height:var(--jse-line-height, calc(1em + 4px))}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-header.svelte-12ygzbc,.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-gutter.svelte-12ygzbc{font-weight:normal;text-align:left;color:var(--jse-text-readonly, #8d8d8d);background:var(--jse-table-header-background, #f5f5f5)}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-header.svelte-12ygzbc{padding:0;position:sticky;top:0}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-header .jse-table-root-error.svelte-12ygzbc{padding:calc(0.5 * var(--jse-padding, 10px)) var(--jse-padding, 10px) calc(0.5 * var(--jse-padding, 10px)) calc(0.5 * var(--jse-padding, 10px))}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-table-cell-gutter.svelte-12ygzbc{padding:0 var(--jse-padding, 10px) 0 calc(0.5 * var(--jse-padding, 10px))}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.jse-selected-value.svelte-12ygzbc>.jse-value{background:var(--jse-selection-background-color, #d3d3d3)}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-row .jse-table-cell.svelte-12ygzbc div.jse-value{overflow-wrap:normal;white-space:nowrap;vertical-align:top;display:inline-block}.jse-table-mode.svelte-12ygzbc .jse-contents table.jse-table-main .jse-table-row .jse-table-cell .jse-context-menu-anchor.svelte-12ygzbc{display:inline-flex;position:relative;vertical-align:top}.jse-table-mode.svelte-12ygzbc .jse-contents.jse-contents-loading.svelte-12ygzbc{align-items:unset}.jse-table-mode.svelte-12ygzbc .jse-contents.jse-contents-loading .jse-loading-space.svelte-12ygzbc{flex:1}.jse-table-mode.svelte-12ygzbc .jse-contents.jse-contents-loading .jse-loading.svelte-12ygzbc{flex:2;text-align:center;color:var(--jse-panel-color-readonly, #b2b2b2);box-sizing:border-box;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px)}');
}
function _b(e, n, t) {
  var o,
    r,
    i,
    a = e.slice();
  a[132] = n[t], a[138] = t;
  var s = a[27].startIndex + a[138];
  a[133] = s;
  var l = a[26].rows[a[133]];
  a[134] = l;
  var c = Eg([String(a[133])], null === (o = a[134]) || void 0 === o ? void 0 : o.row);
  a[135] = c;
  var u = null !== (r = a[20]) && void 0 !== r && r.itemsMap ? yp(null === (i = a[20]) || void 0 === i ? void 0 : i.itemsMap, V(a[133])) : void 0;
  return a[136] = u, a;
}
function Wb(e, n, t) {
  var o,
    r = e.slice();
  r[139] = n[t], r[146] = t;
  var i = [String(r[133])].concat(r[139]);
  r[140] = i;
  var a = O(r[140]);
  r[141] = a;
  var s = z(r[132], r[139]);
  r[142] = s;
  var l = Us(r[12].selection) && ol(r[12].selection.path, r[140]);
  r[143] = l;
  var c = null === (o = r[134]) || void 0 === o ? void 0 : o.columns[r[146]];
  r[144] = c;
  var u = Eg(r[140], r[144]);
  return r[135] = u, r;
}
function Qb(e, n, t) {
  var o = e.slice();
  return o[139] = n[t], o;
}
function Yb(e) {
  var n,
    t = e.slice(),
    o = Eg([], null === (n = t[26]) || void 0 === n ? void 0 : n.root);
  return t[135] = o, t;
}
function Gb(e) {
  var n, t, o;
  function r(n) {
    e[79](n);
  }
  var i = {
    containsValidArray: e[22],
    readOnly: e[0],
    historyState: e[24],
    onSort: e[47],
    onTransform: e[48],
    onUndo: e[49],
    onRedo: e[50],
    onContextMenu: e[39],
    onRenderMenu: e[5]
  };
  return void 0 !== e[9] && (i.showSearch = e[9]), n = new cb({
    props: i
  }), vo.push(function () {
    return Do(n, "showSearch", r);
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, t) {
      Vo(n, e, t), o = !0;
    },
    p: function (e, o) {
      var r = {};
      4194304 & o[0] && (r.containsValidArray = e[22]), 1 & o[0] && (r.readOnly = e[0]), 16777216 & o[0] && (r.historyState = e[24]), 32 & o[0] && (r.onRenderMenu = e[5]), !t && 512 & o[0] && (t = !0, r.showSearch = e[9], xo(function () {
        return t = !1;
      })), n.$set(r);
    },
    i: function (e) {
      o || (qo(n.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), o = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Kb(e) {
  var n;
  return {
    c: function () {
      (n = Pt("div")).innerHTML = '<div class="jse-loading-space svelte-12ygzbc"></div> <div class="jse-loading svelte-12ygzbc">loading...</div>', Ut(n, "class", "jse-contents jse-contents-loading svelte-12ygzbc");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    p: nt,
    i: nt,
    o: nt,
    d: function (e) {
      e && Et(n);
    }
  };
}
function Zb(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u = [ny, ey, Xb],
    d = [];
  function f(e, n) {
    return e[22] ? 0 : e[18] && void 0 !== e[17] && "" !== e[17] ? 1 : 2;
  }
  return r = f(e), i = d[r] = u[r](e), {
    c: function () {
      n = Pt("label"), t = Pt("input"), o = At(), i.c(), a = Nt(), Ut(t, "type", "text"), t.readOnly = !0, Ut(t, "tabindex", "-1"), Ut(t, "class", "jse-hidden-input svelte-12ygzbc"), Ut(n, "class", "jse-hidden-input-label svelte-12ygzbc");
    },
    m: function (i, u) {
      Rt(i, n, u), Ct(n, t), e[80](t), Rt(i, o, u), d[r].m(i, u), Rt(i, a, u), s = !0, l || (c = Bt(t, "paste", e[44]), l = !0);
    },
    p: function (e, n) {
      var t = r;
      (r = f(e)) === t ? d[r].p(e, n) : (Ro(), Po(d[t], 1, 1, function () {
        d[t] = null;
      }), Eo(), (i = d[r]) ? i.p(e, n) : (i = d[r] = u[r](e)).c(), qo(i, 1), i.m(a.parentNode, a));
    },
    i: function (e) {
      s || (qo(i), s = !0);
    },
    o: function (e) {
      Po(i), s = !1;
    },
    d: function (t) {
      t && (Et(n), Et(o), Et(a)), e[80](null), d[r].d(t), l = !1, c();
    }
  };
}
function Xb(e) {
  var n, t;
  return n = new Lb({
    props: {
      text: e[17],
      json: e[8],
      readOnly: e[0],
      parser: e[2],
      openJSONEditorModal: e[46],
      onChangeMode: e[4],
      onClick: e[84]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      131072 & t[0] && (o.text = e[17]), 256 & t[0] && (o.json = e[8]), 1 & t[0] && (o.readOnly = e[0]), 4 & t[0] && (o.parser = e[2]), 16 & t[0] && (o.onChangeMode = e[4]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function ey(e) {
  var n, t, o, r;
  return n = new Nf({
    props: {
      type: "error",
      message: "The loaded JSON document is invalid and could not be repaired automatically.",
      actions: e[0] ? [] : [{
        icon: en,
        text: "Repair manually",
        title: 'Open the document in "code" mode and repair it manually',
        onClick: e[42]
      }]
    }
  }), o = new nh({
    props: {
      text: e[17],
      json: e[8],
      indentation: e[3],
      parser: e[2]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment), t = At(), Jo(o.$$.fragment);
    },
    m: function (e, i) {
      Vo(n, e, i), Rt(e, t, i), Vo(o, e, i), r = !0;
    },
    p: function (e, t) {
      var r = {};
      1 & t[0] && (r.actions = e[0] ? [] : [{
        icon: en,
        text: "Repair manually",
        title: 'Open the document in "code" mode and repair it manually',
        onClick: e[42]
      }]), n.$set(r);
      var i = {};
      131072 & t[0] && (i.text = e[17]), 256 & t[0] && (i.json = e[8]), 8 & t[0] && (i.indentation = e[3]), 4 & t[0] && (i.parser = e[2]), o.$set(i);
    },
    i: function (e) {
      r || (qo(n.$$.fragment, e), qo(o.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), Po(o.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(t), Ho(n, e), Ho(o, e);
    }
  };
}
function ny(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c,
    u,
    d,
    f,
    v,
    p,
    m,
    g,
    h,
    j,
    b,
    y,
    x,
    w,
    $,
    k,
    C,
    S,
    M,
    O = !G(null === (n = e[26]) || void 0 === n ? void 0 : n.root);
  o = new xg({
    props: {
      json: e[8],
      documentState: e[12],
      parser: e[2],
      showSearch: e[9],
      showReplace: e[21],
      readOnly: e[0],
      columns: e[11],
      onSearch: e[30],
      onFocus: e[31],
      onPatch: e[34],
      onClose: e[32]
    }
  });
  for (var z = O && ty(Yb(e)), R = Ao(e[11]), E = [], q = 0; q < R.length; q += 1) E[q] = ry(Qb(e, R, q));
  for (var P = function (e) {
      return Po(E[e], 1, 1, function () {
        E[e] = null;
      });
    }, I = e[28] && iy(e), T = Ao(e[27].visibleItems), A = [], N = 0; N < T.length; N += 1) A[N] = py(_b(e, T, N));
  var B = function (e) {
      return Po(A[e], 1, 1, function () {
        A[e] = null;
      });
    },
    F = e[19] && my(e),
    L = e[23] && gy(e);
  return k = new Qf({
    props: {
      validationErrors: e[13],
      selectError: e[45]
    }
  }), {
    c: function () {
      t = Pt("div"), Jo(o.$$.fragment), r = At(), i = Pt("div"), a = Pt("table"), s = Pt("tbody"), l = Pt("tr"), c = Pt("th"), z && z.c(), u = At();
      for (var n = 0; n < E.length; n += 1) E[n].c();
      d = At(), I && I.c(), f = At(), v = Pt("tr"), p = Pt("td"), g = At();
      for (var C = 0; C < A.length; C += 1) A[C].c();
      h = At(), j = Pt("tr"), b = Pt("td"), x = At(), F && F.c(), w = At(), L && L.c(), $ = At(), Jo(k.$$.fragment), Ut(t, "class", "jse-search-box-container svelte-12ygzbc"), Ut(c, "class", "jse-table-cell jse-table-cell-header svelte-12ygzbc"), Ut(l, "class", "jse-table-row jse-table-row-header svelte-12ygzbc"), Ut(p, "colspan", m = e[11].length), Ut(p, "class", "svelte-12ygzbc"), Wt(p, "height", e[27].startHeight + "px"), Ut(v, "class", "jse-table-invisible-start-section"), Ut(b, "colspan", y = e[11].length), Ut(b, "class", "svelte-12ygzbc"), Wt(b, "height", e[27].endHeight + "px"), Ut(j, "class", "jse-table-invisible-end-section"), Ut(a, "class", "jse-table-main svelte-12ygzbc"), Ut(i, "class", "jse-contents svelte-12ygzbc");
    },
    m: function (n, m) {
      Rt(n, t, m), Vo(o, t, null), Rt(n, r, m), Rt(n, i, m), Ct(i, a), Ct(a, s), Ct(s, l), Ct(l, c), z && z.m(c, null), Ct(l, u);
      for (var y = 0; y < E.length; y += 1) E[y] && E[y].m(l, null);
      Ct(l, d), I && I.m(l, null), Ct(s, f), Ct(s, v), Ct(v, p), Ct(s, g);
      for (var O = 0; O < A.length; O += 1) A[O] && A[O].m(s, null);
      Ct(s, h), Ct(s, j), Ct(j, b), e[83](i), Rt(n, x, m), F && F.m(n, m), Rt(n, w, m), L && L.m(n, m), Rt(n, $, m), Vo(k, n, m), C = !0, S || (M = [jt(Rb.call(null, i, e[51])), Bt(i, "scroll", e[35])], S = !0);
    },
    p: function (e, n) {
      var t,
        r = {};
      if (256 & n[0] && (r.json = e[8]), 4096 & n[0] && (r.documentState = e[12]), 4 & n[0] && (r.parser = e[2]), 512 & n[0] && (r.showSearch = e[9]), 2097152 & n[0] && (r.showReplace = e[21]), 1 & n[0] && (r.readOnly = e[0]), 2048 & n[0] && (r.columns = e[11]), o.$set(r), 67108864 & n[0] && (O = !G(null === (t = e[26]) || void 0 === t ? void 0 : t.root)), O ? z ? (z.p(Yb(e), n), 67108864 & n[0] && qo(z, 1)) : ((z = ty(Yb(e))).c(), qo(z, 1), z.m(c, null)) : z && (Ro(), Po(z, 1, 1, function () {
        z = null;
      }), Eo()), 6145 & n[0] | 4 & n[1]) {
        var i;
        for (R = Ao(e[11]), i = 0; i < R.length; i += 1) {
          var a = Qb(e, R, i);
          E[i] ? (E[i].p(a, n), qo(E[i], 1)) : (E[i] = ry(a), E[i].c(), qo(E[i], 1), E[i].m(l, d));
        }
        for (Ro(), i = R.length; i < E.length; i += 1) P(i);
        Eo();
      }
      if (e[28] ? I ? (I.p(e, n), 268435456 & n[0] && qo(I, 1)) : ((I = iy(e)).c(), qo(I, 1), I.m(l, null)) : I && (Ro(), Po(I, 1, 1, function () {
        I = null;
      }), Eo()), (!C || 2048 & n[0] && m !== (m = e[11].length)) && Ut(p, "colspan", m), 134217728 & n[0] && Wt(p, "height", e[27].startHeight + "px"), 504371205 & n[0] | 2129984 & n[1]) {
        var u;
        for (T = Ao(e[27].visibleItems), u = 0; u < T.length; u += 1) {
          var f = _b(e, T, u);
          A[u] ? (A[u].p(f, n), qo(A[u], 1)) : (A[u] = py(f), A[u].c(), qo(A[u], 1), A[u].m(s, h));
        }
        for (Ro(), u = T.length; u < A.length; u += 1) B(u);
        Eo();
      }
      (!C || 2048 & n[0] && y !== (y = e[11].length)) && Ut(b, "colspan", y), 134217728 & n[0] && Wt(b, "height", e[27].endHeight + "px"), e[19] ? F ? (F.p(e, n), 524288 & n[0] && qo(F, 1)) : ((F = my(e)).c(), qo(F, 1), F.m(w.parentNode, w)) : F && (Ro(), Po(F, 1, 1, function () {
        F = null;
      }), Eo()), e[23] ? L ? (L.p(e, n), 8388608 & n[0] && qo(L, 1)) : ((L = gy(e)).c(), qo(L, 1), L.m($.parentNode, $)) : L && (Ro(), Po(L, 1, 1, function () {
        L = null;
      }), Eo());
      var v = {};
      8192 & n[0] && (v.validationErrors = e[13]), k.$set(v);
    },
    i: function (e) {
      if (!C) {
        qo(o.$$.fragment, e), qo(z);
        for (var n = 0; n < R.length; n += 1) qo(E[n]);
        qo(I);
        for (var t = 0; t < T.length; t += 1) qo(A[t]);
        qo(F), qo(L), qo(k.$$.fragment, e), C = !0;
      }
    },
    o: function (e) {
      Po(o.$$.fragment, e), Po(z), E = E.filter(Boolean);
      for (var n = 0; n < E.length; n += 1) Po(E[n]);
      Po(I), A = A.filter(Boolean);
      for (var t = 0; t < A.length; t += 1) Po(A[t]);
      Po(F), Po(L), Po(k.$$.fragment, e), C = !1;
    },
    d: function (n) {
      n && (Et(t), Et(r), Et(i), Et(x), Et(w), Et($)), Ho(o), z && z.d(), qt(E, n), I && I.d(), qt(A, n), e[83](null), F && F.d(n), L && L.d(n), Ho(k, n), S = !1, at(M);
    }
  };
}
function ty(e) {
  var n,
    t,
    o = e[135] && oy(e);
  return {
    c: function () {
      o && o.c(), n = Nt();
    },
    m: function (e, r) {
      o && o.m(e, r), Rt(e, n, r), t = !0;
    },
    p: function (e, t) {
      e[135] ? o ? (o.p(e, t), 67108864 & t[0] && qo(o, 1)) : ((o = oy(e)).c(), qo(o, 1), o.m(n.parentNode, n)) : o && (Ro(), Po(o, 1, 1, function () {
        o = null;
      }), Eo());
    },
    i: function (e) {
      t || (qo(o), t = !0);
    },
    o: function (e) {
      Po(o), t = !1;
    },
    d: function (e) {
      e && Et(n), o && o.d(e);
    }
  };
}
function oy(e) {
  var n, t, o;
  return t = new kp({
    props: {
      validationError: e[135],
      onExpand: qj
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), Ut(n, "class", "jse-table-root-error svelte-12ygzbc");
    },
    m: function (e, r) {
      Rt(e, n, r), Vo(t, n, null), o = !0;
    },
    p: function (e, n) {
      var o = {};
      67108864 & n[0] && (o.validationError = e[135]), t.$set(o);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function ry(e) {
  var n, t, o;
  return t = new zb({
    props: {
      path: e[139],
      sortedColumn: e[12].sortedColumn,
      readOnly: e[0],
      onSort: e[33]
    }
  }), {
    c: function () {
      n = Pt("th"), Jo(t.$$.fragment), Ut(n, "class", "jse-table-cell jse-table-cell-header svelte-12ygzbc");
    },
    m: function (e, r) {
      Rt(e, n, r), Vo(t, n, null), o = !0;
    },
    p: function (e, n) {
      var o = {};
      2048 & n[0] && (o.path = e[139]), 4096 & n[0] && (o.sortedColumn = e[12].sortedColumn), 1 & n[0] && (o.readOnly = e[0]), t.$set(o);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function iy(e) {
  var n, t, o;
  return t = new Vb({
    props: {
      count: Array.isArray(e[8]) ? e[8].length : 0,
      maxSampleCount: e[10],
      onRefresh: e[81]
    }
  }), {
    c: function () {
      n = Pt("th"), Jo(t.$$.fragment), Ut(n, "class", "jse-table-cell jse-table-cell-header svelte-12ygzbc");
    },
    m: function (e, r) {
      Rt(e, n, r), Vo(t, n, null), o = !0;
    },
    p: function (e, n) {
      var o = {};
      256 & n[0] && (o.count = Array.isArray(e[8]) ? e[8].length : 0), 1024 & n[0] && (o.maxSampleCount = e[10]), 1024 & n[0] && (o.onRefresh = e[81]), t.$set(o);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t);
    }
  };
}
function ay(e) {
  var n, t;
  return n = new kp({
    props: {
      validationError: e[135],
      onExpand: qj
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      201326592 & t[0] && (o.validationError = e[135]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function sy(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l = e[133] + "",
    c = e[135] && ay(e);
  function u() {
    for (var n, t = arguments.length, o = new Array(t), r = 0; r < t; r++) o[r] = arguments[r];
    return (n = e)[82].apply(n, [e[133]].concat(o));
  }
  return {
    c: function () {
      n = Pt("th"), t = Tt(l), o = At(), c && c.c(), Ut(n, "class", "jse-table-cell jse-table-cell-gutter svelte-12ygzbc");
    },
    m: function (e, l) {
      Rt(e, n, l), Ct(n, t), Ct(n, o), c && c.m(n, null), i = !0, a || (s = jt(r = Rb.call(null, n, u)), a = !0);
    },
    p: function (o, a) {
      e = o, (!i || 134217728 & a[0]) && l !== (l = e[133] + "") && Ht(t, l), e[135] ? c ? (c.p(e, a), 201326592 & a[0] && qo(c, 1)) : ((c = ay(e)).c(), qo(c, 1), c.m(n, null)) : c && (Ro(), Po(c, 1, 1, function () {
        c = null;
      }), Eo()), r && st(r.update) && 134217728 & a[0] && r.update.call(null, u);
    },
    i: function (e) {
      i || (qo(c), i = !0);
    },
    o: function (e) {
      Po(c), i = !1;
    },
    d: function (e) {
      e && Et(n), c && c.d(), a = !1, s();
    }
  };
}
function ly(e) {
  var n, t;
  return n = new jb({
    props: {
      path: e[140],
      value: void 0 !== e[142] ? e[142] : "",
      enforceString: Rs(e[142], e[12].enforceStringMap, e[141], e[25].parser),
      selection: e[143] ? e[12].selection : null,
      searchResultItems: e[147],
      context: e[25]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      134219776 & t[0] && (o.path = e[140]), 134219776 & t[0] && (o.value = void 0 !== e[142] ? e[142] : ""), 167778304 & t[0] && (o.enforceString = Rs(e[142], e[12].enforceStringMap, e[141], e[25].parser)), 134223872 & t[0] && (o.selection = e[143] ? e[12].selection : null), 135268352 & t[0] && (o.searchResultItems = e[147]), 33554432 & t[0] && (o.context = e[25]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function cy(e) {
  var n, t;
  return n = new wb({
    props: {
      path: e[140],
      value: e[142],
      parser: e[2],
      isSelected: e[143],
      containsSearchResult: !G(e[147]),
      containsActiveSearchResult: e[148],
      onEdit: e[46]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      134219776 & t[0] && (o.path = e[140]), 134219776 & t[0] && (o.value = e[142]), 4 & t[0] && (o.parser = e[2]), 134223872 & t[0] && (o.isSelected = e[143]), 135268352 & t[0] && (o.containsSearchResult = !G(e[147])), 135268352 & t[0] && (o.containsActiveSearchResult = e[148]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function uy(e) {
  var n, t, o, r;
  return t = new Xv({
    props: {
      selected: !0,
      onContextMenu: e[37]
    }
  }), {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), o = At(), Ut(n, "class", "jse-context-menu-anchor svelte-12ygzbc");
    },
    m: function (e, i) {
      Rt(e, n, i), Vo(t, n, null), Rt(e, o, i), r = !0;
    },
    p: nt,
    i: function (e) {
      r || (qo(t.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && (Et(n), Et(o)), Ho(t);
    }
  };
}
function dy(e) {
  var n, t;
  return n = new kp({
    props: {
      validationError: e[135],
      onExpand: qj
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      201328640 & t[0] && (o.validationError = e[135]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function fy(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l,
    c = !e[0] && e[143] && !dl(e[12].selection),
    u = [cy, ly],
    d = [];
  function f(e, n) {
    return 134219776 & n[0] && (t = null), null == t && (t = !!Yr(e[142])), t ? 0 : 1;
  }
  function v(e, n) {
    return 0 === n ? function (e) {
      var n = e.slice(),
        t = n[136] ? yp(n[136], n[141]) : void 0;
      n[147] = t;
      var o = !!n[147] && Object.values(n[147]).some(function (e) {
        return e.some(function (e) {
          return e.active;
        });
      });
      return n[148] = o, n;
    }(e) : function (e) {
      var n,
        t,
        o = e.slice(),
        r = null !== (n = o[20]) && void 0 !== n && n.itemsMap ? Zl(null === (t = o[20]) || void 0 === t ? void 0 : t.itemsMap, o[141]) : void 0;
      return o[147] = r, o;
    }(e);
  }
  o = f(e, [-1, -1, -1, -1, -1]), r = d[o] = u[o](v(e, o));
  var p = c && uy(e),
    m = e[135] && dy(e);
  return {
    c: function () {
      n = Pt("td"), r.c(), i = Nt(), p && p.c(), a = Nt(), m && m.c(), Ut(n, "class", "jse-table-cell svelte-12ygzbc"), Ut(n, "data-path", s = ta(e[140])), Yt(n, "jse-selected-value", e[143]);
    },
    m: function (e, t) {
      Rt(e, n, t), d[o].m(n, null), Ct(n, i), p && p.m(n, null), Ct(n, a), m && m.m(n, null), l = !0;
    },
    p: function (e, t) {
      var g = o;
      (o = f(e, t)) === g ? d[o].p(v(e, o), t) : (Ro(), Po(d[g], 1, 1, function () {
        d[g] = null;
      }), Eo(), (r = d[o]) ? r.p(v(e, o), t) : (r = d[o] = u[o](v(e, o))).c(), qo(r, 1), r.m(n, i)), 134223873 & t[0] && (c = !e[0] && e[143] && !dl(e[12].selection)), c ? p ? (p.p(e, t), 134223873 & t[0] && qo(p, 1)) : ((p = uy(e)).c(), qo(p, 1), p.m(n, a)) : p && (Ro(), Po(p, 1, 1, function () {
        p = null;
      }), Eo()), e[135] ? m ? (m.p(e, t), 201328640 & t[0] && qo(m, 1)) : ((m = dy(e)).c(), qo(m, 1), m.m(n, null)) : m && (Ro(), Po(m, 1, 1, function () {
        m = null;
      }), Eo()), (!l || 134219776 & t[0] && s !== (s = ta(e[140]))) && Ut(n, "data-path", s), (!l || 134223872 & t[0]) && Yt(n, "jse-selected-value", e[143]);
    },
    i: function (e) {
      l || (qo(r), qo(p), qo(m), l = !0);
    },
    o: function (e) {
      Po(r), Po(p), Po(m), l = !1;
    },
    d: function (e) {
      e && Et(n), d[o].d(), p && p.d(), m && m.d();
    }
  };
}
function vy(e) {
  var n;
  return {
    c: function () {
      Ut(n = Pt("td"), "class", "jse-table-cell svelte-12ygzbc");
    },
    m: function (e, t) {
      Rt(e, n, t);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function py(e) {
  for (var n, t, o, r, i = e[133], a = sy(e), s = Ao(e[11]), l = [], c = 0; c < s.length; c += 1) l[c] = fy(Wb(e, s, c));
  var u = function (e) {
      return Po(l[e], 1, 1, function () {
        l[e] = null;
      });
    },
    d = e[28] && vy();
  return {
    c: function () {
      n = Pt("tr"), a.c(), t = At();
      for (var e = 0; e < l.length; e += 1) l[e].c();
      o = At(), d && d.c(), Ut(n, "class", "jse-table-row svelte-12ygzbc");
    },
    m: function (e, i) {
      Rt(e, n, i), a.m(n, null), Ct(n, t);
      for (var s = 0; s < l.length; s += 1) l[s] && l[s].m(n, null);
      Ct(n, o), d && d.m(n, null), r = !0;
    },
    p: function (e, r) {
      if (134217728 & r[0] && ct(i, i = e[133]) ? (Ro(), Po(a, 1, 1, nt), Eo(), (a = sy(e)).c(), qo(a, 1), a.m(n, t)) : a.p(e, r), 235935749 & r[0] | 32832 & r[1]) {
        var c;
        for (s = Ao(e[11]), c = 0; c < s.length; c += 1) {
          var f = Wb(e, s, c);
          l[c] ? (l[c].p(f, r), qo(l[c], 1)) : (l[c] = fy(f), l[c].c(), qo(l[c], 1), l[c].m(n, o));
        }
        for (Ro(), c = s.length; c < l.length; c += 1) u(c);
        Eo();
      }
      e[28] ? d || ((d = vy()).c(), d.m(n, null)) : d && (d.d(1), d = null);
    },
    i: function (e) {
      if (!r) {
        qo(a);
        for (var n = 0; n < s.length; n += 1) qo(l[n]);
        r = !0;
      }
    },
    o: function (e) {
      Po(a), l = l.filter(Boolean);
      for (var n = 0; n < l.length; n += 1) Po(l[n]);
      r = !1;
    },
    d: function (e) {
      e && Et(n), a.d(e), qt(l, e), d && d.d();
    }
  };
}
function my(e) {
  var n, t;
  return n = new Nf({
    props: {
      type: "info",
      message: "You pasted a JSON ".concat(Array.isArray(e[19].contents) ? "array" : "object", " as text"),
      actions: [{
        icon: Me,
        text: "Paste as JSON instead",
        title: "Paste the text as JSON instead of a single value",
        onMouseDown: e[40]
      }, {
        text: "Leave as is",
        title: "Keep the pasted content as a single value",
        onClick: e[41]
      }]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      524288 & t[0] && (o.message = "You pasted a JSON ".concat(Array.isArray(e[19].contents) ? "array" : "object", " as text")), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function gy(e) {
  var n, t;
  return n = new Nf({
    props: {
      type: "success",
      message: "The loaded JSON document was invalid but is successfully repaired.",
      actions: e[0] ? [] : [{
        icon: Ce,
        text: "Ok",
        title: "Accept the repaired document",
        onClick: e[7]
      }, {
        icon: en,
        text: "Repair manually instead",
        title: "Leave the document unchanged and repair it manually instead",
        onClick: e[42]
      }],
      onClose: e[6]
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t[0] && (o.actions = e[0] ? [] : [{
        icon: Ce,
        text: "Ok",
        title: "Accept the repaired document",
        onClick: e[7]
      }, {
        icon: en,
        text: "Repair manually instead",
        title: "Leave the document unchanged and repair it manually instead",
        onClick: e[42]
      }]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function hy(e) {
  var n,
    t,
    o,
    r,
    i,
    a,
    s,
    l = e[1] && Gb(e),
    c = [Zb, Kb],
    u = [];
  return o = function (e, n) {
    return e[29] ? 1 : 0;
  }(e), r = u[o] = c[o](e), {
    c: function () {
      n = Pt("div"), l && l.c(), t = At(), r.c(), Ut(n, "role", "table"), Ut(n, "class", "jse-table-mode svelte-12ygzbc"), Yt(n, "no-main-menu", !e[1]);
    },
    m: function (r, c) {
      Rt(r, n, c), l && l.m(n, null), Ct(n, t), u[o].m(n, null), e[85](n), i = !0, a || (s = [Bt(n, "mousedown", e[36]), Bt(n, "keydown", e[43]), Bt(n, "contextmenu", e[38])], a = !0);
    },
    p: function (e, o) {
      e[1] ? l ? (l.p(e, o), 2 & o[0] && qo(l, 1)) : ((l = Gb(e)).c(), qo(l, 1), l.m(n, t)) : l && (Ro(), Po(l, 1, 1, function () {
        l = null;
      }), Eo()), r.p(e, o), (!i || 2 & o[0]) && Yt(n, "no-main-menu", !e[1]);
    },
    i: function (e) {
      i || (qo(l), qo(r), i = !0);
    },
    o: function (e) {
      Po(l), Po(r), i = !1;
    },
    d: function (t) {
      t && Et(n), l && l.d(), u[o].d(), e[85](null), a = !1, at(s);
    }
  };
}
var jy = 18;
function by(e, n, t) {
  var i,
    s,
    l,
    c = Qo("jsoneditor:TableMode"),
    u = co("simple-modal").open,
    d = co("absolute-popup"),
    f = d.openAbsolutePopup,
    v = d.closeAbsolutePopup,
    p = yf(),
    m = fe(),
    h = fe(),
    j = "undefined" == typeof window;
  c("isSSR:", j);
  var b,
    y,
    x,
    $,
    k,
    C,
    S = n.readOnly,
    E = n.externalContent,
    q = n.externalSelection,
    P = n.mainMenuBar,
    I = n.escapeControlCharacters,
    T = n.escapeUnicodeCharacters,
    A = n.flattenColumns,
    B = n.parser,
    F = n.parseMemoizeOne,
    U = n.validator,
    D = n.validationParser,
    J = n.indentation,
    V = n.onChange,
    H = n.onChangeMode,
    W = n.onSelect,
    Q = n.onRenderValue,
    Y = n.onRenderMenu,
    K = n.onRenderContextMenu,
    Z = n.onFocus,
    X = n.onBlur,
    ee = n.onSortModal,
    te = n.onTransformModal,
    oe = n.onJSONEditorModal;
  zf({
    onMount: io,
    onDestroy: ao,
    getWindow: function () {
      return Zi(y);
    },
    hasFocus: function () {
      return pe && document.hasFocus() || Xi(y);
    },
    onFocus: function () {
      me = !0, Z && Z();
    },
    onBlur: function () {
      me = !1, X && X();
    }
  });
  var re,
    ie,
    ae = void 0,
    se = !1,
    le = !1;
  function ce() {
    return (ce = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return t(12, xe = g(g({}, xe), {}, {
              selection: null
            })), e.next = 3, Ue(n);
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  var ue,
    de = 1e4,
    ve = [],
    pe = !1,
    me = !1,
    ge = {},
    he = 600,
    je = 0;
  function be(e) {
    c("updateSelection", e);
    var n = "function" == typeof e ? e(xe.selection) || null : e;
    ne(n, xe.selection) || (t(12, xe = g(g({}, xe), {}, {
      selection: n
    })), W(n));
  }
  function ye(e) {
    xe.selection && void 0 !== e && (L(e, yl(xe.selection)) && L(e, bl(xe.selection)) || (c("clearing selection: path does not exist anymore", xe.selection), t(12, xe = g(g({}, xe), {}, {
      selection: null
    }))));
  }
  var xe = fs(),
    we = !1;
  var $e,
    ke = $f({
      onChange: function (e) {
        t(24, Ce = e);
      }
    }),
    Ce = ke.getState();
  function Se(e) {
    var n = k,
      o = xi(e) ? e.text !== C : !ne(n, e.json);
    if (c("update external content", {
      isChanged: o
    }), o) {
      var r = k,
        i = xe,
        a = C,
        s = we;
      if (xi(e)) try {
        t(8, k = F(e.text)), t(17, C = e.text), t(23, we = !1), t(18, ae = void 0);
      } catch (n) {
        try {
          t(8, k = F(_(e.text))), t(17, C = e.text), t(23, we = !0), t(18, ae = void 0);
        } catch (o) {
          t(8, k = void 0), t(17, C = e.text), t(23, we = !1), t(18, ae = "" !== C ? ji(C, n.message || String(n)) : void 0);
        }
      } else t(8, k = e.json), t(17, C = void 0), t(23, we = !1), t(18, ae = void 0);
      ye(k), xe.sortedColumn && t(12, xe = g(g({}, xe), {}, {
        sortedColumn: null
      })), Me({
        previousJson: r,
        previousState: i,
        previousText: a,
        previousTextIsRepaired: s
      });
    }
  }
  function Me(e) {
    var n = e.previousJson,
      t = e.previousState,
      o = e.previousText,
      r = e.previousTextIsRepaired;
    void 0 === n && void 0 === o || (void 0 !== k ? void 0 !== n ? ke.add({
      undo: {
        patch: [{
          op: "replace",
          path: "",
          value: n
        }],
        state: rl(t),
        json: void 0,
        text: o,
        textIsRepaired: r
      },
      redo: {
        patch: [{
          op: "replace",
          path: "",
          value: k
        }],
        state: rl(xe),
        json: void 0,
        text: C,
        textIsRepaired: we
      }
    }) : ke.add({
      undo: {
        patch: void 0,
        json: void 0,
        text: o,
        state: rl(t),
        textIsRepaired: r
      },
      redo: {
        patch: void 0,
        json: k,
        state: rl(xe),
        text: C,
        textIsRepaired: we
      }
    }) : void 0 !== n && ke.add({
      undo: {
        patch: void 0,
        json: n,
        state: rl(t),
        text: o,
        textIsRepaired: r
      },
      redo: {
        patch: void 0,
        json: void 0,
        text: C,
        textIsRepaired: we,
        state: rl(xe)
      }
    }));
  }
  var Oe = [],
    ze = sn(Sf);
  function Re(e, n, o, r) {
    kf(function () {
      var i;
      try {
        i = ze(e, n, o, r);
      } catch (e) {
        i = [{
          path: [],
          message: "Failed to validate: " + e.message,
          severity: ur.warning
        }];
      }
      ne(i, Oe) || (c("validationErrors changed:", i), t(13, Oe = i));
    }, function (e) {
      return c("validationErrors updated in ".concat(e, " ms"));
    });
  }
  function Ee() {
    return c("validate"), ae ? {
      parseError: ae,
      isRepairable: !1
    } : (Re(k, U, B, D), G(Oe) ? null : {
      validationErrors: Oe
    });
  }
  function qe(e, n) {
    if (c("patch", e, n), void 0 === k) throw new Error("Cannot apply patch: no JSON");
    var o = k,
      r = xe,
      i = we,
      a = Fl(k, e),
      s = bs(k, xe, e).json,
      l = Pg(xe, e, ve),
      u = "function" == typeof n ? n(s, l) : void 0;
    t(8, k = u && void 0 !== u.json ? u.json : s);
    var d = u && void 0 !== u.state ? u.state : l;
    return t(12, xe = d), t(17, C = void 0), t(23, we = !1), t(19, re = void 0), t(18, ae = void 0), ke.add({
      undo: {
        patch: a,
        json: void 0,
        text: void 0,
        state: rl(r),
        textIsRepaired: i
      },
      redo: {
        patch: e,
        json: void 0,
        state: rl(d),
        text: void 0,
        textIsRepaired: we
      }
    }), {
      json: k,
      previousJson: o,
      undo: a,
      redo: e
    };
  }
  function Pe(e, n) {
    c("handlePatch", e, n);
    var t = {
        json: k,
        text: C
      },
      o = qe(e, n);
    return Ie(t, o), o;
  }
  function Ie(e, n) {
    if ((void 0 !== e.json || void 0 !== (null == e ? void 0 : e.text)) && V) if (void 0 !== C) V({
      text: C,
      json: void 0
    }, e, {
      contentErrors: Ee(),
      patchResult: n
    });else if (void 0 !== k) {
      V({
        text: void 0,
        json: k
      }, e, {
        contentErrors: Ee(),
        patchResult: n
      });
    }
  }
  function Te(e) {
    c("handleFind", e);
  }
  function Ne(e) {
    c("pasted json as text", e), t(19, re = e);
  }
  function Be(e) {
    var n = parseInt(e[0], 10),
      t = [String(n + 1)].concat(w(e.slice(1)));
    return L(k, t) ? al(t, !1) : al(e, !1);
  }
  function Fe() {
    c("focus"), $ && ($.focus(), $.select());
  }
  function Le() {
    xe.selection || be(!N(k) || G(k) || G(ve) ? null : al(["0"].concat(w(ve[0])), !1));
  }
  function Ue(e) {
    var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
      t = se ? Ur : 0,
      o = Mg(e, ve, ge, jy),
      i = o - je + t + jy,
      s = Ze(e);
    if (c("scrollTo", {
      path: e,
      top: o,
      scrollTop: je,
      elem: s
    }), !x) return Promise.resolve();
    var l = x.getBoundingClientRect();
    if (s && !n) {
      var u = s.getBoundingClientRect();
      if (u.bottom > l.top && u.top < l.bottom) return Promise.resolve();
    }
    var d = -Math.max(t + 36, l.height / 4);
    return new Promise(s ? function (n) {
      p(s, {
        container: x,
        offset: d,
        duration: 300,
        callback: function () {
          Qe(e), n();
        }
      });
    } : function (n) {
      var t;
      p(i, {
        container: x,
        offset: d,
        duration: 300,
        callback: (t = a(r().mark(function t() {
          return r().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.next = 2, bo();
              case 2:
                Qe(e), n();
              case 4:
              case "end":
                return t.stop();
            }
          }, t);
        })), function () {
          return t.apply(this, arguments);
        })
      });
    });
  }
  function Qe(e) {
    var n = Ze(e);
    if (n && x) {
      var o = x.getBoundingClientRect(),
        r = n.getBoundingClientRect();
      if (r.right > o.right) {
        var i = r.right - o.right;
        t(15, x.scrollLeft += i, x);
      }
      if (r.left < o.left) {
        var a = o.left - r.left;
        t(15, x.scrollLeft -= a, x);
      }
    }
  }
  function Ge(e) {
    !function (e) {
      if (x) {
        var n = Og(e, ve).rowIndex,
          o = Mg(e, ve, ge, jy),
          r = o + (ge[n] || jy),
          i = x.getBoundingClientRect(),
          a = je,
          s = je + i.height - 18;
        if (r > s) {
          var l = r - s;
          t(15, x.scrollTop += l, x);
        }
        if (o < a) {
          var c = a - o;
          t(15, x.scrollTop -= c, x);
        }
      }
    }(e), Qe(e);
  }
  function Ze(e) {
    var n = ve.find(function (n) {
        return ol(e.slice(1), n);
      }),
      t = n ? e.slice(0, 1).concat(n) : e;
    return x ? x.querySelector('td[data-path="'.concat(ta(t), '"]')) : null;
  }
  function Xe(e) {
    var n = e.anchor,
      t = e.left,
      o = e.top,
      r = e.width,
      i = e.height,
      a = e.offsetTop,
      s = e.offsetLeft,
      l = e.showTip,
      c = function (e) {
        var n = e.json,
          t = e.documentState,
          o = e.readOnly,
          r = e.parser,
          i = e.onEditValue,
          a = e.onEditRow,
          s = e.onToggleEnforceString,
          l = e.onCut,
          c = e.onCopy,
          u = e.onPaste,
          d = e.onRemove,
          f = e.onDuplicateRow,
          v = e.onInsertBeforeRow,
          p = e.onInsertAfterRow,
          m = e.onRemoveRow,
          g = t.selection,
          h = void 0 !== n,
          j = !!g,
          b = void 0 !== n && g ? z(n, bl(g)) : void 0,
          y = h && (Ds(g) || Ls(g) || Us(g)),
          x = !o && h && null != g && nl(g),
          w = x && !Yr(b),
          $ = !o && y,
          k = null != g && void 0 !== b && Rs(b, t.enforceStringMap, O(bl(g)), r);
        return [{
          type: "separator"
        }, {
          type: "row",
          items: [{
            type: "column",
            items: [{
              type: "label",
              text: "Table cell:"
            }, {
              type: "dropdown-button",
              main: {
                type: "button",
                onClick: function () {
                  return i();
                },
                icon: De,
                text: "Edit",
                title: "Edit the value (Double-click on the value)",
                disabled: !x
              },
              width: "11em",
              items: [{
                type: "button",
                icon: De,
                text: "Edit",
                title: "Edit the value (Double-click on the value)",
                onClick: function () {
                  return i();
                },
                disabled: !x
              }, {
                type: "button",
                icon: k ? Je : Ve,
                text: "Enforce string",
                title: "Enforce keeping the value as string when it contains a numeric value",
                onClick: function () {
                  return s();
                },
                disabled: !w
              }]
            }, {
              type: "dropdown-button",
              main: {
                type: "button",
                onClick: function () {
                  return l(!0);
                },
                icon: He,
                text: "Cut",
                title: "Cut selected contents, formatted with indentation (Ctrl+X)",
                disabled: !$
              },
              width: "10em",
              items: [{
                type: "button",
                icon: He,
                text: "Cut formatted",
                title: "Cut selected contents, formatted with indentation (Ctrl+X)",
                onClick: function () {
                  return l(!0);
                },
                disabled: o || !y
              }, {
                type: "button",
                icon: He,
                text: "Cut compacted",
                title: "Cut selected contents, without indentation (Ctrl+Shift+X)",
                onClick: function () {
                  return l(!1);
                },
                disabled: o || !y
              }]
            }, {
              type: "dropdown-button",
              main: {
                type: "button",
                onClick: function () {
                  return c(!0);
                },
                icon: Ae,
                text: "Copy",
                title: "Copy selected contents, formatted with indentation (Ctrl+C)",
                disabled: !y
              },
              width: "12em",
              items: [{
                type: "button",
                icon: Ae,
                text: "Copy formatted",
                title: "Copy selected contents, formatted with indentation (Ctrl+C)",
                onClick: function () {
                  return c(!1);
                },
                disabled: !y
              }, {
                type: "button",
                icon: Ae,
                text: "Copy compacted",
                title: "Copy selected contents, without indentation (Ctrl+Shift+C)",
                onClick: function () {
                  return c(!1);
                },
                disabled: !y
              }]
            }, {
              type: "button",
              onClick: function () {
                return u();
              },
              icon: _e,
              text: "Paste",
              title: "Paste clipboard contents (Ctrl+V)",
              disabled: o || !j
            }, {
              type: "button",
              onClick: function () {
                return d();
              },
              icon: Ye,
              text: "Remove",
              title: "Remove selected contents (Delete)",
              disabled: o || !y
            }]
          }, {
            type: "column",
            items: [{
              type: "label",
              text: "Table row:"
            }, {
              type: "button",
              onClick: function () {
                return a();
              },
              icon: De,
              text: "Edit row",
              title: "Edit the current row",
              disabled: o || !j || !h
            }, {
              type: "button",
              onClick: function () {
                return f();
              },
              icon: We,
              text: "Duplicate row",
              title: "Duplicate the current row",
              disabled: o || !j || !h
            }, {
              type: "button",
              onClick: function () {
                return v();
              },
              icon: Ke,
              text: "Insert before",
              title: "Insert a row before the current row",
              disabled: o || !j || !h
            }, {
              type: "button",
              onClick: function () {
                return p();
              },
              icon: Ke,
              text: "Insert after",
              title: "Insert a row after the current row",
              disabled: o || !j || !h
            }, {
              type: "button",
              onClick: function () {
                return m();
              },
              icon: Ye,
              text: "Remove row",
              title: "Remove current row",
              disabled: o || !j || !h
            }]
          }]
        }];
      }({
        json: k,
        documentState: xe,
        readOnly: S,
        parser: B,
        onEditValue: nn,
        onEditRow: tn,
        onToggleEnforceString: on,
        onCut: ln,
        onCopy: un,
        onPaste: an,
        onRemove: fn,
        onDuplicateRow: vn,
        onInsertBeforeRow: pn,
        onInsertAfterRow: mn,
        onRemoveRow: gn
      }),
      u = K(c);
    if (!1 !== u) {
      var d = {
        left: t,
        top: o,
        offsetTop: a,
        offsetLeft: s,
        width: r,
        height: i,
        anchor: n,
        closeOnOuterClick: !0,
        onClose: function () {
          pe = !1, Fe();
        }
      };
      pe = !0;
      var p = f(Yh, {
        tip: l ? "Tip: you can open this context menu via right-click or with Ctrl+Q" : void 0,
        items: u,
        onRequestClose: function () {
          v(p), Fe();
        }
      }, d);
    }
  }
  function en(e) {
    if (!dl(xe.selection)) {
      if (e && (e.stopPropagation(), e.preventDefault()), e && "contextmenu" === e.type && e.target !== $) Xe({
        left: e.clientX,
        top: e.clientY,
        width: Lr,
        height: Fr,
        showTip: !1
      });else {
        var n,
          t = null === (n = x) || void 0 === n ? void 0 : n.querySelector(".jse-table-cell.jse-selected-value");
        if (t) Xe({
          anchor: t,
          offsetTop: 2,
          width: Lr,
          height: Fr,
          showTip: !1
        });else {
          var o,
            r = null === (o = x) || void 0 === o ? void 0 : o.getBoundingClientRect();
          r && Xe({
            top: r.top + 2,
            left: r.left + 2,
            width: Lr,
            height: Fr,
            showTip: !1
          });
        }
      }
      return !1;
    }
  }
  function nn() {
    if (!S && xe.selection) {
      var e = bl(xe.selection);
      Yr(z(k, e)) ? xn(e) : be(al(e, !0));
    }
  }
  function tn() {
    !S && xe.selection && xn(bl(xe.selection).slice(0, 1));
  }
  function on() {
    if (!S && Us(xe.selection)) {
      var e = xe.selection.path,
        n = O(e),
        t = z(k, e),
        o = !Rs(t, xe.enforceStringMap, n, B),
        r = o ? String(t) : ti(String(t), B);
      c("handleToggleEnforceString", {
        enforceString: o,
        value: t,
        updatedValue: r
      }), Pe([{
        op: "replace",
        path: n,
        value: r
      }], function (e, t) {
        return {
          state: js(t, n, o)
        };
      });
    }
  }
  function rn() {
    return (rn = a(r().mark(function e() {
      var n, t, o, i, a;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (c("apply pasted json", re), re) {
              e.next = 3;
              break;
            }
            return e.abrupt("return");
          case 3:
            o = (t = re).path, i = t.contents, ia(a = (null === (n = x) || void 0 === n ? void 0 : n.querySelector(".jse-editable-div")) || null) && a.cancel(), Pe([{
              op: "replace",
              path: O(o),
              value: i
            }]), setTimeout(Fe);
          case 9:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function an() {
    u(nv, {}, g(g({}, Or), {}, {
      styleWindow: {
        width: "450px"
      }
    }), {
      onClose: function () {
        return Fe();
      }
    });
  }
  function ln(e) {
    return cn.apply(this, arguments);
  }
  function cn() {
    return (cn = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, Tg({
              json: k,
              documentState: xe,
              indentation: n ? J : void 0,
              readOnly: S,
              parser: B,
              onPatch: Pe
            });
          case 2:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function un() {
    return dn.apply(this, arguments);
  }
  function dn() {
    return dn = a(r().mark(function e() {
      var n,
        t = arguments;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (n = !(t.length > 0 && void 0 !== t[0]) || t[0], void 0 !== k) {
              e.next = 3;
              break;
            }
            return e.abrupt("return");
          case 3:
            return e.next = 5, Ng({
              json: k,
              documentState: xe,
              indentation: n ? J : void 0,
              parser: B
            });
          case 5:
          case "end":
            return e.stop();
        }
      }, e);
    })), dn.apply(this, arguments);
  }
  function fn() {
    Lg({
      json: k,
      text: C,
      documentState: xe,
      keepSelection: !0,
      readOnly: S,
      onChange: V,
      onPatch: Pe
    });
  }
  function vn() {
    Ug({
      json: k,
      documentState: xe,
      columns: ve,
      readOnly: S,
      onPatch: Pe
    });
  }
  function pn() {
    Dg({
      json: k,
      documentState: xe,
      columns: ve,
      readOnly: S,
      onPatch: Pe
    });
  }
  function mn() {
    Jg({
      json: k,
      documentState: xe,
      columns: ve,
      readOnly: S,
      onPatch: Pe
    });
  }
  function gn() {
    Vg({
      json: k,
      documentState: xe,
      columns: ve,
      readOnly: S,
      onPatch: Pe
    });
  }
  function hn() {
    return (hn = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, _g({
              char: n,
              selectInside: !1,
              refJsonEditor: y,
              json: k,
              selection: xe.selection,
              readOnly: S,
              parser: B,
              onPatch: Pe,
              onReplaceJson: jn,
              onSelect: be
            });
          case 2:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function jn(e, n) {
    var o = xe,
      r = k,
      i = C,
      a = {
        json: k,
        text: C
      },
      s = we,
      l = gs(k, xe, [], As),
      c = "function" == typeof n ? n(e, l) : void 0;
    t(8, k = c && void 0 !== c.json ? c.json : e), t(12, xe = c && void 0 !== c.state ? c.state : l), t(17, C = void 0), t(23, we = !1), t(18, ae = void 0), ye(k), Me({
      previousJson: r,
      previousState: o,
      previousText: i,
      previousTextIsRepaired: s
    });
    Ie(a, null);
  }
  function bn(e, n) {
    c("handleChangeText");
    var o = xe,
      r = k,
      i = C,
      a = {
        json: k,
        text: C
      },
      s = we;
    try {
      t(8, k = F(e)), t(12, xe = gs(k, xe, [], As)), t(17, C = void 0), t(23, we = !1), t(18, ae = void 0);
    } catch (n) {
      try {
        t(8, k = F(_(e))), t(12, xe = gs(k, xe, [], As)), t(17, C = e), t(23, we = !0), t(18, ae = void 0);
      } catch (o) {
        t(8, k = void 0), t(12, xe = fs({
          json: k,
          expand: As
        })), t(17, C = e), t(23, we = !1), t(18, ae = "" !== C ? ji(C, n.message || String(n)) : void 0);
      }
    }
    if ("function" == typeof n) {
      var l = n(k, xe);
      t(8, k = l && l.json ? l.json : k), t(12, xe = l && l.state ? l.state : xe);
    }
    ye(k), Me({
      previousJson: r,
      previousState: o,
      previousText: i,
      previousTextIsRepaired: s
    });
    Ie(a, null);
  }
  function yn(e) {
    if (void 0 !== k) {
      var n = e.id,
        t = e.onTransform,
        o = e.onClose,
        r = e.rootPath || [];
      pe = !0, te({
        id: n || h,
        json: k,
        rootPath: r || [],
        onTransform: function (e) {
          t ? t({
            operations: e,
            json: k,
            transformedJson: R(k, e)
          }) : (c("onTransform", r, e), Pe(e));
        },
        onClose: function () {
          pe = !1, Fe(), o && o();
        }
      });
    }
  }
  function xn(e) {
    c("openJSONEditorModal", {
      path: e
    }), pe = !0, oe({
      content: {
        json: z(k, e)
      },
      path: e,
      onPatch: $e.onPatch,
      onClose: function () {
        pe = !1, Fe();
      }
    });
  }
  function wn(e, n) {
    u(Dv, {
      text: e,
      onParse: function (e) {
        return mi(e, function (e) {
          return vi(e, B);
        });
      },
      onRepair: gi,
      onApply: n
    }, g(g({}, Or), {}, {
      styleWindow: {
        width: "600px",
        height: "500px"
      },
      styleContent: {
        padding: 0,
        height: "100%"
      }
    }), {
      onClose: function () {
        return Fe();
      }
    });
  }
  function $n(e) {
    c("openFind", {
      findAndReplace: e
    }), t(9, se = !1), t(21, le = !1), bo().then(function () {
      t(9, se = !0), t(21, le = e);
    });
  }
  function kn() {
    if (!S && ke.getState().canUndo) {
      var e = ke.undo();
      if (e) {
        var n = {
          json: k,
          text: C
        };
        t(8, k = e.undo.patch ? R(k, e.undo.patch) : e.undo.json), t(12, xe = e.undo.state), t(17, C = e.undo.text), t(23, we = e.undo.textIsRepaired), t(18, ae = void 0), c("undo", {
          item: e,
          json: k
        }), Ie(n, e.undo.patch && e.redo.patch ? {
          json: k,
          previousJson: n.json,
          redo: e.undo.patch,
          undo: e.redo.patch
        } : null), Fe(), xe.selection && Ue(bl(xe.selection), !1);
      }
    }
  }
  function Cn() {
    if (!S && ke.getState().canRedo) {
      var e = ke.redo();
      if (e) {
        var n = {
          json: k,
          text: C
        };
        t(8, k = e.redo.patch ? R(k, e.redo.patch) : e.redo.json), t(12, xe = e.redo.state), t(17, C = e.redo.text), t(23, we = e.redo.textIsRepaired), t(18, ae = void 0), c("redo", {
          item: e,
          json: k
        }), Ie(n, e.undo.patch && e.redo.patch ? {
          json: k,
          previousJson: n.json,
          redo: e.redo.patch,
          undo: e.undo.patch
        } : null), Fe(), xe.selection && Ue(bl(xe.selection), !1);
      }
    }
  }
  function Sn(e, n) {
    t(76, ge[n] = e.getBoundingClientRect().height, ge);
  }
  return e.$$set = function (e) {
    "readOnly" in e && t(0, S = e.readOnly), "externalContent" in e && t(53, E = e.externalContent), "externalSelection" in e && t(54, q = e.externalSelection), "mainMenuBar" in e && t(1, P = e.mainMenuBar), "escapeControlCharacters" in e && t(55, I = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && t(56, T = e.escapeUnicodeCharacters), "flattenColumns" in e && t(57, A = e.flattenColumns), "parser" in e && t(2, B = e.parser), "parseMemoizeOne" in e && t(58, F = e.parseMemoizeOne), "validator" in e && t(59, U = e.validator), "validationParser" in e && t(60, D = e.validationParser), "indentation" in e && t(3, J = e.indentation), "onChange" in e && t(61, V = e.onChange), "onChangeMode" in e && t(4, H = e.onChangeMode), "onSelect" in e && t(62, W = e.onSelect), "onRenderValue" in e && t(63, Q = e.onRenderValue), "onRenderMenu" in e && t(5, Y = e.onRenderMenu), "onRenderContextMenu" in e && t(64, K = e.onRenderContextMenu), "onFocus" in e && t(65, Z = e.onFocus), "onBlur" in e && t(66, X = e.onBlur), "onSortModal" in e && t(67, ee = e.onSortModal), "onTransformModal" in e && t(68, te = e.onTransformModal), "onJSONEditorModal" in e && t(69, oe = e.onJSONEditorModal);
  }, e.$$.update = function () {
    50331648 & e.$$.dirty[1] && t(75, b = Ii({
      escapeControlCharacters: I,
      escapeUnicodeCharacters: T
    })), 512 & e.$$.dirty[0] && function (e) {
      if (x) {
        var n = e ? Ur : -100;
        x.scrollTo({
          top: t(15, x.scrollTop += n, x),
          left: x.scrollLeft
        });
      }
    }(se), 4194304 & e.$$.dirty[1] && Se(E), 8388608 & e.$$.dirty[1] && function (e) {
      ne(xe.selection, e) || (c("applyExternalSelection", e), (Vs(e) || null === e) && be(e));
    }(q), 3328 & e.$$.dirty[0] | 67108864 & e.$$.dirty[1] && t(11, ve = N(k) ? function (e, n) {
      var t,
        r = new Set(n.map(O)),
        i = new Set(e.map(O)),
        a = o(r);
      try {
        for (a.s(); !(t = a.n()).done;) {
          var s = t.value;
          i.has(s) || r.delete(s);
        }
      } catch (e) {
        a.e(e);
      } finally {
        a.f();
      }
      var l,
        c = o(i);
      try {
        for (c.s(); !(l = c.n()).done;) {
          var u = l.value;
          r.has(u) || r.add(u);
        }
      } catch (e) {
        c.e(e);
      } finally {
        c.f();
      }
      return w(r).map(M);
    }($g(k, A, de), ve) : []), 2304 & e.$$.dirty[0] && t(22, ue = !(!k || G(ve))), 1280 & e.$$.dirty[0] && t(28, i = Array.isArray(k) && k.length > de), 768 & e.$$.dirty[0] | 114688 & e.$$.dirty[2] && t(27, s = Sg(je, he, k, ge, jy, se ? Ur : 0)), 256 & e.$$.dirty[0] && x && x.scrollTo({
      top: x.scrollTop,
      left: x.scrollLeft
    }), 4357 & e.$$.dirty[0] | 8194 & e.$$.dirty[2] && t(25, $e = {
      readOnly: S,
      parser: B,
      normalization: b,
      getJson: function () {
        return k;
      },
      getDocumentState: function () {
        return xe;
      },
      findElement: Ze,
      findNextInside: Be,
      focus: Fe,
      onPatch: Pe,
      onSelect: be,
      onFind: Te,
      onPasteJson: Ne,
      onRenderValue: Q
    }), 260 & e.$$.dirty[0] | 805306368 & e.$$.dirty[1] && Re(k, U, B, D), 10240 & e.$$.dirty[0] && t(26, l = Rg(Oe, ve));
  }, [S, P, B, J, H, Y, Fe, function () {
    if (we && void 0 !== k) {
      var e = xe,
        n = k,
        o = C,
        r = {
          json: k,
          text: C
        },
        i = we;
      t(17, C = void 0), t(23, we = !1), ye(k), Me({
        previousJson: n,
        previousState: e,
        previousText: o,
        previousTextIsRepaired: i
      });
      Ie(r, null);
    }
    return {
      json: k,
      text: C
    };
  }, k, se, de, ve, xe, Oe, y, x, $, C, ae, re, ie, le, ue, we, Ce, $e, l, s, i, j, function (e) {
    t(20, ie = e);
  }, function (e) {
    return ce.apply(this, arguments);
  }, function () {
    t(9, se = !1), t(21, le = !1), Fe();
  }, function (e) {
    if (!S) {
      c("onSortByHeader", e);
      var n = e.sortDirection === fr.desc ? -1 : 1;
      Pe(Tm(k, [], e.path, n), function (n, t) {
        return {
          state: g(g({}, t), {}, {
            sortedColumn: e
          })
        };
      });
    }
  }, Pe, function (e) {
    t(78, je = e.target.scrollTop);
  }, function (e) {
    if (1 === e.buttons || 2 === e.buttons) {
      var n = e.target,
        t = oa(n);
      if (t) {
        if (dl(xe.selection) && hl(k, xe.selection, t)) return;
        be(al(t, !1)), e.preventDefault();
      }
      n.isContentEditable || me || setTimeout(Fe);
    }
  }, Xe, en, function (e) {
    Xe({
      anchor: ea(e.target, "BUTTON"),
      offsetTop: 0,
      width: Lr,
      height: Fr,
      showTip: !0
    });
  }, function () {
    return rn.apply(this, arguments);
  }, function () {
    c("clear pasted json"), t(19, re = void 0), Fe();
  }, function () {
    H(sr.text);
  }, function (e) {
    var n = sa(e);
    if (c("keydown", {
      combo: n,
      key: e.key
    }), "Ctrl+X" === n && (e.preventDefault(), ln(!0)), "Ctrl+Shift+X" === n && (e.preventDefault(), ln(!1)), "Ctrl+C" === n && (e.preventDefault(), un(!0)), "Ctrl+Shift+C" === n && (e.preventDefault(), un(!1)), "Ctrl+D" === n && e.preventDefault(), "Delete" !== n && "Backspace" !== n || (e.preventDefault(), fn()), "Insert" === n && e.preventDefault(), "Ctrl+A" === n && e.preventDefault(), "Ctrl+Q" === n && en(e), "ArrowLeft" === n && (e.preventDefault(), Le(), xe.selection)) {
      var t = function (e, n) {
        var t = Og(bl(n), e),
          o = t.rowIndex,
          r = t.columnIndex;
        return r > 0 ? al(zg({
          rowIndex: o,
          columnIndex: r - 1
        }, e), !1) : n;
      }(ve, xe.selection);
      be(t), Ge(bl(t));
    }
    if ("ArrowRight" === n && (e.preventDefault(), Le(), xe.selection)) {
      var o = function (e, n) {
        var t = Og(bl(n), e),
          o = t.rowIndex,
          r = t.columnIndex;
        return r < e.length - 1 ? al(zg({
          rowIndex: o,
          columnIndex: r + 1
        }, e), !1) : n;
      }(ve, xe.selection);
      be(o), Ge(bl(o));
    }
    if ("ArrowUp" === n && (e.preventDefault(), Le(), xe.selection)) {
      var r = function (e, n) {
        var t = Og(bl(n), e),
          o = t.rowIndex,
          r = t.columnIndex;
        return o > 0 ? al(zg({
          rowIndex: o - 1,
          columnIndex: r
        }, e), !1) : n;
      }(ve, xe.selection);
      be(r), Ge(bl(r));
    }
    if ("ArrowDown" === n && (e.preventDefault(), Le(), xe.selection)) {
      var i = function (e, n, t) {
        var o = Og(bl(t), n),
          r = o.rowIndex,
          i = o.columnIndex;
        return r < e.length - 1 ? al(zg({
          rowIndex: r + 1,
          columnIndex: i
        }, n), !1) : t;
      }(k, ve, xe.selection);
      be(i), Ge(bl(i));
    }
    if ("Enter" === n && xe.selection && Us(xe.selection)) {
      e.preventDefault();
      var a = xe.selection.path;
      Yr(z(k, a)) ? xn(a) : S || be(g(g({}, xe.selection), {}, {
        edit: !0
      }));
    }
    if (1 === n.replace(/^Shift\+/, "").length && xe.selection) return e.preventDefault(), void function (e) {
      hn.apply(this, arguments);
    }(e.key);
    if ("Ctrl+Enter" === n && Us(xe.selection)) {
      var s = z(k, xe.selection.path);
      ni(s) && window.open(String(s), "_blank");
    }
    "Escape" === n && xe.selection && (e.preventDefault(), be(null)), "Ctrl+F" === n && (e.preventDefault(), $n(!1)), "Ctrl+H" === n && (e.preventDefault(), $n(!0)), "Ctrl+Z" === n && (e.preventDefault(), kn()), "Ctrl+Shift+Z" === n && (e.preventDefault(), Cn());
  }, function (e) {
    var n;
    e.preventDefault();
    var t = null === (n = e.clipboardData) || void 0 === n ? void 0 : n.getData("text/plain");
    void 0 !== t && Fg({
      clipboardText: t,
      json: k,
      selection: xe.selection,
      readOnly: S,
      parser: B,
      onPatch: Pe,
      onChangeText: bn,
      openRepairModal: wn
    });
  }, function (e) {
    c("select validation error", e), be(al(e.path, !1)), Ue(e.path);
  }, xn, function () {
    !function (e) {
      S || void 0 === k || (pe = !0, ee({
        id: m,
        json: k,
        rootPath: e,
        onSort: function (n) {
          var t = n.operations,
            o = n.itemPath,
            r = n.direction;
          c("onSort", t, e, o, r), Pe(t, function (e, n) {
            return {
              state: g(g({}, n), {}, {
                sortedColumn: {
                  path: o,
                  sortDirection: -1 === r ? fr.desc : fr.asc
                }
              })
            };
          });
        },
        onClose: function () {
          pe = !1, Fe();
        }
      }));
    }([]);
  }, function () {
    yn({
      rootPath: []
    });
  }, kn, Cn, function (e) {
    t(77, he = e.getBoundingClientRect().height);
  }, Sn, E, q, I, T, A, F, U, D, V, W, Q, K, Z, X, ee, te, oe, Ee, qe, Ue, Ze, yn, b, ge, he, je, function (e) {
    t(9, se = e);
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(16, $ = e);
    });
  }, function () {
    return t(10, de = 1 / 0);
  }, function (e, n) {
    return Sn(n, e);
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(15, x = e);
    });
  }, function () {
    Fe();
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(14, y = e);
    });
  }];
}
var yy = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, by, hy, ct, {
      readOnly: 0,
      externalContent: 53,
      externalSelection: 54,
      mainMenuBar: 1,
      escapeControlCharacters: 55,
      escapeUnicodeCharacters: 56,
      flattenColumns: 57,
      parser: 2,
      parseMemoizeOne: 58,
      validator: 59,
      validationParser: 60,
      indentation: 3,
      onChange: 61,
      onChangeMode: 4,
      onSelect: 62,
      onRenderValue: 63,
      onRenderMenu: 5,
      onRenderContextMenu: 64,
      onFocus: 65,
      onBlur: 66,
      onSortModal: 67,
      onTransformModal: 68,
      onJSONEditorModal: 69,
      validate: 70,
      patch: 71,
      focus: 6,
      acceptAutoRepair: 7,
      scrollTo: 72,
      findElement: 73,
      openTransformModal: 74
    }, Hb, [-1, -1, -1, -1, -1]), t;
  }
  return v(n, Wo), b(n, [{
    key: "validate",
    get: function () {
      return this.$$.ctx[70];
    }
  }, {
    key: "patch",
    get: function () {
      return this.$$.ctx[71];
    }
  }, {
    key: "focus",
    get: function () {
      return this.$$.ctx[6];
    }
  }, {
    key: "acceptAutoRepair",
    get: function () {
      return this.$$.ctx[7];
    }
  }, {
    key: "scrollTo",
    get: function () {
      return this.$$.ctx[72];
    }
  }, {
    key: "findElement",
    get: function () {
      return this.$$.ctx[73];
    }
  }, {
    key: "openTransformModal",
    get: function () {
      return this.$$.ctx[74];
    }
  }]);
}();
function xy(e) {
  var n,
    t,
    o = {
      externalContent: e[0],
      externalSelection: e[1],
      readOnly: e[2],
      indentation: e[3],
      mainMenuBar: e[6],
      navigationBar: e[7],
      escapeControlCharacters: e[10],
      escapeUnicodeCharacters: e[11],
      parser: e[13],
      parseMemoizeOne: e[14],
      validator: e[15],
      validationParser: e[16],
      pathParser: e[17],
      onError: e[23],
      onChange: e[18],
      onChangeMode: e[19],
      onSelect: e[20],
      onRenderValue: e[21],
      onClassName: e[22],
      onFocus: e[24],
      onBlur: e[25],
      onRenderMenu: e[32],
      onRenderContextMenu: e[33],
      onSortModal: e[26],
      onTransformModal: e[27],
      onJSONEditorModal: e[28]
    };
  return n = new uj({
    props: o
  }), e[49](n), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t[0] && (o.externalContent = e[0]), 2 & t[0] && (o.externalSelection = e[1]), 4 & t[0] && (o.readOnly = e[2]), 8 & t[0] && (o.indentation = e[3]), 64 & t[0] && (o.mainMenuBar = e[6]), 128 & t[0] && (o.navigationBar = e[7]), 1024 & t[0] && (o.escapeControlCharacters = e[10]), 2048 & t[0] && (o.escapeUnicodeCharacters = e[11]), 8192 & t[0] && (o.parser = e[13]), 16384 & t[0] && (o.parseMemoizeOne = e[14]), 32768 & t[0] && (o.validator = e[15]), 65536 & t[0] && (o.validationParser = e[16]), 131072 & t[0] && (o.pathParser = e[17]), 8388608 & t[0] && (o.onError = e[23]), 262144 & t[0] && (o.onChange = e[18]), 524288 & t[0] && (o.onChangeMode = e[19]), 1048576 & t[0] && (o.onSelect = e[20]), 2097152 & t[0] && (o.onRenderValue = e[21]), 4194304 & t[0] && (o.onClassName = e[22]), 16777216 & t[0] && (o.onFocus = e[24]), 33554432 & t[0] && (o.onBlur = e[25]), 2 & t[1] && (o.onRenderMenu = e[32]), 4 & t[1] && (o.onRenderContextMenu = e[33]), 67108864 & t[0] && (o.onSortModal = e[26]), 134217728 & t[0] && (o.onTransformModal = e[27]), 268435456 & t[0] && (o.onJSONEditorModal = e[28]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (t) {
      e[49](null), Ho(n, t);
    }
  };
}
function wy(e) {
  var n,
    t,
    o = {
      externalContent: e[0],
      externalSelection: e[1],
      readOnly: e[2],
      mainMenuBar: e[6],
      escapeControlCharacters: e[10],
      escapeUnicodeCharacters: e[11],
      flattenColumns: e[12],
      parser: e[13],
      parseMemoizeOne: e[14],
      validator: e[15],
      validationParser: e[16],
      indentation: e[3],
      onChange: e[18],
      onChangeMode: e[19],
      onSelect: e[20],
      onRenderValue: e[21],
      onFocus: e[24],
      onBlur: e[25],
      onRenderMenu: e[32],
      onRenderContextMenu: e[33],
      onSortModal: e[26],
      onTransformModal: e[27],
      onJSONEditorModal: e[28]
    };
  return n = new yy({
    props: o
  }), e[48](n), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t[0] && (o.externalContent = e[0]), 2 & t[0] && (o.externalSelection = e[1]), 4 & t[0] && (o.readOnly = e[2]), 64 & t[0] && (o.mainMenuBar = e[6]), 1024 & t[0] && (o.escapeControlCharacters = e[10]), 2048 & t[0] && (o.escapeUnicodeCharacters = e[11]), 4096 & t[0] && (o.flattenColumns = e[12]), 8192 & t[0] && (o.parser = e[13]), 16384 & t[0] && (o.parseMemoizeOne = e[14]), 32768 & t[0] && (o.validator = e[15]), 65536 & t[0] && (o.validationParser = e[16]), 8 & t[0] && (o.indentation = e[3]), 262144 & t[0] && (o.onChange = e[18]), 524288 & t[0] && (o.onChangeMode = e[19]), 1048576 & t[0] && (o.onSelect = e[20]), 2097152 & t[0] && (o.onRenderValue = e[21]), 16777216 & t[0] && (o.onFocus = e[24]), 33554432 & t[0] && (o.onBlur = e[25]), 2 & t[1] && (o.onRenderMenu = e[32]), 4 & t[1] && (o.onRenderContextMenu = e[33]), 67108864 & t[0] && (o.onSortModal = e[26]), 134217728 & t[0] && (o.onTransformModal = e[27]), 268435456 & t[0] && (o.onJSONEditorModal = e[28]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (t) {
      e[48](null), Ho(n, t);
    }
  };
}
function $y(e) {
  var n,
    t,
    o = {
      externalContent: e[0],
      externalSelection: e[1],
      readOnly: e[2],
      indentation: e[3],
      tabSize: e[4],
      mainMenuBar: e[6],
      statusBar: e[8],
      askToFormat: e[9],
      escapeUnicodeCharacters: e[11],
      parser: e[13],
      validator: e[15],
      validationParser: e[16],
      onChange: e[18],
      onSelect: e[20],
      onChangeMode: e[19],
      onError: e[23],
      onFocus: e[24],
      onBlur: e[25],
      onRenderMenu: e[32],
      onSortModal: e[26],
      onTransformModal: e[27]
    };
  return n = new ab({
    props: o
  }), e[47](n), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      1 & t[0] && (o.externalContent = e[0]), 2 & t[0] && (o.externalSelection = e[1]), 4 & t[0] && (o.readOnly = e[2]), 8 & t[0] && (o.indentation = e[3]), 16 & t[0] && (o.tabSize = e[4]), 64 & t[0] && (o.mainMenuBar = e[6]), 256 & t[0] && (o.statusBar = e[8]), 512 & t[0] && (o.askToFormat = e[9]), 2048 & t[0] && (o.escapeUnicodeCharacters = e[11]), 8192 & t[0] && (o.parser = e[13]), 32768 & t[0] && (o.validator = e[15]), 65536 & t[0] && (o.validationParser = e[16]), 262144 & t[0] && (o.onChange = e[18]), 1048576 & t[0] && (o.onSelect = e[20]), 524288 & t[0] && (o.onChangeMode = e[19]), 8388608 & t[0] && (o.onError = e[23]), 16777216 & t[0] && (o.onFocus = e[24]), 33554432 & t[0] && (o.onBlur = e[25]), 2 & t[1] && (o.onRenderMenu = e[32]), 67108864 & t[0] && (o.onSortModal = e[26]), 134217728 & t[0] && (o.onTransformModal = e[27]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (t) {
      e[47](null), Ho(n, t);
    }
  };
}
function ky(e) {
  var n,
    t,
    o,
    r,
    i,
    a = [$y, wy, xy],
    s = [];
  function l(e, t) {
    return 32 & t[0] && (n = null), null == n && (n = !(e[5] !== sr.text && "code" !== String(e[5]))), n ? 0 : e[5] === sr.table ? 1 : 2;
  }
  return t = l(e, [-1, -1]), o = s[t] = a[t](e), {
    c: function () {
      o.c(), r = Nt();
    },
    m: function (e, n) {
      s[t].m(e, n), Rt(e, r, n), i = !0;
    },
    p: function (e, n) {
      var i = t;
      (t = l(e, n)) === i ? s[t].p(e, n) : (Ro(), Po(s[i], 1, 1, function () {
        s[i] = null;
      }), Eo(), (o = s[t]) ? o.p(e, n) : (o = s[t] = a[t](e)).c(), qo(o, 1), o.m(r.parentNode, r));
    },
    i: function (e) {
      i || (qo(o), i = !0);
    },
    o: function (e) {
      Po(o), i = !1;
    },
    d: function (e) {
      e && Et(r), s[t].d(e);
    }
  };
}
function Cy(e, n, t) {
  var o,
    i,
    s,
    l,
    c,
    u,
    d = n.content,
    f = n.selection,
    v = n.readOnly,
    p = n.indentation,
    m = n.tabSize,
    g = n.mode,
    h = n.mainMenuBar,
    j = n.navigationBar,
    b = n.statusBar,
    y = n.askToFormat,
    x = n.escapeControlCharacters,
    w = n.escapeUnicodeCharacters,
    $ = n.flattenColumns,
    k = n.parser,
    C = n.parseMemoizeOne,
    S = n.validator,
    M = n.validationParser,
    O = n.pathParser,
    z = n.insideModal,
    R = n.onChange,
    E = n.onChangeMode,
    q = n.onSelect,
    P = n.onRenderValue,
    I = n.onClassName,
    T = n.onRenderMenu,
    A = n.onRenderContextMenu,
    N = n.onError,
    B = n.onFocus,
    F = n.onBlur,
    L = n.onSortModal,
    U = n.onTransformModal,
    D = n.onJSONEditorModal,
    J = {
      type: "separator"
    };
  function V() {
    return (V = a(r().mark(function e() {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (!s) {
              e.next = 3;
              break;
            }
            return e.next = 3, s.refresh();
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  return e.$$set = function (e) {
    "content" in e && t(0, d = e.content), "selection" in e && t(1, f = e.selection), "readOnly" in e && t(2, v = e.readOnly), "indentation" in e && t(3, p = e.indentation), "tabSize" in e && t(4, m = e.tabSize), "mode" in e && t(5, g = e.mode), "mainMenuBar" in e && t(6, h = e.mainMenuBar), "navigationBar" in e && t(7, j = e.navigationBar), "statusBar" in e && t(8, b = e.statusBar), "askToFormat" in e && t(9, y = e.askToFormat), "escapeControlCharacters" in e && t(10, x = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && t(11, w = e.escapeUnicodeCharacters), "flattenColumns" in e && t(12, $ = e.flattenColumns), "parser" in e && t(13, k = e.parser), "parseMemoizeOne" in e && t(14, C = e.parseMemoizeOne), "validator" in e && t(15, S = e.validator), "validationParser" in e && t(16, M = e.validationParser), "pathParser" in e && t(17, O = e.pathParser), "insideModal" in e && t(34, z = e.insideModal), "onChange" in e && t(18, R = e.onChange), "onChangeMode" in e && t(19, E = e.onChangeMode), "onSelect" in e && t(20, q = e.onSelect), "onRenderValue" in e && t(21, P = e.onRenderValue), "onClassName" in e && t(22, I = e.onClassName), "onRenderMenu" in e && t(35, T = e.onRenderMenu), "onRenderContextMenu" in e && t(36, A = e.onRenderContextMenu), "onError" in e && t(23, N = e.onError), "onFocus" in e && t(24, B = e.onFocus), "onBlur" in e && t(25, F = e.onBlur), "onSortModal" in e && t(26, L = e.onSortModal), "onTransformModal" in e && t(27, U = e.onTransformModal), "onJSONEditorModal" in e && t(28, D = e.onJSONEditorModal);
  }, e.$$.update = function () {
    524320 & e.$$.dirty[0] && t(46, l = [{
      type: "button",
      text: "text",
      title: "Switch to text mode (current mode: ".concat(g, ")"),
      className: "jse-group-button jse-first" + (g === sr.text || "code" === g ? " jse-selected" : ""),
      onClick: function () {
        return E(sr.text);
      }
    }, {
      type: "button",
      text: "tree",
      title: "Switch to tree mode (current mode: ".concat(g, ")"),
      className: "jse-group-button " + (g === sr.tree ? " jse-selected" : ""),
      onClick: function () {
        return E(sr.tree);
      }
    }, {
      type: "button",
      text: "table",
      title: "Switch to table mode (current mode: ".concat(g, ")"),
      className: "jse-group-button jse-last" + (g === sr.table ? " jse-selected" : ""),
      onClick: function () {
        return E(sr.table);
      }
    }]), 36 & e.$$.dirty[0] | 32792 & e.$$.dirty[1] && t(32, c = function (e) {
      var n = tv(e[0]) ? l.concat(e) : l.concat(J, e),
        t = ve(n);
      return T(n, {
        mode: g,
        modal: z,
        readOnly: v
      }) || t;
    }), 38 & e.$$.dirty[0] | 40 & e.$$.dirty[1] && t(33, u = function (e) {
      var n,
        t = ve(e);
      return null !== (n = A(e, {
        mode: g,
        modal: z,
        readOnly: v,
        selection: f
      })) && void 0 !== n ? n : !v && t;
    });
  }, [d, f, v, p, m, g, h, j, b, y, x, w, $, k, C, S, M, O, R, E, q, P, I, N, B, F, L, U, D, o, i, s, c, u, z, T, A, function (e) {
    if (o) return o.patch(e);
    if (i) return i.patch(e);
    if (s) return s.patch(e);
    throw new Error('Method patch is not available in mode "'.concat(g, '"'));
  }, function (e) {
    if (o) return o.expand(e);
    throw new Error('Method expand is not available in mode "'.concat(g, '"'));
  }, function (e) {
    if (s) s.openTransformModal(e);else if (o) o.openTransformModal(e);else {
      if (!i) throw new Error('Method transform is not available in mode "'.concat(g, '"'));
      i.openTransformModal(e);
    }
  }, function () {
    if (s) return s.validate();
    if (o) return o.validate();
    if (i) return i.validate();
    throw new Error('Method validate is not available in mode "'.concat(g, '"'));
  }, function () {
    return o ? o.acceptAutoRepair() : d;
  }, function (e) {
    if (o) return o.scrollTo(e);
    if (i) return i.scrollTo(e);
    throw new Error('Method scrollTo is not available in mode "'.concat(g, '"'));
  }, function (e) {
    if (o) return o.findElement(e);
    if (i) return i.findElement(e);
    throw new Error('Method findElement is not available in mode "'.concat(g, '"'));
  }, function () {
    s ? s.focus() : o ? o.focus() : i && i.focus();
  }, function () {
    return V.apply(this, arguments);
  }, l, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(31, s = e);
    });
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(30, i = e);
    });
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(29, o = e);
    });
  }];
}
var Sy = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Cy, ky, lt, {
      content: 0,
      selection: 1,
      readOnly: 2,
      indentation: 3,
      tabSize: 4,
      mode: 5,
      mainMenuBar: 6,
      navigationBar: 7,
      statusBar: 8,
      askToFormat: 9,
      escapeControlCharacters: 10,
      escapeUnicodeCharacters: 11,
      flattenColumns: 12,
      parser: 13,
      parseMemoizeOne: 14,
      validator: 15,
      validationParser: 16,
      pathParser: 17,
      insideModal: 34,
      onChange: 18,
      onChangeMode: 19,
      onSelect: 20,
      onRenderValue: 21,
      onClassName: 22,
      onRenderMenu: 35,
      onRenderContextMenu: 36,
      onError: 23,
      onFocus: 24,
      onBlur: 25,
      onSortModal: 26,
      onTransformModal: 27,
      onJSONEditorModal: 28,
      patch: 37,
      expand: 38,
      transform: 39,
      validate: 40,
      acceptAutoRepair: 41,
      scrollTo: 42,
      findElement: 43,
      focus: 44,
      refresh: 45
    }, null, [-1, -1]), t;
  }
  return v(n, Wo), b(n, [{
    key: "patch",
    get: function () {
      return this.$$.ctx[37];
    }
  }, {
    key: "expand",
    get: function () {
      return this.$$.ctx[38];
    }
  }, {
    key: "transform",
    get: function () {
      return this.$$.ctx[39];
    }
  }, {
    key: "validate",
    get: function () {
      return this.$$.ctx[40];
    }
  }, {
    key: "acceptAutoRepair",
    get: function () {
      return this.$$.ctx[41];
    }
  }, {
    key: "scrollTo",
    get: function () {
      return this.$$.ctx[42];
    }
  }, {
    key: "findElement",
    get: function () {
      return this.$$.ctx[43];
    }
  }, {
    key: "focus",
    get: function () {
      return this.$$.ctx[44];
    }
  }, {
    key: "refresh",
    get: function () {
      return this.$$.ctx[45];
    }
  }]);
}();
function My(e) {
  St(e, "svelte-1m281k0", '.jse-modal.svelte-1m281k0.svelte-1m281k0{flex:1;display:flex;flex-direction:column;min-width:0;min-height:0;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;background:var(--jse-modal-background, #f5f5f5);color:var(--jse-text-color, #4d4d4d)}.jse-modal.svelte-1m281k0 .svelte-select{--border:var(--jse-svelte-select-border, 1px solid #d8dbdf);--item-is-active-bg:var(--jse-item-is-active-bg, #3883fa);--border-radius:var(--jse-svelte-select-border-radius, 3px);--background:var(--jse-svelte-select-background, #fff);--padding:var(--jse-svelte-select-padding, 0 10px);--multi-select-padding:var(--jse-svelte-select-multi-select-padding, 0 10px);--font-size:var(--jse-svelte-select-font-size, var(--jse-font-size, 16px));--height:36px;--multi-item-height:28px;--multi-item-margin:2px;--multi-item-padding:2px 8px;--multi-item-border-radius:6px;--indicator-top:8px}.jse-modal.svelte-1m281k0 .jse-modal-contents.svelte-1m281k0{flex:1;display:flex;flex-direction:column;padding:20px;overflow:auto;min-width:0;min-height:0}.jse-modal.svelte-1m281k0 .jse-modal-contents .jse-actions.svelte-1m281k0{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding, 10px)}.jse-modal.svelte-1m281k0 .jse-modal-contents .jse-actions button.jse-primary.svelte-1m281k0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-primary-background, var(--jse-theme-color, #3883fa));color:var(--jse-button-primary-color, #fff);padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.svelte-1m281k0 .jse-modal-contents .jse-actions button.jse-primary.svelte-1m281k0:hover{background:var(--jse-button-primary-background-highlight, var(--jse-theme-color-highlight, #5f9dff))}.jse-modal.svelte-1m281k0 .jse-modal-contents .jse-actions button.jse-primary.svelte-1m281k0:disabled{background:var(--jse-button-primary-background-disabled, #9d9d9d)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-overlay-background, rgba(0, 0, 0, 0.3))}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0;overflow:auto}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-jsoneditor{width:800px;max-height:500px;display:flex}.bg.jse-modal-bg .jse-modal-window:has(div.fullscreen){margin:var(--jse-padding, 10px);padding:0;width:calc(100vw - 2 * var(--jse-padding, 10px));height:calc(100vh - 2 * var(--jse-padding, 10px));max-width:none;max-height:none}.bg.jse-modal-bg .jse-modal-container{flex:1;display:flex;flex-direction:column;padding:0;max-height:none}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 .jse-modal-contents.svelte-1m281k0{padding-top:0}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 .jse-modal-contents .jse-label.svelte-1m281k0{font-weight:bold;display:block;box-sizing:border-box}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 .jse-modal-contents .jse-label .jse-label-inner.svelte-1m281k0{margin-top:calc(2 * var(--jse-padding, 10px));margin-bottom:calc(0.5 * var(--jse-padding, 10px));box-sizing:border-box}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 .jse-modal-contents .jse-label .jse-label-inner button.svelte-1m281k0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;font-weight:bold;padding:0}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 .jse-modal-contents .jse-modal-inline-editor.svelte-1m281k0{flex:1;min-height:150px;min-width:0;display:flex;--jse-theme-color:var(--jse-modal-editor-theme-color, var(--jse-modal-theme-color, #707070));--jse-theme-color-highlight:var(--jse-modal-editor-theme-color-highlight, var(--jse-modal-theme-color-highlight, #646464))}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 .jse-actions.svelte-1m281k0{gap:var(--jse-padding, 10px);align-items:center}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 .jse-actions .jse-error.svelte-1m281k0{flex:1;color:var(--jse-error-color, #ee5341)}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 .jse-actions button.jse-secondary.svelte-1m281k0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);padding:5px;margin:0;background:var(--jse-button-secondary-background, #d3d3d3);color:var(--jse-button-secondary-color, var(--jse-text-color, #4d4d4d));padding:var(--jse-padding, 10px) calc(2 * var(--jse-padding, 10px));border-radius:3px}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 .jse-actions button.jse-secondary.svelte-1m281k0:hover{background:var(--jse-button-secondary-background-highlight, #e1e1e1)}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 .jse-actions button.jse-secondary.svelte-1m281k0:disabled{background:var(--jse-button-secondary-background-disabled, #9d9d9d)}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 input.svelte-1m281k0{border:var(--jse-input-border, 1px solid #d8dbdf);outline:none;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding, 10px));font-family:var(--jse-font-family-mono, consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace);font-size:var(--jse-font-size-mono, 14px);color:inherit;background:var(--jse-input-background, var(--jse-background-color, #fff))}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 input.svelte-1m281k0:focus{border:var(--jse-input-border-focus, 1px solid var(--jse-input-border-focus, var(--jse-theme-color, #3883fa)))}.jse-modal.jse-jsoneditor-modal.svelte-1m281k0 input.svelte-1m281k0:read-only{background:var(--jse-input-background-readonly, transparent)}');
}
function Oy(e) {
  var n, t;
  return {
    c: function () {
      n = Pt("div"), t = Tt(e[23]), Ut(n, "class", "jse-error svelte-1m281k0");
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: function (e, n) {
      8388608 & n[0] && Ht(t, e[23]);
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function zy(e) {
  var n, t, o, r, i, a;
  return t = new Ya({
    props: {
      data: rn
    }
  }), {
    c: function () {
      n = Pt("button"), Jo(t.$$.fragment), o = Tt(" Back"), Ut(n, "type", "button"), Ut(n, "class", "jse-secondary svelte-1m281k0");
    },
    m: function (s, l) {
      Rt(s, n, l), Vo(t, n, null), Ct(n, o), r = !0, i || (a = Bt(n, "click", e[28]), i = !0);
    },
    p: nt,
    i: function (e) {
      r || (qo(t.$$.fragment, e), r = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), r = !1;
    },
    d: function (e) {
      e && Et(n), Ho(t), i = !1, a();
    }
  };
}
function Ry(e) {
  var n, t, o;
  return {
    c: function () {
      (n = Pt("button")).textContent = "Close", Ut(n, "type", "button"), Ut(n, "class", "jse-primary svelte-1m281k0");
    },
    m: function (r, i) {
      Rt(r, n, i), t || (o = [Bt(n, "click", e[28]), jt(Py.call(null, n))], t = !0);
    },
    p: nt,
    d: function (e) {
      e && Et(n), t = !1, at(o);
    }
  };
}
function Ey(e) {
  var n, t, o;
  return {
    c: function () {
      (n = Pt("button")).textContent = "Apply", Ut(n, "type", "button"), Ut(n, "class", "jse-primary svelte-1m281k0");
    },
    m: function (r, i) {
      Rt(r, n, i), t || (o = [Bt(n, "click", e[27]), jt(Py.call(null, n))], t = !0);
    },
    p: nt,
    d: function (e) {
      e && Et(n), t = !1, at(o);
    }
  };
}
function qy(e) {
  var n, t, o, r, i, a, s, l, c, u, d, f, v, p, m, g, h, j, b, y;
  function x(n) {
    e[39](n);
  }
  var w = {
    title: "Edit nested content " + (e[20].length > 1 ? " (".concat(e[20].length, ")") : ""),
    fullScreenButton: !0,
    onClose: e[28]
  };
  void 0 !== e[22] && (w.fullscreen = e[22]), t = new ff({
    props: w
  }), vo.push(function () {
    return Do(t, "fullscreen", x);
  });
  var $ = {
    mode: e[24].mode,
    content: e[24].content,
    selection: e[24].selection,
    readOnly: e[0],
    indentation: e[1],
    tabSize: e[2],
    statusBar: e[5],
    askToFormat: e[6],
    mainMenuBar: e[3],
    navigationBar: e[4],
    escapeControlCharacters: e[7],
    escapeUnicodeCharacters: e[8],
    flattenColumns: e[9],
    parser: e[10],
    parseMemoizeOne: e[25],
    validator: e[11],
    validationParser: e[12],
    pathParser: e[13],
    insideModal: !0,
    onError: e[33],
    onChange: e[30],
    onChangeMode: e[32],
    onSelect: e[31],
    onRenderValue: e[14],
    onClassName: e[15],
    onFocus: qj,
    onBlur: qj,
    onRenderMenu: e[16],
    onRenderContextMenu: e[17],
    onSortModal: e[18],
    onTransformModal: e[19],
    onJSONEditorModal: e[34]
  };
  v = new Sy({
    props: $
  }), e[40](v);
  var k = e[23] && Oy(e),
    C = e[20].length > 1 && zy(e);
  function S(e, n) {
    return e[0] ? Ry : Ey;
  }
  var M = S(e),
    O = M(e);
  return {
    c: function () {
      n = Pt("div"), Jo(t.$$.fragment), r = At(), i = Pt("div"), (a = Pt("div")).innerHTML = '<div class="jse-label-inner svelte-1m281k0">Path</div>', s = At(), l = Pt("input"), c = At(), (u = Pt("div")).innerHTML = '<div class="jse-label-inner svelte-1m281k0">Contents</div>', d = At(), f = Pt("div"), Jo(v.$$.fragment), p = At(), m = Pt("div"), k && k.c(), g = At(), C && C.c(), h = At(), O.c(), Ut(a, "class", "jse-label svelte-1m281k0"), Ut(l, "class", "jse-path svelte-1m281k0"), Ut(l, "type", "text"), l.readOnly = !0, Ut(l, "title", "Selected path"), l.value = e[26], Ut(u, "class", "jse-label svelte-1m281k0"), Ut(f, "class", "jse-modal-inline-editor svelte-1m281k0"), Ut(m, "class", "jse-actions svelte-1m281k0"), Ut(i, "class", "jse-modal-contents svelte-1m281k0"), Ut(n, "class", "jse-modal jse-jsoneditor-modal svelte-1m281k0"), Yt(n, "fullscreen", e[22]);
    },
    m: function (o, x) {
      Rt(o, n, x), Vo(t, n, null), Ct(n, r), Ct(n, i), Ct(i, a), Ct(i, s), Ct(i, l), Ct(i, c), Ct(i, u), Ct(i, d), Ct(i, f), Vo(v, f, null), Ct(i, p), Ct(i, m), k && k.m(m, null), Ct(m, g), C && C.m(m, null), Ct(m, h), O.m(m, null), j = !0, b || (y = jt(Kf.call(null, n, e[29])), b = !0);
    },
    p: function (e, r) {
      var i = {};
      1048576 & r[0] && (i.title = "Edit nested content " + (e[20].length > 1 ? " (".concat(e[20].length, ")") : "")), !o && 4194304 & r[0] && (o = !0, i.fullscreen = e[22], xo(function () {
        return o = !1;
      })), t.$set(i), (!j || 67108864 & r[0] && l.value !== e[26]) && (l.value = e[26]);
      var a = {};
      16777216 & r[0] && (a.mode = e[24].mode), 16777216 & r[0] && (a.content = e[24].content), 16777216 & r[0] && (a.selection = e[24].selection), 1 & r[0] && (a.readOnly = e[0]), 2 & r[0] && (a.indentation = e[1]), 4 & r[0] && (a.tabSize = e[2]), 32 & r[0] && (a.statusBar = e[5]), 64 & r[0] && (a.askToFormat = e[6]), 8 & r[0] && (a.mainMenuBar = e[3]), 16 & r[0] && (a.navigationBar = e[4]), 128 & r[0] && (a.escapeControlCharacters = e[7]), 256 & r[0] && (a.escapeUnicodeCharacters = e[8]), 512 & r[0] && (a.flattenColumns = e[9]), 1024 & r[0] && (a.parser = e[10]), 33554432 & r[0] && (a.parseMemoizeOne = e[25]), 2048 & r[0] && (a.validator = e[11]), 4096 & r[0] && (a.validationParser = e[12]), 8192 & r[0] && (a.pathParser = e[13]), 16384 & r[0] && (a.onRenderValue = e[14]), 32768 & r[0] && (a.onClassName = e[15]), 65536 & r[0] && (a.onRenderMenu = e[16]), 131072 & r[0] && (a.onRenderContextMenu = e[17]), 262144 & r[0] && (a.onSortModal = e[18]), 524288 & r[0] && (a.onTransformModal = e[19]), v.$set(a), e[23] ? k ? k.p(e, r) : ((k = Oy(e)).c(), k.m(m, g)) : k && (k.d(1), k = null), e[20].length > 1 ? C ? (C.p(e, r), 1048576 & r[0] && qo(C, 1)) : ((C = zy(e)).c(), qo(C, 1), C.m(m, h)) : C && (Ro(), Po(C, 1, 1, function () {
        C = null;
      }), Eo()), M === (M = S(e)) && O ? O.p(e, r) : (O.d(1), (O = M(e)) && (O.c(), O.m(m, null))), (!j || 4194304 & r[0]) && Yt(n, "fullscreen", e[22]);
    },
    i: function (e) {
      j || (qo(t.$$.fragment, e), qo(v.$$.fragment, e), qo(C), j = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), Po(v.$$.fragment, e), Po(C), j = !1;
    },
    d: function (o) {
      o && Et(n), Ho(t), e[40](null), Ho(v), k && k.d(), C && C.d(), O.d(), b = !1, y();
    }
  };
}
function Py(e) {
  e.focus();
}
function Iy(e, n, t) {
  var o,
    r,
    i,
    a,
    s,
    l,
    c = Qo("jsoneditor:JSONEditorModal"),
    u = n.content,
    d = n.path,
    f = n.onPatch,
    v = n.readOnly,
    p = n.indentation,
    m = n.tabSize,
    h = n.mainMenuBar,
    j = n.navigationBar,
    b = n.statusBar,
    y = n.askToFormat,
    x = n.escapeControlCharacters,
    $ = n.escapeUnicodeCharacters,
    k = n.flattenColumns,
    C = n.parser,
    S = n.validator,
    M = n.validationParser,
    z = n.pathParser,
    E = n.onRenderValue,
    q = n.onClassName,
    P = n.onRenderMenu,
    I = n.onRenderContextMenu,
    T = n.onSortModal,
    A = n.onTransformModal,
    B = co("simple-modal").close,
    F = {
      mode: D(u),
      content: u,
      selection: null,
      relativePath: d
    },
    L = [F],
    U = void 0;
  function D(e) {
    return wi(e) && N(e.json) ? sr.table : sr.tree;
  }
  function J() {
    var e,
      n = (null === (e = ee(L)) || void 0 === e ? void 0 : e.selection) || null;
    Vs(n) && s.scrollTo(bl(n));
  }
  function V() {
    c("handleClose"), L.length > 1 ? (t(20, L = X(L)), bo().then(J), t(23, U = void 0)) : B();
  }
  return e.$$set = function (e) {
    "content" in e && t(35, u = e.content), "path" in e && t(36, d = e.path), "onPatch" in e && t(37, f = e.onPatch), "readOnly" in e && t(0, v = e.readOnly), "indentation" in e && t(1, p = e.indentation), "tabSize" in e && t(2, m = e.tabSize), "mainMenuBar" in e && t(3, h = e.mainMenuBar), "navigationBar" in e && t(4, j = e.navigationBar), "statusBar" in e && t(5, b = e.statusBar), "askToFormat" in e && t(6, y = e.askToFormat), "escapeControlCharacters" in e && t(7, x = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && t(8, $ = e.escapeUnicodeCharacters), "flattenColumns" in e && t(9, k = e.flattenColumns), "parser" in e && t(10, C = e.parser), "validator" in e && t(11, S = e.validator), "validationParser" in e && t(12, M = e.validationParser), "pathParser" in e && t(13, z = e.pathParser), "onRenderValue" in e && t(14, E = e.onRenderValue), "onClassName" in e && t(15, q = e.onClassName), "onRenderMenu" in e && t(16, P = e.onRenderMenu), "onRenderContextMenu" in e && t(17, I = e.onRenderContextMenu), "onSortModal" in e && t(18, T = e.onSortModal), "onTransformModal" in e && t(19, A = e.onTransformModal);
  }, e.$$.update = function () {
    1048576 & e.$$.dirty[0] && t(24, o = ee(L) || F), 1048576 & e.$$.dirty[0] && t(38, r = L.flatMap(function (e) {
      return e.relativePath;
    })), 128 & e.$$.dirty[1] && t(26, i = G(r) ? "(document root)" : $a(r)), 1024 & e.$$.dirty[0] && t(25, a = sn(C.parse));
  }, [v, p, m, h, j, b, y, x, $, k, C, S, M, z, E, q, P, I, T, A, L, s, l, U, o, a, i, function () {
    if (c("handleApply"), !v) try {
      t(23, U = void 0);
      var e = o.relativePath,
        n = o.content,
        r = [{
          op: "replace",
          path: O(e),
          value: ki(n, C).json
        }];
      if (L.length > 1) {
        var i = ki(L[L.length - 2].content, C).json,
          a = {
            json: R(i, r)
          },
          s = g(g({}, L[L.length - 2] || F), {}, {
            content: a
          });
        t(20, L = [].concat(w(L.slice(0, L.length - 2)), [s])), bo().then(J);
      } else f(r), B();
    } catch (e) {
      t(23, U = String(e));
    }
  }, V, function () {
    l ? t(22, l = !1) : V();
  }, function (e) {
    c("handleChange", e);
    var n = g(g({}, o), {}, {
      content: e
    });
    t(20, L = [].concat(w(X(L)), [n]));
  }, function (e) {
    c("handleChangeSelection", e);
    var n = g(g({}, o), {}, {
      selection: e
    });
    t(20, L = [].concat(w(X(L)), [n]));
  }, function (e) {
    c("handleChangeMode", e);
    var n = g(g({}, o), {}, {
      mode: e
    });
    t(20, L = [].concat(w(X(L)), [n]));
  }, function (e) {
    t(23, U = e.toString()), console.error(e);
  }, function (e) {
    var n = e.content,
      o = e.path;
    c("handleJSONEditorModal", {
      content: n,
      path: o
    });
    var r = {
      mode: D(n),
      content: n,
      selection: null,
      relativePath: o
    };
    t(20, L = [].concat(w(L), [r]));
  }, u, d, f, r, function (e) {
    t(22, l = e);
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(21, s = e);
    });
  }];
}
var Ty = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Iy, qy, ct, {
      content: 35,
      path: 36,
      onPatch: 37,
      readOnly: 0,
      indentation: 1,
      tabSize: 2,
      mainMenuBar: 3,
      navigationBar: 4,
      statusBar: 5,
      askToFormat: 6,
      escapeControlCharacters: 7,
      escapeUnicodeCharacters: 8,
      flattenColumns: 9,
      parser: 10,
      validator: 11,
      validationParser: 12,
      pathParser: 13,
      onRenderValue: 14,
      onClassName: 15,
      onRenderMenu: 16,
      onRenderContextMenu: 17,
      onSortModal: 18,
      onTransformModal: 19
    }, My, [-1, -1]), t;
  }
  return v(n, Wo), b(n);
}();
function Ay(e, n, t) {
  var o = co("simple-modal");
  return [o.open, o.close];
}
var Ny = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Ay, null, ct, {
      open: 0,
      close: 1
    }), t;
  }
  return v(n, Wo), b(n, [{
    key: "open",
    get: function () {
      return this.$$.ctx[0];
    }
  }, {
    key: "close",
    get: function () {
      return this.$$.ctx[1];
    }
  }]);
}();
function By(e) {
  St(e, "svelte-ybuk0j", '.jse-main.svelte-ybuk0j{width:100%;height:100%;min-width:0;min-height:150px;font-family:var(--jse-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif);font-size:var(--jse-font-size, 16px);line-height:normal;position:relative;display:flex;flex-direction:row}');
}
function Fy(e) {
  var n,
    t,
    o = {
      mode: e[1],
      content: e[0],
      selection: e[2],
      readOnly: e[3],
      indentation: e[4],
      tabSize: e[5],
      statusBar: e[8],
      askToFormat: e[9],
      mainMenuBar: e[6],
      navigationBar: e[7],
      escapeControlCharacters: e[10],
      escapeUnicodeCharacters: e[11],
      flattenColumns: e[12],
      parser: e[13],
      parseMemoizeOne: e[27],
      validator: e[14],
      validationParser: e[15],
      pathParser: e[16],
      insideModal: !1,
      onError: e[21],
      onChange: e[28],
      onChangeMode: e[32],
      onSelect: e[29],
      onRenderValue: e[17],
      onClassName: e[18],
      onFocus: e[30],
      onBlur: e[31],
      onRenderMenu: e[19],
      onRenderContextMenu: e[20],
      onSortModal: e[34],
      onTransformModal: e[33],
      onJSONEditorModal: e[35]
    };
  return n = new Sy({
    props: o
  }), e[62](n), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      2 & t[0] && (o.mode = e[1]), 1 & t[0] && (o.content = e[0]), 4 & t[0] && (o.selection = e[2]), 8 & t[0] && (o.readOnly = e[3]), 16 & t[0] && (o.indentation = e[4]), 32 & t[0] && (o.tabSize = e[5]), 256 & t[0] && (o.statusBar = e[8]), 512 & t[0] && (o.askToFormat = e[9]), 64 & t[0] && (o.mainMenuBar = e[6]), 128 & t[0] && (o.navigationBar = e[7]), 1024 & t[0] && (o.escapeControlCharacters = e[10]), 2048 & t[0] && (o.escapeUnicodeCharacters = e[11]), 4096 & t[0] && (o.flattenColumns = e[12]), 8192 & t[0] && (o.parser = e[13]), 134217728 & t[0] && (o.parseMemoizeOne = e[27]), 16384 & t[0] && (o.validator = e[14]), 32768 & t[0] && (o.validationParser = e[15]), 65536 & t[0] && (o.pathParser = e[16]), 2097152 & t[0] && (o.onError = e[21]), 131072 & t[0] && (o.onRenderValue = e[17]), 262144 & t[0] && (o.onClassName = e[18]), 524288 & t[0] && (o.onRenderMenu = e[19]), 1048576 & t[0] && (o.onRenderContextMenu = e[20]), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (t) {
      e[62](null), Ho(n, t);
    }
  };
}
function Ly(e) {
  var n,
    t,
    o,
    r,
    i,
    a = e[22];
  function s(n) {
    e[61](n);
  }
  var l = {};
  void 0 !== e[25] && (l.open = e[25]), n = new Ny({
    props: l
  }), vo.push(function () {
    return Do(n, "open", s);
  });
  var c = Fy(e);
  return {
    c: function () {
      Jo(n.$$.fragment), o = At(), r = Pt("div"), c.c(), Ut(r, "class", "jse-main svelte-ybuk0j"), Yt(r, "jse-focus", e[23]);
    },
    m: function (e, t) {
      Vo(n, e, t), Rt(e, o, t), Rt(e, r, t), c.m(r, null), i = !0;
    },
    p: function (e, o) {
      var s = {};
      !t && 33554432 & o[0] && (t = !0, s.open = e[25], xo(function () {
        return t = !1;
      })), n.$set(s), 4194304 & o[0] && ct(a, a = e[22]) ? (Ro(), Po(c, 1, 1, nt), Eo(), (c = Fy(e)).c(), qo(c, 1), c.m(r, null)) : c.p(e, o), (!i || 8388608 & o[0]) && Yt(r, "jse-focus", e[23]);
    },
    i: function (e) {
      i || (qo(n.$$.fragment, e), qo(c), i = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), Po(c), i = !1;
    },
    d: function (e) {
      e && (Et(o), Et(r)), Ho(n, e), c.d(e);
    }
  };
}
function Uy(e) {
  var n, t;
  return n = new pr({
    props: {
      closeOnEsc: !1,
      $$slots: {
        default: [Ly]
      },
      $$scope: {
        ctx: e
      }
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      201326591 & t[0] | 8 & t[2] && (o.$$scope = {
        dirty: t,
        ctx: e
      }), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Dy(e) {
  for (var n, t, o, r = [{
      show: null === (n = e[26]) || void 0 === n ? void 0 : n.component
    }, Er, {
      closeOnEsc: !1
    }], i = {
      $$slots: {
        default: [Uy]
      },
      $$scope: {
        ctx: e
      }
    }, a = 0; a < r.length; a += 1) i = ot(i, r[a]);
  return (t = new pr({
    props: i
  })).$on("close", e[36]), {
    c: function () {
      Jo(t.$$.fragment);
    },
    m: function (e, n) {
      Vo(t, e, n), o = !0;
    },
    p: function (e, n) {
      var o,
        i = 67108864 & n[0] ? Lo(r, [{
          show: null === (o = e[26]) || void 0 === o ? void 0 : o.component
        }, r[1], r[2]]) : {};
      201326591 & n[0] | 8 & n[2] && (i.$$scope = {
        dirty: n,
        ctx: e
      }), t.$set(i);
    },
    i: function (e) {
      o || (qo(t.$$.fragment, e), o = !0);
    },
    o: function (e) {
      Po(t.$$.fragment, e), o = !1;
    },
    d: function (e) {
      Ho(t, e);
    }
  };
}
function Jy(e) {
  var n, t;
  return n = new wa({
    props: {
      $$slots: {
        default: [Dy]
      },
      $$scope: {
        ctx: e
      }
    }
  }), {
    c: function () {
      Jo(n.$$.fragment);
    },
    m: function (e, o) {
      Vo(n, e, o), t = !0;
    },
    p: function (e, t) {
      var o = {};
      268435455 & t[0] | 8 & t[2] && (o.$$scope = {
        dirty: t,
        ctx: e
      }), n.$set(o);
    },
    i: function (e) {
      t || (qo(n.$$.fragment, e), t = !0);
    },
    o: function (e) {
      Po(n.$$.fragment, e), t = !1;
    },
    d: function (e) {
      Ho(n, e);
    }
  };
}
function Vy(e, n, t) {
  var o,
    i,
    s,
    l = Qo("jsoneditor:JSONEditor"),
    c = n.content,
    u = void 0 === c ? {
      text: ""
    } : c,
    d = n.selection,
    f = void 0 === d ? null : d,
    v = n.readOnly,
    p = void 0 !== v && v,
    m = n.indentation,
    g = void 0 === m ? 2 : m,
    h = n.tabSize,
    j = void 0 === h ? 4 : h,
    b = n.mode,
    y = void 0 === b ? sr.tree : b,
    x = n.mainMenuBar,
    w = void 0 === x || x,
    $ = n.navigationBar,
    k = void 0 === $ || $,
    C = n.statusBar,
    S = void 0 === C || C,
    M = n.askToFormat,
    O = void 0 === M || M,
    z = n.escapeControlCharacters,
    R = void 0 !== z && z,
    E = n.escapeUnicodeCharacters,
    q = void 0 !== E && E,
    P = n.flattenColumns,
    I = void 0 === P || P,
    T = n.parser,
    A = void 0 === T ? JSON : T,
    N = n.validator,
    B = void 0 === N ? null : N,
    F = n.validationParser,
    L = void 0 === F ? JSON : F,
    U = n.pathParser,
    D = void 0 === U ? {
      parse: ka,
      stringify: $a
    } : U,
    J = n.queryLanguages,
    V = void 0 === J ? [Pa] : J,
    H = n.queryLanguageId,
    _ = void 0 === H ? V[0].id : H,
    W = n.onChangeQueryLanguage,
    Q = void 0 === W ? qj : W,
    Y = n.onChange,
    G = void 0 === Y ? null : Y,
    K = n.onSelect,
    Z = void 0 === K ? null : K,
    X = n.onRenderValue,
    ee = void 0 === X ? wc : X,
    ne = n.onClassName,
    te = void 0 === ne ? function () {} : ne,
    oe = n.onRenderMenu,
    re = void 0 === oe ? qj : oe,
    ie = n.onRenderContextMenu,
    ae = void 0 === ie ? qj : ie,
    se = n.onChangeMode,
    le = void 0 === se ? qj : se,
    ce = n.onError,
    ue = void 0 === ce ? function (e) {
      console.error(e), alert(e.toString());
    } : ce,
    de = n.onFocus,
    fe = void 0 === de ? qj : de,
    pe = n.onBlur,
    me = void 0 === pe ? qj : pe,
    ge = Vr(),
    he = !1,
    je = null,
    be = A;
  function ye() {
    return (ye = a(r().mark(function e(n) {
      var o;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (l("set"), !(o = bi(n))) {
              e.next = 4;
              break;
            }
            throw new Error(o);
          case 4:
            t(22, ge = Vr()), t(0, u = n);
          case 6:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function xe() {
    return (xe = a(r().mark(function e(n) {
      var o;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (l("update"), !(o = bi(n))) {
              e.next = 4;
              break;
            }
            throw new Error(o);
          case 4:
            return t(0, u = n), e.next = 7, bo();
          case 7:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function we() {
    return (we = a(r().mark(function e(n) {
      var o;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (!xi(u)) {
              e.next = 8;
              break;
            }
            e.prev = 1, t(0, u = {
              json: A.parse(u.text),
              text: void 0
            }), e.next = 8;
            break;
          case 5:
            throw e.prev = 5, e.t0 = e.catch(1), new Error("Cannot apply patch: current document contains invalid JSON");
          case 8:
            return o = i.patch(n), e.next = 11, bo();
          case 11:
            return e.abrupt("return", o);
          case 12:
          case "end":
            return e.stop();
        }
      }, e, null, [[1, 5]]);
    }))).apply(this, arguments);
  }
  function $e() {
    return ($e = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return t(2, f = n), e.next = 3, bo();
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function ke() {
    return (ke = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return i.expand(n), e.next = 3, bo();
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function Ce() {
    return Ce = a(r().mark(function e() {
      var n;
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return n = i.acceptAutoRepair(), e.next = 3, bo();
          case 3:
            return e.abrupt("return", n);
          case 4:
          case "end":
            return e.stop();
        }
      }, e);
    })), Ce.apply(this, arguments);
  }
  function Se() {
    return (Se = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, i.scrollTo(n);
          case 2:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function Me() {
    return Oe.apply(this, arguments);
  }
  function Oe() {
    return (Oe = a(r().mark(function e() {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return i.focus(), e.next = 3, bo();
          case 3:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function ze() {
    return (ze = a(r().mark(function e() {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, i.refresh();
          case 2:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function Re() {
    return (Re = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return this.$set(n), e.next = 3, bo();
          case 3:
          case "end":
            return e.stop();
        }
      }, e, this);
    }))).apply(this, arguments);
  }
  function Ee() {
    return (Ee = a(r().mark(function e() {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return this.$destroy(), e.next = 3, bo();
          case 3:
          case "end":
            return e.stop();
        }
      }, e, this);
    }))).apply(this, arguments);
  }
  function qe() {
    return (qe = a(r().mark(function e(n) {
      return r().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            if (y !== n) {
              e.next = 2;
              break;
            }
            return e.abrupt("return");
          case 2:
            return t(1, y = n), e.next = 5, bo();
          case 5:
            return e.next = 7, Me();
          case 7:
            le(n);
          case 8:
          case "end":
            return e.stop();
        }
      }, e);
    }))).apply(this, arguments);
  }
  function Pe(e) {
    l("handleChangeQueryLanguage", e), t(37, _ = e), Q(e);
  }
  function Ie(e) {
    var n = e.id,
      t = e.json,
      r = e.rootPath,
      i = e.onTransform,
      a = e.onClose;
    p || s($j, {
      id: n,
      json: t,
      rootPath: r,
      indentation: g,
      escapeControlCharacters: R,
      escapeUnicodeCharacters: q,
      parser: A,
      parseMemoizeOne: o,
      validationParser: L,
      pathParser: D,
      queryLanguages: V,
      queryLanguageId: _,
      onChangeQueryLanguage: Pe,
      onRenderValue: ee,
      onRenderMenu: re,
      onRenderContextMenu: ae,
      onClassName: te,
      onTransform: i
    }, Rr, {
      onClose: a
    });
  }
  function Te(e) {
    var n = e.id,
      t = e.json,
      o = e.rootPath,
      r = e.onSort,
      i = e.onClose;
    p || s(Ej, {
      id: n,
      json: t,
      rootPath: o,
      onSort: r
    }, zr, {
      onClose: i
    });
  }
  return e.$$set = function (e) {
    "content" in e && t(0, u = e.content), "selection" in e && t(2, f = e.selection), "readOnly" in e && t(3, p = e.readOnly), "indentation" in e && t(4, g = e.indentation), "tabSize" in e && t(5, j = e.tabSize), "mode" in e && t(1, y = e.mode), "mainMenuBar" in e && t(6, w = e.mainMenuBar), "navigationBar" in e && t(7, k = e.navigationBar), "statusBar" in e && t(8, S = e.statusBar), "askToFormat" in e && t(9, O = e.askToFormat), "escapeControlCharacters" in e && t(10, R = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && t(11, q = e.escapeUnicodeCharacters), "flattenColumns" in e && t(12, I = e.flattenColumns), "parser" in e && t(13, A = e.parser), "validator" in e && t(14, B = e.validator), "validationParser" in e && t(15, L = e.validationParser), "pathParser" in e && t(16, D = e.pathParser), "queryLanguages" in e && t(38, V = e.queryLanguages), "queryLanguageId" in e && t(37, _ = e.queryLanguageId), "onChangeQueryLanguage" in e && t(39, Q = e.onChangeQueryLanguage), "onChange" in e && t(40, G = e.onChange), "onSelect" in e && t(41, Z = e.onSelect), "onRenderValue" in e && t(17, ee = e.onRenderValue), "onClassName" in e && t(18, te = e.onClassName), "onRenderMenu" in e && t(19, re = e.onRenderMenu), "onRenderContextMenu" in e && t(20, ae = e.onRenderContextMenu), "onChangeMode" in e && t(42, le = e.onChangeMode), "onError" in e && t(21, ue = e.onError), "onFocus" in e && t(43, fe = e.onFocus), "onBlur" in e && t(44, me = e.onBlur);
  }, e.$$.update = function () {
    if (8193 & e.$$.dirty[0] | 536870912 & e.$$.dirty[1] && !Ei(A, be)) {
      if (l("parser changed, recreate editor"), wi(u)) {
        var n = be.stringify(u.json);
        t(0, u = {
          json: void 0 !== n ? A.parse(n) : void 0
        });
      }
      t(60, be = A), t(22, ge = Vr());
    }
    if (1 & e.$$.dirty[0]) {
      var r = bi(u);
      r && console.error("Error: " + r);
    }
    8192 & e.$$.dirty[0] && t(27, o = sn(A.parse)), 2 & e.$$.dirty[0] && (l("mode changed to", y), "code" === y && console.warn('Deprecation warning: "code" mode is renamed to "text". Please use mode="text" instead.'));
  }, [u, y, f, p, g, j, w, k, S, O, R, q, I, A, B, L, D, ee, te, re, ae, ue, ge, he, i, s, je, o, function (e, n, o) {
    t(0, u = e), G && G(e, n, o);
  }, function (e) {
    t(2, f = e), Z && Z(ve(e));
  }, function () {
    t(23, he = !0), fe && fe();
  }, function () {
    t(23, he = !1), me && me();
  }, function (e) {
    return qe.apply(this, arguments);
  }, Ie, Te, function (e) {
    var n = e.content,
      o = e.path,
      r = e.onPatch,
      i = e.onClose;
    l("onJSONEditorModal", {
      content: n,
      path: o
    }), t(26, je = {
      component: ir(Ty, {
        content: n,
        path: o,
        onPatch: r,
        readOnly: p,
        indentation: g,
        tabSize: j,
        mainMenuBar: w,
        navigationBar: k,
        statusBar: S,
        askToFormat: O,
        escapeControlCharacters: R,
        escapeUnicodeCharacters: q,
        flattenColumns: I,
        parser: A,
        validator: void 0,
        validationParser: L,
        pathParser: D,
        onRenderValue: ee,
        onClassName: te,
        onRenderMenu: re,
        onRenderContextMenu: ae,
        onSortModal: Te,
        onTransformModal: Ie
      }),
      callbacks: {
        onClose: i
      }
    });
  }, function () {
    var e, n;
    null === (e = je) || void 0 === e || null === (e = e.callbacks) || void 0 === e || null === (n = e.onClose) || void 0 === n || n.call(e), t(26, je = null);
  }, _, V, Q, G, Z, le, fe, me, function () {
    return u;
  }, function (e) {
    return ye.apply(this, arguments);
  }, function (e) {
    return xe.apply(this, arguments);
  }, function (e) {
    return we.apply(this, arguments);
  }, function (e) {
    return $e.apply(this, arguments);
  }, function (e) {
    return ke.apply(this, arguments);
  }, function (e) {
    i.transform(e);
  }, function () {
    return i.validate();
  }, function () {
    return Ce.apply(this, arguments);
  }, function (e) {
    return Se.apply(this, arguments);
  }, function (e) {
    return i.findElement(e);
  }, Me, function () {
    return ze.apply(this, arguments);
  }, function (e) {
    return Re.apply(this, arguments);
  }, function () {
    return Ee.apply(this, arguments);
  }, be, function (e) {
    t(25, s = e);
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(24, i = e);
    });
  }];
}
var Hy = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Vy, Jy, ct, {
      content: 0,
      selection: 2,
      readOnly: 3,
      indentation: 4,
      tabSize: 5,
      mode: 1,
      mainMenuBar: 6,
      navigationBar: 7,
      statusBar: 8,
      askToFormat: 9,
      escapeControlCharacters: 10,
      escapeUnicodeCharacters: 11,
      flattenColumns: 12,
      parser: 13,
      validator: 14,
      validationParser: 15,
      pathParser: 16,
      queryLanguages: 38,
      queryLanguageId: 37,
      onChangeQueryLanguage: 39,
      onChange: 40,
      onSelect: 41,
      onRenderValue: 17,
      onClassName: 18,
      onRenderMenu: 19,
      onRenderContextMenu: 20,
      onChangeMode: 42,
      onError: 21,
      onFocus: 43,
      onBlur: 44,
      get: 45,
      set: 46,
      update: 47,
      patch: 48,
      select: 49,
      expand: 50,
      transform: 51,
      validate: 52,
      acceptAutoRepair: 53,
      scrollTo: 54,
      findElement: 55,
      focus: 56,
      refresh: 57,
      updateProps: 58,
      destroy: 59
    }, By, [-1, -1, -1]), t;
  }
  return v(n, Wo), b(n, [{
    key: "get",
    get: function () {
      return this.$$.ctx[45];
    }
  }, {
    key: "set",
    get: function () {
      return this.$$.ctx[46];
    }
  }, {
    key: "update",
    get: function () {
      return this.$$.ctx[47];
    }
  }, {
    key: "patch",
    get: function () {
      return this.$$.ctx[48];
    }
  }, {
    key: "select",
    get: function () {
      return this.$$.ctx[49];
    }
  }, {
    key: "expand",
    get: function () {
      return this.$$.ctx[50];
    }
  }, {
    key: "transform",
    get: function () {
      return this.$$.ctx[51];
    }
  }, {
    key: "validate",
    get: function () {
      return this.$$.ctx[52];
    }
  }, {
    key: "acceptAutoRepair",
    get: function () {
      return this.$$.ctx[53];
    }
  }, {
    key: "scrollTo",
    get: function () {
      return this.$$.ctx[54];
    }
  }, {
    key: "findElement",
    get: function () {
      return this.$$.ctx[55];
    }
  }, {
    key: "focus",
    get: function () {
      return this.$$.ctx[56];
    }
  }, {
    key: "refresh",
    get: function () {
      return this.$$.ctx[57];
    }
  }, {
    key: "updateProps",
    get: function () {
      return this.$$.ctx[58];
    }
  }, {
    key: "destroy",
    get: function () {
      return this.$$.ctx[59];
    }
  }]);
}();
function _y(e) {
  St(e, "svelte-9wp3tj", ".jse-value.jse-string.svelte-9wp3tj{color:var(--jse-value-color-string, #008000)}.jse-value.jse-object.svelte-9wp3tj,.jse-value.jse-array.svelte-9wp3tj{min-width:16px;color:var(--jse-delimiter-color, rgba(0, 0, 0, 0.38))}.jse-value.jse-number.svelte-9wp3tj{color:var(--jse-value-color-number, #ee422e)}.jse-value.jse-boolean.svelte-9wp3tj{color:var(--jse-value-color-boolean, #ff8c00)}.jse-value.jse-null.svelte-9wp3tj{color:var(--jse-value-color-null, #004ed0)}.jse-value.jse-invalid.svelte-9wp3tj{color:var(--jse-text-color, #4d4d4d)}.jse-value.jse-url.svelte-9wp3tj{color:var(--jse-value-color-url, #008000);text-decoration:underline}.jse-enum-value.svelte-9wp3tj{background:var(--jse-hover-background-color, rgba(0, 0, 0, 0.06));border:none;padding:0;font-family:inherit;font-size:inherit;cursor:pointer;outline:none}.jse-enum-value.jse-selected.svelte-9wp3tj{background:var(--jse-selection-background-color, #d3d3d3);color:inherit}.jse-enum-value.jse-value.svelte-9wp3tj:focus{color:var(--jse-text-color, #4d4d4d)}.jse-json-node.jse-selected .jse-enum-value.svelte-9wp3tj{background:transparent}");
}
function Wy(e, n, t) {
  var o = e.slice();
  return o[13] = n[t], o;
}
function Qy(e) {
  var n,
    t,
    o,
    r = e[13].text + "";
  return {
    c: function () {
      n = Pt("option"), t = Tt(r), n.__value = o = e[13].value, _t(n, n.__value);
    },
    m: function (e, o) {
      Rt(e, n, o), Ct(n, t);
    },
    p: function (e, i) {
      4 & i && r !== (r = e[13].text + "") && Ht(t, r), 4 & i && o !== (o = e[13].value) && (n.__value = o, _t(n, n.__value));
    },
    d: function (e) {
      e && Et(n);
    }
  };
}
function Yy(e) {
  for (var n, t, o, r, i = Ao(e[2]), a = [], l = 0; l < i.length; l += 1) a[l] = Qy(Wy(e, i, l));
  return {
    c: function () {
      n = Pt("select");
      for (var o = 0; o < a.length; o += 1) a[o].c();
      Ut(n, "class", t = ht("jse-enum-value ".concat(wl(e[4], e[0]))) + " svelte-9wp3tj"), void 0 === e[4] && yo(function () {
        return e[10].call(n);
      }), Yt(n, "jse-selected", Us(e[1]));
    },
    m: function (t, i) {
      Rt(t, n, i);
      for (var s = 0; s < a.length; s += 1) a[s] && a[s].m(n, null);
      Qt(n, e[4], !0), e[11](n), o || (r = [Bt(n, "change", e[10]), Bt(n, "change", e[5]), Bt(n, "mousedown", Gy)], o = !0);
    },
    p: function (e, o) {
      var r = s(o, 1)[0];
      if (4 & r) {
        var l;
        for (i = Ao(e[2]), l = 0; l < i.length; l += 1) {
          var c = Wy(e, i, l);
          a[l] ? a[l].p(c, r) : (a[l] = Qy(c), a[l].c(), a[l].m(n, null));
        }
        for (; l < a.length; l += 1) a[l].d(1);
        a.length = i.length;
      }
      17 & r && t !== (t = ht("jse-enum-value ".concat(wl(e[4], e[0]))) + " svelte-9wp3tj") && Ut(n, "class", t), 16 & r && Qt(n, e[4]), 19 & r && Yt(n, "jse-selected", Us(e[1]));
    },
    i: nt,
    o: nt,
    d: function (t) {
      t && Et(n), qt(a, t), e[11](null), o = !1, at(r);
    }
  };
}
function Gy(e) {
  e.stopPropagation();
}
function Ky(e, n, t) {
  var o,
    r = n.path,
    i = n.value,
    a = n.parser,
    s = n.readOnly,
    l = n.selection,
    c = n.onPatch,
    u = n.options,
    d = i;
  return e.$$set = function (e) {
    "path" in e && t(6, r = e.path), "value" in e && t(7, i = e.value), "parser" in e && t(0, a = e.parser), "readOnly" in e && t(8, s = e.readOnly), "selection" in e && t(1, l = e.selection), "onPatch" in e && t(9, c = e.onPatch), "options" in e && t(2, u = e.options);
  }, e.$$.update = function () {
    128 & e.$$.dirty && t(4, d = i), 2 & e.$$.dirty && function (e) {
      e && o && o.focus();
    }(l);
  }, [a, l, u, o, d, function (e) {
    e.stopPropagation(), s || c([{
      op: "replace",
      path: O(r),
      value: d
    }]);
  }, r, i, s, c, function () {
    var e;
    e = this.querySelector(":checked"), d = e && e.__value, t(4, d), t(7, i);
  }, function (e) {
    vo[e ? "unshift" : "push"](function () {
      t(3, o = e), t(2, u);
    });
  }];
}
var Zy = function (e) {
  function n(e) {
    var t;
    return h(this, n), _o(t = u(this, n), e, Ky, Yy, ct, {
      path: 6,
      value: 7,
      parser: 0,
      readOnly: 8,
      selection: 1,
      onPatch: 9,
      options: 2
    }, _y), t;
  }
  return v(n, Wo), b(n);
}();
function Xy(e, n, t) {
  var o = ex(e, n || {}, t);
  return o ? function (e) {
    if (Array.isArray(e.enum)) return e.enum;
    var n = e.oneOf || e.anyOf || e.allOf;
    if (Array.isArray(n)) {
      var t = n.filter(function (e) {
        return e.enum;
      });
      if (t.length > 0) return t[0].enum;
    }
    return null;
  }(o) : null;
}
function ex(e, n, t) {
  for (var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e, i = t.slice(1, t.length), a = t[0], l = [r], c = 0, u = [r.oneOf, r.anyOf, r.allOf]; c < u.length; c++) {
    var d = u[c];
    Array.isArray(d) && (l = l.concat(d));
  }
  var f,
    v = o(l);
  try {
    for (v.s(); !(f = v.n()).done;) {
      if ("$ref" in (r = f.value) && "string" == typeof r.$ref) {
        var p,
          m = r.$ref;
        if (m in n) r = n[m];else {
          if (!m.startsWith("#/")) {
            if (1 === (null === (p = m.match(/#\//g)) || void 0 === p ? void 0 : p.length)) {
              var g = s(m.split("#/"), 2),
                h = g[0],
                j = g[1];
              if (h in n) {
                var b = n[h],
                  y = {
                    $ref: "#/".concat(j)
                  },
                  x = [];
                return x.push(a), i.length > 0 && x.push.apply(x, w(i)), ex(b, n, x, y);
              }
              throw Error("Unable to resolve reference ".concat(m));
            }
            throw Error("Unable to resolve reference ".concat(m));
          }
          var $ = m.substring(2).split("/");
          r = e;
          var k,
            C = o($);
          try {
            for (C.s(); !(k = C.n()).done;) {
              var M = k.value;
              if (!(M in r)) throw Error("Unable to resolve reference ".concat(m));
              r = r[M];
            }
          } catch (e) {
            C.e(e);
          } finally {
            C.f();
          }
        }
      }
      if (void 0 === a) return r;
      if ("object" === S(r.properties) && null !== r.properties && a in r.properties) return ex(e, n, i, r = r.properties[a]);
      if ("object" === S(r.patternProperties) && null !== r.patternProperties) for (var O in r.patternProperties) if (a.match(O)) return ex(e, n, i, r = r.patternProperties[O]);
      if ("object" === S(r.additionalProperties)) return ex(e, n, i, r = r.additionalProperties);
      if ("object" === S(r.items) && null !== r.items) return ex(e, n, i, r = r.items);
    }
  } catch (e) {
    v.e(e);
  } finally {
    v.f();
  }
  return null;
}
function nx(e, n, t) {
  var o = Xy(n, t, e.path);
  if (o) {
    var r = e.value,
      i = e.path,
      a = e.selection,
      s = e.parser,
      l = e.readOnly,
      c = e.onPatch,
      u = o.map(function (e) {
        return {
          value: e,
          text: e
        };
      }),
      d = o.includes(e.value) ? u : [{
        value: r,
        text: r
      }].concat(u);
    return [{
      component: Zy,
      props: {
        value: r,
        path: i,
        selection: a,
        parser: s,
        readOnly: l,
        onPatch: c,
        options: d
      }
    }];
  }
  return null;
}
function tx(e) {
  if (void 0 === e.schema) throw new Error("Deprecation warning: the signature of createAjvValidator is changed from createAjvValidator(schema, schemaDefinitions, ajvOptions) to createAjvValidator({ schema, schemaDefinitions, ajvOptions }). Please pass the arguments as an object instead of unnamed arguments.");
  var n = function (e) {
    var n = e.schemaDefinitions,
      t = e.ajvOptions,
      o = new Xn(g({
        allErrors: !0,
        verbose: !0,
        $data: !0
      }, t));
    n && Object.keys(n).forEach(function (e) {
      o.addSchema(n[e], e);
    });
    return o;
  }(e);
  if (void 0 !== e.onCreateAjv && !1 === (n = e.onCreateAjv(n) || n).opts.verbose) throw new Error("Ajv must be configured with the option verbose=true");
  var t = n.compile(e.schema);
  if (t.errors) throw t.errors[0];
  return function (e) {
    return t(e), (t.errors || []).map(ox).map(function (n) {
      return function (e, n) {
        return {
          path: A(e, n.instancePath),
          message: n.message || "Unknown error",
          severity: ur.warning
        };
      }(e, n);
    });
  };
}
function ox(e) {
  if ("enum" === e.keyword && Array.isArray(e.schema)) {
    var n = e.schema;
    if (n) {
      if ((n = n.map(function (e) {
        return JSON.stringify(e);
      })).length > 5) {
        var t = ["(" + (n.length - 5) + " more...)"];
        (n = n.slice(0, 5)).push(t);
      }
      e.message = "should be equal to one of: " + n.join(", ");
    }
  }
  return "additionalProperties" === e.keyword && (e.message = "should NOT have additional property: " + e.params.additionalProperty), e;
}
var rx = {
  id: "lodash",
  name: "Lodash",
  description: '\n<p>\n  Enter a JavaScript function to filter, sort, or transform the data.\n  You can use <a href="https://lodash.com" target="_blank" rel="noopener noreferrer">Lodash</a>\n  functions like <code>_.map</code>, <code>_.filter</code>,\n  <code>_.orderBy</code>, <code>_.sortBy</code>, <code>_.groupBy</code>,\n  <code>_.pick</code>, <code>_.uniq</code>, <code>_.get</code>, etcetera.\n</p>\n',
  createQuery: function (e, n) {
    var t = n.filter,
      o = n.sort,
      r = n.projection,
      i = ["  return _.chain(data)\n"];
    if (t && t.path && t.relation && t.value) {
      var a = "item => item".concat(Ma(t.path)),
        s = qa(t.value),
        l = "string" == typeof s ? "'".concat(t.value, "'") : oi(t.value) && !Number.isSafeInteger(s) ? "".concat(t.value, "n") : t.value;
      i.push("    .filter(".concat(a, " ").concat(t.relation, " ").concat(l, ")\n"));
    }
    o && o.path && o.direction && i.push("    .orderBy([".concat(function (e) {
      return 0 === e.length ? "" : e.every(function (e) {
        return za.test(e) || Oa.test(e);
      }) ? "'" + e.map(Sa).join("").replace(/^\./, "") + "'" : JSON.stringify(e);
    }(o.path), "], ['").concat(o.direction, "'])\n"));
    if (r && r.paths) if (r.paths.length > 1) {
      var c = r.paths.map(function (e) {
        var n = ee(e) || "item";
        return "      ".concat(JSON.stringify(n), ": item").concat(Ma(e));
      });
      i.push("    .map(item => ({\n".concat(c.join(",\n"), "\n    }))\n"));
    } else {
      var u = r.paths[0];
      i.push("    .map(item => item".concat(Ma(u), ")\n"));
    }
    return i.push("    .value()\n"), "function query (data) {\n".concat(i.join(""), "}");
  },
  executeQuery: function (e, n) {
    !function (e) {
      var n,
        t,
        o = null === (n = e.match(/_\.chain\(/g)) || void 0 === n ? void 0 : n.length,
        r = null === (t = e.match(/\.value\(\)/g)) || void 0 === t ? void 0 : t.length;
      if (o !== r) throw new Error("Cannot execute query: Lodash _.chain(...) must end with .value()");
    }(n);
    var t = new Function("_", '"use strict";\n\n' + n + '\n\nif (typeof query !== "function") {\n  throw new Error("Cannot execute query: expecting a function named \'query\' but is undefined")\n}\n\nreturn query;\n')(W)(e);
    return void 0 !== t ? t : null;
  }
};
var ix = {
  id: "jmespath",
  name: "JMESPath",
  description: '\n<p>\n  Enter a <a href="https://jmespath.org" target="_blank" rel="noopener noreferrer">JMESPath</a> query \n  to filter, sort, or transform the JSON data.\n To learn JMESPath, go to <a href="https://jmespath.org/tutorial.html" target="_blank" rel="noopener noreferrer">the interactive tutorial</a>.\n</p>\n',
  createQuery: function (e, n) {
    var t = n.sort,
      o = n.filter,
      r = n.projection,
      i = "";
    if (o && o.path && o.relation && o.value) {
      var a = ["0"].concat(o.path),
        s = z(e, a),
        l = qa(o.value),
        c = "string" == typeof s && null != l ? '"'.concat(o.value, '"') : l;
      i += "[? " + ax(o.path) + " " + o.relation + " `" + c + "`]";
    } else i += Array.isArray(e) ? "[*]" : "@";
    t && t.path && t.direction && ("desc" === t.direction ? i += " | reverse(sort_by(@, &" + ax(t.path) + "))" : i += " | sort_by(@, &" + ax(t.path) + ")");
    if (r && r.paths) if ("]" !== i[i.length - 1] && (i += " | [*]"), 1 === r.paths.length) {
      var u = r.paths[0];
      i += 0 === u.length ? "" : "." + ax(u);
    } else r.paths.length > 1 && (i += ".{" + r.paths.map(function (e) {
      return sx(e[e.length - 1]) + ": " + ax(e);
    }).join(", ") + "}");
    return i;
  },
  executeQuery: function (e, n, t) {
    var o = Ei(t, JSON) ? e : function (e) {
      var n = t.stringify(e);
      return void 0 !== n ? JSON.parse(n) : void 0;
    }(e);
    return et.search(o, n);
  }
};
function ax(e) {
  if (0 === e.length) return "@";
  var n = e.map(function (e) {
    return "number" == typeof e ? "[" + e + "]" : "." + sx(String(e));
  }).join("");
  return "." === n[0] ? n.slice(1) : n;
}
function sx(e) {
  return e.match(/^[A-Za-z\d_$]+$/) ? e : JSON.stringify(e);
}
export { Xa as BooleanToggle, cr as CaretType, ss as ColorPicker, zl as EditableValue, Zy as EnumValue, Hy as JSONEditor, sr as Mode, fc as ReadonlyValue, dr as SearchField, lr as SelectionType, fr as SortDirection, xc as TimestampTag, vr as UpdateSelectionAfterChange, ur as ValidationSeverity, ll as createAfterSelection, tx as createAjvValidator, sl as createInsideSelection, il as createKeySelection, cl as createMultiSelection, al as createValueSelection, Mi as estimateSerializedSize, Bs as isAfterSelection, yi as isContent, cv as isContentParseError, uv as isContentValidationErrors, lv as isContextMenuColumn, sv as isContextMenuRow, dl as isEditingSelection, Ei as isEqualParser, Fs as isInsideSelection, wi as isJSONContent, Ls as isKeySelection, Si as isLargeContent, iv as isMenuButton, av as isMenuDropDownButton, rv as isMenuLabel, ov as isMenuSeparator, tv as isMenuSpace, Ds as isMultiSelection, fv as isNestedValidationError, pv as isSvelteActionRenderer, vv as isSvelteComponentRenderer, xi as isTextContent, dv as isValidationError, Us as isValueSelection, Pa as javascriptQueryLanguage, ix as jmespathQueryLanguage, rx as lodashQueryLanguage, Kf as onEscape, ka as parseJSONPath, nx as renderJSONSchemaEnum, wc as renderValue, Rb as resizeObserver, $a as stringifyJSONPath, ki as toJSONContent, $i as toTextContent };
